export default {
    "de": {
        "currency": {
            "aed": "UAE Dirham",
            "afn": "Afghan Afghani",
            "all": "albanischer Lek",
            "amd": "armenischer Dram",
            "ang": "Die Niederlande Antillian Gulden",
            "aoa": "Kwanza",
            "ars": "argentinischen Peso",
            "aud": "Australischer Dollar",
            "awg": "Aruba Florin",
            "azn": "Azerbaijani Manat",
            "bam": "Bosnien und Herzegowina Marka",
            "bbd": "Barbados-Dollar",
            "bdt": "Bangladeshi Taka",
            "bgn": "Lew",
            "bhd": "Bahrain-Dinar",
            "bif": "Burundi-Franc",
            "bnd": "Brunei-Dollar",
            "bob": "Boliviano",
            "brl": "brasilianischer Real",
            "bsd": "Bahama-Dollar",
            "btc": "Bitcoin",
            "btn": "Ngultrum",
            "bwp": "Botswana Pula",
            "byn": "New Belarus Rubel",
            "bzd": "Belize-Dollar",
            "cad": "Kanadischer Dollar",
            "cdf": "kongolesische Franc",
            "chf": "Schweizerfranken",
            "clp": "chilenischer Peso",
            "cop": "Kolumbianischer Peso",
            "crc": "Costa Rica Colon",
            "cup": "kubanischer Peso",
            "cve": "Kapverdische Escudo",
            "czk": "Tschechische Krone",
            "djf": "Djiboutian Franc",
            "dkk": "Dänische Krone",
            "dop": "Dominikanische Peso",
            "dzd": "algerische Dinar",
            "egp": "Ägyptisches Pfund",
            "ern": "Eritrean Nakfa",
            "etb": "Birr",
            "eur": "Euro",
            "fjd": "Fidschi-Dollar",
            "fkp": "Falkland Pfund",
            "gbp": "Pfund Sterling",
            "gel": "georgische Lari",
            "ghs": "ghanaische Cedi",
            "gip": "Gibraltar-Pfund",
            "gmd": "Gambian Dalasi",
            "gnf": "guineische Franc",
            "gtq": "guatemaltekische Quetzal",
            "gyd": "Guyanese Dollar",
            "hkd": "Hongkong Dollar",
            "hnl": "honduranische Lempira",
            "hrk": "Kroatisches Kuna",
            "htg": "haitianische Gourde",
            "huf": "ungarischer Forint",
            "idr": "indonesische Rupiah",
            "ils": "Israelischer Schekel",
            "inr": "Indische Rupie",
            "iqd": "irakischer Dinar",
            "irr": "iranischer Rial",
            "isk": "isländische Krone",
            "jmd": "Jamaika-Dollar",
            "jod": "jordanischer Dinar",
            "jpy": "Japanische YEN",
            "kes": "Kenia-Schilling",
            "kgs": "Kyrgyzstani Som",
            "khr": "Kambodschanische Riel",
            "kmf": "komorischen Franc",
            "kpw": "Nordkoreanischer Won",
            "krw": "Südkoreanischer Won",
            "kwd": "Kuwait-Dinar",
            "kyd": "Kaiman-Dollar",
            "kzt": "Tenge",
            "lak": "Lao Kip",
            "lbp": "libanesische Lira",
            "lkr": "Sri-Lanka-Rupie",
            "lrd": "Liberianischer Dollar",
            "lsl": "Loti",
            "lvl": "lettischen Lats",
            "lyd": "libysche Dinar",
            "mad": "marokkanischer Dirham",
            "mdl": "Moldovan Leu",
            "mga": "Malagasy Ariary",
            "mkd": "Denar",
            "mmk": "Myanma Kyat",
            "mnt": "Tugrik",
            "mop": "Macau-Pataca",
            "mro": "Ouguiya",
            "mur": "Mauritius-Rupie",
            "mvr": "Rufiyaa",
            "mwk": "malaysischer Ringgit",
            "mxn": "mexikanischer Peso",
            "myr": "malaysischer Ringgit",
            "mzn": "mosambikanische Metical",
            "nad": "namibischer Dollar",
            "ngn": "Nigerianische Naira",
            "nio": "Nicaraguacordoba",
            "nok": "norwegische Krone",
            "npr": "nepalesische Rupie",
            "nzd": "Neuseeland Dollar",
            "omr": "OmanRial",
            "pab": "panamesische Balboa",
            "pen": "Peruanischer Nuevo Sol",
            "pgk": "Kina",
            "php": "Philippinischer Peso",
            "pkr": "pakistanische Rupie",
            "pln": "Polnischer Zloty",
            "pyg": "Paraguay Guarani",
            "qar": "Qatari Riyal",
            "rmb": "Renminbi",
            "ron": "rumänischer Leu",
            "rsd": "serbischer Dinar",
            "rub": "russischer Rubel",
            "rwf": "Rwandan Franc",
            "sar": "Saudi-Rial",
            "sbd": "Salomonen Dollar",
            "scr": "Seychellen-Rupie",
            "sdg": "sudanesische Pfund",
            "sek": "Schwedische Krone",
            "sgd": "Singapur-Dollar",
            "shp": "St. Helena Pfund",
            "sll": "Sierra Leone Leone",
            "sos": "Somalia-Schilling",
            "srd": "surinamischen Dollar",
            "std": "Sao Tome und Principe Dobra",
            "syp": "Syrisches Pfund",
            "szl": "Lilangeni",
            "thb": "Thai Baht",
            "tjs": "Somoni",
            "tmt": "Turkmenistan Manat",
            "tnd": "Tunesischer Dinar",
            "top": "Paanga",
            "try": "Neue Türkische Lira",
            "ttd": "Trinidad und Tobago-Dollar",
            "twd": "Neuer Taiwan-Dollar",
            "tzs": "Tansania-Schilling",
            "uah": "Hryvnia",
            "ugx": "Uganda-Schilling",
            "usd": "US Dollar",
            "uyu": "uruguayischen Peso",
            "uzs": "usbekische Som",
            "vef": "venezolanischen Bolivar",
            "vnd": "Vietnamesischer Dong",
            "vuv": "Vanuatu Vatu",
            "wst": "Samoan Tala",
            "xaf": "Zentralafrikanische Franc CFA",
            "xcd": "East Caribbean Dollar",
            "xdr": "Sonderziehungsrechte",
            "xof": "Westkaribischer Franc",
            "xpf": "CFP-Franc",
            "yer": "Jemen-Rial",
            "zar": "Südafrikanischer Rand",
            "zmw": "sambischen Kwacha"
        },
        "shop-currency-rate": {
            "rate-last-updated-x-days-ago": "Rate aktualisiert {time} Tagen",
            "rate-last-updated-x-hours-ago": "Rate aktualisiert {time} Stunden"
        },
        "hyperair": {
            "copyright-footer": "Copyright © 2018 HyperAir Incorporation Limited. Alle Rechte vorbehalten.",
            "today": "Heute"
        },
        "product-simcard": {
            "shipping-methods": {
                "hkpost": "Hong Kong Post (Kostenlos)",
                "international": "Internationales Versenden",
                "sf": "SF Express (Hong Kong only. Courier fee payable on delivery. Free Shipping for orders over HK$399)"
            }
        },
        "country": {
            "afghanistan": "Afghanistan",
            "aland-islands": "Aland Islands",
            "albania": "Albanien",
            "algeria": "Algerien",
            "andorra": "Andorra",
            "angola": "Angola",
            "anguilla": "Anguilla",
            "antigua-&-barbuda": "Antigua & Barbuda",
            "antigua-barbuda": "Antigua und Barbuda",
            "argentina": "Argentinien",
            "armenia": "Armenien",
            "aruba": "Aruba",
            "australia": "Australien",
            "austria": "Österreich",
            "azerbaijan": "Aserbaidschan",
            "azores": "Azoren",
            "bahamas": "Bahamas",
            "bahrain": "Bahrain",
            "bangladesh": "Bangladesch",
            "barbados": "Barbados",
            "belarus": "Weißrussland",
            "belgium": "Belgien",
            "belize": "Belize",
            "benin": "Benin",
            "bermuda": "Bermuda",
            "bhutan": "Bhutan",
            "bolivia": "Bolivien",
            "bonaire": "Bonaire",
            "bosnia-herzegovina": "Bosnien und Herzegowina",
            "botswana": "Botswana",
            "brazil": "Brasilien",
            "british-virgin-islands": "Britische Jungferninseln",
            "brunei": "Brunei",
            "bulgaria": "Bulgarien",
            "burkina-faso": "Burkina Faso",
            "burundi": "Burundi",
            "cambodia": "Kambodscha",
            "cameroon": "Kamerun",
            "canada": "Kanada",
            "canary-islands": "Kanarische Inseln",
            "cape-verde-islands": "Kapverdische Inseln",
            "cayman-islands": "Cayman Inseln",
            "central-african-republic": "Zentralafrikanische Republik",
            "chad": "Tschad",
            "chile": "Chile",
            "china": "China",
            "colombia": "Kolumbien",
            "comoros": "Komoren",
            "congo": "Kongo",
            "cook-islands": "Cookinseln",
            "costa-rica": "Costa Rica",
            "cote-d-ivoire": "Elfenbeinküste",
            "croatia": "Kroatien",
            "cruise-ship": "Kreuzfahrtschiff",
            "cuba": "Kuba",
            "curacao": "Curacao",
            "cyprus": "Zypern",
            "cyprus---north": "Zypern",
            "cyprus---south": "Zypern",
            "czech-republic": "Tschechische Republik",
            "denmark": "Dänemark",
            "djibouti": "Dschibuti",
            "dominica": "Dominica",
            "dominican-republic": "Dominikanische Republik",
            "dubai": "Dubai",
            "easter-island": "Osterinsel",
            "ecuador": "Ecuador",
            "egypt": "Ägypten",
            "el-salvador": "El Salvador",
            "equatorial-guinea": "Äquatorialguinea",
            "eritrea": "Eritrea",
            "estonia": "Estland",
            "ethiopia": "Äthiopien",
            "europe": "Europe",
            "falkland-islands": "Falkland Inseln",
            "faroe-islands": "Färöer Inseln",
            "fiji": "Fidschi",
            "finland": "Finnland",
            "france": "Frankreich",
            "french-guiana": "Französisch-Guayana",
            "french-polynesia": "Französisch Polynesien",
            "french-west-indies": "Französische Antillen",
            "gabon": "Gabun",
            "gambia": "Gambia",
            "georgia": "Georgia",
            "germany": "Deutschland",
            "ghana": "Ghana",
            "gibraltar": "Gibraltar",
            "greece": "Griechenland",
            "greenland": "Grönland",
            "grenada": "Grenada",
            "guadeloupe": "Guadeloupe",
            "guam": "Guam",
            "guatemala": "Guatemala",
            "guernsey": "Guernsey",
            "guinea": "Guinea",
            "guinea---bissau": "Guinea Bissau",
            "guinea-bissau": "Guinea-Bissau",
            "guyana": "Guyana",
            "haiti": "Haiti",
            "honduras": "Honduras",
            "hong-kong": "Hongkong",
            "hungary": "Ungarn",
            "iceland": "Island",
            "india": "Indien",
            "indonesia": "Indonesien",
            "iran": "Ich rannte",
            "iraq": "Irak",
            "ireland": "Irland",
            "isle-of-man": "Isle of Man",
            "israel": "Israel",
            "italy": "Italien",
            "jamaica": "Jamaika",
            "japan": "Japan",
            "jersey": "Jersey",
            "jordan": "Jordan",
            "kazakhstan": "Kasachstan",
            "kenya": "Kenia",
            "kiribati": "Kiribati",
            "kosovo": "Kosovo",
            "kuwait": "Kuwait",
            "kyrgyz-republic": "Kirgisische Republik",
            "kyrgyzstan": "Kirgisistan",
            "laos": "Laos",
            "latvia": "Lettland",
            "lebanon": "Libanon",
            "lesotho": "Lesotho",
            "liberia": "Liberia",
            "libya": "Libyen",
            "liechtenstein": "Liechtenstein",
            "lithuania": "Litauen",
            "luxembourg": "Luxemburg",
            "macau": "Macau",
            "macedonia": "Mazedonien",
            "madagascar": "Madagaskar",
            "madeira": "Madeira",
            "malawi": "Malawi",
            "malaysia": "Malaysia",
            "maldives": "Malediven",
            "mali": "Mali",
            "malta": "Malta",
            "marshall-islands": "Marshallinseln",
            "martinique": "Martinique",
            "mauritania": "Mauretanien",
            "mauritius": "Mauritius",
            "mayotte": "Mayotte",
            "mexico": "Mexiko",
            "micronesia": "Mikronesien",
            "moldova": "Moldawien",
            "monaco": "Monaco",
            "mongolia": "Mongolei",
            "montenegro": "Montenegro",
            "montserrat": "Montserrat",
            "morocco": "Marokko",
            "mozambique": "Mosambik",
            "myanmar": "Myanmar",
            "namibia": "Namibia",
            "nauru": "Nauru",
            "nepal": "Nepal",
            "netherlands": "Niederlande",
            "netherlands-antilles": "Niederländische Antillen",
            "new-caledonia": "Neu-Kaledonien",
            "new-zealand": "Neuseeland",
            "nicaragua": "Nicaragua",
            "niger": "Niger",
            "nigeria": "Nigeria",
            "niue": "Niue",
            "norfolk-islands": "Norfolkinseln",
            "north-korea": "Nord Korea",
            "northern-marianas": "Nördliche Marianen",
            "norway": "Norwegen",
            "oman": "Oman",
            "pakistan": "Pakistan",
            "palau": "Palau",
            "palestine": "Palästina",
            "panama": "Panama",
            "papua-new-guinea": "Papua Neu-Guinea",
            "paraguay": "Paraguay",
            "peru": "Peru",
            "philippines": "Philippinen",
            "poland": "Polen",
            "portugal": "Portugal",
            "puerto-rico": "Puerto Rico",
            "qatar": "Katar",
            "reunion": "Wiedervereinigung",
            "romania": "Rumänien",
            "russia": "Russland",
            "rwanda": "Ruanda",
            "saint-barthelemy": "SAINT BARTHELEMY",
            "saint-martin": "Sankt Martin",
            "saint-pierre-&-miquelon": "Saint Pierre & Miquelon",
            "samoa": "Samoa",
            "san-marino": "San Marino",
            "sao-tome-&-principe": "Sao Tome & Principe",
            "sao-tome-principe": "São Tomé und Príncipe",
            "satellite": "Satellit",
            "saudi-arabia": "Saudi Arabien",
            "senegal": "Senegal",
            "serbia": "Serbien",
            "seychelles": "Seychellen",
            "sierra-leone": "Sierra Leone",
            "singapore": "Singapur",
            "slovak-republic": "Slowakische Republik",
            "slovakia": "Slowakei",
            "slovenia": "Slowenien",
            "solomon-islands": "Salomon-Inseln",
            "somalia": "Somalia",
            "south-africa": "Südafrika",
            "south-korea": "Südkorea",
            "spain": "Spanien",
            "sri-lanka": "Sri Lanka",
            "st-helena": "St. Helena",
            "st-kitts": "St. Kitts",
            "st-kitts-&-nevis": "St. Kitts & Nevis",
            "st-lucia": "St. Lucia",
            "st-vincent": "St. Vincent",
            "st.-helena": "St. Helena",
            "st.-kitts": "St. Kitts",
            "st.-lucia": "St. Lucia",
            "sudan": "Sudan",
            "suriname": "Suriname",
            "swaziland": "Swasiland",
            "sweden": "Schweden",
            "switzerland": "Schweiz",
            "syria": "Syrien",
            "taiwan": "Taiwan",
            "tajikistan": "Tadschikistan",
            "tanzania": "Tansania",
            "thailand": "Thailand",
            "timor-l'este": "Timor L'Este",
            "togo": "gehen",
            "tonga": "Tonga",
            "trinidad-&-tobago": "Trinidad & Tobago",
            "trinidad-tobago": "Trinidad und Tobago",
            "tunisia": "Tunesien",
            "turkey": "Truthahn",
            "turkmenistan": "Turkmenistan",
            "turks-&-caicos": "Turks & Caicos",
            "turks-&-caicos-islands": "Turks- und Caicosinseln",
            "turks-caicos-islands": "Turks- und Caicosinseln",
            "uganda": "Uganda",
            "ukraine": "Ukraine",
            "united-arab-emirates": "Vereinigte Arabische Emirate",
            "united-kingdom": "Großbritannien",
            "united-states": "Vereinigte Staaten",
            "united-states-minor-outlying-islands": "USA, kleinere ausgelagerte Inseln",
            "uruguay": "Uruguay",
            "uzbekistan": "Usbekistan",
            "vanuatu": "Vanuatu",
            "vatican-city": "Vatikanstadt",
            "venezuela": "Venezuela",
            "vietnam": "Vietnam",
            "virgin-islands": "Jungferninseln",
            "virgin-islands-(us)": "Amerikanische Jungferninseln",
            "wallis-&-futuna": "Wallis & Futuna",
            "wallis-futuna": "Wallis und Futuna",
            "yemen": "Jemen",
            "zambia": "Sambia",
            "zimbabwe": "Zimbabwe"
        },
        "inspiration": {
            "published-date": "M Y",
            "published-duration": ": Dauer Tage zuvor",
            "published-duration-singular": "Gestern",
            "published-duration-today": "Heute"
        },
        "promotion-center": {
            "expires-at": "",
            "redeem": {
                "error": {
                    "already-redeemed": "Sie haben den Gutschein bereits eingelöst.",
                    "new-customer-only": "Das Angebot gilt nur für Neukunden.",
                    "not-found": "Ungültiger Promotion-Code"
                }
            }
        },
        "auth": {
            "failed": "Diese Anmeldeinformationen stimmen nicht mit unseren Datensätzen überein.",
            "throttle": "Zu viele Anmeldeversuche Bitte versuchen Sie es erneut in: Sekunden Sekunden."
        },
        "web": {
            "activity": {
                "countdown-title": "",
                "more-button": "More tour and tickets",
                "section-subtitle": "Find the cheapest tour and tickets in Singapore",
                "section-title": "Tour and Tickets"
            },
            "checkout": {
                "use-promo-code": ""
            },
            "checkout-failed": {
                "checkout-failed": ""
            },
            "checkout-success": {
                "checkout-success": "Zahlungserfolg",
                "continue-shopping-button": "Mit dem Einkaufen fortfahren",
                "done-button": "Fertig👌🏻",
                "download-now": "Jetzt downloaden",
                "order-number": "Bestellnummer",
                "register-email": "Deine E-Mail",
                "register-password": "Lege ein Passwort fest",
                "sim-product": "<span class=\"bold\"> : sim </span>erfolgreich gekauft. Die Bestätigungs-E-Mail wurde gesendet an: email.",
                "slogan": "Öffnen Sie die HyperAir-App und genießen Sie die exklusiven Reiseprivilegien! Sie können auch die Echtzeit-Auftragsverfolgung in der App haben!",
                "slogan-password": "Noch ein Schritt! Sie können in der App einen Willkommens-Gutschein für eine SIM-Karte im Wert von HK $ 10 und eine Auftragsverfolgung in Echtzeit genießen!",
                "trace-order": "",
                "trace-order-password": "",
                "welcome-offer": "Noch ein Schritt! Sie können in der App einen Willkommens-Gutschein für eine SIM-Karte im Wert von HK $ 10 und eine Auftragsverfolgung in Echtzeit genießen!"
            },
            "country": {
                "all": "Alles",
                "contact-us-description": "<a href=\"mailto:corporate@hyperair.com\\>corporate@hyperair.com</a>查詢",
                "data": "Datenlimit:",
                "day": "Tage):",
                "day-day": "Tag",
                "esim": "eSIM",
                "esim-section-title": "Bestes eSIM für: Land",
                "num-of-review": ": Anzahl der Bewertungen",
                "per-day": "Tag",
                "phone-call": "Anruf",
                "plug-n-go": "",
                "plug-n-go-esim": "Sofort kaufen und verwenden",
                "plug-n-go-sim": "Plug and Use",
                "section-title": "Beste SIM-Karte für: Land",
                "section-title copy": "Beste SIM-Karte für: Land",
                "sim": "SIM",
                "supplier": "Anbieter:"
            },
            "download-app-banner": {
                "download-now": "App jetzt herunterladen",
                "hyperair": "HyperAir",
                "subtitle": "Laden Sie die HyperAir-App herunter und registrieren Sie sie, um das HK $ 10-Willkommensangebot zu genießen!",
                "title": "Intelligenter reisen. Irgendwo."
            },
            "email-subscription": {
                "cancel-button": "再諗一諗",
                "completed-subscribe": "Thank you for subscribing!",
                "confirm-button": "我要最抵優惠",
                "duplicate-email": "你的電郵已經訂閱了",
                "invalid-email": "Invalid email address",
                "title-1": "想Staycation價格跌至新低時通知你？",
                "title-2": "仲搜羅全城最抵既Staycation 及美食套餐優惠"
            },
            "fanfare": {
                "cover-title": "SIM-Karten-Angebot",
                "datetime-format": "j M",
                "end-next-fanfare": "Die nächste SIM-Karte-Angebot:",
                "end-title": "Bleiben Sie mit unserem App & Social Media für die nächsten SIM Angebote abgestimmt",
                "end-title2": "Stay tuned für unsere APP & Social Media-Plattformen für die nächste SIM-Karte Angebot",
                "more-details-button": "Mehr Details",
                "out-of-stock": "Ausverkauft",
                "popular-countries-subtitle": "Gratis Surface Mail, schnelle Anlieferung",
                "popular-countries-title": "Beliebte SIM-Karten",
                "section-title": "SIM-Karten zu super günstigen Preisen",
                "title": "Nur für kurze Zeit | begrenzte Karten",
                "x-inventory-left": "Zuletzt {inventory}"
            },
            "fanfare-breadcrumb": "SIM-Karten-Angebot",
            "filter-button": {
                "filter": "Filter"
            },
            "filter-container": {
                "apply": "",
                "category": "Kategorie",
                "category-aquarium": "Aquarium",
                "category-class": "Klasse",
                "category-day-tour": "Tagesausflug",
                "category-discount": "Rabatt",
                "category-diving": "Tauchen",
                "category-food": "Essen",
                "category-massage-beauty": "Massage und Beauty",
                "category-museum": "Museum",
                "category-musical": "Musical",
                "category-outlet": "Auslauf",
                "category-photography": "Fotografie",
                "category-playground": "Spielplatz",
                "category-railway": "Eisenbahn",
                "category-show": "Show",
                "category-ski": "Ski",
                "category-spa": "Spa",
                "category-theme-park": "Freizeitpark",
                "category-ticket": "Fahrkarte",
                "category-transport": "Transport",
                "category-transport-ticket": "Transport Ticket",
                "category-vr": "VR",
                "category-water-park": "Wasserpark",
                "category-yoga": "Yoga",
                "category-zoo": "Zoo",
                "clear-all": "Reset",
                "facilities": "Services & facilities",
                "filter": "Filter",
                "food": "Food",
                "header": "Filter",
                "popular-search": "Popular Search🔥",
                "price": "Preis",
                "provider": "Informationsseite",
                "subcategory-buffet": "Buffet",
                "subcategory-car": "Auto",
                "subcategory-facial": "Gesichts",
                "subcategory-food": "Essen",
                "subcategory-half-day-tour": "Halbtagestour",
                "subcategory-massage": "Massage",
                "subcategory-meal-voucher": "Mahlzeit Gutschein",
                "subcategory-one-day-tour": "One Day Tour",
                "subcategory-restaurant": "Restaurant",
                "subcategory-transport": "Transport",
                "tag": "Tag"
            },
            "footer": {
                "about-hyperair-description": "HyperAir ist eine intelligente Reiseplattform nach Ihren Wünschen und bietet die am besten geeignete und preiswerteste Reiselösung, sodass Sie überall intelligenter reisen können.",
                "download-now": "Jetzt downloaden",
                "email-subscription-button": "Subscribe",
                "email-subscription-placeholder": "Enter your email",
                "email-subscription-social-title": "or Follow our Facebook and Instagram",
                "email-subscription-title": "Subscribe to get the latest staycation discount",
                "travel-license": "Travel Agent Licence Number："
            },
            "fx-booking": {
                "back-button": "",
                "confirm-booking": "",
                "confirm-button": "",
                "contact-shop": "",
                "get-money-before": ""
            },
            "home": {
                "cover-button": "Jetzt erleben",
                "cover-subtitle": "Öffnen Sie sich einer neuen Welt von HyperAir",
                "cover-title": "Intelligenter reisen. Irgendwo.",
                "grid": {
                    "1": {
                        "subtitle": "Neueste Inspiration",
                        "title": "Cat Residents in der türkischen Kirche"
                    },
                    "2": {
                        "subtitle": "Neueste Inspiration",
                        "title": "Olympische Spiele 2020 in Tokio noch 1 Jahr"
                    },
                    "3": {
                        "subtitle": "Heiße Picks",
                        "title": "Online-Bestpreisgarantie"
                    },
                    "4": {
                        "subtitle": "제한된 시간 제공",
                        "title": "SIM 카드 팡파르"
                    },
                    "5": {
                        "subtitle": "Beliebtes Ziel",
                        "title": "Sneak Peek von Disneyland Galaxy Edge"
                    }
                },
                "home-example": {
                    "column-subtitle-1": "Nehmen Sie als Beispiel 2 Personen 7-tägige Reise nach Japan:",
                    "column-subtitle-2": "Preisvergleich",
                    "column-title-1": "eine Reise, maximieren Sie Ihre Ersparnis",
                    "column-title-2": "Vergleichen Sie 11 Online-Reisebüros",
                    "hotel": "Hotel-Belohnungen",
                    "hotel-package-1": "Hotel Nikko Osaka x6 Nächte",
                    "insurance": "Reiseversicherung",
                    "insurance-package-1": "7-tägige Reiseversicherung x2",
                    "money": "Reiseversicherung",
                    "money-package-1": "Tauschen Sie JPD ¥ 410.000",
                    "save": "speichern",
                    "sim": "Reise-SIM",
                    "sim-package-1": "Japan 7-Tage DoCoMo SIM x2",
                    "slogan": "Vergleichen Sie vor der Buchung, sparen Sie Geld für Ihre nächste Reise!",
                    "total-saving": "Gesamteinsparungen 1443",
                    "travel-experience": "Reiseerfahrung",
                    "travel-experience-package-1": "JR Pass für ganz Japan x2",
                    "travel-experience-package-2": "Universal Studios Japan ™ 1-Day eTicket x2"
                },
                "media-header-title": "Press",
                "more": "Mehr Reise-SIM",
                "partners-title": "Partnership",
                "photo-banner-button": "Mehr erfahren",
                "photo-banner-title": "Reisegeld schlauer tauschen",
                "services-header-description": "",
                "services-header-title": "One-Stop-Reisedienstleistungen",
                "services-icon-subtitle-1": "Helfen Sie, Reisegeld schlauer zu machen!",
                "services-icon-subtitle-2": "Bieten Sie die besten SIM-Karten mit kostenlosem Versand!",
                "services-icon-subtitle-3": "Erlauben Sie Ihnen, die Welt mit maßgeschneiderten Lösungen zu erkunden!",
                "services-icon-title-1": "Reisegeld",
                "services-icon-title-2": "Reise-SIM",
                "services-icon-title-3": "Reiseerfahrung",
                "statistic": {
                    "num-of-city": "",
                    "num-of-comparison": "",
                    "num-of-experience": "",
                    "num-of-saving": ""
                },
                "testimonial-1-content": "個 呢 個 個 個 個 個 個 個 唔 駛 員 的 個 個 個 個 ， 的 的 的 的 的 的 的",
                "testimonial-1-subtitle": "Android-Benutzer",
                "testimonial-1-user": "Christine Lam",
                "testimonial-2-content": "Die SIM-Karte ist nicht verfügbar會 會 再買",
                "testimonial-2-subtitle": "iOS-Benutzer",
                "testimonial-2-user": "Engel",
                "testimonial-header-description": "",
                "testimonial-header-title": "Kundenempfehlung",
                "travel-activities": {
                    "home-slogan": "Vergleichen und finden Sie Ihr bestes Reiseerlebnis auf verschiedenen Websites"
                },
                "travel-country-header-description": "Klare Klassifizierung, leicht zu wählen",
                "travel-country-header-title": "Travel SIM deckt 200 Länder ab",
                "travel-info-header-description": "Holen Sie sich die brandheiße Reiseinspiration",
                "travel-info-header-title": "Reiseinspiration",
                "travel-marketplace-header-description": "",
                "travel-marketplace-header-title": "",
                "travel-sim-header-description": "Beste SIM-Karte befasst sich mit kostenlosem Versand",
                "travel-sim-header-title": "Beliebte Reise-SIM"
            },
            "hotel": {
                "cover-subtitle": "Genießen Sie 5% exklusiv Trip.com Hotelbuchung Angebot",
                "cover-title": "Hotel Prämien",
                "discount-detail": "Wenden Sie diesen Gutscheincode „HYPERAIR5“ 5% Hotelbuchung Angebot genießen",
                "discount-title": "HYPERAIR5",
                "highlight-subtitle1": "Entdecken Sie Hotels auf der ganzen Welt für einen einzigartigen Aufenthalt.",
                "highlight-subtitle2": "Holen Sie sich die besten Angebote und Ihr Geld für die nächste Reise sparen.",
                "highlight-subtitle3": "Schauen Sie sich die Hotelpreise zu jeder Zeit an jedem Ort.",
                "highlight-title1": "globale Abdeckung",
                "highlight-title2": "exklusive Privilegien",
                "highlight-title3": "Ein-Klick-Buchung"
            },
            "hypermiles": {
                "activity": "Activity",
                "balance": "Outstanding Balance",
                "benefit": "Your Privileges",
                "cumulative-purchase": "Accumulated Spending：HK$ {amount}",
                "diamond-black": "Diamond Black",
                "expire": "Expired HyperMiles ({date})",
                "expire-reminder-1": "HyperMiles is valid for one year from the shopping month",
                "expire-reminder-2": "Remember to use HyperMiles before expiry!",
                "hypermiles-total": "HyperMiles",
                "member": "Member",
                "member-tier": "You have become HyperAir {member_tier} member",
                "membership-details": "Membership Tier",
                "next-purchase": "save HK${amount} in your next purchase",
                "order-num": "Order No: {order_num}",
                "permanent-membership": "Permanent Membership",
                "popup-title": "HyperMiles Reward Scheme",
                "precious-platinum": "Precious Platinum",
                "product_purchase": "HyperMiles from gadgets purchase ({date})",
                "record": "HyperMiles Record",
                "royal-blue": "Royal Blue",
                "simcard_purchase": "HyperMiles from SIM purchase ({date})",
                "tier": "",
                "title": "HyperMiles. Explore the World, Enjoy the rebate!",
                "u-have": "Your have",
                "usage": "Redeemed HyperMiles",
                "what-is-hypermiles": "What is HyperMiles",
                "what-is-hypermiles-slogan1": "Spend more. Earn more!",
                "what-is-hypermiles-slogan2": "Every 100 HyperMiles can be used as HK$1 at checkout, no minimum spending limit",
                "what-is-hypermiles-slogan3": "Spend more at HyperAir to enjoy more privileges"
            },
            "hypermiles-disclaimer": "terms and conditions apply",
            "hypermiles-discount-diamond-black": "Spend every HK$1 to enjoy 1 HyperMiles",
            "hypermiles-discount-precious-platinum": "Spend every HK$1.5 to enjoy 1 HyperMiles",
            "hypermiles-discount-royal-blue": "Spend every HK$2 to enjoy 1 HyperMiles",
            "hypermiles-special-diamond-black": "Exclusive pre-sale offer",
            "hypermiles-spend-diamond-black": "Cumulative spending of HK$3,000",
            "hypermiles-spend-precious-platinum": "Cumulative spending of HK$1,500",
            "hypermiles-spend-royal-blue": "Basic Member",
            "login": {
                "email": "",
                "existing-user": "",
                "forgot-password": "",
                "forgot-password-please-fill-in-email": "",
                "login": "",
                "login-with-facebook": "",
                "login-with-google": "",
                "new-user": "",
                "or": "",
                "password": "",
                "phone-input-placeholder": "",
                "phone-input-title": "",
                "phone-verify": "",
                "resend-verification-code": "",
                "reset-password": "",
                "title": "",
                "verification-code-input-title": ""
            },
            "logo-loader": {
                "slogan": "We're almost there"
            },
            "my-order": {
                "amount": "",
                "esim-qrcode": "",
                "fx-status-cancelled": "",
                "fx-status-confirmed": "",
                "order-date": "",
                "order-details": "",
                "order-num": "",
                "status-confirmed": "",
                "status-pending-confirmation": "",
                "status-ready-to-ship": "",
                "status-shipped": ""
            },
            "my-order-details": {
                "delivery-info": "",
                "discount": "",
                "recipient-address": "",
                "recipient-email": "",
                "recipient-name": "",
                "recipient-tel": "",
                "shipping-method": "",
                "status": "",
                "total": "",
                "valid-date": ""
            },
            "nav": {
                "about-us": "Über uns",
                "car": "",
                "company": "Unternehmen",
                "company-address": "Entrepreneurship Centre, Level 3, Cyberport 3, Hong Kong",
                "contact-us": "Kontaktiere uns",
                "contact-us-description": "Bei Fragen wenden Sie sich bitte per E-Mail an <a href=\"mailto:hello@hyperair.com\">hello@hyperair.com</a> .",
                "disclaimer": "Disclaimer",
                "download-app": "Lade App herunter",
                "flight": "",
                "foodie": "Foodie",
                "home": "Home",
                "hotel": "Hotel",
                "jobs": "Rekrutierung",
                "logout": "Ausloggen",
                "media-coverage": "Press",
                "monthly-rental-hotel": "Monthly Rental Hotel",
                "privacy-policy": "Datenschutz-Bestimmungen",
                "promo-banner-text": "HyperAir 客戶專享 5% Trip.com 獨家酒店折扣",
                "quarantine-hotel": "Long Stay Hotel",
                "refund-policy": "Rückgaberecht",
                "spa-and-beauty": "Spa and Beauty",
                "staycation": "Staycation",
                "tag-line": "Compare Travel Sites & Save Money",
                "terms-of-service": "Nutzungsbedingungen",
                "travel-activity": "",
                "travel-affiliate-codes": "Gutscheine",
                "travel-affiliate-codes-md": "Gutscheine",
                "travel-blog": "Blog",
                "travel-experience-d": "Reise Tour und Erfahrung",
                "travel-experience-md": "Reise Tour und Erfahrung",
                "travel-insurance": "Reiseversicherung",
                "travel-insurance-md": "Reiseversicherung",
                "travel-marketplace": "Travel Gadgets",
                "travel-marketplace-md": "Travel Gadgets",
                "travel-money": "Reisegeld",
                "travel-money-md": "Reisegeld",
                "travel-sim": "Reise-SIM",
                "travel-sim-md": "Reise-SIM"
            },
            "photo-banner": {
                "banner-button": ""
            },
            "product-card": {
                "num-of-review": "{num}-of-review ratings"
            },
            "redirection-gate": {
                "columns-1-description": "Vergleichen Sie die besten Reise-Erfahrungen aus verschiedenen Websites",
                "columns-1-title": "Reiseaktivität Vergleich",
                "columns-2-description": "Bestes SIM-Karte Abkommen wird mit freiem Verschiffen!",
                "columns-2-title": "Travel SIM",
                "columns-3-description": "Vergleichen und buchen Sie die beste FX Rate in der Stadt",
                "columns-3-title": "Reisegeld",
                "promo-code": "Code",
                "remember-to-fill-promo-code": "Denken Sie daran, die oben Promo-Code vor der Kasse zu beantragen",
                "title": "We are taking you to {domain}",
                "trouble-link": "If the browser does not redirect you in 10 seconds, please click this <a href=\"{link}\">link</a>."
            },
            "register": {
                "guest-checkout": "",
                "title": ""
            },
            "seo": {
                "best-price-guarantee-title": "Best Price Guarantee",
                "country-description": "{country} Travel SIM - Bestpreisgarantie mit kostenlosem Versand",
                "country-keywords": "SIM, DataSIM, DataSIM, 4G, 4G, 4G, 4G, 4G, 4G, 4G, 4G, 4G上 上, 大阪 上, 泰國 4G 上, 泰國 泰國, 曼谷 4G 上, 台灣 4G 上, 台灣 4G 上, 台灣 台灣, 台北 4G 上,台中 4G, 台中 4G, 台中 4G, 首 4G, 首 4G, 首 4G, 首 4G, 網卡 4G, 中國 4G澳門 上 網卡, Docomo, Softbank",
                "country-title": "{country} Travel SIM - Bestpreisgarantie mit kostenlosem Versand",
                "home-description": "HyperAir ist eine intelligente Reiseplattform nach Ihren Wünschen und bietet die am besten geeignete und preiswerteste Reiselösung, sodass Sie überall intelligenter reisen können.",
                "home-keywords": "sim 卡, 上 網卡, 電話 電話, 數據 數據, DataSIM, 旅遊 DataSIM, 數據 數據, 4G 上, 上 上, 4G 上, SIM 卡, Reise-SIM, 旅遊 SIM 卡, 唱 唱, 唱 X 神器X 器, 唱 唱, 唱 唱 App, 兌換, 找 找, 兌換 兌換, 找 店, 銀行, 外匯, 外滙, 旅行, 旅行, 旅遊, 旅遊, 行程, 機票, 機票,比較, 格 格, 特價, 預訂, 交易, 旅遊, 日本, 泰國, 韓國, 台灣, 日圓, 日元, 台幣, 泰銖, HyperAir, HyperAir FX, HyperAir Travel, Reisen, Reisegeld, Fremdwährung, Devisen,百年, 堅 堅, 發達 發達, 飛鳥, richbird, crazy bird, berlin exchange",
                "home-title": "HyperAir - Reisen Sie intelligenter. Irgendwo. | Beste Reise-SIM, FX, Reiseversicherung, lokale Erfahrungen",
                "hotel-description": "Holen Sie sich zusätzliche Hotelbuchung Angebote über HyperAir.com",
                "hotel-keywords": "Hotel, Hotels, Rabatt, Reservierungen, Asien, Europa, Amerika, Bangkok, Singapur, Hong Kong, Phuket, Thailand, Malaysia, Bali, London, Paris, Treueprogramm, Unterbringung, Unterkunft, acomodation, Unterkunft, Ferienhäuser",
                "hotel-title": "Hotel Angebote",
                "money-exchange-description": "Check {shop_name}'s latest FX rate and book your travel money online. You can lock in FX rate and reserve foreign currency.",
                "money-exchange-keywords": "{shop_name}, 唱錢神器, 唱X神器, 唱錢X器, 唱錢, 兌換, 找換, 兌換店, 找換店, 銀行, 金融, 外匯, 外滙, 匯率, 滙率, 匯款, 外幣, 貨幣, 旅行, 旅遊, 行程, 酒店, 機票, 比較, 格價, 特價, 預訂, 交易, 旅遊保險, 日本, 泰國, 韓國, 台灣, 日圓, 日元, 台幣, 泰銖, HyperAir, HyperAir FX, HyperAir Travel, Travel, Travel Money, Foreign Currency, Foreign Exchange, 百年, 堅成, 發達鳥, 飛鳥, richbird, crazy bird, berlin exchange",
                "money-exchange-title": "{shop_name}'s latest FX rate with instant booking | Lock in FX rate and reserve your travel money instantly",
                "privacy-policy-title": "Privacy Policy",
                "refund-policy-title": "Refund & Return Policy",
                "sim-fanfares-description": "HyperAir hat den ersten SIM-Karte Fanfares in Hong Kong ins Leben gerufen. Sie können mit Rabatt bis zu 50% Rabatt auf SIM-Karten für die Reise kaufen. Nur für kurze Zeit, begrenztes Angebot!",
                "sim-fanfares-keywords": "fanfares, Simkarten, SIM-Karte, SIM 卡, 上 網卡, 電話 卡, 數據 卡, DataSIM, 旅遊 DataSIM, 數據 咭, 4G 上 網卡, 上 網卡, 4G 上 網卡, 日本 4G 上 網卡, 日本 上 網卡, 東京 4G 上 網卡, 東京 上 網卡, 大阪 4G 上 網卡, 大阪 上 網卡, 泰國 4G 上 網卡, 泰國 上 網卡, 曼谷 4G 上 網卡, 布吉 上 網卡, 芭提雅 4G 上 網卡, 台灣 4G 上 網卡, 台灣 上 網卡, 台北 4G上 網卡, 高雄 上 網卡, 台中 4G 上 網卡, 台中 上 網卡, 韓國 4G 上 網卡, 韓國 上 網卡, 首 爾 4G 上 網卡, 首 爾 上 網卡, 中國 4G 上 網卡, 中國 上 網卡, 深圳 4G 上 網卡, 深圳 上網卡, 澳門 4G 上 網卡, 澳門 上 網卡, Docomo, Softbank",
                "sim-fanfares-title": "SIM-Karte Fanfares - begrenzte Zeit, begrenzt Karten",
                "term-of-service-title": "Terms of Service",
                "travel-activity-search-results-description": "",
                "travel-activity-search-results-keywords": "{activity}, travel, local experience, local activity, ticket, activities, day tours, tourist attractions",
                "travel-activity-search-results-title": "HyperAir - Search Result of {q} in {city}",
                "travel-affiliate-codes-description": "HyperAir aktualisiert fortlaufend die neuesten Rabattcodes / Promotion-Codes für die Reservierung Hotel Rabatte, Flugrabatte, Aktivität Rabatte, Reiseversicherung Rabatte, SIM-Karte Rabatte und Preisnachlässe Kreditkarte.",
                "travel-affiliate-codes-keywords": "Rabatt-Code, elektronischer Coupon, Rabatt-Code, Aktionscodes, Promo Code, Rabattcode, Hotel, Flugticket, Angebot, Kreditkarte anbieten, Reiseangebote",
                "travel-affiliate-codes-title": "2023 Neueste Travel Discount Codes (Daily Updates) | Rabatt Buchung für Hotels, Flüge, Aktivitäten, Reiseversicherung, Daten-SIM",
                "travel-insurance-description": "Suchen Sie nach den besten Reiseversicherung Pläne? Welche Pläne decken Mobiltelefone? Vergleichen Versicherungspläne von Unternehmen wie AIG, MSIG und Starr, und online kaufen mit Extra-Rabatt!",
                "travel-insurance-keywords": "AIG, MSIG, Starr, AIG Promocode, MSIG Promocode, Starr Promocode, Reiseversicherung, Reiseversicherung online, vergleicht Reiseversicherung, günstige Reiseversicherung, Reiseversicherung Hong Kong, einfache Fahrt, Jahresplan",
                "travel-insurance-title": "Beste Reiseversicherung Preise & Vergleiche in Hong Kong 2023",
                "travel-marketplace-checkout-payme-title": "Pay with PayMe",
                "travel-marketplace-checkout-success-keywords": "創意, 產品, 流行, 電器, 生活, 精品, 智能家居, 設計, 高品質, 設計概念, 創意科技, 生活用品, 戶外休閒, 廚房, 餐桌, 個人護理, 防疫抗疫, 健康, 遊戲, 兒童玩樂, 健身, 家居健身, gym, home gym, smart home, style home",
                "travel-marketplace-checkout-success-title": "{product_name}",
                "travel-marketplace-description": "A collection of coolest gadgets that you'll like",
                "travel-marketplace-keywords": "創意, 產品, 流行, 電器, 生活, 精品, 智能家居, 設計, 高品質, 設計概念, 創意科技, 生活用品, 戶外休閒, 廚房, 餐桌, 個人護理, 防疫抗疫, 健康, 遊戲, 兒童玩樂, 健身, 家居健身, gym, home gym, smart home, style home",
                "travel-marketplace-product-checkout-title": "{product}",
                "travel-marketplace-product-title": "{product}",
                "travel-marketplace-title": "Travel Gadgets",
                "travel-money-description": "HyperAir bietet Ihnen eine brandneue Möglichkeit, an Reisegeld zu kommen. Jetzt können Sie den Austausch online mit dem besten in der Stadt Wechselkurs buchen!",
                "travel-money-keywords": "sim,,,,,,,,,,,,, , 兌換 兌換, 找 找, 銀行, 金融, 外匯, 外滙, 匯率, 滙率, 匯款, 外幣, 貨幣, 旅行, 旅遊, 特價, 預訂, 交易, 交易, 旅遊, 保險日本, 泰國, 韓國, 台灣, 日圓, 日元, 台幣, 泰銖, HyperAir, HyperAir FX, HyperAir-Reisen, Reisen, Reisegeld, Fremdwährung, Devisen, 百年, 堅 堅, 發達 發達, rich, richbird, verrückter Vogel berlin austausch",
                "travel-money-title": "HyperAir - Travel Money Smarter austauschen.",
                "travel-product-checkout-keywords": "創意, 產品, 流行, 電器, 生活, 精品, 智能家居, 設計, 高品質, 設計概念, 創意科技, 生活用品, 戶外休閒, 廚房, 餐桌, 個人護理, 防疫抗疫, 健康, 遊戲, 兒童玩樂, 健身, 家居健身, gym, home gym, smart home, style home",
                "travel-product-keywords": "創意, 產品, 流行, 電器, 生活, 精品, 智能家居, 設計, 高品質, 設計概念, 創意科技, 生活用品, 戶外休閒, 廚房, 餐桌, 個人護理, 防疫抗疫, 健康, 遊戲, 兒童玩樂, 健身, 家居健身, gym, home gym, smart home, style home",
                "travel-sim-checkout-description": "{country} Travel SIM - Hochwertige SIM-Karte mit kostenlosem Versand bis an die Haustür!",
                "travel-sim-checkout-keywords": "上 上, 電話 電話, 數據 數據, DataSIM, 旅遊 DataSIM, 數據 數據, 4G 上, 上 上, 4G 上, 日本 日本, 東京 4G 上, 東京 東京,上網 大阪 上, 泰國 4G 上, 泰國 泰國, 曼谷 4G 上, 台灣 4G 上, 台灣 4G 網卡, 台灣 台灣, 台北 4G 上, 高雄 4G 上, 台中 台中 上, 韓國 4G 上, 韓國 韓國, 首 4G 上, 爾 首 上, 中國 中國, 網卡 4G 上, 深圳 中國 網卡, 深圳 網卡, 網卡 4G 上, Docomo, Softbank",
                "travel-sim-checkout-success-description": "{country} Travel SIM - Hochwertige SIM-Karte mit kostenlosem Versand bis an die Haustür!",
                "travel-sim-checkout-success-keywords": "上 上, 電話 電話, 數據 數據, DataSIM, 旅遊 DataSIM, 數據 數據, 4G 上, 上 上, 4G 上, 日本 日本, 東京 4G 上, 東京 東京,上網 大阪 上, 泰國 4G 上, 泰國 泰國, 曼谷 4G 上, 台灣 4G 上, 台灣 4G 網卡, 台灣 台灣, 台北 4G 上, 高雄 4G 上, 台中 台中 上, 韓國 4G 上, 韓國 韓國, 首 4G 上, 爾 首 上, 中國 中國, 網卡 4G 上, 深圳 中國 網卡, 深圳 網卡, 網卡 4G 上, Docomo, Softbank",
                "travel-sim-checkout-success-title": "Zahlungserfolg - Reise-SIM",
                "travel-sim-checkout-title": "Bestellung aufgeben - Reise-SIM",
                "travel-sim-keywords": "sim 卡, 上 上, 電話 電話, 數據 Data, DataSIM, 旅遊 DataSIM, 數據 數據, 4G 上, 日本 日本, 日本 sim 卡, 東京 4G 上, 大阪 4G上 上, 大阪 上, 泰國 4G 上, 泰國 泰國 上, 泰國 sim 卡, 曼谷 4G 上, 台灣 4G 網卡, 台灣 sim 卡, 台北4G, 4G, 4G, 4G, 4G, 4G, 4G, 4G, 4G, 4G, 4G, 4G, 4G, 4G, 4G , 中國 中國 內地 數據, 深圳 4G 上, 深圳 深圳 上, 歐洲 4G 上, 歐洲 歐洲 上, 歐洲 sim 卡, 英國 4G 上, 英國 sim 卡, 法國 4G 上 上, 法國 法國 上, 法國 sim 卡, 恴 4G 上, 意大利 意大利 上, 巴黎 sim 卡, 巴黎 4G 上, 瑞士 4G 上, 瑞士 sim 卡,瑞士 sim 卡, Docomo, Softbank, 和 和, 聯通, 3hk, 3uk, Birdie, 自由 自由, Luft sim, sim2fly, AIS, ist sim2fly, SK Telecom, TrueMove, dtac, t mobile, vietnamobile",
                "travel-sim-title": "【{country} SIM】{sim_name} - Bestpreisgarantie mit kostenlosem Versand",
                "travel-sims-description": "Globale Reise-SIM-Suchmaschine mit hochwertiger SIM-Karte und kostenlosem Versand bis an Ihre Haustür!",
                "travel-sims-keywords": "sim, sim, sim, sim, sim, sim, sim, sim, sim, sim, sim, sim, sim, sim, sim, sim, sim, sim, sim, sim, sim, sim, sim, sim, sim, sim, sim, sim, sim, sim, sim, sim, sim, sim, sim, sim, sim, sim, sim, sim, sim上 上, 大阪 上, 泰國 4G 上, 泰國 泰國 上, 泰國 sim 卡, 曼谷 4G 上, 台灣 4G 網卡, 台灣 sim 卡, 台北4G, 4G, 4G, 4G, 4G, 4G, 4G, 4G, 4G, 4G, 4G, 4G, 4G, 4G, 4G卡, 中國 中國 內地, 卡 上., 深圳 深圳, 網卡 澳門 上, 澳門 澳門 澳門, Doc 歐洲 歐洲, Doc 歐洲, Doc AIS, Doc 歐洲, Soft Doc, AIS AIS, AIS sim, AIS sim , t mobile 全球 全球 上, vietnamobile",
                "travel-sims-title": "Travel SIM - Bestpreisgarantie mit kostenlosem Versand"
            },
            "shop-confirmation": {
                "app-download": "",
                "app-download-subtitle": "",
                "instruction": "",
                "my-order": "",
                "pending-confirm": ""
            },
            "staycation": {
                "activity-countdown-button": "Find the cheapest price",
                "all-hotels": {
                    "sorting": {
                        "recommended": "Recommended"
                    }
                },
                "all-hotels-all-button": "All",
                "all-hotels-hotel-name": "Hotel Name",
                "all-hotels-last-updated": "Last Updated",
                "all-hotels-less-button": "Less",
                "all-hotels-more-button": "More",
                "all-hotels-no-result": "Sorry, we couldn't find any results",
                "all-hotels-title": "",
                "compare-packages": "Compare other packages",
                "countdown-button": "More Details",
                "countdown-title": "",
                "countdown2-title": "HyperAir Recommended",
                "countdown3-title": "最新 Staycation 酒店限時優惠",
                "month-format": "MMM",
                "order-d-title": "浪漫精品酒店 💕💕",
                "order-g-subtitle": "暑假帶埋一家大細Relax下",
                "order-g-title": "親子Staycation必去之選👨‍👩‍👧‍👦😍",
                "order-h-title": "郵輪之旅🛳️",
                "order-i-title": "情侶煮飯仔酒店 🍽️",
                "order-j-title": "Glamping豪華露營推介",
                "seo-description": "點解咁多人用 HyperAir 搵 Staycation? 因為集合左 KKday, Trip.com, Klook 及各大香港酒店平台，一眼比較邊到有late checkout、免費泊車、自助早午晚餐及餐飲回贈等獨家 Staycation 優惠，每日更新。",
                "seo-keywords": "staycation, staycation 優惠, 香港 staycation, staycation 香港, staycation hk, staycation package, staycation hong kong, 酒店, 酒店 優惠, staycation 中文, 香港 酒店, klook 優惠, klook 優惠, kkday 優惠, trip 優惠, agoda 優惠, runhotel staycation, 酒店 套票, staycation 酒店, 香港 酒店 套票, 訂 酒店 優惠, 酒店 package, 特價 酒店, 香港 優惠 酒店, 酒店 優惠 套 票, 特價 酒店 香港, 香港 酒店 優惠, 酒店 住宿 優惠, staycation 2020, staycation 2021, staycation 2022, staycation 1月 優惠, staycation 2月 優惠, staycation 3月 優惠, staycation 4月 優惠, staycation 5月 優惠, staycation 6月 優惠, staycation 7月 優惠, staycation 8月 優惠, staycation 9月 優惠, staycation 10月 優惠, staycation 11月 優惠, staycation 12月 優惠, 四季酒店, W酒店, Murray, JW Marriott, St. Regis, Conrad Hotel, Grand Hyatt, Ritz Carlton, Rosewood, 露台 酒店, 廚房 酒店, 親子 酒店, 情侶 酒店",
                "seo-title": "【2021年9月最新】香港酒店 Staycation 優惠搜尋神器 全港最齊．每日更新 - 最齊香港staycation優惠、酒店優惠、Hong Kong Staycation Ideas、Klook優惠、KKday優惠、Trip優惠、Agoda優惠、專業旅運優惠 - HyperAir 玩樂必備搜尋比較平台！一次過，比較全球多個玩樂旅遊預訂網站！ - HyperAir",
                "share-button-alert": "Copied the Link",
                "subtitle": "每日更新酒店餐飲及住宿優惠（{start_month}月至{end_month}月）",
                "title": "",
                "top10-title": "",
                "top102-title": "",
                "top103-title": "值得一試的 Staycation 酒店🥂"
            },
            "travel-activities": {
                "best-deals": "Best Deal",
                "book-now": "View Deal",
                "disclaimer": "Die angegebenen Preise sind nur als Referenz. Im Falle von Unstimmigkeiten besuchen Sie bitte die Website unserer Partner.",
                "empty-destination": "",
                "more-deals": "More Deals",
                "not-available": "Not Available",
                "offers": "",
                "provider-getyourguide": "GetYourGuide",
                "provider-hk": {
                    "trip": {
                        "com": "Trip.com"
                    }
                },
                "provider-hyperair": "HyperAir",
                "provider-kkday": "KKday",
                "provider-klook": "KLOOK",
                "provider-seoultravelpass": "SeoulPass",
                "provider-sim": {
                    "hyperair": {
                        "com": "HyperAir"
                    }
                },
                "provider-travelexpert": "Travel Expert",
                "provider-trip": "Trip.com",
                "ratings": "Bewertung",
                "recommended-title": "Beliebtere Aktivitäten in {city}",
                "search-africa-oceania": "Afrika / Ozeanien",
                "search-all-cities": "Alle Städte",
                "search-america": "Amerika",
                "search-asia": "Asien",
                "search-button": "Suche",
                "search-cancel-button": "Stornieren",
                "search-country-placeholder": "Land oder Stadt eingeben",
                "search-euro-middleeast": "Europa / Mittlerer Osten",
                "search-hardcoded-cities": "Beliebte Suchen:",
                "search-placeholder": "Suche \"JR Pass\"",
                "search-popular-cities": "Beliebte Städte",
                "search-searched-cities": "Gesuchte Städte",
                "search-slogan-2": "",
                "show-similar-product": "Vergleichen ähnlich",
                "sorting": {
                    "price-asc": "Preis niedrig bis hoch)",
                    "price-desc": "Preis (absteigend)",
                    "rating": "Bewertung",
                    "relevance": "Relevanz",
                    "sort-by": "Sortiere nach"
                },
                "title": "Suchergebnisse passend zu \"{q}\"",
                "title-everything": "Beliebte Aktivitäten in {city}",
                "title-no-result": "Es wurden leider keine Ergebnisse für \"{q}\" gefunden.",
                "title-no-result-without-keyword": "Es wurden keine Ergebnisse finden",
                "total-results": "Gesamtergebnis <b>{number} </ b>"
            },
            "travel-affiliate-codes": {
                "cover-slogan": "Geben Sie Rabatt-Codes für internationale Reisebuchungsseiten",
                "cover-title": "Reisen Rabatt-Gutscheine",
                "disclaimer": "Die Förderung Angebote gezeigt sind nur als Referenz. Im Falle von Abweichungen finden Sie auf der Website unserer Partner. Lieferanten können die Informationen jederzeit ohne vorherige Ankündigung geändert oder gelöscht werden und wird nach alleinigem Ermessen zu dem Angebot haben.",
                "exclusive": "Exklusiv",
                "type-activity": "Aktivität",
                "type-air": "Flugticket",
                "type-all": "Alle",
                "type-hotel": "Hotel",
                "type-insurance": "Reiseversicherung",
                "type-shopping": "Einkaufen",
                "type-sim": "SIM Karte",
                "use-promo-code": "Code abrufen",
                "valid-until": "Gültig bis:"
            },
            "travel-insurance": {
                "breadcrumb-travel-insurance": "Reiseversicherung",
                "cover-subtitle": "Suchen und vergleichen Sie die beste Reiseversicherung mit Mobilfunkabdeckung!",
                "cover-title": "Reiseversicherung",
                "departure-date-alert": "",
                "disclaimer": "Quote ist nur als Referenz. Bitte beachten Sie die Versicherungsgesellschaft Website für weitere Informationen.",
                "highlight-subtitle1": "Liste aus dem Schlüssel Abdeckung der Reiseversicherung Pläne für Ihre einfache Wahl",
                "highlight-subtitle2": "Vergleichen Sie die beste Reiseversicherung Angebote zu Hilfe, die Sie jeden Dollar sparen!",
                "highlight-subtitle3": "Genießen Sie exklusive Reiseversicherung Privilegien und Angebote!",
                "highlight-title1": "Coverage-Vergleich",
                "highlight-title2": "Preisvergleich",
                "highlight-title3": "exklusive Prämien",
                "num-of-travellers-alert": "",
                "partner-title": "Unsere Reiseversicherung Partner",
                "return-date-alert": "",
                "section-title": "Sie suchen jetzt {num_of_day} für {num_of_traveller} Reisenden (n)",
                "slogan": "3 einfache Schritte",
                "sorting": {
                    "coverage": "Beste Coverage",
                    "price-asc": "Preis niedrig bis hoch)",
                    "price-desc": "Preis (absteigend)"
                },
                "step1": "Füllen Sie das Info",
                "step1-detail": "Geben Sie Ihren Zielort, Datum und Nr. von Reisenden",
                "step2": "Vergleichen Sie die Pläne",
                "step2-detail": "Vergleichen Sie den Preis und den Umfang der Reiseversicherung Pläne",
                "step3": "Genießen Sie die Angebote",
                "step3-detail": "Ein-Klick auf exklusive Reiseversicherung buchen Sie bequem online"
            },
            "travel-insurance-product-card": {
                "apply-now": "Holen Sie sich das Angebot",
                "cancellation": "STORNIERUNG",
                "car-rental": "FAHRZEUG RENTAL EXCESS",
                "cruise-vacation": "Kreuzfahrt (optional Vorteile)",
                "dangerous-sports": "GEFÄHRLICHE SPORTS",
                "hyperair-exclusive": "HYPERAIR EXCLUSIVE",
                "medical": "MEDIZINISCH",
                "mobile": "Verlust / Beschädigung des Mobiltelefons",
                "personal-belongings": "PERSÖNLICHE BESITZTÜMER",
                "trip-delay": "TRIP DELAY"
            },
            "travel-insurance-search-bar": {
                "children": "Kinder im Alter von unter 18",
                "date": "Abfahrtsdatum und Rückgabedatum",
                "destination": "Wohin gehst du",
                "friend": "Freunde / Verwandte",
                "myself": "Mich selber",
                "number-of-traveller": "Anzahl der Reisenden",
                "search-button": "Suche",
                "spouse": "Ehepartner"
            },
            "travel-marketplace": {
                "buy-now-can-earn-x-miles": "",
                "cover-slogan": "Eine Sammlung von coolsten Gadgets, die Sie mögen",
                "cover-title": "Travel Gadgets"
            },
            "travel-marketplace-categories": "Categories",
            "travel-marketplace-checkout": {
                "delivery-message-body": "Arbeitstage sind von Montag bis Freitag (außer an Feiertagen). Die Reihenfolge cut-off 12.00 Uhr (GMT + 8). Bestellungen, die nach 12{00} (GMT + 8) werden am nächsten Werktag versandt werden.",
                "delivery-method-1": "SF Express (Hong Kong Only)",
                "delivery-method-1-description": "Mit dem SF Express, ist Eilbotegebühr HK $ 30 pro Bestellung. Courier Gebühr wird beim Kauf über HK $ 800 verzichtet. Die bestellten Artikel werden per Kurier innerhalb von 1-3 Werktagen geliefert werden, und die Inseln werden 5 Arbeitstage, die sich auf SF Express Website.",
                "delivery-method-2": "Internationales Versenden",
                "delivery-method-2-description": "Lieferung innerhalb von 4 bis 15 Arbeitstage je nach Bestimmungsort. Gebühr Versand ist HK $ 100 pro Stück. Die obige internationale Zustellgebühr wird auf einer Schätzung basiert. Weiterer Zuschlag gilt."
            },
            "travel-money": {
                "breadcrumb-travel-money": "Reisegeld",
                "cover-button": "Jetzt erleben",
                "cover-slogan": "Reisegeld schlauer tauschen",
                "cover-title": "Reisegeld",
                "disclaimer": "Die angezeigten Preise sind nur als Referenz. Im Falle von Abweichungen entnehmen Sie bitte der Website des Geldwechsler.",
                "empty-amount": "",
                "fx": "",
                "fx-slogan": "Vier einfache Schritte",
                "fx-step1": "Suche",
                "fx-step1-detail": "Wählen Sie die Währung aus, die Sie umtauschen möchten",
                "fx-step2": "Vergleichen Sie",
                "fx-step2-detail": "Finden Sie den günstigsten Tarif und den bequemsten Abholort",
                "fx-step3": "Buch",
                "fx-step3-detail": "Reservieren Sie das Reisegeld online",
                "fx-step4": "Abholen",
                "fx-step4-detail": "Zeigen Sie den QR-Code, um das Reisegeld zu erhalten",
                "hyperair-feature-1": "Clever",
                "hyperair-feature-1-description": "Eine clevere Art, Reisegeld umzutauschen. Jetzt können Sie mit nur wenigen Klicks den günstigsten Preis finden und das Reisegeld online reservieren. Zeit, sich von der langen Schlange zu verabschieden!",
                "hyperair-feature-2": "Zuverlässig",
                "hyperair-feature-2-description": "Ein zuverlässiger Weg zum Geldwechsel. Alle unsere Partner sind lizenzierte Banken und Geldwechsler, um Ihre Devisen sicher zu verwahren.",
                "hyperair-feature-3": "Irgendwo. Jederzeit.",
                "hyperair-feature-3-description": "Ein brandneuer Weg, um an Reisegeld zu kommen. Wir sind bestrebt, die Präsenz in Übersee zu vergrößern und Ihnen das intelligenteste Reiseerlebnis aller Zeiten zu bieten.",
                "i-will-get": "ICH WERDE BEKOMMEN",
                "i-will-pay": "ICH WERDE BEZAHLEN",
                "join-us": "Für mehr Geschäftsmöglichkeit",
                "join-us-button": "Begleiten Sie uns jetzt",
                "join-us-slogan": "Werden Sie unser Lieferant",
                "search-bar-placeholder": "Menge eingeben",
                "search-button": "Suche",
                "section-title": "",
                "section-title-from-hkd": "Suche HKD für {amount} {currency}",
                "section-title-to-hkd": "Suche {amount} {currency} HKD",
                "why-hyperair": "",
                "why-hyperair-description": "HyperAir bietet Ihnen eine brandneue Möglichkeit, an Reisegeld zu kommen. Jetzt können Sie den Austausch online mit dem besten in der Stadt Wechselkurs buchen!",
                "why-hyperair-title": "Warum Uns Wählen?"
            },
            "travel-product": {
                "buy-now": "Kaufe jetzt",
                "product-option": "Optionen"
            },
            "travel-sim": {
                "as-low-as": "So niedrig wie",
                "book-now": "Jetzt bestellen",
                "breadcrumb-homepage": "Startseite",
                "breadcrumb-mainpage": "Hauptseite",
                "breadcrumb-travel-sim": "Reise-SIM",
                "cancellation-policy": "Stornierungsbedingungen",
                "cancellation-policy-content": "Nach dem Kauf können keine Stornierungen, Rückerstattungen oder Änderungen vorgenommen werden.",
                "download-hyperair-now-description": "Scannen Sie den QR-Code oder besuchen Sie den App Store, um die HyperAir App herunterzuladen",
                "download-hyperair-now-title": "Laden Sie die HyperAir App herunter",
                "first-step": "Schritt 1",
                "go-to-shopping-cart-description": "",
                "go-to-shopping-cart-title": "",
                "hardcoded-countries-title": "Andere Beliebte Länder:",
                "highlights": "Höhepunkte",
                "important-notice": "Wichtiger Hinweis",
                "instructions": "Anleitung",
                "lowest-price-guarantee": "Bestpreisgarantie",
                "no-stock": "Ausverkauft",
                "num-of-review": ": Anzahl der Überprüfungen",
                "popular-countries": "Travel SIM deckt 200 Länder ab",
                "popular-countries-search-button": "Suche in anderen Ländern",
                "product-highlights": "Product Description",
                "product-specification": "Produktspezifikation",
                "related-sims": "Verwandte: Land SIM",
                "related-sims-search-button": "Mehr: Länder-SIM",
                "review": "Rezension",
                "review-date": "{Datum}",
                "review-no-firstname-user": "Reisender",
                "scan-product-qr-code": "掃 掃 QR-Code 購買 此 此",
                "second-step": "Schritt 2",
                "sim": " Sim Cards",
                "web-traffic": "Gekauft: Anzahl der gekauften Zeiten seit letzter Woche und: Anzahl der Verkehrsteilnehmer sehen sich diese SIM-Karte gerade an",
                "web-traffic-title": "Diese SIM ist in den heißen Verkäufen!"
            },
            "travel-sim-checkout": {
                "-secure-payment-slogan": "",
                "address": "Lieferadresse",
                "address-column1": "z.B. Raum A, 18 / F, Weltzentrum",
                "address-column2": "z.B. 88 Fahrstraße",
                "address-column3": "z.B. Zentral, Hong Kong",
                "back-button": "Zurück",
                "checkout-title-1": "Lieferinfo",
                "confirm-button": "Fortsetzen",
                "country-code": "Landesvorwahl",
                "delivery-message-body": "Working days are from Monday to Friday (except public holidays). The order cut-off time is 12：00 PM (GMT+8). Orders placed after 12：00 PM (GMT+8) will ship out the next working day.\n<br><br>Within the same working day, orders with the same delivery address will be sent together.",
                "delivery-message-header": "Lieferschein",
                "delivery-method": "Versandart",
                "delivery-method-1": "Hong Kong Post (Free)",
                "delivery-method-1-description": "By Hong Kong Post's Local Mail, the estimated delivery will be within 3-6 working days. Status tracking is not available to local mail and customers shall bare the full responsibility of losing items by using Hong Kong Post’s ordinary mail service.\n<br><br>Note: Due to the time required for delivery, customers who are about to travel are recommended to choose SF Express",
                "delivery-method-2": "SF Express (Hong Kong only. Courier fee payable on delivery)",
                "delivery-method-2-description": "By SF Express (courier fee payable on delivery), the ordered items will be delivered by courier within 1-3 working days, and islands will take longer delivery time. The courier fee is about HK$16-$25 by referring to the website of SF Express.\n<br><br>Note: The order over HK$399 will be upgraded to SF Express for FREE",
                "delivery-method-3": "International Shipping",
                "delivery-method-3-description": "Delivered by Hong Kong Post (tracking no. will be provided) within 4 to 15 working days depends on the destination. Shipping cost HK$30.",
                "error-alert-address": "Bitte geben Sie die Lieferadresse ein.",
                "error-alert-invalid-email": "Das E-Mail-Format ist ungültig.",
                "error-alert-invalid-recipient-first-num": "Die Kontaktnummer sollte mit 2,3,5,6,7,8 oder 9 beginnen.",
                "error-alert-invalid-recipient-number": "Bitte geben Sie die richtige Telefonnummer ein.",
                "error-alert-invalid-user-first-num": "Die Handynummer sollte mit 5,6,7,8 oder 9 beginnen.",
                "error-alert-invalid-user-number": "Bitte geben Sie die richtige Handynummer ein.",
                "error-alert-personal-info": "Bitte geben Sie Ihre persönlichen Daten ein.",
                "error-alert-recipient-info": "Bitte geben Sie die Empfängerinformationen ein.",
                "error-invalid-credit-card-info": "Ungültige Kreditkarteninformationen",
                "facebook-login": "Weiter mit Facebook",
                "google-login": "Weiter mit Google",
                "logged-in": "Eingeloggt",
                "login": "Bestehender Kunde, melden Sie sich an, um den Express-Check-out zu genießen",
                "login-button": "Anmeldung",
                "login-email": "Email",
                "login-no-user-exists": "Hoppla! Leider können wir Ihre Anmeldedaten nicht bestätigen. Bitte versuchen Sie es erneut oder schließen Sie die Bestellung einfach ab, ohne dass Sie auschecken müssen.",
                "login-password": "Passwort",
                "payme": {
                    "error-contacting-payme": "Zahlungsfehler, bitte Nachbestellung erneut oder kontaktieren Sie den Kundendienst."
                },
                "payment": {
                    "actual-payment": "The transaction will be settled at HK${actual_payment} and the exchange rate will be based on your credit card issuer.",
                    "choose-payment-method": "Zahlungsart auswählen:",
                    "logistic-information": "Lieferinfo",
                    "modify-information": "Bearbeitungs Information",
                    "pay-now": "Zahl jetzt",
                    "payme-instruction-do-not-close": "Bitte schließen Sie nicht diese Seite, bevor die Zahlung abgeschlossen ist",
                    "payme-instruction-step-1": "1. Öffnen Sie die PayMe App.",
                    "payme-instruction-step-2": "2. Scannen Sie den Paycode zu autorisieren Zahlung.",
                    "payme-instruction-step-3": "3. Führen Sie die Zahlung in der App und Bestätigung abwarten.",
                    "payme-instruction-title": "Bezahlen mit PayMe",
                    "payme-title": "Fotografiere diesen Paycode mit PayMe",
                    "payment": "Zahlung",
                    "price": "Menge",
                    "shipping-fee": "Versandkosten",
                    "subtotal": "Zwischensumme"
                },
                "payment-method": "Zahlungsmethode",
                "pending": {
                    "mobile-redirection-text": "Sie haben PayMe als Zahlungsmethode ausgewählt und wird dem PayMe App zur vollständigen Bezahlung weitergeleitet.",
                    "need-to-pay": "Offener Betrag",
                    "order-number": "Bestellnummer",
                    "order-success-please-pay": "Bitte zahlen Sie mit PayMe den Bestellvorgang abzuschließen",
                    "paycode-error": "Zahlungsfehler, bitte Nachbestellung erneut oder kontaktieren Sie den Kundendienst.",
                    "paycode-expired": "PayMe des paycode abgelaufen, bitte erneut um wieder.",
                    "re-order": "Nachbestellung",
                    "title-payme": "Bezahlen Sie mit PayMe"
                },
                "recipient-address": "Lieferadresse",
                "recipient-information": "Empfänger Info",
                "recipient-name": "Empfängername",
                "recipient-phone-number": "Telefonnummer des Empfängers",
                "secure-payment-slogan": "Sichere Kasse | Die Zahlung wird verschlüsselt und sicher per SSL übertragen",
                "simproduct-detail": "Bestellinfo",
                "simproduct-quantity": "Menge",
                "simproduct-redeem": "",
                "simproduct-redeem-hypermiles": "",
                "simproduct-title": "Produkt",
                "simproduct-will-redeeming-x-miles": "",
                "simproduct-you-have-x-hypermiles": "",
                "user-email": "E-Mail (Rechnung erhalten)",
                "user-firstname": "Vorname",
                "user-information": "Persönliche Informationen",
                "user-lastname": "Nachname",
                "user-phone-number": "Handynummer",
                "vertical-divider": "ODER"
            },
            "travel-sims": {
                "column-title-1": "Klare Klassifizierung, leicht zu wählen",
                "column-title-2": "Online-Zahlung, bequem und schnell",
                "column-title-3": "Kostenlose Post, schnelle Lieferung",
                "country-search-no-place-found": "Für dieses Reiseziel wurden keine Ergebnisse gefunden",
                "cover-button": "Bestellen Sie jetzt mit der HyperAir App",
                "cover-slogan": "Beste SIM-Karte befasst sich mit kostenlosem Versand!",
                "cover-title": "Reise-SIM",
                "empty-destination": "",
                "num-of-days": "",
                "search-button": "",
                "search-input": "Land suchen",
                "search-placeholder": "Land suchen",
                "search-slogan": "Wohin gehst du?",
                "travel-sim-header-description": "",
                "travel-sim-header-title": ""
            }
        },
        "passwords": {
            "password": "Passwörter müssen aus mindestens sechs Zeichen bestehen und mit der Bestätigung übereinstimmen.",
            "reset": "Dein Passwort wurde zurück gesetzt!",
            "sent": "Wir haben Ihren Link zum Zurücksetzen des Passworts per E-Mail gesendet!",
            "token": "Dieses Passwort-Reset-Token ist ungültig.",
            "user": "Wir können keinen Benutzer mit dieser E-Mail-Adresse finden."
        },
        "mail": {
            "product-simcard": {
                "delivery-update": {
                    "subject": "Ihre SIM-Kartenbestellung ist unterwegs"
                },
                "purchased": {
                    "subject": "Bestätigung der Reise-SIM-Bestellung"
                },
                "tracking-number-update": {
                    "subject": "Ihre Auftragsverfolgungsnummer wird aktualisiert"
                }
            }
        },
        "member-center": {
            "login-to-receive-codes": "",
            "my-orders-empty": "Keine Aufzeichnungen",
            "my-orders-title": "meine Bestellungen",
            "profile-area-code": "Vorwahl",
            "profile-email": "Email",
            "profile-firstname": "Vorname",
            "profile-lastname": "Nachname",
            "profile-save": "speichern",
            "profile-tel": "Tel",
            "profile-title": "Profil",
            "profile-update-successfully": "",
            "promo-code-enter-promotion-code": "Aktionscode eintragen",
            "promo-code-my-promo-code": "Mein HyperAir Promotion-Code",
            "promo-code-no-code": "",
            "promo-code-please-fill-in-code": "",
            "promo-code-redeem": "Einlösen",
            "promo-code-redeem-code": "Einlösen HyperAir Promotion-Code",
            "promo-code-select": "Wählen",
            "promo-code-title": "HyperAir Promo-Code",
            "title": "Mitgliederzentrum"
        },
        "weekday": {
            "1": "Montag",
            "2": "Dienstag",
            "3": "Mittwoch",
            "4": "Donnerstag",
            "5": "Freitag",
            "6": "Samstag",
            "7": "Sonntag"
        },
        "exchange-shop-details": {
            "address": "Adresse",
            "book-button": "buchen Sie jetzt",
            "br": "BR",
            "closed-book-button": "Geschlossen",
            "download-pop-up": {
                "slogan-1": "Locked in bewerten",
                "slogan-2": "Instant comfirmation",
                "title": "Laden App für die FX-Buchung"
            },
            "latest-updated": "Letztes Update",
            "not-available-book-button": "Nicht verfügbar",
            "opening-hrs": "Öffnungszeiten",
            "phone-num": "Telefonnummer",
            "rate": "Bewertung",
            "reviews": "Bewertungen",
            "table-buy-rate": "Kaufen Preis",
            "table-compare-button": "Vergleichen Sie",
            "table-currency": "Währung",
            "table-sell-rate": "Verkaufskurs",
            "table-short-form": "Code",
            "table-title": "andere Währungen"
        },
        "credit-card": {
            "cannot-add-card": "Beim Hinzufügen Ihrer Kreditkarte ist ein Fehler aufgetreten. Bitte überprüfen Sie Ihre Angaben und versuchen Sie es erneut, oder fügen Sie eine andere Kreditkarte hinzu.",
            "cannot-process": "Beim Aufladen Ihrer Kreditkarte ist ein Fehler aufgetreten. Bitte überprüfen Sie Ihre Angaben und versuchen Sie es erneut. Sie können auch mit einer anderen Kreditkarte auschecken."
        },
        "shoppingcart": {
            "add": {
                "no-stock": "Hoppla! Die maximale Abnahmemenge für dieses Produkt wurde erreicht ..."
            },
            "pay": {
                "db-locked": "Server ausgelastet. Bitte versuchen Sie es später noch einmal. (Referenzcode: E1003)",
                "invalid-promotion-code": "Ungültiger Promotion-Code",
                "no-stock": "Produkt (e) gerade nicht am Lager! (Ref. Code: E1002)"
            },
            "promotion-message": {
                "up-sell-1": "Genießen Sie HK $ 10 Rabatt mit Willkommensgutschein",
                "up-sell-2": "Genießen Sie HK $ 15 Rabatt mit dem Promo-Code HYPER15, wenn Sie mehr als HK $ 299 ausgeben"
            }
        },
        "product": {
            "label-confirmation-duration-24_hours": "24 Stunden Bestätigung",
            "label-confirmation-duration-48_hours": "48 Stunden Bestätigung",
            "label-confirmation-duration-instant": "Sofortige Bestätigung",
            "label-duration-unit-day": "& nbsp; Tage",
            "label-duration-unit-hour": "Std)",
            "label-duration-unit-hr": "Stunden",
            "label-duration-unit-min": "& nbsp; Minuten",
            "label-earliest-available-date": "j M Y",
            "label-earliest-available-date-today": "Heute",
            "label-earliest-available-date-tomorrow": "Morgen",
            "label-lang-en": "Englisch",
            "label-lang-jp": "Japanisch",
            "label-lang-kr": "Koreanisch",
            "label-lang-zh": "Chinesisch",
            "label-meet-up-method-hotel_pickup": "Abholung vom Hotel",
            "label-meet-up-method-location_meet_up": "Ort treffen sich",
            "label-refundable-conditional_cancel": "Bedingte Stornierung",
            "label-refundable-no_cancel": "Keine Stornierung",
            "label-ticket-logistic-mobile": "Handy Voucher akzeptiert",
            "label-ticket-logistic-printed": "Gedruckter Gutschein akzeptiert",
            "label-ticket-logistic-printed_or_mobile": "Gedruckter oder mobiler Gutschein akzeptiert",
            "label-ticket-validity-fixed_date": "Ticket mit festem Datum",
            "label-ticket-validity-open_date": "Open Date Ticket",
            "label-ticket-validity-open_or_fixed_date": "Open / Fixed Date Ticket"
        },
        "pagination": {
            "next": "Weiter & raquo;",
            "previous": "& laquo; Bisherige"
        },
        "city": {
            "abu-dhabi": "Abu Dhabi",
            "adelaide": "Adelaide",
            "agra": "Agra",
            "ahmedabad": "Ahmedabad",
            "alice-springs": "Alice Springs",
            "alsace": "Elsass",
            "amritsar": "Amritsar",
            "amsterdam": "Amsterdam",
            "andalusia": "Andalusien",
            "antalya": "Antalya",
            "anuradhapura": "Anuradhapura",
            "athens": "Athen",
            "auckland": "Auckland",
            "bacolod": "Bacolod",
            "bagan": "Bagan",
            "baku": "Baku",
            "bali": "Bali",
            "bandung": "Bandung",
            "bangalore": "Bangalore",
            "bangkok": "Bangkok",
            "barcelona": "Barcelona",
            "batam": "Batam",
            "bath": "Bad",
            "bay-of-islands": "Bucht der Inseln",
            "beijing": "Peking",
            "belfast": "Belfast",
            "bentota": "Bentota",
            "berlin": "Berlin",
            "bohol": "Bohol",
            "boracay": "Boracay",
            "bordeaux": "Bordeaux",
            "boston": "Boston",
            "bratislava": "Bratislava",
            "brisbane": "Brisbane",
            "bruges": "Brügge",
            "brussels": "Brüssel",
            "budapest": "Budapest",
            "burgundy": "Burgund",
            "busan": "Busan",
            "cairns": "Cairns",
            "cambridge": "Cambridge",
            "cameron-highlands": "Cameron Highlands",
            "canary-islands": "Kanarische Inseln",
            "cape-town": "Kapstadt",
            "cappadocia": "Kappadokien",
            "cebu": "Cebu",
            "champagne": "Champagner",
            "chengdu": "Chengdu",
            "chennai": "Chennai",
            "chiang-mai": "Chiang Mai",
            "chiang-rai": "Chiang Rai",
            "chiayi": "Chiayi",
            "chicago": "Chicago",
            "chongqing": "Chongqing",
            "christchurch": "Christchurch",
            "cochin": "Cochin",
            "cologne": "Köln",
            "colombo": "Colombo",
            "copenhagen": "Kopenhagen",
            "costa-del-sol": "Costa del Sol",
            "crete": "Kreta",
            "da-lat": "Da Lat",
            "da-nang": "Da Nang",
            "darwin": "Darwin",
            "davao": "Davao",
            "delhi": "Delhi",
            "dhaka": "Dhaka",
            "dresden": "Dresden",
            "dubai": "Dubai",
            "dublin": "Dublin",
            "dubrovnik": "Dubrovnik",
            "dumaguete": "Dumaguete",
            "dunedin": "Dunedin",
            "düsseldorf": "Düsseldorf",
            "edinburgh": "Edinburgh",
            "finnish-lapland": "",
            "florence": "Florenz",
            "frankfurt": "Frankfurt",
            "fraser-island": "Fraser Island",
            "french-riviera": "Französische Riviera",
            "fukuoka": "Fukuoka",
            "galle": "Galle",
            "galway": "Galway",
            "gangtok": "Gangtok",
            "gangwon-do": "Gangwon-do",
            "gdansk": "Danzig",
            "geneva": "Genf",
            "genting-highlands": "Genting Highlands",
            "geraldton": "Geraldton",
            "glasgow": "Glasgow",
            "goa": "Goa",
            "gold-coast": "Goldküste",
            "gothenburg": "Göteborg",
            "guam": "Guam",
            "guangdong": "Guangdong",
            "guilin": "Guilin",
            "guizhou": "Guizhou",
            "gyeonggi-do": "Gyeonggi-do",
            "haikou": "Haikou",
            "hakone": "Hakone",
            "halong": "Halong",
            "hamburg": "Hamburg",
            "hangzhou": "Hangzhou",
            "hanoi": "Hanoi",
            "harbin": "Harbin",
            "hat-yai": "Hat Yai",
            "hawaii": "Hawaii",
            "heidelberg": "Heidelberg",
            "helsinki": "Helsinki",
            "himachal-pradesh": "Himachal Pradesh",
            "hiroshima": "Hiroshima",
            "ho-chi-minh-city": "Ho Chi Minh Stadt",
            "hobart": "Hobart",
            "hoi-an": "Hoi An",
            "hokkaido": "Hokkaido",
            "hong-kong": "Hongkong",
            "hua-hin": "Hua Hin",
            "hualien": "Hualien",
            "hue": "Farbton",
            "hyderabad": "Hyderabad",
            "iloilo": "Iloilo",
            "incheon": "Incheon",
            "inle-lake": "Inle See",
            "inner-mongolia": "Innere Mongolei",
            "innsbruck": "Innsbruck",
            "interlaken": "Interlaken",
            "inverness": "Inverness",
            "ipoh": "Ipoh",
            "istanbul": "Istanbul",
            "jaipur": "Jaipur",
            "jaisalmer": "Jaisalmer",
            "jakarta": "Jakarta",
            "jeju": "Jeju",
            "jerusalem": "Jerusalem",
            "jodhpur": "Jodhpur",
            "johor-bahru": "Johor Bahru",
            "kandy": "Kandy",
            "kaohsiung": "Kaohsiung",
            "kathmandu": "Kathmandu",
            "kazan": "Kazan",
            "kenting": "Kenting",
            "kiev": "Kiew",
            "kinmen": "Kinmen",
            "kobe": "Kobe",
            "koh-chang": "Koh chang",
            "koh-samui": "Koh Samui",
            "krabi": "Krabi",
            "krakow": "Krakau",
            "kuala-lumpur": "Kuala Lumpur",
            "kumamoto": "Kumamoto",
            "kyoto": "Kyoto",
            "kyushu": "Kyushu",
            "lake-district": "Seegebiet",
            "langkawi": "Langkawi",
            "lapland": "Lappland",
            "las-vegas": "Las Vegas",
            "launceston": "Launceston",
            "lausanne": "Lausanne",
            "leipzig": "Leipzig",
            "lisbon": "Lissabon",
            "liverpool": "Liverpool",
            "ljubljana": "Ljubljana",
            "loire-valley": "Loiretal",
            "lombok": "Lombok",
            "london": "London",
            "los-angeles": "Los Angeles",
            "luang-prabang": "Luang Prabang",
            "lucerne": "Luzerne",
            "lviv": "Lemberg",
            "lyon": "Lyon",
            "macao": "Macau",
            "macau": "",
            "madrid": "Madrid",
            "malaga": "Malaga",
            "manchester": "Manchester",
            "mandalay": "Mandalay",
            "manila": "Manila",
            "marrakech": "Marrakesch",
            "mauritius": "Mauritius",
            "medan": "Medan",
            "melaka": "Melaka",
            "melbourne": "Melbourne",
            "miami": "Miami",
            "milford-sound": "Milford Sound",
            "montreux": "Montreux",
            "moscow": "Moskau",
            "mumbai": "Mumbai",
            "munich": "München",
            "muscat": "Muscat",
            "nagano": "Nagano",
            "nagoya": "Nagoya",
            "naples": "Neapel",
            "nelson": "Nelson",
            "new-delhi": "Neu-Delhi",
            "new-york": "New York",
            "nha-trang": "Nha Trang",
            "niagara-falls": "Niagarafälle",
            "niigata": "Niigata",
            "normandy": "Normandie",
            "odessa": "Odessa",
            "okayama": "Okayama",
            "okinawa": "Okinawa",
            "orlando": "Orlando",
            "osaka": "Osaka",
            "oslo": "Oslo",
            "oxford": "Oxford",
            "palawan": "Palawan",
            "paris": "Paris",
            "pattaya": "Pattaya",
            "penang": "Penang",
            "penghu": "Penghu",
            "perth": "Perth",
            "philadelphia": "Philadelphia",
            "phnom-penh": "Phnom Penh",
            "phu-quoc": "Phu Quoc",
            "phuket": "Phuket",
            "pisa": "Pisa",
            "pokhara": "Pokhara",
            "port-lincoln": "Port Lincoln",
            "porto": "",
            "porto-district": "Porto Bezirk",
            "prague": "Prag",
            "provence": "Provence",
            "puglia": "Apulien",
            "pune": "Pune",
            "pushkar": "Pushkar",
            "queenstown": "Queenstown",
            "ras-al-khaimah": "Ras Al Khaimah",
            "reykjavik": "Reykjavik",
            "rhodes": "Rhodos",
            "rhône-alpes": "Rhône-Alpes",
            "rome": "Rom",
            "rotorua": "Rotorua",
            "rotterdam": "Rotterdam",
            "sabah": "Sabah",
            "saint-petersburg": "Sankt Petersburg",
            "saipan": "Saipan",
            "salzburg": "Salzburg",
            "san-diego": "San Diego",
            "san-francisco": "San Francisco",
            "santorini": "Santorini",
            "sanya": "Sanya",
            "sapa": "Sapa",
            "sarawak": "Sarawak",
            "seattle": "Seattle",
            "seoul": "Seoul",
            "seville": "Sevilla",
            "shanghai": "Shanghai",
            "sibiu": "Sibiu",
            "sicily": "Sizilien",
            "siem-reap": "Siem Reap",
            "sihanoukville": "Sihanoukville",
            "singapore": "Singapur",
            "split": "Teilt",
            "surabaya": "Surabaya",
            "suzhou": "Suzhou",
            "swedish-lapland": "Schwedisches Lappland",
            "sydney": "Sydney",
            "taichung": "Taichung",
            "tainan": "Tainan",
            "taipei": "Taipei",
            "taitung": "Taitung",
            "tarragona": "Tarragona",
            "taupo": "Taupo",
            "terengganu": "Terengganu",
            "thessaloniki": "Thessaloniki",
            "tokyo": "Tokyo",
            "toledo": "Toledo",
            "trincomalee": "Trincomalee",
            "turin": "Turin",
            "udaipur": "Udaipur",
            "uluru": "Uluru",
            "uttarakhand": "Uttarakhand",
            "varanasi": "Varanasi",
            "venice": "Venedig",
            "verona": "Verona",
            "vienna": "Wien",
            "vientiane": "Vientiane",
            "volendam": "Volendam",
            "washington-dc": "Washington, D.C",
            "wellington": "Wellington",
            "whitsundays": "Pfingstsonntage",
            "xiamen": "Xiamen",
            "xian": "Xian",
            "yangon": "Yangon",
            "yilan": "Yilan",
            "yogyakarta": "Yogyakarta",
            "york": "York",
            "yunnan": "Yunnan",
            "zagreb": "Zagreb",
            "zhangjiajie": "Zhangjiajie",
            "zurich": "Zürich"
        },
        "validation": {
            "accepted": "Das Attribut: muss akzeptiert werden.",
            "active_url": "Das Attribut: ist keine gültige URL.",
            "after": "Das Attribut: muss ein Datum nach: Datum sein.",
            "after_or_equal": "Das Attribut: muss ein Datum nach oder gleich dem Datum sein.",
            "alpha": "Das Attribut: darf nur Buchstaben enthalten.",
            "alpha_dash": "Das Attribut: darf nur Buchstaben, Zahlen und Bindestriche enthalten.",
            "alpha_num": "Das Attribut: darf nur Buchstaben und Zahlen enthalten.",
            "array": "Das Attribut: muss ein Array sein.",
            "before": "Das Attribut: muss ein Datum vor: Datum sein.",
            "before_or_equal": "Das Attribut: muss ein Datum vor oder gleich dem Datum sein.",
            "between": {
                "array": "Das Attribut: muss zwischen: min und: max Elementen haben.",
                "file": "Das Attribut: muss zwischen: min und: max Kilobyte liegen.",
                "numeric": "Das Attribut: muss zwischen: min und: max.",
                "string": "Das Attribut: muss zwischen: min und: max Zeichen liegen."
            },
            "boolean": "Das Attributfeld: muss wahr oder falsch sein.",
            "confirmed": "Die Bestätigung des Attributs stimmt nicht überein.",
            "custom": {
                "attribute-name": {
                    "rule-name": "benutzerdefinierte Nachricht"
                }
            },
            "date": "Das Attribut: ist kein gültiges Datum.",
            "date_format": "Das Attribut: entspricht nicht dem Format: format.",
            "different": "Das Attribut: und das andere müssen unterschiedlich sein.",
            "digits": "Das Attribut: muss Ziffern sein.",
            "digits_between": "Das Attribut: muss zwischen: min und: max Ziffern liegen.",
            "dimensions": "Das Attribut: hat ungültige Bilddimensionen.",
            "distinct": "Das Feld: attribute hat einen doppelten Wert.",
            "email": "Das Attribut: muss eine gültige E-Mail-Adresse sein.",
            "exists": "Das Attribut selected: ist ungültig.",
            "file": "Das Attribut: muss eine Datei sein.",
            "filled": "",
            "image": "",
            "in": "Das Attribut selected: ist ungültig.",
            "in_array": "",
            "integer": "",
            "ip": "",
            "ipv4": "",
            "ipv6": "",
            "json": "",
            "max": {
                "array": "",
                "file": "",
                "numeric": "",
                "string": ""
            },
            "mimes": "",
            "mimetypes": "",
            "min": {
                "array": "",
                "file": "",
                "numeric": "",
                "string": ""
            },
            "not_in": "Das Attribut selected: ist ungültig.",
            "numeric": "",
            "present": "",
            "regex": "",
            "required": "",
            "required_if": "",
            "required_unless": "",
            "required_with": "",
            "required_with_all": "",
            "required_without": "",
            "required_without_all": "",
            "same": "",
            "size": {
                "array": "",
                "file": "",
                "numeric": "",
                "string": ""
            },
            "string": "",
            "timezone": "",
            "unique": "",
            "uploaded": "",
            "url": ""
        },
        "reset-password": {
            "confirm-new-password": "Bestätige neues Passwort",
            "enter-new-password": "Neues Passwort eingeben",
            "please-enter-a-new-password": "Bitte geben Sie ein neues Passwort für Ihr Konto ein: email.",
            "submit": "einreichen",
            "success-content": "Erfolgreich! Bitte melden Sie sich in der HyperAir Mobile App mit dem neuen Passwort an.",
            "title": "Passwort zurücksetzen",
            "validation-display": "Das Passwort muss mindestens 6 Zeichen enthalten."
        },
        "notification": {
            "activation-e-minus-content": "15 Tage Countdown! Ihr Travel SIM-Willkommensgutschein ist in Kürze abgelaufen! Verpassen Sie nicht die Chance, den Gutschein für Ihre bevorstehende Reise zu nutzen!",
            "activation-e-minus-title": "",
            "activation-t-plus-content": "Denken Sie daran, unseren Willkommens-SIM-Karten-Coupon für Ihre bevorstehende Reise zu verwenden! Intelligenter reisen. Irgendwo.",
            "activation-t-plus-title": "",
            "ask-shop-to-quote-content": "Preisanfrage für Kauf: Betrag: Währung",
            "ask-shop-to-quote-content2": "Angebot anfordern für Verkauf: Betrag: Währung",
            "ask-shop-to-quote-title": "Neue Angebotsanfrage",
            "email-booking-details": "Buchungsdetails",
            "email-booking-id": "Buchungs-ID",
            "email-exchange-approved-content": "Umgetauschte Bestellung zum Kauf freigegeben: Betrag: Währung zum Kurs: Kurs",
            "email-exchange-approved-footer": "Vielen Dank, dass Sie HyperAir verwenden.",
            "email-exchange-approved-title": "Shop antwortete: \"Ihr Reisegeld steht zur Abholung bereit!\"",
            "email-exchange-completed-content": "Umgetauschte Bestellung zum Kauf abgeschlossen: Betrag: Währung zum Kurs: Kurs",
            "email-exchange-completed-footer": "Vielen Dank, dass Sie HyperAir verwenden.",
            "email-exchange-completed-title": "Ihr Reisegeldwechsel ist abgeschlossen!",
            "email-exchange-confirmed-content": "Umgetauschte Bestellung zum Kauf bestätigt: Betrag: Währung zum Kurs: Kurs",
            "email-exchange-confirmed-footer": "Vielen Dank, dass Sie HyperAir verwenden.",
            "email-exchange-confirmed-title": "Ihr Reisegeld steht zur Abholung bereit!",
            "email-footer-copy-right": "Alle Rechte vorbehalten.",
            "email-greetings": "Hallo!",
            "email-i-got": "ich habe",
            "email-i-paid": "ich habe bezahlt",
            "email-i-will-get": "ich werde bekommen",
            "email-i-will-pay": "ich werde bezahlen",
            "email-pickup-before": "Abholung vor",
            "email-product-confirmed-greeting": "Sehr geehrter Kunde,<br><br>Vielen Dank, dass Sie HyperAir verwenden. Ihr Gutschein ist fertig.",
            "email-product-confirmed-subject": "Bestellung wurde bestätigt",
            "email-product-confirmed-title": "Ihre Bestellung wird bestätigt",
            "email-product-purchased": {
                "shipping": {
                    "international": "Internationales Versenden",
                    "sf": "SF Express (Hong Kong Only)"
                }
            },
            "email-product-purchased-delievery-address": "Lieferadresse",
            "email-product-purchased-delivery-info": "Info zur Lieferung",
            "email-product-purchased-delivery-method": "Versandart",
            "email-product-purchased-discount": "Rabatt",
            "email-product-purchased-email": "Email",
            "email-product-purchased-greeting": "Sehr geehrter Kunde,<br><br> gute Wahl. Es wird einige Zeit dauern, um die Reservierung zu bestätigen. Aber keine Sorge, meistens können wir die Bestellung innerhalb von 12 Stunden bestätigen. Vielen Dank, dass Sie HyperAir verwenden!",
            "email-product-purchased-have-a-nice-trip": "Gute Reise!",
            "email-product-purchased-important-notice": "Allgemeine Geschäftsbedingungen gelten.",
            "email-product-purchased-important-notice-content": "Allgemeine Geschäftsbedingungen gelten.",
            "email-product-purchased-name": "Name",
            "email-product-purchased-order-date": "Auftragsdatum",
            "email-product-purchased-order-details": "Bestelldetails",
            "email-product-purchased-order-no": "Bestellnummer",
            "email-product-purchased-personal-info": "Persönliche Informationen",
            "email-product-purchased-receipient-name": "Empfängername",
            "email-product-purchased-receipient-phone-no": "Telefon-Nr.",
            "email-product-purchased-shipping-fee": "Versandkosten",
            "email-product-purchased-sub-total": "Zwischensumme",
            "email-product-purchased-subject": "Die Bestellung muss noch bestätigt werden",
            "email-product-purchased-title": "Ihre Bestellung steht noch aus",
            "email-product-purchased-total": "Gesamt",
            "email-product-simcapurchased-personal-info": "Persönliche Informationen",
            "email-product-simcard-delivery-title": "Ihre Bestellung SIM: Bestellnummer wurde erstellt und versendet am: Datum. Wenn Sie sich für SF Express entschieden haben, teilen wir Ihnen die Sendungsnummer später mit. Sie können es auch auf unserer mobilen App überprüfen.",
            "email-product-simcard-delivery-title-carbon-format": "j M Y",
            "email-product-simcard-delivery-update-greeting": "Sehr geehrter Kunde,<br><br>Vielen Dank, dass Sie HyperAir verwenden. Ihre SIM-Kartenbestellung ist unterwegs.",
            "email-product-simcard-delivery-update-title": "Ihre SIM-Kartenbestellung ist unterwegs",
            "email-product-simcard-delivery-update-tracking": "Verfolgungsdetails",
            "email-product-simcard-delivery-update-tracking-no": "Auftragsnummer, Frachtnummer, Sendungscode",
            "email-product-simcard-delivery-update-tracking-no-hkpost": "Auftragsnummer, Frachtnummer, Sendungscode: -",
            "email-product-simcard-delivery-update-tracking-no-sf": "Auftragsnummer, Frachtnummer, Sendungscode",
            "email-product-simcard-delivery-waiting-update-tracking-no-sf": "Warten auf das Update von SF Express",
            "email-product-simcard-delivery-with-tracking-num-title": "Ihre Bestellung SIM: Bestellnummer wird von SF Express mit Sendungsverfolgungsnummer verschickt: Sendungsverfolgungsnummer. Bitte achten Sie bei der Abholung auf Ihr Handy. Sie können den Versandstatus auch auf der SF Express-Website überprüfen. Vielen Dank, dass Sie die HyperAir-Dienste nutzen.",
            "email-product-simcard-esim-code-greeting": "Sehr geehrter Kunde,<br><br>Vielen Dank, dass Sie HyperAir verwenden. Hier ist Ihr eSIM-Aktivierungs-QR-Code.",
            "email-product-simcard-esim-code-important-notice-content": "<span style=\"font-size: 10px; line-height: 12px;\">Anleitung:<br />1. Wechseln Sie zu Einstellung<br />2. Tippen Sie auf \"Mobile Daten\"<br />3. Tippen Sie in Datenplänen auf \"Datenplan hinzufügen\"<br />4. Scannen Sie den QR-Code in der Kamera frame<br />Wenn Sie aufgefordert werden, einen Bestätigungscode für die Aktivierung des eSIM einzugeben, geben Sie die vom Netzbetreiber angegebene Nummer ein. Eine Frage haben? Bitte senden Sie eine E-Mail an hello@hyperair.com und wir werden uns umgehend bei Ihnen melden.</span>",
            "email-product-simcard-esim-code-title": "Hier ist Ihr eSIM-Aktivierungs-QR-Code",
            "email-product-simcard-esim-code-warning": "Bitte beachten Sie, dass das eSIM aktiviert wird, sobald der QR-Code gescannt wurde. Bitte scannen Sie es nur, wenn Sie den Dienst starten möchten.",
            "email-product-simcard-purchased-delievery-address": "Lieferadresse",
            "email-product-simcard-purchased-delivery-info": "Lieferinfo",
            "email-product-simcard-purchased-delivery-method": "Versandart",
            "email-product-simcard-purchased-discount": "Rabatt",
            "email-product-simcard-purchased-greeting": "Sehr geehrter Kunde,<br><br>Vielen Dank, dass Sie HyperAir verwenden. Wir bereiten jetzt die Lieferung Ihrer Reise-SIM vor.",
            "email-product-simcard-purchased-greeting-esim-only": "Sehr geehrter Kunde,<br><br>Vielen Dank, dass Sie HyperAir verwenden. Ihr eSIM ist fertig! Bitte finden Sie den beigefügten QR-Code und aktivieren Sie ihn gemäß der Anleitung.",
            "email-product-simcard-purchased-greeting-esim-with-sim": "Sehr geehrter Kunde,<br><br>Vielen Dank, dass Sie HyperAir verwenden. Wir bereiten jetzt die Lieferung Ihrer Reise-SIM vor. Finden Sie für Ihr eSIM den beigefügten QR-Code und aktivieren Sie ihn gemäß den Anweisungen.",
            "email-product-simcard-purchased-greeting-sim-only": "Sehr geehrter Kunde,<br><br>Vielen Dank, dass Sie HyperAir verwenden. Wir bereiten jetzt die Lieferung Ihrer Reise-SIM vor.",
            "email-product-simcard-purchased-have-a-nice-trip": "Gute Reise!",
            "email-product-simcard-purchased-important-notice": "Wichtiger Hinweis",
            "email-product-simcard-purchased-important-notice-content": "<span style=\"font-size: 10px; line-height: 12px;\">1. Bei der Hong Kong Post wird die Lieferung voraussichtlich innerhalb von 5 Werktagen erfolgen. Die Statusverfolgung ist für lokale Post nicht verfügbar. Kunden tragen die volle Verantwortung für den Verlust von Artikeln mithilfe von Hongkong. </span><br> <span style=\"font-size: 10px; line-height: 12px;\">2. Bitte aktivieren Sie die Reise-SIM-Karte vor Ablauf.</span><br> <span style=\"font-size: 10px; line-height: 12px;\">3. Alle gelieferten Produkte unterliegen den allgemeinen Geschäftsbedingungen.</span><br><br> <span style=\"font-size: 10px; line-height: 12px;\">Haben Sie eine Frage? Bitte senden Sie eine E-Mail an hello@hyperair.com und wir werden uns umgehend bei Ihnen melden.</span>",
            "email-product-simcard-purchased-important-notice-content-esim-only": "<span style=\"font-size: 10px; line-height: 12px;\">1. Bei der Hong Kong Post wird die Lieferung voraussichtlich innerhalb von 5 Werktagen erfolgen. Die Statusverfolgung ist für lokale Post nicht verfügbar. Kunden tragen die volle Verantwortung für den Verlust von Artikeln mithilfe von Hongkong. </span><br> <span style=\"font-size: 10px; line-height: 12px;\">2. Bitte aktivieren Sie die Reise-SIM-Karte vor Ablauf.</span><br> <span style=\"font-size: 10px; line-height: 12px;\">3. Alle gelieferten Produkte unterliegen den allgemeinen Geschäftsbedingungen.</span><br><br> <span style=\"font-size: 10px; line-height: 12px;\">Haben Sie eine Frage? Bitte senden Sie eine E-Mail an hello@hyperair.com und wir werden uns umgehend bei Ihnen melden.</span>",
            "email-product-simcard-purchased-important-notice-content-esim-with-sim": "<span style=\"font-size: 10px; line-height: 12px;\">1. Bei der Hong Kong Post wird die Lieferung voraussichtlich innerhalb von 5 Werktagen erfolgen. Die Statusverfolgung ist für lokale Post nicht verfügbar. Kunden tragen die volle Verantwortung für den Verlust von Artikeln mithilfe von Hongkong. </span><br> <span style=\"font-size: 10px; line-height: 12px;\">2. Bitte aktivieren Sie die Reise-SIM-Karte vor Ablauf.</span><br> <span style=\"font-size: 10px; line-height: 12px;\">3. Alle gelieferten Produkte unterliegen den allgemeinen Geschäftsbedingungen.</span><br><br> <span style=\"font-size: 10px; line-height: 12px;\">Haben Sie eine Frage? Bitte senden Sie eine E-Mail an hello@hyperair.com und wir werden uns umgehend bei Ihnen melden.</span>",
            "email-product-simcard-purchased-important-notice-content-sim-only": "<span style=\"font-size: 10px; line-height: 12px;\">1. Bei der Hong Kong Post wird die Lieferung voraussichtlich innerhalb von 5 Werktagen erfolgen. Die Statusverfolgung ist für lokale Post nicht verfügbar. Kunden tragen die volle Verantwortung für den Verlust von Artikeln mithilfe von Hongkong. </span><br> <span style=\"font-size: 10px; line-height: 12px;\">2. Bitte aktivieren Sie die Reise-SIM-Karte vor Ablauf.</span><br> <span style=\"font-size: 10px; line-height: 12px;\">3. Alle gelieferten Produkte unterliegen den allgemeinen Geschäftsbedingungen.</span><br><br> <span style=\"font-size: 10px; line-height: 12px;\">Haben Sie eine Frage? Bitte senden Sie eine E-Mail an hello@hyperair.com und wir werden uns umgehend bei Ihnen melden.</span>",
            "email-product-simcard-purchased-order-date": "Auftragsdatum",
            "email-product-simcard-purchased-order-details": "Bestelldetails",
            "email-product-simcard-purchased-order-no": "Bestellnummer",
            "email-product-simcard-purchased-personal-info": "Persönliche Informationen",
            "email-product-simcard-purchased-receipient-name": "Empfängername",
            "email-product-simcard-purchased-receipient-phone-no": "Telefonnummer des Empfängers",
            "email-product-simcard-purchased-shipping-fee": "Versandkosten",
            "email-product-simcard-purchased-sub-total": "Zwischensumme",
            "email-product-simcard-purchased-title": "Ihre Reise-SIM-Bestellung wurde bestätigt.",
            "email-product-simcard-purchased-title-esim-only": "Ihre Travel eSIM-Bestellung wurde bestätigt.",
            "email-product-simcard-purchased-title-esim-with-sim": "Ihre Reise-SIM-Bestellung wurde bestätigt.",
            "email-product-simcard-purchased-title-sim-only": "Ihre Reise-SIM-Bestellung wurde bestätigt.",
            "email-product-simcard-purchased-total": "Gesamt",
            "email-product-simcard-tracking-number-updated-greeting": "Sehr geehrter Kunde,<br><br>Nochmals vielen Dank, dass Sie HyperAir verwenden. Ihre Tracking-Nummer wird aktualisiert.",
            "email-product-simcard-tracking-number-updated-title": "Ihr Auftragsstatus wird aktualisiert",
            "email-product-simcard-tracking-number-updated-tracking-no-sf": "Auftragsnummer, Frachtnummer, Sendungscode",
            "email-product-type-confirmed-greeting": "",
            "email-product-type-confirmed-title": "",
            "email-product-type-purchased-greeting": "",
            "email-product-type-purchased-title": "",
            "email-rate": "Bewertung",
            "email-shop-name": "Laden Name",
            "email-verification-action": "Bestätige deine E-Mail",
            "email-verification-content": "Willkommen bei HyperAir! Um die Registrierung abzuschließen, müssen Sie nur bestätigen, dass wir Ihre E-Mail richtig verstanden haben.",
            "email-verification-title": "Bitte bestätige deine Email",
            "email-verified-content": "Ihre E-Mail-Adresse wurde bestätigt. Vielen Dank, dass Sie zu HyperAir gekommen sind.",
            "email-verified-title": "Email überprüft",
            "engagement-content": "Verwenden Sie welcome10",
            "engagement-title": "Verwenden Sie welcome10",
            "exchange-approved-content": "Kaufbestätigung: Betrag: Währung zum Kurs: Kurs.",
            "exchange-approved-content2": "Bestätigung für den Verkauf: Betrag: Währung zum Kurs: Kurs.",
            "exchange-approved-footer": "",
            "exchange-approved-title": "Shop antwortete: \"Ihr Reisegeld steht zur Abholung bereit!\"",
            "exchange-cancelled-content": "Ein Kunde hat die Bestellung für den Kauf abgebrochen: Betrag: Währung zum Kurs: Kurs.",
            "exchange-cancelled-content2": "Ein Kunde hat eine Bestellung zum Verkauf storniert: Betrag: Währung zum Kurs: Kurs.",
            "exchange-cancelled-title": "Umtauschauftrag storniert",
            "exchange-completed-content": "Abgeschlossen für den Kauf: Betrag: Währung zum Kurs: Kurs.",
            "exchange-completed-content2": "Abgeschlossen für den Verkauf: Betrag: Währung zum Kurs: Kurs.",
            "exchange-completed-footer": "",
            "exchange-completed-title": "Ihr Reisegeldwechsel ist abgeschlossen!",
            "exchange-confirmed-content": "Sie haben einen Kunden zum Kauf bestätigt: Betrag: Währung zum Kurs: Kurs.",
            "exchange-confirmed-content2": "Sie haben einen Kunden für den Verkauf bestätigt: Betrag: Währung zum Kurs: Kurs.",
            "exchange-confirmed-footer": "",
            "exchange-confirmed-title": "Neuer Umtauschauftrag eingegangen",
            "exchange-pending-content": "Überprüfen Sie die neue Bestellung für den Kauf: Betrag: Währung zum Kurs: Kurs.",
            "exchange-pending-content2": "Ausstehende Bestellung zum Verkauf: Betrag: Währung zum Kurs: Kurs.",
            "exchange-pending-title": "Genehmigung eines neuen Auftrags ausstehend",
            "exchange-rejected-content": "Bestellung kann nicht zum Kauf angenommen werden: Betrag: Währung zum Kurs: Kurs. Bitte buchen Sie erneut bei einem anderen Shop.",
            "exchange-rejected-content2": "Bestellung kann nicht zum Verkauf angenommen werden: Betrag: Währung zum Kurs: Kurs. Bitte buchen Sie erneut bei einem anderen Shop.",
            "exchange-rejected-title": "Hoppla! Entschuldigung, der Shop kann Ihre Bestellung nicht annehmen.",
            "footer-trouble-link": "Wenn Sie Probleme beim Klicken auf die Schaltfläche \": actionText\" haben, kopieren Sie die folgende URL und fügen Sie sie in Ihren Webbrowser ein: <a href=\"{actionUrl}\">: actionUrl</a>",
            "password-reset-action": "Passwort zurücksetzen",
            "password-reset-content": "Sie erhalten diese E-Mail, weil wir eine Anforderung zum Zurücksetzen des Passworts für Ihr Konto erhalten haben.",
            "password-reset-footer": "Wenn Sie kein Zurücksetzen des Kennworts angefordert haben, ist keine weitere Aktion erforderlich.",
            "password-reset-title": "Passwort zurücksetzen",
            "simcard-purchased-title": "",
            "sms-verification-content": "Ihr HyperAir-Code lautet: verificationCode"
        },
        "error": {
            "all-shops-are-closed": "Hoppla, alle Geschäfte sind momentan geschlossen. Bitte versuchen Sie es später noch einmal.",
            "cancel-booking-failed": "Diese Bestellung kann abgeschlossen, abgelaufen oder storniert werden. Bitte überprüfen Sie diese Bestellung unter [Meine Buchungen> Abgeschlossen] oder [Meine Buchungen> Nicht abgeschlossen].",
            "cancel-booking-failed-title": "Diese Bestellung kann nicht storniert werden",
            "invalid-api-app-version": "Aktualisieren Sie die APP jetzt, um die neuen Funktionen zu erhalten, und genießen Sie den Rabatt von 5% auf die Bestellung von Travel SIM mit dem Gutscheincode „GIVEME5“ !!",
            "invalid-old-password": "Vorhandenes Passwort ist ungültig.",
            "password-incorrect": "Falsches Passwort.",
            "phone-number-is-already-registered": "Diese Telefonnummer wurde bereits mit einer anderen E-Mail-Adresse registriert. Sie können sich mit der richtigen E-Mail-Adresse anmelden. Bitte senden Sie eine E-Mail an hello@hyperair.com, wenn Sie Unterstützung benötigen.",
            "this-email-is-registered": "Diese E-Mail-Adresse wird bereits von einem anderen Konto verwendet.",
            "this-phone-number-is-registered": "Diese Telefonnummer wurde bereits registriert. Bitte senden Sie eine E-Mail an hello@hyperair.com, wenn Sie Unterstützung benötigen."
        },
        "marketplace": {
            "homepage-product": "Beliebte Produkte",
            "homepage-recently-viewed": "zuletzt angesehen",
            "product-carousels": {
                "group1": "Sommererlebnis",
                "group2": "Bestbewertet"
            }
        }
    },
    "en-SG": {
        "currency": {
            "aed": "UAE Dirham",
            "afn": "Afghan Afghani",
            "all": "Albanian Lek",
            "amd": "Armenian Dram",
            "ang": "Netherlands Antillean Gulden",
            "aoa": "Angolan Kwanza",
            "ars": "Argentine Peso",
            "aud": "Australian Dollar",
            "awg": "Aruban Florin",
            "azn": "Azerbaijani Manat",
            "bam": "Bosnia and Herzegovina Marka",
            "bbd": "Barbadian Dollar",
            "bdt": "Bangladeshi Taka",
            "bgn": "Bulgarian Lev",
            "bhd": "Bahraini Dinar",
            "bif": "Burundi Franc",
            "bnd": "Brunei Dollar",
            "bob": "Bolivian Boliviano",
            "brl": "Brazilian Real",
            "bsd": "Bahamian Dollar",
            "btc": "Bitcoin",
            "btn": "Bhutanese Ngultrum",
            "bwp": "Botswana Pula",
            "byn": "New Belarusian Ruble",
            "bzd": "Belize Dollar",
            "cad": "Canadian Dollar",
            "cdf": "Congolese Franc",
            "chf": "Swiss Franc",
            "clp": "Chilean Peso",
            "cop": "Colombian Peso",
            "crc": "Costa Rican Colon",
            "cup": "Cuban Peso",
            "cve": "Cape Verdean Escudo",
            "czk": "Czech Koruna",
            "djf": "Djiboutian Franc",
            "dkk": "Danish Krone",
            "dop": "Dominican Peso",
            "dzd": "Algerian Dinar",
            "egp": "Egyptian Pound",
            "ern": "Eritrean Nakfa",
            "etb": "Ethiopian Birr",
            "eur": "Euro",
            "fjd": "Fijian Dollar",
            "fkp": "Falkland Islands Pound",
            "gbp": "Pound Sterling",
            "gel": "Georgian Lari",
            "ghs": "Ghanaian Cedi",
            "gip": "Gibraltar Pound",
            "gmd": "Gambian Dalasi",
            "gnf": "Guinean Franc",
            "gtq": "Guatemalan Quetzal",
            "gyd": "Guyanese Dollar",
            "hkd": "Hong Kong Dollar",
            "hnl": "Honduran Lempira",
            "hrk": "Croatian Kuna",
            "htg": "Haitian Gourde",
            "huf": "Hungarian Forint",
            "idr": "Indonesian Rupiah",
            "ils": "Israeli New Sheqel",
            "inr": "Indian Rupee",
            "iqd": "Iraqi Dinar",
            "irr": "Iranian Rial",
            "isk": "Icelandic Króna",
            "jmd": "Jamaican Dollar",
            "jod": "Jordanian Dinar",
            "jpy": "Japanese Yen",
            "kes": "Kenyan Shilling",
            "kgs": "Kyrgyzstani Som",
            "khr": "Cambodian Riel",
            "kmf": "Comorian Franc",
            "kpw": "North Korean Won",
            "krw": "South Korean Won",
            "kwd": "Kuwaiti Dinar",
            "kyd": "Cayman Islands Dollar",
            "kzt": "Kazakhstani Tenge",
            "lak": "Lao Kip",
            "lbp": "Lebanese Lira",
            "lkr": "Sri Lankan Rupee",
            "lrd": "Liberian Dollar",
            "lsl": "Lesotho Loti",
            "lvl": "Latvian Lats",
            "lyd": "Libyan Dinar",
            "mad": "Moroccan Dirham",
            "mdl": "Moldovan Leu",
            "mga": "Malagasy Ariary",
            "mkd": "Macedonian Denar",
            "mmk": "Myanma Kyat",
            "mnt": "Mongolian Tugrik",
            "mop": "Macanese Pataca",
            "mro": "Mauritanian Ouguiya",
            "mur": "Mauritian Rupee",
            "mvr": "Maldivian Rufiyaa",
            "mwk": "Malaysian Ringgit",
            "mxn": "Mexican Peso",
            "myr": "Malaysian Ringgit",
            "mzn": "Mozambican Metical",
            "nad": "Namibian Dollar",
            "ngn": "Nigerian Naira",
            "nio": "Nicaraguan Cordoba",
            "nok": "Norwegian Krone",
            "npr": "Nepalese Rupee",
            "nzd": "New Zealand Dollar",
            "omr": "Omani Rial",
            "pab": "Panamanian Balboa",
            "pen": "Peruvian Nuevo Sol",
            "pgk": "Papua New Guinean Kina",
            "php": "Philippine Peso",
            "pkr": "Pakistani Rupee",
            "pln": "Polish Zloty",
            "pyg": "Paraguayan Guarani",
            "qar": "Qatari Riyal",
            "rmb": "Renminbi",
            "ron": "Romanian Leu",
            "rsd": "Serbian Dinar",
            "rub": "Russian Ruble",
            "rwf": "Rwandan Franc",
            "sar": "Saudi Riyal",
            "sbd": "Solomon Islands Dollar",
            "scr": "Seychellois Rupee",
            "sdg": "Sudanese Pound",
            "sek": "Swedish Krona",
            "sgd": "Singapore Dollar",
            "shp": "Saint Helena Pound",
            "sll": "Sierra Leonean Leone",
            "sos": "Somali Shilling",
            "srd": "Surinamese Dollar",
            "std": "Sao Tome And Principe Dobra",
            "syp": "Syrian Pound",
            "szl": "Swazi Lilangeni",
            "thb": "Thai Baht",
            "tjs": "Tajikistani Somoni",
            "tmt": "Turkmenistan Manat",
            "tnd": "Tunisian Dinar",
            "top": "Paanga",
            "try": "Turkish New Lira",
            "ttd": "Trinidad and Tobago Dollar",
            "twd": "New Taiwan Dollar",
            "tzs": "Tanzanian Shilling",
            "uah": "Ukrainian Hryvnia",
            "ugx": "Ugandan Shilling",
            "usd": "US Dollar",
            "uyu": "Uruguayan Peso",
            "uzs": "Uzbekistani Som",
            "vef": "Venezuelan Bolivar",
            "vnd": "Vietnamese Dong",
            "vuv": "Vanuatu Vatu",
            "wst": "Samoan Tala",
            "xaf": "Central African CFA Franc",
            "xcd": "East Caribbean Dollar",
            "xdr": "Special Drawing Rights",
            "xof": "West African CFA Franc",
            "xpf": "CFP Franc",
            "yer": "Yemeni Rial",
            "zar": "South African Rand",
            "zmw": "Zambian Kwacha"
        },
        "shop-currency-rate": {
            "rate-last-updated-x-days-ago": "Rate updated {time} days ago",
            "rate-last-updated-x-hours-ago": "Rate updated {time} hours ago"
        },
        "hyperair": {
            "copyright-footer": "Copyright © 2018 HyperAir Incorporation Limited. All Rights Reserved.",
            "today": "Today"
        },
        "product-simcard": {
            "shipping-methods": {
                "hkpost": "Hong Kong Post (Free)",
                "international": "International Shipping",
                "sf": "SF Express (Hong Kong only. Courier fee payable on delivery. Free Shipping for orders over HK$399)"
            }
        },
        "country": {
            "afghanistan": "Afghanistan",
            "aland-islands": "Aland Islands",
            "albania": "Albania",
            "algeria": "Algeria",
            "andorra": "Andorra",
            "angola": "Angola",
            "anguilla": "Anguilla",
            "antigua-&-barbuda": "Antigua & Barbuda",
            "antigua-barbuda": "Antigua and Barbuda",
            "argentina": "Argentina",
            "armenia": "Armenia",
            "aruba": "Aruba",
            "australia": "Australia",
            "austria": "Austria",
            "azerbaijan": "Azerbaijan",
            "azores": "Azores",
            "bahamas": "Bahamas",
            "bahrain": "Bahrain",
            "bangladesh": "Bangladesh",
            "barbados": "Barbados",
            "belarus": "Belarus",
            "belgium": "Belgium",
            "belize": "Belize",
            "benin": "Benin",
            "bermuda": "Bermuda",
            "bhutan": "Bhutan",
            "bolivia": "Bolivia",
            "bonaire": "Bonaire",
            "bosnia-herzegovina": "Bosnia & Herzegovina",
            "botswana": "Botswana",
            "brazil": "Brazil",
            "british-virgin-islands": "British Virgin Islands",
            "brunei": "Brunei",
            "bulgaria": "Bulgaria",
            "burkina-faso": "Burkina Faso",
            "burundi": "Burundi",
            "cambodia": "Cambodia",
            "cameroon": "Cameroon",
            "canada": "Canada",
            "canary-islands": "Canary Islands",
            "cape-verde-islands": "Cape Verde Islands",
            "cayman-islands": "Cayman Islands",
            "central-african-republic": "Central African Republic",
            "chad": "Chad",
            "chile": "Chile",
            "china": "China",
            "colombia": "Colombia",
            "comoros": "Comoros",
            "congo": "Congo",
            "cook-islands": "Cook Islands",
            "costa-rica": "Costa Rica",
            "cote-d-ivoire": "Cote D Ivoire",
            "croatia": "Croatia",
            "cruise-ship": "Cruise Ship",
            "cuba": "Cuba",
            "curacao": "Curacao",
            "cyprus": "Cyprus",
            "cyprus---north": "Cyprus",
            "cyprus---south": "Cyprus",
            "czech-republic": "Czech Republic",
            "denmark": "Denmark",
            "djibouti": "Djibouti",
            "dominica": "Dominica",
            "dominican-republic": "Dominican Republic",
            "dubai": "Dubai",
            "easter-island": "Easter Island",
            "ecuador": "Ecuador",
            "egypt": "Egypt",
            "el-salvador": "El Salvador",
            "equatorial-guinea": "Equatorial Guinea",
            "eritrea": "Eritrea",
            "estonia": "Estonia",
            "ethiopia": "Ethiopia",
            "europe": "Europe",
            "falkland-islands": "Falkland Islands",
            "faroe-islands": "Faroe Islands",
            "fiji": "Fiji",
            "finland": "Finland",
            "france": "France",
            "french-guiana": "French Guiana",
            "french-polynesia": "French Polynesia",
            "french-west-indies": "French West Indies",
            "gabon": "Gabon",
            "gambia": "Gambia",
            "georgia": "Georgia",
            "germany": "Germany",
            "ghana": "Ghana",
            "gibraltar": "Gibraltar",
            "greece": "Greece",
            "greenland": "Greenland",
            "grenada": "Grenada",
            "guadeloupe": "Guadeloupe",
            "guam": "Guam",
            "guatemala": "Guatemala",
            "guernsey": "Guernsey",
            "guinea": "Guinea",
            "guinea---bissau": "Guinea Bissau",
            "guinea-bissau": "Guinea-Bissau",
            "guyana": "Guyana",
            "haiti": "Haiti",
            "honduras": "Honduras",
            "hong-kong": "Hong Kong",
            "hungary": "Hungary",
            "iceland": "Iceland",
            "india": "India",
            "indonesia": "Indonesia",
            "iran": "Iran",
            "iraq": "Iraq",
            "ireland": "Ireland",
            "isle-of-man": "Isle of Man",
            "israel": "Israel",
            "italy": "Italy",
            "jamaica": "Jamaica",
            "japan": "Japan",
            "jersey": "Jersey",
            "jordan": "Jordan",
            "kazakhstan": "Kazakhstan",
            "kenya": "Kenya",
            "kiribati": "Kiribati",
            "kosovo": "Kosovo",
            "kuwait": "Kuwait",
            "kyrgyz-republic": "Kyrgyz Republic",
            "kyrgyzstan": "Kyrgyzstan",
            "laos": "Laos",
            "latvia": "Latvia",
            "lebanon": "Lebanon",
            "lesotho": "Lesotho",
            "liberia": "Liberia",
            "libya": "Libya",
            "liechtenstein": "Liechtenstein",
            "lithuania": "Lithuania",
            "luxembourg": "Luxembourg",
            "macau": "Macau",
            "macedonia": "Macedonia",
            "madagascar": "Madagascar",
            "madeira": "Madeira",
            "malawi": "Malawi",
            "malaysia": "Malaysia",
            "maldives": "Maldives",
            "mali": "Mali",
            "malta": "Malta",
            "marshall-islands": "Marshall Islands",
            "martinique": "Martinique",
            "mauritania": "Mauritania",
            "mauritius": "Mauritius",
            "mayotte": "Mayotte",
            "mexico": "Mexico",
            "micronesia": "Micronesia",
            "moldova": "Moldova",
            "monaco": "Monaco",
            "mongolia": "Mongolia",
            "montenegro": "Montenegro",
            "montserrat": "Montserrat",
            "morocco": "Morocco",
            "mozambique": "Mozambique",
            "myanmar": "Myanmar",
            "namibia": "Namibia",
            "nauru": "Nauru",
            "nepal": "Nepal",
            "netherlands": "Netherlands",
            "netherlands-antilles": "Netherlands Antilles",
            "new-caledonia": "New Caledonia",
            "new-zealand": "New Zealand",
            "nicaragua": "Nicaragua",
            "niger": "Niger",
            "nigeria": "Nigeria",
            "niue": "Niue",
            "norfolk-islands": "Norfolk Islands",
            "north-korea": "North Korea",
            "northern-marianas": "Northern Marianas",
            "norway": "Norway",
            "oman": "Oman",
            "pakistan": "Pakistan",
            "palau": "Palau",
            "palestine": "Palestine",
            "panama": "Panama",
            "papua-new-guinea": "Papua New Guinea",
            "paraguay": "Paraguay",
            "peru": "Peru",
            "philippines": "Philippines",
            "poland": "Poland",
            "portugal": "Portugal",
            "puerto-rico": "Puerto Rico",
            "qatar": "Qatar",
            "reunion": "Reunion",
            "romania": "Romania",
            "russia": "Russia",
            "rwanda": "Rwanda",
            "saint-barthelemy": "Saint Barthelemy",
            "saint-martin": "Saint Martin",
            "saint-pierre-&-miquelon": "Saint Pierre & Miquelon",
            "samoa": "Samoa",
            "san-marino": "San Marino",
            "sao-tome-&-principe": "Sao Tome & Principe",
            "sao-tome-principe": "São Tomé and Príncipe",
            "satellite": "Satellite",
            "saudi-arabia": "Saudi Arabia",
            "senegal": "Senegal",
            "serbia": "Serbia",
            "seychelles": "Seychelles",
            "sierra-leone": "Sierra Leone",
            "singapore": "Singapore",
            "slovak-republic": "Slovak Republic",
            "slovakia": "Slovakia",
            "slovenia": "Slovenia",
            "solomon-islands": "Solomon Islands",
            "somalia": "Somalia",
            "south-africa": "South Africa",
            "south-korea": "South Korea",
            "spain": "Spain",
            "sri-lanka": "Sri Lanka",
            "st-helena": "Saint Helena",
            "st-kitts": "Saint Kitts",
            "st-kitts-&-nevis": "St Kitts & Nevis",
            "st-lucia": "St Lucia",
            "st-vincent": "St Vincent",
            "st.-helena": "St. Helena",
            "st.-kitts": "St. Kitts",
            "st.-lucia": "St. Lucia",
            "sudan": "Sudan",
            "suriname": "Suriname",
            "swaziland": "Swaziland",
            "sweden": "Sweden",
            "switzerland": "Switzerland",
            "syria": "Syria",
            "taiwan": "Taiwan",
            "tajikistan": "Tajikistan",
            "tanzania": "Tanzania",
            "thailand": "Thailand",
            "timor-l'este": "Timor L'Este",
            "togo": "Togo",
            "tonga": "Tonga",
            "trinidad-&-tobago": "Trinidad & Tobago",
            "trinidad-tobago": "Trinidad and Tobago",
            "tunisia": "Tunisia",
            "turkey": "Turkey",
            "turkmenistan": "Turkmenistan",
            "turks-&-caicos": "Turks & Caicos",
            "turks-&-caicos-islands": "Turks & Caicos Islands",
            "turks-caicos-islands": "Turks and Caicos Islands",
            "uganda": "Uganda",
            "ukraine": "Ukraine",
            "united-arab-emirates": "United Arab Emirates",
            "united-kingdom": "United Kingdom",
            "united-states": "United States",
            "united-states-minor-outlying-islands": "United States Minor Outlying Islands",
            "uruguay": "Uruguay",
            "uzbekistan": "Uzbekistan",
            "vanuatu": "Vanuatu",
            "vatican-city": "Vatican City",
            "venezuela": "Venezuela",
            "vietnam": "Vietnam",
            "virgin-islands": "Virgin Islands",
            "virgin-islands-(us)": "Virgin Islands (US)",
            "wallis-&-futuna": "Wallis & Futuna",
            "wallis-futuna": "Wallis and Futuna",
            "yemen": "Yemen",
            "zambia": "Zambia",
            "zimbabwe": "Zimbabwe"
        },
        "inspiration": {
            "published-date": "M Y",
            "published-duration": "{duration} days before",
            "published-duration-singular": "Yesterday",
            "published-duration-today": "Today"
        },
        "promotion-center": {
            "expires-at": "Expires on",
            "redeem": {
                "error": {
                    "already-redeemed": "You have already redeemed the coupon.",
                    "new-customer-only": "Offer is valid for new customer only.",
                    "not-found": "Invalid Promotion Code"
                }
            }
        },
        "auth": {
            "failed": "These credentials do not match our records.",
            "throttle": "Too many login attempts. Please try again in {seconds} seconds."
        },
        "web": {
            "activity": {
                "countdown-title": "",
                "more-button": "More tour and tickets",
                "section-subtitle": "Find the cheapest tour and tickets in Singapore",
                "section-title": "Compare Tour and Tickets in Singapore"
            },
            "checkout": {
                "use-promo-code": "Use Promotion Code"
            },
            "checkout-failed": {
                "checkout-failed": "Payment Failed, please try again later"
            },
            "checkout-success": {
                "checkout-success": "Payment Success",
                "continue-shopping-button": "Continue shopping",
                "done-button": "Done👌🏻",
                "download-now": "Download Now",
                "order-number": "Order Number",
                "register-email": "Your email",
                "register-password": "Set your password",
                "sim-product": "Successfully purchased <span class=\"bold\"> {sim} </span>. The confirmation email has been sent to {email}.",
                "slogan": "Open HyperAir app to enjoy the exclusive privileges! You can also have the real time order tracking in the App!",
                "slogan-password": "One more step! You can enjoy HK$10 Welcome SIM card coupon and real time order tracking in the App!",
                "trace-order": "",
                "trace-order-password": "",
                "welcome-offer": "One more step! You can enjoy HK$10 Welcome SIM card coupon and real time order tracking in the App!"
            },
            "country": {
                "all": "ALL",
                "contact-us-description": "如有任何疑問，歡迎發送電郵到<a href=\"mailto:corporate@hyperair.com\\>corporate@hyperair.com</a>查詢",
                "data": "Data Limit:",
                "day": "Day(s):",
                "day-day": "Day(s)",
                "esim": "eSIM",
                "esim-section-title": "Best eSIM for {country}",
                "num-of-review": "{num}-of-review ratings",
                "per-day": "day",
                "phone-call": "Phone Call",
                "plug-n-go": "",
                "plug-n-go-esim": "Instant buy and use",
                "plug-n-go-sim": "Plug and use",
                "section-title": "Best SIM card for {country}",
                "section-title copy": "Best SIM card for {country}",
                "sim": "SIM",
                "supplier": "Provider:"
            },
            "download-app-banner": {
                "download-now": "Download App Now",
                "hyperair": "HyperAir",
                "subtitle": "Download & register HyperAir App to enjoy HK$10 welcome offer!",
                "title": "Travel Smarter. Anywhere."
            },
            "email-subscription": {
                "cancel-button": "Let me think about it",
                "completed-subscribe": "Thank you for subscribing!",
                "confirm-button": "Get the best offer",
                "duplicate-email": "This email address has already subscribed",
                "invalid-email": "Invalid email address",
                "title-1": "Wanna be notified when Staycation drops to a record low?",
                "title-2": "Finds the best staycation and gourmet discounted package in the city"
            },
            "fanfare": {
                "cover-title": "SIM Card Offer",
                "datetime-format": "j M",
                "end-next-fanfare": "Upcoming SIM Card Offer:",
                "end-title": "Stay tuned to our App & social media for the next SIM Offers",
                "end-title2": "Stay Tuned to our APP & social media platforms for the next SIM Card Offer",
                "more-details-button": "More Details",
                "out-of-stock": "Sold Out",
                "popular-countries-subtitle": "Free Surface Mail, Speedy Delivery",
                "popular-countries-title": "Popular SIM Cards",
                "section-title": "SIM Cards at super discounted prices",
                "title": "Limited Time | Limited Cards",
                "x-inventory-left": "Last {inventory}"
            },
            "fanfare-breadcrumb": "SIM Card Offer",
            "filter-button": {
                "filter": "Filter"
            },
            "filter-container": {
                "apply": "",
                "category": "Category",
                "category-aquarium": "Aquarium",
                "category-class": "Class",
                "category-day-tour": "Day Tour",
                "category-discount": "Discount",
                "category-diving": "Diving",
                "category-food": "Food",
                "category-massage-beauty": "Massage and Beauty",
                "category-museum": "Museum",
                "category-musical": "Musical",
                "category-outlet": "Outlet",
                "category-photography": "Photography",
                "category-playground": "Playground",
                "category-railway": "Railway",
                "category-show": "Show",
                "category-ski": "Ski",
                "category-spa": "Hotspring",
                "category-theme-park": "Theme Park",
                "category-ticket": "Ticket",
                "category-transport": "Transport",
                "category-transport-ticket": "Transport Ticket",
                "category-vr": "VR",
                "category-water-park": "Water Park",
                "category-yoga": "Yoga",
                "category-zoo": "Zoo",
                "clear-all": "Reset",
                "facilities": "Services & facilities",
                "filter": "Filter",
                "food": "Food",
                "header": "Filter",
                "popular-search": "Popular Search🔥",
                "price": "Price",
                "provider": "Travel Site",
                "subcategory-buffet": "Buffet",
                "subcategory-car": "Car",
                "subcategory-facial": "Facial",
                "subcategory-food": "Food",
                "subcategory-half-day-tour": "Half Day Tour",
                "subcategory-massage": "Spa & Massage",
                "subcategory-meal-voucher": "Meal Voucher",
                "subcategory-one-day-tour": "One Day Tour",
                "subcategory-restaurant": "Restaurant",
                "subcategory-transport": "Transportation",
                "tag": "Tag"
            },
            "footer": {
                "about-hyperair-description": "HyperAir is an intelligent travel platform to your liking, offering the most suitable and value-for-money travel solution, so that you can travel smarter, anywhere.",
                "download-now": "Download Now",
                "email-subscription-button": "Subscribe",
                "email-subscription-placeholder": "Enter your email",
                "email-subscription-social-title": "or Follow our Facebook and Instagram",
                "email-subscription-title": "Subscribe to get the latest staycation discount",
                "travel-license": "Travel Agent Licence Number："
            },
            "fx-booking": {
                "back-button": "更改訂單",
                "confirm-booking": "核對資料",
                "confirm-button": "確認訂單",
                "contact-shop": "如果您無法準時到達，請致電兌換店或取消訂單。",
                "get-money-before": "請於以下時間前提取。"
            },
            "home": {
                "cover-button": "Experience Now",
                "cover-subtitle": "Open yourself to a new world of HyperAir",
                "cover-title": "Explore what's fun.",
                "grid": {
                    "1": {
                        "subtitle": "Latest Inspiration",
                        "title": "Cat Residents in Turkish Church"
                    },
                    "2": {
                        "subtitle": "Latest Inspiration",
                        "title": "Tokyo Olympics 2020 1 Year To Go"
                    },
                    "3": {
                        "subtitle": "Hot Picks",
                        "title": "Online Best Price Guarantee"
                    },
                    "4": {
                        "subtitle": "Limited Time Offer",
                        "title": "SIM Card Fanfares"
                    },
                    "5": {
                        "subtitle": "Popular Destination",
                        "title": "Sneak Peek of Disneyland Galaxy's Edge"
                    }
                },
                "home-example": {
                    "column-subtitle-1": "7-day Japan trip for 2 people:",
                    "column-subtitle-2": "Price Comparison",
                    "column-title-1": "Maximize your saving in one trip",
                    "column-title-2": "Compare various online travel agencies",
                    "hotel": "Hotel Rewards",
                    "hotel-package-1": "Hotel Nikko Osaka x6 nights",
                    "insurance": "Travel Insurance",
                    "insurance-package-1": "7-Day Travel Insurance x2",
                    "money": "Travel Moeny",
                    "money-package-1": "Exchange JPD ¥ 410,000",
                    "save": "Save",
                    "sim": "Travel SIM",
                    "sim-package-1": "Japan 7-Day DoCoMo SIM x2",
                    "slogan": "Compare before booking, save money for your next trip!",
                    "total-saving": "Total Savings $ 1,443",
                    "travel-experience": "Experience",
                    "travel-experience-package-1": "JR Pass for Whole Japan x2",
                    "travel-experience-package-2": "Universal Studios eTicket x2"
                },
                "media-header-title": "Press",
                "more": "More Travel SIM",
                "partners-title": "Partnership",
                "photo-banner-button": "Learn more",
                "photo-banner-title": "Exchange travel money smarter",
                "services-header-description": "",
                "services-header-title": "One-stop Travel Services",
                "services-icon-subtitle-1": "Help you to get travel money smarter!",
                "services-icon-subtitle-2": "Offer you the best SIM cards with free delivery!",
                "services-icon-subtitle-3": "Allow you to explore the world with tailored solution!",
                "services-icon-title-1": "Travel Money",
                "services-icon-title-2": "Travel SIM",
                "services-icon-title-3": "Tours and Tickets",
                "statistic": {
                    "num-of-city": "Saved by Customers",
                    "num-of-comparison": "Experience and Tours",
                    "num-of-experience": "Countries and Cities",
                    "num-of-saving": "Comparisons"
                },
                "testimonial-1-content": "呢個app很好用，方便比較滙率，唔駛周圍去揾資料。很欣賞程式員佢地既用心製作，佢地都很積極用心為我解決使用時的困難。推薦使用！",
                "testimonial-1-subtitle": "Android User",
                "testimonial-1-user": "Christine Lam",
                "testimonial-2-content": "好方便，訂SIM卡好快就送到，唔洗特登出街買SIM卡，價錢都好平吓。網絡收得幾好，上次去日本喺市區同近郊玩都好流暢！下次會再買！",
                "testimonial-2-subtitle": "iOS User",
                "testimonial-2-user": "Angel",
                "testimonial-header-description": "",
                "testimonial-header-title": "Customer Testimonials",
                "travel-activities": {
                    "home-slogan": "Compare and find your best travel experience from different websites"
                },
                "travel-country-header-description": "Clear Classification, Easy to Pick",
                "travel-country-header-title": "Travel SIM covers 200+ countries",
                "travel-info-header-description": "Bring you the red-hot travel inspiration",
                "travel-info-header-title": "Travel Inspiration",
                "travel-marketplace-header-description": "",
                "travel-marketplace-header-title": "",
                "travel-sim-header-description": "Best SIM card deals with free shipping",
                "travel-sim-header-title": "Popular Travel SIM"
            },
            "hotel": {
                "cover-subtitle": "Enjoy 5% exclusive Trip.com hotel booking offer",
                "cover-title": "Hotel Rewards",
                "discount-detail": "Apply promo code \"HYPERAIR5\" to enjoy 5% hotel booking offer",
                "discount-title": "HYPERAIR5",
                "highlight-subtitle1": "Discover hotels around the world for a unique stay.",
                "highlight-subtitle2": "Get the best deals and save your money for the next travel.",
                "highlight-subtitle3": "Check the hotel rates anytime anywhere.",
                "highlight-title1": "Global Coverage",
                "highlight-title2": "Exclusive Privileges",
                "highlight-title3": "One-click Booking"
            },
            "hypermiles": {
                "activity": "Activity",
                "balance": "Outstanding Balance",
                "benefit": "Your Privileges",
                "cumulative-purchase": "Accumulated Spending：HK$ {amount}",
                "diamond-black": "Diamond Black",
                "expire": "Expired HyperMiles ({date})",
                "expire-reminder-1": "HyperMiles is valid for one year from the shopping month",
                "expire-reminder-2": "Remember to use HyperMiles before expiry!",
                "hypermiles-total": "HyperMiles",
                "member": "Member",
                "member-tier": "You have become HyperAir {member_tier} member",
                "membership-details": "Membership Tier",
                "next-purchase": "save HK${amount} in your next purchase",
                "order-num": "Order No: {order_num}",
                "permanent-membership": "Permanent Membership",
                "popup-title": "HyperMiles Reward Scheme",
                "precious-platinum": "Precious Platinum",
                "product_purchase": "HyperMiles from gadgets purchase ({date})",
                "record": "HyperMiles Record",
                "royal-blue": "Royal Blue",
                "simcard_purchase": "HyperMiles from SIM purchase ({date})",
                "tier": "",
                "title": "HyperMiles. Explore the World, Enjoy the rebate!",
                "u-have": "Your have",
                "usage": "Redeemed HyperMiles",
                "what-is-hypermiles": "What is HyperMiles",
                "what-is-hypermiles-slogan1": "Spend more. Earn more!",
                "what-is-hypermiles-slogan2": "Every 100 HyperMiles can be used as HK$1 at checkout, no minimum spending limit",
                "what-is-hypermiles-slogan3": "Spend more at HyperAir to enjoy more privileges"
            },
            "hypermiles-disclaimer": "terms and conditions apply",
            "hypermiles-discount-diamond-black": "Spend every HK$1 to enjoy 1 HyperMiles",
            "hypermiles-discount-precious-platinum": "Spend every HK$1.5 to enjoy 1 HyperMiles",
            "hypermiles-discount-royal-blue": "Spend every HK$2 to enjoy 1 HyperMiles",
            "hypermiles-special-diamond-black": "Exclusive pre-sale offer",
            "hypermiles-spend-diamond-black": "Cumulative spending of HK$3,000",
            "hypermiles-spend-precious-platinum": "Cumulative spending of HK$1,500",
            "hypermiles-spend-royal-blue": "Basic Member",
            "login": {
                "email": "Email",
                "existing-user": "Existing User",
                "forgot-password": "Forgot Password",
                "forgot-password-please-fill-in-email": "Enter your email and we'll send you a link to get back into your account.",
                "login": "Login",
                "login-with-facebook": "Continue with Facebook",
                "login-with-google": "Continue with Google",
                "new-user": "New User",
                "or": "Or",
                "password": "Password",
                "phone-input-placeholder": "Enter your Phone Number",
                "phone-input-title": "Input Your Phone Number.",
                "phone-verify": "Phone Verification",
                "resend-verification-code": "Resend After 30s",
                "reset-password": "Reset Password",
                "title": "Login",
                "verification-code-input-title": "Input Your Verification Code."
            },
            "logo-loader": {
                "slogan": "We're almost there"
            },
            "my-order": {
                "amount": "Amount",
                "esim-qrcode": "eSIM Code",
                "fx-status-cancelled": "Cancelled",
                "fx-status-confirmed": "Confirmed",
                "order-date": "Order Date",
                "order-details": "Order Details",
                "order-num": "Order Number",
                "status-confirmed": "Shipped",
                "status-pending-confirmation": "Ready To Ship",
                "status-ready-to-ship": "Ready To Ship",
                "status-shipped": "Shipped"
            },
            "my-order-details": {
                "delivery-info": "Delivery Info",
                "discount": "Discount",
                "recipient-address": "Address",
                "recipient-email": "Email",
                "recipient-name": "Recipient Name",
                "recipient-tel": "Recipient Tel",
                "shipping-method": "Shipping Method",
                "status": "Status",
                "total": "Total",
                "valid-date": "Valid Date"
            },
            "nav": {
                "about-us": "About Us",
                "car": "Cars",
                "company": "Company",
                "company-address": "Entrepreneurship Centre, Level 3, Cyberport 3, Hong Kong",
                "contact-us": "Contact Us",
                "contact-us-description": "Please email to <a href=\"mailto:hello@hyperair.com\">hello@hyperair.com</a> for any enquiries.",
                "disclaimer": "Disclaimer",
                "download-app": "Download App",
                "flight": "Flights",
                "foodie": "Foodie",
                "home": "Home",
                "hotel": "Hotel",
                "jobs": "Recruitment",
                "logout": "Logout",
                "media-coverage": "Press",
                "monthly-rental-hotel": "Monthly Rental Hotel",
                "privacy-policy": "Privacy Policy",
                "promo-banner-text": "HyperAir 客戶專享 5% Trip.com 獨家酒店折扣",
                "quarantine-hotel": "Long Stay Hotel",
                "refund-policy": "Refund Policy",
                "spa-and-beauty": "Spa and Beauty",
                "staycation": "Staycation",
                "tag-line": "Compare Travel Sites & Save Money",
                "terms-of-service": "Terms of Service",
                "travel-activity": "Travel Activity",
                "travel-affiliate-codes": "Coupons",
                "travel-affiliate-codes-md": "Coupons",
                "travel-blog": "Blog",
                "travel-experience-d": "Tours and Tickets",
                "travel-experience-md": "Tours and Tickets",
                "travel-insurance": "Travel Insurance",
                "travel-insurance-md": "Insurance",
                "travel-marketplace": "Travel Gadgets",
                "travel-marketplace-md": "Travel Gadgets",
                "travel-money": "Travel Money",
                "travel-money-md": "Money",
                "travel-sim": "Travel SIM",
                "travel-sim-md": "SIM"
            },
            "photo-banner": {
                "banner-button": ""
            },
            "product-card": {
                "num-of-review": "{num}-of-review ratings"
            },
            "redirection-gate": {
                "columns-1-description": "Compare the best travel experience from different websites",
                "columns-1-title": "Travel Activity Comparison",
                "columns-2-description": "Best SIM card deals with free shipping!",
                "columns-2-title": "Travel SIM",
                "columns-3-description": "Compare and book the best FX rate in town",
                "columns-3-title": "Travel Money",
                "promo-code": "Code",
                "remember-to-fill-promo-code": "Remember to apply the above promo code before checkout",
                "title": "We are taking you to {domain}",
                "trouble-link": "If the browser does not redirect you in 10 seconds, please click this <a href=\"{link}\">link</a>."
            },
            "register": {
                "guest-checkout": "Guest Checkout",
                "title": "Register"
            },
            "seo": {
                "best-price-guarantee-title": "Best Price Guarantee",
                "country-description": "{country} Travel SIM - Best Price Guarantee with Free Shipping",
                "country-keywords": "SIM卡,上網卡,電話卡,數據卡,DataSIM,旅遊DataSIM,數據咭,4G上網卡,上網卡,4G上網卡,日本4G上網卡,日本上網卡,東京4G上網卡,東京上網卡,大阪4G上網卡,大阪上網卡,泰國4G上網卡,泰國上網卡,曼谷4G上網卡,布吉上網卡,芭提雅4G上網卡,台灣4G上網卡,台灣上網卡,台北4G上網卡,高雄上網卡,台中4G上網卡,台中上網卡,韓國4G上網卡,韓國上網卡,首爾4G上網卡,首爾上網卡,中國4G上網卡,中國上網卡,深圳4G上網卡,深圳上網卡,澳門4G上網卡,澳門上網卡, Docomo, Softbank",
                "country-title": "{country} Travel SIM - Best Price Guarantee with Free Shipping",
                "home-description": "HyperAir is an intelligent travel platform to your liking, offering the most suitable and value-for-money travel solution, so that you can travel smarter, anywhere.",
                "home-keywords": "sim卡,上網卡,電話卡,數據卡,DataSIM,旅遊DataSIM,數據咭,4G上網卡,上網卡,4G上網卡,SIM卡,Travel SIM,旅遊SIM卡,唱錢神器,唱X神器,唱錢X器,唱錢,唱錢app,兌換,找換,兌換店,找換店,銀行,金融,外匯,外滙,匯率,滙率,匯款,外幣,貨幣,旅行,旅遊,行程,酒店,機票,比較,格價,特價,預訂,交易,旅遊保險,日本,泰國,韓國,台灣,日圓,日元,台幣,泰銖,HyperAir,HyperAir FX,HyperAir Travel,Travel,Travel Money,Foreign Currency,Foreign Exchange,百年,堅成,發達鳥,飛鳥,richbird,crazy bird,berlin exchange",
                "home-title": "‎HyperAir - Best Travel Comparison & Search Engine | Experience, Hotel, SIM, Exchange, Travel Insurance",
                "hotel-description": "Get extra hotel booking offers via HyperAir.com",
                "hotel-keywords": "hotel, hotels, discount, reservations, Asia, Europe, America, Bangkok, Singapore, Hong Kong, Phuket, Thailand, Malaysia, Bali, London, Paris, loyalty program, acommodation, accomodation, acomodation, accommodation, vacation rentals",
                "hotel-title": "Hotel Offers",
                "money-exchange-description": "Check {shop_name}'s latest FX rate and book your travel money online. You can lock in FX rate and reserve foreign currency.",
                "money-exchange-keywords": "{shop_name}, 唱錢神器, 唱X神器, 唱錢X器, 唱錢, 兌換, 找換, 兌換店, 找換店, 銀行, 金融, 外匯, 外滙, 匯率, 滙率, 匯款, 外幣, 貨幣, 旅行, 旅遊, 行程, 酒店, 機票, 比較, 格價, 特價, 預訂, 交易, 旅遊保險, 日本, 泰國, 韓國, 台灣, 日圓, 日元, 台幣, 泰銖, HyperAir, HyperAir FX, HyperAir Travel, Travel, Travel Money, Foreign Currency, Foreign Exchange, 百年, 堅成, 發達鳥, 飛鳥, richbird, crazy bird, berlin exchange",
                "money-exchange-title": "{shop_name}'s latest FX rate with instant booking | Lock in FX rate and reserve your travel money instantly",
                "privacy-policy-title": "Privacy Policy",
                "refund-policy-title": "Refund & Return Policy",
                "sim-fanfares-description": "HyperAir has launched the first SIM Card Fanfares in Hong Kong. You can purchase SIM cards for your trip with discount up to 50% off. Limited Time, Limited Offer !",
                "sim-fanfares-keywords": "fanfares,simcard, sim card, SIM卡,上網卡,電話卡,數據卡,DataSIM,旅遊DataSIM,數據咭,4G上網卡,上網卡,4G上網卡,日本4G上網卡,日本上網卡,東京4G上網卡,東京上網卡,大阪4G上網卡,大阪上網卡,泰國4G上網卡,泰國上網卡,曼谷4G上網卡,布吉上網卡,芭提雅4G上網卡,台灣4G上網卡,台灣上網卡,台北4G上網卡,高雄上網卡,台中4G上網卡,台中上網卡,韓國4G上網卡,韓國上網卡,首爾4G上網卡,首爾上網卡,中國4G上網卡,中國上網卡,深圳4G上網卡,深圳上網卡,澳門4G上網卡,澳門上網卡, Docomo, Softbank",
                "sim-fanfares-title": "SIM Card Fanfares - Limited Time, Limited Cards",
                "term-of-service-title": "Terms of Service",
                "travel-activity-search-results-description": "Compare prices and find an amazing deal for {activity}. Save more on travel with HyperAir now!",
                "travel-activity-search-results-keywords": "{activity}, travel, local experience, local activity, ticket, activities, day tours, tourist attractions",
                "travel-activity-search-results-title": "HyperAir - Search Result of {q} in {city}",
                "travel-affiliate-codes-description": "HyperAir continuously updates the latest discount codes / promotion codes for booking hotel discounts, air ticket discounts, activity discounts, travel insurance discounts, SIM card discounts and credit card discounts.",
                "travel-affiliate-codes-keywords": "Discount Code, Electronic Coupon, Discount Code, Promotion Code, Promo Code, Discount Code, Hotel, Air Ticket, Offer, Credit Card Offer, Travel Offer",
                "travel-affiliate-codes-title": "2023 Latest Travel Discount Codes (Daily Updates) | Discount booking for hotels, flights, activities, travel insurance, Data SIM",
                "travel-insurance-description": "Search for the best Travel Insurance plans? Which plans cover mobile phones? Compare insurance plans from companies like AIG, MSIG and Starr, and buy online with extra discount !",
                "travel-insurance-keywords": "AIG, MSIG, Starr, AIG Promocode, MSIG Promocode, Starr Promocode, Travel Insurance, travel insurance online, compare Travel Insurance, cheap travel insurance, travel insurance hong kong, single trip, annual plan",
                "travel-insurance-title": "Best Travel Insurance Rates & Comparisons in Hong Kong 2023",
                "travel-marketplace-checkout-payme-title": "Pay with PayMe",
                "travel-marketplace-checkout-success-keywords": "創意, 產品, 流行, 電器, 生活, 精品, 智能家居, 設計, 高品質, 設計概念, 創意科技, 生活用品, 戶外休閒, 廚房, 餐桌, 個人護理, 防疫抗疫, 健康, 遊戲, 兒童玩樂, 健身, 家居健身, gym, home gym, smart home, style home",
                "travel-marketplace-checkout-success-title": "Payment Success",
                "travel-marketplace-description": "A collection of coolest gadgets that you'll like",
                "travel-marketplace-keywords": "創意, 產品, 流行, 電器, 生活, 精品, 智能家居, 設計, 高品質, 設計概念, 創意科技, 生活用品, 戶外休閒, 廚房, 餐桌, 個人護理, 防疫抗疫, 健康, 遊戲, 兒童玩樂, 健身, 家居健身, gym, home gym, smart home, style home",
                "travel-marketplace-product-checkout-title": "{product}",
                "travel-marketplace-product-title": "{product}",
                "travel-marketplace-title": "Travel Gadgets",
                "travel-money-description": "HyperAir provides you a brand new way to get travel money. Now you can book the exchange online with the best in town exchange rate!",
                "travel-money-keywords": "sim卡,上網卡,電話卡,數據卡,DataSIM,旅遊DataSIM,數據咭,4G上網卡,上網卡,4G上網卡,唱錢神器,唱X神器,唱錢X器,唱錢,兌換,找換,兌換店,找換店,銀行,金融,外匯,外滙,匯率,滙率,匯款,外幣,貨幣,旅行,旅遊,行程,酒店,機票,比較,格價,特價,預訂,交易,旅遊保險,日本,泰國,韓國,台灣,日圓,日元,台幣,泰銖,HyperAir,HyperAir FX,HyperAir Travel,Travel,Travel Money,Foreign Currency,Foreign Exchange,百年,堅成,發達鳥,飛鳥,richbird,crazy bird,berlin exchange",
                "travel-money-title": "HyperAir - Exchange Travel Money Smarter.",
                "travel-product-checkout-keywords": "創意, 產品, 流行, 電器, 生活, 精品, 智能家居, 設計, 高品質, 設計概念, 創意科技, 生活用品, 戶外休閒, 廚房, 餐桌, 個人護理, 防疫抗疫, 健康, 遊戲, 兒童玩樂, 健身, 家居健身, gym, home gym, smart home, style home",
                "travel-product-keywords": "創意, 產品, 流行, 電器, 生活, 精品, 智能家居, 設計, 高品質, 設計概念, 創意科技, 生活用品, 戶外休閒, 廚房, 餐桌, 個人護理, 防疫抗疫, 健康, 遊戲, 兒童玩樂, 健身, 家居健身, gym, home gym, smart home, style home",
                "travel-sim-checkout-description": "{country} Travel SIM - High-quality SIM card with free shipping to your door!",
                "travel-sim-checkout-keywords": "上網卡,電話卡,數據卡,DataSIM,旅遊DataSIM,數據咭,4G上網卡,上網卡,4G上網卡,日本4G上網卡,日本上網卡,東京4G上網卡,東京上網卡,大阪4G上網卡,大阪上網卡,泰國4G上網卡,泰國上網卡,曼谷4G上網卡,布吉上網卡,芭提雅4G上網卡,台灣4G上網卡,台灣上網卡,台北4G上網卡,高雄上網卡,台中4G上網卡,台中上網卡,韓國4G上網卡,韓國上網卡,首爾4G上網卡,首爾上網卡,中國4G上網卡,中國上網卡,深圳4G上網卡,深圳上網卡,澳門4G上網卡,澳門上網卡, Docomo, Softbank",
                "travel-sim-checkout-success-description": "{country} Travel SIM - High-quality SIM card with free shipping to your door!",
                "travel-sim-checkout-success-keywords": "上網卡,電話卡,數據卡,DataSIM,旅遊DataSIM,數據咭,4G上網卡,上網卡,4G上網卡,日本4G上網卡,日本上網卡,東京4G上網卡,東京上網卡,大阪4G上網卡,大阪上網卡,泰國4G上網卡,泰國上網卡,曼谷4G上網卡,布吉上網卡,芭提雅4G上網卡,台灣4G上網卡,台灣上網卡,台北4G上網卡,高雄上網卡,台中4G上網卡,台中上網卡,韓國4G上網卡,韓國上網卡,首爾4G上網卡,首爾上網卡,中國4G上網卡,中國上網卡,深圳4G上網卡,深圳上網卡,澳門4G上網卡,澳門上網卡, Docomo, Softbank",
                "travel-sim-checkout-success-title": "Payment Success - Travel SIM",
                "travel-sim-checkout-title": "Place Order - Travel SIM",
                "travel-sim-keywords": "sim卡,上網卡,電話卡,數據卡,DataSIM,旅遊DataSIM,數據咭,4G上網卡,上網卡,日本4G上網卡,日本上網卡,日本sim卡,東京4G上網卡,東京上網卡,大阪4G上網卡,大阪上網卡,泰國4G上網卡,泰國上網卡,泰國sim卡,曼谷4G上網卡,布吉上網卡,芭提雅4G上網卡,台灣4G上網卡,台灣上網卡,台灣sim卡,台北4G上網卡,高雄上網卡,台中4G上網卡,台中上網卡,韓國sim卡,韓國4G上網卡,韓國上網卡,首爾4G上網卡,首爾上網卡,中國4G上網卡,中國上網卡,中國sim卡,中國內地數據卡,深圳4G上網卡,深圳上網卡,澳門4G上網卡,澳門上網卡, 歐洲4G上網卡,歐洲上網卡,歐洲sim卡,英國4G上網卡,英國上網卡,英國sim卡,法國4G上網卡,法國上網卡,法國sim卡, 恴大利4G上網卡,意大利上網卡,意大利sim卡,巴黎4G上網卡,巴黎上網卡,巴黎sim卡,瑞士4G上網卡,瑞士上網卡,瑞士sim卡,Docomo, Softbank, 和記, 聯通, 3hk, 3uk, birdie, 自由鳥, airsim,sim2fly,AIS,ais sim2fly,SK Telecom,TrueMove,dtac,t mobile 全球上網卡,vietnamobile",
                "travel-sim-title": "【{country} SIM Card】{sim_name} - Best Price Guarantee with Free Shipping",
                "travel-sims-description": "Global Travel SIM Search Engine with high-quality SIM card and free shipping to your door!",
                "travel-sims-keywords": "sim卡,上網卡,電話,數據卡,DataSIM,旅遊DataSIM,數據咭,4G上網卡,4Gsim卡,日本4G上網卡,日本上網卡,日本sim卡,東京4G上網卡,東京上網卡,大阪4G上網卡,大阪上網卡,泰國4G上網卡,泰國上網卡,泰國sim卡,曼谷4G上網卡,布吉上網卡,芭提雅4G上網卡,台灣4G上網卡,台灣上網卡,台灣sim卡,台北4G上網卡,高雄上網卡,台中4G上網卡,台中上網卡,韓國sim卡,韓國4G上網卡,韓國上網卡,首爾4G上網卡,首爾上網卡,中國4G上網卡,中國上網卡,中國sim卡,中國內地數據卡,深圳4G上網卡,深圳上網卡,澳門4G上網卡,澳門上網卡,澳門sim卡,歐洲sim卡,Docomo,Softbank,sim2fly,AIS,ais sim2fly,SK Telecom,TrueMove,dtac,t mobile 全球上網卡,vietnamobile",
                "travel-sims-title": "Travel SIM - Best Price Guarantee with Free Shipping"
            },
            "shop-confirmation": {
                "app-download": "立即下載，推送通知",
                "app-download-subtitle": "下載 HyperAir 接收確認訂單的通知。",
                "instruction": "你的預訂已發送到找換店。一旦確認，我們會透過電郵或通知，將 QR CODE 將收到電郵通知，確認訂單將發送至 {email} 。",
                "my-order": "我的訂單",
                "pending-confirm": "等待兌換店確認"
            },
            "staycation": {
                "activity-countdown-button": "Find the cheapest price",
                "all-hotels": {
                    "sorting": {
                        "recommended": "Recommended"
                    }
                },
                "all-hotels-all-button": "All",
                "all-hotels-hotel-name": "Hotel Name",
                "all-hotels-last-updated": "Last Updated",
                "all-hotels-less-button": "Less",
                "all-hotels-more-button": "More",
                "all-hotels-no-result": "Sorry, we couldn't find any results",
                "all-hotels-title": "Search All Staycation Deals in Singapore",
                "compare-packages": "Compare all packages of this hotel",
                "countdown-button": "More Details",
                "countdown-title": "The Hottest in Singapore🔥",
                "countdown2-title": "HyperAir Recommended",
                "countdown3-title": "",
                "month-format": "MMM",
                "order-d-title": "Family Friendly👨‍👩‍👧‍👦",
                "order-g-subtitle": "暑假帶埋一家大細Relax下",
                "order-g-title": "親子Staycation必去之選👨‍👩‍👧‍👦😍",
                "order-h-title": "郵輪之旅🛳️",
                "order-i-title": "情侶煮飯仔酒店 🍽️",
                "order-j-title": "Glamping豪華露營推介",
                "seo-description": "Browse the best Singapore Hotel Staycation Packages, Deals and Offers being SingapoRediscovers Vouchers eligible in one place. Here you can have Amazing Deals, Easy Price Comparison, Exclusive Offers.",
                "seo-keywords": "hotels, staycation singapore, singapore hotel, staycation deals singapore, staycation, hotel staycation singapore, staycation deals, hotel promotion singapore, staycation singapore 2020, hotel staycation, staycation promotion singapore, best staycation singapore, singapore hotel deals, sentosa staycation deals, staycay singapore, staycation meaning, stb approved hotels, sentosa hotel deals, staycation singapore deals 2020, staycation promotion, sentosa staycation promotion 2020, staycation sg, st b hotel, staycation deals singapore 2020, best staycation deals singapore, sentosa hotel promotion, staycation package singapore, singapore staycation deals 2020, hotel promo, best staycation hotel singapore, capella staycation, fullerton hotel staycation, new hotels in singapore, staycay, hotel staycation promotion, hotel deals, hotels open for staycation, list of hotels in singapore, staycation offers singapore, cheap chalet singapore, top hotels in singapore, singapore hotel rooms, singapore hotel offers, staycation approved hotels, family staycation singapore 2020, mbs staycation deals, fullerton staycation, cheapest hotel in sentosa, best staycation singapore 2020, netflix family plan singapore, hotel discounts singapore, staycation deals sg, netflix promotion singapore, singapore hotel price, netflix promo singapore, hotel promotion singapore 2020, hotels to stay in singapore, w hotel singapore promotion, last minute hotel deals singapore, hilton singapore staycation, fullerton hotel promotion, staycation promo, hotel staycation singapore promotion, short time hotel singapore, nice hotels in singapore, hotel rates in singapore, cheap staycation singapore 2020, staycation package, singapore hotel staycation promo, staycation promotion 2020, cheap hotel in singapore below $20, best hotel deals singapore, sentosa staycation promotion, singapore staycation ideas, affordable staycation singapore, m social parking, singapore hotels with connecting rooms, best hotel for staycation, singapore pools suntec, singapore hotel promo, singapore hotel promotion 2020, staycation offers, list of hotels used for quarantine in singapore, capella singapore promotion, sentosa staycation 2020, st regis staycation, best hotel breakfast singapore, top 10 hotels in singapore, nespresso promo code singapore, cheap hotel in singapore below $30, late check out hotel singapore, discount hotels, singapore hotel package, sentosa chalet singapore, staycation singapore promotion 2020, enjoy 11, apartment staycation singapore, marriott high tea promotion 2020, staycation voucher, capella singapore staycation, best hotel, best place for staycation in singapore, sentosa hotel staycation promotion, staycation singapore for couples, hotel near suntec, day stay hotel singapore, cheap hotel in singapore below 50, staycation promo singapore, hotel staycation sg, best staycation deals, hotel stay, staycation 2020, day room singapore, netflix package singapore, best staycation, stay in singapore, w hotel rooms, klook hotel, day staycation singapore, sentosa staycation package, st regis singapore staycation, family staycation promotion 2020, singapore girl booking, sentosa hotel deals singapore, lyf funan staycation, regent hotel staycation, late check out hotel, best hotel deals, m social hotel parking, raffles city parking promotion, sentosa hotel promotion 2020, good hotels in singapore, sentosa hotel singapore promotion, hotels in singapore city, 2 star hotels in singapore, where to stay in singapore, singapore staycay, sg hotel promo, w hotel promotion, fullerton hotel voucher, staycation ideas",
                "seo-title": "【2021 September Latest】The Best Singapore Hotel Staycation Packages, Deals and Offers (Daily Updates) - Look for SingapoRediscovers Vouchers Eligible Offers here - HyperAir",
                "share-button-alert": "Copied the Link",
                "subtitle": "(Aug to Oct 2021, daily updates)",
                "title": "Best Singapore Hotel Staycation Packages, SRV Deals & Promotions",
                "top10-title": "Top 10 Staycation Packages",
                "top102-title": "Worth to try Staycation Packages",
                "top103-title": "Packages you may interested"
            },
            "travel-activities": {
                "best-deals": "Best Deal",
                "book-now": "View Deal",
                "disclaimer": "The prices shown are only for reference. In case of discrepancy, please refer to the our partners' website.",
                "empty-destination": "Please enter country/city",
                "more-deals": "More Deals",
                "not-available": "Not Available",
                "offers": "Offers",
                "provider-getyourguide": "GetYourGuide",
                "provider-hk": {
                    "trip": {
                        "com": "Trip.com"
                    }
                },
                "provider-hyperair": "HyperAir",
                "provider-kkday": "KKday",
                "provider-klook": "KLOOK",
                "provider-seoultravelpass": "SeoulPass",
                "provider-sim": {
                    "hyperair": {
                        "com": "HyperAir"
                    }
                },
                "provider-travelexpert": "Travel Expert",
                "provider-trip": "Trip.com",
                "ratings": "Rating",
                "recommended-title": "More popular activities in {city}",
                "search-africa-oceania": "Africa / Oceania",
                "search-all-cities": "All Cities",
                "search-america": "America",
                "search-asia": "Asia",
                "search-button": "Search",
                "search-cancel-button": "Cancel",
                "search-country-placeholder": "Enter country or city",
                "search-euro-middleeast": "Europe / MiddleEast",
                "search-hardcoded-cities": "Popular Search：",
                "search-placeholder": "Search \"JR Pass\"",
                "search-popular-cities": "🔥 Popular Cities",
                "search-searched-cities": "Searched Cities",
                "search-slogan-2": "Activity/Attraction",
                "show-similar-product": "Compare Similar",
                "sorting": {
                    "price-asc": "Price (Low to High)",
                    "price-desc": "Price (High to Low)",
                    "rating": "Rating",
                    "relevance": "Relevance",
                    "sort-by": "Sort by"
                },
                "title": "Search results matching \"{q}\"",
                "title-everything": "Popular activities in {city}",
                "title-no-result": "Sorry, we couldn't find any results for \"{q}\"",
                "title-no-result-without-keyword": "Sorry, we couldn't find any results",
                "total-results": "Total <b>{number}</b> results"
            },
            "travel-affiliate-codes": {
                "cover-slogan": "Provide discount codes for international travel booking sites",
                "cover-title": "Travel Discount Coupons",
                "disclaimer": "The promotion offers shown are only for reference. In case of discrepancy, please refer to the our partners' website. Suppliers may change or delete the information any time without prior notice and shall have sole discretion to the offer.",
                "exclusive": "Exclusive",
                "type-activity": "Activity",
                "type-air": "Airline Ticket",
                "type-all": "All",
                "type-hotel": "Hotel",
                "type-insurance": "Travel Insurance",
                "type-shopping": "Shopping",
                "type-sim": "SIM Card",
                "use-promo-code": "Get Code",
                "valid-until": "Valid Until:"
            },
            "travel-insurance": {
                "breadcrumb-travel-insurance": "Travel Insurance",
                "cover-subtitle": "Search and compare the best travel insurance with mobile phone coverage!",
                "cover-title": "Travel Insurance",
                "departure-date-alert": "Departure Date must be on or before {latest_date_to_depart}.",
                "disclaimer": "Quote is for reference only. Please refer to the insurance company website for more details.",
                "highlight-subtitle1": "List out the key coverage of the travel insurance plans for your easy selection",
                "highlight-subtitle2": "Compare the best travel insurance deals to help you save every dollar !",
                "highlight-subtitle3": "Enjoy exclusive travel insurance privileges and offers !",
                "highlight-title1": "Coverage Comparison",
                "highlight-title2": "Pricing Comparison",
                "highlight-title3": "Exclusive Rewards",
                "num-of-travellers-alert": "No. of travellers cannot be more than 10",
                "partner-title": "Our Travel Insurance Partners",
                "return-date-alert": "Return Date must be on or before {latest_date_to_return}.",
                "section-title": "You are now searching {num_of_day} for {num_of_traveller} traveller(s)",
                "slogan": "3 Easy Steps",
                "sorting": {
                    "coverage": "Best Coverage",
                    "price-asc": "Price (Low to High)",
                    "price-desc": "Price (High to Low)"
                },
                "step1": "Fill the info",
                "step1-detail": "Enter your destination, date and no. of travellers",
                "step2": "Compare the plans",
                "step2-detail": "Compare the price and coverage of different travel insurance plans",
                "step3": "Enjoy the offers",
                "step3-detail": "One-click to enjoy exclusive travel insurance offers"
            },
            "travel-insurance-product-card": {
                "apply-now": "Get the offer",
                "cancellation": "CANCELLATION",
                "car-rental": "VEHICLE RENTAL EXCESS",
                "cruise-vacation": "CRUISE VACATION (optional benefits)",
                "dangerous-sports": "DANGEROUS SPORTS",
                "hyperair-exclusive": "HYPERAIR EXCLUSIVE",
                "medical": "MEDICAL",
                "mobile": "LOSS/DAMAGE OF MOBILE PHONE",
                "personal-belongings": "PERSONAL BELONGINGS",
                "trip-delay": "TRIP DELAY"
            },
            "travel-insurance-search-bar": {
                "children": "Children aged below 18",
                "date": "Departure Date and Return Date",
                "destination": "Where do you go",
                "friend": "Friends / Relatives",
                "myself": "Myself",
                "number-of-traveller": "Number of Traveller",
                "search-button": "Search",
                "spouse": "Spouse"
            },
            "travel-marketplace": {
                "buy-now-can-earn-x-miles": "Earn HyperMiles for next purchase",
                "cover-slogan": "A collection of coolest gadgets that you'll like",
                "cover-title": "Travel Gadgets"
            },
            "travel-marketplace-categories": "Categories",
            "travel-marketplace-checkout": {
                "delivery-message-body": "Working days are from Monday to Friday (except public holidays). The order cut-off time is 12：00 PM (GMT+8). Orders placed after 12：00 PM (GMT+8) will ship out the next working day.",
                "delivery-method-1": "SF Express (Hong Kong Only)",
                "delivery-method-1-description": "By SF Express, courier fee is HK$30 per order. Courier fee is waived upon purchasing above HK$800. The ordered items will be delivered by courier within 5-10 working days.",
                "delivery-method-2": "International Shipping",
                "delivery-method-2-description": "Delivery in 4 to 15 working days depending on the destination. Shipping fee is HK$100 per item. The above international delivery fee is based on estimation. Further surcharge may apply."
            },
            "travel-money": {
                "breadcrumb-travel-money": "Travel Money",
                "cover-button": "Experience Now",
                "cover-slogan": "Exchange travel money smarter",
                "cover-title": "Travel Money",
                "disclaimer": "The prices shown are only for reference. In case of discrepancy, please refer to the money changers' website.",
                "empty-amount": "Please enter the amount",
                "fx": "",
                "fx-slogan": "Four Easy Steps",
                "fx-step1": "Search",
                "fx-step1-detail": "Choose the currency you want to exchange",
                "fx-step2": "Compare",
                "fx-step2-detail": "Find the best rate and most convenient pick-up spot",
                "fx-step3": "Book",
                "fx-step3-detail": "Reserve the travel money online",
                "fx-step4": "Pick up",
                "fx-step4-detail": "Show the QR code to get the travel money",
                "hyperair-feature-1": "Smart",
                "hyperair-feature-1-description": "A smart way to exchange travel money. Now you can spot the best rate with just a few clicks and reserve the travel money online. Time to say bye to long queue!",
                "hyperair-feature-2": "Reliable",
                "hyperair-feature-2-description": "A reliable way to get the money exchange. All our partners are licensed banks and money exchangers to keep your foreign exchange safe.",
                "hyperair-feature-3": "Anywhere. Anytime.",
                "hyperair-feature-3-description": "A brand new way to get travel money. We are keen to expand overseas footprint and provide you the smartest travel experience anywhere.",
                "i-will-get": "I will get",
                "i-will-pay": "I will pay",
                "join-us": "For more business opportunity",
                "join-us-button": "Join us now",
                "join-us-slogan": "Become our supplier",
                "search-bar-placeholder": "Enter Amount",
                "search-button": "Search",
                "section-title": "{amount} {currency} for HKD",
                "section-title-from-hkd": "Searching HKD for {amount} {currency}",
                "section-title-to-hkd": "Searching {amount} {currency} for HKD",
                "why-hyperair": "",
                "why-hyperair-description": "HyperAir provides you a brand new way to get travel money. Now you can book the exchange online with the best in town exchange rate!",
                "why-hyperair-title": "Why choose us?"
            },
            "travel-product": {
                "buy-now": "Buy Now",
                "product-option": "Options"
            },
            "travel-sim": {
                "as-low-as": "Daily As low as",
                "book-now": "Order Now",
                "breadcrumb-homepage": "Homepage",
                "breadcrumb-mainpage": "Main page",
                "breadcrumb-travel-sim": "Travel SIM",
                "cancellation-policy": "Cancellation Policy",
                "cancellation-policy-content": "No cancellations, refunds or changes can be made after purchase.",
                "download-hyperair-now-description": "Scan the QR code or go to app store to download HyperAir App",
                "download-hyperair-now-title": "Download HyperAir App",
                "first-step": "Step 1",
                "go-to-shopping-cart-description": "",
                "go-to-shopping-cart-title": "",
                "hardcoded-countries-title": "Other Popular Countries:",
                "highlights": "Highlights",
                "important-notice": "Important Notice",
                "instructions": "Instructions",
                "lowest-price-guarantee": "Best Price Guarantee",
                "no-stock": "Sold Out",
                "num-of-review": "{num}-of-review reviews",
                "popular-countries": "Travel SIM covers 200+ countries",
                "popular-countries-search-button": "Search other countries",
                "product-highlights": "Product Description",
                "product-specification": "Product Specification",
                "related-sims": "Related {country} SIM",
                "related-sims-search-button": "More {country} SIM",
                "review": "Review",
                "review-date": "{date}",
                "review-no-firstname-user": "Traveller",
                "scan-product-qr-code": "Scan the QR code to purchase this product",
                "second-step": "Step 2",
                "sim": " Sim Cards",
                "web-traffic": "Purchased {num}-of-purchased times since last week and {num}-of-traffic users are looking at this SIM right now",
                "web-traffic-title": "This SIM is in hot sales!"
            },
            "travel-sim-checkout": {
                "-secure-payment-slogan": "",
                "address": "Delivery Address",
                "address-column1": "e.g. Room A, 18/F, World Center",
                "address-column2": "e.g. 88 Travel Road",
                "address-column3": "e.g. Central, Hong Kong",
                "back-button": "Back",
                "checkout-title-1": "Delivery Info",
                "confirm-button": "Continue",
                "country-code": "Country Code",
                "delivery-message-body": "Working days are from Monday to Friday (except public holidays). The order cut-off time is 12：00 PM (GMT+8). Orders placed after 12：00 PM (GMT+8) will ship out the next working day.\n<br><br>Within the same working day, orders with the same delivery address will be sent together.",
                "delivery-message-header": "Delivery Notice",
                "delivery-method": "Delivery Method",
                "delivery-method-1": "Hong Kong Post (Free)",
                "delivery-method-1-description": "By Hong Kong Post's Local Mail, the estimated delivery will be within 3-6 working days. Status tracking is not available to local mail and customers shall bare the full responsibility of losing items by using Hong Kong Post’s ordinary mail service.\n<br><br>Note: Due to the time required for delivery, customers who are about to travel are recommended to choose SF Express",
                "delivery-method-2": "SF Express (Hong Kong only. Courier fee payable on delivery)",
                "delivery-method-2-description": "By SF Express (courier fee payable on delivery), the ordered items will be delivered by courier within 1-3 working days, and islands will take longer delivery time. The courier fee is about HK$16-$25 by referring to the website of SF Express.\n<br><br>Note: The order over HK$399 will be upgraded to SF Express for FREE",
                "delivery-method-3": "International Shipping",
                "delivery-method-3-description": "Delivered by Hong Kong Post (tracking no. will be provided) within 4 to 15 working days depends on the destination. Shipping cost HK$30.",
                "error-alert-address": "Please fill in the delivery address.",
                "error-alert-invalid-email": "Email format is invalid.",
                "error-alert-invalid-recipient-first-num": "contact number should be started with 2,3,5,6,7,8 or 9.",
                "error-alert-invalid-recipient-number": "Please fill in the correct contact number.",
                "error-alert-invalid-user-first-num": "Mobile number should be start with 5,6,7,8 or 9.",
                "error-alert-invalid-user-number": "Please fill in the correct mobile number.",
                "error-alert-personal-info": "Please fill in Personal Info.",
                "error-alert-recipient-info": "Please fill in Recipient Info.",
                "error-invalid-credit-card-info": "Invalid Credit Card Information",
                "facebook-login": "Continue With Facebook",
                "google-login": "Continue With Google",
                "logged-in": "Logged In",
                "login": "Existing customer, login to enjoy the express check-out",
                "login-button": "Login",
                "login-email": "Email",
                "login-no-user-exists": "Oops! Sorry, we are unable to confirm your login information. Please try again or simply complete the order without guest check-out.",
                "login-password": "Password",
                "payme": {
                    "error-contacting-payme": "Payment error, please re-order again or contact customer support."
                },
                "payment": {
                    "actual-payment": "The transaction will be settled at HK${actual_payment} and the exchange rate will be based on your credit card issuer.",
                    "choose-payment-method": "Choose payment method:",
                    "logistic-information": "Delivery Info",
                    "modify-information": "Edit Info",
                    "pay-now": "Pay Now",
                    "payme-instruction-do-not-close": "Please do not close this page before payment is complete",
                    "payme-instruction-step-1": "1. Open the PayMe app.",
                    "payme-instruction-step-2": "2. Scan the PayCode to authorise payment.",
                    "payme-instruction-step-3": "3. Complete payment in the app and wait for confirmation.",
                    "payme-instruction-title": "Paying with PayMe",
                    "payme-title": "Scan this PayCode with PayMe",
                    "payment": "Payment",
                    "price": "Amount",
                    "shipping-fee": "Shipping Fee",
                    "subtotal": "Subtotal"
                },
                "payment-method": "Payment Method",
                "pending": {
                    "mobile-redirection-text": "You have selected PayMe as your payment method and will be redirected to the PayMe app to complete payment.",
                    "need-to-pay": "Amount due",
                    "order-number": "Order Number",
                    "order-success-please-pay": "Please pay with PayMe to complete the ordering process",
                    "paycode-error": "Payment error, please re-order again or contact customer support.",
                    "paycode-expired": "PayMe's paycode expired, please re-order again.",
                    "re-order": "Re-order",
                    "title-payme": "Pay with PayMe"
                },
                "recipient-address": "Delivery Address",
                "recipient-information": "Recipient Info",
                "recipient-name": "Recipient Name",
                "recipient-phone-number": "Recipient Phone Number",
                "secure-payment-slogan": "Secure Checkout | Payment will be encrypted and securely transmitted using SSL",
                "simproduct-detail": "Order Info",
                "simproduct-quantity": "Quantity",
                "simproduct-redeem": "Redeem",
                "simproduct-redeem-hypermiles": "Redeem Hyper Miles",
                "simproduct-title": "Product",
                "simproduct-will-redeeming-x-miles": "Redeeming {miles} HyperMiles",
                "simproduct-you-have-x-hypermiles": "You have {miles} HyperMiles",
                "user-email": "Email (To receive invoice)",
                "user-firstname": "First Name",
                "user-information": "Personal Info",
                "user-lastname": "Last Name",
                "user-phone-number": "Mobile Number",
                "vertical-divider": "or"
            },
            "travel-sims": {
                "column-title-1": "Clear Classification, Easy to Pick",
                "column-title-2": "Online Payment, Convenient and Fast",
                "column-title-3": "Free Surface Mail, Speedy Delivery",
                "country-search-no-place-found": "Please enter a country name",
                "cover-button": "Order with HyperAir App Now",
                "cover-slogan": "Best SIM card deals with free shipping!",
                "cover-title": "Travel SIM",
                "empty-destination": "Please enter destination",
                "num-of-days": "Number of Days",
                "search-button": "",
                "search-input": "Search country",
                "search-placeholder": "Search country",
                "search-slogan": "Where do you go?",
                "travel-sim-header-description": "",
                "travel-sim-header-title": ""
            }
        },
        "passwords": {
            "password": "Passwords must be at least six characters and match the confirmation.",
            "reset": "Your password has been reset!",
            "sent": "We have e-mailed your password reset link.",
            "token": "This password reset token is invalid.",
            "user": "We can't find a user with that e-mail address."
        },
        "mail": {
            "product-simcard": {
                "delivery-update": {
                    "subject": "Your SIM Card order is on its way"
                },
                "purchased": {
                    "subject": "Travel SIM Order Confirmation"
                },
                "tracking-number-update": {
                    "subject": "Your order tracking number is updated"
                }
            }
        },
        "member-center": {
            "login-to-receive-codes": "Register an account to receive promotion code",
            "my-orders-empty": "No Records",
            "my-orders-title": "My Orders",
            "profile-area-code": "Area Code",
            "profile-email": "Email",
            "profile-firstname": "First Name",
            "profile-lastname": "Last Name",
            "profile-save": "Save",
            "profile-tel": "Mobile Phone",
            "profile-title": "Profile",
            "profile-update-successfully": "Updated successfully",
            "promo-code-enter-promotion-code": "Enter promotion code",
            "promo-code-my-promo-code": "My HyperAir Coupons",
            "promo-code-no-code": "Sorry, you do not have any promotion code",
            "promo-code-please-fill-in-code": "Please fill in promotion code",
            "promo-code-redeem": "Redeem",
            "promo-code-redeem-code": "Redeem HyperAir Coupon",
            "promo-code-select": "Select",
            "promo-code-title": "HyperAir Coupon",
            "title": "My Account"
        },
        "weekday": {
            "1": "Monday",
            "2": "Tuesday",
            "3": "Wednesday",
            "4": "Thursday",
            "5": "Friday",
            "6": "Saturday",
            "7": "Sunday"
        },
        "exchange-shop-details": {
            "address": "Address",
            "book-button": "Book Now",
            "br": "BR",
            "closed-book-button": "Closed",
            "download-pop-up": {
                "slogan-1": "Locked in Rate",
                "slogan-2": "Instant Comfirmation",
                "title": "Download App for the FX Booking"
            },
            "latest-updated": "Latest Updated",
            "not-available-book-button": "Reference Only",
            "opening-hrs": "Opening Hours",
            "phone-num": "Phone Number",
            "rate": "Rate",
            "reviews": "Reviews",
            "table-buy-rate": "Buy rate",
            "table-compare-button": "Compare",
            "table-currency": "Currency",
            "table-sell-rate": "Sell Rate",
            "table-short-form": "Code",
            "table-title": "Other Currencies"
        },
        "credit-card": {
            "cannot-add-card": "Something went wrong while adding your credit card. Please check your information and try again or you may add another credit card.",
            "cannot-process": "Something went wrong while charging your credit card. Please check your information and try again or you may check out with another credit card."
        },
        "shoppingcart": {
            "add": {
                "no-stock": "Oops! Reached the maximum purchasable quantity for this product..."
            },
            "pay": {
                "db-locked": "Server busy. Please try again later. (Ref. Code: E1003)",
                "invalid-promotion-code": "Invalid Promotion Code",
                "no-stock": "Product(s) out of stock just now! (Ref. Code: E1002)"
            },
            "promotion-message": {
                "up-sell-1": "Enjoy HK$10 off with welcome coupon",
                "up-sell-2": "Enjoy HK$15 off with promo code HYPER15 when spending above HK$299"
            }
        },
        "product": {
            "label-confirmation-duration-24_hours": "24 hours confirmation",
            "label-confirmation-duration-48_hours": "48 hours confirmation",
            "label-confirmation-duration-instant": "Instant confirmation",
            "label-duration-unit-day": "&nbsp;days",
            "label-duration-unit-hour": "hour(s)",
            "label-duration-unit-hr": "&nbsp;hours",
            "label-duration-unit-min": "&nbsp;mins",
            "label-earliest-available-date": "j M Y",
            "label-earliest-available-date-today": "Today",
            "label-earliest-available-date-tomorrow": "Tomorrow",
            "label-lang-en": "English",
            "label-lang-jp": "Japanese",
            "label-lang-kr": "Korean",
            "label-lang-zh": "Chinese",
            "label-meet-up-method-hotel_pickup": "Hotel pickup",
            "label-meet-up-method-location_meet_up": "Location meet up",
            "label-refundable-conditional_cancel": "Conditional cancellation",
            "label-refundable-no_cancel": "No cancellation",
            "label-ticket-logistic-mobile": "Mobile voucher accepted",
            "label-ticket-logistic-printed": "Printed voucher accepted",
            "label-ticket-logistic-printed_or_mobile": "Printed or Mobile voucher accepted",
            "label-ticket-validity-fixed_date": "Fixed Date Ticket",
            "label-ticket-validity-open_date": "Open Date Ticket",
            "label-ticket-validity-open_or_fixed_date": "Open/Fixed Date Ticket"
        },
        "pagination": {
            "next": "Next",
            "previous": "Previous"
        },
        "city": {
            "abu-dhabi": "Abu Dhabi",
            "adelaide": "Adelaide",
            "agra": "Agra",
            "ahmedabad": "Ahmedabad",
            "alice-springs": "Alice Springs",
            "alsace": "Alsace",
            "amritsar": "Amritsar",
            "amsterdam": "Amsterdam",
            "andalusia": "Andalusia",
            "antalya": "Antalya",
            "anuradhapura": "Anuradhapura",
            "athens": "Athens",
            "auckland": "Auckland",
            "bacolod": "Bacolod",
            "bagan": "Bagan",
            "baku": "Baku",
            "bali": "Bali",
            "bandung": "Bandung",
            "bangalore": "Bangalore",
            "bangkok": "Bangkok",
            "barcelona": "Barcelona",
            "batam": "Batam",
            "bath": "Bath",
            "bay-of-islands": "Bay of Islands",
            "beijing": "Beijing",
            "belfast": "Belfast",
            "bentota": "Bentota",
            "berlin": "Berlin",
            "bohol": "Bohol",
            "boracay": "Boracay",
            "bordeaux": "Bordeaux",
            "boston": "Boston",
            "bratislava": "Bratislava",
            "brisbane": "Brisbane",
            "bruges": "Bruges",
            "brussels": "Brussels",
            "budapest": "Budapest",
            "burgundy": "Burgundy",
            "busan": "Busan",
            "cairns": "Cairns",
            "cambridge": "Cambridge",
            "cameron-highlands": "Cameron Highlands",
            "canary-islands": "Canary Islands",
            "cape-town": "Cape Town",
            "cappadocia": "Cappadocia",
            "cebu": "Cebu",
            "champagne": "Champagne",
            "chengdu": "Chengdu",
            "chennai": "Chennai",
            "chiang-mai": "Chiang Mai",
            "chiang-rai": "Chiang Rai",
            "chiayi": "Chiayi",
            "chicago": "Chicago",
            "chongqing": "Chongqing",
            "christchurch": "Christchurch",
            "cochin": "Cochin",
            "cologne": "Cologne",
            "colombo": "Colombo",
            "copenhagen": "Copenhagen",
            "costa-del-sol": "Costa del Sol",
            "crete": "Crete",
            "da-lat": "Da Lat",
            "da-nang": "Da Nang",
            "darwin": "Darwin",
            "davao": "Davao",
            "delhi": "Delhi",
            "dhaka": "Dhaka",
            "dresden": "Dresden",
            "dubai": "Dubai",
            "dublin": "Dublin",
            "dubrovnik": "Dubrovnik",
            "dumaguete": "Dumaguete",
            "dunedin": "Dunedin",
            "düsseldorf": "Düsseldorf",
            "edinburgh": "Edinburgh",
            "finnish-lapland": "Lapland",
            "florence": "Florence",
            "frankfurt": "Frankfurt",
            "fraser-island": "Fraser Island",
            "french-riviera": "French Riviera",
            "fukuoka": "Fukuoka",
            "galle": "Galle",
            "galway": "Galway",
            "gangtok": "Gangtok",
            "gangwon-do": "Gangwon-do",
            "gdansk": "Gdansk",
            "geneva": "Geneva",
            "genting-highlands": "Genting Highlands",
            "geraldton": "Geraldton",
            "glasgow": "Glasgow",
            "goa": "Goa",
            "gold-coast": "Gold Coast",
            "gothenburg": "Gothenburg",
            "guam": "Guam",
            "guangdong": "Guangdong",
            "guilin": "Guilin",
            "guizhou": "Guizhou",
            "gyeonggi-do": "Gyeonggi-do",
            "haikou": "Haikou",
            "hakone": "Hakone",
            "halong": "Halong",
            "hamburg": "Hamburg",
            "hangzhou": "Hangzhou",
            "hanoi": "Hanoi",
            "harbin": "Harbin",
            "hat-yai": "Hat Yai",
            "hawaii": "Hawaii",
            "heidelberg": "Heidelberg",
            "helsinki": "Helsinki",
            "himachal-pradesh": "Himachal Pradesh",
            "hiroshima": "Hiroshima",
            "ho-chi-minh-city": "Ho Chi Minh City",
            "hobart": "Hobart",
            "hoi-an": "Hoi An",
            "hokkaido": "Hokkaido",
            "hong-kong": "Hong Kong",
            "hua-hin": "Hua Hin",
            "hualien": "Hualien",
            "hue": "Hue",
            "hyderabad": "Hyderabad",
            "iloilo": "Iloilo",
            "incheon": "Incheon",
            "inle-lake": "Inle Lake",
            "inner-mongolia": "Inner Mongolia",
            "innsbruck": "Innsbruck",
            "interlaken": "Interlaken",
            "inverness": "Inverness",
            "ipoh": "Ipoh",
            "istanbul": "Istanbul",
            "jaipur": "Jaipur",
            "jaisalmer": "Jaisalmer",
            "jakarta": "Jakarta",
            "jeju": "Jeju",
            "jerusalem": "Jerusalem",
            "jodhpur": "Jodhpur",
            "johor-bahru": "Johor Bahru",
            "kandy": "Kandy",
            "kaohsiung": "Kaohsiung",
            "kathmandu": "Kathmandu",
            "kazan": "Kazan",
            "kenting": "Kenting",
            "kiev": "Kiev",
            "kinmen": "Kinmen",
            "kobe": "Kobe",
            "koh-chang": "Koh Chang",
            "koh-samui": "Koh Samui",
            "krabi": "Krabi",
            "krakow": "Krakow",
            "kuala-lumpur": "Kuala Lumpur",
            "kumamoto": "Kumamoto",
            "kyoto": "Kyoto",
            "kyushu": "Kyushu",
            "lake-district": "Lake District",
            "langkawi": "Langkawi",
            "lapland": "Lapland",
            "las-vegas": "Las Vegas",
            "launceston": "Launceston",
            "lausanne": "Lausanne",
            "leipzig": "Leipzig",
            "lisbon": "Lisbon",
            "liverpool": "Liverpool",
            "ljubljana": "Ljubljana",
            "loire-valley": "Loire Valley",
            "lombok": "Lombok",
            "london": "London",
            "los-angeles": "Los Angeles",
            "luang-prabang": "Luang Prabang",
            "lucerne": "Lucerne",
            "lviv": "Lviv",
            "lyon": "Lyon",
            "macao": "Macau",
            "macau": "Macau",
            "madrid": "Madrid",
            "malaga": "Malaga",
            "manchester": "Manchester",
            "mandalay": "Mandalay",
            "manila": "Manila",
            "marrakech": "Marrakech",
            "mauritius": "Mauritius",
            "medan": "Medan",
            "melaka": "Melaka",
            "melbourne": "Melbourne",
            "miami": "Miami",
            "milford-sound": "Milford Sound",
            "montreux": "Montreux",
            "moscow": "Moscow",
            "mumbai": "Mumbai",
            "munich": "Munich",
            "muscat": "Muscat",
            "nagano": "Nagano",
            "nagoya": "Nagoya",
            "naples": "Naples",
            "nelson": "Nelson",
            "new-delhi": "New Delhi",
            "new-york": "New York",
            "nha-trang": "Nha Trang",
            "niagara-falls": "Niagara Falls",
            "niigata": "Niigata",
            "normandy": "Normandy",
            "odessa": "Odessa",
            "okayama": "Okayama",
            "okinawa": "Okinawa",
            "orlando": "Orlando",
            "osaka": "Osaka",
            "oslo": "Oslo",
            "oxford": "Oxford",
            "palawan": "Palawan",
            "paris": "Paris",
            "pattaya": "Pattaya",
            "penang": "Penang",
            "penghu": "Penghu",
            "perth": "Perth",
            "philadelphia": "Philadelphia",
            "phnom-penh": "Phnom Penh",
            "phu-quoc": "Phu Quoc",
            "phuket": "Phuket",
            "pisa": "Pisa",
            "pokhara": "Pokhara",
            "port-lincoln": "Port Lincoln",
            "porto": "Porto",
            "porto-district": "Porto District",
            "prague": "Prague",
            "provence": "Provence",
            "puglia": "Puglia",
            "pune": "Pune",
            "pushkar": "Pushkar",
            "queenstown": "Queenstown",
            "ras-al-khaimah": "Ras Al Khaimah",
            "reykjavik": "Reykjavik",
            "rhodes": "Rhodes",
            "rhône-alpes": "Rhône-Alpes",
            "rome": "Rome",
            "rotorua": "Rotorua",
            "rotterdam": "Rotterdam",
            "sabah": "Sabah",
            "saint-petersburg": "Saint Petersburg",
            "saipan": "Saipan",
            "salzburg": "Salzburg",
            "san-diego": "San Diego",
            "san-francisco": "San Francisco",
            "santorini": "Santorini",
            "sanya": "Sanya",
            "sapa": "Sapa",
            "sarawak": "Sarawak",
            "seattle": "Seattle",
            "seoul": "Seoul",
            "seville": "Seville",
            "shanghai": "Shanghai",
            "sibiu": "Sibiu",
            "sicily": "Sicily",
            "siem-reap": "Siem Reap",
            "sihanoukville": "Sihanoukville",
            "singapore": "Singapore",
            "split": "Split",
            "surabaya": "Surabaya",
            "suzhou": "Suzhou",
            "swedish-lapland": "Swedish Lapland",
            "sydney": "Sydney",
            "taichung": "Taichung",
            "tainan": "Tainan",
            "taipei": "Taipei",
            "taitung": "Taitung",
            "tarragona": "Tarragona",
            "taupo": "Taupo",
            "terengganu": "Terengganu",
            "thessaloniki": "Thessaloniki",
            "tokyo": "Tokyo",
            "toledo": "Toledo",
            "trincomalee": "Trincomalee",
            "turin": "Turin",
            "udaipur": "Udaipur",
            "uluru": "Uluru",
            "uttarakhand": "Uttarakhand",
            "varanasi": "Varanasi",
            "venice": "Venice",
            "verona": "Verona",
            "vienna": "Vienna",
            "vientiane": "Vientiane",
            "volendam": "Volendam",
            "washington-dc": "Washington DC",
            "wellington": "Wellington",
            "whitsundays": "Whitsundays",
            "xiamen": "Xiamen",
            "xian": "Xian",
            "yangon": "Yangon",
            "yilan": "Yilan",
            "yogyakarta": "Yogyakarta",
            "york": "York",
            "yunnan": "Yunnan",
            "zagreb": "Zagreb",
            "zhangjiajie": "Zhangjiajie",
            "zurich": "Zurich"
        },
        "validation": {
            "accepted": "The {attribute} must be accepted.",
            "active_url": "The {attribute} is not a valid URL.",
            "after": "The {attribute} must be a date after {date}.",
            "after_or_equal": "The {attribute} must be a date after or equal to {date}.",
            "alpha": "The {attribute} may only contain letters.",
            "alpha_dash": "The {attribute} may only contain letters, numbers, and dashes.",
            "alpha_num": "The {attribute} may only contain letters and numbers.",
            "array": "The {attribute} must be an array.",
            "before": "The {attribute} must be a date before {date}.",
            "before_or_equal": "The {attribute} must be a date before or equal to {date}.",
            "between": {
                "array": "The {attribute} must have between {min} and {max} items.",
                "file": "The {attribute} must be between {min} and {max} kilobytes.",
                "numeric": "The {attribute} must be between {min} and {max}.",
                "string": "The {attribute} must be between {min} and {max} characters."
            },
            "boolean": "The {attribute} field must be true or false.",
            "confirmed": "The {attribute} confirmation does not match.",
            "custom": {
                "attribute-name": {
                    "rule-name": "custom-message"
                }
            },
            "date": "The {attribute} is not a valid date.",
            "date_format": "The {attribute} does not match the format {format}.",
            "different": "The {attribute} and {other} must be different.",
            "digits": "The {attribute} must be {digits} digits.",
            "digits_between": "The {attribute} must be between {min} and {max} digits.",
            "dimensions": "The {attribute} has invalid image dimensions.",
            "distinct": "The {attribute} field has a duplicate value.",
            "email": "The {attribute} must be a valid email address.",
            "exists": "The selected {attribute} is invalid.",
            "file": "The {attribute} must be a file.",
            "filled": "The {attribute} field must have a value.",
            "image": "The {attribute} must be an image.",
            "in": "The selected {attribute} is invalid.",
            "in_array": "The {attribute} field does not exist in {other}.",
            "integer": "The {attribute} must be an integer.",
            "ip": "The {attribute} must be a valid IP address.",
            "ipv4": "The {attribute} must be a valid IPv4 address.",
            "ipv6": "The {attribute} must be a valid IPv6 address.",
            "json": "The {attribute} must be a valid JSON string.",
            "max": {
                "array": "The {attribute} may not have more than {max} items.",
                "file": "The {attribute} may not be greater than {max} kilobytes.",
                "numeric": "The {attribute} may not be greater than {max}.",
                "string": "The {attribute} may not be greater than {max} characters."
            },
            "mimes": "The {attribute} must be a file of type: {values}.",
            "mimetypes": "The {attribute} must be a file of type: {values}.",
            "min": {
                "array": "The {attribute} must have at least {min} items.",
                "file": "The {attribute} must be at least {min} kilobytes.",
                "numeric": "The {attribute} must be at least {min}.",
                "string": "The {attribute} must be at least {min} characters."
            },
            "not_in": "The selected {attribute} is invalid.",
            "numeric": "The {attribute} must be a number.",
            "present": "The {attribute} field must be present.",
            "regex": "The {attribute} format is invalid.",
            "required": "The {attribute} field is required.",
            "required_if": "The {attribute} field is required when {other} is {value}.",
            "required_unless": "The {attribute} field is required unless {other} is in {values}.",
            "required_with": "The {attribute} field is required when {values} is present.",
            "required_with_all": "The {attribute} field is required when {values} is present.",
            "required_without": "The {attribute} field is required when {values} is not present.",
            "required_without_all": "The {attribute} field is required when none of {values} are present.",
            "same": "The {attribute} and {other} must match.",
            "size": {
                "array": "The {attribute} must contain {size} items.",
                "file": "The {attribute} must be {size} kilobytes.",
                "numeric": "The {attribute} must be {size}.",
                "string": "The {attribute} must be {size} characters."
            },
            "string": "The {attribute} must be a string.",
            "timezone": "The {attribute} must be a valid zone.",
            "unique": "The {attribute} has already been taken.",
            "uploaded": "The {attribute} failed to upload.",
            "url": "The {attribute} format is invalid."
        },
        "reset-password": {
            "confirm-new-password": "Confirm new password",
            "enter-new-password": "Enter new password",
            "please-enter-a-new-password": "Please enter a new password for your account {email}.",
            "submit": "Submit",
            "success-content": "Successful! Please log in the HyperAir mobile app with the new password.",
            "title": "Reset Password",
            "validation-display": "Password must contain at least 6 characters."
        },
        "notification": {
            "activation-e-minus-content": "15 days countdown! Your Travel SIM welcome coupon will be expired very soon! Don't miss the chance to use the coupon for your upcoming trip!",
            "activation-e-minus-title": "",
            "activation-t-plus-content": "Remember to use our welcome SIM card coupon for your upcoming trip! Travel Smarter. Anywhere.",
            "activation-t-plus-title": "",
            "ask-shop-to-quote-content": "Request quotation for buying {amount} {currency}",
            "ask-shop-to-quote-content2": "Request quotation for selling {amount} {currency}",
            "ask-shop-to-quote-title": "New Request for Quotation",
            "email-booking-details": "Booking Details",
            "email-booking-id": "Booking ID",
            "email-exchange-approved-content": "Exchanged order approved for buying {amount} {currency} at rate {rate}",
            "email-exchange-approved-footer": "Thank you for using HyperAir.",
            "email-exchange-approved-title": "Shop replied, \"Your travel money is ready for pickup!\"",
            "email-exchange-completed-content": "Exchanged order completed for buying {amount} {currency} at rate {rate}",
            "email-exchange-completed-footer": "Thank you for using HyperAir.",
            "email-exchange-completed-title": "Your travel money exchange is completed!",
            "email-exchange-confirmed-content": "Exchanged order confirmed for buying {amount} {currency} at rate {rate}",
            "email-exchange-confirmed-footer": "Thank you for using HyperAir.",
            "email-exchange-confirmed-title": "Your travel money is ready for your pickup!",
            "email-footer-copy-right": "All rights reserved.",
            "email-greetings": "Hello!",
            "email-i-got": "I got",
            "email-i-paid": "I paid",
            "email-i-will-get": "I will get",
            "email-i-will-pay": "I will pay",
            "email-pickup-before": "Pickup before",
            "email-product-confirmed-greeting": "Dear valued customer,<br><br>Thank you for using HyperAir. Your voucher is ready.",
            "email-product-confirmed-subject": "Order has been confirmed",
            "email-product-confirmed-title": "Your Order is Confirmed",
            "email-product-purchased": {
                "shipping": {
                    "international": "International Shipping",
                    "sf": "SF Express (Hong Kong Only)"
                }
            },
            "email-product-purchased-delievery-address": "Delivery Address",
            "email-product-purchased-delivery-info": "Delivery Info",
            "email-product-purchased-delivery-method": "Delivery Method",
            "email-product-purchased-discount": "Discount",
            "email-product-purchased-email": "Email",
            "email-product-purchased-greeting": "Dear valued customer,<br><br> Good choice. It will take some time to confirm the reservation. But do not worry, most of time we can confirm the order within 12 hours. Thanks for using HyperAir!",
            "email-product-purchased-have-a-nice-trip": "Have a nice trip!",
            "email-product-purchased-important-notice": "Terms & Conditions apply.",
            "email-product-purchased-important-notice-content": "Terms & Conditions apply.",
            "email-product-purchased-name": "Name",
            "email-product-purchased-order-date": "Order Date",
            "email-product-purchased-order-details": "Order Details",
            "email-product-purchased-order-no": "Order Number",
            "email-product-purchased-personal-info": "Personal Info",
            "email-product-purchased-receipient-name": "Recipient Name",
            "email-product-purchased-receipient-phone-no": "Phone No.",
            "email-product-purchased-shipping-fee": "Shipping Fee",
            "email-product-purchased-sub-total": "Sub-total",
            "email-product-purchased-subject": "Order is pending to confirm",
            "email-product-purchased-title": "Your Order is Pending",
            "email-product-purchased-total": "Total",
            "email-product-simcapurchased-personal-info": "Personal Info",
            "email-product-simcard-delivery-title": "Your order SIM{order}-num has been prepared and shipped on {date}. If you have chosen SF Express, we will provide the tracking number later. You can also check it on our mobile app.",
            "email-product-simcard-delivery-title-carbon-format": "j M Y",
            "email-product-simcard-delivery-update-greeting": "Dear valued customer,<br><br>Thank you for using HyperAir. Your SIM card order is on its way.",
            "email-product-simcard-delivery-update-title": "Your SIM Card order is on its way",
            "email-product-simcard-delivery-update-tracking": "Tracking Details",
            "email-product-simcard-delivery-update-tracking-no": "Tracking Number",
            "email-product-simcard-delivery-update-tracking-no-hkpost": "Tracking Number: -",
            "email-product-simcard-delivery-update-tracking-no-sf": "Tracking Number",
            "email-product-simcard-delivery-waiting-update-tracking-no-sf": "Are waiting SF Express to update",
            "email-product-simcard-delivery-with-tracking-num-title": "Your order SIM{order}-num will be shipped by SF Express with tracking number: {tracking}-num. Please pay attention to your mobile phone for delivery pick up. You can also check the shipping status on the SF Express website. Thanks for using HyperAir services.",
            "email-product-simcard-esim-code-greeting": "Dear valued customer,<br><br>Thank you for using HyperAir. Here's your eSIM activation QR Code.",
            "email-product-simcard-esim-code-important-notice-content": "<span style=\"font-size: 10px; line-height: 12px;\">Instructions:<br />1. Go to Setting<br />2. Tap \"Mobile Data\"<br />3. In Data Plans, tap \"Add Data Plan\"<br />4. Scan the QR code in the camera frame<br />If you are asked to enter a confirmation code to activate the eSIM, enter the number that the carrier provided. Have a question? Please email to hello@hyperair.com and we will get back to you.</span>",
            "email-product-simcard-esim-code-title": "Here's your eSIM activation QR Code",
            "email-product-simcard-esim-code-warning": "Kindly note that the eSIM will be activated once the QR code is scanned. Please scan it only when you want to start the service.",
            "email-product-simcard-purchased-delievery-address": "Delivery Address",
            "email-product-simcard-purchased-delivery-info": "Delivery Info",
            "email-product-simcard-purchased-delivery-method": "Delivery Method",
            "email-product-simcard-purchased-discount": "Discount",
            "email-product-simcard-purchased-greeting": "Dear valued customer,<br><br>Thank you for using HyperAir. We are now preparing the delivery of your Travel SIM.",
            "email-product-simcard-purchased-greeting-esim-only": "Dear valued customer,<br><br>Thank you for using HyperAir, your eSIM is ready! Please find the attached QR code and activate according to the instructions.",
            "email-product-simcard-purchased-greeting-esim-with-sim": "Dear valued customer,<br><br>Thank you for using HyperAir. We are now preparing the delivery of your Travel SIM. For your eSIM, please find the attached QR code and activate according to the instructions.",
            "email-product-simcard-purchased-greeting-sim-only": "Dear valued customer,<br><br>Thank you for using HyperAir. We are now preparing the delivery of your Travel SIM.",
            "email-product-simcard-purchased-have-a-nice-trip": "Have a nice trip!",
            "email-product-simcard-purchased-important-notice": "Important Notice",
            "email-product-simcard-purchased-important-notice-content": "<span style=\"font-size: 10px; line-height: 12px;\">1. By Hong Kong Post's Local Mail, the estimated delivery will be within 5 working days. Status tracking is not available to local mail and customers shall bare the full responsibility of losing items by using Hong Kong </span><br> <span style=\"font-size: 10px; line-height: 12px;\">2. Please activate the Travel SIM card before expiry.</span><br> <span style=\"font-size: 10px; line-height: 12px;\">3. All delivered products are subject to terms and conditions.</span><br><br> <span style=\"font-size: 10px; line-height: 12px;\">Have a question? Please email to hello@hyperair.com and we will get back to you.</span>",
            "email-product-simcard-purchased-important-notice-content-esim-only": "<span style=\"font-size: 10px; line-height: 12px;\">1. By Hong Kong Post's Local Mail, the estimated delivery will be within 5 working days. Status tracking is not available to local mail and customers shall bare the full responsibility of losing items by using Hong Kong </span><br> <span style=\"font-size: 10px; line-height: 12px;\">2. Please activate the Travel SIM card before expiry.</span><br> <span style=\"font-size: 10px; line-height: 12px;\">3. All delivered products are subject to terms and conditions.</span><br><br> <span style=\"font-size: 10px; line-height: 12px;\">Have a question? Please email to hello@hyperair.com and we will get back to you.</span>",
            "email-product-simcard-purchased-important-notice-content-esim-with-sim": "<span style=\"font-size: 10px; line-height: 12px;\">1. By Hong Kong Post's Local Mail, the estimated delivery will be within 5 working days. Status tracking is not available to local mail and customers shall bare the full responsibility of losing items by using Hong Kong </span><br> <span style=\"font-size: 10px; line-height: 12px;\">2. Please activate the Travel SIM card before expiry.</span><br> <span style=\"font-size: 10px; line-height: 12px;\">3. All delivered products are subject to terms and conditions.</span><br><br> <span style=\"font-size: 10px; line-height: 12px;\">Have a question? Please email to hello@hyperair.com and we will get back to you.</span>",
            "email-product-simcard-purchased-important-notice-content-sim-only": "<span style=\"font-size: 10px; line-height: 12px;\">1. By Hong Kong Post's Local Mail, the estimated delivery will be within 5 working days. Status tracking is not available to local mail and customers shall bare the full responsibility of losing items by using Hong Kong </span><br> <span style=\"font-size: 10px; line-height: 12px;\">2. Please activate the Travel SIM card before expiry.</span><br> <span style=\"font-size: 10px; line-height: 12px;\">3. All delivered products are subject to terms and conditions.</span><br><br> <span style=\"font-size: 10px; line-height: 12px;\">Have a question? Please email to hello@hyperair.com and we will get back to you.</span>",
            "email-product-simcard-purchased-order-date": "Order Date",
            "email-product-simcard-purchased-order-details": "Order Details",
            "email-product-simcard-purchased-order-no": "Order Number",
            "email-product-simcard-purchased-personal-info": "Personal Info",
            "email-product-simcard-purchased-receipient-name": "Recipient Name",
            "email-product-simcard-purchased-receipient-phone-no": "Recipient Phone No.",
            "email-product-simcard-purchased-shipping-fee": "Shipping Fee",
            "email-product-simcard-purchased-sub-total": "Sub-total",
            "email-product-simcard-purchased-title": "Your Travel SIM order has been confirmed.",
            "email-product-simcard-purchased-title-esim-only": "Your Travel eSIM order has been confirmed.",
            "email-product-simcard-purchased-title-esim-with-sim": "Your Travel SIM order has been confirmed.",
            "email-product-simcard-purchased-title-sim-only": "Your Travel SIM order has been confirmed.",
            "email-product-simcard-purchased-total": "Total",
            "email-product-simcard-tracking-number-updated-greeting": "Dear valued customer,<br><br>Thank you again for using HyperAir. Your tracking number is updated.",
            "email-product-simcard-tracking-number-updated-title": "Your order tracking status is updated",
            "email-product-simcard-tracking-number-updated-tracking-no-sf": "Tracking Number",
            "email-product-type-confirmed-greeting": "Dear valued customer,<br><br>Thank you for using HyperAir. Your product is on its way.",
            "email-product-type-confirmed-title": "Your product is on its way",
            "email-product-type-purchased-greeting": "Dear valued customer,<br><br> Thank you for using HyperAir. We are now preparing the delivery of your product.",
            "email-product-type-purchased-title": "Your Product Purchase Order",
            "email-rate": "Rate",
            "email-shop-name": "Shop name",
            "email-verification-action": "Confirm Your Email",
            "email-verification-content": "Welcome to HyperAir! To finish signing up, you just need to confirm that we got your email right.",
            "email-verification-title": "Please confirm your email",
            "email-verified-content": "Your email is verified. Thank you for joining HyperAir.",
            "email-verified-title": "Email Verified",
            "engagement-content": "Use welcome10",
            "engagement-title": "Use welcome10",
            "exchange-approved-content": "Confirmation for buying {amount} {currency} at rate {rate}.",
            "exchange-approved-content2": "Confirmation for selling {amount} {currency} at rate {rate}.",
            "exchange-approved-footer": "",
            "exchange-approved-title": "Shop replied, \"Your travel money is ready for pickup!\"",
            "exchange-cancelled-content": "A client cancalled order for buying {amount} {currency} at rate {rate}.",
            "exchange-cancelled-content2": "A client cancelled order for selling {amount} {currency} at rate {rate}.",
            "exchange-cancelled-title": "Exchange Order Cancelled",
            "exchange-completed-content": "Completed for buying {amount} {currency} at rate {rate}.",
            "exchange-completed-content2": "Completed for selling {amount} {currency} at rate {rate}.",
            "exchange-completed-footer": "",
            "exchange-completed-title": "Your travel money exchange is completed!",
            "exchange-confirmed-content": "You confirmed a client for buying {amount} {currency} at rate {rate}.",
            "exchange-confirmed-content2": "You confirmed a client for selling {amount} {currency} at rate {rate}.",
            "exchange-confirmed-footer": "",
            "exchange-confirmed-title": "New Exchange Order Received",
            "exchange-pending-content": "Review new order for buying {amount} {currency} at rate {rate}.",
            "exchange-pending-content2": "Pending order for selling {amount} {currency} at rate {rate}.",
            "exchange-pending-title": "Pending New Order Approval",
            "exchange-rejected-content": "Order cannot be taken for buying {amount} {currency} at rate {rate}. Please book with another shop again.",
            "exchange-rejected-content2": "Order cannot be taken for selling {amount} {currency} at rate {rate}. Please book with another shop again.",
            "exchange-rejected-title": "Oops! Sorry, the shop is unable to take your order.",
            "footer-trouble-link": "If you’re having trouble clicking the \"{actionText}\" button, copy and paste the URL below into your web browser: <a href=\"{actionUrl}\">{actionUrl}</a>",
            "password-reset-action": "Reset Password",
            "password-reset-content": "You are receiving this email because we received a password reset request for your account.",
            "password-reset-footer": "If you did not request a password reset, no further action is required.",
            "password-reset-title": "Password Reset",
            "simcard-purchased-title": "",
            "sms-verification-content": "Your HyperAir Code is {verificationCode}"
        },
        "error": {
            "all-shops-are-closed": "Oops, all shops are closed right now. Please try again later.",
            "cancel-booking-failed": "This order may be completed, expired or cancelled. Please check this order in [My Bookings > Completed] or [My Bookings > Uncompleted].",
            "cancel-booking-failed-title": "Unable to cancel this order",
            "invalid-api-app-version": "Update the APP now to get the new functions and enjoy the 5% discount on Travel SIM order with promo code “GIVEME5”!!",
            "invalid-old-password": "Existing password is invalid.",
            "password-incorrect": "Incorrect password.",
            "phone-number-is-already-registered": "This phone number has already been registered with another email address. You can log in with the correct email address. Please email to hello@hyperair.com for any support.",
            "this-email-is-registered": "This email address is already used by another account.",
            "this-phone-number-is-registered": "This phone number has already been registered. Please email to hello@hyperair.com for any support."
        },
        "marketplace": {
            "homepage-product": "Popular Products",
            "homepage-recently-viewed": "Recently Viewed",
            "product-carousels": {
                "group1": "Most Popular",
                "group2": "Top Rated"
            }
        }
    },
    "en-US": {
        "currency": {
            "aed": "UAE Dirham",
            "afn": "Afghan Afghani",
            "all": "Albanian Lek",
            "amd": "Armenian Dram",
            "ang": "Netherlands Antillean Gulden",
            "aoa": "Angolan Kwanza",
            "ars": "Argentine Peso",
            "aud": "Australian Dollar",
            "awg": "Aruban Florin",
            "azn": "Azerbaijani Manat",
            "bam": "Bosnia and Herzegovina Marka",
            "bbd": "Barbadian Dollar",
            "bdt": "Bangladeshi Taka",
            "bgn": "Bulgarian Lev",
            "bhd": "Bahraini Dinar",
            "bif": "Burundi Franc",
            "bnd": "Brunei Dollar",
            "bob": "Bolivian Boliviano",
            "brl": "Brazilian Real",
            "bsd": "Bahamian Dollar",
            "btc": "Bitcoin",
            "btn": "Bhutanese Ngultrum",
            "bwp": "Botswana Pula",
            "byn": "New Belarusian Ruble",
            "bzd": "Belize Dollar",
            "cad": "Canadian Dollar",
            "cdf": "Congolese Franc",
            "chf": "Swiss Franc",
            "clp": "Chilean Peso",
            "cop": "Colombian Peso",
            "crc": "Costa Rican Colon",
            "cup": "Cuban Peso",
            "cve": "Cape Verdean Escudo",
            "czk": "Czech Koruna",
            "djf": "Djiboutian Franc",
            "dkk": "Danish Krone",
            "dop": "Dominican Peso",
            "dzd": "Algerian Dinar",
            "egp": "Egyptian Pound",
            "ern": "Eritrean Nakfa",
            "etb": "Ethiopian Birr",
            "eur": "Euro",
            "fjd": "Fijian Dollar",
            "fkp": "Falkland Islands Pound",
            "gbp": "Pound Sterling",
            "gel": "Georgian Lari",
            "ghs": "Ghanaian Cedi",
            "gip": "Gibraltar Pound",
            "gmd": "Gambian Dalasi",
            "gnf": "Guinean Franc",
            "gtq": "Guatemalan Quetzal",
            "gyd": "Guyanese Dollar",
            "hkd": "Hong Kong Dollar",
            "hnl": "Honduran Lempira",
            "hrk": "Croatian Kuna",
            "htg": "Haitian Gourde",
            "huf": "Hungarian Forint",
            "idr": "Indonesian Rupiah",
            "ils": "Israeli New Sheqel",
            "inr": "Indian Rupee",
            "iqd": "Iraqi Dinar",
            "irr": "Iranian Rial",
            "isk": "Icelandic Króna",
            "jmd": "Jamaican Dollar",
            "jod": "Jordanian Dinar",
            "jpy": "Japanese Yen",
            "kes": "Kenyan Shilling",
            "kgs": "Kyrgyzstani Som",
            "khr": "Cambodian Riel",
            "kmf": "Comorian Franc",
            "kpw": "North Korean Won",
            "krw": "South Korean Won",
            "kwd": "Kuwaiti Dinar",
            "kyd": "Cayman Islands Dollar",
            "kzt": "Kazakhstani Tenge",
            "lak": "Lao Kip",
            "lbp": "Lebanese Lira",
            "lkr": "Sri Lankan Rupee",
            "lrd": "Liberian Dollar",
            "lsl": "Lesotho Loti",
            "lvl": "Latvian Lats",
            "lyd": "Libyan Dinar",
            "mad": "Moroccan Dirham",
            "mdl": "Moldovan Leu",
            "mga": "Malagasy Ariary",
            "mkd": "Macedonian Denar",
            "mmk": "Myanma Kyat",
            "mnt": "Mongolian Tugrik",
            "mop": "Macanese Pataca",
            "mro": "Mauritanian Ouguiya",
            "mur": "Mauritian Rupee",
            "mvr": "Maldivian Rufiyaa",
            "mwk": "Malaysian Ringgit",
            "mxn": "Mexican Peso",
            "myr": "Malaysian Ringgit",
            "mzn": "Mozambican Metical",
            "nad": "Namibian Dollar",
            "ngn": "Nigerian Naira",
            "nio": "Nicaraguan Cordoba",
            "nok": "Norwegian Krone",
            "npr": "Nepalese Rupee",
            "nzd": "New Zealand Dollar",
            "omr": "Omani Rial",
            "pab": "Panamanian Balboa",
            "pen": "Peruvian Nuevo Sol",
            "pgk": "Papua New Guinean Kina",
            "php": "Philippine Peso",
            "pkr": "Pakistani Rupee",
            "pln": "Polish Zloty",
            "pyg": "Paraguayan Guarani",
            "qar": "Qatari Riyal",
            "rmb": "Renminbi",
            "ron": "Romanian Leu",
            "rsd": "Serbian Dinar",
            "rub": "Russian Ruble",
            "rwf": "Rwandan Franc",
            "sar": "Saudi Riyal",
            "sbd": "Solomon Islands Dollar",
            "scr": "Seychellois Rupee",
            "sdg": "Sudanese Pound",
            "sek": "Swedish Krona",
            "sgd": "Singapore Dollar",
            "shp": "Saint Helena Pound",
            "sll": "Sierra Leonean Leone",
            "sos": "Somali Shilling",
            "srd": "Surinamese Dollar",
            "std": "Sao Tome And Principe Dobra",
            "syp": "Syrian Pound",
            "szl": "Swazi Lilangeni",
            "thb": "Thai Baht",
            "tjs": "Tajikistani Somoni",
            "tmt": "Turkmenistan Manat",
            "tnd": "Tunisian Dinar",
            "top": "Paanga",
            "try": "Turkish New Lira",
            "ttd": "Trinidad and Tobago Dollar",
            "twd": "New Taiwan Dollar",
            "tzs": "Tanzanian Shilling",
            "uah": "Ukrainian Hryvnia",
            "ugx": "Ugandan Shilling",
            "usd": "US Dollar",
            "uyu": "Uruguayan Peso",
            "uzs": "Uzbekistani Som",
            "vef": "Venezuelan Bolivar",
            "vnd": "Vietnamese Dong",
            "vuv": "Vanuatu Vatu",
            "wst": "Samoan Tala",
            "xaf": "Central African CFA Franc",
            "xcd": "East Caribbean Dollar",
            "xdr": "Special Drawing Rights",
            "xof": "West African CFA Franc",
            "xpf": "CFP Franc",
            "yer": "Yemeni Rial",
            "zar": "South African Rand",
            "zmw": "Zambian Kwacha"
        },
        "shop-currency-rate": {
            "rate-last-updated-x-days-ago": "Rate updated {time} days ago",
            "rate-last-updated-x-hours-ago": "Rate updated {time} hours ago"
        },
        "hyperair": {
            "copyright-footer": "Copyright © 2018 HyperAir Incorporation Limited. All Rights Reserved.",
            "today": "Today"
        },
        "product-simcard": {
            "shipping-methods": {
                "hkpost": "Hong Kong Post (Free)",
                "international": "International Shipping",
                "sf": "SF Express (Hong Kong only. Courier fee payable on delivery. Free Shipping for orders over HK$399)"
            }
        },
        "country": {
            "afghanistan": "Afghanistan",
            "aland-islands": "Aland Islands",
            "albania": "Albania",
            "algeria": "Algeria",
            "andorra": "Andorra",
            "angola": "Angola",
            "anguilla": "Anguilla",
            "antigua-&-barbuda": "Antigua & Barbuda",
            "antigua-barbuda": "Antigua and Barbuda",
            "argentina": "Argentina",
            "armenia": "Armenia",
            "aruba": "Aruba",
            "australia": "Australia",
            "austria": "Austria",
            "azerbaijan": "Azerbaijan",
            "azores": "Azores",
            "bahamas": "Bahamas",
            "bahrain": "Bahrain",
            "bangladesh": "Bangladesh",
            "barbados": "Barbados",
            "belarus": "Belarus",
            "belgium": "Belgium",
            "belize": "Belize",
            "benin": "Benin",
            "bermuda": "Bermuda",
            "bhutan": "Bhutan",
            "bolivia": "Bolivia",
            "bonaire": "Bonaire",
            "bosnia-herzegovina": "Bosnia & Herzegovina",
            "botswana": "Botswana",
            "brazil": "Brazil",
            "british-virgin-islands": "British Virgin Islands",
            "brunei": "Brunei",
            "bulgaria": "Bulgaria",
            "burkina-faso": "Burkina Faso",
            "burundi": "Burundi",
            "cambodia": "Cambodia",
            "cameroon": "Cameroon",
            "canada": "Canada",
            "canary-islands": "Canary Islands",
            "cape-verde-islands": "Cape Verde Islands",
            "cayman-islands": "Cayman Islands",
            "central-african-republic": "Central African Republic",
            "chad": "Chad",
            "chile": "Chile",
            "china": "China",
            "colombia": "Colombia",
            "comoros": "Comoros",
            "congo": "Congo",
            "cook-islands": "Cook Islands",
            "costa-rica": "Costa Rica",
            "cote-d-ivoire": "Cote D Ivoire",
            "croatia": "Croatia",
            "cruise-ship": "Cruise Ship",
            "cuba": "Cuba",
            "curacao": "Curacao",
            "cyprus": "Cyprus",
            "cyprus---north": "Cyprus",
            "cyprus---south": "Cyprus",
            "czech-republic": "Czech Republic",
            "denmark": "Denmark",
            "djibouti": "Djibouti",
            "dominica": "Dominica",
            "dominican-republic": "Dominican Republic",
            "dubai": "Dubai",
            "easter-island": "Easter Island",
            "ecuador": "Ecuador",
            "egypt": "Egypt",
            "el-salvador": "El Salvador",
            "equatorial-guinea": "Equatorial Guinea",
            "eritrea": "Eritrea",
            "estonia": "Estonia",
            "ethiopia": "Ethiopia",
            "europe": "Europe",
            "falkland-islands": "Falkland Islands",
            "faroe-islands": "Faroe Islands",
            "fiji": "Fiji",
            "finland": "Finland",
            "france": "France",
            "french-guiana": "French Guiana",
            "french-polynesia": "French Polynesia",
            "french-west-indies": "French West Indies",
            "gabon": "Gabon",
            "gambia": "Gambia",
            "georgia": "Georgia",
            "germany": "Germany",
            "ghana": "Ghana",
            "gibraltar": "Gibraltar",
            "greece": "Greece",
            "greenland": "Greenland",
            "grenada": "Grenada",
            "guadeloupe": "Guadeloupe",
            "guam": "Guam",
            "guatemala": "Guatemala",
            "guernsey": "Guernsey",
            "guinea": "Guinea",
            "guinea---bissau": "Guinea Bissau",
            "guinea-bissau": "Guinea-Bissau",
            "guyana": "Guyana",
            "haiti": "Haiti",
            "honduras": "Honduras",
            "hong-kong": "Hong Kong",
            "hungary": "Hungary",
            "iceland": "Iceland",
            "india": "India",
            "indonesia": "Indonesia",
            "iran": "Iran",
            "iraq": "Iraq",
            "ireland": "Ireland",
            "isle-of-man": "Isle of Man",
            "israel": "Israel",
            "italy": "Italy",
            "jamaica": "Jamaica",
            "japan": "Japan",
            "jersey": "Jersey",
            "jordan": "Jordan",
            "kazakhstan": "Kazakhstan",
            "kenya": "Kenya",
            "kiribati": "Kiribati",
            "kosovo": "Kosovo",
            "kuwait": "Kuwait",
            "kyrgyz-republic": "Kyrgyz Republic",
            "kyrgyzstan": "Kyrgyzstan",
            "laos": "Laos",
            "latvia": "Latvia",
            "lebanon": "Lebanon",
            "lesotho": "Lesotho",
            "liberia": "Liberia",
            "libya": "Libya",
            "liechtenstein": "Liechtenstein",
            "lithuania": "Lithuania",
            "luxembourg": "Luxembourg",
            "macau": "Macau",
            "macedonia": "Macedonia",
            "madagascar": "Madagascar",
            "madeira": "Madeira",
            "malawi": "Malawi",
            "malaysia": "Malaysia",
            "maldives": "Maldives",
            "mali": "Mali",
            "malta": "Malta",
            "marshall-islands": "Marshall Islands",
            "martinique": "Martinique",
            "mauritania": "Mauritania",
            "mauritius": "Mauritius",
            "mayotte": "Mayotte",
            "mexico": "Mexico",
            "micronesia": "Micronesia",
            "moldova": "Moldova",
            "monaco": "Monaco",
            "mongolia": "Mongolia",
            "montenegro": "Montenegro",
            "montserrat": "Montserrat",
            "morocco": "Morocco",
            "mozambique": "Mozambique",
            "myanmar": "Myanmar",
            "namibia": "Namibia",
            "nauru": "Nauru",
            "nepal": "Nepal",
            "netherlands": "Netherlands",
            "netherlands-antilles": "Netherlands Antilles",
            "new-caledonia": "New Caledonia",
            "new-zealand": "New Zealand",
            "nicaragua": "Nicaragua",
            "niger": "Niger",
            "nigeria": "Nigeria",
            "niue": "Niue",
            "norfolk-islands": "Norfolk Islands",
            "north-korea": "North Korea",
            "northern-marianas": "Northern Marianas",
            "norway": "Norway",
            "oman": "Oman",
            "pakistan": "Pakistan",
            "palau": "Palau",
            "palestine": "Palestine",
            "panama": "Panama",
            "papua-new-guinea": "Papua New Guinea",
            "paraguay": "Paraguay",
            "peru": "Peru",
            "philippines": "Philippines",
            "poland": "Poland",
            "portugal": "Portugal",
            "puerto-rico": "Puerto Rico",
            "qatar": "Qatar",
            "reunion": "Reunion",
            "romania": "Romania",
            "russia": "Russia",
            "rwanda": "Rwanda",
            "saint-barthelemy": "Saint Barthelemy",
            "saint-martin": "Saint Martin",
            "saint-pierre-&-miquelon": "Saint Pierre & Miquelon",
            "samoa": "Samoa",
            "san-marino": "San Marino",
            "sao-tome-&-principe": "Sao Tome & Principe",
            "sao-tome-principe": "São Tomé and Príncipe",
            "satellite": "Satellite",
            "saudi-arabia": "Saudi Arabia",
            "senegal": "Senegal",
            "serbia": "Serbia",
            "seychelles": "Seychelles",
            "sierra-leone": "Sierra Leone",
            "singapore": "Singapore",
            "slovak-republic": "Slovak Republic",
            "slovakia": "Slovakia",
            "slovenia": "Slovenia",
            "solomon-islands": "Solomon Islands",
            "somalia": "Somalia",
            "south-africa": "South Africa",
            "south-korea": "South Korea",
            "spain": "Spain",
            "sri-lanka": "Sri Lanka",
            "st-helena": "Saint Helena",
            "st-kitts": "Saint Kitts",
            "st-kitts-&-nevis": "St Kitts & Nevis",
            "st-lucia": "St Lucia",
            "st-vincent": "St Vincent",
            "st.-helena": "St. Helena",
            "st.-kitts": "St. Kitts",
            "st.-lucia": "St. Lucia",
            "sudan": "Sudan",
            "suriname": "Suriname",
            "swaziland": "Swaziland",
            "sweden": "Sweden",
            "switzerland": "Switzerland",
            "syria": "Syria",
            "taiwan": "Taiwan",
            "tajikistan": "Tajikistan",
            "tanzania": "Tanzania",
            "thailand": "Thailand",
            "timor-l'este": "Timor L'Este",
            "togo": "Togo",
            "tonga": "Tonga",
            "trinidad-&-tobago": "Trinidad & Tobago",
            "trinidad-tobago": "Trinidad and Tobago",
            "tunisia": "Tunisia",
            "turkey": "Turkey",
            "turkmenistan": "Turkmenistan",
            "turks-&-caicos": "Turks & Caicos",
            "turks-&-caicos-islands": "Turks & Caicos Islands",
            "turks-caicos-islands": "Turks and Caicos Islands",
            "uganda": "Uganda",
            "ukraine": "Ukraine",
            "united-arab-emirates": "United Arab Emirates",
            "united-kingdom": "United Kingdom",
            "united-states": "United States",
            "united-states-minor-outlying-islands": "United States Minor Outlying Islands",
            "uruguay": "Uruguay",
            "uzbekistan": "Uzbekistan",
            "vanuatu": "Vanuatu",
            "vatican-city": "Vatican City",
            "venezuela": "Venezuela",
            "vietnam": "Vietnam",
            "virgin-islands": "Virgin Islands",
            "virgin-islands-(us)": "Virgin Islands (US)",
            "wallis-&-futuna": "Wallis & Futuna",
            "wallis-futuna": "Wallis and Futuna",
            "yemen": "Yemen",
            "zambia": "Zambia",
            "zimbabwe": "Zimbabwe"
        },
        "inspiration": {
            "published-date": "M Y",
            "published-duration": "{duration} days before",
            "published-duration-singular": "Yesterday",
            "published-duration-today": "Today"
        },
        "promotion-center": {
            "expires-at": "Expires on",
            "redeem": {
                "error": {
                    "already-redeemed": "You have already redeemed the coupon.",
                    "new-customer-only": "Offer is valid for new customer only.",
                    "not-found": "Invalid Promotion Code"
                }
            }
        },
        "auth": {
            "failed": "These credentials do not match our records.",
            "throttle": "Too many login attempts. Please try again in {seconds} seconds."
        },
        "web": {
            "activity": {
                "countdown-title": "",
                "more-button": "More tour and tickets",
                "section-subtitle": "Find the cheapest tour and tickets in Singapore",
                "section-title": "Tour and Tickets"
            },
            "checkout": {
                "use-promo-code": "Use Promotion Code"
            },
            "checkout-failed": {
                "checkout-failed": "Payment Failed, please try again later"
            },
            "checkout-success": {
                "checkout-success": "Payment Success",
                "continue-shopping-button": "Continue shopping",
                "done-button": "Done👌🏻",
                "download-now": "Download Now",
                "order-number": "Order Number",
                "register-email": "Your email",
                "register-password": "Set your password",
                "sim-product": "Successfully purchased <span class=\"bold\"> {sim} </span>. The confirmation email has been sent to {email}.",
                "slogan": "Open HyperAir app to enjoy the exclusive privileges! You can also have the real time order tracking in the App!",
                "slogan-password": "One more step! You can enjoy HK$10 Welcome SIM card coupon and real time order tracking in the App!",
                "trace-order": "",
                "trace-order-password": "",
                "welcome-offer": "One more step! You can enjoy HK$10 Welcome SIM card coupon and real time order tracking in the App!"
            },
            "country": {
                "all": "ALL",
                "contact-us-description": "如有任何疑問，歡迎發送電郵到<a href=\"mailto:corporate@hyperair.com\\>corporate@hyperair.com</a>查詢",
                "data": "Data Limit:",
                "day": "Day(s):",
                "day-day": "Day(s)",
                "esim": "eSIM",
                "esim-section-title": "Best eSIM for {country}",
                "num-of-review": "{num}-of-review ratings",
                "per-day": "day",
                "phone-call": "Phone Call",
                "plug-n-go": "",
                "plug-n-go-esim": "Instant buy and use",
                "plug-n-go-sim": "Plug and use",
                "section-title": "Best SIM card for {country}",
                "section-title copy": "Best SIM card for {country}",
                "sim": "SIM",
                "supplier": "Provider:"
            },
            "download-app-banner": {
                "download-now": "Download App Now",
                "hyperair": "HyperAir",
                "subtitle": "Download & register HyperAir App to enjoy HK$10 welcome offer!",
                "title": "Travel Smarter. Anywhere."
            },
            "email-subscription": {
                "cancel-button": "Let me think about it",
                "completed-subscribe": "Thank you for subscribing!",
                "confirm-button": "Get the best offer",
                "duplicate-email": "This email address has already subscribed",
                "invalid-email": "Invalid email address",
                "title-1": "Wanna be notified when Staycation drops to a record low?",
                "title-2": "Finds the best staycation and gourmet discounted package in the city"
            },
            "fanfare": {
                "cover-title": "SIM Card Offer",
                "datetime-format": "j M",
                "end-next-fanfare": "Upcoming SIM Card Offer:",
                "end-title": "Stay tuned to our App & social media for the next SIM Offers",
                "end-title2": "Stay Tuned to our APP & social media platforms for the next SIM Card Offer",
                "more-details-button": "More Details",
                "out-of-stock": "Sold Out",
                "popular-countries-subtitle": "Free Surface Mail, Speedy Delivery",
                "popular-countries-title": "Popular SIM Cards",
                "section-title": "SIM Cards at super discounted prices",
                "title": "Limited Time | Limited Cards",
                "x-inventory-left": "Last {inventory}"
            },
            "fanfare-breadcrumb": "SIM Card Offer",
            "filter-button": {
                "filter": "Filter"
            },
            "filter-container": {
                "apply": "Apply",
                "category": "Category",
                "category-aquarium": "Aquarium",
                "category-class": "Class",
                "category-day-tour": "Day Tour",
                "category-discount": "Discount",
                "category-diving": "Diving",
                "category-food": "Food",
                "category-massage-beauty": "Massage and Beauty",
                "category-museum": "Museum",
                "category-musical": "Musical",
                "category-outlet": "Outlet",
                "category-photography": "Photography",
                "category-playground": "Playground",
                "category-railway": "Railway",
                "category-show": "Show",
                "category-ski": "Ski",
                "category-spa": "Hotspring",
                "category-theme-park": "Theme Park",
                "category-ticket": "Ticket",
                "category-transport": "Transport",
                "category-transport-ticket": "Transport Ticket",
                "category-vr": "VR",
                "category-water-park": "Water Park",
                "category-yoga": "Yoga",
                "category-zoo": "Zoo",
                "clear-all": "Reset",
                "facilities": "Services & facilities",
                "filter": "Filter",
                "food": "Food",
                "header": "Filter",
                "popular-search": "Popular Search🔥",
                "price": "Price",
                "provider": "Travel Site",
                "subcategory-buffet": "Buffet",
                "subcategory-car": "Car",
                "subcategory-facial": "Facial",
                "subcategory-food": "Food",
                "subcategory-half-day-tour": "Half Day Tour",
                "subcategory-massage": "Spa & Massage",
                "subcategory-meal-voucher": "Meal Voucher",
                "subcategory-one-day-tour": "One Day Tour",
                "subcategory-restaurant": "Restaurant",
                "subcategory-transport": "Transportation",
                "tag": "Tag"
            },
            "footer": {
                "about-hyperair-description": "HyperAir is an intelligent travel platform to your liking, offering the most suitable and value-for-money travel solution, so that you can travel smarter, anywhere.",
                "download-now": "Download Now",
                "email-subscription-button": "Subscribe",
                "email-subscription-placeholder": "Enter your email",
                "email-subscription-social-title": "or Follow our Facebook and Instagram",
                "email-subscription-title": "Subscribe to get the latest staycation discount",
                "travel-license": "Travel Agent Licence Number："
            },
            "fx-booking": {
                "back-button": "更改訂單",
                "confirm-booking": "核對資料",
                "confirm-button": "確認訂單",
                "contact-shop": "如果您無法準時到達，請致電兌換店或取消訂單。",
                "get-money-before": "請於以下時間前提取。"
            },
            "home": {
                "cover-button": "Experience Now",
                "cover-subtitle": "Open yourself to a new world of HyperAir",
                "cover-title": "Explore what's fun.",
                "grid": {
                    "1": {
                        "subtitle": "Latest Inspiration",
                        "title": "Cat Residents in Turkish Church"
                    },
                    "2": {
                        "subtitle": "Latest Inspiration",
                        "title": "Tokyo Olympics 2020 1 Year To Go"
                    },
                    "3": {
                        "subtitle": "Hot Picks",
                        "title": "Online Best Price Guarantee"
                    },
                    "4": {
                        "subtitle": "Limited Time Offer",
                        "title": "SIM Card Fanfares"
                    },
                    "5": {
                        "subtitle": "Popular Destination",
                        "title": "Sneak Peek of Disneyland Galaxy's Edge"
                    }
                },
                "home-example": {
                    "column-subtitle-1": "7-day Japan trip for 2 people:",
                    "column-subtitle-2": "Price Comparison",
                    "column-title-1": "Maximize your saving in one trip",
                    "column-title-2": "Compare various online travel agencies",
                    "hotel": "Hotel Rewards",
                    "hotel-package-1": "Hotel Nikko Osaka x6 nights",
                    "insurance": "Travel Insurance",
                    "insurance-package-1": "7-Day Travel Insurance x2",
                    "money": "Travel Moeny",
                    "money-package-1": "Exchange JPD ¥ 410,000",
                    "save": "Save",
                    "sim": "Travel SIM",
                    "sim-package-1": "Japan 7-Day DoCoMo SIM x2",
                    "slogan": "Compare before booking, save money for your next trip!",
                    "total-saving": "Total Savings $ 1,443",
                    "travel-experience": "Experience",
                    "travel-experience-package-1": "JR Pass for Whole Japan x2",
                    "travel-experience-package-2": "Universal Studios eTicket x2"
                },
                "media-header-title": "Press",
                "more": "More Travel SIM",
                "partners-title": "Partnership",
                "photo-banner-button": "Learn more",
                "photo-banner-title": "Exchange travel money smarter",
                "services-header-description": "",
                "services-header-title": "One-stop Travel Services",
                "services-icon-subtitle-1": "Help you to get travel money smarter!",
                "services-icon-subtitle-2": "Offer you the best SIM cards with free delivery!",
                "services-icon-subtitle-3": "Allow you to explore the world with tailored solution!",
                "services-icon-title-1": "Travel Money",
                "services-icon-title-2": "Travel SIM",
                "services-icon-title-3": "Tours and Tickets",
                "statistic": {
                    "num-of-city": "Saved by Customers",
                    "num-of-comparison": "Experience and Tours",
                    "num-of-experience": "Countries and Cities",
                    "num-of-saving": "Comparisons"
                },
                "testimonial-1-content": "呢個app很好用，方便比較滙率，唔駛周圍去揾資料。很欣賞程式員佢地既用心製作，佢地都很積極用心為我解決使用時的困難。推薦使用！",
                "testimonial-1-subtitle": "Android User",
                "testimonial-1-user": "Christine Lam",
                "testimonial-2-content": "好方便，訂SIM卡好快就送到，唔洗特登出街買SIM卡，價錢都好平吓。網絡收得幾好，上次去日本喺市區同近郊玩都好流暢！下次會再買！",
                "testimonial-2-subtitle": "iOS User",
                "testimonial-2-user": "Angel",
                "testimonial-header-description": "",
                "testimonial-header-title": "Customer Testimonials",
                "travel-activities": {
                    "home-slogan": "Compare and find your best travel experience from different websites"
                },
                "travel-country-header-description": "Clear Classification, Easy to Pick",
                "travel-country-header-title": "Travel SIM covers 200+ countries",
                "travel-info-header-description": "Bring you the red-hot travel inspiration",
                "travel-info-header-title": "Travel Inspiration",
                "travel-marketplace-header-description": "",
                "travel-marketplace-header-title": "",
                "travel-sim-header-description": "Best SIM card deals with free shipping",
                "travel-sim-header-title": "Popular Travel SIM"
            },
            "hotel": {
                "cover-subtitle": "Enjoy 5% exclusive Trip.com hotel booking offer",
                "cover-title": "Hotel Rewards",
                "discount-detail": "Apply promo code \"HYPERAIR5\" to enjoy 5% hotel booking offer",
                "discount-title": "HYPERAIR5",
                "highlight-subtitle1": "Discover hotels around the world for a unique stay.",
                "highlight-subtitle2": "Get the best deals and save your money for the next travel.",
                "highlight-subtitle3": "Check the hotel rates anytime anywhere.",
                "highlight-title1": "Global Coverage",
                "highlight-title2": "Exclusive Privileges",
                "highlight-title3": "One-click Booking"
            },
            "hypermiles": {
                "activity": "Activity",
                "balance": "Outstanding Balance",
                "benefit": "Your Privileges",
                "cumulative-purchase": "Accumulated Spending：HK$ {amount}",
                "diamond-black": "Diamond Black",
                "expire": "Expired HyperMiles ({date})",
                "expire-reminder-1": "HyperMiles is valid for one year from the shopping month",
                "expire-reminder-2": "Remember to use HyperMiles before expiry!",
                "hypermiles-total": "HyperMiles",
                "member": "Member",
                "member-tier": "You have become HyperAir {member_tier} member",
                "membership-details": "Membership Tier",
                "next-purchase": "save HK${amount} in your next purchase",
                "order-num": "Order No: {order_num}",
                "permanent-membership": "Permanent Membership",
                "popup-title": "HyperMiles Reward Scheme",
                "precious-platinum": "Precious Platinum",
                "product_purchase": "HyperMiles from gadgets purchase ({date})",
                "record": "HyperMiles Record",
                "royal-blue": "Royal Blue",
                "simcard_purchase": "HyperMiles from SIM purchase ({date})",
                "tier": "",
                "title": "HyperMiles. Explore the World, Enjoy the rebate!",
                "u-have": "Your have",
                "usage": "Redeemed HyperMiles",
                "what-is-hypermiles": "What is HyperMiles",
                "what-is-hypermiles-slogan1": "Spend more. Earn more!",
                "what-is-hypermiles-slogan2": "Every 100 HyperMiles can be used as HK$1 at checkout, no minimum spending limit",
                "what-is-hypermiles-slogan3": "Spend more at HyperAir to enjoy more privileges"
            },
            "hypermiles-disclaimer": "terms and conditions apply",
            "hypermiles-discount-diamond-black": "Spend every HK$1 to enjoy 1 HyperMiles",
            "hypermiles-discount-precious-platinum": "Spend every HK$1.5 to enjoy 1 HyperMiles",
            "hypermiles-discount-royal-blue": "Spend every HK$2 to enjoy 1 HyperMiles",
            "hypermiles-special-diamond-black": "Exclusive pre-sale offer",
            "hypermiles-spend-diamond-black": "Cumulative spending of HK$3,000",
            "hypermiles-spend-precious-platinum": "Cumulative spending of HK$1,500",
            "hypermiles-spend-royal-blue": "Basic Member",
            "login": {
                "email": "Email",
                "existing-user": "Existing User",
                "forgot-password": "Forgot Password",
                "forgot-password-please-fill-in-email": "Enter your email and we'll send you a link to get back into your account.",
                "login": "Login",
                "login-with-facebook": "Continue with Facebook",
                "login-with-google": "Continue with Google",
                "new-user": "New User",
                "or": "Or",
                "password": "Password",
                "phone-input-placeholder": "Enter your Phone Number",
                "phone-input-title": "Input Your Phone Number.",
                "phone-verify": "Phone Verification",
                "resend-verification-code": "Resend After 30s",
                "reset-password": "Reset Password",
                "title": "Login",
                "verification-code-input-title": "Input Your Verification Code."
            },
            "logo-loader": {
                "slogan": "We're almost there"
            },
            "my-order": {
                "amount": "Amount",
                "esim-qrcode": "eSIM Code",
                "fx-status-cancelled": "Cancelled",
                "fx-status-confirmed": "Confirmed",
                "order-date": "Order Date",
                "order-details": "Order Details",
                "order-num": "Order Number",
                "status-confirmed": "Shipped",
                "status-pending-confirmation": "Ready To Ship",
                "status-ready-to-ship": "Ready To Ship",
                "status-shipped": "Shipped"
            },
            "my-order-details": {
                "delivery-info": "Delivery Info",
                "discount": "Discount",
                "recipient-address": "Address",
                "recipient-email": "Email",
                "recipient-name": "Recipient Name",
                "recipient-tel": "Recipient Tel",
                "shipping-method": "Shipping Method",
                "status": "Status",
                "total": "Total",
                "valid-date": "Valid Date"
            },
            "nav": {
                "about-us": "About Us",
                "car": "Cars",
                "company": "Company",
                "company-address": "Entrepreneurship Centre, Level 3, Cyberport 3, Hong Kong",
                "contact-us": "Contact Us",
                "contact-us-description": "Please email to <a href=\"mailto:hello@hyperair.com\">hello@hyperair.com</a> for any enquiries.",
                "disclaimer": "Disclaimer",
                "download-app": "Download App",
                "flight": "Flights",
                "foodie": "Foodie",
                "home": "Home",
                "hotel": "Hotel",
                "jobs": "Recruitment",
                "logout": "Logout",
                "media-coverage": "Press",
                "monthly-rental-hotel": "Monthly Rental Hotel",
                "privacy-policy": "Privacy Policy",
                "promo-banner-text": "HyperAir 客戶專享 5% Trip.com 獨家酒店折扣",
                "quarantine-hotel": "Long Stay Hotel",
                "refund-policy": "Refund Policy",
                "spa-and-beauty": "Spa and Beauty",
                "staycation": "Staycation",
                "tag-line": "Compare Travel Sites & Save Money",
                "terms-of-service": "Terms of Service",
                "travel-activity": "Travel Activity",
                "travel-affiliate-codes": "Coupons",
                "travel-affiliate-codes-md": "Coupons",
                "travel-blog": "Blog",
                "travel-experience-d": "Tours and Tickets",
                "travel-experience-md": "Tours and Tickets",
                "travel-insurance": "Travel Insurance",
                "travel-insurance-md": "Insurance",
                "travel-marketplace": "Travel Gadgets",
                "travel-marketplace-md": "Travel Gadgets",
                "travel-money": "Travel Money",
                "travel-money-md": "Money",
                "travel-sim": "Travel SIM",
                "travel-sim-md": "SIM"
            },
            "photo-banner": {
                "banner-button": ""
            },
            "product-card": {
                "num-of-review": "{num}-of-review ratings"
            },
            "redirection-gate": {
                "columns-1-description": "Compare the best travel experience from different websites",
                "columns-1-title": "Travel Activity Comparison",
                "columns-2-description": "Best SIM card deals with free shipping!",
                "columns-2-title": "Travel SIM",
                "columns-3-description": "Compare and book the best FX rate in town",
                "columns-3-title": "Travel Money",
                "promo-code": "Code",
                "remember-to-fill-promo-code": "Remember to apply the above promo code before checkout",
                "title": "We are taking you to {domain}",
                "trouble-link": "If the browser does not redirect you in 10 seconds, please click this <a href=\"{link}\">link</a>."
            },
            "register": {
                "guest-checkout": "Guest Checkout",
                "title": "Register"
            },
            "seo": {
                "best-price-guarantee-title": "Best Price Guarantee",
                "country-description": "{country} Travel SIM - Best Price Guarantee with Free Shipping",
                "country-keywords": "SIM卡,上網卡,電話卡,數據卡,DataSIM,旅遊DataSIM,數據咭,4G上網卡,上網卡,4G上網卡,日本4G上網卡,日本上網卡,東京4G上網卡,東京上網卡,大阪4G上網卡,大阪上網卡,泰國4G上網卡,泰國上網卡,曼谷4G上網卡,布吉上網卡,芭提雅4G上網卡,台灣4G上網卡,台灣上網卡,台北4G上網卡,高雄上網卡,台中4G上網卡,台中上網卡,韓國4G上網卡,韓國上網卡,首爾4G上網卡,首爾上網卡,中國4G上網卡,中國上網卡,深圳4G上網卡,深圳上網卡,澳門4G上網卡,澳門上網卡, Docomo, Softbank",
                "country-title": "{country} Travel SIM - Best Price Guarantee with Free Shipping",
                "home-description": "HyperAir is an intelligent travel platform to your liking, offering the most suitable and value-for-money travel solution, so that you can travel smarter, anywhere.",
                "home-keywords": "sim卡,上網卡,電話卡,數據卡,DataSIM,旅遊DataSIM,數據咭,4G上網卡,上網卡,4G上網卡,SIM卡,Travel SIM,旅遊SIM卡,唱錢神器,唱X神器,唱錢X器,唱錢,唱錢app,兌換,找換,兌換店,找換店,銀行,金融,外匯,外滙,匯率,滙率,匯款,外幣,貨幣,旅行,旅遊,行程,酒店,機票,比較,格價,特價,預訂,交易,旅遊保險,日本,泰國,韓國,台灣,日圓,日元,台幣,泰銖,HyperAir,HyperAir FX,HyperAir Travel,Travel,Travel Money,Foreign Currency,Foreign Exchange,百年,堅成,發達鳥,飛鳥,richbird,crazy bird,berlin exchange",
                "home-title": "‎HyperAir - Best Travel Comparison & Search Engine | Experience, Hotel, SIM, Exchange, Travel Insurance",
                "hotel-description": "Get extra hotel booking offers via HyperAir.com",
                "hotel-keywords": "hotel, hotels, discount, reservations, Asia, Europe, America, Bangkok, Singapore, Hong Kong, Phuket, Thailand, Malaysia, Bali, London, Paris, loyalty program, acommodation, accomodation, acomodation, accommodation, vacation rentals",
                "hotel-title": "Hotel Offers",
                "money-exchange-description": "Check {shop_name}'s latest FX rate and book your travel money online. You can lock in FX rate and reserve foreign currency.",
                "money-exchange-keywords": "{shop_name}, 唱錢神器, 唱X神器, 唱錢X器, 唱錢, 兌換, 找換, 兌換店, 找換店, 銀行, 金融, 外匯, 外滙, 匯率, 滙率, 匯款, 外幣, 貨幣, 旅行, 旅遊, 行程, 酒店, 機票, 比較, 格價, 特價, 預訂, 交易, 旅遊保險, 日本, 泰國, 韓國, 台灣, 日圓, 日元, 台幣, 泰銖, HyperAir, HyperAir FX, HyperAir Travel, Travel, Travel Money, Foreign Currency, Foreign Exchange, 百年, 堅成, 發達鳥, 飛鳥, richbird, crazy bird, berlin exchange",
                "money-exchange-title": "{shop_name}'s latest FX rate with instant booking | Lock in FX rate and reserve your travel money instantly",
                "privacy-policy-title": "Privacy Policy",
                "refund-policy-title": "Refund & Return Policy",
                "sim-fanfares-description": "HyperAir has launched the first SIM Card Fanfares in Hong Kong. You can purchase SIM cards for your trip with discount up to 50% off. Limited Time, Limited Offer !",
                "sim-fanfares-keywords": "fanfares,simcard, sim card, SIM卡,上網卡,電話卡,數據卡,DataSIM,旅遊DataSIM,數據咭,4G上網卡,上網卡,4G上網卡,日本4G上網卡,日本上網卡,東京4G上網卡,東京上網卡,大阪4G上網卡,大阪上網卡,泰國4G上網卡,泰國上網卡,曼谷4G上網卡,布吉上網卡,芭提雅4G上網卡,台灣4G上網卡,台灣上網卡,台北4G上網卡,高雄上網卡,台中4G上網卡,台中上網卡,韓國4G上網卡,韓國上網卡,首爾4G上網卡,首爾上網卡,中國4G上網卡,中國上網卡,深圳4G上網卡,深圳上網卡,澳門4G上網卡,澳門上網卡, Docomo, Softbank",
                "sim-fanfares-title": "SIM Card Fanfares - Limited Time, Limited Cards",
                "term-of-service-title": "Terms of Service",
                "travel-activity-search-results-description": "Compare prices and find an amazing deal for {activity}. Save more on travel with HyperAir now!",
                "travel-activity-search-results-keywords": "{activity}, travel, local experience, local activity, ticket, activities, day tours, tourist attractions",
                "travel-activity-search-results-title": "HyperAir - Search Result of {q} in {city}",
                "travel-affiliate-codes-description": "HyperAir continuously updates the latest discount codes / promotion codes for booking hotel discounts, air ticket discounts, activity discounts, travel insurance discounts, SIM card discounts and credit card discounts.",
                "travel-affiliate-codes-keywords": "Discount Code, Electronic Coupon, Discount Code, Promotion Code, Promo Code, Discount Code, Hotel, Air Ticket, Offer, Credit Card Offer, Travel Offer",
                "travel-affiliate-codes-title": "2023 Latest Travel Discount Codes (Daily Updates) | Discount booking for hotels, flights, activities, travel insurance, Data SIM",
                "travel-insurance-description": "Search for the best Travel Insurance plans? Which plans cover mobile phones? Compare insurance plans from companies like AIG, MSIG and Starr, and buy online with extra discount !",
                "travel-insurance-keywords": "AIG, MSIG, Starr, AIG Promocode, MSIG Promocode, Starr Promocode, Travel Insurance, travel insurance online, compare Travel Insurance, cheap travel insurance, travel insurance hong kong, single trip, annual plan",
                "travel-insurance-title": "Best Travel Insurance Rates & Comparisons in Hong Kong 2023",
                "travel-marketplace-checkout-payme-title": "Pay with PayMe",
                "travel-marketplace-checkout-success-keywords": "創意, 產品, 流行, 電器, 生活, 精品, 智能家居, 設計, 高品質, 設計概念, 創意科技, 生活用品, 戶外休閒, 廚房, 餐桌, 個人護理, 防疫抗疫, 健康, 遊戲, 兒童玩樂, 健身, 家居健身, gym, home gym, smart home, style home",
                "travel-marketplace-checkout-success-title": "Payment Success",
                "travel-marketplace-description": "A collection of coolest gadgets that you'll like",
                "travel-marketplace-keywords": "創意, 產品, 流行, 電器, 生活, 精品, 智能家居, 設計, 高品質, 設計概念, 創意科技, 生活用品, 戶外休閒, 廚房, 餐桌, 個人護理, 防疫抗疫, 健康, 遊戲, 兒童玩樂, 健身, 家居健身, gym, home gym, smart home, style home",
                "travel-marketplace-product-checkout-title": "{product}",
                "travel-marketplace-product-title": "{product}",
                "travel-marketplace-title": "Travel Gadgets",
                "travel-money-description": "HyperAir provides you a brand new way to get travel money. Now you can book the exchange online with the best in town exchange rate!",
                "travel-money-keywords": "sim卡,上網卡,電話卡,數據卡,DataSIM,旅遊DataSIM,數據咭,4G上網卡,上網卡,4G上網卡,唱錢神器,唱X神器,唱錢X器,唱錢,兌換,找換,兌換店,找換店,銀行,金融,外匯,外滙,匯率,滙率,匯款,外幣,貨幣,旅行,旅遊,行程,酒店,機票,比較,格價,特價,預訂,交易,旅遊保險,日本,泰國,韓國,台灣,日圓,日元,台幣,泰銖,HyperAir,HyperAir FX,HyperAir Travel,Travel,Travel Money,Foreign Currency,Foreign Exchange,百年,堅成,發達鳥,飛鳥,richbird,crazy bird,berlin exchange",
                "travel-money-title": "HyperAir - Exchange Travel Money Smarter.",
                "travel-product-checkout-keywords": "創意, 產品, 流行, 電器, 生活, 精品, 智能家居, 設計, 高品質, 設計概念, 創意科技, 生活用品, 戶外休閒, 廚房, 餐桌, 個人護理, 防疫抗疫, 健康, 遊戲, 兒童玩樂, 健身, 家居健身, gym, home gym, smart home, style home",
                "travel-product-keywords": "創意, 產品, 流行, 電器, 生活, 精品, 智能家居, 設計, 高品質, 設計概念, 創意科技, 生活用品, 戶外休閒, 廚房, 餐桌, 個人護理, 防疫抗疫, 健康, 遊戲, 兒童玩樂, 健身, 家居健身, gym, home gym, smart home, style home",
                "travel-sim-checkout-description": "{country} Travel SIM - High-quality SIM card with free shipping to your door!",
                "travel-sim-checkout-keywords": "上網卡,電話卡,數據卡,DataSIM,旅遊DataSIM,數據咭,4G上網卡,上網卡,4G上網卡,日本4G上網卡,日本上網卡,東京4G上網卡,東京上網卡,大阪4G上網卡,大阪上網卡,泰國4G上網卡,泰國上網卡,曼谷4G上網卡,布吉上網卡,芭提雅4G上網卡,台灣4G上網卡,台灣上網卡,台北4G上網卡,高雄上網卡,台中4G上網卡,台中上網卡,韓國4G上網卡,韓國上網卡,首爾4G上網卡,首爾上網卡,中國4G上網卡,中國上網卡,深圳4G上網卡,深圳上網卡,澳門4G上網卡,澳門上網卡, Docomo, Softbank",
                "travel-sim-checkout-success-description": "{country} Travel SIM - High-quality SIM card with free shipping to your door!",
                "travel-sim-checkout-success-keywords": "上網卡,電話卡,數據卡,DataSIM,旅遊DataSIM,數據咭,4G上網卡,上網卡,4G上網卡,日本4G上網卡,日本上網卡,東京4G上網卡,東京上網卡,大阪4G上網卡,大阪上網卡,泰國4G上網卡,泰國上網卡,曼谷4G上網卡,布吉上網卡,芭提雅4G上網卡,台灣4G上網卡,台灣上網卡,台北4G上網卡,高雄上網卡,台中4G上網卡,台中上網卡,韓國4G上網卡,韓國上網卡,首爾4G上網卡,首爾上網卡,中國4G上網卡,中國上網卡,深圳4G上網卡,深圳上網卡,澳門4G上網卡,澳門上網卡, Docomo, Softbank",
                "travel-sim-checkout-success-title": "Payment Success - Travel SIM",
                "travel-sim-checkout-title": "Place Order - Travel SIM",
                "travel-sim-keywords": "sim卡,上網卡,電話卡,數據卡,DataSIM,旅遊DataSIM,數據咭,4G上網卡,上網卡,日本4G上網卡,日本上網卡,日本sim卡,東京4G上網卡,東京上網卡,大阪4G上網卡,大阪上網卡,泰國4G上網卡,泰國上網卡,泰國sim卡,曼谷4G上網卡,布吉上網卡,芭提雅4G上網卡,台灣4G上網卡,台灣上網卡,台灣sim卡,台北4G上網卡,高雄上網卡,台中4G上網卡,台中上網卡,韓國sim卡,韓國4G上網卡,韓國上網卡,首爾4G上網卡,首爾上網卡,中國4G上網卡,中國上網卡,中國sim卡,中國內地數據卡,深圳4G上網卡,深圳上網卡,澳門4G上網卡,澳門上網卡, 歐洲4G上網卡,歐洲上網卡,歐洲sim卡,英國4G上網卡,英國上網卡,英國sim卡,法國4G上網卡,法國上網卡,法國sim卡, 恴大利4G上網卡,意大利上網卡,意大利sim卡,巴黎4G上網卡,巴黎上網卡,巴黎sim卡,瑞士4G上網卡,瑞士上網卡,瑞士sim卡,Docomo, Softbank, 和記, 聯通, 3hk, 3uk, birdie, 自由鳥, airsim,sim2fly,AIS,ais sim2fly,SK Telecom,TrueMove,dtac,t mobile 全球上網卡,vietnamobile",
                "travel-sim-title": "【{country} SIM Card】{sim_name} - Best Price Guarantee with Free Shipping",
                "travel-sims-description": "Global Travel SIM Search Engine with high-quality SIM card and free shipping to your door!",
                "travel-sims-keywords": "sim卡,上網卡,電話,數據卡,DataSIM,旅遊DataSIM,數據咭,4G上網卡,4Gsim卡,日本4G上網卡,日本上網卡,日本sim卡,東京4G上網卡,東京上網卡,大阪4G上網卡,大阪上網卡,泰國4G上網卡,泰國上網卡,泰國sim卡,曼谷4G上網卡,布吉上網卡,芭提雅4G上網卡,台灣4G上網卡,台灣上網卡,台灣sim卡,台北4G上網卡,高雄上網卡,台中4G上網卡,台中上網卡,韓國sim卡,韓國4G上網卡,韓國上網卡,首爾4G上網卡,首爾上網卡,中國4G上網卡,中國上網卡,中國sim卡,中國內地數據卡,深圳4G上網卡,深圳上網卡,澳門4G上網卡,澳門上網卡,澳門sim卡,歐洲sim卡,Docomo,Softbank,sim2fly,AIS,ais sim2fly,SK Telecom,TrueMove,dtac,t mobile 全球上網卡,vietnamobile",
                "travel-sims-title": "Travel SIM - Best Price Guarantee with Free Shipping"
            },
            "shop-confirmation": {
                "app-download": "立即下載，推送通知",
                "app-download-subtitle": "下載 HyperAir 接收確認訂單的通知。",
                "instruction": "你的預訂已發送到找換店。一旦確認，我們會透過電郵或通知，將 QR CODE 將收到電郵通知，確認訂單將發送至 {email} 。",
                "my-order": "我的訂單",
                "pending-confirm": "等待兌換店確認"
            },
            "staycation": {
                "activity-countdown-button": "Find the cheapest price",
                "all-hotels": {
                    "sorting": {
                        "recommended": "Recommended"
                    }
                },
                "all-hotels-all-button": "All",
                "all-hotels-hotel-name": "Hotel Name",
                "all-hotels-last-updated": "Last Updated",
                "all-hotels-less-button": "Less",
                "all-hotels-more-button": "More",
                "all-hotels-no-result": "Sorry, we couldn't find any results",
                "all-hotels-title": "搜尋全港最齊 Staycation 酒店",
                "compare-packages": "Compare other packages",
                "countdown-button": "More Details",
                "countdown-title": "最新 Staycation 酒店快閃優惠",
                "countdown2-title": "今期熱爆推介",
                "countdown3-title": "最新 Staycation 酒店限時優惠",
                "month-format": "MMM",
                "order-d-title": "浪漫精品酒店 💕💕",
                "order-g-subtitle": "暑假帶埋一家大細Relax下",
                "order-g-title": "親子Staycation必去之選👨‍👩‍👧‍👦😍",
                "order-h-title": "郵輪之旅🛳️",
                "order-i-title": "情侶煮飯仔酒店 🍽️",
                "order-j-title": "Glamping豪華露營推介",
                "seo-description": "點解咁多人用 HyperAir 搵 Staycation? 因為集合左 KKday, Trip.com, Klook 及各大香港酒店平台，一眼比較邊到有late checkout、免費泊車、自助早午晚餐及餐飲回贈等獨家 Staycation 優惠，每日更新。",
                "seo-keywords": "staycation, staycation 優惠, 香港 staycation, staycation 香港, staycation hk, staycation package, staycation hong kong, 酒店, 酒店 優惠, staycation 中文, 香港 酒店, klook 優惠, klook 優惠, kkday 優惠, trip 優惠, agoda 優惠, runhotel staycation, 酒店 套票, staycation 酒店, 香港 酒店 套票, 訂 酒店 優惠, 酒店 package, 特價 酒店, 香港 優惠 酒店, 酒店 優惠 套 票, 特價 酒店 香港, 香港 酒店 優惠, 酒店 住宿 優惠, staycation 2020, staycation 2021, staycation 2022, staycation 1月 優惠, staycation 2月 優惠, staycation 3月 優惠, staycation 4月 優惠, staycation 5月 優惠, staycation 6月 優惠, staycation 7月 優惠, staycation 8月 優惠, staycation 9月 優惠, staycation 10月 優惠, staycation 11月 優惠, staycation 12月 優惠, 四季酒店, W酒店, Murray, JW Marriott, St. Regis, Conrad Hotel, Grand Hyatt, Ritz Carlton, Rosewood, 露台 酒店, 廚房 酒店, 親子 酒店, 情侶 酒店",
                "seo-title": "【2021 September Latest】The Best Singapore Hotel Staycation Packages, Deals and Offers (Daily Updates) - Look for SingapoRediscovers Vouchers Eligible Offers here - HyperAir",
                "share-button-alert": "Copied the Link",
                "subtitle": "每日更新酒店餐飲及住宿優惠（{start_month}月至{end_month}月）",
                "title": "香港最齊 Staycation 優惠搜尋神器",
                "top10-title": "Top 10 人氣 Staycation 酒店",
                "top102-title": "Staycation 必去之選",
                "top103-title": "值得一試的 Staycation 酒店🥂"
            },
            "travel-activities": {
                "best-deals": "Best Deal",
                "book-now": "View Deal",
                "disclaimer": "The prices shown are only for reference. In case of discrepancy, please refer to the our partners' website.",
                "empty-destination": "Please enter country/city",
                "more-deals": "More Deals",
                "not-available": "Not Available",
                "offers": "Offers",
                "provider-getyourguide": "GetYourGuide",
                "provider-hk": {
                    "trip": {
                        "com": "Trip.com"
                    }
                },
                "provider-hyperair": "HyperAir",
                "provider-kkday": "KKday",
                "provider-klook": "KLOOK",
                "provider-seoultravelpass": "SeoulPass",
                "provider-sim": {
                    "hyperair": {
                        "com": "HyperAir"
                    }
                },
                "provider-travelexpert": "Travel Expert",
                "provider-trip": "Trip.com",
                "ratings": "Rating",
                "recommended-title": "More popular activities in {city}",
                "search-africa-oceania": "Africa / Oceania",
                "search-all-cities": "All Cities",
                "search-america": "America",
                "search-asia": "Asia",
                "search-button": "Search",
                "search-cancel-button": "Cancel",
                "search-country-placeholder": "Enter country or city",
                "search-euro-middleeast": "Europe / MiddleEast",
                "search-hardcoded-cities": "Popular Search：",
                "search-placeholder": "Search \"JR Pass\"",
                "search-popular-cities": "🔥 Popular Cities",
                "search-searched-cities": "Searched Cities",
                "search-slogan-2": "Activity/Attraction",
                "show-similar-product": "Compare Similar",
                "sorting": {
                    "price-asc": "Price (Low to High)",
                    "price-desc": "Price (High to Low)",
                    "rating": "Rating",
                    "relevance": "Relevance",
                    "sort-by": "Sort by"
                },
                "title": "Search results matching \"{q}\"",
                "title-everything": "Popular activities in {city}",
                "title-no-result": "Sorry, we couldn't find any results for \"{q}\"",
                "title-no-result-without-keyword": "Sorry, we couldn't find any results",
                "total-results": "Total <b>{number}</b> results"
            },
            "travel-affiliate-codes": {
                "cover-slogan": "Provide discount codes for international travel booking sites",
                "cover-title": "Travel Discount Coupons",
                "disclaimer": "The promotion offers shown are only for reference. In case of discrepancy, please refer to the our partners' website. Suppliers may change or delete the information any time without prior notice and shall have sole discretion to the offer.",
                "exclusive": "Exclusive",
                "type-activity": "Activity",
                "type-air": "Airline Ticket",
                "type-all": "All",
                "type-hotel": "Hotel",
                "type-insurance": "Travel Insurance",
                "type-shopping": "Shopping",
                "type-sim": "SIM Card",
                "use-promo-code": "Get Code",
                "valid-until": "Valid Until:"
            },
            "travel-insurance": {
                "breadcrumb-travel-insurance": "Travel Insurance",
                "cover-subtitle": "Search and compare the best travel insurance with mobile phone coverage!",
                "cover-title": "Travel Insurance",
                "departure-date-alert": "Departure Date must be on or before {latest_date_to_depart}.",
                "disclaimer": "Quote is for reference only. Please refer to the insurance company website for more details.",
                "highlight-subtitle1": "List out the key coverage of the travel insurance plans for your easy selection",
                "highlight-subtitle2": "Compare the best travel insurance deals to help you save every dollar !",
                "highlight-subtitle3": "Enjoy exclusive travel insurance privileges and offers !",
                "highlight-title1": "Coverage Comparison",
                "highlight-title2": "Pricing Comparison",
                "highlight-title3": "Exclusive Rewards",
                "num-of-travellers-alert": "No. of travellers cannot be more than 10",
                "partner-title": "Our Travel Insurance Partners",
                "return-date-alert": "Return Date must be on or before {latest_date_to_return}.",
                "section-title": "You are now searching {num_of_day} for {num_of_traveller} traveller(s)",
                "slogan": "3 Easy Steps",
                "sorting": {
                    "coverage": "Best Coverage",
                    "price-asc": "Price (Low to High)",
                    "price-desc": "Price (High to Low)"
                },
                "step1": "Fill the info",
                "step1-detail": "Enter your destination, date and no. of travellers",
                "step2": "Compare the plans",
                "step2-detail": "Compare the price and coverage of different travel insurance plans",
                "step3": "Enjoy the offers",
                "step3-detail": "One-click to enjoy exclusive travel insurance offers"
            },
            "travel-insurance-product-card": {
                "apply-now": "Get the offer",
                "cancellation": "CANCELLATION",
                "car-rental": "VEHICLE RENTAL EXCESS",
                "cruise-vacation": "CRUISE VACATION (optional benefits)",
                "dangerous-sports": "DANGEROUS SPORTS",
                "hyperair-exclusive": "HYPERAIR EXCLUSIVE",
                "medical": "MEDICAL",
                "mobile": "LOSS/DAMAGE OF MOBILE PHONE",
                "personal-belongings": "PERSONAL BELONGINGS",
                "trip-delay": "TRIP DELAY"
            },
            "travel-insurance-search-bar": {
                "children": "Children aged below 18",
                "date": "Departure Date and Return Date",
                "destination": "Where do you go",
                "friend": "Friends / Relatives",
                "myself": "Myself",
                "number-of-traveller": "Number of Traveller",
                "search-button": "Search",
                "spouse": "Spouse"
            },
            "travel-marketplace": {
                "buy-now-can-earn-x-miles": "Earn HyperMiles for next purchase",
                "cover-slogan": "A collection of coolest gadgets that you'll like",
                "cover-title": "Travel Gadgets"
            },
            "travel-marketplace-categories": "Categories",
            "travel-marketplace-checkout": {
                "delivery-message-body": "Working days are from Monday to Friday (except public holidays). The order cut-off time is 12：00 PM (GMT+8). Orders placed after 12：00 PM (GMT+8) will ship out the next working day.",
                "delivery-method-1": "SF Express (Hong Kong Only)",
                "delivery-method-1-description": "By SF Express, courier fee is HK$30 per order. Courier fee is waived upon purchasing above HK$800. The ordered items will be delivered by courier within 5-10 working days.",
                "delivery-method-2": "International Shipping",
                "delivery-method-2-description": "Delivery in 4 to 15 working days depending on the destination. Shipping fee is HK$100 per item. The above international delivery fee is based on estimation. Further surcharge may apply."
            },
            "travel-money": {
                "breadcrumb-travel-money": "Travel Money",
                "cover-button": "Experience Now",
                "cover-slogan": "Exchange travel money smarter",
                "cover-title": "Travel Money",
                "disclaimer": "The prices shown are only for reference. In case of discrepancy, please refer to the money changers' website.",
                "empty-amount": "Please enter the amount",
                "fx": "",
                "fx-slogan": "Four Easy Steps",
                "fx-step1": "Search",
                "fx-step1-detail": "Choose the currency you want to exchange",
                "fx-step2": "Compare",
                "fx-step2-detail": "Find the best rate and most convenient pick-up spot",
                "fx-step3": "Book",
                "fx-step3-detail": "Reserve the travel money online",
                "fx-step4": "Pick up",
                "fx-step4-detail": "Show the QR code to get the travel money",
                "hyperair-feature-1": "Smart",
                "hyperair-feature-1-description": "A smart way to exchange travel money. Now you can spot the best rate with just a few clicks and reserve the travel money online. Time to say bye to long queue!",
                "hyperair-feature-2": "Reliable",
                "hyperair-feature-2-description": "A reliable way to get the money exchange. All our partners are licensed banks and money exchangers to keep your foreign exchange safe.",
                "hyperair-feature-3": "Anywhere. Anytime.",
                "hyperair-feature-3-description": "A brand new way to get travel money. We are keen to expand overseas footprint and provide you the smartest travel experience anywhere.",
                "i-will-get": "I will get",
                "i-will-pay": "I will pay",
                "join-us": "For more business opportunity",
                "join-us-button": "Join us now",
                "join-us-slogan": "Become our supplier",
                "search-bar-placeholder": "Enter Amount",
                "search-button": "Search",
                "section-title": "{amount} {currency} for HKD",
                "section-title-from-hkd": "Searching HKD for {amount} {currency}",
                "section-title-to-hkd": "Searching {amount} {currency} for HKD",
                "why-hyperair": "",
                "why-hyperair-description": "HyperAir provides you a brand new way to get travel money. Now you can book the exchange online with the best in town exchange rate!",
                "why-hyperair-title": "Why choose us?"
            },
            "travel-product": {
                "buy-now": "Buy Now",
                "product-option": "Options"
            },
            "travel-sim": {
                "as-low-as": "Daily As low as",
                "book-now": "Order Now",
                "breadcrumb-homepage": "Homepage",
                "breadcrumb-mainpage": "Main page",
                "breadcrumb-travel-sim": "Travel SIM",
                "cancellation-policy": "Cancellation Policy",
                "cancellation-policy-content": "No cancellations, refunds or changes can be made after purchase.",
                "download-hyperair-now-description": "Scan the QR code or go to app store to download HyperAir App",
                "download-hyperair-now-title": "Download HyperAir App",
                "first-step": "Step 1",
                "go-to-shopping-cart-description": "",
                "go-to-shopping-cart-title": "",
                "hardcoded-countries-title": "Other Popular Countries:",
                "highlights": "Highlights",
                "important-notice": "Important Notice",
                "instructions": "Instructions",
                "lowest-price-guarantee": "Best Price Guarantee",
                "no-stock": "Sold Out",
                "num-of-review": "{num}-of-review reviews",
                "popular-countries": "Travel SIM covers 200+ countries",
                "popular-countries-search-button": "Search other countries",
                "product-highlights": "Product Description",
                "product-specification": "Product Specification",
                "related-sims": "Related {country} SIM",
                "related-sims-search-button": "More {country} SIM",
                "review": "Review",
                "review-date": "{date}",
                "review-no-firstname-user": "Traveller",
                "scan-product-qr-code": "Scan the QR code to purchase this product",
                "second-step": "Step 2",
                "sim": " Sim Cards",
                "web-traffic": "Purchased {num}-of-purchased times since last week and {num}-of-traffic users are looking at this SIM right now",
                "web-traffic-title": "This SIM is in hot sales!"
            },
            "travel-sim-checkout": {
                "-secure-payment-slogan": "",
                "address": "Delivery Address",
                "address-column1": "e.g. Room A, 18/F, World Center",
                "address-column2": "e.g. 88 Travel Road",
                "address-column3": "e.g. Central, Hong Kong",
                "back-button": "Back",
                "checkout-title-1": "Delivery Info",
                "confirm-button": "Continue",
                "country-code": "Country Code",
                "delivery-message-body": "Working days are from Monday to Friday (except public holidays). The order cut-off time is 12：00 PM (GMT+8). Orders placed after 12：00 PM (GMT+8) will ship out the next working day.\n<br><br>Within the same working day, orders with the same delivery address will be sent together.",
                "delivery-message-header": "Delivery Notice",
                "delivery-method": "Delivery Method",
                "delivery-method-1": "Hong Kong Post (Free)",
                "delivery-method-1-description": "By Hong Kong Post's Local Mail, the estimated delivery will be within 3-6 working days. Status tracking is not available to local mail and customers shall bare the full responsibility of losing items by using Hong Kong Post’s ordinary mail service.\n<br><br>Note: Due to the time required for delivery, customers who are about to travel are recommended to choose SF Express",
                "delivery-method-2": "SF Express (Hong Kong only. Courier fee payable on delivery)",
                "delivery-method-2-description": "By SF Express (courier fee payable on delivery), the ordered items will be delivered by courier within 1-3 working days, and islands will take longer delivery time. The courier fee is about HK$16-$25 by referring to the website of SF Express.\n<br><br>Note: The order over HK$399 will be upgraded to SF Express for FREE",
                "delivery-method-3": "International Shipping",
                "delivery-method-3-description": "Delivered by Hong Kong Post (tracking no. will be provided) within 4 to 15 working days depends on the destination. Shipping cost HK$30.",
                "error-alert-address": "Please fill in the delivery address.",
                "error-alert-invalid-email": "Email format is invalid.",
                "error-alert-invalid-recipient-first-num": "contact number should be started with 2,3,5,6,7,8 or 9.",
                "error-alert-invalid-recipient-number": "Please fill in the correct contact number.",
                "error-alert-invalid-user-first-num": "Mobile number should be start with 5,6,7,8 or 9.",
                "error-alert-invalid-user-number": "Please fill in the correct mobile number.",
                "error-alert-personal-info": "Please fill in Personal Info.",
                "error-alert-recipient-info": "Please fill in Recipient Info.",
                "error-invalid-credit-card-info": "Invalid Credit Card Information",
                "facebook-login": "Continue With Facebook",
                "google-login": "Continue With Google",
                "logged-in": "Logged In",
                "login": "Existing customer, login to enjoy the express check-out",
                "login-button": "Login",
                "login-email": "Email",
                "login-no-user-exists": "Oops! Sorry, we are unable to confirm your login information. Please try again or simply complete the order without guest check-out.",
                "login-password": "Password",
                "payme": {
                    "error-contacting-payme": "Payment error, please re-order again or contact customer support."
                },
                "payment": {
                    "actual-payment": "The transaction will be settled at HK${actual_payment} and the exchange rate will be based on your credit card issuer.",
                    "choose-payment-method": "Choose payment method:",
                    "logistic-information": "Delivery Info",
                    "modify-information": "Edit Info",
                    "pay-now": "Pay Now",
                    "payme-instruction-do-not-close": "Please do not close this page before payment is complete",
                    "payme-instruction-step-1": "1. Open the PayMe app.",
                    "payme-instruction-step-2": "2. Scan the PayCode to authorise payment.",
                    "payme-instruction-step-3": "3. Complete payment in the app and wait for confirmation.",
                    "payme-instruction-title": "Paying with PayMe",
                    "payme-title": "Scan this PayCode with PayMe",
                    "payment": "Payment",
                    "price": "Amount",
                    "shipping-fee": "Shipping Fee",
                    "subtotal": "Subtotal"
                },
                "payment-method": "Payment Method",
                "pending": {
                    "mobile-redirection-text": "You have selected PayMe as your payment method and will be redirected to the PayMe app to complete payment.",
                    "need-to-pay": "Amount due",
                    "order-number": "Order Number",
                    "order-success-please-pay": "Please pay with PayMe to complete the ordering process",
                    "paycode-error": "Payment error, please re-order again or contact customer support.",
                    "paycode-expired": "PayMe's paycode expired, please re-order again.",
                    "re-order": "Re-order",
                    "title-payme": "Pay with PayMe"
                },
                "recipient-address": "Delivery Address",
                "recipient-information": "Recipient Info",
                "recipient-name": "Recipient Name",
                "recipient-phone-number": "Recipient Phone Number",
                "secure-payment-slogan": "Secure Checkout | Payment will be encrypted and securely transmitted using SSL",
                "simproduct-detail": "Order Info",
                "simproduct-quantity": "Quantity",
                "simproduct-redeem": "Redeem",
                "simproduct-redeem-hypermiles": "Redeem Hyper Miles",
                "simproduct-title": "Product",
                "simproduct-will-redeeming-x-miles": "Redeeming {miles} HyperMiles",
                "simproduct-you-have-x-hypermiles": "You have {miles} HyperMiles",
                "user-email": "Email (To receive invoice)",
                "user-firstname": "First Name",
                "user-information": "Personal Info",
                "user-lastname": "Last Name",
                "user-phone-number": "Mobile Number",
                "vertical-divider": "or"
            },
            "travel-sims": {
                "column-title-1": "Clear Classification, Easy to Pick",
                "column-title-2": "Online Payment, Convenient and Fast",
                "column-title-3": "Free Surface Mail, Speedy Delivery",
                "country-search-no-place-found": "Please enter a country name",
                "cover-button": "Order with HyperAir App Now",
                "cover-slogan": "Best SIM card deals with free shipping!",
                "cover-title": "Travel SIM",
                "empty-destination": "Please enter destination",
                "num-of-days": "Number of Days",
                "search-button": "",
                "search-input": "Search country",
                "search-placeholder": "Search country",
                "search-slogan": "Where do you go?",
                "travel-sim-header-description": "",
                "travel-sim-header-title": ""
            }
        },
        "passwords": {
            "password": "Passwords must be at least six characters and match the confirmation.",
            "reset": "Your password has been reset!",
            "sent": "We have e-mailed your password reset link.",
            "token": "This password reset token is invalid.",
            "user": "We can't find a user with that e-mail address."
        },
        "mail": {
            "product-simcard": {
                "delivery-update": {
                    "subject": "Your SIM Card order is on its way"
                },
                "purchased": {
                    "subject": "Travel SIM Order Confirmation"
                },
                "tracking-number-update": {
                    "subject": "Your order tracking number is updated"
                }
            }
        },
        "member-center": {
            "login-to-receive-codes": "Register an account to receive promotion code",
            "my-orders-empty": "No Records",
            "my-orders-title": "My Orders",
            "profile-area-code": "Area Code",
            "profile-email": "Email",
            "profile-firstname": "First Name",
            "profile-lastname": "Last Name",
            "profile-save": "Save",
            "profile-tel": "Mobile Phone",
            "profile-title": "Profile",
            "profile-update-successfully": "Updated successfully",
            "promo-code-enter-promotion-code": "Enter promotion code",
            "promo-code-my-promo-code": "My HyperAir Coupons",
            "promo-code-no-code": "Sorry, you do not have any promotion code",
            "promo-code-please-fill-in-code": "Please fill in promotion code",
            "promo-code-redeem": "Redeem",
            "promo-code-redeem-code": "Redeem HyperAir Coupon",
            "promo-code-select": "Select",
            "promo-code-title": "HyperAir Coupon",
            "title": "My Account"
        },
        "weekday": {
            "1": "Monday",
            "2": "Tuesday",
            "3": "Wednesday",
            "4": "Thursday",
            "5": "Friday",
            "6": "Saturday",
            "7": "Sunday"
        },
        "exchange-shop-details": {
            "address": "Address",
            "book-button": "Book Now",
            "br": "BR",
            "closed-book-button": "Closed",
            "download-pop-up": {
                "slogan-1": "Locked in Rate",
                "slogan-2": "Instant Comfirmation",
                "title": "Download App for the FX Booking"
            },
            "latest-updated": "Latest Updated",
            "not-available-book-button": "Reference Only",
            "opening-hrs": "Opening Hours",
            "phone-num": "Phone Number",
            "rate": "Rate",
            "reviews": "Reviews",
            "table-buy-rate": "Buy rate",
            "table-compare-button": "Compare",
            "table-currency": "Currency",
            "table-sell-rate": "Sell Rate",
            "table-short-form": "Code",
            "table-title": "Other Currencies"
        },
        "credit-card": {
            "cannot-add-card": "Something went wrong while adding your credit card. Please check your information and try again or you may add another credit card.",
            "cannot-process": "Something went wrong while charging your credit card. Please check your information and try again or you may check out with another credit card."
        },
        "shoppingcart": {
            "add": {
                "no-stock": "Oops! Reached the maximum purchasable quantity for this product..."
            },
            "pay": {
                "db-locked": "Server busy. Please try again later. (Ref. Code: E1003)",
                "invalid-promotion-code": "Invalid Promotion Code",
                "no-stock": "Product(s) out of stock just now! (Ref. Code: E1002)"
            },
            "promotion-message": {
                "up-sell-1": "Enjoy HK$10 off with welcome coupon",
                "up-sell-2": "Enjoy HK$15 off with promo code HYPER15 when spending above HK$299"
            }
        },
        "product": {
            "label-confirmation-duration-24_hours": "24 hours confirmation",
            "label-confirmation-duration-48_hours": "48 hours confirmation",
            "label-confirmation-duration-instant": "Instant confirmation",
            "label-duration-unit-day": "&nbsp;days",
            "label-duration-unit-hour": "hour(s)",
            "label-duration-unit-hr": "&nbsp;hours",
            "label-duration-unit-min": "&nbsp;mins",
            "label-earliest-available-date": "j M Y",
            "label-earliest-available-date-today": "Today",
            "label-earliest-available-date-tomorrow": "Tomorrow",
            "label-lang-en": "English",
            "label-lang-jp": "Japanese",
            "label-lang-kr": "Korean",
            "label-lang-zh": "Chinese",
            "label-meet-up-method-hotel_pickup": "Hotel pickup",
            "label-meet-up-method-location_meet_up": "Location meet up",
            "label-refundable-conditional_cancel": "Conditional cancellation",
            "label-refundable-no_cancel": "No cancellation",
            "label-ticket-logistic-mobile": "Mobile voucher accepted",
            "label-ticket-logistic-printed": "Printed voucher accepted",
            "label-ticket-logistic-printed_or_mobile": "Printed or Mobile voucher accepted",
            "label-ticket-validity-fixed_date": "Fixed Date Ticket",
            "label-ticket-validity-open_date": "Open Date Ticket",
            "label-ticket-validity-open_or_fixed_date": "Open/Fixed Date Ticket"
        },
        "pagination": {
            "next": "Next",
            "previous": "Previous"
        },
        "city": {
            "abu-dhabi": "Abu Dhabi",
            "adelaide": "Adelaide",
            "agra": "Agra",
            "ahmedabad": "Ahmedabad",
            "alice-springs": "Alice Springs",
            "alsace": "Alsace",
            "amritsar": "Amritsar",
            "amsterdam": "Amsterdam",
            "andalusia": "Andalusia",
            "antalya": "Antalya",
            "anuradhapura": "Anuradhapura",
            "athens": "Athens",
            "auckland": "Auckland",
            "bacolod": "Bacolod",
            "bagan": "Bagan",
            "baku": "Baku",
            "bali": "Bali",
            "bandung": "Bandung",
            "bangalore": "Bangalore",
            "bangkok": "Bangkok",
            "barcelona": "Barcelona",
            "batam": "Batam",
            "bath": "Bath",
            "bay-of-islands": "Bay of Islands",
            "beijing": "Beijing",
            "belfast": "Belfast",
            "bentota": "Bentota",
            "berlin": "Berlin",
            "bohol": "Bohol",
            "boracay": "Boracay",
            "bordeaux": "Bordeaux",
            "boston": "Boston",
            "bratislava": "Bratislava",
            "brisbane": "Brisbane",
            "bruges": "Bruges",
            "brussels": "Brussels",
            "budapest": "Budapest",
            "burgundy": "Burgundy",
            "busan": "Busan",
            "cairns": "Cairns",
            "cambridge": "Cambridge",
            "cameron-highlands": "Cameron Highlands",
            "canary-islands": "Canary Islands",
            "cape-town": "Cape Town",
            "cappadocia": "Cappadocia",
            "cebu": "Cebu",
            "champagne": "Champagne",
            "chengdu": "Chengdu",
            "chennai": "Chennai",
            "chiang-mai": "Chiang Mai",
            "chiang-rai": "Chiang Rai",
            "chiayi": "Chiayi",
            "chicago": "Chicago",
            "chongqing": "Chongqing",
            "christchurch": "Christchurch",
            "cochin": "Cochin",
            "cologne": "Cologne",
            "colombo": "Colombo",
            "copenhagen": "Copenhagen",
            "costa-del-sol": "Costa del Sol",
            "crete": "Crete",
            "da-lat": "Da Lat",
            "da-nang": "Da Nang",
            "darwin": "Darwin",
            "davao": "Davao",
            "delhi": "Delhi",
            "dhaka": "Dhaka",
            "dresden": "Dresden",
            "dubai": "Dubai",
            "dublin": "Dublin",
            "dubrovnik": "Dubrovnik",
            "dumaguete": "Dumaguete",
            "dunedin": "Dunedin",
            "düsseldorf": "Düsseldorf",
            "edinburgh": "Edinburgh",
            "finnish-lapland": "Lapland",
            "florence": "Florence",
            "frankfurt": "Frankfurt",
            "fraser-island": "Fraser Island",
            "french-riviera": "French Riviera",
            "fukuoka": "Fukuoka",
            "galle": "Galle",
            "galway": "Galway",
            "gangtok": "Gangtok",
            "gangwon-do": "Gangwon-do",
            "gdansk": "Gdansk",
            "geneva": "Geneva",
            "genting-highlands": "Genting Highlands",
            "geraldton": "Geraldton",
            "glasgow": "Glasgow",
            "goa": "Goa",
            "gold-coast": "Gold Coast",
            "gothenburg": "Gothenburg",
            "guam": "Guam",
            "guangdong": "Guangdong",
            "guilin": "Guilin",
            "guizhou": "Guizhou",
            "gyeonggi-do": "Gyeonggi-do",
            "haikou": "Haikou",
            "hakone": "Hakone",
            "halong": "Halong",
            "hamburg": "Hamburg",
            "hangzhou": "Hangzhou",
            "hanoi": "Hanoi",
            "harbin": "Harbin",
            "hat-yai": "Hat Yai",
            "hawaii": "Hawaii",
            "heidelberg": "Heidelberg",
            "helsinki": "Helsinki",
            "himachal-pradesh": "Himachal Pradesh",
            "hiroshima": "Hiroshima",
            "ho-chi-minh-city": "Ho Chi Minh City",
            "hobart": "Hobart",
            "hoi-an": "Hoi An",
            "hokkaido": "Hokkaido",
            "hong-kong": "Hong Kong",
            "hua-hin": "Hua Hin",
            "hualien": "Hualien",
            "hue": "Hue",
            "hyderabad": "Hyderabad",
            "iloilo": "Iloilo",
            "incheon": "Incheon",
            "inle-lake": "Inle Lake",
            "inner-mongolia": "Inner Mongolia",
            "innsbruck": "Innsbruck",
            "interlaken": "Interlaken",
            "inverness": "Inverness",
            "ipoh": "Ipoh",
            "istanbul": "Istanbul",
            "jaipur": "Jaipur",
            "jaisalmer": "Jaisalmer",
            "jakarta": "Jakarta",
            "jeju": "Jeju",
            "jerusalem": "Jerusalem",
            "jodhpur": "Jodhpur",
            "johor-bahru": "Johor Bahru",
            "kandy": "Kandy",
            "kaohsiung": "Kaohsiung",
            "kathmandu": "Kathmandu",
            "kazan": "Kazan",
            "kenting": "Kenting",
            "kiev": "Kiev",
            "kinmen": "Kinmen",
            "kobe": "Kobe",
            "koh-chang": "Koh Chang",
            "koh-samui": "Koh Samui",
            "krabi": "Krabi",
            "krakow": "Krakow",
            "kuala-lumpur": "Kuala Lumpur",
            "kumamoto": "Kumamoto",
            "kyoto": "Kyoto",
            "kyushu": "Kyushu",
            "lake-district": "Lake District",
            "langkawi": "Langkawi",
            "lapland": "Lapland",
            "las-vegas": "Las Vegas",
            "launceston": "Launceston",
            "lausanne": "Lausanne",
            "leipzig": "Leipzig",
            "lisbon": "Lisbon",
            "liverpool": "Liverpool",
            "ljubljana": "Ljubljana",
            "loire-valley": "Loire Valley",
            "lombok": "Lombok",
            "london": "London",
            "los-angeles": "Los Angeles",
            "luang-prabang": "Luang Prabang",
            "lucerne": "Lucerne",
            "lviv": "Lviv",
            "lyon": "Lyon",
            "macao": "Macau",
            "macau": "Macau",
            "madrid": "Madrid",
            "malaga": "Malaga",
            "manchester": "Manchester",
            "mandalay": "Mandalay",
            "manila": "Manila",
            "marrakech": "Marrakech",
            "mauritius": "Mauritius",
            "medan": "Medan",
            "melaka": "Melaka",
            "melbourne": "Melbourne",
            "miami": "Miami",
            "milford-sound": "Milford Sound",
            "montreux": "Montreux",
            "moscow": "Moscow",
            "mumbai": "Mumbai",
            "munich": "Munich",
            "muscat": "Muscat",
            "nagano": "Nagano",
            "nagoya": "Nagoya",
            "naples": "Naples",
            "nelson": "Nelson",
            "new-delhi": "New Delhi",
            "new-york": "New York",
            "nha-trang": "Nha Trang",
            "niagara-falls": "Niagara Falls",
            "niigata": "Niigata",
            "normandy": "Normandy",
            "odessa": "Odessa",
            "okayama": "Okayama",
            "okinawa": "Okinawa",
            "orlando": "Orlando",
            "osaka": "Osaka",
            "oslo": "Oslo",
            "oxford": "Oxford",
            "palawan": "Palawan",
            "paris": "Paris",
            "pattaya": "Pattaya",
            "penang": "Penang",
            "penghu": "Penghu",
            "perth": "Perth",
            "philadelphia": "Philadelphia",
            "phnom-penh": "Phnom Penh",
            "phu-quoc": "Phu Quoc",
            "phuket": "Phuket",
            "pisa": "Pisa",
            "pokhara": "Pokhara",
            "port-lincoln": "Port Lincoln",
            "porto": "Porto",
            "porto-district": "Porto District",
            "prague": "Prague",
            "provence": "Provence",
            "puglia": "Puglia",
            "pune": "Pune",
            "pushkar": "Pushkar",
            "queenstown": "Queenstown",
            "ras-al-khaimah": "Ras Al Khaimah",
            "reykjavik": "Reykjavik",
            "rhodes": "Rhodes",
            "rhône-alpes": "Rhône-Alpes",
            "rome": "Rome",
            "rotorua": "Rotorua",
            "rotterdam": "Rotterdam",
            "sabah": "Sabah",
            "saint-petersburg": "Saint Petersburg",
            "saipan": "Saipan",
            "salzburg": "Salzburg",
            "san-diego": "San Diego",
            "san-francisco": "San Francisco",
            "santorini": "Santorini",
            "sanya": "Sanya",
            "sapa": "Sapa",
            "sarawak": "Sarawak",
            "seattle": "Seattle",
            "seoul": "Seoul",
            "seville": "Seville",
            "shanghai": "Shanghai",
            "sibiu": "Sibiu",
            "sicily": "Sicily",
            "siem-reap": "Siem Reap",
            "sihanoukville": "Sihanoukville",
            "singapore": "Singapore",
            "split": "Split",
            "surabaya": "Surabaya",
            "suzhou": "Suzhou",
            "swedish-lapland": "Swedish Lapland",
            "sydney": "Sydney",
            "taichung": "Taichung",
            "tainan": "Tainan",
            "taipei": "Taipei",
            "taitung": "Taitung",
            "tarragona": "Tarragona",
            "taupo": "Taupo",
            "terengganu": "Terengganu",
            "thessaloniki": "Thessaloniki",
            "tokyo": "Tokyo",
            "toledo": "Toledo",
            "trincomalee": "Trincomalee",
            "turin": "Turin",
            "udaipur": "Udaipur",
            "uluru": "Uluru",
            "uttarakhand": "Uttarakhand",
            "varanasi": "Varanasi",
            "venice": "Venice",
            "verona": "Verona",
            "vienna": "Vienna",
            "vientiane": "Vientiane",
            "volendam": "Volendam",
            "washington-dc": "Washington DC",
            "wellington": "Wellington",
            "whitsundays": "Whitsundays",
            "xiamen": "Xiamen",
            "xian": "Xian",
            "yangon": "Yangon",
            "yilan": "Yilan",
            "yogyakarta": "Yogyakarta",
            "york": "York",
            "yunnan": "Yunnan",
            "zagreb": "Zagreb",
            "zhangjiajie": "Zhangjiajie",
            "zurich": "Zurich"
        },
        "validation": {
            "accepted": "The {attribute} must be accepted.",
            "active_url": "The {attribute} is not a valid URL.",
            "after": "The {attribute} must be a date after {date}.",
            "after_or_equal": "The {attribute} must be a date after or equal to {date}.",
            "alpha": "The {attribute} may only contain letters.",
            "alpha_dash": "The {attribute} may only contain letters, numbers, and dashes.",
            "alpha_num": "The {attribute} may only contain letters and numbers.",
            "array": "The {attribute} must be an array.",
            "before": "The {attribute} must be a date before {date}.",
            "before_or_equal": "The {attribute} must be a date before or equal to {date}.",
            "between": {
                "array": "The {attribute} must have between {min} and {max} items.",
                "file": "The {attribute} must be between {min} and {max} kilobytes.",
                "numeric": "The {attribute} must be between {min} and {max}.",
                "string": "The {attribute} must be between {min} and {max} characters."
            },
            "boolean": "The {attribute} field must be true or false.",
            "confirmed": "The {attribute} confirmation does not match.",
            "custom": {
                "attribute-name": {
                    "rule-name": "custom-message"
                }
            },
            "date": "The {attribute} is not a valid date.",
            "date_format": "The {attribute} does not match the format {format}.",
            "different": "The {attribute} and {other} must be different.",
            "digits": "The {attribute} must be {digits} digits.",
            "digits_between": "The {attribute} must be between {min} and {max} digits.",
            "dimensions": "The {attribute} has invalid image dimensions.",
            "distinct": "The {attribute} field has a duplicate value.",
            "email": "The {attribute} must be a valid email address.",
            "exists": "The selected {attribute} is invalid.",
            "file": "The {attribute} must be a file.",
            "filled": "The {attribute} field must have a value.",
            "image": "The {attribute} must be an image.",
            "in": "The selected {attribute} is invalid.",
            "in_array": "The {attribute} field does not exist in {other}.",
            "integer": "The {attribute} must be an integer.",
            "ip": "The {attribute} must be a valid IP address.",
            "ipv4": "The {attribute} must be a valid IPv4 address.",
            "ipv6": "The {attribute} must be a valid IPv6 address.",
            "json": "The {attribute} must be a valid JSON string.",
            "max": {
                "array": "The {attribute} may not have more than {max} items.",
                "file": "The {attribute} may not be greater than {max} kilobytes.",
                "numeric": "The {attribute} may not be greater than {max}.",
                "string": "The {attribute} may not be greater than {max} characters."
            },
            "mimes": "The {attribute} must be a file of type: {values}.",
            "mimetypes": "The {attribute} must be a file of type: {values}.",
            "min": {
                "array": "The {attribute} must have at least {min} items.",
                "file": "The {attribute} must be at least {min} kilobytes.",
                "numeric": "The {attribute} must be at least {min}.",
                "string": "The {attribute} must be at least {min} characters."
            },
            "not_in": "The selected {attribute} is invalid.",
            "numeric": "The {attribute} must be a number.",
            "present": "The {attribute} field must be present.",
            "regex": "The {attribute} format is invalid.",
            "required": "The {attribute} field is required.",
            "required_if": "The {attribute} field is required when {other} is {value}.",
            "required_unless": "The {attribute} field is required unless {other} is in {values}.",
            "required_with": "The {attribute} field is required when {values} is present.",
            "required_with_all": "The {attribute} field is required when {values} is present.",
            "required_without": "The {attribute} field is required when {values} is not present.",
            "required_without_all": "The {attribute} field is required when none of {values} are present.",
            "same": "The {attribute} and {other} must match.",
            "size": {
                "array": "The {attribute} must contain {size} items.",
                "file": "The {attribute} must be {size} kilobytes.",
                "numeric": "The {attribute} must be {size}.",
                "string": "The {attribute} must be {size} characters."
            },
            "string": "The {attribute} must be a string.",
            "timezone": "The {attribute} must be a valid zone.",
            "unique": "The {attribute} has already been taken.",
            "uploaded": "The {attribute} failed to upload.",
            "url": "The {attribute} format is invalid."
        },
        "reset-password": {
            "confirm-new-password": "Confirm new password",
            "enter-new-password": "Enter new password",
            "please-enter-a-new-password": "Please enter a new password for your account {email}.",
            "submit": "Submit",
            "success-content": "Successful! Please log in the HyperAir mobile app with the new password.",
            "title": "Reset Password",
            "validation-display": "Password must contain at least 6 characters."
        },
        "notification": {
            "activation-e-minus-content": "15 days countdown! Your Travel SIM welcome coupon will be expired very soon! Don't miss the chance to use the coupon for your upcoming trip!",
            "activation-e-minus-title": "",
            "activation-t-plus-content": "Remember to use our welcome SIM card coupon for your upcoming trip! Travel Smarter. Anywhere.",
            "activation-t-plus-title": "",
            "ask-shop-to-quote-content": "Request quotation for buying {amount} {currency}",
            "ask-shop-to-quote-content2": "Request quotation for selling {amount} {currency}",
            "ask-shop-to-quote-title": "New Request for Quotation",
            "email-booking-details": "Booking Details",
            "email-booking-id": "Booking ID",
            "email-exchange-approved-content": "Exchanged order approved for buying {amount} {currency} at rate {rate}",
            "email-exchange-approved-footer": "Thank you for using HyperAir.",
            "email-exchange-approved-title": "Shop replied, \"Your travel money is ready for pickup!\"",
            "email-exchange-completed-content": "Exchanged order completed for buying {amount} {currency} at rate {rate}",
            "email-exchange-completed-footer": "Thank you for using HyperAir.",
            "email-exchange-completed-title": "Your travel money exchange is completed!",
            "email-exchange-confirmed-content": "Exchanged order confirmed for buying {amount} {currency} at rate {rate}",
            "email-exchange-confirmed-footer": "Thank you for using HyperAir.",
            "email-exchange-confirmed-title": "Your travel money is ready for your pickup!",
            "email-footer-copy-right": "All rights reserved.",
            "email-greetings": "Hello!",
            "email-i-got": "I got",
            "email-i-paid": "I paid",
            "email-i-will-get": "I will get",
            "email-i-will-pay": "I will pay",
            "email-pickup-before": "Pickup before",
            "email-product-confirmed-greeting": "Dear valued customer,<br><br>Thank you for using HyperAir. Your voucher is ready.",
            "email-product-confirmed-subject": "Order has been confirmed",
            "email-product-confirmed-title": "Your Order is Confirmed",
            "email-product-purchased": {
                "shipping": {
                    "international": "International Shipping",
                    "sf": "SF Express (Hong Kong Only)"
                }
            },
            "email-product-purchased-delievery-address": "Delivery Address",
            "email-product-purchased-delivery-info": "Delivery Info",
            "email-product-purchased-delivery-method": "Delivery Method",
            "email-product-purchased-discount": "Discount",
            "email-product-purchased-email": "Email",
            "email-product-purchased-greeting": "Dear valued customer,<br><br> Good choice. It will take some time to confirm the reservation. But do not worry, most of time we can confirm the order within 12 hours. Thanks for using HyperAir!",
            "email-product-purchased-have-a-nice-trip": "Have a nice trip!",
            "email-product-purchased-important-notice": "Terms & Conditions apply.",
            "email-product-purchased-important-notice-content": "Terms & Conditions apply.",
            "email-product-purchased-name": "Name",
            "email-product-purchased-order-date": "Order Date",
            "email-product-purchased-order-details": "Order Details",
            "email-product-purchased-order-no": "Order Number",
            "email-product-purchased-personal-info": "Personal Info",
            "email-product-purchased-receipient-name": "Recipient Name",
            "email-product-purchased-receipient-phone-no": "Phone No.",
            "email-product-purchased-shipping-fee": "Shipping Fee",
            "email-product-purchased-sub-total": "Sub-total",
            "email-product-purchased-subject": "Order is pending to confirm",
            "email-product-purchased-title": "Your Order is Pending",
            "email-product-purchased-total": "Total",
            "email-product-simcapurchased-personal-info": "Personal Info",
            "email-product-simcard-delivery-title": "Your order SIM{order}-num has been prepared and shipped on {date}. If you have chosen SF Express, we will provide the tracking number later. You can also check it on our mobile app.",
            "email-product-simcard-delivery-title-carbon-format": "j M Y",
            "email-product-simcard-delivery-update-greeting": "Dear valued customer,<br><br>Thank you for using HyperAir. Your SIM card order is on its way.",
            "email-product-simcard-delivery-update-title": "Your SIM Card order is on its way",
            "email-product-simcard-delivery-update-tracking": "Tracking Details",
            "email-product-simcard-delivery-update-tracking-no": "Tracking Number",
            "email-product-simcard-delivery-update-tracking-no-hkpost": "Tracking Number: -",
            "email-product-simcard-delivery-update-tracking-no-sf": "Tracking Number",
            "email-product-simcard-delivery-waiting-update-tracking-no-sf": "Are waiting SF Express to update",
            "email-product-simcard-delivery-with-tracking-num-title": "Your order SIM{order}-num will be shipped by SF Express with tracking number: {tracking}-num. Please pay attention to your mobile phone for delivery pick up. You can also check the shipping status on the SF Express website. Thanks for using HyperAir services.",
            "email-product-simcard-esim-code-greeting": "Dear valued customer,<br><br>Thank you for using HyperAir. Here's your eSIM activation QR Code.",
            "email-product-simcard-esim-code-important-notice-content": "<span style=\"font-size: 10px; line-height: 12px;\">Instructions:<br />1. Go to Setting<br />2. Tap \"Mobile Data\"<br />3. In Data Plans, tap \"Add Data Plan\"<br />4. Scan the QR code in the camera frame<br />If you are asked to enter a confirmation code to activate the eSIM, enter the number that the carrier provided. Have a question? Please email to hello@hyperair.com and we will get back to you.</span>",
            "email-product-simcard-esim-code-title": "Here's your eSIM activation QR Code",
            "email-product-simcard-esim-code-warning": "Kindly note that the eSIM will be activated once the QR code is scanned. Please scan it only when you want to start the service.",
            "email-product-simcard-purchased-delievery-address": "Delivery Address",
            "email-product-simcard-purchased-delivery-info": "Delivery Info",
            "email-product-simcard-purchased-delivery-method": "Delivery Method",
            "email-product-simcard-purchased-discount": "Discount",
            "email-product-simcard-purchased-greeting": "Dear valued customer,<br><br>Thank you for using HyperAir. We are now preparing the delivery of your Travel SIM.",
            "email-product-simcard-purchased-greeting-esim-only": "Dear valued customer,<br><br>Thank you for using HyperAir, your eSIM is ready! Please find the attached QR code and activate according to the instructions.",
            "email-product-simcard-purchased-greeting-esim-with-sim": "Dear valued customer,<br><br>Thank you for using HyperAir. We are now preparing the delivery of your Travel SIM. For your eSIM, please find the attached QR code and activate according to the instructions.",
            "email-product-simcard-purchased-greeting-sim-only": "Dear valued customer,<br><br>Thank you for using HyperAir. We are now preparing the delivery of your Travel SIM.",
            "email-product-simcard-purchased-have-a-nice-trip": "Have a nice trip!",
            "email-product-simcard-purchased-important-notice": "Important Notice",
            "email-product-simcard-purchased-important-notice-content": "<span style=\"font-size: 10px; line-height: 12px;\">1. By Hong Kong Post's Local Mail, the estimated delivery will be within 5 working days. Status tracking is not available to local mail and customers shall bare the full responsibility of losing items by using Hong Kong </span><br> <span style=\"font-size: 10px; line-height: 12px;\">2. Please activate the Travel SIM card before expiry.</span><br> <span style=\"font-size: 10px; line-height: 12px;\">3. All delivered products are subject to terms and conditions.</span><br><br> <span style=\"font-size: 10px; line-height: 12px;\">Have a question? Please email to hello@hyperair.com and we will get back to you.</span>",
            "email-product-simcard-purchased-important-notice-content-esim-only": "<span style=\"font-size: 10px; line-height: 12px;\">1. By Hong Kong Post's Local Mail, the estimated delivery will be within 5 working days. Status tracking is not available to local mail and customers shall bare the full responsibility of losing items by using Hong Kong </span><br> <span style=\"font-size: 10px; line-height: 12px;\">2. Please activate the Travel SIM card before expiry.</span><br> <span style=\"font-size: 10px; line-height: 12px;\">3. All delivered products are subject to terms and conditions.</span><br><br> <span style=\"font-size: 10px; line-height: 12px;\">Have a question? Please email to hello@hyperair.com and we will get back to you.</span>",
            "email-product-simcard-purchased-important-notice-content-esim-with-sim": "<span style=\"font-size: 10px; line-height: 12px;\">1. By Hong Kong Post's Local Mail, the estimated delivery will be within 5 working days. Status tracking is not available to local mail and customers shall bare the full responsibility of losing items by using Hong Kong </span><br> <span style=\"font-size: 10px; line-height: 12px;\">2. Please activate the Travel SIM card before expiry.</span><br> <span style=\"font-size: 10px; line-height: 12px;\">3. All delivered products are subject to terms and conditions.</span><br><br> <span style=\"font-size: 10px; line-height: 12px;\">Have a question? Please email to hello@hyperair.com and we will get back to you.</span>",
            "email-product-simcard-purchased-important-notice-content-sim-only": "<span style=\"font-size: 10px; line-height: 12px;\">1. By Hong Kong Post's Local Mail, the estimated delivery will be within 5 working days. Status tracking is not available to local mail and customers shall bare the full responsibility of losing items by using Hong Kong </span><br> <span style=\"font-size: 10px; line-height: 12px;\">2. Please activate the Travel SIM card before expiry.</span><br> <span style=\"font-size: 10px; line-height: 12px;\">3. All delivered products are subject to terms and conditions.</span><br><br> <span style=\"font-size: 10px; line-height: 12px;\">Have a question? Please email to hello@hyperair.com and we will get back to you.</span>",
            "email-product-simcard-purchased-order-date": "Order Date",
            "email-product-simcard-purchased-order-details": "Order Details",
            "email-product-simcard-purchased-order-no": "Order Number",
            "email-product-simcard-purchased-personal-info": "Personal Info",
            "email-product-simcard-purchased-receipient-name": "Recipient Name",
            "email-product-simcard-purchased-receipient-phone-no": "Recipient Phone No.",
            "email-product-simcard-purchased-shipping-fee": "Shipping Fee",
            "email-product-simcard-purchased-sub-total": "Sub-total",
            "email-product-simcard-purchased-title": "Your Travel SIM order has been confirmed.",
            "email-product-simcard-purchased-title-esim-only": "Your Travel eSIM order has been confirmed.",
            "email-product-simcard-purchased-title-esim-with-sim": "Your Travel SIM order has been confirmed.",
            "email-product-simcard-purchased-title-sim-only": "Your Travel SIM order has been confirmed.",
            "email-product-simcard-purchased-total": "Total",
            "email-product-simcard-tracking-number-updated-greeting": "Dear valued customer,<br><br>Thank you again for using HyperAir. Your tracking number is updated.",
            "email-product-simcard-tracking-number-updated-title": "Your order tracking status is updated",
            "email-product-simcard-tracking-number-updated-tracking-no-sf": "Tracking Number",
            "email-product-type-confirmed-greeting": "Dear valued customer,<br><br>Thank you for using HyperAir. Your product is on its way.",
            "email-product-type-confirmed-title": "Your product is on its way",
            "email-product-type-purchased-greeting": "Dear valued customer,<br><br> Thank you for using HyperAir. We are now preparing the delivery of your product.",
            "email-product-type-purchased-title": "Your Product Purchase Order",
            "email-rate": "Rate",
            "email-shop-name": "Shop name",
            "email-verification-action": "Confirm Your Email",
            "email-verification-content": "Welcome to HyperAir! To finish signing up, you just need to confirm that we got your email right.",
            "email-verification-title": "Please confirm your email",
            "email-verified-content": "Your email is verified. Thank you for joining HyperAir.",
            "email-verified-title": "Email Verified",
            "engagement-content": "Use welcome10",
            "engagement-title": "Use welcome10",
            "exchange-approved-content": "Confirmation for buying {amount} {currency} at rate {rate}.",
            "exchange-approved-content2": "Confirmation for selling {amount} {currency} at rate {rate}.",
            "exchange-approved-footer": "",
            "exchange-approved-title": "Shop replied, \"Your travel money is ready for pickup!\"",
            "exchange-cancelled-content": "A client cancalled order for buying {amount} {currency} at rate {rate}.",
            "exchange-cancelled-content2": "A client cancelled order for selling {amount} {currency} at rate {rate}.",
            "exchange-cancelled-title": "Exchange Order Cancelled",
            "exchange-completed-content": "Completed for buying {amount} {currency} at rate {rate}.",
            "exchange-completed-content2": "Completed for selling {amount} {currency} at rate {rate}.",
            "exchange-completed-footer": "",
            "exchange-completed-title": "Your travel money exchange is completed!",
            "exchange-confirmed-content": "You confirmed a client for buying {amount} {currency} at rate {rate}.",
            "exchange-confirmed-content2": "You confirmed a client for selling {amount} {currency} at rate {rate}.",
            "exchange-confirmed-footer": "",
            "exchange-confirmed-title": "New Exchange Order Received",
            "exchange-pending-content": "Review new order for buying {amount} {currency} at rate {rate}.",
            "exchange-pending-content2": "Pending order for selling {amount} {currency} at rate {rate}.",
            "exchange-pending-title": "Pending New Order Approval",
            "exchange-rejected-content": "Order cannot be taken for buying {amount} {currency} at rate {rate}. Please book with another shop again.",
            "exchange-rejected-content2": "Order cannot be taken for selling {amount} {currency} at rate {rate}. Please book with another shop again.",
            "exchange-rejected-title": "Oops! Sorry, the shop is unable to take your order.",
            "footer-trouble-link": "If you’re having trouble clicking the \"{actionText}\" button, copy and paste the URL below into your web browser: <a href=\"{actionUrl}\">{actionUrl}</a>",
            "password-reset-action": "Reset Password",
            "password-reset-content": "You are receiving this email because we received a password reset request for your account.",
            "password-reset-footer": "If you did not request a password reset, no further action is required.",
            "password-reset-title": "Password Reset",
            "simcard-purchased-title": "",
            "sms-verification-content": "Your HyperAir Code is {verificationCode}"
        },
        "error": {
            "all-shops-are-closed": "Oops, all shops are closed right now. Please try again later.",
            "cancel-booking-failed": "This order may be completed, expired or cancelled. Please check this order in [My Bookings > Completed] or [My Bookings > Uncompleted].",
            "cancel-booking-failed-title": "Unable to cancel this order",
            "invalid-api-app-version": "Update the APP now to get the new functions and enjoy the 5% discount on Travel SIM order with promo code “GIVEME5”!!",
            "invalid-old-password": "Existing password is invalid.",
            "password-incorrect": "Incorrect password.",
            "phone-number-is-already-registered": "This phone number has already been registered with another email address. You can log in with the correct email address. Please email to hello@hyperair.com for any support.",
            "this-email-is-registered": "This email address is already used by another account.",
            "this-phone-number-is-registered": "This phone number has already been registered. Please email to hello@hyperair.com for any support."
        },
        "marketplace": {
            "homepage-product": "Popular Products",
            "homepage-recently-viewed": "Recently Viewed",
            "product-carousels": {
                "group1": "Most Popular",
                "group2": "Top Rated"
            }
        }
    },
    "fr": {
        "currency": {
            "aed": "Dirham",
            "afn": "Afghani",
            "all": "Lek albanais",
            "amd": "dram arménien",
            "ang": "Pays-Bas Antillaise Gulden",
            "aoa": "Kwanza angolais",
            "ars": "Peso argentin",
            "aud": "Dollar australien",
            "awg": "Florin Arubais",
            "azn": "manat azerbaïdjanais",
            "bam": "Bosnie-Herzégovine Marka",
            "bbd": "Dollar Barbadien",
            "bdt": "Taka bangladais",
            "bgn": "Lev bulgare",
            "bhd": "Dinar bahreïni",
            "bif": "Franc du Burundi",
            "bnd": "Dollar de Brunei",
            "bob": "Boliviano bolivien",
            "brl": "Real brésilien",
            "bsd": "Dollar Bahaméen",
            "btc": "Bitcoin",
            "btn": "Ngultrum",
            "bwp": "Botswana Pula",
            "byn": "Nouveau Rouble biélorusse",
            "bzd": "Belize Dollar",
            "cad": "Dollar canadien",
            "cdf": "Franc congolais",
            "chf": "Franc suisse",
            "clp": "Peso chilien",
            "cop": "Peso colombien",
            "crc": "Colon costaricain",
            "cup": "Le peso cubain",
            "cve": "Escudo capverdien",
            "czk": "Couronne tchèque",
            "djf": "Franc djiboutien",
            "dkk": "Couronne danoise",
            "dop": "Peso Dominicain",
            "dzd": "Dinar Algérien",
            "egp": "Livre égyptienne",
            "ern": "Nakfa érythréen",
            "etb": "Birr éthiopien",
            "eur": "euro",
            "fjd": "Dollar fidjien",
            "fkp": "Îles Falkland Pound",
            "gbp": "Livre sterling",
            "gel": "lari géorgien",
            "ghs": "Cedi ghanéen",
            "gip": "Livre de Gibraltar",
            "gmd": "Dalasi gambien",
            "gnf": "Franc guinéen",
            "gtq": "Quetzal guatémaltèque",
            "gyd": "Dollar guyanais",
            "hkd": "Dollar de Hong Kong",
            "hnl": "lempiras",
            "hrk": "Kuna",
            "htg": "Gourde haïtienne",
            "huf": "Forint hongrois",
            "idr": "roupie indonésienne",
            "ils": "Nouveau shekel israélien",
            "inr": "roupie indienne",
            "iqd": "Dinar irakien",
            "irr": "Rial iranien",
            "isk": "Couronne islandaise",
            "jmd": "Dollar jamaïcain",
            "jod": "Dinar jordanien",
            "jpy": "Yen japonais",
            "kes": "Shilling kenyan",
            "kgs": "Som Kyrgyzstani",
            "khr": "Riel cambodgien",
            "kmf": "Franc comorien",
            "kpw": "Won nord-coréen",
            "krw": "Won sud-coréen",
            "kwd": "Dinar koweïtien",
            "kyd": "Îles Caïmans Dollar",
            "kzt": "tenge kazakh",
            "lak": "Lao Kip",
            "lbp": "libanais Lira",
            "lkr": "Srilankaise",
            "lrd": "Dollar libérien",
            "lsl": "Lesotho Loti",
            "lvl": "lats letton",
            "lyd": "Dinar libyen",
            "mad": "Dirham marocain",
            "mdl": "Leu moldave",
            "mga": "Malagasy Ariary",
            "mkd": "Macédoine Denar",
            "mmk": "kyats Myanma",
            "mnt": "Mongolie Tugrik",
            "mop": "Pataca Macanese",
            "mro": "Ouguiya mauritanien",
            "mur": "Roupie mauricienne",
            "mvr": "Rufiyaa Maldivienne",
            "mwk": "cloche malaisienne",
            "mxn": "Peso mexicain",
            "myr": "cloche malaisienne",
            "mzn": "Mozambique Metical",
            "nad": "Dollar namibien",
            "ngn": "Naira nigérian",
            "nio": "Nicaragua Cordoba",
            "nok": "Couronne norvégienne",
            "npr": "Roupie népalaise",
            "nzd": "Dollar néo-zélandais",
            "omr": "Riyal d'Oman",
            "pab": "Panama Balboa",
            "pen": "Nuevo Sol péruvien",
            "pgk": "Kina",
            "php": "Peso philippin",
            "pkr": "roupie pakistanaise",
            "pln": "zloty polonais",
            "pyg": "Guarani paraguayen",
            "qar": "Rial Qatari",
            "rmb": "renminbi",
            "ron": "Leu roumain",
            "rsd": "Dinar serbe",
            "rub": "Rouble russe",
            "rwf": "Franc rwandais",
            "sar": "Rial saoudien",
            "sbd": "Îles Salomon Dollar",
            "scr": "roupie seychelloise",
            "sdg": "Livre soudanaise",
            "sek": "Couronne suédoise",
            "sgd": "Dollar de Singapour",
            "shp": "Sainte-Hélène Livre",
            "sll": "Sierra-léonais",
            "sos": "Shilling de Somalie",
            "srd": "Dollar surinamien",
            "std": "Sao Tomé-et-Principe Dobra",
            "syp": "Livre syrienne",
            "szl": "Swazi Lilangeni",
            "thb": "Baht thaïlandais",
            "tjs": "somoni tadjik",
            "tmt": "Turkménistan Manat",
            "tnd": "Dinar tunisien",
            "top": "panga",
            "try": "Nouvelle livre turque",
            "ttd": "Trinité-et-Tobago Dollar",
            "twd": "Nouveau dollar de Taïwan",
            "tzs": "Shilling tanzanien",
            "uah": "Hryvnia ukrainien",
            "ugx": "Shilling ougandais",
            "usd": "Dollars américain",
            "uyu": "peso uruguayen",
            "uzs": "Som ouzbèke",
            "vef": "Bolivar vénézuélien",
            "vnd": "Dong Viêt Nam",
            "vuv": "Vanuatu Vatu",
            "wst": "Tala Samoan",
            "xaf": "Afrique centrale CFA",
            "xcd": "Dollar des Caraïbes orientales",
            "xdr": "Droits de tirage spéciaux",
            "xof": "CFA Afrique de l'Ouest Franc",
            "xpf": "Franc CFP",
            "yer": "Riyal du Yémen",
            "zar": "Rand sud-africain",
            "zmw": "Kwacha zambien"
        },
        "shop-currency-rate": {
            "rate-last-updated-x-days-ago": "il y a{time} jours Taux mis à jour",
            "rate-last-updated-x-hours-ago": "il y a heures{time} Taux mis à jour"
        },
        "hyperair": {
            "copyright-footer": "Droits d'auteur © 2018 HyperAir Incorporation Limited. Tous les droits sont réservés.",
            "today": "Aujourd'hui"
        },
        "product-simcard": {
            "shipping-methods": {
                "hkpost": "Hong Kong Post (Gratuit)",
                "international": "Transport maritime international",
                "sf": "SF Express (Hong Kong only. Courier fee payable on delivery. Free Shipping for orders over HK$399)"
            }
        },
        "country": {
            "afghanistan": "Afghanistan",
            "aland-islands": "Iles Aland",
            "albania": "Albanie",
            "algeria": "Algérie",
            "andorra": "Andorre",
            "angola": "Angola",
            "anguilla": "Anguilla",
            "antigua-&-barbuda": "Antigua et Barbuda",
            "antigua-barbuda": "Antigua-et-Barbuda",
            "argentina": "Argentine",
            "armenia": "Arménie",
            "aruba": "Aruba",
            "australia": "Australie",
            "austria": "L'Autriche",
            "azerbaijan": "Azerbaïdjan",
            "azores": "Açores",
            "bahamas": "Bahamas",
            "bahrain": "Bahrein",
            "bangladesh": "Bangladesh",
            "barbados": "Barbade",
            "belarus": "Biélorussie",
            "belgium": "Belgique",
            "belize": "Belize",
            "benin": "Bénin",
            "bermuda": "Bermudes",
            "bhutan": "Bhoutan",
            "bolivia": "Bolivie",
            "bonaire": "Bonaire",
            "bosnia-herzegovina": "Bosnie et Herzégovine",
            "botswana": "Botswana",
            "brazil": "Brésil",
            "british-virgin-islands": "Iles Vierges Britanniques",
            "brunei": "Brunei",
            "bulgaria": "Bulgarie",
            "burkina-faso": "Burkina Faso",
            "burundi": "Burundi",
            "cambodia": "Cambodge",
            "cameroon": "Cameroun",
            "canada": "Canada",
            "canary-islands": "les îles Canaries",
            "cape-verde-islands": "Iles du Cap Vert",
            "cayman-islands": "Îles Caïmans",
            "central-african-republic": "République centrafricaine",
            "chad": "Tchad",
            "chile": "Chili",
            "china": "Chine",
            "colombia": "Colombie",
            "comoros": "Les Comores",
            "congo": "Congo",
            "cook-islands": "les Îles Cook",
            "costa-rica": "Costa Rica",
            "cote-d-ivoire": "Cote D Ivoire",
            "croatia": "Croatie",
            "cruise-ship": "Bateau de croisière",
            "cuba": "Cuba",
            "curacao": "Curacao",
            "cyprus": "Chypre",
            "cyprus---north": "Chypre",
            "cyprus---south": "Chypre",
            "czech-republic": "République tchèque",
            "denmark": "Danemark",
            "djibouti": "Djibouti",
            "dominica": "La Dominique",
            "dominican-republic": "République Dominicaine",
            "dubai": "Dubai",
            "easter-island": "île de Pâques",
            "ecuador": "Équateur",
            "egypt": "Egypte",
            "el-salvador": "Le Salvador",
            "equatorial-guinea": "Guinée Équatoriale",
            "eritrea": "Erythrée",
            "estonia": "Estonie",
            "ethiopia": "Ethiopie",
            "europe": "Europe",
            "falkland-islands": "les îles Falkland",
            "faroe-islands": "Îles Féroé",
            "fiji": "Fidji",
            "finland": "Finlande",
            "france": "France",
            "french-guiana": "Guinée Française",
            "french-polynesia": "Polynésie française",
            "french-west-indies": "Antilles Françaises",
            "gabon": "Gabon",
            "gambia": "Gambie",
            "georgia": "Géorgie",
            "germany": "Allemagne",
            "ghana": "Ghana",
            "gibraltar": "Gibraltar",
            "greece": "Grèce",
            "greenland": "Groenland",
            "grenada": "Grenade",
            "guadeloupe": "Guadeloupe",
            "guam": "Guam",
            "guatemala": "Guatemala",
            "guernsey": "Guernesey",
            "guinea": "Guinée",
            "guinea---bissau": "Guinée Bissau",
            "guinea-bissau": "Guinée Bissau",
            "guyana": "Guyane",
            "haiti": "Haïti",
            "honduras": "Honduras",
            "hong-kong": "Hong Kong",
            "hungary": "Hongrie",
            "iceland": "Islande",
            "india": "Inde",
            "indonesia": "Indonésie",
            "iran": "Iran",
            "iraq": "Irak",
            "ireland": "Irlande",
            "isle-of-man": "Île de man",
            "israel": "Israël",
            "italy": "Italie",
            "jamaica": "Jamaïque",
            "japan": "Japon",
            "jersey": "Jersey",
            "jordan": "Jordan",
            "kazakhstan": "Kazakhstan",
            "kenya": "Kenya",
            "kiribati": "Kiribati",
            "kosovo": "Kosovo",
            "kuwait": "Koweit",
            "kyrgyz-republic": "République du Kirghizistan",
            "kyrgyzstan": "Kirghizistan",
            "laos": "Laos",
            "latvia": "Lettonie",
            "lebanon": "Liban",
            "lesotho": "Lesotho",
            "liberia": "Libéria",
            "libya": "Libye",
            "liechtenstein": "Liechtenstein",
            "lithuania": "Lituanie",
            "luxembourg": "Luxembourg",
            "macau": "macao",
            "macedonia": "Macédoine",
            "madagascar": "Madagascar",
            "madeira": "Madère",
            "malawi": "Malawi",
            "malaysia": "Malaisie",
            "maldives": "Maldives",
            "mali": "Mali",
            "malta": "Malte",
            "marshall-islands": "Iles Marshall",
            "martinique": "Martinique",
            "mauritania": "Mauritanie",
            "mauritius": "Maurice",
            "mayotte": "Mayotte",
            "mexico": "Mexique",
            "micronesia": "Micronésie",
            "moldova": "La Moldavie",
            "monaco": "Monaco",
            "mongolia": "Mongolie",
            "montenegro": "Monténégro",
            "montserrat": "Montserrat",
            "morocco": "Maroc",
            "mozambique": "Mozambique",
            "myanmar": "Myanmar",
            "namibia": "Namibie",
            "nauru": "nauru",
            "nepal": "Népal",
            "netherlands": "Pays-Bas",
            "netherlands-antilles": "Antilles Néerlandaises",
            "new-caledonia": "Nouvelle Calédonie",
            "new-zealand": "nouvelle-Zélande",
            "nicaragua": "Nicaragua",
            "niger": "Niger",
            "nigeria": "Nigeria",
            "niue": "Niue",
            "norfolk-islands": "Iles Norfolk",
            "north-korea": "Corée du Nord",
            "northern-marianas": "Mariannes du Nord",
            "norway": "Norvège",
            "oman": "Oman",
            "pakistan": "Pakistan",
            "palau": "palau",
            "palestine": "Palestine",
            "panama": "Panama",
            "papua-new-guinea": "Papouasie Nouvelle Guinée",
            "paraguay": "Le Paraguay",
            "peru": "Pérou",
            "philippines": "Philippines",
            "poland": "Pologne",
            "portugal": "Le Portugal",
            "puerto-rico": "Porto Rico",
            "qatar": "Qatar",
            "reunion": "réunion",
            "romania": "Roumanie",
            "russia": "Russie",
            "rwanda": "Rwanda",
            "saint-barthelemy": "Saint Barthélemy",
            "saint-martin": "Saint Martin",
            "saint-pierre-&-miquelon": "Saint Pierre Et Miquelon",
            "samoa": "Samoa",
            "san-marino": "Saint Marin",
            "sao-tome-&-principe": "Sao Tomé Et Principe",
            "sao-tome-principe": "Sao Tomé Et Principe",
            "satellite": "Satellite",
            "saudi-arabia": "Arabie Saoudite",
            "senegal": "Sénégal",
            "serbia": "Serbie",
            "seychelles": "les Seychelles",
            "sierra-leone": "Sierra Leone",
            "singapore": "Singapour",
            "slovak-republic": "République slovaque",
            "slovakia": "Slovaquie",
            "slovenia": "La Slovénie",
            "solomon-islands": "Îles Salomon",
            "somalia": "Somalie",
            "south-africa": "Afrique du Sud",
            "south-korea": "Corée du Sud",
            "spain": "Espagne",
            "sri-lanka": "Sri Lanka",
            "st-helena": "Sainte Hélène",
            "st-kitts": "Saint-Christophe",
            "st-kitts-&-nevis": "St Kitts et Nevis",
            "st-lucia": "Sainte Lucie",
            "st-vincent": "St Vincent",
            "st.-helena": "Sainte-Hélène",
            "st.-kitts": "Saint-Kitts",
            "st.-lucia": "Sainte Lucie",
            "sudan": "Soudan",
            "suriname": "Suriname",
            "swaziland": "Swaziland",
            "sweden": "Suède",
            "switzerland": "Suisse",
            "syria": "Syrie",
            "taiwan": "Taïwan",
            "tajikistan": "Tadjikistan",
            "tanzania": "Tanzanie",
            "thailand": "Thaïlande",
            "timor-l'este": "Timor L'Este",
            "togo": "Aller",
            "tonga": "Tonga",
            "trinidad-&-tobago": "Trinité et Tobago",
            "trinidad-tobago": "Trinité-et-Tobago",
            "tunisia": "Tunisie",
            "turkey": "dinde",
            "turkmenistan": "Turkmenistan",
            "turks-&-caicos": "Turks & Caicos",
            "turks-&-caicos-islands": "Îles Turks et Caicos",
            "turks-caicos-islands": "Îles Turques-et-Caïques",
            "uganda": "Ouganda",
            "ukraine": "Ukraine",
            "united-arab-emirates": "Emirats Arabes Unis",
            "united-kingdom": "Royaume-Uni",
            "united-states": "États Unis",
            "united-states-minor-outlying-islands": "Îles mineures éloignées des États-Unis",
            "uruguay": "Uruguay",
            "uzbekistan": "Ouzbékistan",
            "vanuatu": "vanuatu",
            "vatican-city": "Cité du Vatican",
            "venezuela": "Venezuela",
            "vietnam": "Vietnam",
            "virgin-islands": "Les iles vierges",
            "virgin-islands-(us)": "Îles Vierges Américaines",
            "wallis-&-futuna": "WALLIS ET FUTUNA",
            "wallis-futuna": "WALLIS ET FUTUNA",
            "yemen": "Yémen",
            "zambia": "Zambie",
            "zimbabwe": "Zimbabwe"
        },
        "inspiration": {
            "published-date": "Mon",
            "published-duration": ": durée jours avant",
            "published-duration-singular": "Hier",
            "published-duration-today": "Aujourd'hui"
        },
        "promotion-center": {
            "expires-at": "",
            "redeem": {
                "error": {
                    "already-redeemed": "Vous avez déjà échangé le coupon.",
                    "new-customer-only": "L'offre est valable pour les nouveaux clients uniquement.",
                    "not-found": "Code de promotion invalide"
                }
            }
        },
        "auth": {
            "failed": "Ces informations d'identification ne correspondent pas à nos enregistrements.",
            "throttle": "Trop de tentatives de connexion. Veuillez réessayer dans: secondes secondes."
        },
        "web": {
            "activity": {
                "countdown-title": "",
                "more-button": "More tour and tickets",
                "section-subtitle": "Find the cheapest tour and tickets in Singapore",
                "section-title": "Tour and Tickets"
            },
            "checkout": {
                "use-promo-code": ""
            },
            "checkout-failed": {
                "checkout-failed": ""
            },
            "checkout-success": {
                "checkout-success": "Paiement réussi",
                "continue-shopping-button": "Continuer vos achats",
                "done-button": "Fait👌🏻",
                "download-now": "Télécharger maintenant",
                "order-number": "numéro de commande",
                "register-email": "Votre email",
                "register-password": "Définir votre mot de passe",
                "sim-product": "<span class=\"bold\"> acheté: sim </span>. L'email de confirmation a été envoyé à: email.",
                "slogan": "Ouvrez l'application HyperAir pour profiter des privilèges de voyage exclusifs! Vous pouvez également avoir le suivi des commandes en temps réel dans l'application!",
                "slogan-password": "Un pas de plus! Vous pouvez profiter du coupon de bienvenue de la carte SIM 10 $ HK et du suivi des commandes en temps réel dans l'application!",
                "trace-order": "",
                "trace-order-password": "",
                "welcome-offer": "Un pas de plus! Vous pouvez profiter du coupon de bienvenue de la carte SIM 10 $ HK et du suivi des commandes en temps réel dans l'application!"
            },
            "country": {
                "all": "Tout",
                "contact-us-description": "疑問 到<a href=\"mailto:corporate@hyperair.com\\>corporate@hyperair.com</a>",
                "data": "Limite de données:",
                "day": "Journées):",
                "day-day": "journée",
                "esim": "eSIM",
                "esim-section-title": "Meilleur eSIM pour: pays",
                "num-of-review": ": nombre d'évaluations",
                "per-day": "journée",
                "phone-call": "Appel téléphonique",
                "plug-n-go": "",
                "plug-n-go-esim": "Achat instantané et utilisation",
                "plug-n-go-sim": "Branchez et utilisez",
                "section-title": "Meilleure carte SIM pour: pays",
                "section-title copy": "Meilleure carte SIM pour: pays",
                "sim": "SIM",
                "supplier": "Fournisseur:"
            },
            "download-app-banner": {
                "download-now": "Téléchargez l'application maintenant",
                "hyperair": "HyperAir",
                "subtitle": "Téléchargez et enregistrez l'application HyperAir pour profiter de l'offre de bienvenue de 10 HK $!",
                "title": "Voyagez plus intelligemment. Nulle part."
            },
            "email-subscription": {
                "cancel-button": "再諗一諗",
                "completed-subscribe": "Thank you for subscribing!",
                "confirm-button": "我要最抵優惠",
                "duplicate-email": "你的電郵已經訂閱了",
                "invalid-email": "Invalid email address",
                "title-1": "想Staycation價格跌至新低時通知你？",
                "title-2": "仲搜羅全城最抵既Staycation 及美食套餐優惠"
            },
            "fanfare": {
                "cover-title": "Offre Carte SIM",
                "datetime-format": "j M",
                "end-next-fanfare": "Prochaine carte SIM offre:",
                "end-title": "Restez à l'écoute de nos médias App et sociaux pour les prochaines offres SIM",
                "end-title2": "Restez à l'écoute de nos plateformes médias APP et sociaux pour la prochaine carte SIM offre",
                "more-details-button": "Plus de détails",
                "out-of-stock": "Épuisé",
                "popular-countries-subtitle": "Mail carènes, Livraison rapide",
                "popular-countries-title": "Populaire Cartes SIM",
                "section-title": "Cartes SIM à prix super réduit",
                "title": "Minuté | Cartes limitées",
                "x-inventory-left": "Dernier {inventory}"
            },
            "fanfare-breadcrumb": "Offre Carte SIM",
            "filter-button": {
                "filter": "Filtre"
            },
            "filter-container": {
                "apply": "",
                "category": "Catégorie",
                "category-aquarium": "Aquarium",
                "category-class": "Classe",
                "category-day-tour": "Visite d'une journée",
                "category-discount": "Remise",
                "category-diving": "Plongée",
                "category-food": "Nourriture",
                "category-massage-beauty": "Massage et de beauté",
                "category-museum": "Musée",
                "category-musical": "Musical",
                "category-outlet": "Sortie",
                "category-photography": "La photographie",
                "category-playground": "Terrain de jeux",
                "category-railway": "Chemin de fer",
                "category-show": "Spectacle",
                "category-ski": "Ski",
                "category-spa": "Spa",
                "category-theme-park": "Parc d'attractions",
                "category-ticket": "Billet",
                "category-transport": "Transport",
                "category-transport-ticket": "Transport ticket",
                "category-vr": "VR",
                "category-water-park": "Parc aquatique",
                "category-yoga": "Yoga",
                "category-zoo": "zoo",
                "clear-all": "Réinitialiser",
                "facilities": "Services & facilities",
                "filter": "Filtre",
                "food": "Food",
                "header": "Filtre",
                "popular-search": "Popular Search🔥",
                "price": "Prix",
                "provider": "site Voyage",
                "subcategory-buffet": "Buffet",
                "subcategory-car": "Voiture",
                "subcategory-facial": "soin du visage",
                "subcategory-food": "Nourriture",
                "subcategory-half-day-tour": "Demi-journée",
                "subcategory-massage": "Massage",
                "subcategory-meal-voucher": "repas Voucher",
                "subcategory-one-day-tour": "Excursion d'une journée",
                "subcategory-restaurant": "Restaurant",
                "subcategory-transport": "Transport",
                "tag": "Tag"
            },
            "footer": {
                "about-hyperair-description": "HyperAir est une plate-forme de voyage intelligente qui vous convient, offrant la solution de voyage la plus adaptée et la plus économique, pour que vous puissiez voyager plus intelligemment, où que vous soyez.",
                "download-now": "Télécharger maintenant",
                "email-subscription-button": "Subscribe",
                "email-subscription-placeholder": "Enter your email",
                "email-subscription-social-title": "or Follow our Facebook and Instagram",
                "email-subscription-title": "Subscribe to get the latest staycation discount",
                "travel-license": "Travel Agent Licence Number："
            },
            "fx-booking": {
                "back-button": "",
                "confirm-booking": "",
                "confirm-button": "",
                "contact-shop": "",
                "get-money-before": ""
            },
            "home": {
                "cover-button": "Expérience maintenant",
                "cover-subtitle": "Ouvrez-vous à un nouveau monde HyperAir",
                "cover-title": "Voyagez plus intelligemment. Nulle part.",
                "grid": {
                    "1": {
                        "subtitle": "Dernière inspiration",
                        "title": "Cat résidents dans l'église turque"
                    },
                    "2": {
                        "subtitle": "Dernière inspiration",
                        "title": "Jeux olympiques de Tokyo 2020 dans un an"
                    },
                    "3": {
                        "subtitle": "Coups chauds",
                        "title": "Garantie du meilleur prix en ligne"
                    },
                    "4": {
                        "subtitle": "Ưu đãi thời gian có hạn",
                        "title": "Fanfares thẻ SIM"
                    },
                    "5": {
                        "subtitle": "Destination populaire",
                        "title": "Coup d'œil sur le bord de Disneyland Galaxy"
                    }
                },
                "home-example": {
                    "column-subtitle-1": "Prenons l'exemple du voyage de 7 jours au Japon pour 2 personnes:",
                    "column-subtitle-2": "Comparaison de prix",
                    "column-title-1": "un voyage, maximisez vos économies",
                    "column-title-2": "Comparez 11 agences de voyages en ligne",
                    "hotel": "Récompenses d'hôtel",
                    "hotel-package-1": "Hôtel Nikko Osaka x6 nuits",
                    "insurance": "Assurance voyage",
                    "insurance-package-1": "Assurance voyage 7 jours x2",
                    "money": "Assurance voyage",
                    "money-package-1": "Échange JPD ¥ 410,000",
                    "save": "sauvegarder",
                    "sim": "Voyage SIM",
                    "sim-package-1": "Japon DoCoMo SIM 7 jours x2",
                    "slogan": "Comparez avant de réserver, économisez de l'argent pour votre prochain voyage!",
                    "total-saving": "Économies totales 1443 $",
                    "travel-experience": "Expérience de voyage",
                    "travel-experience-package-1": "JR Pass pour tout le Japon x2",
                    "travel-experience-package-2": "1 jour eTicket x2 Universal Studios Japan"
                },
                "media-header-title": "Press",
                "more": "Plus de carte SIM de voyage",
                "partners-title": "Partnership",
                "photo-banner-button": "apprendre encore plus",
                "photo-banner-title": "Échangez votre argent de voyage plus intelligemment",
                "services-header-description": "",
                "services-header-title": "Services de voyage à guichet unique",
                "services-icon-subtitle-1": "Vous aider à obtenir de l'argent de voyage plus intelligemment!",
                "services-icon-subtitle-2": "Offrez-vous les meilleures cartes SIM avec livraison gratuite!",
                "services-icon-subtitle-3": "Vous permettent d'explorer le monde avec une solution sur mesure!",
                "services-icon-title-1": "Argent de Voyage",
                "services-icon-title-2": "Travel SIM",
                "services-icon-title-3": "Expérience de voyage",
                "statistic": {
                    "num-of-city": "",
                    "num-of-comparison": "",
                    "num-of-experience": "",
                    "num-of-saving": ""
                },
                "testimonial-1-content": "個 app 很好",
                "testimonial-1-subtitle": "Utilisateur Android",
                "testimonial-1-user": "Christine Lam",
                "testimonial-2-content": "Carte SIM Carte SIM Carte SIM Carte SIM再買！",
                "testimonial-2-subtitle": "Utilisateur iOS",
                "testimonial-2-user": "ange",
                "testimonial-header-description": "",
                "testimonial-header-title": "Témoignages de clients",
                "travel-activities": {
                    "home-slogan": "Comparez et trouvez votre meilleure expérience de voyage à partir de différents sites Web"
                },
                "travel-country-header-description": "Classification claire, facile à choisir",
                "travel-country-header-title": "Travel SIM couvre 200 pays",
                "travel-info-header-description": "Vous apporter l'inspiration de voyage rouge",
                "travel-info-header-title": "Inspiration de voyage",
                "travel-marketplace-header-description": "",
                "travel-marketplace-header-title": "",
                "travel-sim-header-description": "Meilleure carte SIM traite de la livraison gratuite",
                "travel-sim-header-title": "SIM de voyage populaire"
            },
            "hotel": {
                "cover-subtitle": "Profitez de 5% Trip.com offre exclusive de réservation d'hôtel",
                "cover-title": "Récompenses de l'hôtel",
                "discount-detail": "Appliquer le code promo « HYPERAIR5 » pour profiter de 5% offre de réservation d'hôtel",
                "discount-title": "HYPERAIR5",
                "highlight-subtitle1": "Découvrez hôtels dans le monde pour un séjour unique.",
                "highlight-subtitle2": "Obtenez les meilleures offres et économisez votre argent pour le prochain Voyage.",
                "highlight-subtitle3": "Vérifiez les tarifs en tout temps partout.",
                "highlight-title1": "Couverture mondiale",
                "highlight-title2": "privilèges exclusifs",
                "highlight-title3": "Réservation en un clic"
            },
            "hypermiles": {
                "activity": "Activity",
                "balance": "Outstanding Balance",
                "benefit": "Your Privileges",
                "cumulative-purchase": "Accumulated Spending：HK$ {amount}",
                "diamond-black": "Diamond Black",
                "expire": "Expired HyperMiles ({date})",
                "expire-reminder-1": "HyperMiles is valid for one year from the shopping month",
                "expire-reminder-2": "Remember to use HyperMiles before expiry!",
                "hypermiles-total": "HyperMiles",
                "member": "Member",
                "member-tier": "You have become HyperAir {member_tier} member",
                "membership-details": "Membership Tier",
                "next-purchase": "save HK${amount} in your next purchase",
                "order-num": "Order No: {order_num}",
                "permanent-membership": "Permanent Membership",
                "popup-title": "HyperMiles Reward Scheme",
                "precious-platinum": "Precious Platinum",
                "product_purchase": "HyperMiles from gadgets purchase ({date})",
                "record": "HyperMiles Record",
                "royal-blue": "Royal Blue",
                "simcard_purchase": "HyperMiles from SIM purchase ({date})",
                "tier": "",
                "title": "HyperMiles. Explore the World, Enjoy the rebate!",
                "u-have": "Your have",
                "usage": "Redeemed HyperMiles",
                "what-is-hypermiles": "What is HyperMiles",
                "what-is-hypermiles-slogan1": "Spend more. Earn more!",
                "what-is-hypermiles-slogan2": "Every 100 HyperMiles can be used as HK$1 at checkout, no minimum spending limit",
                "what-is-hypermiles-slogan3": "Spend more at HyperAir to enjoy more privileges"
            },
            "hypermiles-disclaimer": "terms and conditions apply",
            "hypermiles-discount-diamond-black": "Spend every HK$1 to enjoy 1 HyperMiles",
            "hypermiles-discount-precious-platinum": "Spend every HK$1.5 to enjoy 1 HyperMiles",
            "hypermiles-discount-royal-blue": "Spend every HK$2 to enjoy 1 HyperMiles",
            "hypermiles-special-diamond-black": "Exclusive pre-sale offer",
            "hypermiles-spend-diamond-black": "Cumulative spending of HK$3,000",
            "hypermiles-spend-precious-platinum": "Cumulative spending of HK$1,500",
            "hypermiles-spend-royal-blue": "Basic Member",
            "login": {
                "email": "",
                "existing-user": "",
                "forgot-password": "",
                "forgot-password-please-fill-in-email": "",
                "login": "",
                "login-with-facebook": "",
                "login-with-google": "",
                "new-user": "",
                "or": "",
                "password": "",
                "phone-input-placeholder": "",
                "phone-input-title": "",
                "phone-verify": "",
                "resend-verification-code": "",
                "reset-password": "",
                "title": "",
                "verification-code-input-title": ""
            },
            "logo-loader": {
                "slogan": "We're almost there"
            },
            "my-order": {
                "amount": "",
                "esim-qrcode": "",
                "fx-status-cancelled": "",
                "fx-status-confirmed": "",
                "order-date": "",
                "order-details": "",
                "order-num": "",
                "status-confirmed": "",
                "status-pending-confirmation": "",
                "status-ready-to-ship": "",
                "status-shipped": ""
            },
            "my-order-details": {
                "delivery-info": "",
                "discount": "",
                "recipient-address": "",
                "recipient-email": "",
                "recipient-name": "",
                "recipient-tel": "",
                "shipping-method": "",
                "status": "",
                "total": "",
                "valid-date": ""
            },
            "nav": {
                "about-us": "À propos de nous",
                "car": "",
                "company": "Entreprise",
                "company-address": "Entrepreneurship Centre, Level 3, Cyberport 3, Hong Kong",
                "contact-us": "Contactez nous",
                "contact-us-description": "Envoyez un e-mail à <a href=\"mailto:hello@hyperair.com\">hello@hyperair.com</a> pour toute demande de renseignements.",
                "disclaimer": "Disclaimer",
                "download-app": "Télécharger l'application",
                "flight": "",
                "foodie": "Foodie",
                "home": "Home",
                "hotel": "Hôtel",
                "jobs": "Recrutement",
                "logout": "Connectez - Out",
                "media-coverage": "Press",
                "monthly-rental-hotel": "Monthly Rental Hotel",
                "privacy-policy": "Politique de confidentialité",
                "promo-banner-text": "HyperAir 客戶專享 5% Trip.com 獨家酒店折扣",
                "quarantine-hotel": "Long Stay Hotel",
                "refund-policy": "Politique de remboursement",
                "spa-and-beauty": "Spa and Beauty",
                "staycation": "Staycation",
                "tag-line": "Compare Travel Sites & Save Money",
                "terms-of-service": "conditions d'utilisation",
                "travel-activity": "",
                "travel-affiliate-codes": "coupons",
                "travel-affiliate-codes-md": "coupons",
                "travel-blog": "Blog",
                "travel-experience-d": "voyage et expérience",
                "travel-experience-md": "voyage et expérience",
                "travel-insurance": "Assurance voyage",
                "travel-insurance-md": "Assurance voyage",
                "travel-marketplace": "Gadgets Voyage",
                "travel-marketplace-md": "Gadgets Voyage",
                "travel-money": "Argent de Voyage",
                "travel-money-md": "Argent de Voyage",
                "travel-sim": "Travel SIM",
                "travel-sim-md": "Travel SIM"
            },
            "photo-banner": {
                "banner-button": ""
            },
            "product-card": {
                "num-of-review": "{num}-of-review ratings"
            },
            "redirection-gate": {
                "columns-1-description": "Comparez la meilleure expérience de Voyage de différents sites",
                "columns-1-title": "Activité Voyage Comparaison",
                "columns-2-description": "Meilleures offres de la carte SIM avec la livraison gratuite!",
                "columns-2-title": "Voyage SIM",
                "columns-3-description": "Comparez et réservez le meilleur taux de change en ville",
                "columns-3-title": "Argent de Voyage",
                "promo-code": "Code",
                "remember-to-fill-promo-code": "Rappelez-vous d'appliquer le code promo ci-dessus avant la caisse",
                "title": "We are taking you to {domain}",
                "trouble-link": "If the browser does not redirect you in 10 seconds, please click this <a href=\"{link}\">link</a>."
            },
            "register": {
                "guest-checkout": "",
                "title": ""
            },
            "seo": {
                "best-price-guarantee-title": "Best Price Guarantee",
                "country-description": "{country} Travel SIM - Meilleur Prix Garanti avec Livraison Gratuite",
                "country-keywords": "Cartes SIM, DataSIM, DataSIM,, 4G,, 4S, 4G 上 上, G, 4G,, 阪, 4G網卡, 大 上 網卡, 4G, 上 網卡, 4G, 上 網卡, 4G, 4G 上, 上, 4G, 4G 上,,中 4G 網卡, 中 上, 4G, 上, 4G,, 中 4G 上, 中國, 4G 上, 4G 上,上 網卡, Docomo, Softbank",
                "country-title": "{country} Travel SIM - Meilleur Prix Garanti avec Livraison Gratuite",
                "home-description": "HyperAir est une plate-forme de voyage intelligente qui vous convient, offrant la solution de voyage la plus adaptée et la plus économique, pour que vous puissiez voyager plus intelligemment, où que vous soyez.",
                "home-keywords": "sim 卡 sim, 網卡,, DataSIM, DataSIM, IM, 4G,, 4G, SIM, Voyage SIM, SIM, 錢 神器,,, X 器, 唱 錢, 唱 錢 app,,, 兌換 店,, 換 店,, 金融,, 外匯, 外滙,,,, 外幣,,,,,,,,, , 格 價, 特價, 預訂, 交易, 旅遊,, 泰國, 韓國, 韓國, 台灣, 日圓, 日元, 台幣,,,, HyperAir, HyperAir FX, Voyage HyperAir, Voyage, Voyage Money, Devises étrangères, , 堅 成, 發達 鳥, bird, oiseau fou, oiseau fou, échange de Berlin",
                "home-title": "HyperAir - Voyagez plus intelligemment. Nulle part. | Meilleur voyage SIM, FX, assurance voyage, expériences locales",
                "hotel-description": "Obtenez des offres de réservation d'hôtel supplémentaires via HyperAir.com",
                "hotel-keywords": "hôtel, hôtels, escompte, réservations, Asie, Europe, Amérique, Bangkok, Singapour, Hong Kong, Phuket, Thaïlande, Malaisie, Bali, Londres, Paris, programme de fidélité, LOGEMENTS, hébergement, andalousie, hébergement, location de vacances",
                "hotel-title": "Offres de l'hôtel",
                "money-exchange-description": "Check {shop_name}'s latest FX rate and book your travel money online. You can lock in FX rate and reserve foreign currency.",
                "money-exchange-keywords": "{shop_name}, 唱錢神器, 唱X神器, 唱錢X器, 唱錢, 兌換, 找換, 兌換店, 找換店, 銀行, 金融, 外匯, 外滙, 匯率, 滙率, 匯款, 外幣, 貨幣, 旅行, 旅遊, 行程, 酒店, 機票, 比較, 格價, 特價, 預訂, 交易, 旅遊保險, 日本, 泰國, 韓國, 台灣, 日圓, 日元, 台幣, 泰銖, HyperAir, HyperAir FX, HyperAir Travel, Travel, Travel Money, Foreign Currency, Foreign Exchange, 百年, 堅成, 發達鳥, 飛鳥, richbird, crazy bird, berlin exchange",
                "money-exchange-title": "{shop_name}'s latest FX rate with instant booking | Lock in FX rate and reserve your travel money instantly",
                "privacy-policy-title": "Privacy Policy",
                "refund-policy-title": "Refund & Return Policy",
                "sim-fanfares-description": "HyperAir a lancé la première carte SIM Fanfares à Hong Kong. Vous pouvez acheter des cartes SIM pour votre voyage avec des réductions jusqu'à 50% de réduction. Limitée dans le temps, offre limitée!",
                "sim-fanfares-keywords": "Fanfares, Musique SIMCARD, carte SIM, SIM 卡, 上 網卡, 電話 卡, 數據 卡, DataSIM, 旅遊 DataSIM, 數據 咭, 4G 上 網卡, 上 網卡, 4G 上 網卡, 日本 4G 上 網卡, 日本 上 網卡, 東京 4G 上 網卡, 東京 上 網卡, 大阪 4G 上 網卡, 大阪 上 網卡, 泰國 4G 上 網卡, 泰國 上 網卡, 曼谷 4G 上 網卡, 布吉 上 網卡, 芭提雅 4G 上 網卡, 台灣 4G 上 網卡, 台灣 上 網卡, 台北 4G上 網卡, 高雄 上 網卡, 台中 4G 上 網卡, 台中 上 網卡, 韓國 4G 上 網卡, 韓國 上 網卡, 首 爾 4G 上 網卡, 首 爾 上 網卡, 中國 4G 上 網卡, 中國 上 網卡, 深圳 4G 上 網卡, 深圳 上網卡, 澳門 4G 上 網卡, 澳門 上 網卡, Docomo, Softbank",
                "sim-fanfares-title": "Carte SIM Fanfares - durée limitée, Cartes limitée",
                "term-of-service-title": "Terms of Service",
                "travel-activity-search-results-description": "",
                "travel-activity-search-results-keywords": "{activity}, travel, local experience, local activity, ticket, activities, day tours, tourist attractions",
                "travel-activity-search-results-title": "HyperAir - Search Result of {q} in {city}",
                "travel-affiliate-codes-description": "HyperAir met à jour en permanence les derniers codes des codes de réduction / promotion pour réductions réservation d'hôtel, réductions de billets d'avion, réductions d'activités, réductions d'assurance Voyage, rabais de la carte SIM et des remises de cartes de crédit.",
                "travel-affiliate-codes-keywords": "Code de réduction, coupon électronique, code de réduction, code promotionnel, Promo Code, code de réduction, Hôtel, Billet, Offre, Carte de crédit Offre, Offre Voyage",
                "travel-affiliate-codes-title": "2023 Les derniers codes (Mises à jour Voyage discount par jour) | Réduction pour réservation pour les hôtels, vols, activités, assurance Voyage, données SIM",
                "travel-insurance-description": "Rechercher les meilleurs plans d'assurance Voyage? Quels sont les plans couvrent les téléphones mobiles? Comparez les régimes d'assurance des entreprises comme AIG, MSIG et Starr, et acheter en ligne avec une remise supplémentaire!",
                "travel-insurance-keywords": "AIG, MSIG, Starr, AIG Promocode, MSIG Promocode, Starr Promocode, Assurance Voyage, Assurance Voyage en ligne, comparer Assurance Voyage, Assurance Voyage pas cher, assurance Voyage HONGKONG, unique voyage, plan annuel",
                "travel-insurance-title": "Meilleur Voyage Assurance frais et comparaisons à Hong Kong 2023",
                "travel-marketplace-checkout-payme-title": "Pay with PayMe",
                "travel-marketplace-checkout-success-keywords": "創意, 產品, 流行, 電器, 生活, 精品, 智能家居, 設計, 高品質, 設計概念, 創意科技, 生活用品, 戶外休閒, 廚房, 餐桌, 個人護理, 防疫抗疫, 健康, 遊戲, 兒童玩樂, 健身, 家居健身, gym, home gym, smart home, style home",
                "travel-marketplace-checkout-success-title": "{product_name}",
                "travel-marketplace-description": "A collection of coolest gadgets that you'll like",
                "travel-marketplace-keywords": "創意, 產品, 流行, 電器, 生活, 精品, 智能家居, 設計, 高品質, 設計概念, 創意科技, 生活用品, 戶外休閒, 廚房, 餐桌, 個人護理, 防疫抗疫, 健康, 遊戲, 兒童玩樂, 健身, 家居健身, gym, home gym, smart home, style home",
                "travel-marketplace-product-checkout-title": "{product}",
                "travel-marketplace-product-title": "{product}",
                "travel-marketplace-title": "Gadgets Voyage",
                "travel-money-description": "HyperAir vous offre une toute nouvelle façon d’obtenir de l’argent de voyage. Maintenant, vous pouvez réserver l'échange en ligne avec le meilleur taux de change de la ville!",
                "travel-money-keywords": "sim,, 卡, 卡, DataSIM, DataSIM, 咭, 4G 網卡,, 4G, 錢 神器, X 神器, 錢 X 器, 錢, 錢,, , 兌換 店, 找 換 店,, 金融,,,, 滙率, 匯款, 外幣, 貨幣,,, 旅遊,,,,,,,,,,,,, , 泰國, 韓國, 台灣, 日圓, 日元,,, HyperAir, HyperAir FX, Voyage HyperAir, Voyage, Argent de voyage, Devises étrangères, Échange de devises,, 鳥, bird, Richbird, oiseau fou , échange de berlin",
                "travel-money-title": "HyperAir - Exchange Travel Money Smarter.",
                "travel-product-checkout-keywords": "創意, 產品, 流行, 電器, 生活, 精品, 智能家居, 設計, 高品質, 設計概念, 創意科技, 生活用品, 戶外休閒, 廚房, 餐桌, 個人護理, 防疫抗疫, 健康, 遊戲, 兒童玩樂, 健身, 家居健身, gym, home gym, smart home, style home",
                "travel-product-keywords": "創意, 產品, 流行, 電器, 生活, 精品, 智能家居, 設計, 高品質, 設計概念, 創意科技, 生活用品, 戶外休閒, 廚房, 餐桌, 個人護理, 防疫抗疫, 健康, 遊戲, 兒童玩樂, 健身, 家居健身, gym, home gym, smart home, style home",
                "travel-sim-checkout-description": "{country} Travel SIM - Carte SIM de haute qualité avec livraison gratuite à domicile!",
                "travel-sim-checkout-keywords": "網卡, 卡, 卡, DataSIM, DataSIM, 咭, 4G, 網卡, 4G, 4G 上, 上 網卡, 4G,,,,, 大,大阪 上 網卡, 4G,, 4G, 網卡, 4G, 4G, 上 網卡, 4G,, 上 網卡, 中 4G, , 中 上 網卡, 4G, 上 網卡, 爾 4G, 爾 上, 中國 4G, 中國 上, 4G 上,, 上, 4 上, , Docomo, Softbank",
                "travel-sim-checkout-success-description": "{country} Travel SIM - Carte SIM de haute qualité avec livraison gratuite à domicile!",
                "travel-sim-checkout-success-keywords": "網卡, 卡, 卡, DataSIM, DataSIM, 咭, 4G, 網卡, 4G, 4G 上, 上 網卡, 4G,,,,, 大,大阪 上 網卡, 4G,, 4G, 網卡, 4G, 4G, 上 網卡, 4G,, 上 網卡, 中 4G, , 中 上 網卡, 4G, 上 網卡, 爾 4G, 爾 上, 中國 4G, 中國 上, 4G 上,, 上, 4 上, , Docomo, Softbank",
                "travel-sim-checkout-success-title": "Succès de paiement - Travel SIM",
                "travel-sim-checkout-title": "Passer la commande - Carte SIM de voyage",
                "travel-sim-keywords": "sim 上, 網卡, 卡, 卡, DataSIM, DataSIM, 咭, 4G,, 4G, 上 網卡, 咭 sim 卡, 4G,,, 4G網卡, 大 上 網卡, 4G, 上 網卡, sim 卡, 4G, 上, 4G 上, 4G 上, 上, sim 卡, 4G 網卡, 中 4G, 中 上, 韓國 sim, 4G, 網卡, 爾 4G, 爾, 中 4G 上, 中, 中, 中國 內地 數據 卡, 4G, 上 網卡, 4G, 上 網卡, 4G, 上 網卡, 歐洲 sim 卡, 4G 上,,,, , 4G, 上 網卡, 法國 sim, 大利 4G, 大利 上 網卡, 大利 sim, 4G 上 網卡, 上, sim, 大 sim, 4G 上,瑞士 sim 卡, Docomo, Softbank,,, 3hk, 3uk, birdie, 鳥, air sim, sim2fly, AIS, sim2fly, SK Telecom, TrueMove, dtac, téléphone mobile, vietnamobile",
                "travel-sim-title": "【{country} SIM】{sim_name} - Garantie du meilleur prix avec livraison gratuite",
                "travel-sims-description": "Global Travel SIM Search Engine avec carte SIM de haute qualité et livraison gratuite à domicile!",
                "travel-sims-keywords": "sim,, 卡, 卡, DataSIM, DataSIM, 咭, 4G 網卡, 4Gsim 卡, 4G, 上, sim 卡, 4G 東京,, 大 4G網卡, 大 上 網卡, 4G, 上 網卡, sim 卡, 4G, 上, 4G 上, 4G 上, 上, sim 卡, 4G 網卡, 中 4G, 中 上, 韓國 sim, 4G, 網卡, 爾 4G, 爾, 中 4G 上, 中, 中, 中 內地 數據 卡, 4G 網卡, 上 網卡, 4G 網卡, 上 網卡, sim, 歐洲 sim, Docomo, Softbank, sim2fly, AIS, sim2fly, SKIM, TrueMove, dtac , téléphone portable, vietnamobile",
                "travel-sims-title": "Travel SIM - Garantie du meilleur prix avec livraison gratuite"
            },
            "shop-confirmation": {
                "app-download": "",
                "app-download-subtitle": "",
                "instruction": "",
                "my-order": "",
                "pending-confirm": ""
            },
            "staycation": {
                "activity-countdown-button": "Find the cheapest price",
                "all-hotels": {
                    "sorting": {
                        "recommended": "Recommended"
                    }
                },
                "all-hotels-all-button": "All",
                "all-hotels-hotel-name": "Hotel Name",
                "all-hotels-last-updated": "Last Updated",
                "all-hotels-less-button": "Less",
                "all-hotels-more-button": "More",
                "all-hotels-no-result": "Sorry, we couldn't find any results",
                "all-hotels-title": "",
                "compare-packages": "Compare other packages",
                "countdown-button": "More Details",
                "countdown-title": "",
                "countdown2-title": "HyperAir Recommended",
                "countdown3-title": "最新 Staycation 酒店限時優惠",
                "month-format": "MMM",
                "order-d-title": "浪漫精品酒店 💕💕",
                "order-g-subtitle": "暑假帶埋一家大細Relax下",
                "order-g-title": "親子Staycation必去之選👨‍👩‍👧‍👦😍",
                "order-h-title": "郵輪之旅🛳️",
                "order-i-title": "情侶煮飯仔酒店 🍽️",
                "order-j-title": "Glamping豪華露營推介",
                "seo-description": "點解咁多人用 HyperAir 搵 Staycation? 因為集合左 KKday, Trip.com, Klook 及各大香港酒店平台，一眼比較邊到有late checkout、免費泊車、自助早午晚餐及餐飲回贈等獨家 Staycation 優惠，每日更新。",
                "seo-keywords": "staycation, staycation 優惠, 香港 staycation, staycation 香港, staycation hk, staycation package, staycation hong kong, 酒店, 酒店 優惠, staycation 中文, 香港 酒店, klook 優惠, klook 優惠, kkday 優惠, trip 優惠, agoda 優惠, runhotel staycation, 酒店 套票, staycation 酒店, 香港 酒店 套票, 訂 酒店 優惠, 酒店 package, 特價 酒店, 香港 優惠 酒店, 酒店 優惠 套 票, 特價 酒店 香港, 香港 酒店 優惠, 酒店 住宿 優惠, staycation 2020, staycation 2021, staycation 2022, staycation 1月 優惠, staycation 2月 優惠, staycation 3月 優惠, staycation 4月 優惠, staycation 5月 優惠, staycation 6月 優惠, staycation 7月 優惠, staycation 8月 優惠, staycation 9月 優惠, staycation 10月 優惠, staycation 11月 優惠, staycation 12月 優惠, 四季酒店, W酒店, Murray, JW Marriott, St. Regis, Conrad Hotel, Grand Hyatt, Ritz Carlton, Rosewood, 露台 酒店, 廚房 酒店, 親子 酒店, 情侶 酒店",
                "seo-title": "【2021年9月最新】香港酒店 Staycation 優惠搜尋神器 全港最齊．每日更新 - 最齊香港staycation優惠、酒店優惠、Hong Kong Staycation Ideas、Klook優惠、KKday優惠、Trip優惠、Agoda優惠、專業旅運優惠 - HyperAir 玩樂必備搜尋比較平台！一次過，比較全球多個玩樂旅遊預訂網站！ - HyperAir",
                "share-button-alert": "Copied the Link",
                "subtitle": "每日更新酒店餐飲及住宿優惠（{start_month}月至{end_month}月）",
                "title": "",
                "top10-title": "",
                "top102-title": "",
                "top103-title": "值得一試的 Staycation 酒店🥂"
            },
            "travel-activities": {
                "best-deals": "Best Deal",
                "book-now": "View Deal",
                "disclaimer": "Les prix indiqués sont uniquement à titre de référence. En cas de divergence, veuillez vous référer au site Internet de nos partenaires.",
                "empty-destination": "",
                "more-deals": "More Deals",
                "not-available": "Not Available",
                "offers": "",
                "provider-getyourguide": "GetYourGuide",
                "provider-hk": {
                    "trip": {
                        "com": "Trip.com"
                    }
                },
                "provider-hyperair": "HyperAir",
                "provider-kkday": "KKday",
                "provider-klook": "KLOOK",
                "provider-seoultravelpass": "SeoulPass",
                "provider-sim": {
                    "hyperair": {
                        "com": "HyperAir"
                    }
                },
                "provider-travelexpert": "Travel Expert",
                "provider-trip": "Trip.com",
                "ratings": "Évaluation",
                "recommended-title": "Plus d'activités populaires à {city}",
                "search-africa-oceania": "Afrique / Océanie",
                "search-all-cities": "Toutes les villes",
                "search-america": "Amérique",
                "search-asia": "Asie",
                "search-button": "Chercher",
                "search-cancel-button": "Annuler",
                "search-country-placeholder": "Entrez le pays ou la ville",
                "search-euro-middleeast": "Europe / Moyen-Orient",
                "search-hardcoded-cities": "Recherche populaire:",
                "search-placeholder": "Recherchez \"JR Pass\"",
                "search-popular-cities": "Villes populaires",
                "search-searched-cities": "Villes recherchées",
                "search-slogan-2": "",
                "show-similar-product": "comparer similaires",
                "sorting": {
                    "price-asc": "Prix ​​croissant)",
                    "price-desc": "Prix ​​(du plus élevé au plus bas)",
                    "rating": "Évaluation",
                    "relevance": "Pertinence",
                    "sort-by": "Trier par"
                },
                "title": "Résultats de recherche correspondant à \": q\"",
                "title-everything": "Activités populaires à {city}",
                "title-no-result": "Désolé, nous n'avons trouvé aucun résultat pour \"{q}\"",
                "title-no-result-without-keyword": "Désolé, nous ne avons trouvé aucun résultat",
                "total-results": "Total <b>{number}</b> de résultats"
            },
            "travel-affiliate-codes": {
                "cover-slogan": "Fournir des codes réduction pour les sites de réservation de Voyage internationaux",
                "cover-title": "Bons de réduction Voyage",
                "disclaimer": "Les offres de promotion ne sont données qu'à titre de référence. En cas de divergence, s'il vous plaît consulter le site Web des partenaires. Les fournisseurs peuvent modifier ou supprimer l'information à tout moment sans préavis et ont la seule discrétion de l'offre.",
                "exclusive": "Exclusif",
                "type-activity": "Activité",
                "type-air": "Billet d'avion",
                "type-all": "Tout",
                "type-hotel": "Hôtel",
                "type-insurance": "Assurance voyage",
                "type-shopping": "Achats",
                "type-sim": "Carte SIM",
                "use-promo-code": "Obtenir le code",
                "valid-until": "Valable jusque:"
            },
            "travel-insurance": {
                "breadcrumb-travel-insurance": "Assurance voyage",
                "cover-subtitle": "Recherchez et comparez la meilleure assurance Voyage avec une couverture de téléphone mobile!",
                "cover-title": "Assurance voyage",
                "departure-date-alert": "",
                "disclaimer": "Citation est pour référence. S'il vous plaît consulter le site Web de la compagnie d'assurance pour plus de détails.",
                "highlight-subtitle1": "Liste sur la couverture clé des régimes d'assurance Voyage pour votre sélection facile",
                "highlight-subtitle2": "Comparez les meilleures offres d'assurance Voyage pour vous aider à économiser chaque dollar!",
                "highlight-subtitle3": "Profitez de privilèges exclusifs d'assurance Voyage et des offres!",
                "highlight-title1": "couverture Comparaison",
                "highlight-title2": "Comparaison prix",
                "highlight-title3": "Récompenses exclusives",
                "num-of-travellers-alert": "",
                "partner-title": "Notre Assurance Voyage Partenaires",
                "return-date-alert": "",
                "section-title": "Vous êtes à la recherche maintenant {num_of_day} pour voyageur {num_of_traveller} (s)",
                "slogan": "3 étapes faciles",
                "sorting": {
                    "coverage": "La meilleure protection",
                    "price-asc": "Prix ​​croissant)",
                    "price-desc": "Prix ​​(décroissant)"
                },
                "step1": "Remplissez les informations",
                "step1-detail": "Entrez votre destination, la date et non. des voyageurs",
                "step2": "Comparer les plans",
                "step2-detail": "Comparez le prix et la couverture des différents régimes d'assurance Voyage",
                "step3": "Profitez des offres",
                "step3-detail": "Un clic pour profiter des offres exclusives d'assurance Voyage"
            },
            "travel-insurance-product-card": {
                "apply-now": "Obtenez l'offre",
                "cancellation": "ANNULATION",
                "car-rental": "LOCATION DE VÉHICULES EXCES",
                "cruise-vacation": "LOCATION DE VACANCES DE CROISIÈRE (avantages en option)",
                "dangerous-sports": "SPORTS DANGEREUSE",
                "hyperair-exclusive": "HYPERAIR EXCLUSIF",
                "medical": "MÉDICAL",
                "mobile": "PERTE / DOMMAGES DE TÉLÉPHONE MOBILE",
                "personal-belongings": "AFFAIRES PERSONNELLES",
                "trip-delay": "RETARD DE VOYAGE"
            },
            "travel-insurance-search-bar": {
                "children": "Les enfants âgés de moins de 18 ans",
                "date": "Date de départ et de retour",
                "destination": "Où vas-tu",
                "friend": "Amis / parents",
                "myself": "Moi même",
                "number-of-traveller": "Nombre de voyageurs",
                "search-button": "Chercher",
                "spouse": "Époux"
            },
            "travel-marketplace": {
                "buy-now-can-earn-x-miles": "",
                "cover-slogan": "Une collection de gadgets les plus cools que vous aimerez",
                "cover-title": "Gadgets Voyage"
            },
            "travel-marketplace-categories": "Categories",
            "travel-marketplace-checkout": {
                "delivery-message-body": "Les jours ouvrables sont du lundi au vendredi (sauf jours fériés). Le est 24{00} (GMT + 8) coupure de l'ordre du temps. Les commandes passées après 24{00} (GMT + 8) expédieront le jour ouvrable suivant.",
                "delivery-method-1": "SF Express (Hong Kong uniquement)",
                "delivery-method-1-description": "Par SF Express, les frais de courrier est de 30 $ HK par commande. les frais de courrier est levée lors de l'achat au-dessus de HK $ 800. Les articles commandés seront livrés par courrier dans les 1-3 jours ouvrables, et les îles prendront 5 jours ouvrables, se référant au site Web SF Express.",
                "delivery-method-2": "Transport maritime international",
                "delivery-method-2-description": "Livraison en 4 à 15 jours ouvrables selon la destination. Frais d'expédition est HK 100 $ par article. Les frais de livraison internationale ci-dessus est basée sur l'estimation. De plus en supplément peut demander."
            },
            "travel-money": {
                "breadcrumb-travel-money": "Argent de Voyage",
                "cover-button": "Expérience maintenant",
                "cover-slogan": "Échangez votre argent de voyage plus intelligemment",
                "cover-title": "Argent de Voyage",
                "disclaimer": "Les prix indiqués sont uniquement pour référence. En cas de divergence, s'il vous plaît consulter le site Web des bureaux de change.",
                "empty-amount": "",
                "fx": "",
                "fx-slogan": "Quatre étapes faciles",
                "fx-step1": "Chercher",
                "fx-step1-detail": "Choisissez la devise que vous souhaitez échanger",
                "fx-step2": "Comparer",
                "fx-step2-detail": "Trouvez le meilleur tarif et le lieu de prise en charge le plus pratique",
                "fx-step3": "Livré",
                "fx-step3-detail": "Réserver l'argent du voyage en ligne",
                "fx-step4": "Ramasser",
                "fx-step4-detail": "Afficher le code QR pour obtenir l'argent du voyage",
                "hyperair-feature-1": "Intelligent",
                "hyperair-feature-1-description": "Une façon intelligente d’échanger de l’argent de voyage. En quelques clics, vous pouvez désormais déterminer le meilleur tarif et réserver en ligne l'argent du voyage. Il est temps de dire au revoir à la longue file!",
                "hyperair-feature-2": "Fiable",
                "hyperair-feature-2-description": "Un moyen fiable d'obtenir de l'argent. Tous nos partenaires sont des banques et des échangeurs de fonds agréés qui assurent la sécurité de vos opérations de change.",
                "hyperair-feature-3": "Nulle part. À tout moment.",
                "hyperair-feature-3-description": "Une toute nouvelle façon d'obtenir de l'argent de voyage. Nous souhaitons élargir notre présence à l’étranger et vous offrir la meilleure expérience de voyage au monde.",
                "i-will-get": "J'AURAI",
                "i-will-pay": "JE PAIERAI",
                "join-us": "Pour plus d'opportunité d'affaires",
                "join-us-button": "Rejoignez nous maintenant",
                "join-us-slogan": "Devenir notre fournisseur",
                "search-bar-placeholder": "Entrer le montant",
                "search-button": "Chercher",
                "section-title": "",
                "section-title-from-hkd": "Recherche HKD pour {amount} {currency}",
                "section-title-to-hkd": "Recherche {amount} {currency} pour HKD",
                "why-hyperair": "",
                "why-hyperair-description": "HyperAir vous offre une toute nouvelle façon d’obtenir de l’argent de voyage. Maintenant, vous pouvez réserver l'échange en ligne avec le meilleur taux de change de la ville!",
                "why-hyperair-title": "Pourquoi nous choisir?"
            },
            "travel-product": {
                "buy-now": "Acheter maintenant",
                "product-option": "options"
            },
            "travel-sim": {
                "as-low-as": "Aussi bas que",
                "book-now": "Commandez maintenant",
                "breadcrumb-homepage": "Page d'accueil",
                "breadcrumb-mainpage": "Page d'accueil",
                "breadcrumb-travel-sim": "Travel SIM",
                "cancellation-policy": "Politique d'annulation",
                "cancellation-policy-content": "Aucune annulation, remboursement ou changement ne peut être effectué après l'achat.",
                "download-hyperair-now-description": "Scannez le code QR ou rendez-vous sur l'App Store pour télécharger l'application HyperAir.",
                "download-hyperair-now-title": "Téléchargez l'application HyperAir",
                "first-step": "Étape 1",
                "go-to-shopping-cart-description": "",
                "go-to-shopping-cart-title": "",
                "hardcoded-countries-title": "Autres Pays populaires:",
                "highlights": "Points forts",
                "important-notice": "Avis important",
                "instructions": "instructions",
                "lowest-price-guarantee": "Garantie du meilleur prix",
                "no-stock": "Épuisé",
                "num-of-review": ": num-of-review reviews",
                "popular-countries": "Travel SIM couvre 200 pays",
                "popular-countries-search-button": "Rechercher d'autres pays",
                "product-highlights": "Product Description",
                "product-specification": "Spécification de produit",
                "related-sims": "Connexes: pays SIM",
                "related-sims-search-button": "Plus: pays SIM",
                "review": "La revue",
                "review-date": "{Date}",
                "review-no-firstname-user": "Voyageur",
                "scan-product-qr-code": "一掃 QR Code 此 產品",
                "second-step": "Étape 2",
                "sim": " Sim Cards",
                "web-traffic": "Acheté: nombre de fois acheté depuis la semaine dernière et: nombre d'utilisateurs du trafic consultent actuellement cette carte SIM",
                "web-traffic-title": "Cette carte SIM est en vente chaude!"
            },
            "travel-sim-checkout": {
                "-secure-payment-slogan": "",
                "address": "Adresse de livraison",
                "address-column1": "par exemple. Salle A, 18 / F, Centre mondial",
                "address-column2": "par exemple. 88 route de voyage",
                "address-column3": "par exemple. Central, Hong Kong",
                "back-button": "Retour",
                "checkout-title-1": "Informations de livraison",
                "confirm-button": "Continuer",
                "country-code": "Code postal",
                "delivery-message-body": "Working days are from Monday to Friday (except public holidays). The order cut-off time is 12：00 PM (GMT+8). Orders placed after 12：00 PM (GMT+8) will ship out the next working day.\n<br><br>Within the same working day, orders with the same delivery address will be sent together.",
                "delivery-message-header": "Avis de livraison",
                "delivery-method": "méthode de livraison",
                "delivery-method-1": "Hong Kong Post (Free)",
                "delivery-method-1-description": "By Hong Kong Post's Local Mail, the estimated delivery will be within 3-6 working days. Status tracking is not available to local mail and customers shall bare the full responsibility of losing items by using Hong Kong Post’s ordinary mail service.\n<br><br>Note: Due to the time required for delivery, customers who are about to travel are recommended to choose SF Express",
                "delivery-method-2": "SF Express (Hong Kong only. Courier fee payable on delivery)",
                "delivery-method-2-description": "By SF Express (courier fee payable on delivery), the ordered items will be delivered by courier within 1-3 working days, and islands will take longer delivery time. The courier fee is about HK$16-$25 by referring to the website of SF Express.\n<br><br>Note: The order over HK$399 will be upgraded to SF Express for FREE",
                "delivery-method-3": "International Shipping",
                "delivery-method-3-description": "Delivered by Hong Kong Post (tracking no. will be provided) within 4 to 15 working days depends on the destination. Shipping cost HK$30.",
                "error-alert-address": "S'il vous plaît remplir l'adresse de livraison.",
                "error-alert-invalid-email": "Le format de courrier électronique est invalide.",
                "error-alert-invalid-recipient-first-num": "le numéro de contact doit commencer par 2,3,5,6,7,8 ou 9.",
                "error-alert-invalid-recipient-number": "S'il vous plaît remplir le numéro de contact correct.",
                "error-alert-invalid-user-first-num": "Le numéro de téléphone portable doit commencer par 5,6,7,8 ou 9.",
                "error-alert-invalid-user-number": "S'il vous plaît remplir le numéro de mobile correct.",
                "error-alert-personal-info": "S'il vous plaît remplir les informations personnelles.",
                "error-alert-recipient-info": "Veuillez renseigner les informations sur le destinataire.",
                "error-invalid-credit-card-info": "Information de carte de crédit invalide",
                "facebook-login": "Continuer avec Facebook",
                "google-login": "Continuer avec Google",
                "logged-in": "Connecté",
                "login": "Client existant, connectez-vous pour profiter du départ express",
                "login-button": "S'identifier",
                "login-email": "Email",
                "login-no-user-exists": "Oops! Désolé, nous ne pouvons pas confirmer vos informations de connexion. Veuillez réessayer ou simplement compléter la commande sans passer la commande.",
                "login-password": "Mot de passe",
                "payme": {
                    "error-contacting-payme": "Erreur de paiement, s'il vous plaît réordonner à nouveau ou de soutien à la clientèle de contact."
                },
                "payment": {
                    "actual-payment": "The transaction will be settled at HK${actual_payment} and the exchange rate will be based on your credit card issuer.",
                    "choose-payment-method": "Choisissez le mode de paiement:",
                    "logistic-information": "Informations de livraison",
                    "modify-information": "Modifier les informations",
                    "pay-now": "Payez maintenant",
                    "payme-instruction-do-not-close": "S'il vous plaît ne pas fermer cette page avant le paiement complet",
                    "payme-instruction-step-1": "1. Ouvrez l'application PayMe.",
                    "payme-instruction-step-2": "2. Numérisez le PayCode d'autoriser le paiement.",
                    "payme-instruction-step-3": "3. Le paiement complet dans l'application et attendez la confirmation.",
                    "payme-instruction-title": "Payer avec PayMe",
                    "payme-title": "Scannez ce PayCode avec PayMe",
                    "payment": "Paiement",
                    "price": "Montant",
                    "shipping-fee": "Frais d'expédition",
                    "subtotal": "Total"
                },
                "payment-method": "Mode de paiement",
                "pending": {
                    "mobile-redirection-text": "Vous avez sélectionné PayMe comme méthode de paiement et sera redirigé vers l'application PayMe au paiement complet.",
                    "need-to-pay": "Montant dû",
                    "order-number": "Numéro de commande",
                    "order-success-please-pay": "S'il vous plaît payer avec PayMe pour terminer le processus de commande",
                    "paycode-error": "Erreur de paiement, s'il vous plaît réordonner à nouveau ou de soutien à la clientèle de contact.",
                    "paycode-expired": "Le paycode de PayMe a expiré, s'il vous plaît réordonner à nouveau.",
                    "re-order": "Réorganiser",
                    "title-payme": "Payez avec PayMe"
                },
                "recipient-address": "Adresse de livraison",
                "recipient-information": "Informations sur le destinataire",
                "recipient-name": "Nom du destinataire",
                "recipient-phone-number": "Numéro de téléphone du destinataire",
                "secure-payment-slogan": "Paiement sécurisé | Le paiement sera crypté et transmis de manière sécurisée via SSL",
                "simproduct-detail": "Informations de commande",
                "simproduct-quantity": "Quantité",
                "simproduct-redeem": "",
                "simproduct-redeem-hypermiles": "",
                "simproduct-title": "Produit",
                "simproduct-will-redeeming-x-miles": "",
                "simproduct-you-have-x-hypermiles": "",
                "user-email": "Email (pour recevoir la facture)",
                "user-firstname": "Prénom",
                "user-information": "Informations personnelles",
                "user-lastname": "Nom de famille",
                "user-phone-number": "Numéro de portable",
                "vertical-divider": "Ou"
            },
            "travel-sims": {
                "column-title-1": "Classification claire, facile à choisir",
                "column-title-2": "Paiement en ligne, pratique et rapide",
                "column-title-3": "Courrier de surface gratuit, livraison rapide",
                "country-search-no-place-found": "Aucun résultat n'a été trouvé pour cette destination",
                "cover-button": "Commandez avec HyperAir App maintenant",
                "cover-slogan": "Meilleure carte SIM traite de la livraison gratuite!",
                "cover-title": "Travel SIM",
                "empty-destination": "",
                "num-of-days": "",
                "search-button": "",
                "search-input": "Pays de recherche",
                "search-placeholder": "Pays de recherche",
                "search-slogan": "Où vas-tu?",
                "travel-sim-header-description": "",
                "travel-sim-header-title": ""
            }
        },
        "passwords": {
            "password": "Les mots de passe doivent comporter au moins six caractères et correspondre à la confirmation.",
            "reset": "Votre mot de passe a été réinitialisé!",
            "sent": "Nous avons envoyé par e-mail votre lien de réinitialisation de mot de passe!",
            "token": "Ce jeton de réinitialisation de mot de passe n'est pas valide.",
            "user": "Nous ne pouvons pas trouver un utilisateur avec cette adresse e-mail."
        },
        "mail": {
            "product-simcard": {
                "delivery-update": {
                    "subject": "Votre commande de carte SIM est en route"
                },
                "purchased": {
                    "subject": "Confirmation de commande de la carte SIM"
                },
                "tracking-number-update": {
                    "subject": "Votre numéro de suivi de commande est mis à jour"
                }
            }
        },
        "member-center": {
            "login-to-receive-codes": "",
            "my-orders-empty": "Pas d'enregistrements",
            "my-orders-title": "Mes commandes",
            "profile-area-code": "Indicatif régional",
            "profile-email": "Email",
            "profile-firstname": "Prénom",
            "profile-lastname": "Nom de famille",
            "profile-save": "sauvegarder",
            "profile-tel": "Tel",
            "profile-title": "Profil",
            "profile-update-successfully": "",
            "promo-code-enter-promotion-code": "Entrer le code de promotion",
            "promo-code-my-promo-code": "Mon HyperAir Code promotionnel",
            "promo-code-no-code": "",
            "promo-code-please-fill-in-code": "",
            "promo-code-redeem": "Racheter",
            "promo-code-redeem-code": "Code promotionnel HyperAir Encaisser le",
            "promo-code-select": "Sélectionner",
            "promo-code-title": "HyperAir code promotionnel",
            "title": "Centre des membres"
        },
        "weekday": {
            "1": "Lundi",
            "2": "Mardi",
            "3": "Mercredi",
            "4": "Jeudi",
            "5": "Vendredi",
            "6": "samedi",
            "7": "dimanche"
        },
        "exchange-shop-details": {
            "address": "Adresse",
            "book-button": "Reserve maintenant",
            "br": "BR",
            "closed-book-button": "Fermé",
            "download-pop-up": {
                "slogan-1": "Enfermé dans Taux",
                "slogan-2": "Comfirmation Instant",
                "title": "Télécharger App pour le FX Réservation"
            },
            "latest-updated": "dernière mise à jour",
            "not-available-book-button": "Indisponible",
            "opening-hrs": "Horaires d'ouvertures",
            "phone-num": "Numéro de téléphone",
            "rate": "Taux",
            "reviews": "Commentaires",
            "table-buy-rate": "Acheter taux",
            "table-compare-button": "Comparer",
            "table-currency": "Devise",
            "table-sell-rate": "Taux de ventes",
            "table-short-form": "Code",
            "table-title": "autres Devises"
        },
        "credit-card": {
            "cannot-add-card": "Quelque chose s'est mal passé lors de l'ajout de votre carte de crédit. Veuillez vérifier vos informations et réessayer ou ajouter une autre carte de crédit.",
            "cannot-process": "Une erreur s'est produite lors du chargement de votre carte de crédit. Veuillez vérifier vos informations et réessayer ou vous pouvez utiliser une autre carte de crédit."
        },
        "shoppingcart": {
            "add": {
                "no-stock": "Oops! Atteint la quantité maximale pouvant être achetée pour ce produit ..."
            },
            "pay": {
                "db-locked": "Serveur occupé. Veuillez réessayer plus tard. (Code de référence: E1003)",
                "invalid-promotion-code": "Code de promotion invalide",
                "no-stock": "Produit (s) en rupture de stock en ce moment! (Code de référence: E1002)"
            },
            "promotion-message": {
                "up-sell-1": "Profitez de 10 $ HK de réduction avec le coupon de bienvenue",
                "up-sell-2": "Profitez de 15 $ HK de réduction avec le code promo HYPER15 lorsque vous dépensez plus de 299 HK $"
            }
        },
        "product": {
            "label-confirmation-duration-24_hours": "Confirmation de 24 heures",
            "label-confirmation-duration-48_hours": "Confirmation de 48 heures",
            "label-confirmation-duration-instant": "Confirmation instantanée",
            "label-duration-unit-day": "& nbsp; jours",
            "label-duration-unit-hour": "Heures)",
            "label-duration-unit-hr": "& nbsp; heures",
            "label-duration-unit-min": "& nbsp; minutes",
            "label-earliest-available-date": "j M Y",
            "label-earliest-available-date-today": "Aujourd'hui",
            "label-earliest-available-date-tomorrow": "demain",
            "label-lang-en": "Anglais",
            "label-lang-jp": "japonais",
            "label-lang-kr": "coréen",
            "label-lang-zh": "chinois",
            "label-meet-up-method-hotel_pickup": "Ramassage à l'hôtel",
            "label-meet-up-method-location_meet_up": "Lieu de rendez-vous",
            "label-refundable-conditional_cancel": "Annulation conditionnelle",
            "label-refundable-no_cancel": "Aucune annulation",
            "label-ticket-logistic-mobile": "Coupon mobile accepté",
            "label-ticket-logistic-printed": "Bon imprimé accepté",
            "label-ticket-logistic-printed_or_mobile": "Bon imprimé ou mobile accepté",
            "label-ticket-validity-fixed_date": "Billet à date fixe",
            "label-ticket-validity-open_date": "Billet à date ouverte",
            "label-ticket-validity-open_or_fixed_date": "Billet à date ouverte / fixe"
        },
        "pagination": {
            "next": "Suivant & raquo;",
            "previous": "& laquo; précédent"
        },
        "city": {
            "abu-dhabi": "Abu Dhabi",
            "adelaide": "Adélaïde",
            "agra": "Agra",
            "ahmedabad": "Ahmedabad",
            "alice-springs": "Alice Springs",
            "alsace": "Alsace",
            "amritsar": "Amritsar",
            "amsterdam": "Amsterdam",
            "andalusia": "Andalousie",
            "antalya": "Antalya",
            "anuradhapura": "Anuradhapura",
            "athens": "Athènes",
            "auckland": "Auckland",
            "bacolod": "Bacolod",
            "bagan": "Bagan",
            "baku": "Bakou",
            "bali": "Bali",
            "bandung": "Bandung",
            "bangalore": "Bangalore",
            "bangkok": "Bangkok",
            "barcelona": "Barcelone",
            "batam": "Batam",
            "bath": "Une baignoire",
            "bay-of-islands": "Baie des îles",
            "beijing": "Pékin",
            "belfast": "Belfast",
            "bentota": "Bentota",
            "berlin": "Berlin",
            "bohol": "Bohol",
            "boracay": "Boracay",
            "bordeaux": "Bordeaux",
            "boston": "Boston",
            "bratislava": "Bratislava",
            "brisbane": "Brisbane",
            "bruges": "Bruges",
            "brussels": "Bruxelles",
            "budapest": "Budapest",
            "burgundy": "Bourgogne",
            "busan": "Busan",
            "cairns": "Cairns",
            "cambridge": "Cambridge",
            "cameron-highlands": "Cameron Highlands",
            "canary-islands": "les îles Canaries",
            "cape-town": "Le Cap",
            "cappadocia": "Cappadoce",
            "cebu": "Cebu",
            "champagne": "Champagne",
            "chengdu": "Chengdu",
            "chennai": "Chennai",
            "chiang-mai": "Chiang Mai",
            "chiang-rai": "Chiang Rai",
            "chiayi": "Chiayi",
            "chicago": "Chicago",
            "chongqing": "Chongqing",
            "christchurch": "Christchurch",
            "cochin": "Cochin",
            "cologne": "Eau de Cologne",
            "colombo": "Colombo",
            "copenhagen": "Copenhague",
            "costa-del-sol": "Costa del Sol",
            "crete": "Crète",
            "da-lat": "Da Lat",
            "da-nang": "Da Nang",
            "darwin": "Darwin",
            "davao": "Davao",
            "delhi": "Delhi",
            "dhaka": "Dhaka",
            "dresden": "Dresde",
            "dubai": "Dubai",
            "dublin": "Dublin",
            "dubrovnik": "Dubrovnik",
            "dumaguete": "Dumaguete",
            "dunedin": "Dunedin",
            "düsseldorf": "Düsseldorf",
            "edinburgh": "Edinbourg",
            "finnish-lapland": "",
            "florence": "Florence",
            "frankfurt": "Francfort",
            "fraser-island": "Île Fraser",
            "french-riviera": "Côte d'Azur",
            "fukuoka": "Fukuoka",
            "galle": "Galle",
            "galway": "Galway",
            "gangtok": "Gangtok",
            "gangwon-do": "Gangwon-do",
            "gdansk": "Gdansk",
            "geneva": "Genève",
            "genting-highlands": "Genting Highlands",
            "geraldton": "Geraldton",
            "glasgow": "Glasgow",
            "goa": "Goa",
            "gold-coast": "Côte d'or",
            "gothenburg": "Göteborg",
            "guam": "Guam",
            "guangdong": "Guangdong",
            "guilin": "Guilin",
            "guizhou": "Guizhou",
            "gyeonggi-do": "Gyeonggi-do",
            "haikou": "Haikou",
            "hakone": "Hakone",
            "halong": "Halong",
            "hamburg": "Hambourg",
            "hangzhou": "Hangzhou",
            "hanoi": "Hanoi",
            "harbin": "Harbin",
            "hat-yai": "Chapeau Yai",
            "hawaii": "Hawaii",
            "heidelberg": "Heidelberg",
            "helsinki": "Helsinki",
            "himachal-pradesh": "Himachal Pradesh",
            "hiroshima": "Hiroshima",
            "ho-chi-minh-city": "Ho Chi Minh-Ville",
            "hobart": "Hobart",
            "hoi-an": "Hoi An",
            "hokkaido": "Hokkaido",
            "hong-kong": "Hong Kong",
            "hua-hin": "Hua Hin",
            "hualien": "Hualien",
            "hue": "Teinte",
            "hyderabad": "Hyderabad",
            "iloilo": "Iloilo",
            "incheon": "Incheon",
            "inle-lake": "Lac Inle",
            "inner-mongolia": "Mongolie intérieure",
            "innsbruck": "Innsbruck",
            "interlaken": "Interlaken",
            "inverness": "Inverness",
            "ipoh": "Ipoh",
            "istanbul": "Istanbul",
            "jaipur": "Jaipur",
            "jaisalmer": "Jaisalmer",
            "jakarta": "Jakarta",
            "jeju": "Jeju",
            "jerusalem": "Jérusalem",
            "jodhpur": "Jodhpur",
            "johor-bahru": "Johor Bahru",
            "kandy": "Kandy",
            "kaohsiung": "Kaohsiung",
            "kathmandu": "Katmandou",
            "kazan": "Kazan",
            "kenting": "Kenting",
            "kiev": "Kiev",
            "kinmen": "Kinmen",
            "kobe": "Kobe",
            "koh-chang": "Koh Chang",
            "koh-samui": "Koh Samui",
            "krabi": "Krabi",
            "krakow": "Cracovie",
            "kuala-lumpur": "Kuala Lumpur",
            "kumamoto": "Kumamoto",
            "kyoto": "Kyoto",
            "kyushu": "Kyushu",
            "lake-district": "Lake District",
            "langkawi": "Langkawi",
            "lapland": "Laponie",
            "las-vegas": "Las Vegas",
            "launceston": "Launceston",
            "lausanne": "Lausanne",
            "leipzig": "Leipzig",
            "lisbon": "Lisbonne",
            "liverpool": "Liverpool",
            "ljubljana": "Ljubljana",
            "loire-valley": "Vallée de la Loire",
            "lombok": "Lombok",
            "london": "Londres",
            "los-angeles": "Los Angeles",
            "luang-prabang": "Luang Prabang",
            "lucerne": "Luzerne",
            "lviv": "Lviv",
            "lyon": "Lyon",
            "macao": "Macao",
            "macau": "",
            "madrid": "Madrid",
            "malaga": "Malaga",
            "manchester": "Manchester",
            "mandalay": "Mandalay",
            "manila": "Manille",
            "marrakech": "Marrakech",
            "mauritius": "Maurice",
            "medan": "Medan",
            "melaka": "Melaka",
            "melbourne": "Melbourne",
            "miami": "Miami",
            "milford-sound": "Milford Sound",
            "montreux": "Montreux",
            "moscow": "Moscou",
            "mumbai": "Mumbai",
            "munich": "Munich",
            "muscat": "Muscat",
            "nagano": "Nagano",
            "nagoya": "Nagoya",
            "naples": "Naples",
            "nelson": "Nelson",
            "new-delhi": "New Delhi",
            "new-york": "New York",
            "nha-trang": "Nha Trang",
            "niagara-falls": "chutes du Niagara",
            "niigata": "Niigata",
            "normandy": "la Normandie",
            "odessa": "Odessa",
            "okayama": "Okayama",
            "okinawa": "Okinawa",
            "orlando": "Orlando",
            "osaka": "Osaka",
            "oslo": "Oslo",
            "oxford": "Oxford",
            "palawan": "Palawan",
            "paris": "Paris",
            "pattaya": "Pattaya",
            "penang": "Penang",
            "penghu": "Penghu",
            "perth": "Perth",
            "philadelphia": "crême Philadelphia",
            "phnom-penh": "Phnom Penh",
            "phu-quoc": "Phu Quoc",
            "phuket": "Phuket",
            "pisa": "Pise",
            "pokhara": "Pokhara",
            "port-lincoln": "Port Lincoln",
            "porto": "",
            "porto-district": "District de Porto",
            "prague": "Prague",
            "provence": "Provence",
            "puglia": "Pouilles",
            "pune": "Pune",
            "pushkar": "Pushkar",
            "queenstown": "Queenstown",
            "ras-al-khaimah": "Ras Al Khaimah",
            "reykjavik": "Reykjavik",
            "rhodes": "Rhodes",
            "rhône-alpes": "Rhône-Alpes",
            "rome": "Rome",
            "rotorua": "Rotorua",
            "rotterdam": "Rotterdam",
            "sabah": "Sabah",
            "saint-petersburg": "Saint-Pétersbourg",
            "saipan": "Saipan",
            "salzburg": "Salzburg",
            "san-diego": "San Diego",
            "san-francisco": "San Francisco",
            "santorini": "Santorin",
            "sanya": "Sanya",
            "sapa": "Sapa",
            "sarawak": "Sarawak",
            "seattle": "Seattle",
            "seoul": "Séoul",
            "seville": "Séville",
            "shanghai": "Shanghai",
            "sibiu": "Sibiu",
            "sicily": "La Sicile",
            "siem-reap": "Siem Reap",
            "sihanoukville": "Sihanoukville",
            "singapore": "Singapour",
            "split": "Divisé",
            "surabaya": "Surabaya",
            "suzhou": "Suzhou",
            "swedish-lapland": "Laponie suédoise",
            "sydney": "Sydney",
            "taichung": "Taichung",
            "tainan": "Tainan",
            "taipei": "Taipei",
            "taitung": "Taitung",
            "tarragona": "Tarragone",
            "taupo": "Taupo",
            "terengganu": "Terengganu",
            "thessaloniki": "Thessalonique",
            "tokyo": "Tokyo",
            "toledo": "Tolède",
            "trincomalee": "Trincomalee",
            "turin": "Turin",
            "udaipur": "Udaipur",
            "uluru": "Uluru",
            "uttarakhand": "Uttarakhand",
            "varanasi": "Varanasi",
            "venice": "Venise",
            "verona": "Verona",
            "vienna": "Vienne",
            "vientiane": "Vientiane",
            "volendam": "Volendam",
            "washington-dc": "Washington DC",
            "wellington": "Wellington",
            "whitsundays": "Whitsundays",
            "xiamen": "Xiamen",
            "xian": "Xian",
            "yangon": "Yangon",
            "yilan": "Yilan",
            "yogyakarta": "Yogyakarta",
            "york": "York",
            "yunnan": "Yunnan",
            "zagreb": "Zagreb",
            "zhangjiajie": "Zhangjiajie",
            "zurich": "Zurich"
        },
        "validation": {
            "accepted": "L'attribut: doit être accepté.",
            "active_url": "L'attribut: n'est pas une URL valide.",
            "after": "L'attribut: doit être une date après: date.",
            "after_or_equal": "L'attribut: doit être une date après ou égale à: date.",
            "alpha": "L'attribut: ne peut contenir que des lettres.",
            "alpha_dash": "L'attribut: ne peut contenir que des lettres, des chiffres et des tirets.",
            "alpha_num": "L'attribut: ne peut contenir que des lettres et des chiffres.",
            "array": "L'attribut: doit être un tableau.",
            "before": "L'attribut: doit être une date antérieure à: date.",
            "before_or_equal": "L'attribut: doit être une date antérieure ou égale à: date.",
            "between": {
                "array": "L'attribut: doit avoir entre: min et: max items.",
                "file": "L'attribut: doit être compris entre: min et: max kilo-octets.",
                "numeric": "L'attribut: doit être compris entre: min et: max.",
                "string": "L'attribut: doit être compris entre: min et: max caractères."
            },
            "boolean": "Le champ d'attribut: doit être vrai ou faux.",
            "confirmed": "La confirmation d'attribut ne correspond pas.",
            "custom": {
                "attribute-name": {
                    "rule-name": "message personnalisé"
                }
            },
            "date": "L'attribut: n'est pas une date valide.",
            "date_format": "L'attribut: ne correspond pas au format: format.",
            "different": "L'attribut: et: autre doivent être différents.",
            "digits": "L'attribut: doit être: digits digits.",
            "digits_between": "L'attribut: doit être compris entre: min et: max digits.",
            "dimensions": "L'attribut: a des dimensions d'image non valides.",
            "distinct": "Le champ d'attribut: a une valeur en double.",
            "email": "L'attribut: doit être une adresse email valide.",
            "exists": "L'attribut sélectionné: n'est pas valide.",
            "file": "L'attribut: doit être un fichier.",
            "filled": "",
            "image": "",
            "in": "L'attribut sélectionné: n'est pas valide.",
            "in_array": "",
            "integer": "",
            "ip": "",
            "ipv4": "",
            "ipv6": "",
            "json": "",
            "max": {
                "array": "",
                "file": "",
                "numeric": "",
                "string": ""
            },
            "mimes": "",
            "mimetypes": "",
            "min": {
                "array": "",
                "file": "",
                "numeric": "",
                "string": ""
            },
            "not_in": "L'attribut sélectionné: n'est pas valide.",
            "numeric": "",
            "present": "",
            "regex": "",
            "required": "",
            "required_if": "",
            "required_unless": "",
            "required_with": "",
            "required_with_all": "",
            "required_without": "",
            "required_without_all": "",
            "same": "",
            "size": {
                "array": "",
                "file": "",
                "numeric": "",
                "string": ""
            },
            "string": "",
            "timezone": "",
            "unique": "",
            "uploaded": "",
            "url": ""
        },
        "reset-password": {
            "confirm-new-password": "Confirmer le nouveau mot de passe",
            "enter-new-password": "Entrez un nouveau mot de passe",
            "please-enter-a-new-password": "Veuillez saisir un nouveau mot de passe pour votre compte: email.",
            "submit": "Soumettre",
            "success-content": "Réussi! Veuillez vous connecter à l'application mobile HyperAir avec le nouveau mot de passe.",
            "title": "Réinitialiser le mot de passe",
            "validation-display": "Le mot de passe doit contenir au moins 6 caractères."
        },
        "notification": {
            "activation-e-minus-content": "Compte à rebours de 15 jours! Votre coupon de bienvenue de la carte SIM de voyage expirera très bientôt! Ne manquez pas la chance d'utiliser le coupon pour votre prochain voyage!",
            "activation-e-minus-title": "",
            "activation-t-plus-content": "N'oubliez pas d'utiliser notre coupon de bienvenue de la carte SIM pour votre prochain voyage! Voyagez plus intelligemment. Nulle part.",
            "activation-t-plus-title": "",
            "ask-shop-to-quote-content": "Demande d'offre d'achat: montant: devise",
            "ask-shop-to-quote-content2": "Demander un devis pour la vente: montant: devise",
            "ask-shop-to-quote-title": "Nouvelle demande d'offre",
            "email-booking-details": "Les détails de réservation",
            "email-booking-id": "Numéro de réservation",
            "email-exchange-approved-content": "Ordre échangé approuvé pour achat: montant: devise au taux de: taux",
            "email-exchange-approved-footer": "Merci d'utiliser HyperAir.",
            "email-exchange-approved-title": "Shop a répondu: \"Votre argent de voyage est prêt pour le ramassage!\"",
            "email-exchange-completed-content": "Commande échangée terminée pour achat: montant: devise au taux: taux",
            "email-exchange-completed-footer": "Merci d'utiliser HyperAir.",
            "email-exchange-completed-title": "Votre échange d'argent de voyage est terminé!",
            "email-exchange-confirmed-content": "Commande échangée confirmée à l’achat: montant: devise au taux de: taux",
            "email-exchange-confirmed-footer": "Merci d'utiliser HyperAir.",
            "email-exchange-confirmed-title": "Votre argent de voyage est prêt pour votre ramassage!",
            "email-footer-copy-right": "Tous les droits sont réservés.",
            "email-greetings": "salut!",
            "email-i-got": "j'ai eu",
            "email-i-paid": "j'ai payé",
            "email-i-will-get": "j'aurai",
            "email-i-will-pay": "Je paierai",
            "email-pickup-before": "Ramassage avant",
            "email-product-confirmed-greeting": "Cher client,<br><br>Merci d’utiliser HyperAir. Votre bon est prêt.",
            "email-product-confirmed-subject": "La commande a été confirmée",
            "email-product-confirmed-title": "Votre commande est confirmée",
            "email-product-purchased": {
                "shipping": {
                    "international": "Transport maritime international",
                    "sf": "SF Express (Hong Kong uniquement)"
                }
            },
            "email-product-purchased-delievery-address": "Adresse de livraison",
            "email-product-purchased-delivery-info": "Infos livraison",
            "email-product-purchased-delivery-method": "méthode de livraison",
            "email-product-purchased-discount": "Remise",
            "email-product-purchased-email": "Email",
            "email-product-purchased-greeting": "Cher client,<br><br> Bon choix. Il faudra un certain temps pour confirmer la réservation. Mais ne vous inquiétez pas, nous pouvons confirmer la commande dans les 12 heures. Merci d'avoir utilisé HyperAir!",
            "email-product-purchased-have-a-nice-trip": "Bon voyage!",
            "email-product-purchased-important-notice": "Termes et conditions s'appliquent.",
            "email-product-purchased-important-notice-content": "Termes et conditions s'appliquent.",
            "email-product-purchased-name": "Prénom",
            "email-product-purchased-order-date": "Date de commande",
            "email-product-purchased-order-details": "Détails de la commande",
            "email-product-purchased-order-no": "numéro de commande",
            "email-product-purchased-personal-info": "Informations personnelles",
            "email-product-purchased-receipient-name": "Nom du bénéficiaire",
            "email-product-purchased-receipient-phone-no": "Pas de téléphone.",
            "email-product-purchased-shipping-fee": "Frais d'expédition",
            "email-product-purchased-sub-total": "Total",
            "email-product-purchased-subject": "La commande est en attente de confirmation",
            "email-product-purchased-title": "Votre commande est en attente",
            "email-product-purchased-total": "Total",
            "email-product-simcapurchased-personal-info": "Informations personnelles",
            "email-product-simcard-delivery-title": "Votre commande SIM: numéro-commande a été préparée et expédiée le: date. Si vous avez choisi SF Express, nous vous fournirons le numéro de suivi ultérieurement. Vous pouvez également le vérifier sur notre application mobile.",
            "email-product-simcard-delivery-title-carbon-format": "j M Y",
            "email-product-simcard-delivery-update-greeting": "Cher client,<br><br>Merci d’utiliser HyperAir. Votre commande de carte SIM est en route.",
            "email-product-simcard-delivery-update-title": "Votre commande de carte SIM est en route",
            "email-product-simcard-delivery-update-tracking": "Détails de suivi",
            "email-product-simcard-delivery-update-tracking-no": "Numéro de suivi",
            "email-product-simcard-delivery-update-tracking-no-hkpost": "Numéro de suivi: -",
            "email-product-simcard-delivery-update-tracking-no-sf": "Numéro de suivi",
            "email-product-simcard-delivery-waiting-update-tracking-no-sf": "Sont en attente de mise à jour de SF Express",
            "email-product-simcard-delivery-with-tracking-num-title": "Votre carte SIM: order-num sera expédiée par SF Express avec le numéro de suivi:: tracking-num. Veuillez faire attention à votre téléphone portable pour le ramassage de la livraison. Vous pouvez également vérifier l'état de l'expédition sur le site Web de SF Express. Merci d'utiliser les services HyperAir.",
            "email-product-simcard-esim-code-greeting": "Cher client,<br><br>Merci d’utiliser HyperAir. Voici votre code QR d'activation eSIM.",
            "email-product-simcard-esim-code-important-notice-content": "<span style=\"font-size: 10px; line-height: 12px;\">Instructions:<br />1. Allez à Paramètre<br />2. Appuyez sur \"Données mobiles\"<br />3. Dans les forfaits de données, appuyez sur \"Ajouter un forfait\"<br />. Scannez le code QR dans l'appareil photo. frame<br />Si vous êtes invité à entrer un code de confirmation pour activer l'eSIM, entrez le numéro fourni par le transporteur. Avoir une question? Envoyez un e-mail à hello@hyperair.com et nous vous contacterons.</span>",
            "email-product-simcard-esim-code-title": "Voici votre code QR d'activation eSIM",
            "email-product-simcard-esim-code-warning": "Veuillez noter que l'eSIM sera activé une fois le code QR scanné. Analysez-le uniquement lorsque vous souhaitez démarrer le service.",
            "email-product-simcard-purchased-delievery-address": "Adresse de livraison",
            "email-product-simcard-purchased-delivery-info": "Informations de livraison",
            "email-product-simcard-purchased-delivery-method": "méthode de livraison",
            "email-product-simcard-purchased-discount": "Remise",
            "email-product-simcard-purchased-greeting": "Cher client,<br><br>Merci d’utiliser HyperAir. Nous préparons actuellement la livraison de votre carte SIM de voyage.",
            "email-product-simcard-purchased-greeting-esim-only": "Cher client,<br><br>Merci d’utiliser HyperAir, votre eSIM est prête! S'il vous plaît trouver le code QR ci-joint et activer selon les instructions.",
            "email-product-simcard-purchased-greeting-esim-with-sim": "Cher client,<br><br>Merci d’utiliser HyperAir. Nous préparons actuellement la livraison de votre carte SIM de voyage. Pour votre eSIM, veuillez trouver le code QR ci-joint et activer selon les instructions.",
            "email-product-simcard-purchased-greeting-sim-only": "Cher client,<br><br>Merci d’utiliser HyperAir. Nous préparons actuellement la livraison de votre carte SIM de voyage.",
            "email-product-simcard-purchased-have-a-nice-trip": "Bon voyage!",
            "email-product-simcard-purchased-important-notice": "Avis important",
            "email-product-simcard-purchased-important-notice-content": "<span style=\"font-size: 10px; line-height: 12px;\">1. Par courrier local de la poste de Hong Kong, la livraison est estimée à 5 jours ouvrables. Le suivi du statut n’est pas disponible pour le courrier local et les clients assument toute la responsabilité de perdre des objets en utilisant Hong Kong </span><br> <span style=\"font-size: 10px; line-height: 12px;\">2. Activez la carte SIM de voyage avant l’expiration.</span><br> <span style=\"font-size: 10px; line-height: 12px;\">3. Tous les produits livrés sont soumis aux termes et conditions.</span><br><br> <span style=\"font-size: 10px; line-height: 12px;\">Vous avez une question? Envoyez un e-mail à hello@hyperair.com et nous vous contacterons.</span>",
            "email-product-simcard-purchased-important-notice-content-esim-only": "<span style=\"font-size: 10px; line-height: 12px;\">1. Par courrier local de la poste de Hong Kong, la livraison est estimée à 5 jours ouvrables. Le suivi du statut n’est pas disponible pour le courrier local et les clients assument toute la responsabilité de perdre des objets en utilisant Hong Kong </span><br> <span style=\"font-size: 10px; line-height: 12px;\">2. Activez la carte SIM de voyage avant l’expiration.</span><br> <span style=\"font-size: 10px; line-height: 12px;\">3. Tous les produits livrés sont soumis aux termes et conditions.</span><br><br> <span style=\"font-size: 10px; line-height: 12px;\">Vous avez une question? Envoyez un e-mail à hello@hyperair.com et nous vous contacterons.</span>",
            "email-product-simcard-purchased-important-notice-content-esim-with-sim": "<span style=\"font-size: 10px; line-height: 12px;\">1. Par courrier local de la poste de Hong Kong, la livraison est estimée à 5 jours ouvrables. Le suivi du statut n’est pas disponible pour le courrier local et les clients assument toute la responsabilité de perdre des objets en utilisant Hong Kong </span><br> <span style=\"font-size: 10px; line-height: 12px;\">2. Activez la carte SIM de voyage avant l’expiration.</span><br> <span style=\"font-size: 10px; line-height: 12px;\">3. Tous les produits livrés sont soumis aux termes et conditions.</span><br><br> <span style=\"font-size: 10px; line-height: 12px;\">Vous avez une question? Envoyez un e-mail à hello@hyperair.com et nous vous contacterons.</span>",
            "email-product-simcard-purchased-important-notice-content-sim-only": "<span style=\"font-size: 10px; line-height: 12px;\">1. Par courrier local de la poste de Hong Kong, la livraison est estimée à 5 jours ouvrables. Le suivi du statut n’est pas disponible pour le courrier local et les clients assument toute la responsabilité de perdre des objets en utilisant Hong Kong </span><br> <span style=\"font-size: 10px; line-height: 12px;\">2. Activez la carte SIM de voyage avant l’expiration.</span><br> <span style=\"font-size: 10px; line-height: 12px;\">3. Tous les produits livrés sont soumis aux termes et conditions.</span><br><br> <span style=\"font-size: 10px; line-height: 12px;\">Vous avez une question? Envoyez un e-mail à hello@hyperair.com et nous vous contacterons.</span>",
            "email-product-simcard-purchased-order-date": "Date de commande",
            "email-product-simcard-purchased-order-details": "Détails de la commande",
            "email-product-simcard-purchased-order-no": "numéro de commande",
            "email-product-simcard-purchased-personal-info": "Informations personnelles",
            "email-product-simcard-purchased-receipient-name": "Nom du destinataire",
            "email-product-simcard-purchased-receipient-phone-no": "Numéro de téléphone du destinataire",
            "email-product-simcard-purchased-shipping-fee": "Frais d'expédition",
            "email-product-simcard-purchased-sub-total": "Total",
            "email-product-simcard-purchased-title": "Votre commande de carte SIM de voyage a été confirmée.",
            "email-product-simcard-purchased-title-esim-only": "Votre commande Travel eSIM a été confirmée.",
            "email-product-simcard-purchased-title-esim-with-sim": "Votre commande de carte SIM de voyage a été confirmée.",
            "email-product-simcard-purchased-title-sim-only": "Votre commande de carte SIM de voyage a été confirmée.",
            "email-product-simcard-purchased-total": "Total",
            "email-product-simcard-tracking-number-updated-greeting": "Cher client,<br><br>Merci encore d’avoir utilisé HyperAir. Votre numéro de suivi est mis à jour.",
            "email-product-simcard-tracking-number-updated-title": "Votre statut de suivi de commande est mis à jour",
            "email-product-simcard-tracking-number-updated-tracking-no-sf": "Numéro de suivi",
            "email-product-type-confirmed-greeting": "",
            "email-product-type-confirmed-title": "",
            "email-product-type-purchased-greeting": "",
            "email-product-type-purchased-title": "",
            "email-rate": "Taux",
            "email-shop-name": "nom de la boutique",
            "email-verification-action": "confirmez votre email",
            "email-verification-content": "Bienvenue sur HyperAir! Pour terminer votre inscription, il vous suffit de confirmer que nous avons bien reçu votre courrier électronique.",
            "email-verification-title": "veuillez confirmer votre email",
            "email-verified-content": "Votre email est vérifié. Merci d'avoir rejoint HyperAir.",
            "email-verified-title": "Email vérifié",
            "engagement-content": "Utilisez welcome10",
            "engagement-title": "Utilisez welcome10",
            "exchange-approved-content": "Confirmation d'achat: montant: devise au taux: taux.",
            "exchange-approved-content2": "Confirmation de vente: montant: devise au taux: taux.",
            "exchange-approved-footer": "",
            "exchange-approved-title": "Shop a répondu: \"Votre argent de voyage est prêt pour le ramassage!\"",
            "exchange-cancelled-content": "Un client a annulé sa commande d'achat: montant: devise au taux: taux.",
            "exchange-cancelled-content2": "Un client a annulé sa commande pour la vente: montant: devise au taux: taux.",
            "exchange-cancelled-title": "Commande d'échange annulée",
            "exchange-completed-content": "Terminé à l'achat: montant: devise au taux: taux.",
            "exchange-completed-content2": "Terminé pour la vente: montant: devise au taux: taux.",
            "exchange-completed-footer": "",
            "exchange-completed-title": "Votre échange d'argent de voyage est terminé!",
            "exchange-confirmed-content": "Vous avez confirmé l'achat d'un client: montant: devise au taux: taux.",
            "exchange-confirmed-content2": "Vous avez confirmé un client pour la vente: montant: devise au taux: taux.",
            "exchange-confirmed-footer": "",
            "exchange-confirmed-title": "Nouvelle commande d'échange reçue",
            "exchange-pending-content": "Examinez la nouvelle commande d'achat: montant: devise au taux: taux.",
            "exchange-pending-content2": "Ordre de vente en attente: montant: devise au taux: taux.",
            "exchange-pending-title": "Approbation de la nouvelle commande en attente",
            "exchange-rejected-content": "L'ordre ne peut être pris pour l'achat: montant: devise au taux: taux. Veuillez réserver à nouveau avec un autre magasin.",
            "exchange-rejected-content2": "L'ordre ne peut être pris pour la vente: montant: devise au taux: taux. Veuillez réserver à nouveau avec un autre magasin.",
            "exchange-rejected-title": "Oops! Désolé, le magasin ne peut pas prendre votre commande.",
            "footer-trouble-link": "Si vous ne parvenez pas à cliquer sur le bouton \": actionText\", copiez et collez l’URL ci-dessous dans votre navigateur Web: <a href=\"{actionUrl}\">: actionUrl</a>.",
            "password-reset-action": "Réinitialiser le mot de passe",
            "password-reset-content": "Vous recevez cet email car nous avons reçu une demande de réinitialisation du mot de passe pour votre compte.",
            "password-reset-footer": "Si vous n'avez pas demandé de réinitialisation de mot de passe, aucune action supplémentaire n'est requise.",
            "password-reset-title": "Réinitialiser le mot de passe",
            "simcard-purchased-title": "",
            "sms-verification-content": "Votre code HyperAir est: verificationCode"
        },
        "error": {
            "all-shops-are-closed": "Oups, tous les magasins sont fermés en ce moment. Veuillez réessayer plus tard.",
            "cancel-booking-failed": "Cette commande peut être complétée, expirée ou annulée. Veuillez vérifier cette commande dans [Mes réservations> Terminé] ou dans [Mes réservations> Inachevées].",
            "cancel-booking-failed-title": "Impossible d'annuler cette commande",
            "invalid-api-app-version": "Mettez à jour l'application dès maintenant pour obtenir les nouvelles fonctions et profiter du rabais de 5% sur la commande de Travel SIM avec le code promotionnel «GIVEME5» !!",
            "invalid-old-password": "Le mot de passe existant n'est pas valide.",
            "password-incorrect": "Mot de passe incorrect.",
            "phone-number-is-already-registered": "Ce numéro de téléphone a déjà été enregistré avec une autre adresse électronique. Vous pouvez vous connecter avec la bonne adresse email. Envoyez un e-mail à hello@hyperair.com pour tout support.",
            "this-email-is-registered": "Cette adresse email est déjà utilisée par un autre compte.",
            "this-phone-number-is-registered": "Ce numéro de téléphone a déjà été enregistré. Envoyez un e-mail à hello@hyperair.com pour tout support."
        },
        "marketplace": {
            "homepage-product": "Produits populaires",
            "homepage-recently-viewed": "Vu récemment",
            "product-carousels": {
                "group1": "Expérience d'été",
                "group2": "Les mieux notés"
            }
        }
    },
    "id": {
        "currency": {
            "aed": "UAE Dirham",
            "afn": "Afghanistan Afghani",
            "all": "Albania Lek",
            "amd": "Dram Armenia",
            "ang": "Antilla Belanda Gulden",
            "aoa": "Angola Kwanza",
            "ars": "Peso Argentina",
            "aud": "Dollar Australia",
            "awg": "Aruban Florin",
            "azn": "Azerbaijan Manat",
            "bam": "Bosnia dan Herzegovina Marka",
            "bbd": "Barbados Dollar",
            "bdt": "Bangladesh Taka",
            "bgn": "Lev Bulgaria",
            "bhd": "Dinar Bahrain",
            "bif": "Burundi Franc",
            "bnd": "Brunei Dollar",
            "bob": "Bolivia Bolivia",
            "brl": "real Brazil",
            "bsd": "Bahama Dollar",
            "btc": "Bitcoin",
            "btn": "Bhutan Ngultrum",
            "bwp": "Botswana Pula",
            "byn": "Baru Belarusia rubel",
            "bzd": "Belize Dollar",
            "cad": "Dolar Kanada",
            "cdf": "Kongo Franc",
            "chf": "Swiss Franc",
            "clp": "Peso Chili",
            "cop": "Kolombia Peso",
            "crc": "Costa Rican Colon",
            "cup": "Kuba Peso",
            "cve": "Cape Verdean Escudo",
            "czk": "Czech Koruna",
            "djf": "Djibouti Franc",
            "dkk": "Danish Krone",
            "dop": "Peso Dominika",
            "dzd": "Aljazair Dinar",
            "egp": "Pound Mesir",
            "ern": "Eritrea Nakfa",
            "etb": "Ethiopia Birr",
            "eur": "Euro",
            "fjd": "Fiji Dollar",
            "fkp": "Kepulauan Falkland Pound",
            "gbp": "Pound sterling",
            "gel": "Georgia Lari",
            "ghs": "Ghana Cedi",
            "gip": "Gibraltar Pound",
            "gmd": "Gambia Dalasi",
            "gnf": "Guinea Franc",
            "gtq": "Guatemala Quetzal",
            "gyd": "Guyana Dollar",
            "hkd": "Dollar Hongkong",
            "hnl": "Honduras Lempira",
            "hrk": "Kuna Kroasia",
            "htg": "Haiti Gourde",
            "huf": "Forint Hungaria",
            "idr": "Rupiah indonesia",
            "ils": "Israel New Shekel",
            "inr": "Rupee India",
            "iqd": "Dinar Irak",
            "irr": "Iran Rial",
            "isk": "Krona Islandia",
            "jmd": "Jamaican Dollar",
            "jod": "Yordania Dinar",
            "jpy": "Yen jepang",
            "kes": "Kenya Shilling",
            "kgs": "Kyrgyzstani Som",
            "khr": "Riel Kamboja",
            "kmf": "Komoro Franc",
            "kpw": "Korea Utara Won",
            "krw": "Korea Selatan Won",
            "kwd": "Kuwait Dinar",
            "kyd": "Cayman Islands Dollar",
            "kzt": "Kazakhstan Tenge",
            "lak": "Lao Kip",
            "lbp": "Lebanon Lira",
            "lkr": "Rupee Sri Lanka",
            "lrd": "Dolar Liberia",
            "lsl": "Lesotho Loti",
            "lvl": "Latvia Lats",
            "lyd": "Dinar Libya",
            "mad": "Maroko Dirham",
            "mdl": "Moldovan Leu",
            "mga": "Malagasi Ariary",
            "mkd": "Macedonia Denar",
            "mmk": "Myanma Kyat",
            "mnt": "Mongolia Tugrik",
            "mop": "Macau Pataca",
            "mro": "Mauritania Ouguiya",
            "mur": "Rupee Mauritius",
            "mvr": "Maladewa Rufiyaa",
            "mwk": "Ringgit Malaysia",
            "mxn": "Peso Meksiko",
            "myr": "Ringgit Malaysia",
            "mzn": "Mozambik Metical",
            "nad": "Namibia Dollar",
            "ngn": "Nigeria Naira",
            "nio": "Nikaragua Cordoba",
            "nok": "Norwegian Krone",
            "npr": "Nepal Rupee",
            "nzd": "Dolar Selandia Baru",
            "omr": "Omani Rial",
            "pab": "Panama Balboa",
            "pen": "Peru Nuevo Sol",
            "pgk": "Papua New Guinea Kina",
            "php": "Peso Filipina",
            "pkr": "Rupee Pakistan",
            "pln": "Polandia Zloty",
            "pyg": "Paraguay Guarani",
            "qar": "Qatar Riyal",
            "rmb": "Renminbi",
            "ron": "Rumania Leu",
            "rsd": "Dinar Serbia",
            "rub": "Rusia rubel",
            "rwf": "Rwanda Franc",
            "sar": "Riyal Saudi",
            "sbd": "Solomon Islands Dollar",
            "scr": "Seychellois Rupee",
            "sdg": "Sudan Pound",
            "sek": "Krona Swedia",
            "sgd": "Dolar Singapura",
            "shp": "Saint Helena Pound",
            "sll": "Sierra Leone Leone",
            "sos": "Somalia Shilling",
            "srd": "Suriname Dolar",
            "std": "Sao Tome Dan Principe Dobra",
            "syp": "Pound Suriah",
            "szl": "Swazi Lilangeni",
            "thb": "thai Baht",
            "tjs": "Tajikistan yang Somoni",
            "tmt": "Turkmenistan Manat",
            "tnd": "Dinar Tunisia",
            "top": "Paanga",
            "try": "Turki New Lira",
            "ttd": "Trinidad dan Tobago Dollar",
            "twd": "Dolar Taiwan Baru",
            "tzs": "Tanzania Shilling",
            "uah": "Ukraina Ukrania",
            "ugx": "Uganda Shilling",
            "usd": "Dolar Amerika",
            "uyu": "Uruguay Peso",
            "uzs": "Som Uzbekistan",
            "vef": "Venezuela Bolivar",
            "vnd": "Vietnam Dong",
            "vuv": "Vanuatu Vatu",
            "wst": "Samoa Tala",
            "xaf": "Afrika Tengah CFA Franc",
            "xcd": "Dolar Karibia Timur",
            "xdr": "Special Drawing Rights",
            "xof": "Afrika Barat CFA Franc",
            "xpf": "CFP Franc",
            "yer": "Rial Yaman",
            "zar": "Rand Afrika Selatan",
            "zmw": "Zambia Kwacha"
        },
        "shop-currency-rate": {
            "rate-last-updated-x-days-ago": "Tingkat diperbarui {time} hari yang lalu",
            "rate-last-updated-x-hours-ago": "Tingkat diperbarui {time} jam yang lalu"
        },
        "hyperair": {
            "copyright-footer": "Hak Cipta © 2018 HyperAir Incorporation Limited. Seluruh hak cipta.",
            "today": "Hari ini"
        },
        "product-simcard": {
            "shipping-methods": {
                "hkpost": "Hong Kong Post (Gratis)",
                "international": "Pengiriman internasional",
                "sf": "SF Express (Hong Kong only. Courier fee payable on delivery. Free Shipping for orders over HK$399)"
            }
        },
        "country": {
            "afghanistan": "Afganistan",
            "aland-islands": "Pulau Aland",
            "albania": "Albania",
            "algeria": "Aljazair",
            "andorra": "Andorra",
            "angola": "Angola",
            "anguilla": "Anguilla",
            "antigua-&-barbuda": "Antigua & Barbuda",
            "antigua-barbuda": "Antigua dan Barbuda",
            "argentina": "Argentina",
            "armenia": "Armenia",
            "aruba": "Aruba",
            "australia": "Australia",
            "austria": "Austria",
            "azerbaijan": "Azerbaijan",
            "azores": "Azores",
            "bahamas": "Bahama",
            "bahrain": "Bahrain",
            "bangladesh": "Bangladesh",
            "barbados": "Barbados",
            "belarus": "Belarus",
            "belgium": "Belgium",
            "belize": "Belize",
            "benin": "Benin",
            "bermuda": "Bermuda",
            "bhutan": "Bhutan",
            "bolivia": "Bolivia",
            "bonaire": "Bonaire",
            "bosnia-herzegovina": "Bosnia & Herzegovina",
            "botswana": "Botswana",
            "brazil": "Brazil",
            "british-virgin-islands": "Kepulauan Virgin Inggris",
            "brunei": "Brunei",
            "bulgaria": "Bulgaria",
            "burkina-faso": "Burkina Faso",
            "burundi": "Burundi",
            "cambodia": "Kamboja",
            "cameroon": "Kamerun",
            "canada": "Kanada",
            "canary-islands": "Pulau Canary",
            "cape-verde-islands": "Kepulauan Tanjung Verde",
            "cayman-islands": "Pulau cayman",
            "central-african-republic": "Republik Afrika Tengah",
            "chad": "Chad",
            "chile": "Chili",
            "china": "Cina",
            "colombia": "Kolumbia",
            "comoros": "Komoro",
            "congo": "Kongo",
            "cook-islands": "Kepulauan Cook",
            "costa-rica": "Kosta Rika",
            "cote-d-ivoire": "Cote D Ivoire",
            "croatia": "Kroasia",
            "cruise-ship": "Kapal pesiar",
            "cuba": "Kuba",
            "curacao": "Curacao",
            "cyprus": "Siprus",
            "cyprus---north": "Siprus",
            "cyprus---south": "Siprus",
            "czech-republic": "Republik Ceko",
            "denmark": "Denmark",
            "djibouti": "Djibouti",
            "dominica": "Dominica",
            "dominican-republic": "Republik Dominika",
            "dubai": "Dubai",
            "easter-island": "Pulau Paskah",
            "ecuador": "Ekuador",
            "egypt": "Mesir",
            "el-salvador": "El Salvador",
            "equatorial-guinea": "Guinea ekuator",
            "eritrea": "Eritrea",
            "estonia": "Estonia",
            "ethiopia": "Etiopia",
            "europe": "Europe",
            "falkland-islands": "Kepulauan Falkland",
            "faroe-islands": "Kepulauan Faroe",
            "fiji": "Fiji",
            "finland": "Finlandia",
            "france": "Perancis",
            "french-guiana": "Guyana Perancis",
            "french-polynesia": "Polinesia Perancis",
            "french-west-indies": "Hindia Barat Perancis",
            "gabon": "Gabon",
            "gambia": "Gambia",
            "georgia": "Georgia",
            "germany": "Jerman",
            "ghana": "Ghana",
            "gibraltar": "Gibraltar",
            "greece": "Yunani",
            "greenland": "Tanah penggembalaan",
            "grenada": "Grenada",
            "guadeloupe": "Guadeloupe",
            "guam": "Guam",
            "guatemala": "Guatemala",
            "guernsey": "Guernsey",
            "guinea": "Guinea",
            "guinea---bissau": "Guinea-Bissau",
            "guinea-bissau": "Guinea-Bissau",
            "guyana": "Guyana",
            "haiti": "Haiti",
            "honduras": "Honduras",
            "hong-kong": "Hongkong",
            "hungary": "Hungaria",
            "iceland": "Islandia",
            "india": "India",
            "indonesia": "Indonesia",
            "iran": "Iran",
            "iraq": "Irak",
            "ireland": "Irlandia",
            "isle-of-man": "Pulau manusia",
            "israel": "Israel",
            "italy": "Italia",
            "jamaica": "Jamaika",
            "japan": "Jepang",
            "jersey": "Jersey",
            "jordan": "Jordan",
            "kazakhstan": "Kazakhstan",
            "kenya": "Kenya",
            "kiribati": "Kiribati",
            "kosovo": "Kosovo",
            "kuwait": "Kuwait",
            "kyrgyz-republic": "Republik Kirgistan",
            "kyrgyzstan": "Kirgistan",
            "laos": "Laos",
            "latvia": "Latvia",
            "lebanon": "Libanon",
            "lesotho": "Lesotho",
            "liberia": "Liberia",
            "libya": "Libya",
            "liechtenstein": "Liechtenstein",
            "lithuania": "Lithuania",
            "luxembourg": "Luksemburg",
            "macau": "Macau",
            "macedonia": "Makedonia",
            "madagascar": "Madagaskar",
            "madeira": "Madeira",
            "malawi": "Malawi",
            "malaysia": "Malaysia",
            "maldives": "Maladewa",
            "mali": "Mali",
            "malta": "Malta",
            "marshall-islands": "Pulau Marshall",
            "martinique": "Martinique",
            "mauritania": "Mauritania",
            "mauritius": "Mauritius",
            "mayotte": "Mayotte",
            "mexico": "Meksiko",
            "micronesia": "Mikronesia",
            "moldova": "Moldova",
            "monaco": "Monako",
            "mongolia": "Mongolia",
            "montenegro": "Montenegro",
            "montserrat": "Montserrat",
            "morocco": "Maroko",
            "mozambique": "Mozambik",
            "myanmar": "Myanmar",
            "namibia": "Namibia",
            "nauru": "Nauru",
            "nepal": "Nepal",
            "netherlands": "Belanda",
            "netherlands-antilles": "Antillen Belanda",
            "new-caledonia": "Kaledonia Baru",
            "new-zealand": "Selandia Baru",
            "nicaragua": "Nikaragua",
            "niger": "Niger",
            "nigeria": "Nigeria",
            "niue": "Niue",
            "norfolk-islands": "Kepulauan Norfolk",
            "north-korea": "Korea Utara",
            "northern-marianas": "Maria Utara",
            "norway": "Norway",
            "oman": "Oman",
            "pakistan": "Pakistan",
            "palau": "Palau",
            "palestine": "Palestina",
            "panama": "Panama",
            "papua-new-guinea": "Papua Nugini",
            "paraguay": "Paraguay",
            "peru": "Peru",
            "philippines": "Filipina",
            "poland": "Polandia",
            "portugal": "Portugal",
            "puerto-rico": "Puerto Riko",
            "qatar": "Qatar",
            "reunion": "Reuni",
            "romania": "Rumania",
            "russia": "Rusia",
            "rwanda": "Rwanda",
            "saint-barthelemy": "Saint Barthelemy",
            "saint-martin": "Saint Martin",
            "saint-pierre-&-miquelon": "Saint Pierre & Miquelon",
            "samoa": "Samoa",
            "san-marino": "San Marino",
            "sao-tome-&-principe": "Sao Tome & Principe",
            "sao-tome-principe": "São Tomé dan Príncipe",
            "satellite": "Satelit",
            "saudi-arabia": "Arab Saudi",
            "senegal": "Senegal",
            "serbia": "Serbia",
            "seychelles": "Seychelles",
            "sierra-leone": "Sierra Leone",
            "singapore": "Singapura",
            "slovak-republic": "Republik Slovakia",
            "slovakia": "Slovakia",
            "slovenia": "Slovenia",
            "solomon-islands": "Pulau Solomon",
            "somalia": "Somalia",
            "south-africa": "Afrika Selatan",
            "south-korea": "Korea Selatan",
            "spain": "Spanyol",
            "sri-lanka": "Srilanka",
            "st-helena": "Saint Helena",
            "st-kitts": "Saint Kitts",
            "st-kitts-&-nevis": "St Kitts & Nevis",
            "st-lucia": "St Lucia",
            "st-vincent": "St Vincent",
            "st.-helena": "St. Helena",
            "st.-kitts": "St. Kitts",
            "st.-lucia": "St. Lucia",
            "sudan": "Sudan",
            "suriname": "Suriname",
            "swaziland": "Swaziland",
            "sweden": "Swedia",
            "switzerland": "Swiss",
            "syria": "Syria",
            "taiwan": "Taiwan",
            "tajikistan": "Tajikistan",
            "tanzania": "Tanzania",
            "thailand": "Thailand",
            "timor-l'este": "Timor L'Este",
            "togo": "Untuk pergi",
            "tonga": "Tonga",
            "trinidad-&-tobago": "Trinidad & Tobago",
            "trinidad-tobago": "Trinidad dan Tobago",
            "tunisia": "Tunisia",
            "turkey": "Turki",
            "turkmenistan": "Turkmenistan",
            "turks-&-caicos": "Turks & Caicos",
            "turks-&-caicos-islands": "Kepulauan Turks & Caicos",
            "turks-caicos-islands": "Kepulauan Turks dan Caicos",
            "uganda": "Uganda",
            "ukraine": "Ukraina",
            "united-arab-emirates": "Uni Emirat Arab",
            "united-kingdom": "Britania Raya",
            "united-states": "Amerika Serikat",
            "united-states-minor-outlying-islands": "Kepulauan Terluar Kecil Amerika Serikat",
            "uruguay": "Uruguay",
            "uzbekistan": "Uzbekistan",
            "vanuatu": "Vanuatu",
            "vatican-city": "Kota Vatikan",
            "venezuela": "Venezuela",
            "vietnam": "Vietnam",
            "virgin-islands": "Virgin Islands",
            "virgin-islands-(us)": "Kepulauan Virgin (AS)",
            "wallis-&-futuna": "Wallis & Futuna",
            "wallis-futuna": "Wallis dan Futuna",
            "yemen": "Yaman",
            "zambia": "Zambia",
            "zimbabwe": "Zimbabwe"
        },
        "inspiration": {
            "published-date": "M Y",
            "published-duration": ": durasi hari sebelumnya",
            "published-duration-singular": "Kemarin",
            "published-duration-today": "Hari ini"
        },
        "promotion-center": {
            "expires-at": "",
            "redeem": {
                "error": {
                    "already-redeemed": "Anda telah menebus kupon.",
                    "new-customer-only": "Penawaran hanya berlaku untuk pelanggan baru.",
                    "not-found": "Kode Promosi Tidak Valid"
                }
            }
        },
        "auth": {
            "failed": "Kredensial ini tidak cocok dengan catatan kami.",
            "throttle": "Terlalu banyak upaya masuk. Silakan coba lagi dalam: detik detik."
        },
        "web": {
            "activity": {
                "countdown-title": "",
                "more-button": "More tour and tickets",
                "section-subtitle": "Find the cheapest tour and tickets in Singapore",
                "section-title": "Tour and Tickets"
            },
            "checkout": {
                "use-promo-code": ""
            },
            "checkout-failed": {
                "checkout-failed": ""
            },
            "checkout-success": {
                "checkout-success": "pembayaran berhasil",
                "continue-shopping-button": "Lanjutkan Belanja",
                "done-button": "Selesai👌🏻",
                "download-now": "Unduh sekarang",
                "order-number": "Jumlah order",
                "register-email": "Email mu",
                "register-password": "Setel kata sandi Anda",
                "sim-product": "Pembelian <span class=\"bold\"> : sim </span>berhasil. Email konfirmasi telah dikirim ke: email.",
                "slogan": "Buka aplikasi HyperAir untuk menikmati hak istimewa perjalanan eksklusif! Anda juga dapat memiliki pelacakan pesanan waktu nyata di Aplikasi!",
                "slogan-password": "Satu langkah lagi! Anda dapat menikmati kupon kartu SIM HK $ 10 dan pelacakan pesanan real-time di App!",
                "trace-order": "",
                "trace-order-password": "",
                "welcome-offer": "Satu langkah lagi! Anda dapat menikmati kupon kartu SIM HK $ 10 dan pelacakan pesanan real-time di App!"
            },
            "country": {
                "all": "Semua",
                "contact-us-description": "如有 任何 疑問 ， 歡迎 發送 電郵 到<a href=\"mailto:corporate@hyperair.com\\>corporate@hyperair.com</a>查詢",
                "data": "Batas Data:",
                "day": "Hari:",
                "day-day": "Hari",
                "esim": "eSIM",
                "esim-section-title": "ESIM terbaik untuk: negara",
                "num-of-review": ": peringkat peringkat review",
                "per-day": "Hari",
                "phone-call": "Panggilan telepon",
                "plug-n-go": "",
                "plug-n-go-esim": "Beli dan gunakan instan",
                "plug-n-go-sim": "Pasang dan gunakan",
                "section-title": "Kartu SIM terbaik untuk: negara",
                "section-title copy": "Kartu SIM terbaik untuk: negara",
                "sim": "SIM",
                "supplier": "Pemberi:"
            },
            "download-app-banner": {
                "download-now": "Unduh Aplikasi Sekarang",
                "hyperair": "HyperAir",
                "subtitle": "Unduh & daftarkan Aplikasi HyperAir untuk menikmati penawaran sambutan HK $ 10!",
                "title": "Perjalanan Lebih Cerdas. Di mana saja."
            },
            "email-subscription": {
                "cancel-button": "再諗一諗",
                "completed-subscribe": "Thank you for subscribing!",
                "confirm-button": "我要最抵優惠",
                "duplicate-email": "你的電郵已經訂閱了",
                "invalid-email": "Invalid email address",
                "title-1": "想Staycation價格跌至新低時通知你？",
                "title-2": "仲搜羅全城最抵既Staycation 及美食套餐優惠"
            },
            "fanfare": {
                "cover-title": "Penawaran Kartu SIM",
                "datetime-format": "j M",
                "end-next-fanfare": "Mendatang Penawaran Kartu SIM:",
                "end-title": "Menantikan untuk App & sosial media kita untuk Penawaran SIM berikutnya",
                "end-title2": "Tetap Tuned untuk platform APP & media sosial kami untuk Penawaran Kartu SIM berikutnya",
                "more-details-button": "Keterangan lebih lanjut",
                "out-of-stock": "Habis terjual",
                "popular-countries-subtitle": "Gratis Permukaan Mail, Pengiriman Speedy",
                "popular-countries-title": "Populer Kartu SIM",
                "section-title": "Kartu SIM dengan harga yang super diskon",
                "title": "Waktu Terbatas | Kartu terbatas",
                "x-inventory-left": "Terakhir{inventory}"
            },
            "fanfare-breadcrumb": "Penawaran Kartu SIM",
            "filter-button": {
                "filter": "Saring"
            },
            "filter-container": {
                "apply": "",
                "category": "Kategori",
                "category-aquarium": "Akuarium",
                "category-class": "Kelas",
                "category-day-tour": "Day Tour",
                "category-discount": "Diskon",
                "category-diving": "penyelaman",
                "category-food": "Makanan",
                "category-massage-beauty": "Pijat dan Kecantikan",
                "category-museum": "Museum",
                "category-musical": "Musikal",
                "category-outlet": "Toko",
                "category-photography": "Fotografi",
                "category-playground": "Tempat bermain",
                "category-railway": "jalan kereta api",
                "category-show": "Menunjukkan",
                "category-ski": "Main ski",
                "category-spa": "Spa",
                "category-theme-park": "theme Park",
                "category-ticket": "Tiket",
                "category-transport": "Mengangkut",
                "category-transport-ticket": "Transportasi Tiket",
                "category-vr": "VR",
                "category-water-park": "Taman air",
                "category-yoga": "yoga",
                "category-zoo": "Kebun binatang",
                "clear-all": "ulang",
                "facilities": "Services & facilities",
                "filter": "Saring",
                "food": "Food",
                "header": "Saring",
                "popular-search": "Popular Search🔥",
                "price": "Harga",
                "provider": "Situs Travel",
                "subcategory-buffet": "Prasmanan",
                "subcategory-car": "Mobil",
                "subcategory-facial": "facial",
                "subcategory-food": "Makanan",
                "subcategory-half-day-tour": "Half Day Tour",
                "subcategory-massage": "Pijat",
                "subcategory-meal-voucher": "meal Voucher",
                "subcategory-one-day-tour": "One Day Tour",
                "subcategory-restaurant": "Restoran",
                "subcategory-transport": "Angkutan",
                "tag": "Tag"
            },
            "footer": {
                "about-hyperair-description": "HyperAir adalah platform perjalanan cerdas yang Anda sukai, menawarkan solusi perjalanan yang paling sesuai dan bernilai baik, sehingga Anda dapat melakukan perjalanan yang lebih cerdas, di mana saja.",
                "download-now": "Unduh sekarang",
                "email-subscription-button": "Subscribe",
                "email-subscription-placeholder": "Enter your email",
                "email-subscription-social-title": "or Follow our Facebook and Instagram",
                "email-subscription-title": "Subscribe to get the latest staycation discount",
                "travel-license": "Travel Agent Licence Number："
            },
            "fx-booking": {
                "back-button": "",
                "confirm-booking": "",
                "confirm-button": "",
                "contact-shop": "",
                "get-money-before": ""
            },
            "home": {
                "cover-button": "Pengalaman Sekarang",
                "cover-subtitle": "Buka diri Anda ke dunia baru HyperAir",
                "cover-title": "Perjalanan Lebih Cerdas. Di mana saja.",
                "grid": {
                    "1": {
                        "subtitle": "Inspirasi terbaru",
                        "title": "Penduduk Kucing di Gereja Turki"
                    },
                    "2": {
                        "subtitle": "Inspirasi terbaru",
                        "title": "Olimpiade Tokyo 2020 1 Tahun Lagi"
                    },
                    "3": {
                        "subtitle": "pilihan terbanyak",
                        "title": "Jaminan Harga Terbaik Online"
                    },
                    "4": {
                        "subtitle": "Befristetes Angebot",
                        "title": "SIM-Karten-Fanfares"
                    },
                    "5": {
                        "subtitle": "Tujuan Populer",
                        "title": "Menyelinap Mengintip Disneyland Galaxy's Edge"
                    }
                },
                "home-example": {
                    "column-subtitle-1": "ambil 2 orang perjalanan 7 hari ke Jepang sebagai contoh:",
                    "column-subtitle-2": "Perbandingan harga",
                    "column-title-1": "satu perjalanan, maksimalkan penghematan Anda",
                    "column-title-2": "Bandingkan 11 agen perjalanan online",
                    "hotel": "Hotel Rewards",
                    "hotel-package-1": "Hotel Nikko Osaka x6 malam",
                    "insurance": "Asuransi perjalanan",
                    "insurance-package-1": "Asuransi Perjalanan 7-Hari x2",
                    "money": "Asuransi perjalanan",
                    "money-package-1": "Tukarkan JPD ¥ 410.000",
                    "save": "Menyimpan",
                    "sim": "SIM perjalanan",
                    "sim-package-1": "SIM DoCoMo 7-Hari Jepang 7",
                    "slogan": "Bandingkan sebelum memesan, hemat uang untuk perjalanan Anda berikutnya!",
                    "total-saving": "Total Penghematan $ 1,443",
                    "travel-experience": "Pengalaman Perjalanan",
                    "travel-experience-package-1": "JR Pass untuk Seluruh Jepang x2",
                    "travel-experience-package-2": "Universal Studios Japan ™ 1-Day eticket x2"
                },
                "media-header-title": "Press",
                "more": "Lebih banyak SIM Perjalanan",
                "partners-title": "Partnership",
                "photo-banner-button": "Belajarlah lagi",
                "photo-banner-title": "Tukarkan uang perjalanan dengan lebih cerdas",
                "services-header-description": "",
                "services-header-title": "Layanan Perjalanan Satu Pintu",
                "services-icon-subtitle-1": "Membantu Anda mendapatkan uang perjalanan dengan lebih cerdas!",
                "services-icon-subtitle-2": "Menawarkan kartu SIM terbaik dengan pengiriman gratis!",
                "services-icon-subtitle-3": "Memungkinkan Anda menjelajahi dunia dengan solusi khusus!",
                "services-icon-title-1": "Uang Perjalanan",
                "services-icon-title-2": "SIM perjalanan",
                "services-icon-title-3": "Pengalaman Perjalanan",
                "statistic": {
                    "num-of-city": "",
                    "num-of-comparison": "",
                    "num-of-experience": "",
                    "num-of-saving": ""
                },
                "testimonial-1-content": "呢 個 aplikasi 很好 用 ， 方便 比便 便 ， 唔 駛 周圍 去 揾 資料。 很 程式 地 地 地 地 地 地 地 製作 佢 佢 佢 佢 地 地 地 地 地 地 地 地 地",
                "testimonial-1-subtitle": "Pengguna Android",
                "testimonial-1-user": "Christine Lam",
                "testimonial-2-content": "好 方便 ， 訂 SIM 卡 好 快 就 送到 ， 唔洗 特登 出 街 買 卡 SIM 卡 ， 價錢 都 好 平 吓。。 網絡 收 好 好 ， ， 去 日本 喺 喺 喺 市區 同 好 好！ 下次 下次 下次會 再買！",
                "testimonial-2-subtitle": "Pengguna iOS",
                "testimonial-2-user": "malaikat",
                "testimonial-header-description": "",
                "testimonial-header-title": "Testimoni Pelanggan",
                "travel-activities": {
                    "home-slogan": "Bandingkan dan temukan pengalaman perjalanan terbaik Anda dari berbagai situs web"
                },
                "travel-country-header-description": "Klasifikasi yang Jelas, Mudah Dipilih",
                "travel-country-header-title": "SIM perjalanan mencakup 200 negara",
                "travel-info-header-description": "Membawa Anda inspirasi perjalanan merah-panas",
                "travel-info-header-title": "Inspirasi Perjalanan",
                "travel-marketplace-header-description": "",
                "travel-marketplace-header-title": "",
                "travel-sim-header-description": "Penawaran kartu SIM terbaik dengan pengiriman gratis",
                "travel-sim-header-title": "SIM Perjalanan Populer"
            },
            "hotel": {
                "cover-subtitle": "Nikmati 5% Trip.com eksklusif menawarkan pemesanan hotel",
                "cover-title": "Imbalan Hotel",
                "discount-detail": "Menerapkan kode promo \"HYPERAIR5\" untuk menikmati 5% tawaran pemesanan hotel",
                "discount-title": "HYPERAIR5",
                "highlight-subtitle1": "Temukan hotel di seluruh dunia untuk tinggal yang unik.",
                "highlight-subtitle2": "Mendapatkan penawaran terbaik dan menyimpan uang Anda untuk perjalanan berikutnya.",
                "highlight-subtitle3": "Periksa tarif hotel mana saja kapan saja.",
                "highlight-title1": "Cakupan global",
                "highlight-title2": "Keistimewaan eksklusif",
                "highlight-title3": "Satu-klik Pemesanan"
            },
            "hypermiles": {
                "activity": "Activity",
                "balance": "Outstanding Balance",
                "benefit": "Your Privileges",
                "cumulative-purchase": "Accumulated Spending：HK$ {amount}",
                "diamond-black": "Diamond Black",
                "expire": "Expired HyperMiles ({date})",
                "expire-reminder-1": "HyperMiles is valid for one year from the shopping month",
                "expire-reminder-2": "Remember to use HyperMiles before expiry!",
                "hypermiles-total": "HyperMiles",
                "member": "Member",
                "member-tier": "You have become HyperAir {member_tier} member",
                "membership-details": "Membership Tier",
                "next-purchase": "save HK${amount} in your next purchase",
                "order-num": "Order No: {order_num}",
                "permanent-membership": "Permanent Membership",
                "popup-title": "HyperMiles Reward Scheme",
                "precious-platinum": "Precious Platinum",
                "product_purchase": "HyperMiles from gadgets purchase ({date})",
                "record": "HyperMiles Record",
                "royal-blue": "Royal Blue",
                "simcard_purchase": "HyperMiles from SIM purchase ({date})",
                "tier": "",
                "title": "HyperMiles. Explore the World, Enjoy the rebate!",
                "u-have": "Your have",
                "usage": "Redeemed HyperMiles",
                "what-is-hypermiles": "What is HyperMiles",
                "what-is-hypermiles-slogan1": "Spend more. Earn more!",
                "what-is-hypermiles-slogan2": "Every 100 HyperMiles can be used as HK$1 at checkout, no minimum spending limit",
                "what-is-hypermiles-slogan3": "Spend more at HyperAir to enjoy more privileges"
            },
            "hypermiles-disclaimer": "terms and conditions apply",
            "hypermiles-discount-diamond-black": "Spend every HK$1 to enjoy 1 HyperMiles",
            "hypermiles-discount-precious-platinum": "Spend every HK$1.5 to enjoy 1 HyperMiles",
            "hypermiles-discount-royal-blue": "Spend every HK$2 to enjoy 1 HyperMiles",
            "hypermiles-special-diamond-black": "Exclusive pre-sale offer",
            "hypermiles-spend-diamond-black": "Cumulative spending of HK$3,000",
            "hypermiles-spend-precious-platinum": "Cumulative spending of HK$1,500",
            "hypermiles-spend-royal-blue": "Basic Member",
            "login": {
                "email": "",
                "existing-user": "",
                "forgot-password": "",
                "forgot-password-please-fill-in-email": "",
                "login": "",
                "login-with-facebook": "",
                "login-with-google": "",
                "new-user": "",
                "or": "",
                "password": "",
                "phone-input-placeholder": "",
                "phone-input-title": "",
                "phone-verify": "",
                "resend-verification-code": "",
                "reset-password": "",
                "title": "",
                "verification-code-input-title": ""
            },
            "logo-loader": {
                "slogan": "We're almost there"
            },
            "my-order": {
                "amount": "",
                "esim-qrcode": "",
                "fx-status-cancelled": "",
                "fx-status-confirmed": "",
                "order-date": "",
                "order-details": "",
                "order-num": "",
                "status-confirmed": "",
                "status-pending-confirmation": "",
                "status-ready-to-ship": "",
                "status-shipped": ""
            },
            "my-order-details": {
                "delivery-info": "",
                "discount": "",
                "recipient-address": "",
                "recipient-email": "",
                "recipient-name": "",
                "recipient-tel": "",
                "shipping-method": "",
                "status": "",
                "total": "",
                "valid-date": ""
            },
            "nav": {
                "about-us": "Tentang kami",
                "car": "",
                "company": "Perusahaan",
                "company-address": "Entrepreneurship Centre, Level 3, Cyberport 3, Hong Kong",
                "contact-us": "Hubungi kami",
                "contact-us-description": "Silakan email ke <a href=\"mailto:hello@hyperair.com\">hello@hyperair.com</a> untuk setiap pertanyaan.",
                "disclaimer": "Disclaimer",
                "download-app": "Unduh Aplikasi",
                "flight": "",
                "foodie": "Foodie",
                "home": "Home",
                "hotel": "Hotel",
                "jobs": "Pengerahan",
                "logout": "Keluar",
                "media-coverage": "Press",
                "monthly-rental-hotel": "Monthly Rental Hotel",
                "privacy-policy": "Rahasia pribadi",
                "promo-banner-text": "HyperAir 客戶專享 5% Trip.com 獨家酒店折扣",
                "quarantine-hotel": "Long Stay Hotel",
                "refund-policy": "Kebijakan pengembalian",
                "spa-and-beauty": "Spa and Beauty",
                "staycation": "Staycation",
                "tag-line": "Compare Travel Sites & Save Money",
                "terms-of-service": "Ketentuan Layanan",
                "travel-activity": "",
                "travel-affiliate-codes": "kupon",
                "travel-affiliate-codes-md": "kupon",
                "travel-blog": "Blog",
                "travel-experience-d": "perjalanan wisata dan pengalaman",
                "travel-experience-md": "perjalanan wisata dan pengalaman",
                "travel-insurance": "Asuransi perjalanan",
                "travel-insurance-md": "Asuransi perjalanan",
                "travel-marketplace": "Gadget Travel",
                "travel-marketplace-md": "Gadget Travel",
                "travel-money": "Uang Perjalanan",
                "travel-money-md": "Uang Perjalanan",
                "travel-sim": "SIM perjalanan",
                "travel-sim-md": "SIM perjalanan"
            },
            "photo-banner": {
                "banner-button": ""
            },
            "product-card": {
                "num-of-review": "{num}-of-review ratings"
            },
            "redirection-gate": {
                "columns-1-description": "Bandingkan pengalaman perjalanan dari website yang berbeda terbaik",
                "columns-1-title": "Travel Kegiatan Perbandingan",
                "columns-2-description": "Terbaik penawaran kartu SIM dengan bebas biaya!",
                "columns-2-title": "SIM Travel",
                "columns-3-description": "Bandingkan dan buku tingkat FX terbaik di kota",
                "columns-3-title": "Uang Travel",
                "promo-code": "Kode",
                "remember-to-fill-promo-code": "Ingatlah untuk menerapkan kode promo di atas sebelum checkout",
                "title": "We are taking you to {domain}",
                "trouble-link": "If the browser does not redirect you in 10 seconds, please click this <a href=\"{link}\">link</a>."
            },
            "register": {
                "guest-checkout": "",
                "title": ""
            },
            "seo": {
                "best-price-guarantee-title": "Best Price Guarantee",
                "country-description": "{country} negara perjalanan - Jaminan Harga Terbaik dengan Pengiriman Gratis",
                "country-keywords": "SIM 卡, 上 網卡, 電話 卡, 數據 卡, DataSIM, 旅遊 DataSIM, 數據 咭, 4G 上 網卡, 上 網卡, 4G 上 網卡, 日本 4G 上 網卡, 日本 上 網卡, 東京 4G 上 網卡, 東京 上 網卡, 大阪 4G上 網卡, 大阪 上 網卡, 泰國 4G 上 網卡, 泰國 上 網卡, 曼谷 4G 上 網卡, 布吉 上 網卡, 芭提雅 4G 上 網卡, 台灣 4G 上 網卡, 台灣 上 網卡, 台北 4G 上 網卡, 高雄 上 網卡, 4G中 4G 上 網卡, 台中 上 網卡, 韓國 4G 上 網卡, 韓國 上 網卡, 首 爾 4G 上 網卡, 首 爾 上 網卡, 中上 4G 上 網卡, 中國 上 網卡, 深圳 4G 上 網卡, 深圳 上 網卡, 澳門 4G 上 網卡,澳門 上 網卡, Docomo, Softbank",
                "country-title": "{country} negara perjalanan - Jaminan Harga Terbaik dengan Pengiriman Gratis",
                "home-description": "HyperAir adalah platform perjalanan cerdas yang Anda sukai, menawarkan solusi perjalanan yang paling sesuai dan bernilai baik, sehingga Anda dapat melakukan perjalanan yang lebih cerdas, di mana saja.",
                "home-keywords": "sim 卡, 上 網卡, 電話 卡, 數據 卡, DataSIM, 旅遊 DataSIM, 數據 咭, 4G 上 網卡, 上 網卡, 4G 上 網卡, SIM 卡, SIM Perjalanan, 旅遊 SIM 卡, 唱 錢 神器, 唱 X 神器, 唱 錢X 器, 唱 錢, 唱 錢 aplikasi, 兌換, 找 換, 兌換 店, 找 換 店, 銀行, 金融, 外匯, 外滙, 外滙, 匯率, 滙率, 匯款, 外幣, 貨幣, 旅行, 旅行, 旅遊, 行程, 酒店, 機票,比較, 格 價, 特價, 預訂, 交易, 旅遊 保險, 日本, 泰國, 韓國, 台灣, 日圓, 日元, 台幣, 泰銖, 泰銖, HyperAir, HyperAir FX, Perjalanan HyperAir, Perjalanan, Uang Perjalanan, Mata Uang Asing, Valuta Asing,百年, 堅 成, 發達 鳥, 飛鳥, richbird, burung gila, pertukaran berlin",
                "home-title": "HyperAir - Travel Smarter. Di mana saja. | SIM Perjalanan Terbaik, FX, Asuransi Perjalanan, Pengalaman Lokal",
                "hotel-description": "Dapatkan penawaran pemesanan hotel ekstra melalui HyperAir.com",
                "hotel-keywords": "Hotel, hotel, diskon, pemesanan, Asia, Eropa, Amerika, Bangkok, Singapura, Hong Kong, Phuket, Thailand, Malaysia, Bali, London, Paris, program loyalitas, acommodation, akomodasi, acomodation, akomodasi, liburan",
                "hotel-title": "Penawaran Hotel",
                "money-exchange-description": "Check {shop_name}'s latest FX rate and book your travel money online. You can lock in FX rate and reserve foreign currency.",
                "money-exchange-keywords": "{shop_name}, 唱錢神器, 唱X神器, 唱錢X器, 唱錢, 兌換, 找換, 兌換店, 找換店, 銀行, 金融, 外匯, 外滙, 匯率, 滙率, 匯款, 外幣, 貨幣, 旅行, 旅遊, 行程, 酒店, 機票, 比較, 格價, 特價, 預訂, 交易, 旅遊保險, 日本, 泰國, 韓國, 台灣, 日圓, 日元, 台幣, 泰銖, HyperAir, HyperAir FX, HyperAir Travel, Travel, Travel Money, Foreign Currency, Foreign Exchange, 百年, 堅成, 發達鳥, 飛鳥, richbird, crazy bird, berlin exchange",
                "money-exchange-title": "{shop_name}'s latest FX rate with instant booking | Lock in FX rate and reserve your travel money instantly",
                "privacy-policy-title": "Privacy Policy",
                "refund-policy-title": "Refund & Return Policy",
                "sim-fanfares-description": "HyperAir telah meluncurkan Kartu SIM fanfares pertama di Hong Kong. Anda dapat membeli kartu SIM untuk perjalanan Anda dengan diskon hingga 50% off. Waktu Terbatas, Penawaran Terbatas!",
                "sim-fanfares-keywords": "fanfares, simcard, sim card, SIM 卡, 上 網卡, 電話 卡, 數據 卡, DataSIM, 旅遊 DataSIM, 數據 咭, 4G 上 網卡, 上 網卡, 4G 上 網卡, 日本 4G 上 網卡, 日本 上 網卡, 東京 4G 上 網卡, 東京 上 網卡, 大阪 4G 上 網卡, 大阪 上 網卡, 泰國 4G 上 網卡, 泰國 上 網卡, 曼谷 4G 上 網卡, 布吉 上 網卡, 芭提雅 4G 上 網卡, 台灣 4G 上 網卡, 台灣 上 網卡, 台北 4G上 網卡, 高雄 上 網卡, 台中 4G 上 網卡, 台中 上 網卡, 韓國 4G 上 網卡, 韓國 上 網卡, 首 爾 4G 上 網卡, 首 爾 上 網卡, 中國 4G 上 網卡, 中國 上 網卡, 深圳 4G 上 網卡, 深圳 上網卡, 澳門 4G 上 網卡, 澳門 上 網卡, DoCoMo, Softbank",
                "sim-fanfares-title": "SIM Card fanfares - Waktu Terbatas, Kartu Terbatas",
                "term-of-service-title": "Terms of Service",
                "travel-activity-search-results-description": "",
                "travel-activity-search-results-keywords": "{activity}, travel, local experience, local activity, ticket, activities, day tours, tourist attractions",
                "travel-activity-search-results-title": "HyperAir - Search Result of {q} in {city}",
                "travel-affiliate-codes-description": "HyperAir terus memperbarui kode kode diskon / promosi terbaru untuk diskon pemesanan hotel, tiket diskon udara, aktivitas diskon, diskon asuransi perjalanan, diskon kartu SIM dan diskon kartu kredit.",
                "travel-affiliate-codes-keywords": "Kode Diskon, Kupon Elektronik, Kode diskon, Kode Promosi, Kode Promo, Kode diskon, Hotel, Tiket Pesawat, Penawaran, Kartu Kredit Penawaran, Penawaran Travel",
                "travel-affiliate-codes-title": "2023 Kode Diskon Travel Terbaru (Harian Update) | pemesanan diskon hotel, penerbangan, kegiatan, asuransi perjalanan, Data SIM",
                "travel-insurance-description": "Mencari yang terbaik rencana Asuransi Perjalanan? rencana yang mencakup ponsel? Bandingkan rencana asuransi dari perusahaan seperti AIG, MSIG dan Starr, dan membeli secara online dengan diskon ekstra!",
                "travel-insurance-keywords": "AIG, MSIG, Starr, AIG Promocode, MSIG Promocode, Starr Promocode, Asuransi Perjalanan, asuransi perjalanan online, membandingkan Asuransi Perjalanan, asuransi murah perjalanan, asuransi perjalanan hong kong, satu perjalanan, rencana tahunan",
                "travel-insurance-title": "Terbaik Asuransi Perjalanan Tarif & Perbandingan di Hong Kong 2023",
                "travel-marketplace-checkout-payme-title": "Pay with PayMe",
                "travel-marketplace-checkout-success-keywords": "創意, 產品, 流行, 電器, 生活, 精品, 智能家居, 設計, 高品質, 設計概念, 創意科技, 生活用品, 戶外休閒, 廚房, 餐桌, 個人護理, 防疫抗疫, 健康, 遊戲, 兒童玩樂, 健身, 家居健身, gym, home gym, smart home, style home",
                "travel-marketplace-checkout-success-title": "{product_name}",
                "travel-marketplace-description": "A collection of coolest gadgets that you'll like",
                "travel-marketplace-keywords": "創意, 產品, 流行, 電器, 生活, 精品, 智能家居, 設計, 高品質, 設計概念, 創意科技, 生活用品, 戶外休閒, 廚房, 餐桌, 個人護理, 防疫抗疫, 健康, 遊戲, 兒童玩樂, 健身, 家居健身, gym, home gym, smart home, style home",
                "travel-marketplace-product-checkout-title": "{product}",
                "travel-marketplace-product-title": "{product}",
                "travel-marketplace-title": "Gadget Travel",
                "travel-money-description": "HyperAir memberi Anda cara baru untuk mendapatkan uang perjalanan. Sekarang Anda dapat memesan pertukaran online dengan nilai tukar terbaik di kota!",
                "travel-money-keywords": "sim 卡, 上 網卡, 電話 卡, 數據 卡, DataSIM, ��遊 DataSIM, 數據 咭, 4G 上 網卡, 上 網卡, 4G 上 網卡, 唱 錢 神器, 唱 X 神器, 唱 錢 X 器, 唱 錢, 兌換, 找 換, 兌換 店, 找 換 店, 銀行, 金融, 外匯, 外滙, 匯率, 滙率, 匯款, 外幣, 貨幣, 旅行, 旅行, 旅遊, 行程, 酒店, 酒店, 機票, 比較, 格 價, 特價, 預訂, 交易, 旅遊 保險,日本, 泰國, 韓國, 台灣, 日圓, 日元, 台幣, 泰銖, HyperAir, HyperAir FX, HyperAir Perjalanan, Perjalanan, Uang Perjalanan, Mata Uang Asing, Valuta Asing, 百年, 堅 成, 發達 鳥, 飛鳥, burung kaya, burung gila , pertukaran berlin",
                "travel-money-title": "HyperAir - Tukarkan Uang Perjalanan Lebih Cerdas.",
                "travel-product-checkout-keywords": "創意, 產品, 流行, 電器, 生活, 精品, 智能家居, 設計, 高品質, 設計概念, 創意科技, 生活用品, 戶外休閒, 廚房, 餐桌, 個人護理, 防疫抗疫, 健康, 遊戲, 兒童玩樂, 健身, 家居健身, gym, home gym, smart home, style home",
                "travel-product-keywords": "創意, 產品, 流行, 電器, 生活, 精品, 智能家居, 設計, 高品質, 設計概念, 創意科技, 生活用品, 戶外休閒, 廚房, 餐桌, 個人護理, 防疫抗疫, 健康, 遊戲, 兒童玩樂, 健身, 家居健身, gym, home gym, smart home, style home",
                "travel-sim-checkout-description": "{country} Travel SIM - Kartu SIM berkualitas tinggi dengan pengiriman gratis ke pintu Anda!",
                "travel-sim-checkout-keywords": "上 網卡, 電話 卡, 數據 卡, DataSIM, 旅遊 DataSIM, 數據 咭, 4G 上 網卡, 上 網卡, 4G 上 網卡, 日本 4G 上 網卡, 日本 上 網卡, 東京 4G 上 網卡, 東京 上 網卡, 阪 上 上 網卡,大阪 上 網卡, 泰國 4G 上 網卡, 泰國 上 網卡, 曼谷 4G 上 網卡, 布吉 上 網卡, 芭提雅 4G 上 網卡, 台灣 4G 上 網卡, 台灣 上 網卡, 台北 4G 上 網卡, 高雄 上 網卡, 台中 4G 上網卡, 台中 上 網卡, 韓國 4G 上 網卡, 韓國 上 網卡, 首 爾 4G 上 網卡, 首 爾 上 網卡, 中國 4G 上 網卡, 中國 國 網卡, 深圳 4G 上 網卡, 深圳 上 澳門, 澳門 4G 上 網卡, 澳門 上 網卡, Docomo, Softbank",
                "travel-sim-checkout-success-description": "{country} Travel SIM - Kartu SIM berkualitas tinggi dengan pengiriman gratis ke pintu Anda!",
                "travel-sim-checkout-success-keywords": "上 網卡, 電話 卡, 數據 卡, DataSIM, 旅遊 DataSIM, 數據 咭, 4G 上 網卡, 上 網卡, 4G 上 網卡, 日本 4G 上 網卡, 日本 上 網卡, 東京 4G 上 網卡, 東京 上 網卡, 阪 上 上 網卡,大阪 上 網卡, 泰國 4G 上 網卡, 泰國 上 網卡, 曼谷 4G 上 網卡, 布吉 上 網卡, 芭提雅 4G 上 網卡, 台灣 4G 上 網卡, 台灣 上 網卡, 台北 4G 上 網卡, 高雄 上 網卡, 台中 4G 上網卡, 台中 上 網卡, 韓國 4G 上 網卡, 韓國 上 網卡, 首 爾 4G 上 網卡, 首 爾 上 網卡, 中國 4G 上 網卡, 中國 國 網卡, 深圳 4G 上 網卡, 深圳 上 澳門, 澳門 4G 上 網卡, 澳門 上 網卡, Docomo, Softbank",
                "travel-sim-checkout-success-title": "Keberhasilan Pembayaran - SIM Perjalanan",
                "travel-sim-checkout-title": "Place Order - SIM Perjalanan",
                "travel-sim-keywords": "sim 卡, 上 網卡, 電話 卡, 數據 卡, DataSIM, 旅遊 DataSIM, 數據 咭, 4G 上 網卡, 上 網卡, 日本 4G 上 網卡, 日本 上 網卡, 日本 sim 卡, 東京 4G 上 網卡, 東京 上 網卡, 大阪 4G上 ��卡, 大阪 上 網卡, 泰國 4G 上 網卡, 泰國 上 網卡, 泰國 sim 卡, 曼谷 4G 上 網卡, 布吉 上 網卡, 芭提雅 4G 上 網卡, 台灣 4G 上 網卡, 台灣 上 網卡, 台灣 sim 卡, 台北4G 上 網卡, 高雄 上 網卡, 台中 4G 上 網卡, 台中 上 網卡, 韓國 sim 卡, 韓國 4G 上 網卡, 韓國 上 網卡, 首 爾 4G 上 網卡, 首 爾 上, 中國 4G 上 國, 中國 上 網卡, 中國 sim卡, 中內 數據地 數據 卡, 深圳 4G 上 網卡, 深圳 上 網卡, 澳門 4G 上 網卡, 澳門 上 網卡, 歐洲 4G 上 網卡, 歐洲 上 網卡, 歐洲 sim 卡, 英國 4G 上 網卡, 英國 上 英國, 英國 sim 卡, 法國 4G 上 網卡, 法國 上 網卡, 法國 sim 卡, 恴 大利 4G 上 網卡, 意大利 上 網卡, 意大利 sim 卡, 巴黎 4G 上 網卡, 巴黎 上 網卡, 巴黎 sim 卡, 瑞士 4G 上 瑞士, 瑞士 上 網卡,瑞士 sim 卡, Docomo, Softbank, 和 記, 聯通, 3hk, 3uk, birdie, 自由 鳥, udara sim, sim2fly, AIS, ais sim2fly, SK Telecom, TrueMove, dtac, t seluler 全球 上 網卡, vietnamobile",
                "travel-sim-title": "【{country} SIM】{sim_name} - Jaminan Harga Terbaik dengan Pengiriman Gratis",
                "travel-sims-description": "Mesin Pencari SIM Perjalanan Global dengan kartu SIM berkualitas tinggi dan pengiriman gratis ke rumah Anda!",
                "travel-sims-keywords": "sim 卡, 上 網卡, 電話 卡, 數據 卡, DataSIM, 旅遊 DataSIM, 數據 咭, 4G 上 網卡, 4Gsim 卡, 日本 4G 上 網卡, 日本 上 網卡, 日本 sim 卡, 東京 4G 上 網卡, 東京 上 網卡, 大阪 4G上 網卡, 大阪 上 網卡, 泰國 4G 上 網卡, 泰國 上 網卡, 泰國 sim 卡, 曼谷 4G 上 網卡, 布吉 上 網卡, 芭提雅 4G 上 網卡, 台灣 4G 上 網卡, 台灣 上 網卡, 台灣 sim 卡, 台北4G 上 網卡, 高雄 上 網卡, 台中 4G 上 網卡, 台中 上 網卡, 韓國 sim 卡, 韓國 4G 上 網卡, 韓國 上 網卡, 首 爾 4G 上 網卡, 首 爾 上, 中國 4G 上 國, 中國 上 網卡, 中國 sim國, 國內 內地 數據 卡, 深圳 4G 上 網卡, 深圳 上 網卡, 澳門 4G 上 網卡, 澳門 上 網卡, 澳門 sim 卡, 歐洲 sim 卡, Docomo, Softbank, sim2fly, AIS, ais sim2fly, SK Telecom, TrueMove, dtac , t seluler 全球 上 網卡, vietnamobile",
                "travel-sims-title": "SIM Perjalanan - Jaminan Harga Terbaik dengan Pengiriman Gratis"
            },
            "shop-confirmation": {
                "app-download": "",
                "app-download-subtitle": "",
                "instruction": "",
                "my-order": "",
                "pending-confirm": ""
            },
            "staycation": {
                "activity-countdown-button": "Find the cheapest price",
                "all-hotels": {
                    "sorting": {
                        "recommended": "Recommended"
                    }
                },
                "all-hotels-all-button": "All",
                "all-hotels-hotel-name": "Hotel Name",
                "all-hotels-last-updated": "Last Updated",
                "all-hotels-less-button": "Less",
                "all-hotels-more-button": "More",
                "all-hotels-no-result": "Sorry, we couldn't find any results",
                "all-hotels-title": "",
                "compare-packages": "Compare other packages",
                "countdown-button": "More Details",
                "countdown-title": "",
                "countdown2-title": "HyperAir Recommended",
                "countdown3-title": "最新 Staycation 酒店限時優惠",
                "month-format": "MMM",
                "order-d-title": "浪漫精品酒店 💕💕",
                "order-g-subtitle": "暑假帶埋一家大細Relax下",
                "order-g-title": "親子Staycation必去之選👨‍👩‍👧‍👦😍",
                "order-h-title": "郵輪之旅🛳️",
                "order-i-title": "情侶煮飯仔酒店 🍽️",
                "order-j-title": "Glamping豪華露營推介",
                "seo-description": "點解咁多人用 HyperAir 搵 Staycation? 因為集合左 KKday, Trip.com, Klook 及各大香港酒店平台，一眼比較邊到有late checkout、免費泊車、自助早午晚餐及餐飲回贈等獨家 Staycation 優惠，每日更新。",
                "seo-keywords": "staycation, staycation 優惠, 香港 staycation, staycation 香港, staycation hk, staycation package, staycation hong kong, 酒店, 酒店 優惠, staycation 中文, 香港 酒店, klook 優惠, klook 優惠, kkday 優惠, trip 優惠, agoda 優惠, runhotel staycation, 酒店 套票, staycation 酒店, 香港 酒店 套票, 訂 酒店 優惠, 酒店 package, 特價 酒店, 香港 優惠 酒店, 酒店 優惠 套 票, 特價 酒店 香港, 香港 酒店 優惠, 酒店 住宿 優惠, staycation 2020, staycation 2021, staycation 2022, staycation 1月 優惠, staycation 2月 優惠, staycation 3月 優惠, staycation 4月 優惠, staycation 5月 優惠, staycation 6月 優惠, staycation 7月 優惠, staycation 8月 優惠, staycation 9月 優惠, staycation 10月 優惠, staycation 11月 優惠, staycation 12月 優惠, 四季酒店, W酒店, Murray, JW Marriott, St. Regis, Conrad Hotel, Grand Hyatt, Ritz Carlton, Rosewood, 露台 酒店, 廚房 酒店, 親子 酒店, 情侶 酒店",
                "seo-title": "【2021年9月最新】香港酒店 Staycation 優惠搜尋神器 全港最齊．每日更新 - 最齊香港staycation優惠、酒店優惠、Hong Kong Staycation Ideas、Klook優惠、KKday優惠、Trip優惠、Agoda優惠、專業旅運優惠 - HyperAir 玩樂必備搜尋比較平台！一次過，比較全球多個玩樂旅遊預訂網站！ - HyperAir",
                "share-button-alert": "Copied the Link",
                "subtitle": "每日更新酒店餐飲及住宿優惠（{start_month}月至{end_month}月）",
                "title": "",
                "top10-title": "",
                "top102-title": "",
                "top103-title": "值得一試的 Staycation 酒店🥂"
            },
            "travel-activities": {
                "best-deals": "Best Deal",
                "book-now": "View Deal",
                "disclaimer": "Harga yang tertera hanya untuk referensi. Jika ada perbedaan, silakan merujuk ke situs web mitra kami.",
                "empty-destination": "",
                "more-deals": "More Deals",
                "not-available": "Not Available",
                "offers": "",
                "provider-getyourguide": "GetYourGuide",
                "provider-hk": {
                    "trip": {
                        "com": "Trip.com"
                    }
                },
                "provider-hyperair": "HyperAir",
                "provider-kkday": "KKday",
                "provider-klook": "KLOOK",
                "provider-seoultravelpass": "SeoulPass",
                "provider-sim": {
                    "hyperair": {
                        "com": "HyperAir"
                    }
                },
                "provider-travelexpert": "Travel Expert",
                "provider-trip": "Trip.com",
                "ratings": "Peringkat",
                "recommended-title": "Aktivitas yang lebih populer di {city}",
                "search-africa-oceania": "Afrika / Oseania",
                "search-all-cities": "Semua Kota",
                "search-america": "Amerika",
                "search-asia": "Asia",
                "search-button": "Cari",
                "search-cancel-button": "Membatalkan",
                "search-country-placeholder": "Masukkan negara atau kota",
                "search-euro-middleeast": "Eropa / Timur Tengah",
                "search-hardcoded-cities": "Popular Search:",
                "search-placeholder": "Cari \"JR Pass\"",
                "search-popular-cities": "Kota-kota Populer",
                "search-searched-cities": "Kota yang Dicari",
                "search-slogan-2": "",
                "show-similar-product": "bandingkan serupa",
                "sorting": {
                    "price-asc": "Harga (Rendah ke Tinggi)",
                    "price-desc": "Harga (Tinggi ke Rendah)",
                    "rating": "Peringkat",
                    "relevance": "Relevansi",
                    "sort-by": "Sortir dengan"
                },
                "title": "Hasil pencarian yang cocok \"{q}\"",
                "title-everything": "Aktivitas populer di {city}",
                "title-no-result": "Maaf, kami tidak dapat menemukan hasil untuk \"{q}\"",
                "title-no-result-without-keyword": "Maaf, kami tidak menemukan hasil apapun",
                "total-results": "Total hasil <b>{number} </b>"
            },
            "travel-affiliate-codes": {
                "cover-slogan": "Menyediakan kode diskon untuk situs pemesanan perjalanan internasional",
                "cover-title": "Kupon Diskon Travel",
                "disclaimer": "Menawarkan promosi yang ditampilkan adalah hanya untuk referensi. Bila terjadi perbedaan, silakan merujuk ke situs web mitra kami. Pemasok dapat mengubah atau menghapus informasi setiap saat tanpa pemberitahuan terlebih dahulu dan harus memiliki kebijakannya tawaran tersebut.",
                "exclusive": "Eksklusif",
                "type-activity": "Aktivitas",
                "type-air": "Tiket pesawat",
                "type-all": "Semua",
                "type-hotel": "Hotel",
                "type-insurance": "Asuransi perjalanan",
                "type-shopping": "Perbelanjaan",
                "type-sim": "Kartu SIM",
                "use-promo-code": "Ambil kode",
                "valid-until": "Berlaku hingga:"
            },
            "travel-insurance": {
                "breadcrumb-travel-insurance": "Asuransi perjalanan",
                "cover-subtitle": "Cari dan bandingkan asuransi perjalanan terbaik dengan cakupan ponsel!",
                "cover-title": "Asuransi perjalanan",
                "departure-date-alert": "",
                "disclaimer": "Kutipan adalah untuk referensi saja. Silakan merujuk ke situs perusahaan asuransi untuk rincian lebih lanjut.",
                "highlight-subtitle1": "Daftar keluar cakupan kunci dari rencana asuransi perjalanan untuk seleksi mudah Anda",
                "highlight-subtitle2": "Bandingkan terbaik penawaran asuransi perjalanan untuk membantu Anda menyimpan setiap dolar!",
                "highlight-subtitle3": "Menikmati hak istimewa asuransi perjalanan eksklusif dan penawaran!",
                "highlight-title1": "cakupan Perbandingan",
                "highlight-title2": "Pricing Perbandingan",
                "highlight-title3": "Hadiah eksklusif",
                "num-of-travellers-alert": "",
                "partner-title": "Kami Perjalanan Asuransi Mitra",
                "return-date-alert": "",
                "section-title": "Anda sekarang mencari {num_of_day} untuk {num_of_traveller} wisatawan (s)",
                "slogan": "3 Langkah Mudah",
                "sorting": {
                    "coverage": "Cakupan terbaik",
                    "price-asc": "Harga (Rendah ke Tinggi)",
                    "price-desc": "Harga (Tinggi ke Rendah)"
                },
                "step1": "Isi info",
                "step1-detail": "Masukkan tujuan Anda, tanggal dan tidak ada. dari wisatawan",
                "step2": "Bandingkan rencana",
                "step2-detail": "Bandingkan harga dan cakupan rencana asuransi perjalanan yang berbeda",
                "step3": "Nikmati penawaran",
                "step3-detail": "Satu-klik untuk menikmati penawaran asuransi perjalanan eksklusif"
            },
            "travel-insurance-product-card": {
                "apply-now": "Dapatkan tawaran",
                "cancellation": "PEMBATALAN",
                "car-rental": "KENDARAAN RENTAL KELEBIHAN",
                "cruise-vacation": "CRUISE VACATION (manfaat opsional)",
                "dangerous-sports": "SPORTS BERBAHAYA",
                "hyperair-exclusive": "HYPERAIR EKSKLUSIF",
                "medical": "MEDIS",
                "mobile": "KEHILANGAN / KERUSAKAN PONSEL",
                "personal-belongings": "BARANG PRIBADI",
                "trip-delay": "TRIP DELAY"
            },
            "travel-insurance-search-bar": {
                "children": "Anak-anak berusia di bawah 18",
                "date": "Tanggal keberangkatan dan tanggal kembali",
                "destination": "Di mana Anda pergi",
                "friend": "Teman / Kerabat",
                "myself": "Diri",
                "number-of-traveller": "Jumlah Wisatawan",
                "search-button": "Cari",
                "spouse": "Pasangan"
            },
            "travel-marketplace": {
                "buy-now-can-earn-x-miles": "",
                "cover-slogan": "Koleksi gadget paling keren yang Anda akan menyukai",
                "cover-title": "Gadget Travel"
            },
            "travel-marketplace-categories": "Categories",
            "travel-marketplace-checkout": {
                "delivery-message-body": "hari kerja dari Senin sampai Jumat (kecuali hari libur). Urutan cut-off time adalah 12{00} (GMT + 8). Pesanan ditempatkan setelah 12{00} (GMT + 8) akan mengapalkan hari kerja berikutnya.",
                "delivery-method-1": "SF Express (Hong Kong Only)",
                "delivery-method-1-description": "Oleh SF Express, biaya kurir adalah HK $ 30 per pesanan. Biaya kurir dibebaskan setelah pembelian di atas HK $ 800. item yang dipesan akan dikirimkan melalui kurir dalam waktu 1-3 hari kerja, dan pulau-pulau akan mengambil 5 hari kerja, merujuk ke website SF Express.",
                "delivery-method-2": "Pengiriman internasional",
                "delivery-method-2-description": "Pengiriman 4 sampai 15 hari kerja tergantung pada tujuan. Biaya pengiriman adalah HK $ 100 per item. Biaya pengiriman internasional atas didasarkan pada estimasi. biaya tambahan lanjut mungkin berlaku."
            },
            "travel-money": {
                "breadcrumb-travel-money": "Uang Travel",
                "cover-button": "Pengalaman Sekarang",
                "cover-slogan": "Tukarkan uang perjalanan dengan lebih cerdas",
                "cover-title": "Uang Perjalanan",
                "disclaimer": "Harga yang ditampilkan adalah hanya untuk referensi. Bila terjadi perbedaan, silakan lihat website penukar uang.",
                "empty-amount": "",
                "fx": "",
                "fx-slogan": "Empat Langkah Mudah",
                "fx-step1": "Pencarian",
                "fx-step1-detail": "Pilih mata uang yang ingin Anda tukarkan",
                "fx-step2": "Membandingkan",
                "fx-step2-detail": "Temukan tarif terbaik dan tempat penjemputan paling nyaman",
                "fx-step3": "Buku",
                "fx-step3-detail": "Cadangan uang perjalanan online",
                "fx-step4": "Menjemput",
                "fx-step4-detail": "Tunjukkan kode QR untuk mendapatkan uang perjalanan",
                "hyperair-feature-1": "Pintar",
                "hyperair-feature-1-description": "Cara cerdas untuk bertukar uang perjalanan. Sekarang Anda dapat menemukan tarif terbaik hanya dengan beberapa klik dan memesan uang perjalanan online. Saatnya mengucapkan selamat tinggal pada antrian panjang!",
                "hyperair-feature-2": "Andal",
                "hyperair-feature-2-description": "Cara yang andal untuk mendapatkan pertukaran uang. Semua mitra kami adalah bank berlisensi dan penukar uang untuk menjaga keamanan valas Anda.",
                "hyperair-feature-3": "Di mana saja. Kapan saja.",
                "hyperair-feature-3-description": "Cara baru untuk mendapatkan uang perjalanan. Kami ingin memperluas jejak di luar negeri dan memberikan Anda pengalaman perjalanan paling cerdas di mana saja.",
                "i-will-get": "SAYA AKAN MENDAPATKAN",
                "i-will-pay": "SAYA AKAN MEMBAYAR",
                "join-us": "Untuk peluang bisnis yang lebih banyak",
                "join-us-button": "Bergabunglah Dengan Kami Sekarang",
                "join-us-slogan": "Menjadi pemasok kami",
                "search-bar-placeholder": "Masukan jumlah",
                "search-button": "Cari",
                "section-title": "",
                "section-title-from-hkd": "Mencari HKD untuk {amount} {currency}",
                "section-title-to-hkd": "Mencari {amount} {currency} untuk HKD",
                "why-hyperair": "",
                "why-hyperair-description": "HyperAir memberi Anda cara baru untuk mendapatkan uang perjalanan. Sekarang Anda dapat memesan pertukaran online dengan nilai tukar terbaik di kota!",
                "why-hyperair-title": "Mengapa memilih kami?"
            },
            "travel-product": {
                "buy-now": "Beli sekarang",
                "product-option": "Pilihan"
            },
            "travel-sim": {
                "as-low-as": "Serendah",
                "book-now": "Pesan sekarang",
                "breadcrumb-homepage": "Beranda",
                "breadcrumb-mainpage": "Halaman Utama",
                "breadcrumb-travel-sim": "SIM perjalanan",
                "cancellation-policy": "Kebijakan Pembatalan",
                "cancellation-policy-content": "Tidak ada pembatalan, pengembalian uang, atau perubahan yang dapat dilakukan setelah pembelian.",
                "download-hyperair-now-description": "Pindai kode QR atau buka toko aplikasi untuk mengunduh Aplikasi HyperAir",
                "download-hyperair-now-title": "Unduh Aplikasi HyperAir",
                "first-step": "Langkah 1",
                "go-to-shopping-cart-description": "",
                "go-to-shopping-cart-title": "",
                "hardcoded-countries-title": "Negara-negara Populer lainnya:",
                "highlights": "Highlight",
                "important-notice": "Pemberitahuan Penting",
                "instructions": "Instruksi",
                "lowest-price-guarantee": "Jaminan Harga Terbaik",
                "no-stock": "Habis terjual",
                "num-of-review": ": num-of-review",
                "popular-countries": "SIM perjalanan mencakup 200 negara",
                "popular-countries-search-button": "Cari negara lain",
                "product-highlights": "Product Description",
                "product-specification": "Spesifikasi produk",
                "related-sims": "Terkait: SIM negara",
                "related-sims-search-button": "Lebih lanjut: SIM negara",
                "review": "Ulasan",
                "review-date": "{tanggal}",
                "review-no-firstname-user": "Wisatawan",
                "scan-product-qr-code": "掃 一掃 Kode QR 購買 此 產品",
                "second-step": "Langkah 2",
                "sim": " Sim Cards",
                "web-traffic": "Dibeli: jumlah waktu pembelian sejak minggu lalu dan: jumlah pengguna lalu lintas sedang melihat SIM ini sekarang",
                "web-traffic-title": "SIM ini dalam penjualan panas!"
            },
            "travel-sim-checkout": {
                "-secure-payment-slogan": "",
                "address": "Alamat Pengiriman",
                "address-column1": "misalnya Kamar A, 18 / F, World Center",
                "address-column2": "misalnya 88 Travel Road",
                "address-column3": "misalnya Pusat, Hong Kong",
                "back-button": "Kembali",
                "checkout-title-1": "Info Pengiriman",
                "confirm-button": "Terus",
                "country-code": "Kode negara",
                "delivery-message-body": "Working days are from Monday to Friday (except public holidays). The order cut-off time is 12：00 PM (GMT+8). Orders placed after 12：00 PM (GMT+8) will ship out the next working day.\n<br><br>Within the same working day, orders with the same delivery address will be sent together.",
                "delivery-message-header": "Pemberitahuan pengiriman",
                "delivery-method": "metode pengiriman",
                "delivery-method-1": "Hong Kong Post (Free)",
                "delivery-method-1-description": "By Hong Kong Post's Local Mail, the estimated delivery will be within 3-6 working days. Status tracking is not available to local mail and customers shall bare the full responsibility of losing items by using Hong Kong Post’s ordinary mail service.\n<br><br>Note: Due to the time required for delivery, customers who are about to travel are recommended to choose SF Express",
                "delivery-method-2": "SF Express (Hong Kong only. Courier fee payable on delivery)",
                "delivery-method-2-description": "By SF Express (courier fee payable on delivery), the ordered items will be delivered by courier within 1-3 working days, and islands will take longer delivery time. The courier fee is about HK$16-$25 by referring to the website of SF Express.\n<br><br>Note: The order over HK$399 will be upgraded to SF Express for FREE",
                "delivery-method-3": "International Shipping",
                "delivery-method-3-description": "Delivered by Hong Kong Post (tracking no. will be provided) within 4 to 15 working days depends on the destination. Shipping cost HK$30.",
                "error-alert-address": "Silakan isi alamat pengiriman.",
                "error-alert-invalid-email": "Format email tidak valid.",
                "error-alert-invalid-recipient-first-num": "nomor kontak harus dimulai dengan 2,3,5,6,7,8 atau 9.",
                "error-alert-invalid-recipient-number": "Silakan isi nomor kontak yang benar.",
                "error-alert-invalid-user-first-num": "Nomor ponsel harus dimulai dengan 5,6,7,8 atau 9.",
                "error-alert-invalid-user-number": "Silakan isi nomor ponsel yang benar.",
                "error-alert-personal-info": "Silakan isi Info Pribadi.",
                "error-alert-recipient-info": "Silakan isi Info Penerima.",
                "error-invalid-credit-card-info": "Informasi Kartu Kredit Tidak Valid",
                "facebook-login": "Lanjutkan Dengan Facebook",
                "google-login": "Lanjutkan Dengan Google",
                "logged-in": "Masuk",
                "login": "Pelanggan yang sudah ada, login untuk menikmati check-out kilat",
                "login-button": "Masuk",
                "login-email": "E-mail",
                "login-no-user-exists": "Ups! Maaf, kami tidak dapat mengonfirmasi informasi login Anda. Silakan coba lagi atau cukup isi pesanan tanpa tamu check-out.",
                "login-password": "Kata sandi",
                "payme": {
                    "error-contacting-payme": "kesalahan pembayaran, silahkan re-order lagi atau hubungi dukungan pelanggan."
                },
                "payment": {
                    "actual-payment": "The transaction will be settled at HK${actual_payment} and the exchange rate will be based on your credit card issuer.",
                    "choose-payment-method": "Pilih cara pembayaran:",
                    "logistic-information": "Info Pengiriman",
                    "modify-information": "Edit Info",
                    "pay-now": "Bayar sekarang",
                    "payme-instruction-do-not-close": "Jangan menutup halaman ini sebelum pembayaran selesai",
                    "payme-instruction-step-1": "1. Buka aplikasi payme.",
                    "payme-instruction-step-2": "2. Scan Paycode untuk pembayaran authorize.",
                    "payme-instruction-step-3": "3. pembayaran lengkap dalam aplikasi dan tunggu konfirmasi.",
                    "payme-instruction-title": "Membayar dengan payme",
                    "payme-title": "Memindai Paycode ini dengan payme",
                    "payment": "Pembayaran",
                    "price": "Jumlah",
                    "shipping-fee": "Biaya pengiriman",
                    "subtotal": "Subtotal"
                },
                "payment-method": "Metode pembayaran",
                "pending": {
                    "mobile-redirection-text": "Anda telah memilih payme sebagai metode pembayaran dan akan diarahkan ke aplikasi payme untuk menyelesaikan pembayaran.",
                    "need-to-pay": "jumlah karena",
                    "order-number": "Jumlah order",
                    "order-success-please-pay": "Silakan membayar dengan payme untuk menyelesaikan proses pemesanan",
                    "paycode-error": "kesalahan pembayaran, silahkan re-order lagi atau hubungi dukungan pelanggan.",
                    "paycode-expired": "Paycode payme ini berakhir, silakan re-order lagi.",
                    "re-order": "Re-order",
                    "title-payme": "Bayar dengan payme"
                },
                "recipient-address": "Alamat Pengiriman",
                "recipient-information": "Info Penerima",
                "recipient-name": "nama Penerima",
                "recipient-phone-number": "Nomor Telepon Penerima",
                "secure-payment-slogan": "Checkout Aman | Pembayaran akan dienkripsi dan dikirimkan secara aman menggunakan SSL",
                "simproduct-detail": "Info Pemesanan",
                "simproduct-quantity": "Kuantitas",
                "simproduct-redeem": "",
                "simproduct-redeem-hypermiles": "",
                "simproduct-title": "Produk",
                "simproduct-will-redeeming-x-miles": "",
                "simproduct-you-have-x-hypermiles": "",
                "user-email": "Email (Untuk menerima faktur)",
                "user-firstname": "Nama depan",
                "user-information": "Informasi pribadi",
                "user-lastname": "Nama keluarga",
                "user-phone-number": "Nomor handphone",
                "vertical-divider": "Atau"
            },
            "travel-sims": {
                "column-title-1": "Klasifikasi yang Jelas, Mudah Dipilih",
                "column-title-2": "Pembayaran Online, Nyaman dan Cepat",
                "column-title-3": "Surface Mail Gratis, Pengiriman Cepat",
                "country-search-no-place-found": "Tidak ditemukan hasil untuk tujuan ini",
                "cover-button": "Pesan dengan HyperAir App Now",
                "cover-slogan": "Penawaran kartu SIM terbaik dengan pengiriman gratis!",
                "cover-title": "SIM perjalanan",
                "empty-destination": "",
                "num-of-days": "",
                "search-button": "",
                "search-input": "Cari negara",
                "search-placeholder": "Cari negara",
                "search-slogan": "Kemana kamu pergi",
                "travel-sim-header-description": "",
                "travel-sim-header-title": ""
            }
        },
        "passwords": {
            "password": "Kata sandi minimal harus enam karakter dan cocok dengan konfirmasi.",
            "reset": "Kata sandi Anda telah disetel ulang!",
            "sent": "Kami telah mengirim e-mail tautan atur ulang kata sandi Anda!",
            "token": "Token atur ulang kata sandi ini tidak valid.",
            "user": "Kami tidak dapat menemukan pengguna dengan alamat email itu."
        },
        "mail": {
            "product-simcard": {
                "delivery-update": {
                    "subject": "Pesanan Kartu SIM Anda sedang dalam perjalanan"
                },
                "purchased": {
                    "subject": "Konfirmasi Pemesanan SIM Perjalanan"
                },
                "tracking-number-update": {
                    "subject": "Nomor pelacakan pesanan Anda diperbarui"
                }
            }
        },
        "member-center": {
            "login-to-receive-codes": "",
            "my-orders-empty": "Tidak ada Rekaman",
            "my-orders-title": "pesananku",
            "profile-area-code": "Kode area",
            "profile-email": "Surel",
            "profile-firstname": "Nama depan",
            "profile-lastname": "Nama keluarga",
            "profile-save": "Menyimpan",
            "profile-tel": "tel",
            "profile-title": "Profil",
            "profile-update-successfully": "",
            "promo-code-enter-promotion-code": "Masukkan kode promosi",
            "promo-code-my-promo-code": "Saya HyperAir Kode Promosi",
            "promo-code-no-code": "",
            "promo-code-please-fill-in-code": "",
            "promo-code-redeem": "Menebus",
            "promo-code-redeem-code": "Gunakan HyperAir Kode Promosi",
            "promo-code-select": "Pilih",
            "promo-code-title": "HyperAir Kode Promo",
            "title": "anggota Pusat"
        },
        "weekday": {
            "1": "Senin",
            "2": "Selasa",
            "3": "Rabu",
            "4": "Kamis",
            "5": "Jumat",
            "6": "Sabtu",
            "7": "Minggu"
        },
        "exchange-shop-details": {
            "address": "Alamat",
            "book-button": "Pesan sekarang",
            "br": "BR",
            "closed-book-button": "Tutup",
            "download-pop-up": {
                "slogan-1": "Terkunci di Tingkat",
                "slogan-2": "instan comfirmation",
                "title": "Unduh App untuk Pemesanan FX"
            },
            "latest-updated": "terbaru Diperbarui",
            "not-available-book-button": "tidak tersedia",
            "opening-hrs": "Jam buka",
            "phone-num": "Nomor telepon",
            "rate": "Menilai",
            "reviews": "ulasan",
            "table-buy-rate": "Beli tingkat",
            "table-compare-button": "Membandingkan",
            "table-currency": "Mata uang",
            "table-sell-rate": "Tingkat Jual",
            "table-short-form": "Kode",
            "table-title": "Mata Uang lain"
        },
        "credit-card": {
            "cannot-add-card": "Terjadi kesalahan saat menambahkan kartu kredit Anda. Silakan periksa informasi Anda dan coba lagi atau Anda dapat menambahkan kartu kredit lain.",
            "cannot-process": "Terjadi kesalahan saat mengisi daya kartu kredit Anda. Silakan periksa informasi Anda dan coba lagi atau Anda dapat memeriksa dengan kartu kredit lain."
        },
        "shoppingcart": {
            "add": {
                "no-stock": "Ups! Mencapai jumlah pembelian maksimum untuk produk ini ..."
            },
            "pay": {
                "db-locked": "Server sibuk. Silakan coba lagi nanti. (Kode Ref: E1003)",
                "invalid-promotion-code": "Kode Promosi Tidak Valid",
                "no-stock": "Produk kehabisan stok sekarang! (Kode Ref: E1002)"
            },
            "promotion-message": {
                "up-sell-1": "Nikmati diskon HK $ 10 dengan kupon sambutan",
                "up-sell-2": "Nikmati diskon HK $ 15 dengan kode promo HYPER15 saat berbelanja di atas HK $ 299"
            }
        },
        "product": {
            "label-confirmation-duration-24_hours": "Konfirmasi 24 jam",
            "label-confirmation-duration-48_hours": "Konfirmasi 48 jam",
            "label-confirmation-duration-instant": "Konfirmasi instan",
            "label-duration-unit-day": "& nbsp; hari",
            "label-duration-unit-hour": "jam)",
            "label-duration-unit-hr": "& nbsp; jam",
            "label-duration-unit-min": "& nbsp; mnt",
            "label-earliest-available-date": "j M Y",
            "label-earliest-available-date-today": "Hari ini",
            "label-earliest-available-date-tomorrow": "Besok",
            "label-lang-en": "Inggris",
            "label-lang-jp": "Jepang",
            "label-lang-kr": "Korea",
            "label-lang-zh": "Cina",
            "label-meet-up-method-hotel_pickup": "Penjemputan hotel",
            "label-meet-up-method-location_meet_up": "Lokasi bertemu",
            "label-refundable-conditional_cancel": "Pembatalan bersyarat",
            "label-refundable-no_cancel": "Tidak ada pembatalan",
            "label-ticket-logistic-mobile": "Voucher seluler diterima",
            "label-ticket-logistic-printed": "Voucher cetak diterima",
            "label-ticket-logistic-printed_or_mobile": "Voucher cetak atau seluler diterima",
            "label-ticket-validity-fixed_date": "Tiket Tanggal Tetap",
            "label-ticket-validity-open_date": "Buka Tiket Tanggal",
            "label-ticket-validity-open_or_fixed_date": "Buka / Tetap Tiket Tanggal"
        },
        "pagination": {
            "next": "Selanjutnya & raquo;",
            "previous": "& laquo; Sebelumnya"
        },
        "city": {
            "abu-dhabi": "Abu Dhabi",
            "adelaide": "Adelaide",
            "agra": "Agra",
            "ahmedabad": "Ahmedabad",
            "alice-springs": "mata air alice",
            "alsace": "Alsace",
            "amritsar": "Amritsar",
            "amsterdam": "Amsterdam",
            "andalusia": "Andalusia",
            "antalya": "Antalya",
            "anuradhapura": "Anuradhapura",
            "athens": "Athena",
            "auckland": "Auckland",
            "bacolod": "Bacolod",
            "bagan": "Bagan",
            "baku": "Baku",
            "bali": "Bali",
            "bandung": "Bandung",
            "bangalore": "Bangalore",
            "bangkok": "Bangkok",
            "barcelona": "Barcelona",
            "batam": "Batam",
            "bath": "Mandi",
            "bay-of-islands": "Teluk Kepulauan",
            "beijing": "Beijing",
            "belfast": "Belfast",
            "bentota": "Bentota",
            "berlin": "Berlin",
            "bohol": "Bohol",
            "boracay": "Boracay",
            "bordeaux": "Bordeaux",
            "boston": "Boston",
            "bratislava": "Bratislava",
            "brisbane": "Brisbane",
            "bruges": "Bruges",
            "brussels": "Brussel",
            "budapest": "Budapest",
            "burgundy": "Burgundy",
            "busan": "Busan",
            "cairns": "Cairns",
            "cambridge": "Cambridge",
            "cameron-highlands": "Tanah Tinggi Cameron",
            "canary-islands": "Pulau Canary",
            "cape-town": "Cape Town",
            "cappadocia": "Kapadokia",
            "cebu": "Cebu",
            "champagne": "sampanye",
            "chengdu": "Chengdu",
            "chennai": "Chennai",
            "chiang-mai": "Chiang Mai",
            "chiang-rai": "Chiang Rai",
            "chiayi": "Chiayi",
            "chicago": "Chicago",
            "chongqing": "Chongqing",
            "christchurch": "Christchurch",
            "cochin": "Cochin",
            "cologne": "Cologne",
            "colombo": "Kolombo",
            "copenhagen": "Kopenhagen",
            "costa-del-sol": "Costa del Sol",
            "crete": "Kreta",
            "da-lat": "Da Lat",
            "da-nang": "Da Nang",
            "darwin": "Darwin",
            "davao": "Davao",
            "delhi": "Delhi",
            "dhaka": "Dhaka",
            "dresden": "Dresden",
            "dubai": "Dubai",
            "dublin": "Dublin",
            "dubrovnik": "Dubrovnik",
            "dumaguete": "Dumaguete",
            "dunedin": "Dunedin",
            "düsseldorf": "Düsseldorf",
            "edinburgh": "Edinburgh",
            "finnish-lapland": "",
            "florence": "Florence",
            "frankfurt": "Frankfurt",
            "fraser-island": "Pulau Fraser",
            "french-riviera": "Riviera Perancis",
            "fukuoka": "Fukuoka",
            "galle": "Galle",
            "galway": "Galway",
            "gangtok": "Gangtok",
            "gangwon-do": "Gangwon-do",
            "gdansk": "Gdansk",
            "geneva": "Jenewa",
            "genting-highlands": "Dataran Tinggi Genting",
            "geraldton": "Geraldton",
            "glasgow": "Glasgow",
            "goa": "Goa",
            "gold-coast": "Gold Coast",
            "gothenburg": "Göteborg",
            "guam": "Guam",
            "guangdong": "Guangdong",
            "guilin": "Guilin",
            "guizhou": "Guizhou",
            "gyeonggi-do": "Gyeonggi-do",
            "haikou": "Haikou",
            "hakone": "Hakone",
            "halong": "Halong",
            "hamburg": "Hamburg",
            "hangzhou": "Hangzhou",
            "hanoi": "Hanoi",
            "harbin": "Harbin",
            "hat-yai": "Hat Yai",
            "hawaii": "Hawaii",
            "heidelberg": "Heidelberg",
            "helsinki": "Helsinki",
            "himachal-pradesh": "Himachal Pradesh",
            "hiroshima": "Hiroshima",
            "ho-chi-minh-city": "Kota Ho Chi Minh",
            "hobart": "Hobart",
            "hoi-an": "Hoi An",
            "hokkaido": "Hokkaido",
            "hong-kong": "Hongkong",
            "hua-hin": "Hua Hin",
            "hualien": "Hualien",
            "hue": "Warna",
            "hyderabad": "Hyderabad",
            "iloilo": "Iloilo",
            "incheon": "Incheon",
            "inle-lake": "Danau Inle",
            "inner-mongolia": "Mongolia Dalam",
            "innsbruck": "Innsbruck",
            "interlaken": "Interlaken",
            "inverness": "Inverness",
            "ipoh": "Ipoh",
            "istanbul": "Istanbul",
            "jaipur": "Jaipur",
            "jaisalmer": "Jaisalmer",
            "jakarta": "Jakarta",
            "jeju": "Jeju",
            "jerusalem": "Yerusalem",
            "jodhpur": "Jodhpur",
            "johor-bahru": "Johor Baru",
            "kandy": "Kandy",
            "kaohsiung": "Kaohsiung",
            "kathmandu": "Kathmandu",
            "kazan": "Kazan",
            "kenting": "Kenting",
            "kiev": "Kiev",
            "kinmen": "Kinmen",
            "kobe": "Kobe",
            "koh-chang": "Koh Chang",
            "koh-samui": "Koh Samui",
            "krabi": "Krabi",
            "krakow": "Krakow",
            "kuala-lumpur": "Kuala Lumpur",
            "kumamoto": "Kumamoto",
            "kyoto": "Kyoto",
            "kyushu": "Kyushu",
            "lake-district": "Distrik Danau",
            "langkawi": "Langkawi",
            "lapland": "Lapland",
            "las-vegas": "Las Vegas",
            "launceston": "Launceston",
            "lausanne": "Lausanne",
            "leipzig": "Leipzig",
            "lisbon": "Lisbon",
            "liverpool": "Liverpool",
            "ljubljana": "Ljubljana",
            "loire-valley": "Lembah Loire",
            "lombok": "Lombok",
            "london": "London",
            "los-angeles": "Los Angeles",
            "luang-prabang": "Luang Prabang",
            "lucerne": "Lucerne",
            "lviv": "Lviv",
            "lyon": "Lyon",
            "macao": "Macau",
            "macau": "",
            "madrid": "Madrid",
            "malaga": "Malaga",
            "manchester": "Manchester",
            "mandalay": "Mandalay",
            "manila": "Manila",
            "marrakech": "Marrakech",
            "mauritius": "Mauritius",
            "medan": "Medan",
            "melaka": "Melaka",
            "melbourne": "Melbourne",
            "miami": "Miami",
            "milford-sound": "Milford Sound",
            "montreux": "Montreux",
            "moscow": "Moskow",
            "mumbai": "Mumbai",
            "munich": "Munich",
            "muscat": "Muscat",
            "nagano": "Nagano",
            "nagoya": "Nagoya",
            "naples": "Napoli",
            "nelson": "Nelson",
            "new-delhi": "New Delhi",
            "new-york": "New York",
            "nha-trang": "Nha Trang",
            "niagara-falls": "air terjun Niagara",
            "niigata": "Niigata",
            "normandy": "Normandia",
            "odessa": "Odessa",
            "okayama": "Okayama",
            "okinawa": "Okinawa",
            "orlando": "Orlando",
            "osaka": "Osaka",
            "oslo": "Oslo",
            "oxford": "Oxford",
            "palawan": "Palawan",
            "paris": "Paris",
            "pattaya": "Pattaya",
            "penang": "Penang",
            "penghu": "Penghu",
            "perth": "Perth",
            "philadelphia": "Philadelphia",
            "phnom-penh": "Phnom Penh",
            "phu-quoc": "Phu Quoc",
            "phuket": "Phuket",
            "pisa": "Pisa",
            "pokhara": "Pokhara",
            "port-lincoln": "Port Lincoln",
            "porto": "",
            "porto-district": "Distrik Porto",
            "prague": "Praha",
            "provence": "Provence",
            "puglia": "Puglia",
            "pune": "Pune",
            "pushkar": "Pushkar",
            "queenstown": "Queenstown",
            "ras-al-khaimah": "Ras Al Khaimah",
            "reykjavik": "Reykjavik",
            "rhodes": "Rhodes",
            "rhône-alpes": "Rhône-Alpes",
            "rome": "Roma",
            "rotorua": "Rotorua",
            "rotterdam": "Rotterdam",
            "sabah": "Sabah",
            "saint-petersburg": "Saint Petersburg",
            "saipan": "Saipan",
            "salzburg": "Salzburg",
            "san-diego": "San Diego",
            "san-francisco": "San Fransisco",
            "santorini": "Santorini",
            "sanya": "Sanya",
            "sapa": "Sapa",
            "sarawak": "Sarawak",
            "seattle": "Seattle",
            "seoul": "Seoul",
            "seville": "Seville",
            "shanghai": "Shanghai",
            "sibiu": "Sibiu",
            "sicily": "Sisilia",
            "siem-reap": "Siem Reap",
            "sihanoukville": "Sihanoukville",
            "singapore": "Singapura",
            "split": "Membagi",
            "surabaya": "Surabaya",
            "suzhou": "Suzhou",
            "swedish-lapland": "Laplandia Swedia",
            "sydney": "Sydney",
            "taichung": "Taichung",
            "tainan": "Tainan",
            "taipei": "Taipei",
            "taitung": "Taitung",
            "tarragona": "Tarragona",
            "taupo": "Taupo",
            "terengganu": "Terengganu",
            "thessaloniki": "Thessaloniki",
            "tokyo": "Tokyo",
            "toledo": "Toledo",
            "trincomalee": "Trincomalee",
            "turin": "Turin",
            "udaipur": "Udaipur",
            "uluru": "Uluru",
            "uttarakhand": "Uttarakhand",
            "varanasi": "Varanasi",
            "venice": "Venesia",
            "verona": "Verona",
            "vienna": "Wina",
            "vientiane": "Vientiane",
            "volendam": "Volendam",
            "washington-dc": "Washington DC",
            "wellington": "Wellington",
            "whitsundays": "Whitsundays",
            "xiamen": "Xiamen",
            "xian": "Xian",
            "yangon": "Yangon",
            "yilan": "Yilan",
            "yogyakarta": "Yogyakarta",
            "york": "York",
            "yunnan": "Yunnan",
            "zagreb": "Zagreb",
            "zhangjiajie": "Zhangjiajie",
            "zurich": "Zurich"
        },
        "validation": {
            "accepted": "Atribut: harus diterima.",
            "active_url": "Atribut: bukan URL yang valid.",
            "after": "Atribut: harus berupa tanggal setelah: tanggal.",
            "after_or_equal": "Atribut: harus berupa tanggal setelah atau sama dengan: tanggal.",
            "alpha": "Atribut: hanya dapat berisi huruf.",
            "alpha_dash": "Atribut: hanya dapat berisi huruf, angka, dan tanda hubung.",
            "alpha_num": "Atribut: hanya dapat berisi huruf dan angka.",
            "array": "Atribut: harus berupa array.",
            "before": "Atribut: harus tanggal sebelum: tanggal.",
            "before_or_equal": "Atribut: harus berupa tanggal sebelum atau sama dengan: tanggal.",
            "between": {
                "array": "Atribut: harus memiliki antara: min dan: item maks.",
                "file": "Atribut: harus antara: min dan: maks kilobyte.",
                "numeric": "Atribut: harus antara: min dan: maks.",
                "string": "Atribut: harus antara: min dan: karakter maks."
            },
            "boolean": "Bidang: atribut harus benar atau salah.",
            "confirmed": "Konfirmasi atribut: tidak cocok.",
            "custom": {
                "attribute-name": {
                    "rule-name": "pesan khusus"
                }
            },
            "date": "Atribut: bukan tanggal yang valid.",
            "date_format": "Atribut: tidak cocok dengan format: format.",
            "different": "Atribut: dan: lainnya harus berbeda.",
            "digits": "Atribut: harus: digit digit.",
            "digits_between": "Atribut: harus antara: min dan: digit maksimum.",
            "dimensions": "Atribut: memiliki dimensi gambar tidak valid.",
            "distinct": "Bidang: atribut memiliki nilai duplikat.",
            "email": "Atribut: harus berupa alamat email yang valid.",
            "exists": "Atribut yang dipilih: tidak valid.",
            "file": "Atribut: harus berupa file.",
            "filled": "",
            "image": "",
            "in": "Atribut yang dipilih: tidak valid.",
            "in_array": "",
            "integer": "",
            "ip": "",
            "ipv4": "",
            "ipv6": "",
            "json": "",
            "max": {
                "array": "",
                "file": "",
                "numeric": "",
                "string": ""
            },
            "mimes": "",
            "mimetypes": "",
            "min": {
                "array": "",
                "file": "",
                "numeric": "",
                "string": ""
            },
            "not_in": "Atribut yang dipilih: tidak valid.",
            "numeric": "",
            "present": "",
            "regex": "",
            "required": "",
            "required_if": "",
            "required_unless": "",
            "required_with": "",
            "required_with_all": "",
            "required_without": "",
            "required_without_all": "",
            "same": "",
            "size": {
                "array": "",
                "file": "",
                "numeric": "",
                "string": ""
            },
            "string": "",
            "timezone": "",
            "unique": "",
            "uploaded": "",
            "url": ""
        },
        "reset-password": {
            "confirm-new-password": "Konfirmasi password baru",
            "enter-new-password": "Masukan kata sandi baru",
            "please-enter-a-new-password": "Silakan masukkan kata sandi baru untuk akun Anda: email.",
            "submit": "Menyerahkan",
            "success-content": "Berhasil! Silakan masuk ke aplikasi seluler HyperAir dengan kata sandi baru.",
            "title": "Setel Ulang Kata Sandi",
            "validation-display": "Kata sandi harus mengandung setidaknya 6 karakter."
        },
        "notification": {
            "activation-e-minus-content": "15 hari mundur! Kupon selamat datang SIM Perjalanan Anda akan segera kedaluwarsa! Jangan lewatkan kesempatan untuk menggunakan kupon untuk perjalanan Anda yang akan datang!",
            "activation-e-minus-title": "",
            "activation-t-plus-content": "Ingatlah untuk menggunakan kupon kartu SIM kami untuk perjalanan Anda yang akan datang! Perjalanan Lebih Cerdas. Di mana saja.",
            "activation-t-plus-title": "",
            "ask-shop-to-quote-content": "Permintaan kutipan untuk membeli: jumlah: mata uang",
            "ask-shop-to-quote-content2": "Permintaan penawaran untuk penjualan: jumlah: mata uang",
            "ask-shop-to-quote-title": "Permintaan Baru untuk Kutipan",
            "email-booking-details": "Detail Pemesanan",
            "email-booking-id": "ID Pemesanan",
            "email-exchange-approved-content": "Pesanan yang dipertukarkan disetujui untuk membeli: jumlah: mata uang dengan kurs: kurs",
            "email-exchange-approved-footer": "Terima kasih telah menggunakan HyperAir.",
            "email-exchange-approved-title": "Shop menjawab, \"Uang perjalanan Anda siap untuk diambil!\"",
            "email-exchange-completed-content": "Pesanan yang ditukar selesai untuk pembelian: jumlah: mata uang dengan kurs: kurs",
            "email-exchange-completed-footer": "Terima kasih telah menggunakan HyperAir.",
            "email-exchange-completed-title": "Penukaran uang perjalanan Anda selesai!",
            "email-exchange-confirmed-content": "Pesanan yang dipertukarkan dikonfirmasikan untuk pembelian: jumlah: mata uang pada kurs: kurs",
            "email-exchange-confirmed-footer": "Terima kasih telah menggunakan HyperAir.",
            "email-exchange-confirmed-title": "Uang perjalanan Anda siap untuk diambil!",
            "email-footer-copy-right": "Seluruh hak cipta.",
            "email-greetings": "Halo!",
            "email-i-got": "saya mendapatkan",
            "email-i-paid": "aku telah bayar",
            "email-i-will-get": "saya akan mendapatkan",
            "email-i-will-pay": "saya akan membayar",
            "email-pickup-before": "Penjemputan sebelumnya",
            "email-product-confirmed-greeting": "Pelanggan yang terhormat,<br><br>Terima kasih telah menggunakan HyperAir. Voucher Anda sudah siap.",
            "email-product-confirmed-subject": "Pesanan telah dikonfirmasi",
            "email-product-confirmed-title": "Pesanan Anda Dikonfirmasi",
            "email-product-purchased": {
                "shipping": {
                    "international": "Pengiriman internasional",
                    "sf": "SF Express (Hong Kong Only)"
                }
            },
            "email-product-purchased-delievery-address": "Alamat pengiriman",
            "email-product-purchased-delivery-info": "Info pengiriman",
            "email-product-purchased-delivery-method": "Metode Pengiriman",
            "email-product-purchased-discount": "Diskon",
            "email-product-purchased-email": "E-mail",
            "email-product-purchased-greeting": "Pelanggan yang kami hormati,<br><br> Pilihan bagus. Diperlukan waktu untuk mengonfirmasi pemesanan. Tapi jangan khawatir, sebagian besar waktu kami dapat mengkonfirmasi pesanan dalam waktu 12 jam. Terima kasih telah menggunakan HyperAir!",
            "email-product-purchased-have-a-nice-trip": "Semoga perjalananmu menyenangkan!",
            "email-product-purchased-important-notice": "Syarat & Ketentuan berlaku.",
            "email-product-purchased-important-notice-content": "Syarat & Ketentuan berlaku.",
            "email-product-purchased-name": "Nama",
            "email-product-purchased-order-date": "Tanggal pemesanan",
            "email-product-purchased-order-details": "Detail pesanan",
            "email-product-purchased-order-no": "Jumlah order",
            "email-product-purchased-personal-info": "Informasi pribadi",
            "email-product-purchased-receipient-name": "Nama penerima",
            "email-product-purchased-receipient-phone-no": "No Telepon.",
            "email-product-purchased-shipping-fee": "Biaya pengiriman",
            "email-product-purchased-sub-total": "Sub-total",
            "email-product-purchased-subject": "Pesanan sedang menunggu konfirmasi",
            "email-product-purchased-title": "Pesanan Anda Ditangguhkan",
            "email-product-purchased-total": "Total",
            "email-product-simcapurchased-personal-info": "Informasi pribadi",
            "email-product-simcard-delivery-title": "SIM pesanan Anda: order-num telah disiapkan dan dikirimkan pada: tanggal. Jika Anda memilih SF Express, kami akan memberikan nomor pelacakan nanti. Anda juga dapat memeriksanya di aplikasi seluler kami.",
            "email-product-simcard-delivery-title-carbon-format": "j M Y",
            "email-product-simcard-delivery-update-greeting": "Pelanggan yang terhormat,<br><br>Terima kasih telah menggunakan HyperAir. Pesanan kartu SIM Anda sedang dalam perjalanan.",
            "email-product-simcard-delivery-update-title": "Pesanan Kartu SIM Anda sedang dalam perjalanan",
            "email-product-simcard-delivery-update-tracking": "Detail Pelacakan",
            "email-product-simcard-delivery-update-tracking-no": "Melacak nomor",
            "email-product-simcard-delivery-update-tracking-no-hkpost": "Melacak nomor: -",
            "email-product-simcard-delivery-update-tracking-no-sf": "Melacak nomor",
            "email-product-simcard-delivery-waiting-update-tracking-no-sf": "Sedang menunggu SF Express untuk memperbarui",
            "email-product-simcard-delivery-with-tracking-num-title": "SIM pesanan Anda: order-num akan dikirimkan oleh SF Express dengan nomor pelacakan:: tracking-num. Harap perhatikan telepon seluler Anda untuk penjemputan pengiriman. Anda juga dapat memeriksa status pengiriman di situs web SF Express. Terima kasih telah menggunakan layanan HyperAir.",
            "email-product-simcard-esim-code-greeting": "Pelanggan yang terhormat,<br><br>Terima kasih telah menggunakan HyperAir. Inilah aktivasi QR Code eSIM Anda.",
            "email-product-simcard-esim-code-important-notice-content": "<span style=\"font-size: 10px; line-height: 12px;\">Instruksi:<br />1. Masuk ke Pengaturan<br />2. Ketuk \"Data Seluler\"<br />3. Dalam Paket Data, ketuk \"Tambah Paket Data\"<br />4. Pindai kode QR di kamera frame<br />Jika Anda diminta untuk memasukkan kode konfirmasi untuk mengaktifkan eSIM, masukkan nomor yang disediakan operator. Punya pertanyaan? Silakan email ke hello@hyperair.com dan kami akan menghubungi Anda.</span>",
            "email-product-simcard-esim-code-title": "Inilah aktivasi QR Code eSIM Anda",
            "email-product-simcard-esim-code-warning": "Harap perhatikan bahwa eSIM akan diaktifkan setelah kode QR dipindai. Silakan memindai hanya ketika Anda ingin memulai layanan.",
            "email-product-simcard-purchased-delievery-address": "Alamat Pengiriman",
            "email-product-simcard-purchased-delivery-info": "Info Pengiriman",
            "email-product-simcard-purchased-delivery-method": "metode pengiriman",
            "email-product-simcard-purchased-discount": "Diskon",
            "email-product-simcard-purchased-greeting": "Pelanggan yang terhormat,<br><br>Terima kasih telah menggunakan HyperAir. Kami sekarang sedang mempersiapkan pengiriman SIM Perjalanan Anda.",
            "email-product-simcard-purchased-greeting-esim-only": "Pelanggan yang terhormat,<br><br>Terima kasih telah menggunakan HyperAir, eSIM Anda siap! Silakan temukan kode QR terlampir dan aktifkan sesuai dengan instruksi.",
            "email-product-simcard-purchased-greeting-esim-with-sim": "Pelanggan yang terhormat,<br><br>Terima kasih telah menggunakan HyperAir. Kami sekarang sedang mempersiapkan pengiriman SIM Perjalanan Anda. Untuk eSIM Anda, silakan temukan kode QR terlampir dan aktifkan sesuai dengan instruksi.",
            "email-product-simcard-purchased-greeting-sim-only": "Pelanggan yang terhormat,<br><br>Terima kasih telah menggunakan HyperAir. Kami sekarang sedang mempersiapkan pengiriman SIM Perjalanan Anda.",
            "email-product-simcard-purchased-have-a-nice-trip": "Semoga perjalananmu menyenangkan!",
            "email-product-simcard-purchased-important-notice": "Pemberitahuan Penting",
            "email-product-simcard-purchased-important-notice-content": "<span style=\"font-size: 10px; line-height: 12px;\">1. Melalui Surat Lokal Hong Kong Post, perkiraan pengiriman akan dalam 5 hari kerja. Pelacakan status tidak tersedia untuk surat lokal dan pelanggan harus bertanggung jawab penuh atas kehilangan barang dengan menggunakan Hong Kong </span><br> <span style=\"font-size: 10px; line-height: 12px;\">2. Silakan aktifkan kartu SIM Perjalanan sebelum kedaluwarsa.</span><br> <span style=\"font-size: 10px; line-height: 12px;\">3. Semua produk yang dikirim tunduk pada syarat dan ketentuan.</span><br><br> <span style=\"font-size: 10px; line-height: 12px;\">Ada pertanyaan? Silakan email ke hello@hyperair.com dan kami akan menghubungi Anda.</span>",
            "email-product-simcard-purchased-important-notice-content-esim-only": "<span style=\"font-size: 10px; line-height: 12px;\">1. Melalui Surat Lokal Hong Kong Post, perkiraan pengiriman akan dalam 5 hari kerja. Pelacakan status tidak tersedia untuk surat lokal dan pelanggan harus bertanggung jawab penuh atas kehilangan barang dengan menggunakan Hong Kong </span><br> <span style=\"font-size: 10px; line-height: 12px;\">2. Silakan aktifkan kartu SIM Perjalanan sebelum kedaluwarsa.</span><br> <span style=\"font-size: 10px; line-height: 12px;\">3. Semua produk yang dikirim tunduk pada syarat dan ketentuan.</span><br><br> <span style=\"font-size: 10px; line-height: 12px;\">Ada pertanyaan? Silakan email ke hello@hyperair.com dan kami akan menghubungi Anda.</span>",
            "email-product-simcard-purchased-important-notice-content-esim-with-sim": "<span style=\"font-size: 10px; line-height: 12px;\">1. Melalui Surat Lokal Hong Kong Post, perkiraan pengiriman akan dalam 5 hari kerja. Pelacakan status tidak tersedia untuk surat lokal dan pelanggan harus bertanggung jawab penuh atas kehilangan barang dengan menggunakan Hong Kong </span><br> <span style=\"font-size: 10px; line-height: 12px;\">2. Silakan aktifkan kartu SIM Perjalanan sebelum kedaluwarsa.</span><br> <span style=\"font-size: 10px; line-height: 12px;\">3. Semua produk yang dikirim tunduk pada syarat dan ketentuan.</span><br><br> <span style=\"font-size: 10px; line-height: 12px;\">Ada pertanyaan? Silakan email ke hello@hyperair.com dan kami akan menghubungi Anda.</span>",
            "email-product-simcard-purchased-important-notice-content-sim-only": "<span style=\"font-size: 10px; line-height: 12px;\">1. Melalui Surat Lokal Hong Kong Post, perkiraan pengiriman akan dalam 5 hari kerja. Pelacakan status tidak tersedia untuk surat lokal dan pelanggan harus bertanggung jawab penuh atas kehilangan barang dengan menggunakan Hong Kong </span><br> <span style=\"font-size: 10px; line-height: 12px;\">2. Silakan aktifkan kartu SIM Perjalanan sebelum kedaluwarsa.</span><br> <span style=\"font-size: 10px; line-height: 12px;\">3. Semua produk yang dikirim tunduk pada syarat dan ketentuan.</span><br><br> <span style=\"font-size: 10px; line-height: 12px;\">Ada pertanyaan? Silakan email ke hello@hyperair.com dan kami akan menghubungi Anda.</span>",
            "email-product-simcard-purchased-order-date": "Tanggal pemesanan",
            "email-product-simcard-purchased-order-details": "Detail pesanan",
            "email-product-simcard-purchased-order-no": "Jumlah order",
            "email-product-simcard-purchased-personal-info": "Informasi pribadi",
            "email-product-simcard-purchased-receipient-name": "nama Penerima",
            "email-product-simcard-purchased-receipient-phone-no": "Nomor Telepon Penerima",
            "email-product-simcard-purchased-shipping-fee": "Biaya pengiriman",
            "email-product-simcard-purchased-sub-total": "Sub-total",
            "email-product-simcard-purchased-title": "Pesanan SIM Travel Anda telah dikonfirmasi.",
            "email-product-simcard-purchased-title-esim-only": "Pesanan eSIM Perjalanan Anda telah dikonfirmasi.",
            "email-product-simcard-purchased-title-esim-with-sim": "Pesanan SIM Travel Anda telah dikonfirmasi.",
            "email-product-simcard-purchased-title-sim-only": "Pesanan SIM Travel Anda telah dikonfirmasi.",
            "email-product-simcard-purchased-total": "Total",
            "email-product-simcard-tracking-number-updated-greeting": "Pelanggan yang terhormat,<br><br>Sekali lagi terima kasih telah menggunakan HyperAir. Nomor pelacakan Anda diperbarui.",
            "email-product-simcard-tracking-number-updated-title": "Status pelacakan pesanan Anda diperbarui",
            "email-product-simcard-tracking-number-updated-tracking-no-sf": "Melacak nomor",
            "email-product-type-confirmed-greeting": "",
            "email-product-type-confirmed-title": "",
            "email-product-type-purchased-greeting": "",
            "email-product-type-purchased-title": "",
            "email-rate": "Menilai",
            "email-shop-name": "NAMA BELANJA",
            "email-verification-action": "Konfirmasikan Email Anda",
            "email-verification-content": "Selamat datang di HyperAir! Untuk menyelesaikan pendaftaran, Anda hanya perlu mengonfirmasi bahwa kami menerima email Anda dengan benar.",
            "email-verification-title": "Silahkan konfirmasi email Anda",
            "email-verified-content": "Email Anda sudah diverifikasi. Terima kasih telah bergabung dengan HyperAir.",
            "email-verified-title": "email terverifikasi",
            "engagement-content": "Gunakan selamat datang10",
            "engagement-title": "Gunakan selamat datang10",
            "exchange-approved-content": "Konfirmasi untuk membeli: jumlah: mata uang dengan kurs: kurs.",
            "exchange-approved-content2": "Konfirmasi untuk penjualan: jumlah: mata uang dengan kurs: kurs.",
            "exchange-approved-footer": "",
            "exchange-approved-title": "Shop menjawab, \"Uang perjalanan Anda siap untuk diambil!\"",
            "exchange-cancelled-content": "Seorang klien membatalkan pesanan untuk membeli: jumlah: mata uang dengan kurs: kurs.",
            "exchange-cancelled-content2": "Klien membatalkan pesanan penjualan: jumlah: mata uang dengan kurs: kurs.",
            "exchange-cancelled-title": "Exchange Order Dibatalkan",
            "exchange-completed-content": "Selesai untuk membeli: jumlah: mata uang dengan kurs: kurs.",
            "exchange-completed-content2": "Selesai untuk penjualan: jumlah: mata uang dengan kurs: kurs.",
            "exchange-completed-footer": "",
            "exchange-completed-title": "Penukaran uang perjalanan Anda selesai!",
            "exchange-confirmed-content": "Anda mengonfirmasi klien untuk membeli: jumlah: mata uang dengan kurs: kurs.",
            "exchange-confirmed-content2": "Anda mengonfirmasi klien untuk menjual: jumlah: mata uang dengan kurs: kurs.",
            "exchange-confirmed-footer": "",
            "exchange-confirmed-title": "Pesanan Exchange Baru Diterima",
            "exchange-pending-content": "Tinjau pesanan baru untuk membeli: jumlah: mata uang dengan kurs: kurs.",
            "exchange-pending-content2": "Pesanan tertunda untuk penjualan: jumlah: mata uang pada kurs: kurs.",
            "exchange-pending-title": "Persetujuan Pesanan Baru yang Tertunda",
            "exchange-rejected-content": "Pesanan tidak dapat diambil untuk membeli: jumlah: mata uang dengan kurs: kurs. Silakan pesan dengan toko lain lagi.",
            "exchange-rejected-content2": "Pesanan tidak dapat diambil untuk penjualan: jumlah: mata uang dengan kurs: kurs. Silakan pesan dengan toko lain lagi.",
            "exchange-rejected-title": "Ups! Maaf, toko tidak dapat menerima pesanan Anda.",
            "footer-trouble-link": "Jika Anda mengalami kesulitan mengklik tombol \": actionText\", salin dan tempel URL di bawah ini ke browser web Anda: <a href=\"{actionUrl}\">: actionUrl</a>",
            "password-reset-action": "Setel Ulang Kata Sandi",
            "password-reset-content": "Anda menerima email ini karena kami menerima permintaan pengaturan ulang kata sandi untuk akun Anda.",
            "password-reset-footer": "Jika Anda tidak meminta pengaturan ulang kata sandi, tidak ada tindakan lebih lanjut yang diperlukan.",
            "password-reset-title": "Reset Kata Sandi",
            "simcard-purchased-title": "",
            "sms-verification-content": "Kode HyperAir Anda adalah: verifikasi Kode"
        },
        "error": {
            "all-shops-are-closed": "Ups, semua toko tutup sekarang. Silakan coba lagi nanti.",
            "cancel-booking-failed": "Pesanan ini dapat diselesaikan, kedaluwarsa atau dibatalkan. Silakan periksa pesanan ini di [Pemesanan Saya> Selesai] atau [Pemesanan Saya> Tidak Selesai].",
            "cancel-booking-failed-title": "Tidak dapat membatalkan pesanan ini",
            "invalid-api-app-version": "Perbarui aplikasi sekarang untuk mendapatkan fungsi-fungsi baru dan nikmati diskon 5% untuk pemesanan SIM Travel dengan kode promo \"GIVEME5\" !!",
            "invalid-old-password": "Kata sandi yang ada tidak valid.",
            "password-incorrect": "Kata kunci Salah.",
            "phone-number-is-already-registered": "Nomor telepon ini sudah terdaftar dengan alamat email lain. Anda dapat masuk dengan alamat email yang benar. Silakan email ke hello@hyperair.com untuk dukungan apa pun.",
            "this-email-is-registered": "Alamat email ini sudah digunakan oleh akun lain.",
            "this-phone-number-is-registered": "Nomor telepon ini sudah terdaftar. Silakan email ke hello@hyperair.com untuk dukungan apa pun."
        },
        "marketplace": {
            "homepage-product": "Produk Populer",
            "homepage-recently-viewed": "baru saja dilihat",
            "product-carousels": {
                "group1": "Pengalaman Musim Panas",
                "group2": "Nilai Tertinggi"
            }
        }
    },
    "ja": {
        "currency": {
            "aed": "UAEディルハム",
            "afn": "アフガニ",
            "all": "アルバニアレク",
            "amd": "アルメニアドラム",
            "ang": "オランダアンティグルデン",
            "aoa": "クワンザ",
            "ars": "アルゼンチンペソ",
            "aud": "オーストラリアドル",
            "awg": "アルバ・フロリン",
            "azn": "アゼルバイジャンマナト",
            "bam": "ボスニア・ヘルツェゴビナマルカ",
            "bbd": "バルバドス・ドル",
            "bdt": "バングラデシュタカ",
            "bgn": "ブルガリアレフ",
            "bhd": "バーレーンディナール",
            "bif": "ブルンジフラン",
            "bnd": "ブルネイドル",
            "bob": "ボリビアボリビア",
            "brl": "ブラジルレアル",
            "bsd": "バハマドル",
            "btc": "ビットコイン",
            "btn": "ニュルタム",
            "bwp": "ボツワナプーラ",
            "byn": "新ベラルーシルーブル",
            "bzd": "ベリーズドル",
            "cad": "カナダドル",
            "cdf": "コンゴ・フラン",
            "chf": "スイスフラン",
            "clp": "チリペソ",
            "cop": "コロンビアペソ",
            "crc": "コスタリカコロン",
            "cup": "キューバペソ",
            "cve": "カーボベルデエスクード",
            "czk": "チェココルナ",
            "djf": "ジブチ・フラン",
            "dkk": "デンマーククローネ",
            "dop": "ドミニカペソ",
            "dzd": "アルジェリアディナール",
            "egp": "エジプトポンド",
            "ern": "エリトリアNakfa",
            "etb": "エチオピアブル",
            "eur": "ユーロ",
            "fjd": "フィジー・ドル",
            "fkp": "フォークランド諸島ポンド",
            "gbp": "英貨1ポンド",
            "gel": "グルジアラリ",
            "ghs": "ガーナセディ",
            "gip": "ジブラルタルポンド",
            "gmd": "ガンビアダラシ",
            "gnf": "ギニア・フラン",
            "gtq": "グアテマラケツァール",
            "gyd": "ガイアナ・ドル",
            "hkd": "香港ドル",
            "hnl": "ホンジュラスレンピラ",
            "hrk": "クロアチアクーナ",
            "htg": "ハイチグールド",
            "huf": "ハンガリーフォリント",
            "idr": "インドネシアルピア",
            "ils": "イスラエル新シェケル",
            "inr": "インドルピー",
            "iqd": "イラクディナール",
            "irr": "イランリアル",
            "isk": "アイスランドクローナ",
            "jmd": "ジャマイカドル",
            "jod": "ヨルダン・ディナール",
            "jpy": "日本円",
            "kes": "ケニアシリング",
            "kgs": "キルギス・ソム",
            "khr": "カンボジアリエル",
            "kmf": "コモロ・フラン",
            "kpw": "北朝鮮ウォン",
            "krw": "韓国ウォン",
            "kwd": "クウェートディナール",
            "kyd": "ケイマン諸島ドル",
            "kzt": "テンゲ",
            "lak": "ラオスキップ",
            "lbp": "レバノンリラ",
            "lkr": "スリランカ・ルピー",
            "lrd": "リベリアドル",
            "lsl": "レソトロティ",
            "lvl": "ラトビアラッツ",
            "lyd": "リビアディナール",
            "mad": "モロッコディルハム",
            "mdl": "モルドバレイ",
            "mga": "マダガスカル・アリアリ",
            "mkd": "マケドニアディナール",
            "mmk": "ミャンマーチャット",
            "mnt": "モンゴルのTugrik",
            "mop": "マカオ・パタカ",
            "mro": "ウギア",
            "mur": "モーリシャス・ルピー",
            "mvr": "ルフィヤ",
            "mwk": "マレーシアリンギット",
            "mxn": "メキシコペソ",
            "myr": "マレーシアリンギット",
            "mzn": "モザンビークメティカル",
            "nad": "ナミビア・ドル",
            "ngn": "ナイジェリアナイラ",
            "nio": "ニカラグアコルドバ",
            "nok": "ノルウェークローネ",
            "npr": "ネパールルピー",
            "nzd": "ニュージーランドドル",
            "omr": "オマーンリアル",
            "pab": "パナマバルボア",
            "pen": "ペルーヌエボ・ソル",
            "pgk": "キナ",
            "php": "フィリピンペソ",
            "pkr": "パキスタン・ルピー",
            "pln": "ズウォティ",
            "pyg": "グアラニー",
            "qar": "カタール・リヤル",
            "rmb": "人民元",
            "ron": "ルーマニアレイ",
            "rsd": "セルビアディナール",
            "rub": "ロシアルーブル",
            "rwf": "ルワンダ・フラン",
            "sar": "サウジリヤル",
            "sbd": "ソロモン諸島ドル",
            "scr": "セーシェル・ルピー",
            "sdg": "スーダンポンド",
            "sek": "スウェーデンクローナ",
            "sgd": "シンガポールドル",
            "shp": "セントヘレナ島ポンド",
            "sll": "シエラレオネレオーネ",
            "sos": "ソマリアシリング",
            "srd": "スリナムドル",
            "std": "サントメ・プリンシペドブラ",
            "syp": "シリアポンド",
            "szl": "リランゲニ",
            "thb": "タイバーツ",
            "tjs": "ソモニ",
            "tmt": "トルクメニスタンマナト",
            "tnd": "チュニジアディナール",
            "top": "Paanga",
            "try": "トルコ新リラ",
            "ttd": "トリニダードトバゴドル",
            "twd": "新台湾ドル",
            "tzs": "タンザニアシリング",
            "uah": "ウクライナグリブナ",
            "ugx": "ウガンダシリング",
            "usd": "米ドル",
            "uyu": "ウルグアイ・ペソ",
            "uzs": "ウズベキスタンソム",
            "vef": "ベネズエラボリバル",
            "vnd": "ベトナムドン",
            "vuv": "バヌアツバツ",
            "wst": "サモアタラ",
            "xaf": "中央アフリカCFAフラン",
            "xcd": "東カリブドル",
            "xdr": "特別引出権",
            "xof": "西アフリカCFAフラン",
            "xpf": "CFPフラン",
            "yer": "イエメン・リアル",
            "zar": "南アフリカランド",
            "zmw": "ザンビア・クワチャ"
        },
        "shop-currency-rate": {
            "rate-last-updated-x-days-ago": "レート更新{time}日前",
            "rate-last-updated-x-hours-ago": "レート更新{time}時間前"
        },
        "hyperair": {
            "copyright-footer": "Copyright©2018 HyperAir Incorporation Limited。全著作権所有。",
            "today": "今日"
        },
        "product-simcard": {
            "shipping-methods": {
                "hkpost": "Hong Kong Post（無料）",
                "international": "海外発送",
                "sf": "SF Express (Hong Kong only. Courier fee payable on delivery. Free Shipping for orders over HK$399)"
            }
        },
        "country": {
            "afghanistan": "アフガニスタン",
            "aland-islands": "オーランド諸島",
            "albania": "アルバニア",
            "algeria": "アルジェリア",
            "andorra": "アンドラ",
            "angola": "アンゴラ",
            "anguilla": "アンギラ",
            "antigua-&-barbuda": "アンティグアバーブーダ",
            "antigua-barbuda": "アンティグアバーブーダ",
            "argentina": "アルゼンチン",
            "armenia": "アルメニア",
            "aruba": "アルバ",
            "australia": "オーストラリア",
            "austria": "オーストリア",
            "azerbaijan": "アゼルバイジャン",
            "azores": "アゾレス",
            "bahamas": "バハマ",
            "bahrain": "バーレーン",
            "bangladesh": "バングラデシュ",
            "barbados": "バルバドス",
            "belarus": "ベラルーシ",
            "belgium": "ベルギー",
            "belize": "ベリーズ",
            "benin": "ベニン",
            "bermuda": "バミューダ",
            "bhutan": "ブータン",
            "bolivia": "ボリビア",
            "bonaire": "ボネール",
            "bosnia-herzegovina": "ボスニア・ヘルツェゴビナ",
            "botswana": "ボツワナ",
            "brazil": "ブラジル",
            "british-virgin-islands": "イギリス領ヴァージン諸島",
            "brunei": "ブルネイ",
            "bulgaria": "ブルガリア",
            "burkina-faso": "ブルキナファソ",
            "burundi": "ブルンジ",
            "cambodia": "カンボジア",
            "cameroon": "カメルーン",
            "canada": "カナダ",
            "canary-islands": "カナリア諸島",
            "cape-verde-islands": "カーボベルデ諸島",
            "cayman-islands": "ケイマン諸島",
            "central-african-republic": "中央アフリカ共和国",
            "chad": "チャド",
            "chile": "チリ",
            "china": "中国",
            "colombia": "コロンビア",
            "comoros": "コモロ",
            "congo": "コンゴ",
            "cook-islands": "クック諸島",
            "costa-rica": "コスタリカ",
            "cote-d-ivoire": "コートジボワール",
            "croatia": "クロアチア",
            "cruise-ship": "クルーズ船",
            "cuba": "キューバ",
            "curacao": "キュラソー",
            "cyprus": "キプロス",
            "cyprus---north": "キプロス",
            "cyprus---south": "キプロス",
            "czech-republic": "チェコ共和国",
            "denmark": "デンマーク",
            "djibouti": "ジブチ",
            "dominica": "ドミニカ国",
            "dominican-republic": "ドミニカ共和国",
            "dubai": "Dubai",
            "easter-island": "イースター島",
            "ecuador": "エクアドル",
            "egypt": "エジプト",
            "el-salvador": "エルサルバドル",
            "equatorial-guinea": "赤道ギニア",
            "eritrea": "エリトリア",
            "estonia": "エストニア",
            "ethiopia": "エチオピア",
            "europe": "Europe",
            "falkland-islands": "フォークランド諸島",
            "faroe-islands": "フェロー諸島",
            "fiji": "フィジー",
            "finland": "フィンランド",
            "france": "フランス",
            "french-guiana": "フランス領ギアナ",
            "french-polynesia": "フランス領ポリネシア",
            "french-west-indies": "フランス領西インド諸島",
            "gabon": "ガボン",
            "gambia": "ガンビア",
            "georgia": "ジョージア",
            "germany": "ドイツ",
            "ghana": "ガーナ",
            "gibraltar": "ジブラルタル",
            "greece": "ギリシャ",
            "greenland": "グリーンランド",
            "grenada": "グレナダ",
            "guadeloupe": "グアドループ",
            "guam": "グアム",
            "guatemala": "グアテマラ",
            "guernsey": "ガーンジー",
            "guinea": "ギニア",
            "guinea---bissau": "ギニアビサウ",
            "guinea-bissau": "ギニアビサウ",
            "guyana": "ガイアナ",
            "haiti": "ハイチ",
            "honduras": "ホンジュラス",
            "hong-kong": "香港",
            "hungary": "ハンガリー",
            "iceland": "アイスランド",
            "india": "インド",
            "indonesia": "インドネシア",
            "iran": "イラン",
            "iraq": "イラク",
            "ireland": "アイルランド",
            "isle-of-man": "マン島",
            "israel": "イスラエル",
            "italy": "イタリア",
            "jamaica": "ジャマイカ",
            "japan": "日本",
            "jersey": "ジャージー",
            "jordan": "ヨルダン",
            "kazakhstan": "カザフスタン",
            "kenya": "ケニア",
            "kiribati": "キリバス",
            "kosovo": "コソボ",
            "kuwait": "クウェート",
            "kyrgyz-republic": "キルギス共和国",
            "kyrgyzstan": "キルギスタン",
            "laos": "ラオス",
            "latvia": "ラトビア",
            "lebanon": "レバノン",
            "lesotho": "レソト",
            "liberia": "リベリア",
            "libya": "リビア",
            "liechtenstein": "リヒテンシュタイン",
            "lithuania": "リトアニア",
            "luxembourg": "ルクセンブルク",
            "macau": "マカオ",
            "macedonia": "マケドニア",
            "madagascar": "マダガスカル",
            "madeira": "マデイラ",
            "malawi": "マラウイ",
            "malaysia": "マレーシア",
            "maldives": "モルディブ",
            "mali": "マリ",
            "malta": "マルタ",
            "marshall-islands": "マーシャル諸島",
            "martinique": "マルティニーク",
            "mauritania": "モーリタニア",
            "mauritius": "モーリシャス",
            "mayotte": "マヨット",
            "mexico": "メキシコ",
            "micronesia": "ミクロネシア",
            "moldova": "モルドバ",
            "monaco": "モナコ",
            "mongolia": "モンゴル",
            "montenegro": "モンテネグロ",
            "montserrat": "モントセラト",
            "morocco": "モロッコ",
            "mozambique": "モザンビーク",
            "myanmar": "ミャンマー",
            "namibia": "ナミビア",
            "nauru": "ナウル",
            "nepal": "ネパール",
            "netherlands": "オランダ",
            "netherlands-antilles": "オランダ領アンティル",
            "new-caledonia": "ニューカレドニア",
            "new-zealand": "ニュージーランド",
            "nicaragua": "ニカラグア",
            "niger": "ニジェール",
            "nigeria": "ナイジェリア",
            "niue": "ニウエ",
            "norfolk-islands": "ノーフォーク諸島",
            "north-korea": "北朝鮮",
            "northern-marianas": "北マリアナ",
            "norway": "ノルウェー",
            "oman": "オマーン",
            "pakistan": "パキスタン",
            "palau": "パラオ",
            "palestine": "パレスチナ",
            "panama": "パナマ",
            "papua-new-guinea": "パプアニューギニア",
            "paraguay": "パラグアイ",
            "peru": "ペルー",
            "philippines": "フィリピン",
            "poland": "ポーランド",
            "portugal": "ポルトガル",
            "puerto-rico": "プエルトリコ",
            "qatar": "カタール",
            "reunion": "再会",
            "romania": "ルーマニア",
            "russia": "ロシア",
            "rwanda": "ルワンダ",
            "saint-barthelemy": "サンバルテレミー",
            "saint-martin": "セントマーティン",
            "saint-pierre-&-miquelon": "サンピエール＆ミクロン",
            "samoa": "サモア",
            "san-marino": "サンマリノ",
            "sao-tome-&-principe": "サントメプリンシペ",
            "sao-tome-principe": "サントメプリンシペ",
            "satellite": "衛星",
            "saudi-arabia": "サウジアラビア",
            "senegal": "セネガル",
            "serbia": "セルビア",
            "seychelles": "セイシェル",
            "sierra-leone": "シエラレオネ",
            "singapore": "シンガポール",
            "slovak-republic": "スロバキア共和国",
            "slovakia": "スロバキア",
            "slovenia": "スロベニア",
            "solomon-islands": "ソロモン諸島",
            "somalia": "ソマリア",
            "south-africa": "南アフリカ",
            "south-korea": "韓国",
            "spain": "スペイン",
            "sri-lanka": "スリランカ",
            "st-helena": "セントヘレナ",
            "st-kitts": "セントキッツ",
            "st-kitts-&-nevis": "セントクリストファー・ネイビス",
            "st-lucia": "セントルシア",
            "st-vincent": "セントビンセント",
            "st.-helena": "セントヘレナ",
            "st.-kitts": "セントキッツ",
            "st.-lucia": "セントルシア",
            "sudan": "スーダン",
            "suriname": "スリナム",
            "swaziland": "スワジランド",
            "sweden": "スウェーデン",
            "switzerland": "スイス",
            "syria": "シリア",
            "taiwan": "台湾",
            "tajikistan": "タジキスタン",
            "tanzania": "タンザニア",
            "thailand": "タイ",
            "timor-l'este": "東ティモール",
            "togo": "行く",
            "tonga": "トンガ",
            "trinidad-&-tobago": "トリニダード・トバゴ",
            "trinidad-tobago": "トリニダード・トバゴ",
            "tunisia": "チュニジア",
            "turkey": "七面鳥",
            "turkmenistan": "トルクメニスタン",
            "turks-&-caicos": "タークスカイコス諸島",
            "turks-&-caicos-islands": "タークスカイコス諸島",
            "turks-caicos-islands": "タークス諸島及びカイコス諸島",
            "uganda": "ウガンダ",
            "ukraine": "ウクライナ",
            "united-arab-emirates": "アラブ首長国連邦",
            "united-kingdom": "イギリス",
            "united-states": "アメリカ",
            "united-states-minor-outlying-islands": "アメリカ合衆国の小離島",
            "uruguay": "ウルグアイ",
            "uzbekistan": "ウズベキスタン",
            "vanuatu": "バヌアツ",
            "vatican-city": "バチカン市",
            "venezuela": "ベネズエラ",
            "vietnam": "ベトナム",
            "virgin-islands": "ヴァージン諸島",
            "virgin-islands-(us)": "バージン諸島（米国）",
            "wallis-&-futuna": "ウォリス・フツナ",
            "wallis-futuna": "ワリスとフツナ",
            "yemen": "イエメン",
            "zambia": "ザンビア",
            "zimbabwe": "ジンバブエ"
        },
        "inspiration": {
            "published-date": "僕の",
            "published-duration": ":期間前",
            "published-duration-singular": "昨日",
            "published-duration-today": "今日"
        },
        "promotion-center": {
            "expires-at": "",
            "redeem": {
                "error": {
                    "already-redeemed": "既にクーポンを利用しています。",
                    "new-customer-only": "オファーは新規顧客のみに有効です。",
                    "not-found": "無効なプロモーシ��ンコード"
                }
            }
        },
        "auth": {
            "failed": "これらの資格情報は私たちの記録と一致しません。",
            "throttle": "ログイン試行が多すぎます。 {seconds}秒後にもう一度お試しください。"
        },
        "web": {
            "activity": {
                "countdown-title": "",
                "more-button": "More tour and tickets",
                "section-subtitle": "Find the cheapest tour and tickets in Singapore",
                "section-title": "Tour and Tickets"
            },
            "checkout": {
                "use-promo-code": ""
            },
            "checkout-failed": {
                "checkout-failed": ""
            },
            "checkout-success": {
                "checkout-success": "支払いの成功",
                "continue-shopping-button": "ショッピングを続ける",
                "done-button": "完了👌🏻",
                "download-now": "ダウンロード中",
                "order-number": "注文番号",
                "register-email": "あなたのEメール",
                "register-password": "パスワードを設定する",
                "sim-product": "<span class=\"bold\"> {sim} </span>を正常に購入しました。確認メールが{email}に送信されました。",
                "slogan": "HyperAirアプリを開いて、限定旅行特典をお楽しみください！アプリでリアルタイムの注文追跡を行うこともできます！",
                "slogan-password": "もう一歩！アプリでHK $ 10ウェルカムSIMカードクーポンとリアルタイム注文追跡を楽しむことができます！",
                "trace-order": "",
                "trace-order-password": "",
                "welcome-offer": "もう一歩！アプリでHK $ 10ウェルカムSIMカードクーポンとリアルタイム注文追跡をお楽しみください！"
            },
            "country": {
                "all": "すべて",
                "contact-us-description": "如有任何疑問、歡迎發送電郵到<a href=\"mailto:corporate@hyperair.com\\>Corporate@hyperair.com</a>查詢",
                "data": "データ制限:",
                "day": "日々）:",
                "day-day": "日",
                "esim": "eSIM",
                "esim-section-title": "最適なeSIM{country}",
                "num-of-review": ":レビュー数の評価",
                "per-day": "日",
                "phone-call": "電話",
                "plug-n-go": "",
                "plug-n-go-esim": "インスタント購入と使用",
                "plug-n-go-sim": "プラグアンド使用",
                "section-title": "最高のSIMカード:国",
                "section-title copy": "最高のSIMカード:国",
                "sim": "SIM",
                "supplier": "プロバイダー:"
            },
            "download-app-banner": {
                "download-now": "今すぐアプリをダウンロード",
                "hyperair": "ハイパーエア",
                "subtitle": "HyperAirアプリをダウンロードして登録し、HK $ 10のウェルカムオファーをお楽しみください！",
                "title": "よりスマートに。どこでも。"
            },
            "email-subscription": {
                "cancel-button": "再諗一諗",
                "completed-subscribe": "Thank you for subscribing!",
                "confirm-button": "我要最抵優惠",
                "duplicate-email": "你的電郵已經訂閱了",
                "invalid-email": "Invalid email address",
                "title-1": "想Staycation價格跌至新低時通知你？",
                "title-2": "仲搜羅全城最抵既Staycation 及美食套餐優惠"
            },
            "fanfare": {
                "cover-title": "SIMカードのオファー",
                "datetime-format": "J M",
                "end-next-fanfare": "今後のSIMカードのオファー：",
                "end-title": "次のSIMのオファーのために我々のアプリ＆ソーシャルメディアにご期待ください",
                "end-title2": "私たちのAPP＆次回のSIMカードの提供のためのソーシャルメディアプラットフォームへのお楽しみ",
                "more-details-button": "詳細",
                "out-of-stock": "完売",
                "popular-countries-subtitle": "無料船便、スピーディ配信",
                "popular-countries-title": "人気のSIMカード",
                "section-title": "SIMカードのスーパー割引価格で",
                "title": "期間限定|限定カード",
                "x-inventory-left": "最後に：在庫枚{inventory}"
            },
            "fanfare-breadcrumb": "SIMカードのオファー",
            "filter-button": {
                "filter": "フィルタ"
            },
            "filter-container": {
                "apply": "",
                "category": "カテゴリー",
                "category-aquarium": "水族館",
                "category-class": "クラス",
                "category-day-tour": "日帰りツアー",
                "category-discount": "ディスカウント",
                "category-diving": "ダイビング",
                "category-food": "食物",
                "category-massage-beauty": "マッサージと美容",
                "category-museum": "博物館",
                "category-musical": "ミュージカル",
                "category-outlet": "出口",
                "category-photography": "写真術",
                "category-playground": "遊び場",
                "category-railway": "鉄道",
                "category-show": "公演",
                "category-ski": "スキー",
                "category-spa": "スパ",
                "category-theme-park": "テーマパーク",
                "category-ticket": "チケット",
                "category-transport": "輸送",
                "category-transport-ticket": "交通チケット",
                "category-vr": "VR",
                "category-water-park": "親水公園",
                "category-yoga": "ヨガ",
                "category-zoo": "動物園",
                "clear-all": "リセット",
                "facilities": "Services & facilities",
                "filter": "フィルタ",
                "food": "Food",
                "header": "フィルタ",
                "popular-search": "Popular Search🔥",
                "price": "価格",
                "provider": "トラベルサイト",
                "subcategory-buffet": "ビュッフェ",
                "subcategory-car": "車",
                "subcategory-facial": "フェイシャル",
                "subcategory-food": "食物",
                "subcategory-half-day-tour": "半日ツアー",
                "subcategory-massage": "マッサージ",
                "subcategory-meal-voucher": "食事クーポン",
                "subcategory-one-day-tour": "一日ツアー",
                "subcategory-restaurant": "レストラン",
                "subcategory-transport": "交通手段",
                "tag": "Tag"
            },
            "footer": {
                "about-hyperair-description": "HyperAirは、お客様の好みに合わせたインテリジェントな旅行プラットフォームであり、最も適切で価値のある旅行ソリューションを提供するため、よりスマートにどこへでも旅行できます。",
                "download-now": "ダウンロード中",
                "email-subscription-button": "Subscribe",
                "email-subscription-placeholder": "Enter your email",
                "email-subscription-social-title": "or Follow our Facebook and Instagram",
                "email-subscription-title": "Subscribe to get the latest staycation discount",
                "travel-license": "Travel Agent Licence Number："
            },
            "fx-booking": {
                "back-button": "",
                "confirm-booking": "",
                "confirm-button": "",
                "contact-shop": "",
                "get-money-before": ""
            },
            "home": {
                "cover-button": "今すぐ体験",
                "cover-subtitle": "HyperAirの新しい世界を開いてください",
                "cover-title": "よりスマートに。どこでも。",
                "grid": {
                    "1": {
                        "subtitle": "最新のインスピレーション",
                        "title": "トルコ教会の猫の住人"
                    },
                    "2": {
                        "subtitle": "最新のインスピレーション",
                        "title": "2020年東京オリンピック"
                    },
                    "3": {
                        "subtitle": "ホットピック",
                        "title": "オンライン最安値保証"
                    },
                    "4": {
                        "subtitle": "Offre à durée limitée",
                        "title": "Carte SIM Fanfares"
                    },
                    "5": {
                        "subtitle": "人気の目的地",
                        "title": "ディズニーランドギャラクシーエッジのスニークピーク"
                    }
                },
                "home-example": {
                    "column-subtitle-1": "例として、日本への7日間の2人の旅行を取り上げます。",
                    "column-subtitle-2": "価格比較",
                    "column-title-1": "1回の旅行で節約を最大化",
                    "column-title-2": "11のオンライン旅行代理店を比較",
                    "hotel": "ホテル特典",
                    "hotel-package-1": "ホテル日航大阪x6泊",
                    "insurance": "旅行保険",
                    "insurance-package-1": "7日間の旅行保険x2",
                    "money": "旅行保険",
                    "money-package-1": "交換JPD¥410,000",
                    "save": "セーブ",
                    "sim": "トラベルSIM",
                    "sim-package-1": "日本7日間DoCoMo SIM x2",
                    "slogan": "予約する前に比較して、次の旅行の費用を節約しましょう！",
                    "total-saving": "合計節約額1,443",
                    "travel-experience": "旅行体験",
                    "travel-experience-package-1": "全日本x2のJRパス",
                    "travel-experience-package-2": "ユニバーサル・スタジオ・ジャパン™1-日Eチケット×2"
                },
                "media-header-title": "Press",
                "more": "トラベルSIM",
                "partners-title": "Partnership",
                "photo-banner-button": "もっと詳しく知る",
                "photo-banner-title": "旅行のお金をよりスマートに交換",
                "services-header-description": "",
                "services-header-title": "ワンストップ旅行サービス",
                "services-icon-subtitle-1": "旅費を賢く手に入れましょう！",
                "services-icon-subtitle-2": "最高のSIMカードを無料で提供します！",
                "services-icon-subtitle-3": "カスタマイズされたソリューションで世界を探索できます！",
                "services-icon-title-1": "トラベルマネー",
                "services-icon-title-2": "トラベルSIM",
                "services-icon-title-3": "旅行体験",
                "statistic": {
                    "num-of-city": "",
                    "num-of-comparison": "",
                    "num-of-experience": "",
                    "num-of-saving": ""
                },
                "testimonial-1-content": "很欣賞程式員佢地既用心製作、佢地都很積極用心為我解決使用時的困難。推薦使用！",
                "testimonial-1-subtitle": "Androidユーザー",
                "testimonial-1-user": "クリスティン・ラム",
                "testimonial-2-content": "網絡回収得幾好、上次去日本喺市區同近街玩都好流暢！下次會再買！",
                "testimonial-2-subtitle": "iOSユーザー",
                "testimonial-2-user": "天使",
                "testimonial-header-description": "",
                "testimonial-header-title": "お客様の声",
                "travel-activities": {
                    "home-slogan": "さまざまなウェブサイトから最高の旅行体験を比較して見つける"
                },
                "travel-country-header-description": "明確な分類、選びやすい",
                "travel-country-header-title": "Travel SIMは200か国をカバー",
                "travel-info-header-description": "真っ赤な旅行のインスピレーションをお届けします",
                "travel-info-header-title": "旅行のインスピレーション",
                "travel-marketplace-header-description": "",
                "travel-marketplace-header-title": "",
                "travel-sim-header-description": "送料無料でお得なSIMカード",
                "travel-sim-header-title": "人気のトラベルSIM"
            },
            "hotel": {
                "cover-subtitle": "5％の排他的Trip.comホテル予約プランをお楽しみください",
                "cover-title": "ホテル特典",
                "discount-detail": "5％のホテル予約プランを楽しむためにプロモーションコード「HYPERAIR5」を適用",
                "discount-title": "HYPERAIR5",
                "highlight-subtitle1": "ユニークな滞在のために、世界中のホテルを発見。",
                "highlight-subtitle2": "最高のお得な情報を入手し、次の旅行のためにあなたのお金を節約。",
                "highlight-subtitle3": "ホテル料金いつでもどこでもを確認してください。",
                "highlight-title1": "グローバルカバレッジ",
                "highlight-title2": "特典",
                "highlight-title3": "ワンクリック予約"
            },
            "hypermiles": {
                "activity": "Activity",
                "balance": "Outstanding Balance",
                "benefit": "Your Privileges",
                "cumulative-purchase": "Accumulated Spending：HK$ {amount}",
                "diamond-black": "Diamond Black",
                "expire": "Expired HyperMiles ({date})",
                "expire-reminder-1": "HyperMiles is valid for one year from the shopping month",
                "expire-reminder-2": "Remember to use HyperMiles before expiry!",
                "hypermiles-total": "HyperMiles",
                "member": "Member",
                "member-tier": "You have become HyperAir {member_tier} member",
                "membership-details": "Membership Tier",
                "next-purchase": "save HK${amount} in your next purchase",
                "order-num": "Order No: {order_num}",
                "permanent-membership": "Permanent Membership",
                "popup-title": "HyperMiles Reward Scheme",
                "precious-platinum": "Precious Platinum",
                "product_purchase": "HyperMiles from gadgets purchase ({date})",
                "record": "HyperMiles Record",
                "royal-blue": "Royal Blue",
                "simcard_purchase": "HyperMiles from SIM purchase ({date})",
                "tier": "",
                "title": "HyperMiles. Explore the World, Enjoy the rebate!",
                "u-have": "Your have",
                "usage": "Redeemed HyperMiles",
                "what-is-hypermiles": "What is HyperMiles",
                "what-is-hypermiles-slogan1": "Spend more. Earn more!",
                "what-is-hypermiles-slogan2": "Every 100 HyperMiles can be used as HK$1 at checkout, no minimum spending limit",
                "what-is-hypermiles-slogan3": "Spend more at HyperAir to enjoy more privileges"
            },
            "hypermiles-disclaimer": "terms and conditions apply",
            "hypermiles-discount-diamond-black": "Spend every HK$1 to enjoy 1 HyperMiles",
            "hypermiles-discount-precious-platinum": "Spend every HK$1.5 to enjoy 1 HyperMiles",
            "hypermiles-discount-royal-blue": "Spend every HK$2 to enjoy 1 HyperMiles",
            "hypermiles-special-diamond-black": "Exclusive pre-sale offer",
            "hypermiles-spend-diamond-black": "Cumulative spending of HK$3,000",
            "hypermiles-spend-precious-platinum": "Cumulative spending of HK$1,500",
            "hypermiles-spend-royal-blue": "Basic Member",
            "login": {
                "email": "",
                "existing-user": "",
                "forgot-password": "",
                "forgot-password-please-fill-in-email": "",
                "login": "",
                "login-with-facebook": "",
                "login-with-google": "",
                "new-user": "",
                "or": "",
                "password": "",
                "phone-input-placeholder": "",
                "phone-input-title": "",
                "phone-verify": "",
                "resend-verification-code": "",
                "reset-password": "",
                "title": "",
                "verification-code-input-title": ""
            },
            "logo-loader": {
                "slogan": "We're almost there"
            },
            "my-order": {
                "amount": "",
                "esim-qrcode": "",
                "fx-status-cancelled": "",
                "fx-status-confirmed": "",
                "order-date": "",
                "order-details": "",
                "order-num": "",
                "status-confirmed": "",
                "status-pending-confirmation": "",
                "status-ready-to-ship": "",
                "status-shipped": ""
            },
            "my-order-details": {
                "delivery-info": "",
                "discount": "",
                "recipient-address": "",
                "recipient-email": "",
                "recipient-name": "",
                "recipient-tel": "",
                "shipping-method": "",
                "status": "",
                "total": "",
                "valid-date": ""
            },
            "nav": {
                "about-us": "私たちに関しては",
                "car": "",
                "company": "会社",
                "company-address": "Entrepreneurship Centre, Level 3, Cyberport 3, Hong Kong",
                "contact-us": "お問い合わせ",
                "contact-us-description": "お問い合わせは、 <a href=\"mailto:hello@hyperair.com\">hello@hyperair.com</a> にメールしてください。",
                "disclaimer": "Disclaimer",
                "download-app": "アプリをダウンロードする",
                "flight": "",
                "foodie": "Foodie",
                "home": "Home",
                "hotel": "ホテル",
                "jobs": "募集",
                "logout": "ログアウト",
                "media-coverage": "Press",
                "monthly-rental-hotel": "Monthly Rental Hotel",
                "privacy-policy": "個人情報保護方針",
                "promo-banner-text": "HyperAir 客戶專享 5% Trip.com 獨家酒店折扣",
                "quarantine-hotel": "Long Stay Hotel",
                "refund-policy": "返金について",
                "spa-and-beauty": "Spa and Beauty",
                "staycation": "Staycation",
                "tag-line": "Compare Travel Sites & Save Money",
                "terms-of-service": "利用規約",
                "travel-activity": "",
                "travel-affiliate-codes": "クーポン",
                "travel-affiliate-codes-md": "クーポン",
                "travel-blog": "Blog",
                "travel-experience-d": "旅行ツアーと体験",
                "travel-experience-md": "旅行ツアーと体験",
                "travel-insurance": "旅行保険",
                "travel-insurance-md": "旅行保険",
                "travel-marketplace": "トラベルガジェット",
                "travel-marketplace-md": "トラベルガジェット",
                "travel-money": "トラベルマネー",
                "travel-money-md": "トラベルマネー",
                "travel-sim": "トラベルSIM",
                "travel-sim-md": "トラベルSIM"
            },
            "photo-banner": {
                "banner-button": ""
            },
            "product-card": {
                "num-of-review": "{num}-of-review ratings"
            },
            "redirection-gate": {
                "columns-1-description": "さまざまなウェブサイトから最高の旅の経験を比較",
                "columns-1-title": "旅行の活動の比較",
                "columns-2-description": "送料無料で最高のSIMカードのお得な情報！",
                "columns-2-title": "旅行SIM",
                "columns-3-description": "町で最高のFX率を比較して、予約",
                "columns-3-title": "トラベルマネー",
                "promo-code": "コード",
                "remember-to-fill-promo-code": "チェックアウトの前に上記のプロモーションコードを適用することを忘れないでください",
                "title": "We are taking you to {domain}",
                "trouble-link": "If the browser does not redirect you in 10 seconds, please click this <a href=\"{link}\">link</a>."
            },
            "register": {
                "guest-checkout": "",
                "title": ""
            },
            "seo": {
                "best-price-guarantee-title": "Best Price Guarantee",
                "country-description": "{country} Travel SIM-送料無料のベストプライス保証",
                "country-keywords": "SIM卡、上網卡、電話卡、數據卡、DataSIM、旅遊DataSIM、數據咭、4G上網卡、上網卡、4G上網卡、日本4G上網卡、日本上網卡、東京4G上網卡、東京上網卡、大阪4G上網卡、大阪上網卡、泰國4G上網卡、泰國上網卡、曼谷4G上網卡、布吉上網卡、芭提雅4G上網卡、台灣4G上網卡、台灣上網卡、台北4G上網卡、高雄上網卡、台中4G上網卡、台中上網卡、韓國4G上網卡、韓國上網卡、首爾4G上網卡、首爾上網卡、中國4G上網卡、中國上網卡、深圳4G上網卡、深圳上網卡、澳門4G上網卡、澳門上網卡、ドコモ、ソフトバンク",
                "country-title": "{country} Travel SIM-送料無料のベストプライス保証",
                "home-description": "HyperAirは、お客様の好みに合わせたインテリジェントな旅行プラットフォームであり、最も適切で価値のある旅行ソリューションを提供するため、よりスマートにどこへでも旅行できます。",
                "home-keywords": "sim卡、上網卡、電話卡、數據卡、DataSIM、旅遊DataSIM、數據咭、4G上網卡、上網卡、4G上網卡、SIM卡、Travel SIM、旅遊SIM卡、唱錢神器、唱X神器、唱錢X器、唱錢、唱錢アプリ、兌換、找換、兌換店、找換店、銀行、金融、外匯、外滙、匯率、滙率、匯款、外貨、貨幣、旅行、旅遊、行程、ホテル、機票、比較、格價、特價、預訂、交易、旅遊保險、日本、泰國、韓國、台灣、日圓、日元、台通貨、泰銖、HyperAir、HyperAir FX、HyperAir Travel、Travel、Travel Money、Foreign Currency、Foreign Exchange、百年、堅成、發達鳥、飛鳥、richbird、crazy bird、ベルリン交換",
                "home-title": "HyperAir-よりスマートに。どこでも。 |最高の旅行SIM、FX、旅行保険、現地体験",
                "hotel-description": "HyperAir.comを経由して、余分なホテル予約のオファーをゲット",
                "hotel-keywords": "ホテル、ホテル、割引、予約、アジア、ヨーロッパ、アメリカ、バンコク、シンガポール、香港、プーケット、タイ、マレーシア、バリ、ロンドン、パリ、ロイヤルティプログラム、acommodation、宿泊施設、acomodation、宿泊施設、バケーションレンタル",
                "hotel-title": "ホテルのキャンペーン",
                "money-exchange-description": "Check {shop_name}'s latest FX rate and book your travel money online. You can lock in FX rate and reserve foreign currency.",
                "money-exchange-keywords": "{shop_name}, 唱錢神器, 唱X神器, 唱錢X器, 唱錢, 兌換, 找換, 兌換店, 找換店, 銀行, 金融, 外匯, 外滙, 匯率, 滙率, 匯款, 外幣, 貨幣, 旅行, 旅遊, 行程, 酒店, 機票, 比較, 格價, 特價, 預訂, 交易, 旅遊保險, 日本, 泰國, 韓國, 台灣, 日圓, 日元, 台幣, 泰銖, HyperAir, HyperAir FX, HyperAir Travel, Travel, Travel Money, Foreign Currency, Foreign Exchange, 百年, 堅成, 發達鳥, 飛鳥, richbird, crazy bird, berlin exchange",
                "money-exchange-title": "{shop_name}'s latest FX rate with instant booking | Lock in FX rate and reserve your travel money instantly",
                "privacy-policy-title": "Privacy Policy",
                "refund-policy-title": "Refund & Return Policy",
                "sim-fanfares-description": "HyperAirは香港で最初のSIMカードファンファーレを開始しました。あなたは、50％オフの割引を上にして、あなたの旅行のためにSIMカードを購入することができます。期間限定、限定オファー！",
                "sim-fanfares-keywords": "ファンファーレ、Simcardの、SIMカード、SIM卡、上網卡、電話卡、數據卡、DataSIM、旅遊DataSIM、數據咭、4G上網卡、上網卡、4G上網卡、日本4G上網卡、日本上網卡、東京4G上網卡、東京上網卡、大阪4G上網卡、大阪上網卡、泰國4G上網卡、泰國上網卡、曼谷4G上網卡、布吉上網卡、芭提雅4G上網卡、台灣4G上網卡、台灣上網卡、台北4G上網卡、高雄上網卡、台中4G上網卡、台中上網卡、韓國4G上網卡、韓國上網卡、首爾4G上網卡、首爾上網卡、中國4G上網卡、中國上網卡、深圳4G上網卡、深圳上網卡、澳門4G上網卡、澳門上網卡、ドコモ、ソフトバンク",
                "sim-fanfares-title": "SIMカードファンファーレ - 期間限定、限定カード",
                "term-of-service-title": "Terms of Service",
                "travel-activity-search-results-description": "",
                "travel-activity-search-results-keywords": "{activity}, travel, local experience, local activity, ticket, activities, day tours, tourist attractions",
                "travel-activity-search-results-title": "HyperAir - Search Result of {q} in {city}",
                "travel-affiliate-codes-description": "HyperAirは、継続的に予約ホテルの割引、航空券の割引、活動の割引、旅行保険の割引、SIMカードの割引やクレジットカードの割引のための最新の割引コード/プロモーションコードを更新します。",
                "travel-affiliate-codes-keywords": "割引コード、電子クーポン、割引コード、プロモーションコード、プロモーションコード、割引コード、ホテル、航空券、オファー、クレジットカードのオファー、旅行オファー",
                "travel-affiliate-codes-title": "2023最新の旅行割引コード（毎日更新）|ホテル、航空券、活動、旅行保険、データSIMの割引予約",
                "travel-insurance-description": "最高の旅行保険プランを検索しますか？どちらのプランは、携帯電話をカバー？ AIG、MSIGとスターのような企業からの保険プランを比較し、余分な割引をオンラインで購入！",
                "travel-insurance-keywords": "AIG、オンラインMSIG、スター、AIG Promocode、MSIG Promocode、スターPromocode、旅行保険、旅行保険、旅行保険を比較し、格安旅行保険、旅行保険、香港、片道、年度計画",
                "travel-insurance-title": "香港2023年のベスト旅行保険料金＆比較",
                "travel-marketplace-checkout-payme-title": "Pay with PayMe",
                "travel-marketplace-checkout-success-keywords": "創意, 產品, 流行, 電器, 生活, 精品, 智能家居, 設計, 高品質, 設計概念, 創意科技, 生活用品, 戶外休閒, 廚房, 餐桌, 個人護理, 防疫抗疫, 健康, 遊戲, 兒童玩樂, 健身, 家居健身, gym, home gym, smart home, style home",
                "travel-marketplace-checkout-success-title": "{product_name}",
                "travel-marketplace-description": "A collection of coolest gadgets that you'll like",
                "travel-marketplace-keywords": "創意, 產品, 流行, 電器, 生活, 精品, 智能家居, 設計, 高品質, 設計概念, 創意科技, 生活用品, 戶外休閒, 廚房, 餐桌, 個人護理, 防疫抗疫, 健康, 遊戲, 兒童玩樂, 健身, 家居健身, gym, home gym, smart home, style home",
                "travel-marketplace-product-checkout-title": "{product}",
                "travel-marketplace-product-title": "{product}",
                "travel-marketplace-title": "トラベルガジェット",
                "travel-money-description": "HyperAirは、旅行のお金を得るためのまったく新しい方法を提供します。今、あなたは最高の街の為替レートで交換をオンラインで予約することができます！",
                "travel-money-keywords": "sim卡、上網卡、電話卡、數據卡、DataSIM、旅遊DataSIM、數據咭、4G上網卡、上網卡、4G上網卡、唱錢神器、唱X神器、唱錢X器、唱錢、兌換、找換、兌換店、找換店、銀行、金融、外匯、外滙、匯率、滙率、匯款、外貨、貨幣、旅行、旅遊、行程、ホテル、機票、比較、格價、特價、預訂、交易、旅遊保險、日本、泰國、韓國、台灣、日圓、日元、台貨、泰銖、HyperAir、HyperAir FX、HyperAir Travel、Travel、Travel Money、Foreign Currency、Foreign Exchange、百年、堅成、發達鳥、飛鳥、richbird、crazy bird 、ベルリン交換",
                "travel-money-title": "HyperAir-トラベルマネーをよりスマートに交換。",
                "travel-product-checkout-keywords": "創意, 產品, 流行, 電器, 生活, 精品, 智能家居, 設計, 高品質, 設計概念, 創意科技, 生活用品, 戶外休閒, 廚房, 餐桌, 個人護理, 防疫抗疫, 健康, 遊戲, 兒童玩樂, 健身, 家居健身, gym, home gym, smart home, style home",
                "travel-product-keywords": "創意, 產品, 流行, 電器, 生活, 精品, 智能家居, 設計, 高品質, 設計概念, 創意科技, 生活用品, 戶外休閒, 廚房, 餐桌, 個人護理, 防疫抗疫, 健康, 遊戲, 兒童玩樂, 健身, 家居健身, gym, home gym, smart home, style home",
                "travel-sim-checkout-description": "{country} Travel SIM-ドアまで送料無料の高品質SIMカード！",
                "travel-sim-checkout-keywords": "上網卡、電話卡、數據卡、DataSIM、旅遊DataSIM、數據咭、4G上網卡、上網卡、4G上網卡、日本4G上網卡、日本上網卡、東京4G上網卡、東京上網卡、大阪4G上網卡、大阪上網卡、泰國4G上網卡、泰國上網卡、曼谷4G上網卡、布吉上網卡、芭提雅4G上網卡、台灣4G上網卡、台灣上網卡、台北4G上網卡、高雄上網卡、台中4G上網卡、台中上網卡、韓國4G上網卡、韓國上網卡、首爾4G上網卡、首爾上網卡、中國4G上網卡、中國上網卡、深圳4G上網卡、深圳上網卡、澳門4G上網卡、澳門上網卡、ドコモ、ソフトバンク",
                "travel-sim-checkout-success-description": "{country} Travel SIM-ドアまで送料無料の高品質SIMカード！",
                "travel-sim-checkout-success-keywords": "上網卡、電話卡、數據卡、DataSIM、旅遊DataSIM、數據咭、4G上網卡、上網卡、4G上網卡、日本4G上網卡、日本上網卡、東京4G上網卡、東京上網卡、大阪4G上網卡、大阪上網卡、泰國4G上網卡、泰國上網卡、曼谷4G上網卡、布吉上網卡、芭提雅4G上網卡、台灣4G上網卡、台灣上網卡、台北4G上網卡、高雄上網卡、台中4G上網卡、台中上網卡、韓國4G上網卡、韓國上網卡、首爾4G上網卡、首爾上網卡、中國4G上網卡、中國上網卡、深圳4G上網卡、深圳上網卡、澳門4G上網卡、澳門上網卡、ドコモ、ソフトバンク",
                "travel-sim-checkout-success-title": "支払いの成功-Travel SIM",
                "travel-sim-checkout-title": "注文-Travel SIM",
                "travel-sim-keywords": "sim卡、上網卡、電話卡、數據卡、DataSIM、旅遊DataSIM、數據咭、4G上網卡、上網卡、日本4G上網卡、日本上網卡、日本sim卡、東京4G上網卡、東京上網卡、大阪4G上網卡、大阪上網卡、泰國4G上網卡、泰國上網卡、泰國sim卡、曼谷4G上網卡、布吉上網卡、芭提雅4G上網卡、台灣4G上網卡、台灣上網卡、台灣sim卡、台北4G上網卡、高雄上網卡、台中4G上網卡、台中上網卡、韓國sim卡、韓國4G上網卡、韓國上網卡、首爾4G上網卡、首爾上網卡、中國4G上網卡、中國上網卡、中國sim卡、中國內地數據卡、深圳4G上網卡、深圳上網卡、澳門4G上網卡、澳門上網卡、歐洲4G上網卡、歐洲上網卡、歐洲sim卡、英國4G上網卡、英國上網卡、英國上卡、法國4G上網卡、法國上網卡、法國sim卡、恴大利4G上網卡、意大利上網卡、意大利sim卡、巴黎4G上網卡、巴黎上網卡、巴黎sim卡、瑞士4G上網卡、瑞士上網卡、瑞士sim卡、Docomo、Softbank、和記、聯通、3hk、3uk、バーディー、自由鳥、air sim、sim2fly、AIS、ais sim2fly、SK Telecom、TrueMove、dtac、t mobile全球上網卡、vietnamobile",
                "travel-sim-title": "【{country} SIM】{sim_name} - 送料無料で最高の価格保証",
                "travel-sims-description": "高品質のSIMカードとあなたのドアへの送料無料を備えたグローバルトラベルSIM検索エンジン！",
                "travel-sims-keywords": "sim卡、上網卡、電話卡、數據卡、DataSIM、旅遊DataSIM、數據咭、4G上網卡、4Gsim卡、日本4G上網卡、日本上網卡、日本sim卡、東京4G上網卡、東京上網卡、大阪4G上網卡、大阪上網卡、泰國4G上網卡、泰國上網卡、泰國sim卡、曼谷4G上網卡、布吉上網卡、芭提雅4G上網卡、台灣4G上網卡、台灣上網卡、台灣sim卡、台北4G上網卡、高雄上網卡、台中4G上網卡、台中上網卡、韓國sim卡、韓國4G上網卡、韓國上網卡、首爾4G上網卡、首爾上網卡、中國4G上網卡、中國上網卡、中國sim卡、中國內地數據卡、深圳4G上網卡、深圳上網卡、澳門4G上網卡、澳門上網卡、澳門sim卡、歐洲sim卡、Docomo、Softbank、sim2fly、AIS、ais sim2fly、SK Telecom、TrueMove、dtac 、t mobile全球上網卡、vietnamobile",
                "travel-sims-title": "Travel SIM-送料無料のベストプライス保証"
            },
            "shop-confirmation": {
                "app-download": "",
                "app-download-subtitle": "",
                "instruction": "",
                "my-order": "",
                "pending-confirm": ""
            },
            "staycation": {
                "activity-countdown-button": "Find the cheapest price",
                "all-hotels": {
                    "sorting": {
                        "recommended": "Recommended"
                    }
                },
                "all-hotels-all-button": "All",
                "all-hotels-hotel-name": "Hotel Name",
                "all-hotels-last-updated": "Last Updated",
                "all-hotels-less-button": "Less",
                "all-hotels-more-button": "More",
                "all-hotels-no-result": "Sorry, we couldn't find any results",
                "all-hotels-title": "",
                "compare-packages": "Compare other packages",
                "countdown-button": "More Details",
                "countdown-title": "",
                "countdown2-title": "HyperAir Recommended",
                "countdown3-title": "最新 Staycation 酒店限時優惠",
                "month-format": "MMM",
                "order-d-title": "浪漫精品酒店 💕💕",
                "order-g-subtitle": "暑假帶埋一家大細Relax下",
                "order-g-title": "親子Staycation必去之選👨‍👩‍👧‍👦😍",
                "order-h-title": "郵輪之旅🛳️",
                "order-i-title": "情侶煮飯仔酒店 🍽️",
                "order-j-title": "Glamping豪華露營推介",
                "seo-description": "點解咁多人用 HyperAir 搵 Staycation? 因為集合左 KKday, Trip.com, Klook 及各大香港酒店平台，一眼比較邊到有late checkout、免費泊車、自助早午晚餐及餐飲回贈等獨家 Staycation 優惠，每日更新。",
                "seo-keywords": "staycation, staycation 優惠, 香港 staycation, staycation 香港, staycation hk, staycation package, staycation hong kong, 酒店, 酒店 優惠, staycation 中文, 香港 酒店, klook 優惠, klook 優惠, kkday 優惠, trip 優惠, agoda 優惠, runhotel staycation, 酒店 套票, staycation 酒店, 香港 酒店 套票, 訂 酒店 優惠, 酒店 package, 特價 酒店, 香港 優惠 酒店, 酒店 優惠 套 票, 特價 酒店 香港, 香港 酒店 優惠, 酒店 住宿 優惠, staycation 2020, staycation 2021, staycation 2022, staycation 1月 優惠, staycation 2月 優惠, staycation 3月 優惠, staycation 4月 優惠, staycation 5月 優惠, staycation 6月 優惠, staycation 7月 優惠, staycation 8月 優惠, staycation 9月 優惠, staycation 10月 優惠, staycation 11月 優惠, staycation 12月 優惠, 四季酒店, W酒店, Murray, JW Marriott, St. Regis, Conrad Hotel, Grand Hyatt, Ritz Carlton, Rosewood, 露台 酒店, 廚房 酒店, 親子 酒店, 情侶 酒店",
                "seo-title": "【2021年9月最新】香港酒店 Staycation 優惠搜尋神器 全港最齊．每日更新 - 最齊香港staycation優惠、酒店優惠、Hong Kong Staycation Ideas、Klook優惠、KKday優惠、Trip優惠、Agoda優惠、專業旅運優惠 - HyperAir 玩樂必備搜尋比較平台！一次過，比較全球多個玩樂旅遊預訂網站！ - HyperAir",
                "share-button-alert": "Copied the Link",
                "subtitle": "每日更新酒店餐飲及住宿優惠（{start_month}月至{end_month}月）",
                "title": "",
                "top10-title": "",
                "top102-title": "",
                "top103-title": "值得一試的 Staycation 酒店🥂"
            },
            "travel-activities": {
                "best-deals": "Best Deal",
                "book-now": "View Deal",
                "disclaimer": "表示されている価格は参考値です。矛盾がある場合は、パートナーのWebサイトを参照してください。",
                "empty-destination": "",
                "more-deals": "More Deals",
                "not-available": "Not Available",
                "offers": "",
                "provider-getyourguide": "GetYourGuide",
                "provider-hk": {
                    "trip": {
                        "com": "Trip.com"
                    }
                },
                "provider-hyperair": "HyperAir",
                "provider-kkday": "KKday",
                "provider-klook": "KLOOK",
                "provider-seoultravelpass": "SeoulPass",
                "provider-sim": {
                    "hyperair": {
                        "com": "HyperAir"
                    }
                },
                "provider-travelexpert": "Travel Expert",
                "provider-trip": "Trip.com",
                "ratings": "格付け",
                "recommended-title": "{city}でより人気のあるアクティビティ",
                "search-africa-oceania": "アフリカ/オセアニア",
                "search-all-cities": "すべての都市",
                "search-america": "アメリカ",
                "search-asia": "アジア",
                "search-button": "探す",
                "search-cancel-button": "キャンセル",
                "search-country-placeholder": "国または都市を入力してください",
                "search-euro-middleeast": "ヨーロッパ/中東",
                "search-hardcoded-cities": "人気のある検索：",
                "search-placeholder": "「JR Pass」を検索",
                "search-popular-cities": "人気の都市",
                "search-searched-cities": "検索された都市",
                "search-slogan-2": "",
                "show-similar-product": "同様の比較",
                "sorting": {
                    "price-asc": "価格（低から高）",
                    "price-desc": "価格（高から低）",
                    "rating": "格付け",
                    "relevance": "関連性",
                    "sort-by": "並び替え"
                },
                "title": "「{q}」に一致する検索結果",
                "title-everything": "{city}での人気アクティビティ",
                "title-no-result": "「{q}」の結果が見つかりませんでした",
                "title-no-result-without-keyword": "申し訳ありませんが、我々は結果を見つけることができませんでした",
                "total-results": "合計<b>{number}</ b>結果"
            },
            "travel-affiliate-codes": {
                "cover-slogan": "海外旅行予約サイトの割引コードを提供",
                "cover-title": "旅行割引クーポン",
                "disclaimer": "示さプロモーションの提供は参考用です。不一致の場合には、当社のパートナーのウェブサイトを参照してください。サプライヤーは、変更したり、予告なしに情報をいつでも削除すると提供に裁量を持たなければならないことがあります。",
                "exclusive": "排他的",
                "type-activity": "アクティビティ",
                "type-air": "航空券",
                "type-all": "すべて",
                "type-hotel": "ホテル",
                "type-insurance": "旅行保険",
                "type-shopping": "ショッピング",
                "type-sim": "SIMカード",
                "use-promo-code": "コードを取得",
                "valid-until": "まで有効："
            },
            "travel-insurance": {
                "breadcrumb-travel-insurance": "旅行保険",
                "cover-subtitle": "検索と携帯電話のカバレッジで最高の旅行保険を比較！",
                "cover-title": "旅行保険",
                "departure-date-alert": "",
                "disclaimer": "引用は、参考値です。詳細については、保険会社のウェブサイトを参照してください。",
                "highlight-subtitle1": "あなたの容易な選択のための旅行保険プランの主要報道うち一覧",
                "highlight-subtitle2": "あなたはすべてのドルを節約するための最良の旅行保険プランを比較！",
                "highlight-subtitle3": "排他的な旅行保険の特権や特典をお楽しみください！",
                "highlight-title1": "カバレッジの比較",
                "highlight-title2": "比較と料金",
                "highlight-title3": "独占報酬",
                "num-of-travellers-alert": "",
                "partner-title": "私たちの旅行保険パートナー",
                "return-date-alert": "",
                "section-title": "これで、検索している{num_of_day}用{num_of_traveller}旅行者（複数可）",
                "slogan": "簡単な3つのステップ",
                "sorting": {
                    "coverage": "ベストカバレッジ",
                    "price-asc": "価格（高い順）",
                    "price-desc": "価格（高い順）"
                },
                "step1": "情報を記入",
                "step1-detail": "あなたの目的地、日付とnoを入力。旅行者の",
                "step2": "プランの比較",
                "step2-detail": "別の旅行保険プランの価格とカバレッジの比較",
                "step3": "オファーをお楽しみください",
                "step3-detail": "排他的な旅行保険の提供を楽しむためにワンクリック"
            },
            "travel-insurance-product-card": {
                "apply-now": "プランを取得",
                "cancellation": "キャンセル",
                "car-rental": "レンタカー過剰",
                "cruise-vacation": "クルーズバケーション（オプションのメリット）",
                "dangerous-sports": "DANGEROUS SPORTS",
                "hyperair-exclusive": "HYPERAIR EXCLUSIVE",
                "medical": "MEDICAL",
                "mobile": "携帯電話の損失/ DAMAGE",
                "personal-belongings": "個人の持ち物",
                "trip-delay": "TRIP DELAY"
            },
            "travel-insurance-search-bar": {
                "children": "18歳未満のお子様",
                "date": "出発日と帰着日",
                "destination": "あなたはどこに行くのですか",
                "friend": "友達/親戚",
                "myself": "自分",
                "number-of-traveller": "旅行者の数",
                "search-button": "探す",
                "spouse": "配偶者"
            },
            "travel-marketplace": {
                "buy-now-can-earn-x-miles": "",
                "cover-slogan": "あなたが好きだろうとクールなガジェットのコレクション",
                "cover-title": "トラベルガジェット"
            },
            "travel-marketplace-categories": "Categories",
            "travel-marketplace-checkout": {
                "delivery-message-body": "営業日は（祝日を除く）月曜日から金曜日までです。オーダーカットオフ時間は12{00} PM（GMT + 8）です。 12{00} PM（GMT + 8）の後に置か注文は翌営業日出荷されます。",
                "delivery-method-1": "SFエクスプレス（香港のみ）",
                "delivery-method-1-description": "SF Expressで、宅配便の料金はオーダーあたりHK $ 30です。宅配便の料金はHK $ 800を超える購入時に免除されます。注文した商品は1-3営業日以内に宅配便で配送されます、そして島はSFエクスプレスのウェブサイトを参照すると、5営業日かかります。",
                "delivery-method-2": "海外発送",
                "delivery-method-2-description": "先に応じて、4〜15営業日でお届け。料金送料は項目ごとにHK $ 100です。上記国際配送料金は推定に基づいています。さらに、有料が適用される場合があります。"
            },
            "travel-money": {
                "breadcrumb-travel-money": "トラベルマネー",
                "cover-button": "今すぐ体験",
                "cover-slogan": "旅行のお金をよりスマートに交換",
                "cover-title": "トラベルマネー",
                "disclaimer": "表示価格は参考用です。不一致の場合には、両替商のウェブサイトを参照してください。",
                "empty-amount": "",
                "fx": "",
                "fx-slogan": "4つの簡単なステップ",
                "fx-step1": "サーチ",
                "fx-step1-detail": "交換する通貨を選択してください",
                "fx-step2": "比較する",
                "fx-step2-detail": "最高の料金と最も便利なピックアップスポットを見つける",
                "fx-step3": "本",
                "fx-step3-detail": "旅行のお金をオンラインで予約する",
                "fx-step4": "拾う",
                "fx-step4-detail": "旅行のお金を得るためにQRコードを表示する",
                "hyperair-feature-1": "スマート",
                "hyperair-feature-1-description": "旅行のお金を交換するスマートな方法。これで、数回クリックするだけで最高の料金を見つけて、オンラインで旅費を予約できます。長い行列に別れを告げる時間です！",
                "hyperair-feature-2": "信頼性のある",
                "hyperair-feature-2-description": "両替を得るための信頼できる方法。すべてのパートナーは、外国為替の安全を守るために認可された銀行および両替所です。",
                "hyperair-feature-3": "どこでも。どんなときも。",
                "hyperair-feature-3-description": "旅行のお金を得るためのまったく新しい方法。私たちは、海外のフットプリントを拡大し、どこでもあなたに最もスマートな旅行体験を提供したいと考えています。",
                "i-will-get": "私は手に入れます",
                "i-will-pay": "私が払います",
                "join-us": "より多くのビジネスチャンスのために",
                "join-us-button": "今すぐご参加ください",
                "join-us-slogan": "サプライヤーになる",
                "search-bar-placeholder": "金額を入力します",
                "search-button": "探す",
                "section-title": "",
                "section-title-from-hkd": "探しHKD {amount} {currency}",
                "section-title-to-hkd": "検索{amount} {currency}はHKDため",
                "why-hyperair": "",
                "why-hyperair-description": "HyperAirは、旅行のお金を得るためのまったく新しい方法を提供します。今、あなたは最高の街の為替レートで交換をオンラインで予約することができます！",
                "why-hyperair-title": "なぜ私たちを選ぶのですか？"
            },
            "travel-product": {
                "buy-now": "今買う",
                "product-option": "オプション"
            },
            "travel-sim": {
                "as-low-as": "と低いです",
                "book-now": "今すぐ注文",
                "breadcrumb-homepage": "ホームページ",
                "breadcrumb-mainpage": "メインページ",
                "breadcrumb-travel-sim": "トラベルSIM",
                "cancellation-policy": "取り消し規約",
                "cancellation-policy-content": "購入後のキャンセル、返金、変更はできません。",
                "download-hyperair-now-description": "QRコードをスキャンするか、アプリストアにアクセスしてHyperAirアプリをダウンロードします",
                "download-hyperair-now-title": "HyperAirアプリをダウンロードする",
                "first-step": "ステップ1",
                "go-to-shopping-cart-description": "",
                "go-to-shopping-cart-title": "",
                "hardcoded-countries-title": "その他の人気のある国：",
                "highlights": "ハイライト",
                "important-notice": "重要なお知らせ",
                "instructions": "説明書",
                "lowest-price-guarantee": "ベストプライス保証",
                "no-stock": "完売",
                "num-of-review": ":レビュー数のレビュー",
                "popular-countries": "Travel SIMは200か国をカバー",
                "popular-countries-search-button": "他の国を検索",
                "product-highlights": "Product Description",
                "product-specification": "製品仕様",
                "related-sims": "関連:国SIM",
                "related-sims-search-button": "詳細:国のSIM",
                "review": "レビュー",
                "review-date": ":日付",
                "review-no-firstname-user": "旅行者",
                "scan-product-qr-code": "掃一掃QR Code購買此產品",
                "second-step": "ステップ2",
                "sim": " Sim Cards",
                "web-traffic": "先週以降に購入した{num}-of-purchased回、および{num}-of-trafficユーザーが今このSIMを見ている",
                "web-traffic-title": "このSIMは熱い販売中です！"
            },
            "travel-sim-checkout": {
                "-secure-payment-slogan": "",
                "address": "配送先住所",
                "address-column1": "例えばルー���A、18 / F、ワールドセンター",
                "address-column2": "例えば88トラベルロード",
                "address-column3": "例えば香港中部",
                "back-button": "バック",
                "checkout-title-1": "配送情報",
                "confirm-button": "持続する",
                "country-code": "国コード",
                "delivery-message-body": "Working days are from Monday to Friday (except public holidays). The order cut-off time is 12：00 PM (GMT+8). Orders placed after 12：00 PM (GMT+8) will ship out the next working day.\n<br><br>Within the same working day, orders with the same delivery address will be sent together.",
                "delivery-message-header": "配達通知",
                "delivery-method": "配送方法",
                "delivery-method-1": "Hong Kong Post (Free)",
                "delivery-method-1-description": "By Hong Kong Post's Local Mail, the estimated delivery will be within 3-6 working days. Status tracking is not available to local mail and customers shall bare the full responsibility of losing items by using Hong Kong Post’s ordinary mail service.\n<br><br>Note: Due to the time required for delivery, customers who are about to travel are recommended to choose SF Express",
                "delivery-method-2": "SF Express (Hong Kong only. Courier fee payable on delivery)",
                "delivery-method-2-description": "By SF Express (courier fee payable on delivery), the ordered items will be delivered by courier within 1-3 working days, and islands will take longer delivery time. The courier fee is about HK$16-$25 by referring to the website of SF Express.\n<br><br>Note: The order over HK$399 will be upgraded to SF Express for FREE",
                "delivery-method-3": "International Shipping",
                "delivery-method-3-description": "Delivered by Hong Kong Post (tracking no. will be provided) within 4 to 15 working days depends on the destination. Shipping cost HK$30.",
                "error-alert-address": "配送先住所を入力してください。",
                "error-alert-invalid-email": "メール形式が無効です。",
                "error-alert-invalid-recipient-first-num": "連絡先番号は、2,3,5,6,7,8または9で始まる必要があります",
                "error-alert-invalid-recipient-number": "正しい連絡先番号を入力してください。",
                "error-alert-invalid-user-first-num": "携帯電話番号は5、6、7、8または9で始まる必要があります。",
                "error-alert-invalid-user-number": "正しい携帯電話番号を入力してください。",
                "error-alert-personal-info": "個人情報を入力してください。",
                "error-alert-recipient-info": "受信者情報を入力してください。",
                "error-invalid-credit-card-info": "無効なクレジットカード情報",
                "facebook-login": "Facebookで続ける",
                "google-login": "Googleで続ける",
                "logged-in": "ログイン済み",
                "login": "既存のお客様、ログインしてエクスプレスチェックアウトをお楽しみください",
                "login-button": "ログイン",
                "login-email": "Eメール",
                "login-no-user-exists": "おっと！申し訳ありませんが、ログイン情報を確認できません。もう一度お試しいただくか、ゲストのチェックアウトなしで注文を完了してください。",
                "login-password": "パスワード",
                "payme": {
                    "error-contacting-payme": "支払エラー、再オーダー再びまたはカスタマー・サポートに連絡してください。"
                },
                "payment": {
                    "actual-payment": "The transaction will be settled at HK${actual_payment} and the exchange rate will be based on your credit card issuer.",
                    "choose-payment-method": "支払い方法を選択します。",
                    "logistic-information": "配送情報",
                    "modify-information": "情報を編集",
                    "pay-now": "今払う",
                    "payme-instruction-do-not-close": "支払いが完了する前にこのページを閉じないでください",
                    "payme-instruction-step-1": "1. PayMeアプリ。",
                    "payme-instruction-step-2": "2.スキャンの支払いを承認するPayCode。",
                    "payme-instruction-step-3": "3.完全なアプリでのお支払いと確認を待ちます。",
                    "payme-instruction-title": "PayMeでのお支払い",
                    "payme-title": "PayMeこのPayCodeをスキャン",
                    "payment": "支払い",
                    "price": "量",
                    "shipping-fee": "送料",
                    "subtotal": "小計"
                },
                "payment-method": "支払方法",
                "pending": {
                    "mobile-redirection-text": "あなたは、お支払い方法としてPayMeを選択して、完全な支払いにPayMeアプリにリダイレクトされます。",
                    "need-to-pay": "料金",
                    "order-number": "注文番号",
                    "order-success-please-pay": "注文プロセスを完了するために、PayMeでお支払いください",
                    "paycode-error": "支払エラー、再オーダー再びまたはカスタマー・サポートに連絡してください。",
                    "paycode-expired": "PayMeのpaycodeは再び下さい再オーダー、期限切れ。",
                    "re-order": "再オーダー",
                    "title-payme": "PayMeで支払います"
                },
                "recipient-address": "配送先住所",
                "recipient-information": "受取人情報",
                "recipient-name": "受信者の名前",
                "recipient-phone-number": "受信者の電話番号",
                "secure-payment-slogan": "安全なチェックアウト|支払いは暗号化され、SSLを使用して安全に送信されます",
                "simproduct-detail": "注文情報",
                "simproduct-quantity": "量",
                "simproduct-redeem": "",
                "simproduct-redeem-hypermiles": "",
                "simproduct-title": "製品",
                "simproduct-will-redeeming-x-miles": "",
                "simproduct-you-have-x-hypermiles": "",
                "user-email": "電子メール（請求書を受け取るため）",
                "user-firstname": "ファーストネーム",
                "user-information": "個人情報",
                "user-lastname": "苗字",
                "user-phone-number": "携帯電話番号",
                "vertical-divider": "または"
            },
            "travel-sims": {
                "column-title-1": "明確な分類、選びやすい",
                "column-title-2": "オンライン支払い、便利で速い",
                "column-title-3": "無料の表面メール、迅速な配達",
                "country-search-no-place-found": "この目的地の結果は見つかりませんでした",
                "cover-button": "HyperAirアプリで今すぐ注文する",
                "cover-slogan": "最高のSIMカードは送料無料でお得！",
                "cover-title": "トラベルSIM",
                "empty-destination": "",
                "num-of-days": "",
                "search-button": "",
                "search-input": "国を検索",
                "search-placeholder": "国を検索",
                "search-slogan": "どこに行きますか？",
                "travel-sim-header-description": "",
                "travel-sim-header-title": ""
            }
        },
        "passwords": {
            "password": "パスワードは6文字以上で、確認と一致する必要があります。",
            "reset": "あなたのパスワードはリセットされました！",
            "sent": "パスワード再設定リンクを電子メールで送信しました。",
            "token": "このパスワードリセットトークンは無効です。",
            "user": "そのEメールアドレスを持つユーザーが見つかりません。"
        },
        "mail": {
            "product-simcard": {
                "delivery-update": {
                    "subject": "SIMカードの注文は間もなく開始されます"
                },
                "purchased": {
                    "subject": "Travel SIMの注文確認"
                },
                "tracking-number-update": {
                    "subject": "注文追跡番号が更新されました"
                }
            }
        },
        "member-center": {
            "login-to-receive-codes": "",
            "my-orders-empty": "記録なし",
            "my-orders-title": "私の注文",
            "profile-area-code": "市外局番",
            "profile-email": "Eメール",
            "profile-firstname": "ファーストネーム",
            "profile-lastname": "苗字",
            "profile-save": "セーブ",
            "profile-tel": "電話番号",
            "profile-title": "プロフィール",
            "profile-update-successfully": "",
            "promo-code-enter-promotion-code": "プロモーションコードを入力します。",
            "promo-code-my-promo-code": "マイHyperAirプロモーションコード",
            "promo-code-no-code": "",
            "promo-code-please-fill-in-code": "",
            "promo-code-redeem": "買い戻します",
            "promo-code-redeem-code": "HyperAirプロモーションコードを引き換えます",
            "promo-code-select": "選択する",
            "promo-code-title": "HyperAirプロモーションコード",
            "title": "会員センター"
        },
        "weekday": {
            "1": "月曜",
            "2": "火曜日",
            "3": "水曜日",
            "4": "木曜日",
            "5": "金曜日",
            "6": "土曜日",
            "7": "日曜日"
        },
        "exchange-shop-details": {
            "address": "住所",
            "book-button": "今予約する",
            "br": "BR",
            "closed-book-button": "閉まっている",
            "download-pop-up": {
                "slogan-1": "レートにロックされました",
                "slogan-2": "インスタントComfirmation",
                "title": "FX予約のためのアプリケーションをダウンロード"
            },
            "latest-updated": "最新の更新",
            "not-available-book-button": "無効",
            "opening-hrs": "営業時間",
            "phone-num": "電話番号",
            "rate": "割合",
            "reviews": "レビュー",
            "table-buy-rate": "購入率",
            "table-compare-button": "比較します",
            "table-currency": "通貨",
            "table-sell-rate": "売却率",
            "table-short-form": "コード",
            "table-title": "その他の通貨"
        },
        "credit-card": {
            "cannot-add-card": "クレジットカードの追加中に問題が発生しました。情報を確認して再試行するか、別のクレジットカードを追加してください。",
            "cannot-process": "クレジットカードの請求中に問題が発生しました。情報を確認して再試行するか、別のクレジットカードでチェックアウトしてください。"
        },
        "shoppingcart": {
            "add": {
                "no-stock": "おっと！この製品の最大購入可能数量に達しました..."
            },
            "pay": {
                "db-locked": "サーバービジー状態。後でもう一度やり直してください。 （参照コード{E1003}）",
                "invalid-promotion-code": "無効なプロモーションコード",
                "no-stock": "在庫切れの商品です！ （参照コード{E1002}）"
            },
            "promotion-message": {
                "up-sell-1": "ウェルカムクーポンでHK $ 10オフ",
                "up-sell-2": "HK $ 299を超える場合、プロモーションコードHYPER15でHK $ 15オフ"
            }
        },
        "product": {
            "label-confirmation-duration-24_hours": "24時間の確認",
            "label-confirmation-duration-48_hours": "48時間の確認",
            "label-confirmation-duration-instant": "即時確認",
            "label-duration-unit-day": "＆nbsp; days",
            "label-duration-unit-hour": "時間）",
            "label-duration-unit-hr": "＆nbsp;時間",
            "label-duration-unit-min": "＆nbsp; mins",
            "label-earliest-available-date": "j M Y",
            "label-earliest-available-date-today": "今日",
            "label-earliest-available-date-tomorrow": "明日",
            "label-lang-en": "英語",
            "label-lang-jp": "日本人",
            "label-lang-kr": "韓国語",
            "label-lang-zh": "中国語",
            "label-meet-up-method-hotel_pickup": "ホテル送迎",
            "label-meet-up-method-location_meet_up": "ロケーションミートアップ",
            "label-refundable-conditional_cancel": "条件付きキャンセル",
            "label-refundable-no_cancel": "キャンセル不可",
            "label-ticket-logistic-mobile": "モバイルバウチャーを受け入れました",
            "label-ticket-logistic-printed": "印刷されたバウチャーを受け入れました",
            "label-ticket-logistic-printed_or_mobile": "印刷またはモバイルのバウチャーを受け入れました",
            "label-ticket-validity-fixed_date": "固定日チケット",
            "label-ticket-validity-open_date": "オープンデートチケット",
            "label-ticket-validity-open_or_fixed_date": "オープン/固定日付チケット"
        },
        "pagination": {
            "next": "次へ＆raquo;",
            "previous": "＆laquo;前"
        },
        "city": {
            "abu-dhabi": "アブダビ",
            "adelaide": "アデレード",
            "agra": "アグラ",
            "ahmedabad": "アーメダバード",
            "alice-springs": "アリススプリングズ",
            "alsace": "アルザス",
            "amritsar": "アムリトサル",
            "amsterdam": "アムステルダム",
            "andalusia": "アンダルシア",
            "antalya": "アンタルヤ",
            "anuradhapura": "アヌラーダプラ",
            "athens": "アテネ",
            "auckland": "オークランド",
            "bacolod": "バコロド",
            "bagan": "バガン",
            "baku": "バクー",
            "bali": "バリ島",
            "bandung": "バンドン",
            "bangalore": "バンガロール",
            "bangkok": "バンコク",
            "barcelona": "バルセロナ",
            "batam": "バタム",
            "bath": "浴",
            "bay-of-islands": "ベイオブアイランズ",
            "beijing": "北京",
            "belfast": "ベルファスト",
            "bentota": "ベントータ",
            "berlin": "ベルリン",
            "bohol": "ボホール",
            "boracay": "ボラカイ",
            "bordeaux": "ボルドー",
            "boston": "ボストン",
            "bratislava": "ブラチスラバ",
            "brisbane": "ブリスベン",
            "bruges": "ブルージュ",
            "brussels": "ブリュッセル",
            "budapest": "ブダペスト",
            "burgundy": "ブルゴーニュ",
            "busan": "釜山",
            "cairns": "ケアンズ",
            "cambridge": "ケンブリッジ",
            "cameron-highlands": "キャメロンハイランド",
            "canary-islands": "カナリア諸島",
            "cape-town": "ケープタウン",
            "cappadocia": "カッパドキア",
            "cebu": "セブ",
            "champagne": "シャンパン",
            "chengdu": "成都",
            "chennai": "チェンナイ",
            "chiang-mai": "チェンマイ",
            "chiang-rai": "チェンライ",
            "chiayi": "嘉義",
            "chicago": "シカゴ",
            "chongqing": "重慶",
            "christchurch": "クライストチャーチ",
            "cochin": "コーチン",
            "cologne": "ケルン",
            "colombo": "コロンボ",
            "copenhagen": "コペンハーゲン",
            "costa-del-sol": "コスタデルソル",
            "crete": "クレタ",
            "da-lat": "ダラット",
            "da-nang": "ダナン",
            "darwin": "ダーウィン",
            "davao": "ダバオ",
            "delhi": "デリー",
            "dhaka": "ダッカ",
            "dresden": "ドレスデン",
            "dubai": "ドバイ",
            "dublin": "ダブリン",
            "dubrovnik": "ドゥブロヴニク",
            "dumaguete": "ドゥマゲテ",
            "dunedin": "ダニーデン",
            "düsseldorf": "デュッセルドルフ",
            "edinburgh": "エディンバラ",
            "finnish-lapland": "",
            "florence": "フィレンツェ",
            "frankfurt": "フランクフルト",
            "fraser-island": "フレーザー島",
            "french-riviera": "フランスのリビエラ",
            "fukuoka": "福岡県",
            "galle": "ゴール",
            "galway": "ゴールウェイ",
            "gangtok": "ガントク",
            "gangwon-do": "江原道",
            "gdansk": "グダニスク",
            "geneva": "ジュネーブ",
            "genting-highlands": "ゲンティンハイランド",
            "geraldton": "ジェラルドトン",
            "glasgow": "グラスゴー",
            "goa": "行きます",
            "gold-coast": "ゴールドコースト",
            "gothenburg": "ヨーテボリ",
            "guam": "グアム",
            "guangdong": "広東",
            "guilin": "桂林",
            "guizhou": "貴州",
            "gyeonggi-do": "京畿道",
            "haikou": "海口",
            "hakone": "箱根",
            "halong": "ハロン",
            "hamburg": "ハンブルク",
            "hangzhou": "杭州",
            "hanoi": "ハノイ",
            "harbin": "ハルビン",
            "hat-yai": "ハジャイ",
            "hawaii": "ハワイ",
            "heidelberg": "ハイデルベルク",
            "helsinki": "ヘルシンキ",
            "himachal-pradesh": "ヒマーチャル・プラデーシュ",
            "hiroshima": "広島県",
            "ho-chi-minh-city": "ホーチミン市",
            "hobart": "ホバート",
            "hoi-an": "ホイアン",
            "hokkaido": "北海道",
            "hong-kong": "香港",
            "hua-hin": "ホアヒン",
            "hualien": "花蓮",
            "hue": "色相",
            "hyderabad": "ハイデラバード",
            "iloilo": "イロイロ",
            "incheon": "仁川",
            "inle-lake": "インレー湖",
            "inner-mongolia": "内モンゴル",
            "innsbruck": "インスブルック",
            "interlaken": "インターラーケン",
            "inverness": "インヴァネス",
            "ipoh": "イポー",
            "istanbul": "イスタンブール",
            "jaipur": "ジャイプール",
            "jaisalmer": "ジャイサルメール",
            "jakarta": "ジャカルタ",
            "jeju": "済州",
            "jerusalem": "エルサレム",
            "jodhpur": "ジョードプル",
            "johor-bahru": "ジョホールバル",
            "kandy": "キャンディー",
            "kaohsiung": "高雄",
            "kathmandu": "カトマンズ",
            "kazan": "カザン",
            "kenting": "Ken丁",
            "kiev": "キエフ",
            "kinmen": "金門",
            "kobe": "神戸",
            "koh-chang": "チャン島",
            "koh-samui": "サムイ島",
            "krabi": "クラビ",
            "krakow": "クラクフ",
            "kuala-lumpur": "クアラルンプール",
            "kumamoto": "熊本",
            "kyoto": "京都",
            "kyushu": "九州",
            "lake-district": "湖水地方",
            "langkawi": "ランカウイ",
            "lapland": "ラップランド",
            "las-vegas": "ラスベガス",
            "launceston": "ローンセストン",
            "lausanne": "ローザンヌ",
            "leipzig": "ライプツィヒ",
            "lisbon": "リスボン",
            "liverpool": "リバプール",
            "ljubljana": "リュブリャナ",
            "loire-valley": "ロワール渓谷",
            "lombok": "ロンボク",
            "london": "ロンドン",
            "los-angeles": "ロサンゼルス",
            "luang-prabang": "ルアンパバーン",
            "lucerne": "ルツェルン",
            "lviv": "リヴィウ",
            "lyon": "リヨン",
            "macao": "マカオ",
            "macau": "",
            "madrid": "マドリード",
            "malaga": "マラガ",
            "manchester": "マンチェスター",
            "mandalay": "マンダレー",
            "manila": "マニラ",
            "marrakech": "マラケシュ",
            "mauritius": "モーリシャス",
            "medan": "メダン",
            "melaka": "マラッカ",
            "melbourne": "メルボルン",
            "miami": "マイアミ",
            "milford-sound": "ミルフォードサウンド",
            "montreux": "モントルー",
            "moscow": "モスクワ",
            "mumbai": "ムンバイ",
            "munich": "ミュンヘン",
            "muscat": "マスカット",
            "nagano": "長野",
            "nagoya": "名古屋",
            "naples": "ナポリ",
            "nelson": "ネルソン",
            "new-delhi": "ニューデリー",
            "new-york": "ニューヨーク",
            "nha-trang": "ニャチャン",
            "niagara-falls": "ナイアガラの滝",
            "niigata": "新潟",
            "normandy": "ノルマンディー",
            "odessa": "オデッサ",
            "okayama": "岡山",
            "okinawa": "沖縄県",
            "orlando": "オーランド",
            "osaka": "大阪",
            "oslo": "オスロ",
            "oxford": "オックスフォード",
            "palawan": "パラワン",
            "paris": "パリ",
            "pattaya": "パタヤ",
            "penang": "ペナン",
            "penghu": "eng湖",
            "perth": "パース",
            "philadelphia": "フィラデルフィア",
            "phnom-penh": "プノンペン",
            "phu-quoc": "フーコック",
            "phuket": "プーケット",
            "pisa": "ピサ",
            "pokhara": "ポカラ",
            "port-lincoln": "ポートリンカーン",
            "porto": "",
            "porto-district": "ポルト地区",
            "prague": "プラハ",
            "provence": "プロヴァンス",
            "puglia": "プーリア",
            "pune": "プネ",
            "pushkar": "プシュカル",
            "queenstown": "クイーンズタウン",
            "ras-al-khaimah": "ラスアルカイマ",
            "reykjavik": "レイキャビク",
            "rhodes": "ロードス",
            "rhône-alpes": "ローヌアルプス",
            "rome": "ローマ",
            "rotorua": "ロトルア",
            "rotterdam": "ロッテルダム",
            "sabah": "サバ",
            "saint-petersburg": "セントピーターズバーグ",
            "saipan": "サイパン",
            "salzburg": "ザルツブルク",
            "san-diego": "サンディエゴ",
            "san-francisco": "サンフランシスコ",
            "santorini": "サントリーニ",
            "sanya": "三亜",
            "sapa": "サパ",
            "sarawak": "サラワク",
            "seattle": "シアトル",
            "seoul": "ソウル",
            "seville": "セビリア",
            "shanghai": "上海",
            "sibiu": "シビウ",
            "sicily": "シチリア",
            "siem-reap": "シェムリアップ",
            "sihanoukville": "シアヌークビル",
            "singapore": "シンガポール",
            "split": "スプリット",
            "surabaya": "スラバヤ",
            "suzhou": "蘇州",
            "swedish-lapland": "スウェーデンのラップランド",
            "sydney": "シドニー",
            "taichung": "台中",
            "tainan": "台南",
            "taipei": "台北",
            "taitung": "台東",
            "tarragona": "タラゴナ",
            "taupo": "タウポ",
            "terengganu": "トレンガヌ",
            "thessaloniki": "テッサロニキ",
            "tokyo": "東京",
            "toledo": "トレド",
            "trincomalee": "トリンコマリー",
            "turin": "トリノ",
            "udaipur": "ウダイプル",
            "uluru": "ウルル",
            "uttarakhand": "ウッタラーカンド",
            "varanasi": "バラナシ",
            "venice": "ヴェネツィア",
            "verona": "ヴェローナ",
            "vienna": "ウィーン",
            "vientiane": "ビエンチャン",
            "volendam": "フォーレンダム",
            "washington-dc": "ワシントンDC",
            "wellington": "ウェリントン",
            "whitsundays": "ウィットサンデー",
            "xiamen": "X門",
            "xian": "西安",
            "yangon": "ヤンゴン",
            "yilan": "宜蘭",
            "yogyakarta": "ジョグジャカルタ",
            "york": "ヨーク",
            "yunnan": "雲南",
            "zagreb": "ザグレブ",
            "zhangjiajie": "張家界",
            "zurich": "チューリッヒ"
        },
        "validation": {
            "accepted": "L属性は受け入れなければなりません。",
            "active_url": ":属性は有効なURLではありません。",
            "after": ":属性は{date}より後の日付でなければなりません。",
            "after_or_equal": "{attribute}は、{date}以降の日付でなければなりません。",
            "alpha": "{attribute}には文字のみを含めることができます。",
            "alpha_dash": "{attribute}には、文字、数字、ダッシュのみを含めることができます。",
            "alpha_num": "{attribute}には文字と数字のみを含めることができます。",
            "array": "{attribute}は配列でなければなりません。",
            "before": "{attribute}は{date}より前の日付でなければなりません。",
            "before_or_equal": "{attribute}は、{date}以前の日付でなければなりません。",
            "between": {
                "array": "{attribute}には{min}〜{max}のアイテムが必要です。",
                "file": "{attribute}は{min}から{max}キロバイトの間になければなりません。",
                "numeric": "{attribute}は{min}と{max}の間でなければなりません。",
                "string": "{attribute}は{min}〜{max}文字の間になければなりません。"
            },
            "boolean": "{attribute}フィールドはtrueまたはfalseでなければなりません。",
            "confirmed": "{attribute}の確認が一致しません。",
            "custom": {
                "attribute-name": {
                    "rule-name": "カスタムメッセージ"
                }
            },
            "date": "{attribute}は有効な日付ではありません。",
            "date_format": "{attribute}は{format}の形式と一致しません。",
            "different": "{attribute}と{other}は異なっていなければなりません。",
            "digits": "{attribute}は{digits}桁でなければなりません。",
            "digits_between": "{attribute}は、{min}〜{max}の数字である必要があります。",
            "dimensions": "{attribute}の画像の寸法が無効です。",
            "distinct": "{attribute}フィールドの値が重複しています。",
            "email": "{attribute}は有効なメールアドレスでなければなりません。",
            "exists": "選択した{attribute}は無効です。",
            "file": "{attribute}はファイルでなければなりません。",
            "filled": "{attribute}フィールドには値が必要です。",
            "image": "{attribute}は画像でなければなりません。",
            "in": "選択した{attribute}は無効です。",
            "in_array": "{attribute}フィールドは{other}に存在しません。",
            "integer": "{attribute}は整数でなければなりません。",
            "ip": "{attribute}は有効なIPアドレスでなければなりません。",
            "ipv4": "{attribute}は有効なIPv4アドレスでなければなりません。",
            "ipv6": "{attribute}は有効なIPv6アドレスでなければなりません。",
            "json": "{attribute}は有効なJSON文字列でなければなりません。",
            "max": {
                "array": "{attribute}には{max}を超えるアイテムを含めることはできません。",
                "file": "{attribute}は{max}キロバイトを超えることはできません。",
                "numeric": "{attribute}は{max}より大きくてはいけません。",
                "string": "{attribute}は、{max}文字を超えることはできません。"
            },
            "mimes": "{attribute}は、タイプ{values}のファイルでなければなりません。",
            "mimetypes": "{attribute}は、タイプ{values}のファイルでなければなりません。",
            "min": {
                "array": "{attribute}には少なくとも{min}個のアイテムが必要です。",
                "file": "{attribute}は少なくとも{min}キロバイトでなければなりません。",
                "numeric": "{attribute}は少なくとも{min}でなければなりません。",
                "string": "{attribute}は少なくとも{min}文字でなければなりません。"
            },
            "not_in": "選択した{attribute}は無効です。",
            "numeric": "{attribute}は数値でなければなりません。",
            "present": "{attribute}フィールドが存在する必要があります。",
            "regex": "{attribute}形式は無効です。",
            "required": "{attribute}フィールドは必須です。",
            "required_if": "{other}が{value}の場合、{attribute}フィールドは必須です。",
            "required_unless": "{others}が{values}にない限り、{attribute}フィールドは必須です。",
            "required_with": "{values}が存在する場合、{attribute}フィールドは必須です。",
            "required_with_all": "{values}が存在する場合、{attribute}フィールドは必須です。",
            "required_without": "{values}が存在しない場合、{attribute}フィールドは必須です。",
            "required_without_all": "{values}が存在しない場合、{attribute}フィールドは必須です。",
            "same": "{attribute}と{other}は一致する必要があります。",
            "size": {
                "array": "{attribute}には{size}アイテムが含まれている必要があります。",
                "file": "{attribute}は{size}キロバイトでなければなりません。",
                "numeric": "{attribute}は{size}でなければなりません。",
                "string": "{attribute}は{size}文字でなければなりません。"
            },
            "string": "{attribute}は文字列でなければなりません。",
            "timezone": "{attribute}は有効なゾーンでなければなりません。",
            "unique": "{attribute}はすでに使用されています。",
            "uploaded": "{attribute}のアップロードに失敗しました。",
            "url": "{attribute}形式は無効です。"
        },
        "reset-password": {
            "confirm-new-password": "新しいパスワードを確認",
            "enter-new-password": "新しいパスワードを入力してください",
            "please-enter-a-new-password": "アカウントの新しいパスワードを入力してください{email}。",
            "submit": "提出する",
            "success-content": "成功しました！新しいパスワードでHyperAirモバイルアプリにログインしてください。",
            "title": "パスワードを再設定する",
            "validation-display": "パスワードには6文字以上が必要です。"
        },
        "notification": {
            "activation-e-minus-content": "15日間のカウントダウン！ Travel SIMウェルカムクーポンはまもなく期限切れになります！今後の旅行にクーポンを使用する機会をお見逃しなく！",
            "activation-e-minus-title": "",
            "activation-t-plus-content": "次回の旅行には、必ずウェルカムSIMカードクーポンをご利用ください！よりスマートに。どこでも。",
            "activation-t-plus-title": "",
            "ask-shop-to-quote-content": "購入の見積りを要求する:金額:通貨",
            "ask-shop-to-quote-content2": "販売の見積りを要求する:金額:通貨",
            "ask-shop-to-quote-title": "見積もりの新しいリクエスト",
            "email-booking-details": "予約明細",
            "email-booking-id": "予約ID",
            "email-exchange-approved-content": "交換注文は購入を承認しました:金額:通貨:レート:レート",
            "email-exchange-approved-footer": "HyperAirをご利用いただきありがとうございます。",
            "email-exchange-approved-title": "ショップは、「あなたの旅費は受け取り可能です！」と答えました。",
            "email-exchange-completed-content": "購入のために完了した交換注文:金額:レートでの通貨:レート",
            "email-exchange-completed-footer": "HyperAirをご利用いただきありがとうございます。",
            "email-exchange-completed-title": "旅行の両替が完了しました！",
            "email-exchange-confirmed-content": "交換注文は購入のために確認されました:金額:レートでの通貨:レート",
            "email-exchange-confirmed-footer": "HyperAirをご利用いただきありがとうございます。",
            "email-exchange-confirmed-title": "旅費はピックアップの準備ができています！",
            "email-footer-copy-right": "全著作権所有。",
            "email-greetings": "こんにちは！",
            "email-i-got": "わかった",
            "email-i-paid": "支払いました",
            "email-i-will-get": "私は取得します",
            "email-i-will-pay": "私が払います",
            "email-pickup-before": "前にお迎え",
            "email-product-confirmed-greeting": "親愛なるお客様、<br><br>HyperAirをご利用いただきありがとうございます。バウチャーの準備ができました。",
            "email-product-confirmed-subject": "注文が確認されました",
            "email-product-confirmed-title": "ご注文が確認されました",
            "email-product-purchased": {
                "shipping": {
                    "international": "海外発送",
                    "sf": "SFエクスプレス（香港のみ）"
                }
            },
            "email-product-purchased-delievery-address": "配信アドレス",
            "email-product-purchased-delivery-info": "配達情報",
            "email-product-purchased-delivery-method": "配信方法",
            "email-product-purchased-discount": "ディスカウント",
            "email-product-purchased-email": "Eメール",
            "email-product-purchased-greeting": "親愛なるお客様、<br><br> 良い選択。予約の確認には時間がかかります。ただし、ほとんどの場合、12時間以内に注文を確認できます。 HyperAirをご利用いただきありがとうございます！",
            "email-product-purchased-have-a-nice-trip": "良い旅を！",
            "email-product-purchased-important-notice": "利用規約が適用されます。",
            "email-product-purchased-important-notice-content": "利用規約が適用されます。",
            "email-product-purchased-name": "名",
            "email-product-purchased-order-date": "注文日",
            "email-product-purchased-order-details": "注文詳細",
            "email-product-purchased-order-no": "注文番号",
            "email-product-purchased-personal-info": "個人情報",
            "email-product-purchased-receipient-name": "受信者の名前",
            "email-product-purchased-receipient-phone-no": "電話番号。",
            "email-product-purchased-shipping-fee": "配送料",
            "email-product-purchased-sub-total": "小計",
            "email-product-purchased-subject": "注文は確認待ちです",
            "email-product-purchased-title": "ご注文は保留中です",
            "email-product-purchased-total": "合計",
            "email-product-simcapurchased-personal-info": "個人情報",
            "email-product-simcard-delivery-title": "ご注文のSIM{order}-numは{date}に準備および発送されました。 SF Expressを選択した場合は、後で追跡番号を提供します。モバイルアプリでも確認できます。",
            "email-product-simcard-delivery-title-carbon-format": "j M Y",
            "email-product-simcard-delivery-update-greeting": "親愛なるお客様、<br><br>HyperAirをご利用いただきありがとうございます。 SIMカードの注文は間もなく始まります。",
            "email-product-simcard-delivery-update-title": "SIMカードの注文は間もなく開始されます",
            "email-product-simcard-delivery-update-tracking": "追跡の詳細",
            "email-product-simcard-delivery-update-tracking-no": "追跡番号",
            "email-product-simcard-delivery-update-tracking-no-hkpost": "追跡番号: -",
            "email-product-simcard-delivery-update-tracking-no-sf": "",
            "email-product-simcard-delivery-waiting-update-tracking-no-sf": "SF Expressの更新を待っています",
            "email-product-simcard-delivery-with-tracking-num-title": "ご注文のSIM{order}-numは、追跡番号:{tracking}-numでSF Expressから発送されます。配達の受け取りには携帯電話に注意してください。 SF Express Webサイトで配送状況を確認することもできます。 HyperAirサービスをご利用いただきありがとうございます。",
            "email-product-simcard-esim-code-greeting": "親愛なるお客様、<br><br>HyperAirをご利用いただきありがとうございます。これがeSIMアクティベーションQRコードです。",
            "email-product-simcard-esim-code-important-notice-content": "<span style=\"font-size: 10px; line-height: 12px;\">手順:<br />1.設定<br />に移動します2.「モバイルデータ」をタップします<br />3.データプランで「データプランを追加」をタップします<br />4.カメラでQRコードをスキャンしますフレーム<br />eSIMを有効にするために確認コードの入力を求められた場合、キャリアが提供した番号を入力します。質問があります？ hello@hyperair.comにメールしてください。返信いたします。</span>",
            "email-product-simcard-esim-code-title": "eSIMアクティベーションQRコードはこちら",
            "email-product-simcard-esim-code-warning": "QRコードがスキャンされると、eSIMがアクティブになることにご注意ください。サービスを開始する場合にのみスキャンしてください。",
            "email-product-simcard-purchased-delievery-address": "配送先住所",
            "email-product-simcard-purchased-delivery-info": "配送情報",
            "email-product-simcard-purchased-delivery-method": "配送方法",
            "email-product-simcard-purchased-discount": "ディスカウント",
            "email-product-simcard-purchased-greeting": "親愛なるお客様、<br><br>HyperAirをご利用いただきありがとうございます。 Travel SIMの配信を準備しています。",
            "email-product-simcard-purchased-greeting-esim-only": "親愛なるお客様<br><br>HyperAirをご利用いただきありがとうございます、eSIMの準備ができました！添付のQRコードを見つけて、指示に従ってアクティベートしてください。",
            "email-product-simcard-purchased-greeting-esim-with-sim": "親愛なるお客様、<br><br>HyperAirをご利用いただきありがとうございます。 Travel SIMの配信を準備しています。 eSIMについては、添付のQRコードを見つけて、指示に従ってアクティベートしてください。",
            "email-product-simcard-purchased-greeting-sim-only": "親愛なるお客様、<br><br>HyperAirをご利用いただきありがとうございます。 Travel SIMの配信を準備しています。",
            "email-product-simcard-purchased-have-a-nice-trip": "良い旅を！",
            "email-product-simcard-purchased-important-notice": "重要なお知らせ",
            "email-product-simcard-purchased-important-notice-content": "<span style=\"font-size: 10px; line-height: 12px;\">1. Hong Kong Postのローカルメールでは、配達予定日は5営業日以内になります。地元の郵便ではステータス追跡は利用できません。お客様は、香港 </span><br> <span style=\"font-size: 10px; line-height: 12px;\">を使用してアイテムを紛失する責任を全額負担するものとします。</span><br> <span style=\"font-size: 10px; line-height: 12px;\">3.提供されるすべての製品は、契約条件の対象となります。</span><br><br> <span style=\"font-size: 10px; line-height: 12px;\">質問がありますか？ hello@hyperair.comにメールしてください。返信いたします。</span>",
            "email-product-simcard-purchased-important-notice-content-esim-only": "<span style=\"font-size: 10px; line-height: 12px;\">1. Hong Kong Postのローカルメールでは、配達予定日は5営業日以内になります。地元の郵便ではステータス追跡は利用できません。お客様は、香港 </span><br> <span style=\"font-size: 10px; line-height: 12px;\">を使用して商品を紛失した場合の全責任を負います。2.有効期限前にトラベルSIMカードを有効にしてください。</span><br> <span style=\"font-size: 10px; line-height: 12px;\">3.納入されたすべての製品は利用規約の対象となります。</span><br><br> <span style=\"font-size: 10px; line-height: 12px;\">質問がありますか？ hello@hyperair.comにメールしてください。返信いたします。</span>",
            "email-product-simcard-purchased-important-notice-content-esim-with-sim": "<span style=\"font-size: 10px; line-height: 12px;\">1. Hong Kong Postのローカルメールでは、配達予定日は5営業日以内になります。地元の郵便ではステータス追跡は利用できません。お客様は、香港 </span><br> <span style=\"font-size: 10px; line-height: 12px;\">を使用して商品を紛失した場合の全責任を負います。2.有効期限前にトラベルSIMカードを有効にしてください。</span><br> <span style=\"font-size: 10px; line-height: 12px;\">3.納入されたすべての製品は利用規約の対象となります。</span><br><br> <span style=\"font-size: 10px; line-height: 12px;\">質問がありますか？ hello@hyperair.comにメールしてください。返信いたします。</span>",
            "email-product-simcard-purchased-important-notice-content-sim-only": "<span style=\"font-size: 10px; line-height: 12px;\">1. Hong Kong Postのローカルメールでは、配達予定日は5営業日以内になります。地元の郵便ではステータス追跡は利用できません。お客様は、香港 </span><br> <span style=\"font-size: 10px; line-height: 12px;\">を使用して商品を紛失した場合の全責任を負います。2.有効期限前にトラベルSIMカードを有効にしてください。</span><br> <span style=\"font-size: 10px; line-height: 12px;\">3.納入されたすべての製品は利用規約の対象となります。</span><br><br> <span style=\"font-size: 10px; line-height: 12px;\">質問がありますか？ hello@hyperair.comにメールしてください。返信いたします。</span>",
            "email-product-simcard-purchased-order-date": "注文日",
            "email-product-simcard-purchased-order-details": "注文詳細",
            "email-product-simcard-purchased-order-no": "注文番号",
            "email-product-simcard-purchased-personal-info": "個人情報",
            "email-product-simcard-purchased-receipient-name": "受信者の名前",
            "email-product-simcard-purchased-receipient-phone-no": "受信者の電話番号",
            "email-product-simcard-purchased-shipping-fee": "送料",
            "email-product-simcard-purchased-sub-total": "小計",
            "email-product-simcard-purchased-title": "Travel SIMの注文が確認されました。",
            "email-product-simcard-purchased-title-esim-only": "Travel eSIMの注文が確認されました。",
            "email-product-simcard-purchased-title-esim-with-sim": "Travel SIMの注文が確認されました。",
            "email-product-simcard-purchased-title-sim-only": "Travel SIMの注文が確認されました。",
            "email-product-simcard-purchased-total": "合計",
            "email-product-simcard-tracking-number-updated-greeting": "親愛なるお客様<br><br>HyperAirをご利用いただきありがとうございます。追跡番号が更新されます。",
            "email-product-simcard-tracking-number-updated-title": "注文追跡ステータスが更新されます",
            "email-product-simcard-tracking-number-updated-tracking-no-sf": "追跡番号",
            "email-product-type-confirmed-greeting": "",
            "email-product-type-confirmed-title": "",
            "email-product-type-purchased-greeting": "",
            "email-product-type-purchased-title": "",
            "email-rate": "レート",
            "email-shop-name": "店名",
            "email-verification-action": "メールを確認",
            "email-verification-content": "HyperAirへようこそ！サインアップを完了するには、メールが正しいことを確認する必要があります。",
            "email-verification-title": "メールを確認して下さい",
            "email-verified-content": "メールが確認されました。 HyperAirにご参加いただきありがとうございます。",
            "email-verified-title": "確認済みのEメール",
            "engagement-content": "welcome10を使用する",
            "engagement-title": "welcome10を使用する",
            "exchange-approved-content": "購入の確認:金額:通貨:レート:レート。",
            "exchange-approved-content2": "レート{rate}での販売の確認{amount}{currency}。",
            "exchange-approved-footer": "",
            "exchange-approved-title": "ショップは、「あなたの旅費は受け取り可能です！」と答えました。",
            "exchange-cancelled-content": "クライアントは、レート{rate}で購入{amount}{currency}の注文を呼び出すことができます。",
            "exchange-cancelled-content2": "クライアントがレート{rate}で販売{amount}{currency}の注文をキャンセルしました。",
            "exchange-cancelled-title": "交換注文がキャンセルされました",
            "exchange-completed-content": "購入完了:金額:レート:レートでの通貨。",
            "exchange-completed-content2": "レート{rate}で販売:量:通貨",
            "exchange-completed-footer": "",
            "exchange-completed-title": "旅行の両替が完了しました！",
            "exchange-confirmed-content": "クライアントがレート{rate}で{amount}{currency}を購入することを確認しました。",
            "exchange-confirmed-content2": "レート{rate}で{amount}{currency}を販売するクライアントを確認しました。",
            "exchange-confirmed-footer": "",
            "exchange-confirmed-title": "新しい交換注文を受け取りました",
            "exchange-pending-content": "購入する新しい注文を確認します:金額:レート:レートで通貨。",
            "exchange-pending-content2": "販売の保留中の注文:金額:通貨、レート{rate}。",
            "exchange-pending-title": "保留中の新しい注文の承認",
            "exchange-rejected-content": "レート{rate}で購入{amount}{currency}で注文することはできません。別のショップでもう一度予約してください。",
            "exchange-rejected-content2": "レート{rate}で販売{amount}{currency}を注文することはできません。別のショップでもう一度予約してください。",
            "exchange-rejected-title": "おっと！申し訳ありませんが、ショップではご注文をお受けできません。",
            "footer-trouble-link": "「{actionText}」ボタンをクリックできない場合は、以下のURLをコピーしてWebブラウザーに貼り付けてください: <a href=\"{actionUrl}\">{actionUrl}</a>",
            "password-reset-action": "パスワードを再設定する",
            "password-reset-content": "アカウントのパスワード���セットリクエストを受け取ったため、このメールを受信しています。",
            "password-reset-footer": "パスワードのリセットを要求しなかった場合、それ以上のアクションは不要です。",
            "password-reset-title": "パスワードのリセット",
            "simcard-purchased-title": "",
            "sms-verification-content": "HyperAirコードは{verificationCode}です"
        },
        "error": {
            "all-shops-are-closed": "おっと、すべてのショップは現在閉鎖されています。後でもう一度やり直してください。",
            "cancel-booking-failed": "この注文は完了、期限切れ、またはキャンセルされる場合があります。 [マイ予約>完了]または[マイ予約>未完了]でこの注文を確認してください。",
            "cancel-booking-failed-title": "この注文をキャンセルできません",
            "invalid-api-app-version": "今すぐAPPを更新して、新しい機能を入手し、プロモーションコード「GIVEME5」でTravel SIM注文の5%割引をお楽しみください!!",
            "invalid-old-password": "既存のパスワードは無効です。",
            "password-incorrect": "間違ったパスワード。",
            "phone-number-is-already-registered": "この電話番号はすでに別のメールアドレスに登録されています。正しいメールアドレスでログインできます。サポートが必要な場合は、hello @ hyperair.comにメールしてください。",
            "this-email-is-registered": "このメールアドレスはすでに別のアカウントで使用されています。",
            "this-phone-number-is-registered": "この電話番号はすでに登録されています。サポートが必要な場合は、hello @ hyperair.comにメールしてください。"
        },
        "marketplace": {
            "homepage-product": "人気商品",
            "homepage-recently-viewed": "最近見た",
            "product-carousels": {
                "group1": "人気の体験",
                "group2": "トップレート"
            }
        }
    },
    "ko": {
        "currency": {
            "aed": "아랍 에미리트 디르함",
            "afn": "아프가니스탄 아프가니",
            "all": "알바니아 렉",
            "amd": "음주 알마니 아어",
            "ang": "네덜란드 령 안틸레스 네델란드의 은화",
            "aoa": "앙골라 콴자",
            "ars": "아르헨티나 페소",
            "aud": "호주 달러",
            "awg": "아루바 플로린",
            "azn": "아제르바이잔 마나 트",
            "bam": "보스니아 헤르체고비나 마카",
            "bbd": "바베이도스 달러",
            "bdt": "방글라데시 타카",
            "bgn": "불가리아 레프",
            "bhd": "바레인 디나르",
            "bif": "부룬디 프랑",
            "bnd": "브루나이 달러",
            "bob": "볼리비아 노",
            "brl": "브라질 리얼",
            "bsd": "바하마 달러",
            "btc": "비트 코인",
            "btn": "부탄 눌 트럼",
            "bwp": "보츠와나 풀라",
            "byn": "새로운 벨라루스어 루블",
            "bzd": "벨리즈 달러",
            "cad": "캐나다 달러",
            "cdf": "콩고 프랑",
            "chf": "스위스 프랑",
            "clp": "칠레 페소",
            "cop": "콜롬비아 페소",
            "crc": "코스타리카 콜론",
            "cup": "쿠바 페소",
            "cve": "케이프 베르데 에스 쿠도",
            "czk": "체코 코 루나",
            "djf": "지부티 프랑",
            "dkk": "덴마크 크로네",
            "dop": "도미니카 페소",
            "dzd": "알제리 디나르",
            "egp": "이집트 파운드",
            "ern": "에리트레아 낙파",
            "etb": "에티오피아 비르",
            "eur": "유로",
            "fjd": "피지 달러",
            "fkp": "포클랜드 제도 파운드",
            "gbp": "파운드 스털링",
            "gel": "그루지야어 라리",
            "ghs": "가나 세디",
            "gip": "지브롤터 파운드",
            "gmd": "감비아 달라",
            "gnf": "기니 프랑",
            "gtq": "과테말라 케 트살",
            "gyd": "가이아나 달러",
            "hkd": "홍콩 달러",
            "hnl": "온두라스 렘 피라",
            "hrk": "크로아티아 쿠나",
            "htg": "티어 구르 드",
            "huf": "헝가리 포린 트",
            "idr": "인도네시아 루피아",
            "ils": "이스라엘의 새 셰켈",
            "inr": "인도 루피",
            "iqd": "이라크 디나르",
            "irr": "이란 리알",
            "isk": "아이슬란드 크로나",
            "jmd": "자메이카 달러",
            "jod": "요르단 디나르",
            "jpy": "일본 엔",
            "kes": "케냐 실링",
            "kgs": "키르기스스탄 솜",
            "khr": "크메르어 리엘",
            "kmf": "코모로 프랑",
            "kpw": "조선 민주주의 인민 공화국 원",
            "krw": "한국 원",
            "kwd": "쿠웨이트 디나르",
            "kyd": "케이맨 제도 달러",
            "kzt": "카자흐스탄 텡게",
            "lak": "라오스 킵",
            "lbp": "레바논 리라",
            "lkr": "스리랑카 루피",
            "lrd": "라이베리아 달러",
            "lsl": "레소토 로티",
            "lvl": "라트비아어 라트",
            "lyd": "리비아 디나르",
            "mad": "모로코 디르함",
            "mdl": "몰도바 레우",
            "mga": "마다가스카르 아리아 리",
            "mkd": "마케도니아 디나르",
            "mmk": "미얀마 차트",
            "mnt": "몽골 투 그릭",
            "mop": "마카오 파타카",
            "mro": "모리타니 우기 야",
            "mur": "모리셔스 루피",
            "mvr": "몰디브 루피 야",
            "mwk": "말레이시아 링기트",
            "mxn": "멕시코 페소",
            "myr": "말레이시아 링기트",
            "mzn": "모잠비크 메티 칼",
            "nad": "나미비아 달러",
            "ngn": "나이지리아 나이라",
            "nio": "니카라과 코르도바",
            "nok": "노르웨이 크로네",
            "npr": "네팔 루피",
            "nzd": "뉴질랜드 달러",
            "omr": "오만 리알",
            "pab": "파나마 발보아",
            "pen": "페루 누에 보솔",
            "pgk": "파푸아 뉴기니 키나",
            "php": "필리핀 페소",
            "pkr": "파키스탄 루피",
            "pln": "폴란드 즈 워티",
            "pyg": "파라과이 과라니",
            "qar": "카타르 리얄",
            "rmb": "인민폐",
            "ron": "루마니아 레우",
            "rsd": "세르비아 디나르",
            "rub": "러시아 루블",
            "rwf": "르완다 프랑",
            "sar": "사우디 리얄",
            "sbd": "솔로몬 제도 달러",
            "scr": "세이셸 루피",
            "sdg": "수단 파운드",
            "sek": "스웨덴 크로나",
            "sgd": "싱가포르 달러",
            "shp": "세인트 헬레나 파운드",
            "sll": "시에라 리온 리온",
            "sos": "소말리아 실링",
            "srd": "수리남 달러",
            "std": "상투 메 프린시 페 도브 라",
            "syp": "시리아 파운드",
            "szl": "스와질란드 릴 란게 니",
            "thb": "태국 바트",
            "tjs": "타지키스탄 소모 니",
            "tmt": "투르크 메니스탄 마나 트",
            "tnd": "튀니지 디나르",
            "top": "Paanga",
            "try": "터키 뉴 리라",
            "ttd": "트리니다 드 토바고 달러",
            "twd": "새 대만 달러 호주 달러",
            "tzs": "탄자니아 실링",
            "uah": "우크라이나 흐 리브 냐",
            "ugx": "우간다 실링",
            "usd": "미국 달러",
            "uyu": "우루과이 페소",
            "uzs": "우즈베키스탄 솜",
            "vef": "베네수엘라 볼리바르",
            "vnd": "베트남 동",
            "vuv": "바누아투 바투",
            "wst": "사모아 탈라",
            "xaf": "중앙 아프리카 CFA 프랑",
            "xcd": "동 카리브 달러",
            "xdr": "특별 인출 권",
            "xof": "서 아프리카 CFA 프랑",
            "xpf": "CFP 프랑",
            "yer": "예멘 리알",
            "zar": "남아프리카 공화국 랜드",
            "zmw": "잠비아 콰차"
        },
        "shop-currency-rate": {
            "rate-last-updated-x-days-ago": "속도 업데이트{time} 일 전",
            "rate-last-updated-x-hours-ago": "속도 업데이트{time} 시간 전"
        },
        "hyperair": {
            "copyright-footer": "Copyright © 2018 HyperAir Incorporation Limited. 판권 소유.",
            "today": "오늘"
        },
        "product-simcard": {
            "shipping-methods": {
                "hkpost": "홍콩 포스트 (무료)",
                "international": "국제 배송",
                "sf": "SF Express (Hong Kong only. Courier fee payable on delivery. Free Shipping for orders over HK$399)"
            }
        },
        "country": {
            "afghanistan": "아프가니스탄",
            "aland-islands": "올란드 제도",
            "albania": "알바니아",
            "algeria": "알제리",
            "andorra": "안도라",
            "angola": "앙골라",
            "anguilla": "앵 gu 라",
            "antigua-&-barbuda": "앤티 가바 부다",
            "antigua-barbuda": "앤티가 바부 다",
            "argentina": "아르헨티나",
            "armenia": "아르메니아",
            "aruba": "아루바",
            "australia": "호주",
            "austria": "오스트리아",
            "azerbaijan": "아제르바이잔",
            "azores": "아 조레스",
            "bahamas": "바하마",
            "bahrain": "바레인",
            "bangladesh": "방글라데시",
            "barbados": "바베이도스",
            "belarus": "벨라루스",
            "belgium": "벨기에",
            "belize": "벨리즈",
            "benin": "베냉",
            "bermuda": "버뮤다",
            "bhutan": "부탄",
            "bolivia": "볼리비아",
            "bonaire": "보네르",
            "bosnia-herzegovina": "보스니아 헤르체고비나",
            "botswana": "보츠와나",
            "brazil": "브라질",
            "british-virgin-islands": "영국령 버진 아일랜드",
            "brunei": "브루나이",
            "bulgaria": "불가리아",
            "burkina-faso": "부키 나 파소",
            "burundi": "부룬디",
            "cambodia": "캄보디아",
            "cameroon": "카메룬",
            "canada": "캐나다",
            "canary-islands": "카나리아 제도",
            "cape-verde-islands": "카보 베르데 제도",
            "cayman-islands": "케이맨 제도",
            "central-african-republic": "중앙 아프리카 공화국",
            "chad": "차드",
            "chile": "칠레",
            "china": "중국",
            "colombia": "콜롬비아",
            "comoros": "코모로",
            "congo": "콩고",
            "cook-islands": "쿡 제도",
            "costa-rica": "코스타리카",
            "cote-d-ivoire": "코트 디부 아르",
            "croatia": "크로아티아",
            "cruise-ship": "유람선",
            "cuba": "쿠바",
            "curacao": "퀴 라소",
            "cyprus": "키프로스",
            "cyprus---north": "키프로스",
            "cyprus---south": "키프로스",
            "czech-republic": "체코 공화국",
            "denmark": "덴마크",
            "djibouti": "지부티",
            "dominica": "도미니카",
            "dominican-republic": "도미니카 공화국",
            "dubai": "Dubai",
            "easter-island": "이스터 섬",
            "ecuador": "에콰도르",
            "egypt": "이집트",
            "el-salvador": "엘살바도르",
            "equatorial-guinea": "적도 기니",
            "eritrea": "에리트레아",
            "estonia": "에스토니아",
            "ethiopia": "에티오피아",
            "europe": "Europe",
            "falkland-islands": "포클랜드 제도",
            "faroe-islands": "페로 제도",
            "fiji": "피지",
            "finland": "핀란드",
            "france": "프랑스",
            "french-guiana": "프랑스 령 기아나",
            "french-polynesia": "프랑스 령 폴리네시아의",
            "french-west-indies": "프랑스 서인도 제도",
            "gabon": "가봉",
            "gambia": "감비아",
            "georgia": "그루지야",
            "germany": "독일",
            "ghana": "가나",
            "gibraltar": "지브롤터",
            "greece": "그리��",
            "greenland": "그린란드",
            "grenada": "그레나다",
            "guadeloupe": "과들루프",
            "guam": "괌",
            "guatemala": "과테말라",
            "guernsey": "건지",
            "guinea": "기니",
            "guinea---bissau": "기니 비사우",
            "guinea-bissau": "기니 비사우",
            "guyana": "가이아나",
            "haiti": "아이티",
            "honduras": "온두라스",
            "hong-kong": "홍콩",
            "hungary": "헝가리",
            "iceland": "아이슬란드",
            "india": "인도",
            "indonesia": "인도네시아 공화국",
            "iran": "이란",
            "iraq": "이라크",
            "ireland": "아일랜드",
            "isle-of-man": "아일 오브 맨",
            "israel": "이스라엘",
            "italy": "이탈리아",
            "jamaica": "자메이카",
            "japan": "일본",
            "jersey": "저지",
            "jordan": "요르단",
            "kazakhstan": "카자흐스탄",
            "kenya": "케냐",
            "kiribati": "키리바시",
            "kosovo": "코소보",
            "kuwait": "쿠웨이트",
            "kyrgyz-republic": "키르기스 공화국",
            "kyrgyzstan": "키르기스스탄",
            "laos": "라오스",
            "latvia": "라트비아",
            "lebanon": "레바논",
            "lesotho": "레소토",
            "liberia": "라이베리아",
            "libya": "리비아",
            "liechtenstein": "리히텐슈타인",
            "lithuania": "리투아니아",
            "luxembourg": "룩셈부르크",
            "macau": "마카오",
            "macedonia": "마케도니아",
            "madagascar": "마다가스카르",
            "madeira": "마데이라",
            "malawi": "말라위",
            "malaysia": "말레이시아",
            "maldives": "몰디브",
            "mali": "말리",
            "malta": "몰타",
            "marshall-islands": "마샬 군도",
            "martinique": "마르티니크",
            "mauritania": "모리타니",
            "mauritius": "모리셔스",
            "mayotte": "마 요트",
            "mexico": "멕시코",
            "micronesia": "미크로네시아",
            "moldova": "몰도바",
            "monaco": "모나코",
            "mongolia": "몽골리아",
            "montenegro": "몬테네그로",
            "montserrat": "몬세 라트",
            "morocco": "모로코",
            "mozambique": "모잠비크",
            "myanmar": "미얀마",
            "namibia": "나미비아",
            "nauru": "나우루",
            "nepal": "네팔",
            "netherlands": "네덜란드",
            "netherlands-antilles": "네덜란드 령 앤 틸리 스",
            "new-caledonia": "뉴 칼레도니아",
            "new-zealand": "뉴질랜드",
            "nicaragua": "니카라과",
            "niger": "니제르",
            "nigeria": "나이지리아",
            "niue": "니우에",
            "norfolk-islands": "노퍽 제도",
            "north-korea": "북한",
            "northern-marianas": "북 마리아나",
            "norway": "노르웨이",
            "oman": "오만",
            "pakistan": "파키스탄",
            "palau": "팔라우",
            "palestine": "팔레스타인",
            "panama": "파나마",
            "papua-new-guinea": "파푸아 뉴기니",
            "paraguay": "파라과이",
            "peru": "페루",
            "philippines": "필리핀 제도",
            "poland": "폴란드",
            "portugal": "포르투갈",
            "puerto-rico": "푸에르토 리코",
            "qatar": "카타르",
            "reunion": "재결합",
            "romania": "루마니아",
            "russia": "러시아 제국",
            "rwanda": "르완다",
            "saint-barthelemy": "셍 바텔 리미",
            "saint-martin": "세인트 마틴",
            "saint-pierre-&-miquelon": "생 피에르 미 클롱",
            "samoa": "사모아",
            "san-marino": "산 마리노",
            "sao-tome-&-principe": "상투 메 프린시 페",
            "sao-tome-principe": "상투 메 프린시 페",
            "satellite": "위성",
            "saudi-arabia": "사우디 아라비아",
            "senegal": "세네갈",
            "serbia": "세르비아",
            "seychelles": "세이셸",
            "sierra-leone": "시에라 리온",
            "singapore": "싱가포르",
            "slovak-republic": "슬로바키아",
            "slovakia": "슬로바키아",
            "slovenia": "슬로베니아",
            "solomon-islands": "솔로몬 제도",
            "somalia": "소말리아",
            "south-africa": "남아프리카",
            "south-korea": "대한민국",
            "spain": "스페인",
            "sri-lanka": "스리랑카",
            "st-helena": "세인트 헬레나",
            "st-kitts": "세인트 키츠",
            "st-kitts-&-nevis": "세인트 키츠 네비스",
            "st-lucia": "세인트 루시아",
            "st-vincent": "세인트 빈센트",
            "st.-helena": "세인트 헬레나",
            "st.-kitts": "세인트 키츠",
            "st.-lucia": "세인트 루시아",
            "sudan": "수단",
            "suriname": "수리남",
            "swaziland": "스와질란드",
            "sweden": "스웨덴",
            "switzerland": "스위스",
            "syria": "시리아",
            "taiwan": "대만",
            "tajikistan": "타지키스탄",
            "tanzania": "탄자니아",
            "thailand": "태국",
            "timor-l'este": "동 티모르",
            "togo": "가다",
            "tonga": "통가",
            "trinidad-&-tobago": "트리니다드 토바고",
            "trinidad-tobago": "트리니다드 토바고",
            "tunisia": "튀니지",
            "turkey": "터키",
            "turkmenistan": "투르크 메니스탄",
            "turks-&-caicos": "터크 스케이 커스",
            "turks-&-caicos-islands": "터크 스케이 커스 제도",
            "turks-caicos-islands": "터크 스케이 커스 제도",
            "uganda": "우간다",
            "ukraine": "우크라이나",
            "united-arab-emirates": "아랍 에미리트",
            "united-kingdom": "영국",
            "united-states": "미국",
            "united-states-minor-outlying-islands": "미국령 군소 제도",
            "uruguay": "우루과이",
            "uzbekistan": "우즈베키스탄",
            "vanuatu": "바누아투",
            "vatican-city": "바티칸 시티",
            "venezuela": "베네수엘라",
            "vietnam": "베트남",
            "virgin-islands": "버진 아일랜드",
            "virgin-islands-(us)": "버진 아일랜드",
            "wallis-&-futuna": "월리스 푸 투나",
            "wallis-futuna": "월리스 푸 투나",
            "yemen": "예멘 아랍 공화국",
            "zambia": "잠비아",
            "zimbabwe": "짐바브웨"
        },
        "inspiration": {
            "published-date": "나의",
            "published-duration": ":기간 전",
            "published-duration-singular": "어제",
            "published-duration-today": "오늘"
        },
        "promotion-center": {
            "expires-at": "",
            "redeem": {
                "error": {
                    "already-redeemed": "쿠폰을 이미 사용하셨습니다.",
                    "new-customer-only": "본 행사는 신규 고객에게만 유효합니다.",
                    "not-found": "잘못된 프로모션 코드"
                }
            }
        },
        "auth": {
            "failed": "이 자격 증명은 우리의 기록과 일치하지 않습니다.",
            "throttle": "로그인 시도가 너무 많습니다. :초 초 후에 다시 시도하십시오."
        },
        "web": {
            "activity": {
                "countdown-title": "",
                "more-button": "More tour and tickets",
                "section-subtitle": "Find the cheapest tour and tickets in Singapore",
                "section-title": "Tour and Tickets"
            },
            "checkout": {
                "use-promo-code": ""
            },
            "checkout-failed": {
                "checkout-failed": ""
            },
            "checkout-success": {
                "checkout-success": "결제 성공",
                "continue-shopping-button": "쇼핑을 계속",
                "done-button": "완료",
                "download-now": "지금 다운로드",
                "order-number": "주문 번호",
                "register-email": "귀하의 이메일",
                "register-password": "비밀번호를 설정하세요",
                "sim-product": "<span class=\"bold\"> : sim </span>을 (를) 성공적으로 구매했습니다. 확인 이메일이 : email로 발송되었습니다.",
                "slogan": "독점적 인 여행 특권을 누리려면 HyperAir 앱을여십시오! 당신은 또한 응용 프로그램에서 실시간 주문 추적을 할 수 있습니다!",
                "slogan-password": "한 걸음 더! 앱에서 HK $ 10 Welcome SIM 카드 쿠폰과 실시간 주문 추적을 즐길 수 있습니다!",
                "trace-order": "",
                "trace-order-password": "",
                "welcome-offer": "한 걸음 더! 앱에서 HK $ 10 Welcome SIM 카드 쿠폰과 실시간 주문 추적을 즐길 수 있습니다!"
            },
            "country": {
                "all": "모든",
                "contact-us-description": "如有 任何 疑問 ， 歡迎 發送 電郵 到<a href=\"mailto:corporate@hyperair.com\\>corporate@hyperair.com</a>查詢",
                "data": "데이터 한도 :",
                "day": "일 :",
                "day-day": "일",
                "esim": "eSIM",
                "esim-section-title": "국가 별 최고의 eSIM",
                "num-of-review": ": 검토 횟수",
                "per-day": "일",
                "phone-call": "전화",
                "plug-n-go": "",
                "plug-n-go-esim": "즉시 구매 및 사용",
                "plug-n-go-sim": "플러그 앤 사용",
                "section-title": ": 국가를위한 최고의 SIM 카드",
                "section-title copy": ": 국가를위한 최고의 SIM 카드",
                "sim": "SIM",
                "supplier": "공급자:"
            },
            "download-app-banner": {
                "download-now": "지금 앱 다운로드",
                "hyperair": "하이퍼 에어",
                "subtitle": "HK $ 10 환영 행사를 즐기려면 HyperAir 앱을 다운로드하여 등록하십시오!",
                "title": "똑똑한 여행. 어딘가에."
            },
            "email-subscription": {
                "cancel-button": "再諗一諗",
                "completed-subscribe": "Thank you for subscribing!",
                "confirm-button": "我要最抵優惠",
                "duplicate-email": "你的電郵已經訂閱了",
                "invalid-email": "Invalid email address",
                "title-1": "想Staycation價格跌至新低時通知你？",
                "title-2": "仲搜羅全城最抵既Staycation 及美食套餐優惠"
            },
            "fanfare": {
                "cover-title": "SIM 카드 제공",
                "datetime-format": "J M",
                "end-next-fanfare": "다가오는 SIM 카드 제공 :",
                "end-title": "다음 SIM의 상품에 대한 우리의 앱 및 소셜 미디어에 계속 지켜봐 주시기 바랍니다",
                "end-title2": "다음 SIM 카드 제공에 대한 우리의 APP 및 소셜 미디어 플랫폼으로 지켜봐",
                "more-details-button": "자세한 내용은",
                "out-of-stock": "매진",
                "popular-countries-subtitle": "무료 표면 메일, 빠른 배달",
                "popular-countries-title": "인기 SIM 카드",
                "section-title": "SIM 카드 슈퍼 할인 된 가격으로",
                "title": "제한 시간 | 제한 카드",
                "x-inventory-left": "마지막 {inventory}"
            },
            "fanfare-breadcrumb": "SIM 카드 제공",
            "filter-button": {
                "filter": "필터"
            },
            "filter-container": {
                "apply": "",
                "category": "범주",
                "category-aquarium": "수족관",
                "category-class": "수업",
                "category-day-tour": "데이 투어",
                "category-discount": "할인",
                "category-diving": "다이빙",
                "category-food": "음식",
                "category-massage-beauty": "마사지와 뷰티",
                "category-museum": "박물관",
                "category-musical": "뮤지컬",
                "category-outlet": "콘센트",
                "category-photography": "사진술",
                "category-playground": "운동장",
                "category-railway": "철도",
                "category-show": "보여 주다",
                "category-ski": "스키",
                "category-spa": "온천",
                "category-theme-park": "테마 파크",
                "category-ticket": "티켓",
                "category-transport": "수송",
                "category-transport-ticket": "교통 티켓",
                "category-vr": "VR",
                "category-water-park": "워터 파크",
                "category-yoga": "요가",
                "category-zoo": "동물원",
                "clear-all": "초기화",
                "facilities": "Services & facilities",
                "filter": "필터",
                "food": "Food",
                "header": "필터",
                "popular-search": "Popular Search🔥",
                "price": "가격",
                "provider": "여행 사이트",
                "subcategory-buffet": "뷔페",
                "subcategory-car": "차",
                "subcategory-facial": "얼굴 마사지",
                "subcategory-food": "음식",
                "subcategory-half-day-tour": "반나절 투어",
                "subcategory-massage": "마사지",
                "subcategory-meal-voucher": "식사 바우처",
                "subcategory-one-day-tour": "일일 투어",
                "subcategory-restaurant": "레스토랑",
                "subcategory-transport": "교통",
                "tag": "Tag"
            },
            "footer": {
                "about-hyperair-description": "HyperAir는 취향에 맞는 지능적인 여행 플랫폼으로, 가장 적합하고 저렴한 여행 솔루션을 제공하므로 어디에서나 스마트하게 여행 할 수 있습니다.",
                "download-now": "지금 다운로드",
                "email-subscription-button": "Subscribe",
                "email-subscription-placeholder": "Enter your email",
                "email-subscription-social-title": "or Follow our Facebook and Instagram",
                "email-subscription-title": "Subscribe to get the latest staycation discount",
                "travel-license": "Travel Agent Licence Number："
            },
            "fx-booking": {
                "back-button": "",
                "confirm-booking": "",
                "confirm-button": "",
                "contact-shop": "",
                "get-money-before": ""
            },
            "home": {
                "cover-button": "지금 경험하십시오",
                "cover-subtitle": "새로운 하이퍼 에어의 세계를 열어보세요",
                "cover-title": "똑똑한 여행. 어딘가에.",
                "grid": {
                    "1": {
                        "subtitle": "최신 영감",
                        "title": "터키 교회의 고양이 주민"
                    },
                    "2": {
                        "subtitle": "최신 영감",
                        "title": "도쿄 올림픽 2020 1 년 이동"
                    },
                    "3": {
                        "subtitle": "인기 추천",
                        "title": "온라인 최고의 가격 보장"
                    },
                    "4": {
                        "subtitle": "ข้อเสนอเวลา จำกัด",
                        "title": "ซิมการ์ดประโคม"
                    },
                    "5": {
                        "subtitle": "인기 목적지",
                        "title": "디즈니 랜드 갤럭시 엣지 엿보기"
                    }
                },
                "home-example": {
                    "column-subtitle-1": "예를 들어 2 일 7 일 동안 일본으로 여행하는 경우 :",
                    "column-subtitle-2": "가격 비교",
                    "column-title-1": "한 번의 여행으로 저축을 극대화하십시오",
                    "column-title-2": "11 개의 온라인 여행사 비교",
                    "hotel": "호텔 리워드",
                    "hotel-package-1": "호텔 닛코 오사카 x6 박",
                    "insurance": "여행 보험",
                    "insurance-package-1": "7 일 여행 보험 x2",
                    "money": "여행 보험",
                    "money-package-1": "교환 JPD 410,000 엔",
                    "save": "저장",
                    "sim": "여행 SIM",
                    "sim-package-1": "일본 7 일 DoCoMo SIM x2",
                    "slogan": "예약하기 전에 비교하고 다음 여행 비용을 절약하십시오!",
                    "total-saving": "총 절감액 $ 1,443",
                    "travel-experience": "여행 경험",
                    "travel-experience-package-1": "전일본 JR 패스 2 개",
                    "travel-experience-package-2": "유니버설 스튜디오 재팬 ™ 1 일 e 티켓 2 배"
                },
                "media-header-title": "Press",
                "more": "더 많은 여행 SIM",
                "partners-title": "Partnership",
                "photo-banner-button": "더 알아보기",
                "photo-banner-title": "똑똑한 교환 여행 돈",
                "services-header-description": "",
                "services-header-title": "원 스톱 여행 서비스",
                "services-icon-subtitle-1": "여행 돈을 더 똑똑하게 도와주세요!",
                "services-icon-subtitle-2": "무료 배송으로 최고의 SIM 카드를 제공하십시오!",
                "services-icon-subtitle-3": "맞춤형 솔루션으로 세계를 탐험 할 수 있습니다!",
                "services-icon-title-1": "여행 돈",
                "services-icon-title-2": "여행 SIM",
                "services-icon-title-3": "여행 경험",
                "statistic": {
                    "num-of-city": "",
                    "num-of-comparison": "",
                    "num-of-experience": "",
                    "num-of-saving": ""
                },
                "testimonial-1-content": "呢 個 app 很好 用 ， 方便 比較 滙率 ， 唔 駛 周圍 去 揾 資料。 很 欣賞 程式 員 佢 地 既 用心 製 我 解決 使用 時 的 困難。 推薦 使用！",
                "testimonial-1-subtitle": "안드로이드 사용자",
                "testimonial-1-user": "크리스틴 램",
                "testimonial-2-content": "好 方便 ， 訂 SIM 卡 好 快 就 送到 ， 唔洗 特登 出 街 買 SIM 卡 ， 價錢 都 好 平 吓。 網絡 收 得 幾 好, 上次 去 日本 喺 市區 同 近郊 玩 都 好 流暢！ 下次會 再買！",
                "testimonial-2-subtitle": "iOS 사용자",
                "testimonial-2-user": "천사",
                "testimonial-header-description": "",
                "testimonial-header-title": "고객 평가",
                "travel-activities": {
                    "home-slogan": "다른 웹 사이트에서 최고의 여행 경험을 비교하고 찾으십시오"
                },
                "travel-country-header-description": "명확한 분류, 선택하기 쉬운",
                "travel-country-header-title": "200 개국을 여행하는 SIM 여행",
                "travel-info-header-description": "당신에게 뜨거운 여행 영감을 가져다",
                "travel-info-header-title": "여행 영감",
                "travel-marketplace-header-description": "",
                "travel-marketplace-header-title": "",
                "travel-sim-header-description": "무료 SIM 카드 취급 무료",
                "travel-sim-header-title": "인기 여행 SIM"
            },
            "hotel": {
                "cover-subtitle": "5 % 독점 Trip.com 호텔 예약 서비스를 즐길 수",
                "cover-title": "호텔 보상",
                "discount-detail": "5 % 호텔 예약 서비스를 즐길 수있는 프로모션 코드 \"HYPERAIR5을\"적용",
                "discount-title": "HYPERAIR5",
                "highlight-subtitle1": "독특한 숙박을위한 전 세계 호텔보세요.",
                "highlight-subtitle2": "최고의 거래를 확인하고 다음 여행을위한 당신의 돈을 저장합니다.",
                "highlight-subtitle3": "호텔 요금에 언제든지 어디를 확인합니다.",
                "highlight-title1": "글로벌 범위",
                "highlight-title2": "독점 권한",
                "highlight-title3": "원 클릭 예약"
            },
            "hypermiles": {
                "activity": "Activity",
                "balance": "Outstanding Balance",
                "benefit": "Your Privileges",
                "cumulative-purchase": "Accumulated Spending：HK$ {amount}",
                "diamond-black": "Diamond Black",
                "expire": "Expired HyperMiles ({date})",
                "expire-reminder-1": "HyperMiles is valid for one year from the shopping month",
                "expire-reminder-2": "Remember to use HyperMiles before expiry!",
                "hypermiles-total": "HyperMiles",
                "member": "Member",
                "member-tier": "You have become HyperAir {member_tier} member",
                "membership-details": "Membership Tier",
                "next-purchase": "save HK${amount} in your next purchase",
                "order-num": "Order No: {order_num}",
                "permanent-membership": "Permanent Membership",
                "popup-title": "HyperMiles Reward Scheme",
                "precious-platinum": "Precious Platinum",
                "product_purchase": "HyperMiles from gadgets purchase ({date})",
                "record": "HyperMiles Record",
                "royal-blue": "Royal Blue",
                "simcard_purchase": "HyperMiles from SIM purchase ({date})",
                "tier": "",
                "title": "HyperMiles. Explore the World, Enjoy the rebate!",
                "u-have": "Your have",
                "usage": "Redeemed HyperMiles",
                "what-is-hypermiles": "What is HyperMiles",
                "what-is-hypermiles-slogan1": "Spend more. Earn more!",
                "what-is-hypermiles-slogan2": "Every 100 HyperMiles can be used as HK$1 at checkout, no minimum spending limit",
                "what-is-hypermiles-slogan3": "Spend more at HyperAir to enjoy more privileges"
            },
            "hypermiles-disclaimer": "terms and conditions apply",
            "hypermiles-discount-diamond-black": "Spend every HK$1 to enjoy 1 HyperMiles",
            "hypermiles-discount-precious-platinum": "Spend every HK$1.5 to enjoy 1 HyperMiles",
            "hypermiles-discount-royal-blue": "Spend every HK$2 to enjoy 1 HyperMiles",
            "hypermiles-special-diamond-black": "Exclusive pre-sale offer",
            "hypermiles-spend-diamond-black": "Cumulative spending of HK$3,000",
            "hypermiles-spend-precious-platinum": "Cumulative spending of HK$1,500",
            "hypermiles-spend-royal-blue": "Basic Member",
            "login": {
                "email": "",
                "existing-user": "",
                "forgot-password": "",
                "forgot-password-please-fill-in-email": "",
                "login": "",
                "login-with-facebook": "",
                "login-with-google": "",
                "new-user": "",
                "or": "",
                "password": "",
                "phone-input-placeholder": "",
                "phone-input-title": "",
                "phone-verify": "",
                "resend-verification-code": "",
                "reset-password": "",
                "title": "",
                "verification-code-input-title": ""
            },
            "logo-loader": {
                "slogan": "We're almost there"
            },
            "my-order": {
                "amount": "",
                "esim-qrcode": "",
                "fx-status-cancelled": "",
                "fx-status-confirmed": "",
                "order-date": "",
                "order-details": "",
                "order-num": "",
                "status-confirmed": "",
                "status-pending-confirmation": "",
                "status-ready-to-ship": "",
                "status-shipped": ""
            },
            "my-order-details": {
                "delivery-info": "",
                "discount": "",
                "recipient-address": "",
                "recipient-email": "",
                "recipient-name": "",
                "recipient-tel": "",
                "shipping-method": "",
                "status": "",
                "total": "",
                "valid-date": ""
            },
            "nav": {
                "about-us": "회사 소개",
                "car": "",
                "company": "회사",
                "company-address": "Entrepreneurship Centre, Level 3, Cyberport 3, Hong Kong",
                "contact-us": "문의하기",
                "contact-us-description": "문의 사항이 있으면 <a href=\"mailto:hello@hyperair.com\">hello@hyperair.com</a> 으로 이메일을 보내주십시오.",
                "disclaimer": "Disclaimer",
                "download-app": "앱 다운로드",
                "flight": "",
                "foodie": "Foodie",
                "home": "Home",
                "hotel": "호텔",
                "jobs": "신병 모집",
                "logout": "로그 아웃",
                "media-coverage": "Press",
                "monthly-rental-hotel": "Monthly Rental Hotel",
                "privacy-policy": "개인 정보 정책",
                "promo-banner-text": "HyperAir 客戶專享 5% Trip.com 獨家酒店折扣",
                "quarantine-hotel": "Long Stay Hotel",
                "refund-policy": "환불 정책",
                "spa-and-beauty": "Spa and Beauty",
                "staycation": "Staycation",
                "tag-line": "Compare Travel Sites & Save Money",
                "terms-of-service": "서비스 약관",
                "travel-activity": "",
                "travel-affiliate-codes": "쿠폰",
                "travel-affiliate-codes-md": "쿠폰",
                "travel-blog": "Blog",
                "travel-experience-d": "여행 투어 및 경험",
                "travel-experience-md": "여행 투어 및 경험",
                "travel-insurance": "여행 보험",
                "travel-insurance-md": "여행 보험",
                "travel-marketplace": "여행 가제트",
                "travel-marketplace-md": "여행 가제트",
                "travel-money": "여행 돈",
                "travel-money-md": "여행 돈",
                "travel-sim": "여행 SIM",
                "travel-sim-md": "여행 SIM"
            },
            "photo-banner": {
                "banner-button": ""
            },
            "product-card": {
                "num-of-review": "{num}-of-review ratings"
            },
            "redirection-gate": {
                "columns-1-description": "다른 웹 사이트에서 최상의 여행 경험을 비교",
                "columns-1-title": "여행 활동 비교",
                "columns-2-description": "무료 배송 최저의 SIM 카드 거래!",
                "columns-2-title": "여행 SIM",
                "columns-3-description": "비교하고 도시에서 최고의 환율을 예약",
                "columns-3-title": "여행 돈",
                "promo-code": "암호",
                "remember-to-fill-promo-code": "체크 아웃하기 전에 위의 프로모션 코드를 적용하는 것을 잊지 마십시오",
                "title": "We are taking you to {domain}",
                "trouble-link": "If the browser does not redirect you in 10 seconds, please click this <a href=\"{link}\">link</a>."
            },
            "register": {
                "guest-checkout": "",
                "title": ""
            },
            "seo": {
                "best-price-guarantee-title": "Best Price Guarantee",
                "country-description": "{country} Travel SIM-무료 배송으로 최상의 가격 보장",
                "country-keywords": "SIM 卡, 上 網卡, 電話 卡, 數據 卡, DataSIM, 旅遊 DataSIM, 數據 咭, 4G 上 網卡, 上 網卡, 4G 上 網卡, 日本 4G 上 網卡, 日本 上 網卡, 東京 4G 上 網卡, 東京 上 網卡, 大阪 4G上 網卡, 大阪 上 網卡, 泰國 4G 上 網卡, 泰國 上 網卡, 曼谷 4G 上 網卡, 布吉 上 網卡, 芭提雅 4G 上 網卡, 台灣 4G 上 網卡, 台灣 上 網卡, 台北 4G 上 網卡, 高雄 上 網卡,台中 4G 上 網卡, 台中 上 網卡, 韓國 4G 上 網卡, 韓國 上 網卡, 首 爾 4G 上 網���, 首 爾 上 網卡, 中國 4G 上 網卡, 中國 上 網卡, 深圳 4G 上 網卡, 深圳 上 網卡, 澳門 4G 上 網卡,澳門 上 網卡, 도코모, 소프트 뱅크",
                "country-title": "{country} Travel SIM-무료 배송으로 최상의 가격 보장",
                "home-description": "HyperAir는 취향에 맞는 지능적인 여행 플랫폼으로, 가장 적합하고 저렴한 여행 솔루션을 제공하므로 어디에서나 스마트하게 여행 할 수 있습니다.",
                "home-keywords": "sim 卡, 上 網卡, 電話 卡, 數據 卡, DataSIM, 旅遊 DataSIM, 數據 咭, 4G 上 網卡, 上 網卡, 4G 上 網卡, SIM 卡, 여행 SIM, 旅遊 SIM 卡, 唱 錢 神器, 唱 X 神器, 唱 錢X 器, 唱 錢, 唱 錢 앱, 兌換, 找 換, 兌換 店, 找 換 店, 銀行, 金融, 外匯, 外滙, 匯率, 滙率, 匯款, 外幣, 貨幣, 旅行, 旅遊, 行程, 酒店, 機票,比較, 格 價, 特價, 預訂, 交易, 旅遊 保險, 日本, 泰國, 韓國, 台灣, 日圓, 日元, 台幣, 泰銖, HyperAir, HyperAir FX, HyperAir Travel, Travel, Travel Money, 외화, 외화 교환,百年, 堅 成, 發達 鳥, 飛鳥, richbird, crazy bird, 베를린 교환",
                "home-title": "HyperAir-더 똑똑한 여행. 어딘가에. | 최고의 여행 SIM, FX, 여행 보험, 현지 경험",
                "hotel-description": "HyperAir.com를 통해 별도의 호텔 예약 이벤트를 가져옵니다",
                "hotel-keywords": "호텔, 호텔, 할인, 예약, 아시아, 유럽, 미국, 방콕, 싱가포르, 홍콩, 푸켓, 태국, 말레이시아, 발리, 런던, 파리, 로열티 프로그램, acommodation, 숙박, acomodation, 숙박 시설, 휴가 임대료",
                "hotel-title": "호텔 행사",
                "money-exchange-description": "Check {shop_name}'s latest FX rate and book your travel money online. You can lock in FX rate and reserve foreign currency.",
                "money-exchange-keywords": "{shop_name}, 唱錢神器, 唱X神器, 唱錢X器, 唱錢, 兌換, 找換, 兌換店, 找換店, 銀行, 金融, 外匯, 外滙, 匯率, 滙率, 匯款, 外幣, 貨幣, 旅行, 旅遊, 行程, 酒店, 機票, 比較, 格價, 特價, 預訂, 交易, 旅遊保險, 日本, 泰國, 韓國, 台灣, 日圓, 日元, 台幣, 泰銖, HyperAir, HyperAir FX, HyperAir Travel, Travel, Travel Money, Foreign Currency, Foreign Exchange, 百年, 堅成, 發達鳥, 飛鳥, richbird, crazy bird, berlin exchange",
                "money-exchange-title": "{shop_name}'s latest FX rate with instant booking | Lock in FX rate and reserve your travel money instantly",
                "privacy-policy-title": "Privacy Policy",
                "refund-policy-title": "Refund & Return Policy",
                "sim-fanfares-description": "HyperAir 홍콩에서 제 1 심 카드 과시을 시작했다. 당신은 50 % 할인까지로 여행 SIM 카드를 구입할 수 있습니다. 제한 시간, 기간 한정!",
                "sim-fanfares-keywords": "과시,의 simcard, SIM 카드, SIM 卡, 上 網卡, 電話 卡, 數據 卡, DataSIM, 旅遊 DataSIM, 數據 咭, 4G 上 網卡, 上 網卡, 4G 上 網卡, 日本 4G 上 網卡, 日本 上 網卡, 東京 4G 上 網卡, 東京 上 網卡, 大阪 4G 上 網卡, 大阪 上 網卡, 泰國 4G 上 網卡, 泰國 上 網卡, 曼谷 4G 上 網卡, 布吉 上 網卡, 芭提雅 4G 上 網卡, 台灣 4G 上 網卡, 台灣 上 網卡, 台北 4G上 網卡, 高雄 上 網卡, 台中 4G 上 網卡, 台中 上 網卡, 韓國 4G 上 網卡, 韓國 上 網卡, 首 爾 4G 上 網卡, 首 爾 上 網卡, 中國 4G 上 網卡, 中國 上 網卡, 深圳 4G 上 網卡, 深圳 上網卡, 澳門 4G 上 網卡, 澳門 上 網卡, 도코모, 소프트 뱅크",
                "sim-fanfares-title": "SIM 카드 과시 - 제한 시간, 제한 카드",
                "term-of-service-title": "Terms of Service",
                "travel-activity-search-results-description": "",
                "travel-activity-search-results-keywords": "{activity}, travel, local experience, local activity, ticket, activities, day tours, tourist attractions",
                "travel-activity-search-results-title": "HyperAir - Search Result of {q} in {city}",
                "travel-affiliate-codes-description": "HyperAir 지속적 예약 호텔 할인, 항공권 할인, 활동 할인, 여행 보험 할인, SIM 카드 할인과 신용 카드 할인에 대한 최신 할인 코드 / 프로모션 코드를 업데이트합니다.",
                "travel-affiliate-codes-keywords": "할인 코드, 전자 쿠폰, 할인 코드, 프로모션 코드, 프로모션 코드, 할인 코드, 호텔, 항공 티켓, 제공, 신용 카드 제공, 여행 제공",
                "travel-affiliate-codes-title": "2023 최신 여행 할인 코드 (매일 업데이트) | 호텔, 항공편, 활동, 여행 보험, 데이터 SIM 할인 예약",
                "travel-insurance-description": "최고의 여행 보험 계획에 대한 검색? 어떤 계획은 휴대 전화를 커버? AIG, MSIG 및 스타 같은 회사에서 보험을 비교하고, 추가 할인과 온라인 구매!",
                "travel-insurance-keywords": "AIG는 MSIG는 스타는 AIG Promocode, MSIG Promocode, 온라인 스타 Promocode, 여행 보험, 여행 보험, 여행 보험, 저렴한 여행 보험, 여행 보험 홍콩, 하나의 여행, 연간 계획을 비교",
                "travel-insurance-title": "최고의 여행 보험 요금 및 홍콩 2023 년 비교",
                "travel-marketplace-checkout-payme-title": "Pay with PayMe",
                "travel-marketplace-checkout-success-keywords": "創意, 產品, 流行, 電器, 生活, 精品, 智能家居, 設計, 高品質, 設計概念, 創意科技, 生活用品, 戶外休閒, 廚房, 餐桌, 個人護理, 防疫抗疫, 健康, 遊戲, 兒童玩樂, 健身, 家居健身, gym, home gym, smart home, style home",
                "travel-marketplace-checkout-success-title": "{product_name}",
                "travel-marketplace-description": "A collection of coolest gadgets that you'll like",
                "travel-marketplace-keywords": "創意, 產品, 流行, 電器, 生活, 精品, 智能家居, 設計, 高品質, 設計概念, 創意科技, 生活用品, 戶外休閒, 廚房, 餐桌, 個人護理, 防疫抗疫, 健康, 遊戲, 兒童玩樂, 健身, 家居健身, gym, home gym, smart home, style home",
                "travel-marketplace-product-checkout-title": "{product}",
                "travel-marketplace-product-title": "{product}",
                "travel-marketplace-title": "여행 가제트",
                "travel-money-description": "HyperAir는 여행 돈을 얻는 새로운 방법을 제공합니다. 지금 당신은 최고의 도시 환율로 교환을 온라인으로 예약 할 수 있습니다!",
                "travel-money-keywords": "sim 卡, 上 網卡, 電話 卡, 數據 卡, DataSIM, 旅遊 DataSIM, 數據 咭, 4G 上 網卡, 上 網卡, 4G 上 網卡, 唱 錢 神器, 唱 X 神器, 唱 錢 X 器, 唱 錢, 兌換, 找 換, 兌換 店, 找 換 店, 銀行, 金融, 外匯, 外滙, 匯率, 滙率, 匯款, 外幣, 貨幣, 旅行, 旅遊, 行程, 酒店, 機票, 比較, 格 價, 特價, 預訂, 交易, 旅遊 保險,日本, 泰國, 韓國, 台灣, 日圓, 日元, 台幣, 泰銖, HyperAir, HyperAir FX, HyperAir Travel, Travel, Travel Money, Foreign Currency, Foreign Exchange, 百年, 堅 成, 發達 鳥, 飛鳥, richbird, crazy bird 베를린 교환",
                "travel-money-title": "HyperAir-교환 여행 돈 똑똑",
                "travel-product-checkout-keywords": "創意, 產品, 流行, 電器, 生活, 精品, 智能家居, 設計, 高品質, 設計概念, 創意科技, 生活用品, 戶外休閒, 廚房, 餐桌, 個人護理, 防疫抗疫, 健康, 遊戲, 兒童玩樂, 健身, 家居健身, gym, home gym, smart home, style home",
                "travel-product-keywords": "創意, 產品, 流行, 電器, 生活, 精品, 智能家居, 設計, 高品質, 設計概念, 創意科技, 生活用品, 戶外休閒, 廚房, 餐桌, 個人護理, 防疫抗疫, 健康, 遊戲, 兒童玩樂, 健身, 家居健身, gym, home gym, smart home, style home",
                "travel-sim-checkout-description": "{country} Travel SIM-무료 배송이 가능한 고품질 SIM 카드!",
                "travel-sim-checkout-keywords": "上 網卡, 電話 卡, 數據 卡, DataSIM, 旅遊 DataSIM, 數據 咭, 4G 上 網卡, 上 網卡, 4G 上 網卡, 日本 4G 上 網卡, 日本 上 網卡, 東京 4G 上 網卡, 東京 上 網卡, 大阪 4G 上 網卡,大阪 上 網卡, 泰國 4G 上 網卡, 泰國 上 網卡, 曼谷 4G 上 網卡, 布吉 上 網卡, 芭提雅 4G 上 網卡, 台灣 4G 上 網卡, 台灣 上 網卡, 台北 4G 上 網卡, 高雄 上 網卡, 台中 4G 上網卡, 台中 上 網卡, 韓國 4G 上 網卡, 韓國 上 網卡, 首 爾 4G 上 網卡, 首 爾 上 網卡, 中國 4G 上 網卡, 中國 上 網卡, 深圳 4G 上 網卡, 深圳 上 網卡, 澳門 4G 上 網卡, 澳門 上 網卡, 도코모, 소프트 뱅크",
                "travel-sim-checkout-success-description": "{country} Travel SIM-무료 배송이 가능한 고품질 SIM 카드!",
                "travel-sim-checkout-success-keywords": "上 網卡, 電話 卡, 數據 卡, DataSIM, 旅遊 DataSIM, 數據 咭, 4G 上 網卡, 上 網卡, 4G 上 網卡, 日本 4G 上 網卡, 日本 上 網卡, 東京 4G 上 網卡, 東京 上 網卡, 大阪 4G 上 網卡,大阪 上 網卡, 泰國 4G 上 網卡, 泰國 上 網卡, 曼谷 4G 上 網卡, 布吉 上 網卡, 芭提雅 4G 上 網卡, 台灣 4G 上 網卡, 台灣 上 網卡, 台北 4G 上 網卡, 高雄 上 網卡, 台中 4G 上網卡, 台中 上 網卡, 韓國 4G 上 網卡, 韓國 上 網卡, 首 爾 4G 上 網卡, 首 爾 上 網卡, 中國 4G 上 網卡, 中國 上 網卡, 深圳 4G 上 網卡, 深圳 上 網卡, 澳門 4G 上 網卡, 澳門 上 網卡, 도코모, 소프트 뱅크",
                "travel-sim-checkout-success-title": "결제 성공-여행 SIM",
                "travel-sim-checkout-title": "주문 주문-여행 SIM",
                "travel-sim-keywords": "sim 卡, 上 網卡, 電話 卡, 數據 卡, DataSIM, 旅遊 DataSIM, 數據 咭, 4G 上 網卡, 上 網卡, 日本 4G 上 網卡, 日本 上 網卡, 日本 sim 卡, 東京 4G 上 網卡, 東京 上 網卡, 大阪 4G上 網卡, 大阪 上 網卡, 泰國 4G 上 網卡, 泰國 上 網卡, 泰國 sim 卡, 曼谷 4G 上 網卡, 布吉 上 網卡, 芭提雅 4G 上 網卡, 台灣 4G 上 網卡, 台灣 上 網卡, 台灣 sim 卡, 台北4G 上 網卡, 高雄 上 網卡, 台中 4G 上 網卡, 台中 上 網卡, 韓國 sim 卡, 韓國 4G 上 網卡, 韓國 上 網卡, 首 爾 4G 上 網卡, 首 爾 上 網卡, 中國 4G 上 網卡, 中國 上 網卡, 中國 sim卡, 中國 內地 數據 卡, 深圳 4G 上 網卡, 深圳 上 網卡, 澳門 4G 上 網卡, 澳門 上 網卡, 歐洲 4G 上 網卡, 歐洲 上 網卡, 歐洲 sim 卡, 英國 4G 上 網卡, 英國 上 網卡, 英國 sim 卡, 法國 4G 上 網卡, 法國 上 網卡, 法國 sim 卡, 恴 大利 4G 上 網卡, 意大利 上 網卡, 意大利 sim 卡, 巴黎 4G 上 網卡, 巴黎 上 網卡, 巴黎 sim 卡, 瑞士 4G 上 網卡, 瑞士 上 網卡,瑞士 sim 卡, Docomo, Softbank, 和 記, 聯通, 3hk, 3uk, 버디, 自由 鳥, 공기 sim, sim2fly, AIS, ais sim2fly, SK Telecom, TrueMove, dtac, t mobile 全球 上 網卡, vietnamobile",
                "travel-sim-title": "【{country} SIM】{sim_name} - 무료 배송으로 최고의 가격 보장",
                "travel-sims-description": "고품질 SIM 카드와 무료 배송을 제공하는 글로벌 여행 SIM 검색 엔진!",
                "travel-sims-keywords": "sim 卡, 上 網卡, 電話 卡, 數據 卡, DataSIM, 旅遊 DataSIM, 數據 咭, 4G 上 網卡, 4Gsim 卡, 日本 4G 上 網卡, 日本 上 網卡, 日本 sim 卡, 東京 4G 上 網卡, 東京 上 網卡, 大阪 4G上 網卡, 大阪 上 網卡, 泰國 4G 上 網卡, 泰國 上 網卡, 泰國 sim 卡, 曼谷 4G 上 網卡, 布吉 上 網卡, 芭提雅 4G 上 網卡, 台灣 4G 上 網卡, 台灣 上 網卡, 台灣 sim 卡, 台北4G 上 網卡, 高雄 上 網卡, 台中 4G 上 網卡, 台中 上 網卡, 韓國 sim 卡, 韓國 4G 上 網卡, 韓國 上 網卡, 首 爾 4G 上 網卡, 首 爾 上 網卡, 中國 4G 上 網卡, 中國 上 網卡, 中國 sim卡, 中國 內地 數據 卡, 深圳 4G 上 網卡, 深圳 上 網卡, 澳門 4G 上 網卡, 澳門 上 網卡, 澳門 sim 卡, 歐洲 sim 卡, Docomo, Softbank, sim2fly, AIS, ais sim2fly, SK Telecom, TrueMove, dtac , t 모바일 全球 上 網卡, vietnamobile",
                "travel-sims-title": "여행 SIM-무료 배송으로 최고의 가격 보장"
            },
            "shop-confirmation": {
                "app-download": "",
                "app-download-subtitle": "",
                "instruction": "",
                "my-order": "",
                "pending-confirm": ""
            },
            "staycation": {
                "activity-countdown-button": "Find the cheapest price",
                "all-hotels": {
                    "sorting": {
                        "recommended": "Recommended"
                    }
                },
                "all-hotels-all-button": "All",
                "all-hotels-hotel-name": "Hotel Name",
                "all-hotels-last-updated": "Last Updated",
                "all-hotels-less-button": "Less",
                "all-hotels-more-button": "More",
                "all-hotels-no-result": "Sorry, we couldn't find any results",
                "all-hotels-title": "",
                "compare-packages": "Compare other packages",
                "countdown-button": "More Details",
                "countdown-title": "",
                "countdown2-title": "HyperAir Recommended",
                "countdown3-title": "最新 Staycation 酒店限時優惠",
                "month-format": "MMM",
                "order-d-title": "浪漫精品酒店 💕💕",
                "order-g-subtitle": "暑假帶埋一家大細Relax下",
                "order-g-title": "親子Staycation必去之選👨‍👩‍👧‍👦😍",
                "order-h-title": "郵輪之旅🛳️",
                "order-i-title": "情侶煮飯仔酒店 🍽️",
                "order-j-title": "Glamping豪華露營推介",
                "seo-description": "點解咁多人用 HyperAir 搵 Staycation? 因為集合左 KKday, Trip.com, Klook 及各大香港酒店平台，一眼比較邊到有late checkout、免費泊車、自助早午晚餐及餐飲回贈等獨家 Staycation 優惠，每日更新。",
                "seo-keywords": "staycation, staycation 優惠, 香港 staycation, staycation 香港, staycation hk, staycation package, staycation hong kong, 酒店, 酒店 優惠, staycation 中文, 香港 酒店, klook 優惠, klook 優惠, kkday 優惠, trip 優惠, agoda 優惠, runhotel staycation, 酒店 套票, staycation 酒店, 香港 酒店 套票, 訂 酒店 優惠, 酒店 package, 特價 酒店, 香港 優惠 酒店, 酒店 優惠 套 票, 特價 酒店 香港, 香港 酒店 優惠, 酒店 住宿 優惠, staycation 2020, staycation 2021, staycation 2022, staycation 1月 優惠, staycation 2月 優惠, staycation 3月 優惠, staycation 4月 優惠, staycation 5月 優惠, staycation 6月 優惠, staycation 7月 優惠, staycation 8月 優惠, staycation 9月 優惠, staycation 10月 優惠, staycation 11月 優惠, staycation 12月 優惠, 四季酒店, W酒店, Murray, JW Marriott, St. Regis, Conrad Hotel, Grand Hyatt, Ritz Carlton, Rosewood, 露台 酒店, 廚房 酒店, 親子 酒店, 情侶 酒店",
                "seo-title": "【2021年9月最新】香港酒店 Staycation 優惠搜尋神器 全港最齊．每日更新 - 最齊香港staycation優惠、酒店優惠、Hong Kong Staycation Ideas、Klook優惠、KKday優惠、Trip優惠、Agoda優惠、專業旅運優惠 - HyperAir 玩樂必備搜尋比較平台！一次過，比較全球多個玩樂旅遊預訂網站！ - HyperAir",
                "share-button-alert": "Copied the Link",
                "subtitle": "每日更新酒店餐飲及住宿優惠（{start_month}月至{end_month}月）",
                "title": "",
                "top10-title": "",
                "top102-title": "",
                "top103-title": "值得一試的 Staycation 酒店🥂"
            },
            "travel-activities": {
                "best-deals": "Best Deal",
                "book-now": "View Deal",
                "disclaimer": "표시된 가격은 참조 용입니다. 불일치하는 경우 파트너 웹 사이트를 참조하십시오.",
                "empty-destination": "",
                "more-deals": "More Deals",
                "not-available": "Not Available",
                "offers": "",
                "provider-getyourguide": "GetYourGuide",
                "provider-hk": {
                    "trip": {
                        "com": "Trip.com"
                    }
                },
                "provider-hyperair": "HyperAir",
                "provider-kkday": "KKday",
                "provider-klook": "KLOOK",
                "provider-seoultravelpass": "SeoulPass",
                "provider-sim": {
                    "hyperair": {
                        "com": "HyperAir"
                    }
                },
                "provider-travelexpert": "Travel Expert",
                "provider-trip": "Trip.com",
                "ratings": "평가",
                "recommended-title": "{city}의 더 인기있는 활동",
                "search-africa-oceania": "아프리카 / 오세아니아",
                "search-all-cities": "모든 도시",
                "search-america": "미국",
                "search-asia": "아시아",
                "search-button": "검색",
                "search-cancel-button": "취소",
                "search-country-placeholder": "국가 또는 도시를 입력하십시오",
                "search-euro-middleeast": "유럽 ​​/ 중동",
                "search-hardcoded-cities": "인기 검색 :",
                "search-placeholder": "\"JR 패스\"검색",
                "search-popular-cities": "인기 도시",
                "search-searched-cities": "검색된 도시",
                "search-slogan-2": "",
                "show-similar-product": "비슷한 비교",
                "sorting": {
                    "price-asc": "가격 (낮은 순)",
                    "price-desc": "가격 (높은 순)",
                    "rating": "평가",
                    "relevance": "관련성",
                    "sort-by": "정렬"
                },
                "title": "\"{q}\"와 일치하는 검색 결과",
                "title-everything": "{city} 시티의 인기 액티비티",
                "title-no-result": "죄송합니다. \"{q}\"에 대한 결과를 찾을 수 없습니다",
                "title-no-result-without-keyword": "죄송합니다, 우리는 어떤 결과를 찾을 수 없습니다",
                "total-results": "총 <b>{number}</ b> 결과"
            },
            "travel-affiliate-codes": {
                "cover-slogan": "해외 여행 예약 사이트에 대한 할인 코드를 제공합니다",
                "cover-title": "여행 할인 쿠폰",
                "disclaimer": "표시된 프로모션 이벤트는 참조 용입니다. 불일치의 경우, 파트너의 웹 사이트를 참조하십시오. 공급 업체 변경하거나 사전 통지없이 정보를 언제든지 삭제하고 제공하여 재량을 가진다 할 수있다.",
                "exclusive": "독특한",
                "type-activity": "활동",
                "type-air": "항공권",
                "type-all": "모두",
                "type-hotel": "호텔",
                "type-insurance": "여행 보험",
                "type-shopping": "쇼핑",
                "type-sim": "심 카드",
                "use-promo-code": "코드 받기",
                "valid-until": "까지 유효하다:"
            },
            "travel-insurance": {
                "breadcrumb-travel-insurance": "여행 보험",
                "cover-subtitle": "검색 및 휴대 전화 보험과 최고의 여행 보험 비교!",
                "cover-title": "여행 보험",
                "departure-date-alert": "",
                "disclaimer": "견적은 참고 용입니다. 자세한 내용은 보험 회사 웹 사이트를 참조하십시오.",
                "highlight-subtitle1": "당신의 쉬운 선택을위한 여행 보험의 주요 범위 밖으로 목록",
                "highlight-subtitle2": "당신은 모든 달러를 절약 할 수 있도록 최고의 여행 보험 상품 비교!",
                "highlight-subtitle3": "독점적 인 여행 보험 특권과 혜택을 즐기세요!",
                "highlight-title1": "범위 비교",
                "highlight-title2": "비교 가격",
                "highlight-title3": "독점 보상",
                "num-of-travellers-alert": "",
                "partner-title": "우리의 여행 보험 파트너",
                "return-date-alert": "",
                "section-title": "이제 검색 {num_of_day} {num_of_traveller} 여행자 (들)",
                "slogan": "3 단계",
                "sorting": {
                    "coverage": "최저 범위",
                    "price-asc": "가격 (오름차순)",
                    "price-desc": "가격 (내림차순)"
                },
                "step1": "[정보 채우기",
                "step1-detail": "목적지, 날짜와 더를 입력하지 않습니다. 여행자",
                "step2": "계획을 비교",
                "step2-detail": "다른 여행 보험의 가격과 적용 범위를 비교",
                "step3": "쿠폰을 즐길 수",
                "step3-detail": "독점적 인 여행 보험의 혜택을 즐길 수있는 원 클릭"
            },
            "travel-insurance-product-card": {
                "apply-now": "제안을 받기",
                "cancellation": "해제",
                "car-rental": "차량 렌탈 초과",
                "cruise-vacation": "크루즈 휴가 (옵션 혜택)",
                "dangerous-sports": "위험한 스포츠",
                "hyperair-exclusive": "HYPERAIR 배타적",
                "medical": "의료",
                "mobile": "휴대 전화의 손실 / 손상",
                "personal-belongings": "개인 소지품",
                "trip-delay": "트립 지연"
            },
            "travel-insurance-search-bar": {
                "children": "어린이는 18 세 미만",
                "date": "출발 날짜 및 반환 날짜",
                "destination": "어디 가세요",
                "friend": "친구 / 친척",
                "myself": "자기",
                "number-of-traveller": "여행자의 수",
                "search-button": "검색",
                "spouse": "배우자"
            },
            "travel-marketplace": {
                "buy-now-can-earn-x-miles": "",
                "cover-slogan": "당신이 좋아하는거야 멋진 가젯 모음",
                "cover-title": "여행 가제트"
            },
            "travel-marketplace-categories": "Categories",
            "travel-marketplace-checkout": {
                "delivery-message-body": "작업 일 (공휴일 제외) 월요일부터 금요일까지입니다. 주문 마감 시간 12{00}시 (GMT + 8)입니다. 오후 12시 (GMT + 8) 이후에 접수 된 주문은 익일 밖으로 발송합니다.",
                "delivery-method-1": "SF 익스프레스 (홍콩에만 해당)",
                "delivery-method-1-description": "SF 익스프레스, 택배 요금은 HK에게 주문 당 $ 30. 택배 요금은 HK 이상 $ 800 구매시 면제됩니다. 정렬 된 항목은 1 ~ 3 일 이내에 택배로 배달되며, 섬 SF 익스프레스 웹 사이트를 참조, 5 일이 소요됩니다.",
                "delivery-method-2": "국제 배송",
                "delivery-method-2-description": "4 ~ 15 일의 납품 대상에 따라 달라집니다. 수수료 배송은 HK에게 항목 당 $ 100입니다. 위의 국제 배송 요금은 추정에 근거한다. 또한 추가 요금이 부과 될 수 있습니다."
            },
            "travel-money": {
                "breadcrumb-travel-money": "여행 돈",
                "cover-button": "지금 경험하십시오",
                "cover-slogan": "똑똑한 교환 여행 돈",
                "cover-title": "여행 돈",
                "disclaimer": "표시된 가격은 참조 용입니다. 불일치의 경우, 환전상 '웹 사이트를 참조하십시오.",
                "empty-amount": "",
                "fx": "",
                "fx-slogan": "쉬운 4 단계",
                "fx-step1": "수색",
                "fx-step1-detail": "교환하려는 통화를 선택하십시오",
                "fx-step2": "비교",
                "fx-step2-detail": "최고의 요금과 가장 편리한 픽업 장소 찾기",
                "fx-step3": "책",
                "fx-step3-detail": "여행 돈을 온라인으로 예약하십시오",
                "fx-step4": "픽업",
                "fx-step4-detail": "여행 돈을 얻기 위해 QR 코드를 보여",
                "hyperair-feature-1": "똑똑한",
                "hyperair-feature-1-description": "여행 돈을 교환하는 현명한 방법. 이제 몇 번의 클릭만으로 최고의 요금을 확인하고 온라인으로 여행 돈을 예약 할 수 있습니다. 긴 줄에 안녕을 말할 시간!",
                "hyperair-feature-2": "신뢰성",
                "hyperair-feature-2-description": "환전을 할 수있는 확실한 방법입니다. 우리의 모든 파트너는 귀하의 외환을 안전하게 지키기 위해 라이센스 은행과 환전소입니다.",
                "hyperair-feature-3": "어딘가에. 언제든지",
                "hyperair-feature-3-description": "여행 돈을 얻는 새로운 방법. 우리는 해외 발자국을 확장하고 당신에게 가장 똑똑한 여행 경험을 제공하고자합니다.",
                "i-will-get": "내가 얻을 것이다",
                "i-will-pay": "I WILL PAY",
                "join-us": "더 많은 비즈니스 기회",
                "join-us-button": "지금 가입하십시오",
                "join-us-slogan": "우리의 공급자가 되십시오",
                "search-bar-placeholder": "금액을 입력하세요",
                "search-button": "검색",
                "section-title": "",
                "section-title-from-hkd": "에 대한 검색 HKD {amount} {currency}",
                "section-title-to-hkd": "검색 {amount} {currency} HKD에 대한",
                "why-hyperair": "",
                "why-hyperair-description": "HyperAir는 여행 돈을 얻는 새로운 방법을 제공합니다. 지금 당신은 최고의 도시 환율로 교환을 온라인으로 예약 할 수 있습니다!",
                "why-hyperair-title": "왜 우리를 선택 했죠?"
            },
            "travel-product": {
                "buy-now": "지금 주문",
                "product-option": "옵션"
            },
            "travel-sim": {
                "as-low-as": "낮은",
                "book-now": "지금 주문하세요",
                "breadcrumb-homepage": "홈페이지",
                "breadcrumb-mainpage": "메인 페이지",
                "breadcrumb-travel-sim": "여행 SIM",
                "cancellation-policy": "취소 정책",
                "cancellation-policy-content": "구매 후 취소, 환불 또는 변경할 수 없습니다.",
                "download-hyperair-now-description": "QR 코드를 스캔하거나 앱 스토어로 이동하여 HyperAir 앱을 다운로드하십시오.",
                "download-hyperair-now-title": "HyperAir 앱 다운로드",
                "first-step": "1 단계",
                "go-to-shopping-cart-description": "",
                "go-to-shopping-cart-title": "",
                "hardcoded-countries-title": "다른 인기있는 나라 :",
                "highlights": "하이라이트",
                "important-notice": "중요 공지",
                "instructions": "명령",
                "lowest-price-guarantee": "최고의 ���격 보장",
                "no-stock": "매진",
                "num-of-review": ": 검토 횟수 리뷰",
                "popular-countries": "200 개국을 여행하는 SIM 여행",
                "popular-countries-search-button": "다른 국가 검색",
                "product-highlights": "Product Description",
                "product-specification": "제품 사양",
                "related-sims": "관련 국가 SIM",
                "related-sims-search-button": "더 : 컨트리 SIM",
                "review": "리뷰",
                "review-date": ":데이트",
                "review-no-firstname-user": "여행자",
                "scan-product-qr-code": "Code 一掃 QR 코드 購買 此 產品",
                "second-step": "2 단계",
                "sim": " Sim Cards",
                "web-traffic": "구매 한 : 지난 주 이후 구매 횟수와 트래픽이 많은 사용자가 현재이 SIM을보고 있습니다",
                "web-traffic-title": "이 SIM은 뜨거운 판매입니다!"
            },
            "travel-sim-checkout": {
                "-secure-payment-slogan": "",
                "address": "배달 주소",
                "address-column1": "예 : A, 18 층, 월드 센터",
                "address-column2": "예 : 88 여행 도로",
                "address-column3": "예 : 센트럴, 홍콩",
                "back-button": "뒤로",
                "checkout-title-1": "배송 정보",
                "confirm-button": "잇다",
                "country-code": "국가 코드",
                "delivery-message-body": "Working days are from Monday to Friday (except public holidays). The order cut-off time is 12：00 PM (GMT+8). Orders placed after 12：00 PM (GMT+8) will ship out the next working day.\n<br><br>Within the same working day, orders with the same delivery address will be sent together.",
                "delivery-message-header": "배달 통지",
                "delivery-method": "배달 방법",
                "delivery-method-1": "Hong Kong Post (Free)",
                "delivery-method-1-description": "By Hong Kong Post's Local Mail, the estimated delivery will be within 3-6 working days. Status tracking is not available to local mail and customers shall bare the full responsibility of losing items by using Hong Kong Post’s ordinary mail service.\n<br><br>Note: Due to the time required for delivery, customers who are about to travel are recommended to choose SF Express",
                "delivery-method-2": "SF Express (Hong Kong only. Courier fee payable on delivery)",
                "delivery-method-2-description": "By SF Express (courier fee payable on delivery), the ordered items will be delivered by courier within 1-3 working days, and islands will take longer delivery time. The courier fee is about HK$16-$25 by referring to the website of SF Express.\n<br><br>Note: The order over HK$399 will be upgraded to SF Express for FREE",
                "delivery-method-3": "International Shipping",
                "delivery-method-3-description": "Delivered by Hong Kong Post (tracking no. will be provided) within 4 to 15 working days depends on the destination. Shipping cost HK$30.",
                "error-alert-address": "배송지 주소를 입력하십시오.",
                "error-alert-invalid-email": "이메일 형식이 잘못되었습니다.",
                "error-alert-invalid-recipient-first-num": "연락 번호는 2,3,5,6,7,8 또는 9로 시작해야합니다.",
                "error-alert-invalid-recipient-number": "정확한 연락처를 입력하십시오.",
                "error-alert-invalid-user-first-num": "휴대 전화 번호는 5,6,7,8 또는 9로 시작해야합니다.",
                "error-alert-invalid-user-number": "정확한 휴대폰 번호를 입력하십시오.",
                "error-alert-personal-info": "개인 정보를 작성하십시오.",
                "error-alert-recipient-info": "받는 사람 정보를 입력하십시오.",
                "error-invalid-credit-card-info": "잘못된 신용 카드 정보",
                "facebook-login": "페이스 북으로 계속",
                "google-login": "Google 계속",
                "logged-in": "로그인",
                "login": "기존 고객, 빠른 체크 아웃을 즐기기 위해 로그인",
                "login-button": "로그인",
                "login-email": "이메일",
                "login-no-user-exists": "죄송합니다! 로그인 정보를 확인할 수 없습니다. 손님 체크 아웃없이 다시 시도하거나 주문을 완료하십시오.",
                "login-password": "암호",
                "payme": {
                    "error-contacting-payme": "결제 오류, 재 주문을 다시 또는 고객 지원 센터에 문의하시기 바랍니다."
                },
                "payment": {
                    "actual-payment": "The transaction will be settled at HK${actual_payment} and the exchange rate will be based on your credit card issuer.",
                    "choose-payment-method": "결제 방법 선택:",
                    "logistic-information": "배송 정보",
                    "modify-information": "정보 편집",
                    "pay-now": "지금 지불하세요",
                    "payme-instruction-do-not-close": "결제가 완료되기 전에이 페이지를 닫지 마십시오",
                    "payme-instruction-step-1": "1. PayMe 응용 프로그램.",
                    "payme-instruction-step-2": "2. 검사 권한을 부여 지불에 PayCode.",
                    "payme-instruction-step-3": "3. 전체 응용 프로그램에 지불하고 확인을 기다립니다.",
                    "payme-instruction-title": "PayMe로 지불",
                    "payme-title": "PayMe이 PayCode를 스캔",
                    "payment": "지불",
                    "price": "양",
                    "shipping-fee": "배송료",
                    "subtotal": "소계"
                },
                "payment-method": "지불 방법",
                "pending": {
                    "mobile-redirection-text": "당신은 당신의 지불 방법으로 PayMe을 선택하고 완전한 지불에 PayMe 응용 프로그램에 연결됩니다.",
                    "need-to-pay": "지불액",
                    "order-number": "주문 번호",
                    "order-success-please-pay": "PayMe와 지불은 주문 프로세스를 완료하십시오",
                    "paycode-error": "결제 오류, 재 주문을 다시 또는 고객 지원 센터에 문의하시기 바랍니다.",
                    "paycode-expired": "PayMe의 paycode 다시하십시오 재 주문, 만료되었습니다.",
                    "re-order": "재 주문",
                    "title-payme": "PayMe와 지불"
                },
                "recipient-address": "배달 주소",
                "recipient-information": "받는 사람 정보",
                "recipient-name": "받는 사람 이름",
                "recipient-phone-number": "수신자 전화 번호",
                "secure-payment-slogan": "안전한 결제 | 지불은 SSL을 사용하여 암호화되고 안전하게 전송됩니다",
                "simproduct-detail": "주문 정보",
                "simproduct-quantity": "수량",
                "simproduct-redeem": "",
                "simproduct-redeem-hypermiles": "",
                "simproduct-title": "생성물",
                "simproduct-will-redeeming-x-miles": "",
                "simproduct-you-have-x-hypermiles": "",
                "user-email": "이메일 (인보이스를 받으려면)",
                "user-firstname": "이름",
                "user-information": "개인적인 정보",
                "user-lastname": "성",
                "user-phone-number": "휴대 전화 번호",
                "vertical-divider": "또는"
            },
            "travel-sims": {
                "column-title-1": "명확한 분류, 선택하기 쉬운",
                "column-title-2": "편리하고 빠른 온라인 결제",
                "column-title-3": "무료 우편물, 빠른 배송",
                "country-search-no-place-found": "이 목적지에 대한 검색 결과가 없습니다",
                "cover-button": "HyperAir 앱으로 지금 주문하십시오",
                "cover-slogan": "무료 SIM 카드 취급 무료!",
                "cover-title": "여행 SIM",
                "empty-destination": "",
                "num-of-days": "",
                "search-button": "",
                "search-input": "국가 검색",
                "search-placeholder": "국가 검색",
                "search-slogan": "너는 어디 가니?",
                "travel-sim-header-description": "",
                "travel-sim-header-title": ""
            }
        },
        "passwords": {
            "password": "비밀번호는 6 자 이상이어야하며 확인과 일치해야합니다.",
            "reset": "당신의 비밀번호가 초기화되었습니다!",
            "sent": "비밀번호 재설정 링크를 이메일로 보냈습니다!",
            "token": "이 비밀번호 재설정 토큰이 유효하지 않습니다.",
            "user": "해당 이메일 주소를 가진 사용자를 찾을 수 없습니다."
        },
        "mail": {
            "product-simcard": {
                "delivery-update": {
                    "subject": "SIM 카드 주문이 진행 중입니다"
                },
                "purchased": {
                    "subject": "출장 SIM 주문 확인"
                },
                "tracking-number-update": {
                    "subject": "주문 추적 번호가 업데이트되었습니다"
                }
            }
        },
        "member-center": {
            "login-to-receive-codes": "",
            "my-orders-empty": "아니 기록",
            "my-orders-title": "내 주문",
            "profile-area-code": "지역 코드",
            "profile-email": "이메일",
            "profile-firstname": "이름",
            "profile-lastname": "성",
            "profile-save": "저장",
            "profile-tel": "전화",
            "profile-title": "프로필",
            "profile-update-successfully": "",
            "promo-code-enter-promotion-code": "프로모션 코드를 입력",
            "promo-code-my-promo-code": "내 HyperAir 프로모션 코드",
            "promo-code-no-code": "",
            "promo-code-please-fill-in-code": "",
            "promo-code-redeem": "도로 사다",
            "promo-code-redeem-code": "HyperAir 프로모션 코드 사용",
            "promo-code-select": "고르다",
            "promo-code-title": "HyperAir 프로모션 코드",
            "title": "회원 센터"
        },
        "weekday": {
            "1": "월요일",
            "2": "화요일",
            "3": "수요일",
            "4": "목요일",
            "5": "금요일",
            "6": "토요일",
            "7": "일요일"
        },
        "exchange-shop-details": {
            "address": "주소",
            "book-button": "지금 예약",
            "br": "BR",
            "closed-book-button": "닫은",
            "download-pop-up": {
                "slogan-1": "속도에 잠겨",
                "slogan-2": "인스턴트 Comfirmation",
                "title": "FX는 예약 앱을 다운로드"
            },
            "latest-updated": "최신 업데이트",
            "not-available-book-button": "없는",
            "opening-hrs": "개관 시간",
            "phone-num": "전화 번호",
            "rate": "율",
            "reviews": "리뷰",
            "table-buy-rate": "구매 비율",
            "table-compare-button": "비교",
            "table-currency": "통화",
            "table-sell-rate": "판매 비율",
            "table-short-form": "암호",
            "table-title": "다른 통화"
        },
        "credit-card": {
            "cannot-add-card": "신용 카드를 추가하는 중에 문제가 발생했습니다. 정보를 확인한 후 다시 시도하거나 다른 신용 카드를 추가하십시오.",
            "cannot-process": "신용 카드를 충전하는 중에 문제가 발생했습니다. 정보를 확인한 후 다시 시도하십시오. 그렇지 않으면 다른 신용 카드로 결제 할 수 있습니다."
        },
        "shoppingcart": {
            "add": {
                "no-stock": "죄송합니다! 이 제품의 최대 구매 가능 수량에 도달했습니다 ..."
            },
            "pay": {
                "db-locked": "서버가 혼잡합니다. 나중에 다시 시도하세요. (참조 코드 {E1003})",
                "invalid-promotion-code": "잘못된 프로모션 코드",
                "no-stock": "현재 품절 된 제품! (참조 코드 {E1002})"
            },
            "promotion-message": {
                "up-sell-1": "환영 쿠폰으로 HK $ 10 할인",
                "up-sell-2": "HK $ 299 이상 구매시 프로모션 코드 HYPER15로 HK $ 15 할인"
            }
        },
        "product": {
            "label-confirmation-duration-24_hours": "24 시간 확인",
            "label-confirmation-duration-48_hours": "48 시간 확인",
            "label-confirmation-duration-instant": "즉시 확인",
            "label-duration-unit-day": "& nbsp; 일",
            "label-duration-unit-hour": "시간)",
            "label-duration-unit-hr": "& nbsp; 시간",
            "label-duration-unit-min": "& nbsp; 분",
            "label-earliest-available-date": "j 마이 Y",
            "label-earliest-available-date-today": "오늘",
            "label-earliest-available-date-tomorrow": "내일",
            "label-lang-en": "영어",
            "label-lang-jp": "일본어",
            "label-lang-kr": "한국어",
            "label-lang-zh": "중국말",
            "label-meet-up-method-hotel_pickup": "호텔 픽업",
            "label-meet-up-method-location_meet_up": "위치 모임",
            "label-refundable-conditional_cancel": "조건부 취소",
            "label-refundable-no_cancel": "취소 안함",
            "label-ticket-logistic-mobile": "모바일 바우처 허용",
            "label-ticket-logistic-printed": "인쇄 된 바우처 허용",
            "label-ticket-logistic-printed_or_mobile": "인쇄 또는 모바일 바우처 허용",
            "label-ticket-validity-fixed_date": "고정 날짜 티켓",
            "label-ticket-validity-open_date": "오픈 데이트 티켓",
            "label-ticket-validity-open_or_fixed_date": "오픈 / 고정 날짜 티켓"
        },
        "pagination": {
            "next": "다음 & raquo;",
            "previous": "& laquo; 이전"
        },
        "city": {
            "abu-dhabi": "아부 다비",
            "adelaide": "애들레이드",
            "agra": "아그라",
            "ahmedabad": "아마다 바드",
            "alice-springs": "앨리스 스프링스",
            "alsace": "알자스",
            "amritsar": "암리 차르",
            "amsterdam": "암스테르담",
            "andalusia": "안달루시아",
            "antalya": "안탈리아",
            "anuradhapura": "아누라다푸라",
            "athens": "아테네",
            "auckland": "오클랜드",
            "bacolod": "바콜로드",
            "bagan": "바간",
            "baku": "바쿠",
            "bali": "발리",
            "bandung": "반둥",
            "bangalore": "방갈로르",
            "bangkok": "방콕",
            "barcelona": "바르셀로나",
            "batam": "바탐",
            "bath": "목욕",
            "bay-of-islands": "베이 오브 아일랜드",
            "beijing": "베이징",
            "belfast": "벨파스트",
            "bentota": "벤토 타",
            "berlin": "베를린",
            "bohol": "보홀",
            "boracay": "보라카이",
            "bordeaux": "보르도",
            "boston": "보스턴",
            "bratislava": "브라 티 슬라바",
            "brisbane": "브리즈번",
            "bruges": "브뤼헤",
            "brussels": "브뤼셀",
            "budapest": "부다페스트",
            "burgundy": "부르고뉴",
            "busan": "부산",
            "cairns": "케언즈",
            "cambridge": "케임브리지",
            "cameron-highlands": "카메론 하일 랜즈",
            "canary-islands": "카나리아 제도",
            "cape-town": "케이프 타운",
            "cappadocia": "카파도키아",
            "cebu": "세부",
            "champagne": "샴페인",
            "chengdu": "청두",
            "chennai": "첸나이",
            "chiang-mai": "치앙마이",
            "chiang-rai": "치앙 라이",
            "chiayi": "자이",
            "chicago": "시카고",
            "chongqing": "충칭",
            "christchurch": "크라이스트 처치",
            "cochin": "코친",
            "cologne": "쾰른",
            "colombo": "콜롬보",
            "copenhagen": "코펜하겐",
            "costa-del-sol": "코스타 델 솔",
            "crete": "크레타 섬",
            "da-lat": "달랏",
            "da-nang": "다낭",
            "darwin": "다윈",
            "davao": "다바오",
            "delhi": "델리",
            "dhaka": "다카",
            "dresden": "드레스덴",
            "dubai": "두바이",
            "dublin": "더블린",
            "dubrovnik": "두브 로브 니크",
            "dumaguete": "두마 게티",
            "dunedin": "더니든",
            "düsseldorf": "뒤셀도르프",
            "edinburgh": "에든버러",
            "finnish-lapland": "",
            "florence": "피렌체",
            "frankfurt": "프랑크푸르트",
            "fraser-island": "프레이저 섬",
            "french-riviera": "프랑스 리비에라",
            "fukuoka": "후쿠오카",
            "galle": "갈레",
            "galway": "골웨이",
            "gangtok": "강톡",
            "gangwon-do": "강원도",
            "gdansk": "그단스크",
            "geneva": "제네바",
            "genting-highlands": "겐팅 하이랜드",
            "geraldton": "제 럴턴",
            "glasgow": "글래스고",
            "goa": "고아",
            "gold-coast": "골드 코스트",
            "gothenburg": "예테보리",
            "guam": "괌",
            "guangdong": "광동",
            "guilin": "계림",
            "guizhou": "귀주",
            "gyeonggi-do": "경기도",
            "haikou": "해구",
            "hakone": "하코네",
            "halong": "하롱",
            "hamburg": "함부르크",
            "hangzhou": "항저우",
            "hanoi": "하노이",
            "harbin": "하얼빈",
            "hat-yai": "핫야이",
            "hawaii": "하와이",
            "heidelberg": "하이델베르크",
            "helsinki": "헬싱키",
            "himachal-pradesh": "히 마찰 프라데시",
            "hiroshima": "히로시마",
            "ho-chi-minh-city": "호치민",
            "hobart": "호바트",
            "hoi-an": "호 이안",
            "hokkaido": "홋카이도",
            "hong-kong": "홍콩",
            "hua-hin": "후아힌",
            "hualien": "화롄",
            "hue": "색조",
            "hyderabad": "하이데라바드",
            "iloilo": "일로 일로",
            "incheon": "인천",
            "inle-lake": "인레 호수",
            "inner-mongolia": "몽골 내륙 지방",
            "innsbruck": "인스 브루 크",
            "interlaken": "인터라켄",
            "inverness": "인버네스",
            "ipoh": "이포",
            "istanbul": "이스탄불",
            "jaipur": "자이푸르",
            "jaisalmer": "자이살메르",
            "jakarta": "자카르타",
            "jeju": "제주",
            "jerusalem": "예루살렘",
            "jodhpur": "조드 푸르",
            "johor-bahru": "조호 바루",
            "kandy": "캔디",
            "kaohsiung": "가오슝",
            "kathmandu": "카트만두",
            "kazan": "카잔",
            "kenting": "켄팅",
            "kiev": "키에프",
            "kinmen": "킨멘",
            "kobe": "고베",
            "koh-chang": "코창",
            "koh-samui": "코 사무이",
            "krabi": "크라비",
            "krakow": "크라쿠프",
            "kuala-lumpur": "쿠알라 룸푸르",
            "kumamoto": "구마모토",
            "kyoto": "교토",
            "kyushu": "규슈",
            "lake-district": "레이크 디스트릭트",
            "langkawi": "랑카위",
            "lapland": "라플란드",
            "las-vegas": "라스베가스",
            "launceston": "론서 스턴",
            "lausanne": "로잔",
            "leipzig": "라이프 치히",
            "lisbon": "리스본",
            "liverpool": "리버풀",
            "ljubljana": "류블 랴나",
            "loire-valley": "루 아르 계곡",
            "lombok": "롬복",
            "london": "런던",
            "los-angeles": "로스 앤젤레스",
            "luang-prabang": "루앙프라방",
            "lucerne": "루체른",
            "lviv": "리 보프",
            "lyon": "리옹",
            "macao": "마카오",
            "macau": "",
            "madrid": "마드리드",
            "malaga": "말라가",
            "manchester": "맨체스터",
            "mandalay": "만달레이",
            "manila": "마닐라",
            "marrakech": "마라케시",
            "mauritius": "모리셔스",
            "medan": "메단",
            "melaka": "몰라 카",
            "melbourne": "멜버른",
            "miami": "마이애미",
            "milford-sound": "밀포드 사운드",
            "montreux": "몽트뢰",
            "moscow": "모스크바",
            "mumbai": "뭄바이",
            "munich": "뮌헨",
            "muscat": "무스카트 포도",
            "nagano": "나가노",
            "nagoya": "나고야",
            "naples": "나폴리",
            "nelson": "넬슨",
            "new-delhi": "뉴 델리",
            "new-york": "뉴욕",
            "nha-trang": "냐짱",
            "niagara-falls": "나이아가라 폭포",
            "niigata": "니가타",
            "normandy": "노르망디",
            "odessa": "오데사",
            "okayama": "오카야마",
            "okinawa": "오키나와",
            "orlando": "올랜도",
            "osaka": "오사카",
            "oslo": "오슬로",
            "oxford": "옥스퍼드",
            "palawan": "팔라완",
            "paris": "파리",
            "pattaya": "파타야",
            "penang": "페낭",
            "penghu": "펑후",
            "perth": "퍼스",
            "philadelphia": "필라델피아",
            "phnom-penh": "프놈펜",
            "phu-quoc": "푸 쿠옥",
            "phuket": "푸켓",
            "pisa": "피사",
            "pokhara": "포카라",
            "port-lincoln": "포트 링컨",
            "porto": "",
            "porto-district": "포르토 지구",
            "prague": "프라하",
            "provence": "프로방스",
            "puglia": "풀 리아",
            "pune": "푸네",
            "pushkar": "푸쉬카르",
            "queenstown": "퀸즈타운",
            "ras-al-khaimah": "라스 알카 이마",
            "reykjavik": "레이캬비크",
            "rhodes": "로도스",
            "rhône-alpes": "론 알프",
            "rome": "로마",
            "rotorua": "로토루아",
            "rotterdam": "로테르담",
            "sabah": "사바",
            "saint-petersburg": "상트 페테르부르크",
            "saipan": "사이판",
            "salzburg": "잘츠부르크",
            "san-diego": "샌디에고",
            "san-francisco": "샌프란시스코",
            "santorini": "산토리니",
            "sanya": "삼아",
            "sapa": "사파",
            "sarawak": "사라왁",
            "seattle": "시애틀",
            "seoul": "서울",
            "seville": "세비야",
            "shanghai": "상하이",
            "sibiu": "시비 우",
            "sicily": "시실리",
            "siem-reap": "씨엠립",
            "sihanoukville": "시아누크 빌",
            "singapore": "싱가포르",
            "split": "스플릿",
            "surabaya": "수 라바 야",
            "suzhou": "쑤저우",
            "swedish-lapland": "스웨덴 라플란드",
            "sydney": "시드니",
            "taichung": "타이 중",
            "tainan": "타이난",
            "taipei": "타이페이",
            "taitung": "타이 둥",
            "tarragona": "타라고 나",
            "taupo": "타우포",
            "terengganu": "테 렝가 누",
            "thessaloniki": "테살로니키",
            "tokyo": "도쿄",
            "toledo": "톨레도",
            "trincomalee": "트 링코 말리",
            "turin": "토리노",
            "udaipur": "우다이 푸르",
            "uluru": "울룰루",
            "uttarakhand": "우타 라칸 드",
            "varanasi": "바라나시",
            "venice": "베니스",
            "verona": "베로나",
            "vienna": "비엔나",
            "vientiane": "비엔티안",
            "volendam": "볼렌담",
            "washington-dc": "워싱턴 DC",
            "wellington": "웰링턴",
            "whitsundays": "오순절",
            "xiamen": "아모이",
            "xian": "시안",
            "yangon": "양곤",
            "yilan": "이란",
            "yogyakarta": "욕야 카르타",
            "york": "요크",
            "yunnan": "윈난",
            "zagreb": "자그레브",
            "zhangjiajie": "장가계",
            "zurich": "취리히"
        },
        "validation": {
            "accepted": ":속성을 수락해야합니다.",
            "active_url": "{attribute}는 유효한 URL이 아닙니다.",
            "after": "{attribute}는 {date} 이후의 날짜 여야합니다.",
            "after_or_equal": "{attribute}는 {date} 이후의 날짜 여야합니다.",
            "alpha": ":속성에는 문자 만 포함될 수 있습니다.",
            "alpha_dash": ":속성에는 문자, 숫자 및 대시 만 포함될 수 있습니다.",
            "alpha_num": ":속성에는 문자와 숫자 만 포함될 수 있습니다.",
            "array": "{attribute}는 배열이어야합니다.",
            "before": "{attribute}는 {date} 이전의 날짜 여야합니다.",
            "before_or_equal": "{attribute}는 {date} 이전의 날짜 여야합니다.",
            "between": {
                "array": "{attribute}는 {min}과 {max} 사이에 있어야합니다.",
                "file": "{attribute}는 {min}과 {max} kilobyte 사이 여야합니다.",
                "numeric": "{attribute}는 {min}과 {max} 사이에 있어야합니다.",
                "string": "{attribute}는 {min}과 {max} 사이 여야합니다."
            },
            "boolean": "{attribute} 필드는 true 또는 false 여야합니다.",
            "confirmed": ":속성 확인이 일치하지 않습니다.",
            "custom": {
                "attribute-name": {
                    "rule-name": "맞춤 메시지"
                }
            },
            "date": "{attribute}가 유효한 날짜가 아닙니다.",
            "date_format": "{attribute}가 {format} 형식과 일치하지 않습니다.",
            "different": "{attribute}와 {other}는 달라야합니다.",
            "digits": "{attribute}는 {digits} 숫자 여야합니다.",
            "digits_between": "{attribute}는 {min}과 {max} 사이 여야합니다.",
            "dimensions": "{attribute}의 이미지 크기가 잘못되었습니다.",
            "distinct": "{attribute} 필드에는 중복 값이 있습니다.",
            "email": "{attribute}는 유효한 이메일 주소 여야합니다.",
            "exists": "선택한 :속성이 유효하지 않습니다.",
            "file": "{attribute}는 파일이어야합니다.",
            "filled": "",
            "image": "",
            "in": "선택한 :속성이 유효하지 않습니다.",
            "in_array": "",
            "integer": "",
            "ip": "",
            "ipv4": "",
            "ipv6": "",
            "json": "",
            "max": {
                "array": "",
                "file": "",
                "numeric": "",
                "string": ""
            },
            "mimes": "",
            "mimetypes": "",
            "min": {
                "array": "",
                "file": "",
                "numeric": "",
                "string": ""
            },
            "not_in": "선택한 :속성이 유효하지 않습니다.",
            "numeric": "",
            "present": "",
            "regex": "",
            "required": "",
            "required_if": "",
            "required_unless": "",
            "required_with": "",
            "required_with_all": "",
            "required_without": "",
            "required_without_all": "",
            "same": "",
            "size": {
                "array": "",
                "file": "",
                "numeric": "",
                "string": ""
            },
            "string": "",
            "timezone": "",
            "unique": "",
            "uploaded": "",
            "url": ""
        },
        "reset-password": {
            "confirm-new-password": "새 암호를 확인합니다",
            "enter-new-password": "새로운 비밀번호를 입력하세요",
            "please-enter-a-new-password": "귀하의 계정에 대한 새로운 비밀번호를 입력하십시오 :이메일.",
            "submit": "제출",
            "success-content": "성공한! 새 비밀번호로 HyperAir 모바일 앱에 로그인하십시오.",
            "title": "암호를 재설정",
            "validation-display": "비밀번호는 6 자 이상이어야합니다."
        },
        "notification": {
            "activation-e-minus-content": "15 일 카운트 다운! 여행 SIM 환영 쿠폰이 곧 만료됩니다! 다가오는 여행에 쿠폰을 사용할 기회를 놓치지 마십시오!",
            "activation-e-minus-title": "",
            "activation-t-plus-content": "다가오는 여행에 환영 SIM 카드 쿠폰을 사용해야합니다! 똑똑한 여행. 어딘가에.",
            "activation-t-plus-title": "",
            "ask-shop-to-quote-content": "구매 견적 요청 :금액 :통화",
            "ask-shop-to-quote-content2": "판매 견적 요청 :금액 :통화",
            "ask-shop-to-quote-title": "견적 요청",
            "email-booking-details": "예약 세부 사항",
            "email-booking-id": "예약 ID",
            "email-exchange-approved-content": "구매 승인 된 교환 주문 :금액 :통화 요금 {rate}",
            "email-exchange-approved-footer": "HyperAir를 이용해 주셔서 감사합니다.",
            "email-exchange-approved-title": "상점에서 \"여행 돈을받을 준비가되었습니다!\"",
            "email-exchange-completed-content": "구매를위한 교환 주문 완료 :금액 :통화 요금 {rate}",
            "email-exchange-completed-footer": "HyperAir를 이용해 주셔서 감사합니다.",
            "email-exchange-completed-title": "여행 환전이 완료되었습니다!",
            "email-exchange-confirmed-content": "구매 확인 된 교환 주문 :금액 :통화 요금 {rate}",
            "email-exchange-confirmed-footer": "HyperAir를 이용해 주셔서 감사합니다.",
            "email-exchange-confirmed-title": "당신의 여행 돈은 픽업 준비가되었습니다!",
            "email-footer-copy-right": "판권 소유.",
            "email-greetings": "여보세요!",
            "email-i-got": "알았어",
            "email-i-paid": "나는 지불했다",
            "email-i-will-get": "내가 얻을 것이다",
            "email-i-will-pay": "나는 지불 할 것이다",
            "email-pickup-before": "픽업 전",
            "email-product-confirmed-greeting": "소중한 고객 여러분,<br><br>HyperAir를 이용해 주셔서 감사합니다. 바우처가 준비되었습니다.",
            "email-product-confirmed-subject": "주문이 확인되었습니다",
            "email-product-confirmed-title": "주문이 확인되었습니다",
            "email-product-purchased": {
                "shipping": {
                    "international": "국제 배송",
                    "sf": "SF 익스프레스 (홍콩에만 해당)"
                }
            },
            "email-product-purchased-delievery-address": "배달 주소",
            "email-product-purchased-delivery-info": "배송 정보",
            "email-product-purchased-delivery-method": "배달 방법",
            "email-product-purchased-discount": "할인",
            "email-product-purchased-email": "이메일",
            "email-product-purchased-greeting": "소중한 고객 여러분,<br><br> 좋은 선택입니다. 예약 확인에 시간이 걸립니다. 그러나 걱정하지 마십시오. 대부분 12 시간 이내에 주문을 확인할 수 있습니다. HyperAir를 이용해 주셔서 감사합니다!",
            "email-product-purchased-have-a-nice-trip": "좋은 여행 되세요!",
            "email-product-purchased-important-notice": "이용 약관이 적용됩니다.",
            "email-product-purchased-important-notice-content": "이용 약관이 적용됩니다.",
            "email-product-purchased-name": "이름",
            "email-product-purchased-order-date": "주문 날짜",
            "email-product-purchased-order-details": "주문 세부 정보",
            "email-product-purchased-order-no": "주문 번호",
            "email-product-purchased-personal-info": "개인적인 정보",
            "email-product-purchased-receipient-name": "받는 사람 이름",
            "email-product-purchased-receipient-phone-no": "전화 번호.",
            "email-product-purchased-shipping-fee": "배송비",
            "email-product-purchased-sub-total": "소계",
            "email-product-purchased-subject": "주문 확인 대기 중",
            "email-product-purchased-title": "주문이 보류 중입니다",
            "email-product-purchased-total": "합계",
            "email-product-simcapurchased-personal-info": "개인적인 정보",
            "email-product-simcard-delivery-title": "주문 SIM {order}-num이 (가) {date}에 준비되어 배송되었습니다. SF Express를 선택한 경우 나중에 추적 번호를 제공합니다. 모바일 앱에서 확인할 수도 있습니다.",
            "email-product-simcard-delivery-title-carbon-format": "j 마이 Y",
            "email-product-simcard-delivery-update-greeting": "소중한 고객 여러분,<br><br>HyperAir를 이용해 주셔서 감사합니다. SIM 카드 주문이 진행 중입니다.",
            "email-product-simcard-delivery-update-title": "SIM 카드 주문이 진행 중입니다",
            "email-product-simcard-delivery-update-tracking": "추적 세부 사항",
            "email-product-simcard-delivery-update-tracking-no": "추적 번호",
            "email-product-simcard-delivery-update-tracking-no-hkpost": "추적 번호 :-",
            "email-product-simcard-delivery-update-tracking-no-sf": "추적 번호",
            "email-product-simcard-delivery-waiting-update-tracking-no-sf": "SF Express가 업데이트되기를 기다리고 있습니다",
            "email-product-simcard-delivery-with-tracking-num-title": "주문 번호 SIM {order}-num은 SF Express에서 추적 번호 :{tracking}-num과 함께 배송됩니다. 배송 픽업을 위해 휴대 전화에주의하십시오. SF Express 웹 사이트에서 배송 상태를 확인할 수도 있습니다. HyperAir 서비스를 이용해 주셔서 감사합니다.",
            "email-product-simcard-esim-code-greeting": "소중한 고객 여러분,<br><br>HyperAir를 이용해 주셔서 감사합니다. eSIM 활성화 QR 코드는 다음과 같습니다.",
            "email-product-simcard-esim-code-important-notice-content": "<span style=\"font-size{10px}; line-height{12px};\">지침 :<br />1.<br />설정으로 이동합니다. 2. \"모바일 데이터\"<br />을 누릅니다. 3. 데이터 계획에서 \"데이터 계획 추가\"를 누릅니다<br />4. 카메라에서 QR 코드 스캔 프레임<br />eSIM을 활성화하기 위해 확인 코드를 입력하라는 메시지가 표시되면 통신 사업자가 제공 한 번호를 입력하십시오. 질문이있다? hello@hyperair.com으로 이메일을 보내 주시면 연락 드리겠습니다.</span>",
            "email-product-simcard-esim-code-title": "eSIM 활성화 QR 코드는 다음과 같습니다.",
            "email-product-simcard-esim-code-warning": "QR 코드가 스캔되면 eSIM이 활성화됩니다. 서비스를 시작하려는 경우에만 스캔하십시오.",
            "email-product-simcard-purchased-delievery-address": "배달 주소",
            "email-product-simcard-purchased-delivery-info": "배송 정보",
            "email-product-simcard-purchased-delivery-method": "배달 방법",
            "email-product-simcard-purchased-discount": "할인",
            "email-product-simcard-purchased-greeting": "소중한 고객 여러분,<br><br>HyperAir를 이용해 주셔서 감사합니다. 여행 SIM 배송 준비 중입니다.",
            "email-product-simcard-purchased-greeting-esim-only": "소중한 고객 여러분,<br><br>HyperAir를 이용해 주셔서 감사합니다. eSIM이 준비되었습니다! 첨부 된 QR 코드를 찾아 지침에 따라 활성화하십시오.",
            "email-product-simcard-purchased-greeting-esim-with-sim": "소중한 고객 여러분,<br><br>HyperAir를 이용해 주셔서 감사합니다. 여행 SIM 배송 준비 중입니다. eSIM의 경우 첨부 된 QR 코드를 찾아 지침에 따라 활성화하십시오.",
            "email-product-simcard-purchased-greeting-sim-only": "소중한 고객 여러분,<br><br>HyperAir를 이용해 주셔서 감사합니다. 여행 SIM 배송 준비 중입니다.",
            "email-product-simcard-purchased-have-a-nice-trip": "좋은 여행 되세요!",
            "email-product-simcard-purchased-important-notice": "중요 공지",
            "email-product-simcard-purchased-important-notice-content": "<span style=\"font-size{10px}; line-height{12px};\">1. 홍콩 우편의 지역 우편으로 5 일 이내에 예상 배달됩니다. 현지 우편으로는 상태 추적을 사용할 수 없으며 고객은 홍콩 </span><br> <span style=\"font-size{10px}; line-height{12px};\">을 (를) 사용하여 물품을 잃어 버릴 책임이 있습니다. 2. 만료 전에 여행 SIM 카드를 활성화하십시오.</span><br> <span style=\"font-size{10px}; line-height{12px};\">3. 제공되는 모든 제품에는 이용 약관�� 적용됩니다.</span><br><br> <span style=\"font-size{10px}; line-height{12px};\">질문이 있으십니까? hello@hyperair.com으로 이메일을 보내 주시면 연락 드리겠습니다.</span>",
            "email-product-simcard-purchased-important-notice-content-esim-only": "<span style=\"font-size{10px}; line-height{12px};\">1. 홍콩 우편의 지역 우편으로 5 일 이내에 예상 배달됩니다. 현지 우편으로는 상태 추적을 사용할 수 없으며 고객은 홍콩 </span><br> <span style=\"font-size{10px}; line-height{12px};\">을 (를) 사용하여 물품을 잃어 버릴 책임이 있습니다. 2. 만료 전에 여행 SIM 카드를 활성화하십시오.</span><br> <span style=\"font-size{10px}; line-height{12px};\">3. 제공되는 모든 제품에는 이용 약관이 적용됩니다.</span><br><br> <span style=\"font-size{10px}; line-height{12px};\">질문이 있으십니까? hello@hyperair.com으로 이메일을 보내 주시면 연락 드리겠습니다.</span>",
            "email-product-simcard-purchased-important-notice-content-esim-with-sim": "<span style=\"font-size{10px}; line-height{12px};\">1. 홍콩 우편의 지역 우편으로 5 일 이내에 예상 배달됩니다. 현지 우편으로는 상태 추적을 사용할 수 없으며 고객은 홍콩 </span><br> <span style=\"font-size{10px}; line-height{12px};\">을 (를) 사용하여 물품을 잃어 버릴 책임이 있습니다. 2. 만료 전에 여행 SIM 카드를 활성화하십시오.</span><br> <span style=\"font-size{10px}; line-height{12px};\">3. 제공되는 모든 제품에는 이용 약관이 적용됩니다.</span><br><br> <span style=\"font-size{10px}; line-height{12px};\">질문이 있으십니까? hello@hyperair.com으로 이메일을 보내 주시면 연락 드리겠습니다.</span>",
            "email-product-simcard-purchased-important-notice-content-sim-only": "<span style=\"font-size{10px}; line-height{12px};\">1. 홍콩 우편의 지역 우편으로 5 일 이내에 예상 배달됩니다. 현지 우편으로는 상태 추적을 사용할 수 없으며 고객은 홍콩 </span><br> <span style=\"font-size{10px}; line-height{12px};\">을 (를) 사용하여 물품을 잃어 버릴 책임이 있습니다. 2. 만료 전에 여행 SIM 카드를 활성화하십시오.</span><br> <span style=\"font-size{10px}; line-height{12px};\">3. 제공되는 모든 제품에는 이용 약관이 적용됩니다.</span><br><br> <span style=\"font-size{10px}; line-height{12px};\">질문이 있으십니까? hello@hyperair.com으로 이메일을 보내 주시면 연락 드리겠습니다.</span>",
            "email-product-simcard-purchased-order-date": "주문 날짜",
            "email-product-simcard-purchased-order-details": "주문 세부 정보",
            "email-product-simcard-purchased-order-no": "주문 번호",
            "email-product-simcard-purchased-personal-info": "개인적인 정보",
            "email-product-simcard-purchased-receipient-name": "받는 사람 이름",
            "email-product-simcard-purchased-receipient-phone-no": "수신자 전화 번호",
            "email-product-simcard-purchased-shipping-fee": "배송료",
            "email-product-simcard-purchased-sub-total": "소계",
            "email-product-simcard-purchased-title": "여행 SIM 주문이 확인되었습니다.",
            "email-product-simcard-purchased-title-esim-only": "여행 eSIM 주문이 확인되었습니다.",
            "email-product-simcard-purchased-title-esim-with-sim": "여행 SIM 주문이 확인되었습니다.",
            "email-product-simcard-purchased-title-sim-only": "여행 SIM 주문이 확인되었습니다.",
            "email-product-simcard-purchased-total": "합계",
            "email-product-simcard-tracking-number-updated-greeting": "소중한 고객 여러분,<br><br>HyperAir를 이용해 주셔서 감사합니다. 추적 번호가 업데이트되었습니다.",
            "email-product-simcard-tracking-number-updated-title": "주문 추적 상태가 업데이트되었습니다",
            "email-product-simcard-tracking-number-updated-tracking-no-sf": "추적 번호",
            "email-product-type-confirmed-greeting": "",
            "email-product-type-confirmed-title": "",
            "email-product-type-purchased-greeting": "",
            "email-product-type-purchased-title": "",
            "email-rate": "율",
            "email-shop-name": "가게 이름",
            "email-verification-action": "이메일 확인",
            "email-verification-content": "HyperAir에 오신 것을 환영합니다! 가입을 마치려면 이메일이 제대로 도착했는지 확인하면됩니다.",
            "email-verification-title": "이메일을 확인하시기 바랍니다",
            "email-verified-content": "귀하의 이메일이 확인되었습니다. HyperAir에 참여해 주셔서 감사합니다.",
            "email-verified-title": "이메일 확인 됨",
            "engagement-content": "welcome10 사용",
            "engagement-title": "welcome10 사용",
            "exchange-approved-content": "구매 확인 :금액 :통화 요금 {rate}.",
            "exchange-approved-content2": "판매 확인 :금액 :통화 요금 {rate}.",
            "exchange-approved-footer": "",
            "exchange-approved-title": "상점에서 \"여행 돈을받을 준비가되었습니다!\"",
            "exchange-cancelled-content": "클라이언트는 요율 {rate} {amount} {currency}를 구매 주문이라고 할 수 있습니다.",
            "exchange-cancelled-content2": "고객이 {amount} {currency}의 요율 {rate}에 대한 주문을 취소했습니다.",
            "exchange-cancelled-title": "교환 주문 취소",
            "exchange-completed-content": "구매 완료 :금액 :통화 요금 {rate}.",
            "exchange-completed-content2": "판매 :완료 :금액 :통화 요금 {rate}.",
            "exchange-completed-footer": "",
            "exchange-completed-title": "여행 환전이 완료되었습니다!",
            "exchange-confirmed-content": "요율 {rate}로 {amount} {currency}를 구매할 고객을 확인했습니다.",
            "exchange-confirmed-content2": "요율 {rate}로 {amount} {currency}를 판매 할 고객을 확인했습니다.",
            "exchange-confirmed-footer": "",
            "exchange-confirmed-title": "새로운 교환 주문 접수",
            "exchange-pending-content": "요율 :요율로 구매 {amount} {currency}에 대한 새 주문을 검토하십시오.",
            "exchange-pending-content2": "판매 대기중인 주문 :금액 :통화 요금 {rate}.",
            "exchange-pending-title": "새로운 주문 승인 보류",
            "exchange-rejected-content": "{amount} {currency} at rate {rate}의 구매 주문은 할 수 없습니다. 다른 상점으로 다시 예약하십시오.",
            "exchange-rejected-content2": "{amount} {currency} at rate {rate}로 판매 할 수 없습니다. 다른 상점으로 다시 예약하십시오.",
            "exchange-rejected-title": "죄송합니다! 상점에서 주문을 처리 할 수 없습니다.",
            "footer-trouble-link": "\"{actionText}\"버튼을 클릭하는 데 문제가있는 경우 아래 URL을 복사하여 웹 브라우저에 붙여 넣으십시오 :<a href=\"{actionUrl}\">{actionUrl}</a>",
            "password-reset-action": "암호를 재설정",
            "password-reset-content": "귀하의 계정에 대한 비밀번호 재설정 요청이 접수되어이 이메일을 수신하고 있습니다.",
            "password-reset-footer": "비밀번호 재설정을 요청하지 않은 경우 추가 조치가 필요하지 않습니다.",
            "password-reset-title": "비밀번호 초기화",
            "simcard-purchased-title": "",
            "sms-verification-content": "HyperAir 코드는 다음과 같습니다."
        },
        "error": {
            "all-shops-are-closed": "죄송합니다. 모든 상점이 현재 문을 닫았습니다. 나중에 다시 시도하세요.",
            "cancel-booking-failed": "이 주문은 완료, 만료 또는 취소 될 수 있습니다. [나의 예약> 완료] 또는 [나의 예약> 완료되지 않음]에서이 주문을 확인하십시오.",
            "cancel-booking-failed-title": "이 주문을 취소 할 수 없습니다",
            "invalid-api-app-version": "프로모션 코드“GIVEME5”로 여행 SIM 주문시 5 % 할인 혜택을 받으려면 APP를 지금 업데이트하십시오!",
            "invalid-old-password": "기존 비밀번호가 유효하지 않습니다.",
            "password-incorrect": "잘못된 비밀번호.",
            "phone-number-is-already-registered": "이 전화 번호는 이미 다른 이메일 주소로 등록되었습니다. 올바른 이메일 주소로 로그인 할 수 있습니다. 지원이 필요하면 hello@hyperair.com으로 이메일을 보내주십시오.",
            "this-email-is-registered": "이 이메일 주소는 이미 다른 계정에서 사용 중입니다.",
            "this-phone-number-is-registered": "이 전화 번호는 이미 등록되었습니다. 지원이 필요하면 hello@hyperair.com으로 이메일을 보내주십시오."
        },
        "marketplace": {
            "homepage-product": "인기있는 제품",
            "homepage-recently-viewed": "최근에 본",
            "product-carousels": {
                "group1": "여름 체험",
                "group2": "최고 등급"
            }
        }
    },
    "th": {
        "currency": {
            "aed": "Dirham ยูเออี",
            "afn": "Afghani อัฟกานิสถาน",
            "all": "แอลเบเนียเล็ก",
            "amd": "อาร์เมเนียขายเหล้า",
            "ang": "Antillean กิลเดอร์เนเธอร์แลนด์",
            "aoa": "แองโกลากวานซา",
            "ars": "เปโซอาร์เจนตินา",
            "aud": "ดอลลาร์ออสเตรเลีย",
            "awg": "Aruban Florin",
            "azn": "อาเซอร์ไบจันมนัส",
            "bam": "บอสเนียและเฮอร์เซ Marka",
            "bbd": "ดอลลาร์บาร์เบโดส",
            "bdt": "Taka บังคลาเทศ",
            "bgn": "บัลแกเรีย Lev",
            "bhd": "ดีนาร์บาห์เรน",
            "bif": "ฟรังก์บุรุนดี",
            "bnd": "ดอลลาร์บรูไน",
            "bob": "boliviano โบลิเวีย",
            "brl": "เรียลบราซิล",
            "bsd": "ดอลลาร์บาฮามาส",
            "btc": "Bitcoin",
            "btn": "Ngultrum ภูฏาน",
            "bwp": "บอตสวานา Pula",
            "byn": "เบลารุสรูเบิลใหม่",
            "bzd": "ดอลลาร์เบลีซ",
            "cad": "ดอลลาร์แคนาดา",
            "cdf": "ฟรังก์คองโก",
            "chf": "ฟรังก์สวิส",
            "clp": "เงินเปโซของชิลี",
            "cop": "เงินเปโซของโคลอมเบีย",
            "crc": "โคลอนคอสตาริกา",
            "cup": "เงินเปโซของคิวบา",
            "cve": "เอสคูโดเคปเวอร์",
            "czk": "Koruna เช็ก",
            "djf": "ฟรังก์จิบูตี",
            "dkk": "Krone เดนมาร์ก",
            "dop": "เปโซโดมินิกัน",
            "dzd": "ดีนาร์แอลจีเรีย",
            "egp": "ปอนด์อียิปต์",
            "ern": "Eritrean Nakfa",
            "etb": "birr เอธิโอเปีย",
            "eur": "ยูโร",
            "fjd": "ดอลลาร์ฟิจิ",
            "fkp": "ปอนด์หมู่เกาะฟอล์คแลนด์",
            "gbp": "ปอนด์สเตอร์ลิง",
            "gel": "จอร์เจีย Lari",
            "ghs": "Cedi กานา",
            "gip": "ปอนด์ยิบรอลตา",
            "gmd": "Dalasi แกมเบีย",
            "gnf": "ฟรังก์กินี",
            "gtq": "Quetzal กัวเตมาลา",
            "gyd": "ดอลลาร์กายอานา",
            "hkd": "ดอลลาร์ฮ่องกง",
            "hnl": "ฮอนดูรัส Lempira",
            "hrk": "Kuna โครเอเชีย",
            "htg": "Gourde ชาวไฮติ",
            "huf": "โฟรินท์ฮังการี",
            "idr": "เงินรูเปียอินโดนีเซีย",
            "ils": "อิสราเอล Sheqel ใหม่",
            "inr": "เงินรูปีของอินเดีย",
            "iqd": "ดีนาร์อิรัก",
            "irr": "เรียลอิหร่าน",
            "isk": "ไอซ์แลนด์โครน",
            "jmd": "ดอลลาร์จาเมกา",
            "jod": "ดีนาร์จอร์แดน",
            "jpy": "เงินเยนของญี่ปุ่น",
            "kes": "ชิลลิงเคนยา",
            "kgs": "Som Kyrgyzstani",
            "khr": "เรียลกัมพูชา",
            "kmf": "ฟรังก์ Comorian",
            "kpw": "เกาหลีเหนือ Won",
            "krw": "วอนเกาหลีใต้",
            "kwd": "ดีนาร์คูเวต",
            "kyd": "ดอลลาร์หมู่เกาะเคย์แมน",
            "kzt": "คาซัคสถาน Tenge",
            "lak": "กีบลาว",
            "lbp": "เลบานอนลีรา",
            "lkr": "เงินรูปีของศรีลังกา",
            "lrd": "ดอลลาร์ไลบีเรีย",
            "lsl": "Loti เลโซโท",
            "lvl": "Lats ลัตเวีย",
            "lyd": "ดีนาร์ลิเบีย",
            "mad": "Dirham โมร็อกโก",
            "mdl": "Leu มอลโดวา",
            "mga": "Ariary มาดากัสการ์",
            "mkd": "มาซิโดเนีย Denar",
            "mmk": "Myanma จ๊าด",
            "mnt": "มองโกเลีย Tugrik",
            "mop": "มาเก๊า Pataca",
            "mro": "ชาว Ouguiya",
            "mur": "รูปีมอริเชียส",
            "mvr": "Rufiyaa มัลดีฟส์",
            "mwk": "ริงกิตมาเลเซีย",
            "mxn": "เงินเปโซเม็กซิกัน",
            "myr": "ริงกิตมาเลเซีย",
            "mzn": "โมซัมบิก Metical",
            "nad": "ดอลลาร์นามิเบีย",
            "ngn": "ยินดีไนจีเรีย",
            "nio": "นิการากัวคอร์โด",
            "nok": "โครนนอร์เวย์",
            "npr": "เงินรูปีเนปาล",
            "nzd": "ดอลลาร์นิวซีแลนด์",
            "omr": "เรียลโอมาน",
            "pab": "Balboa ปานามา",
            "pen": "เปรูโซล Nuevo",
            "pgk": "ปาปัวนิวกินี Kina",
            "php": "เปโซของฟิลิปปินส์",
            "pkr": "เงินรูปีของปากีสถาน",
            "pln": "โปแลนด์ Zloty",
            "pyg": "ปารากวัยนี",
            "qar": "Riyal กาตาร์",
            "rmb": "Renminbi",
            "ron": "Leu โรมาเนีย",
            "rsd": "ดีนาร์เซอร์เบีย",
            "rub": "รูเบิลรัสเซีย",
            "rwf": "ฟรังก์รวันดา",
            "sar": "Riyal ซาอุดิ",
            "sbd": "ดอลลาร์หมู่เกาะโซโลมอน",
            "scr": "เงินรูปีเซเชลส์",
            "sdg": "ปอนด์ซูดาน",
            "sek": "โครนสวีเดน",
            "sgd": "ดอลลาร์สิงคโปร์",
            "shp": "ปอนด์เซนต์เฮเลนา",
            "sll": "เซียร์ราลีโอน",
            "sos": "ชิลลิงโซมาเลีย",
            "srd": "ดอลลาร์ซูรินาเม",
            "std": "Sao Tome Principe และ Dobra",
            "syp": "ปอนด์ซีเรีย",
            "szl": "สวาซิแลนด์ Lilangeni",
            "thb": "เงินบาท",
            "tjs": "Tajikistani Somoni",
            "tmt": "เติร์กเมนิสถานมนัส",
            "tnd": "ดีนาร์ตูนิเซีย",
            "top": "Paanga",
            "try": "ลีราตุรกีใหม่",
            "ttd": "ตรินิแดดและโตเบโกดอลลาร์",
            "twd": "ดอลลาร์ไต้หวันใหม่",
            "tzs": "ชิลลิงแทนซาเนีย",
            "uah": "Hryvnia ยูเครน",
            "ugx": "ชิลลิงยูกันดา",
            "usd": "เงินดอลลาร์สหรัฐ",
            "uyu": "เงินเปโซอุรุกวัย",
            "uzs": "Som Uzbekistani",
            "vef": "เวเนซุเอลาโบลีวาร์",
            "vnd": "ดงเวียดนาม",
            "vuv": "วานูอาตูตู",
            "wst": "Tala ซามัว",
            "xaf": "ฟรังก์ CFA แอฟริกากลาง",
            "xcd": "ดอลลาร์แคริบเบียนตะวันออก",
            "xdr": "สิทธิพิเศษถอนเงิน",
            "xof": "เวสต์ฟรังก์ CFA แอฟริกา",
            "xpf": "ฟรังก์ CFP",
            "yer": "เรียลเยเมน",
            "zar": "แรนด์แอฟริกาใต้",
            "zmw": "Kwacha แซมเบีย"
        },
        "shop-currency-rate": {
            "rate-last-updated-x-days-ago": "อัตราการปรับปรุง {time} วันที่ผ่านมา",
            "rate-last-updated-x-hours-ago": "อัตราการปรับปรุง {time} ชั่วโมงที่ผ่านมา"
        },
        "hyperair": {
            "copyright-footer": "ลิขสิทธิ์© 2018 บริษัท ไฮเปอร์แอร์ จำกัด สงวนลิขสิทธิ์.",
            "today": "ในวันนี้"
        },
        "product-simcard": {
            "shipping-methods": {
                "hkpost": "ฮ่องกงโพสต์ (ฟรี)",
                "international": "ขนส่งระหว่างประเทศ",
                "sf": "SF Express (Hong Kong only. Courier fee payable on delivery. Free Shipping for orders over HK$399)"
            }
        },
        "country": {
            "afghanistan": "อัฟกานิสถาน",
            "aland-islands": "หมู่เกาะโอลัน",
            "albania": "แอลเบเนีย",
            "algeria": "แอลจีเรีย",
            "andorra": "อันดอร์รา",
            "angola": "แองโกลา",
            "anguilla": "แองกวิลลา",
            "antigua-&-barbuda": "แอนติกาและบาร์บูดา",
            "antigua-barbuda": "แอนติกาและบาร์บูดา",
            "argentina": "อาร์เจนตินา",
            "armenia": "อาร์เมเนีย",
            "aruba": "อารูบา",
            "australia": "ออสเตรเลีย",
            "austria": "ออสเตรีย",
            "azerbaijan": "อาเซอร์ไบจาน",
            "azores": "อะซอเรส",
            "bahamas": "บาฮามาส",
            "bahrain": "บาห์เรน",
            "bangladesh": "บังคลาเทศ",
            "barbados": "บาร์เบโดส",
            "belarus": "เบลารุส",
            "belgium": "เบลเยียม",
            "belize": "เบลีซ",
            "benin": "เบนิน",
            "bermuda": "BERMUDA",
            "bhutan": "ภูฏาน",
            "bolivia": "โบลิเวีย",
            "bonaire": "โบแนร์",
            "bosnia-herzegovina": "บอสเนียและเฮอร์เซโกวีนา",
            "botswana": "บอตสวานา",
            "brazil": "บราซิล",
            "british-virgin-islands": "หมู่เกาะบริติชเวอร์จิน",
            "brunei": "บรูไน",
            "bulgaria": "บัลแกเรีย",
            "burkina-faso": "บูร์กินาฟาโซ",
            "burundi": "บุรุนดี",
            "cambodia": "กัมพูชา",
            "cameroon": "แคเมอรูน",
            "canada": "แคนาดา",
            "canary-islands": "หมู่เกาะคะเนรี",
            "cape-verde-islands": "หมู่เกาะเคปเวิร์ด",
            "cayman-islands": "หมู่เกาะเคย์แมน",
            "central-african-republic": "สาธารณรัฐอัฟริกากลาง",
            "chad": "ชาด",
            "chile": "ชิลี",
            "china": "ประเทศจีน",
            "colombia": "โคลอมเบีย",
            "comoros": "คอโมโรส",
            "congo": "ประเทศคองโก",
            "cook-islands": "หมู่เกาะคุก",
            "costa-rica": "คอสตาริกา",
            "cote-d-ivoire": "Cote D Ivoire",
            "croatia": "โครเอเชีย",
            "cruise-ship": "เรือสำราญ",
            "cuba": "คิวบา",
            "curacao": "คูราเซา",
            "cyprus": "ประเทศไซปรัส",
            "cyprus---north": "ประเทศไซปรัส",
            "cyprus---south": "ประเทศไซปรัส",
            "czech-republic": "สาธารณรัฐเช็ก",
            "denmark": "เดนมาร์ก",
            "djibouti": "จิบูตี",
            "dominica": "โดมินิกา",
            "dominican-republic": "สาธารณรัฐโดมินิกัน",
            "dubai": "Dubai",
            "easter-island": "เกาะอีสเตอร์",
            "ecuador": "เอกวาดอร์",
            "egypt": "อียิปต์",
            "el-salvador": "เอลซัลวาดอร์",
            "equatorial-guinea": "อิเควทอเรียลกินี",
            "eritrea": "เอริเทรี",
            "estonia": "เอสโตเนีย",
            "ethiopia": "สาธารณรัฐเอธิโอเปีย",
            "europe": "Europe",
            "falkland-islands": "หมู่เกาะฟอล์คแลนด์",
            "faroe-islands": "หมู่เกาะแฟโร",
            "fiji": "ฟิจิ",
            "finland": "ฟินแลนด์",
            "france": "ฝรั่งเศส",
            "french-guiana": "เฟรนช์เกีย",
            "french-polynesia": "เฟรนช์โปลินีเซีย",
            "french-west-indies": "หมู่เกาะอินเดียตะวันตกของฝรั่งเศส",
            "gabon": "ประเทศกาบอง",
            "gambia": "แกมเบีย",
            "georgia": "จอร์เจีย",
            "germany": "ประเทศเยอรมัน",
            "ghana": "ประเทศกานา",
            "gibraltar": "ยิบรอลตา",
            "greece": "กรี��",
            "greenland": "เกาะกรีนแลนด์",
            "grenada": "เกรเนดา",
            "guadeloupe": "ลุป",
            "guam": "กว��",
            "guatemala": "กัวเตมาลา",
            "guernsey": "เสื้อไหมพรม",
            "guinea": "ประเทศกินี",
            "guinea---bissau": "กินีบิสเซา",
            "guinea-bissau": "กินีบิสเซา",
            "guyana": "กายอานา",
            "haiti": "ไฮติ",
            "honduras": "ฮอนดูรัส",
            "hong-kong": "ฮ่องกง",
            "hungary": "ฮังการี",
            "iceland": "ประเทศไอซ์แลนด์",
            "india": "อินเดีย",
            "indonesia": "อินโดนีเซีย",
            "iran": "อิหร่าน",
            "iraq": "อิรัก",
            "ireland": "ไอร์แลนด์",
            "isle-of-man": "ไอล์ออฟแมน",
            "israel": "อิสราเอล",
            "italy": "อิตาลี",
            "jamaica": "JAMAICA",
            "japan": "ประเทศญี่ปุ่น",
            "jersey": "นิวเจอร์ซีย์",
            "jordan": "จอร์แดน",
            "kazakhstan": "คาซัคสถาน",
            "kenya": "ประเทศเคนย่า",
            "kiribati": "ประเทศคิริบาส",
            "kosovo": "โคโซโว",
            "kuwait": "คูเวต",
            "kyrgyz-republic": "สาธารณรัฐคีร์กีซ",
            "kyrgyzstan": "คีร์กีสถาน",
            "laos": "ลาว",
            "latvia": "ลัตเวีย",
            "lebanon": "เลบานอน",
            "lesotho": "เลโซโท",
            "liberia": "ประเทศไลบีเรีย",
            "libya": "ประเทศลิบยา",
            "liechtenstein": "นสไตน์",
            "lithuania": "ประเทศลิธัวเนีย",
            "luxembourg": "ลักเซมเบิร์ก",
            "macau": "มาเก๊า",
            "macedonia": "มาซิโดเนีย",
            "madagascar": "มาดากัสการ์",
            "madeira": "เกาะมะดีระ",
            "malawi": "มาลาวี",
            "malaysia": "ประเทศมาเลเซีย",
            "maldives": "มัลดีฟส์",
            "mali": "มาลี",
            "malta": "เกาะมอลตา",
            "marshall-islands": "หมู่เกาะมาร์แชลล์",
            "martinique": "มาร์ตินีก",
            "mauritania": "ประเทศมอริเตเนีย",
            "mauritius": "มอริเชียส",
            "mayotte": "มายอต",
            "mexico": "เม็กซิโก",
            "micronesia": "ไมโครนีเซีย",
            "moldova": "มอลโดวา",
            "monaco": "โมนาโก",
            "mongolia": "ประเทศมองโกเลีย",
            "montenegro": "มอนเตเนโก",
            "montserrat": "มอนต์เซอร์รัต",
            "morocco": "โมร็อกโก",
            "mozambique": "ประเทศโมซัมบิก",
            "myanmar": "พม่า",
            "namibia": "นามิเบีย",
            "nauru": "ประเทศนาอูรู",
            "nepal": "ประเทศเนปาล",
            "netherlands": "เนเธอร์แลนด์",
            "netherlands-antilles": "เนเธอร์แลนด์",
            "new-caledonia": "นิวแคลิโดเนีย",
            "new-zealand": "นิวซีแลนด์",
            "nicaragua": "นิการากัว",
            "niger": "ประเทศไนเธอร์",
            "nigeria": "ประเทศไนจีเรีย",
            "niue": "นีอูเอ",
            "norfolk-islands": "หมู่เกาะนอร์โฟล์ค",
            "north-korea": "เกาหลีเหนือ",
            "northern-marianas": "มาเรียนาเหนือ",
            "norway": "นอร์เวย์",
            "oman": "โอมาน",
            "pakistan": "ปากีสถาน",
            "palau": "ปาเลา",
            "palestine": "ปาเลสไตน์",
            "panama": "ปานามา",
            "papua-new-guinea": "ปาปัวนิวกินี",
            "paraguay": "ประเทศปารากวัย",
            "peru": "เปรู",
            "philippines": "ฟิลิปปินส์",
            "poland": "โปแลนด์",
            "portugal": "โปรตุเกส",
            "puerto-rico": "เปอร์โตริโก้",
            "qatar": "กาตาร์",
            "reunion": "การรวมตัวใหม่",
            "romania": "โรมาเนีย",
            "russia": "รัสเซีย",
            "rwanda": "รวันดา",
            "saint-barthelemy": "SAINT BARTHELEMY",
            "saint-martin": "เซนต์มาร์ติน",
            "saint-pierre-&-miquelon": "เซนต์ปิแอร์และมีเกอลง",
            "samoa": "ซามัว",
            "san-marino": "ซานมาริโน",
            "sao-tome-&-principe": "เซาโตเม & ปรินซิปี",
            "sao-tome-principe": "เซาโตเมและปรินซิปี",
            "satellite": "ดาวเทียม",
            "saudi-arabia": "ซาอุดิอาราเบีย",
            "senegal": "ประเทศเซเนกัล",
            "serbia": "เซอร์เบีย",
            "seychelles": "เซเชลส์",
            "sierra-leone": "เซียร์ราลีโอน",
            "singapore": "สิงคโปร์",
            "slovak-republic": "สาธารณรัฐสโลวัก",
            "slovakia": "สโลวะเกีย",
            "slovenia": "สโลวีเนีย",
            "solomon-islands": "หมู่เกาะโซโลมอน",
            "somalia": "โซมาเลีย",
            "south-africa": "แอฟริกาใต้",
            "south-korea": "เกาหลีใต้",
            "spain": "สเปน",
            "sri-lanka": "ศรีลังกา",
            "st-helena": "เซนต์เฮเลน่า",
            "st-kitts": "เซนต์คิตส์",
            "st-kitts-&-nevis": "เซนต์คิตส์และเนวิส",
            "st-lucia": "เซนต์ลูเซีย",
            "st-vincent": "เซนต์วินเซนต์",
            "st.-helena": "เซนต์เฮเลน่า",
            "st.-kitts": "เซนต์คิตส์",
            "st.-lucia": "เซนต์ลูเซีย",
            "sudan": "ซูดาน",
            "suriname": "ซูรินาเม",
            "swaziland": "สวาซิแลนด์",
            "sweden": "สวีเดน",
            "switzerland": "ประเทศสวิสเซอร์แลนด์",
            "syria": "ซีเรีย",
            "taiwan": "ไต้หวัน",
            "tajikistan": "ทาจิกิสถาน",
            "tanzania": "ประเทศแทนซาเนีย",
            "thailand": "ประเทศไทย",
            "timor-l'este": "ติมอร์ตะวันออก",
            "togo": "ไป",
            "tonga": "ตองกา",
            "trinidad-&-tobago": "ตรินิแดดและโตเบโก",
            "trinidad-tobago": "ตรินิแดดและโตเบโก",
            "tunisia": "ตูนิเซีย",
            "turkey": "ไก่งวง",
            "turkmenistan": "เติร์กเมนิสถาน",
            "turks-&-caicos": "เติกส์และเคคอส",
            "turks-&-caicos-islands": "หมู่เกาะเติกส์และเคคอส",
            "turks-caicos-islands": "หมู่เกาะเติกส์และหมู่เกาะเคคอส",
            "uganda": "ยูกันดา",
            "ukraine": "ยูเครน",
            "united-arab-emirates": "สหรัฐอาหรับเอมิเรตส์",
            "united-kingdom": "ประเทศอังกฤษ",
            "united-states": "สหรัฐ",
            "united-states-minor-outlying-islands": "หมู่เกาะเล็กรอบนอกของสหรัฐอเมริกา",
            "uruguay": "อุรุกวัย",
            "uzbekistan": "อุซเบกิ",
            "vanuatu": "วานูอาตู",
            "vatican-city": "เมืองวาติกัน",
            "venezuela": "เวเนซุเอลา",
            "vietnam": "เวียดนาม",
            "virgin-islands": "หมู่เกาะเวอร์จิน",
            "virgin-islands-(us)": "หมู่เกาะเวอร์จิน (สหรัฐอเมริกา)",
            "wallis-&-futuna": "วอลลิซและฟูทานา",
            "wallis-futuna": "วาลลิสและฟุตูนา",
            "yemen": "เยเมน",
            "zambia": "แซมเบีย",
            "zimbabwe": "ประเทศซิมบับเว"
        },
        "inspiration": {
            "published-date": "M Y",
            "published-duration": ": ระยะเวลาวันก่อน",
            "published-duration-singular": "เมื่อวาน",
            "published-duration-today": "ในวันนี้"
        },
        "promotion-center": {
            "expires-at": "",
            "redeem": {
                "error": {
                    "already-redeemed": "คุณได้แลกคูปองไปแล้ว",
                    "new-customer-only": "ข้อเสนอใช้ได้สำหรับลูกค้าใหม่เท่านั้น",
                    "not-found": "รหัสโปรโมชั่นไม่ถูกต้อง"
                }
            }
        },
        "auth": {
            "failed": "ข้อมูลรับรองเหล่านี้ไม่ตรงกับบันทึกของเรา",
            "throttle": "มีการพยายามลงชื่อเข้าใช้มากเกินไป โปรดลองอีกครั้งใน: วินาทีวินาที"
        },
        "web": {
            "activity": {
                "countdown-title": "",
                "more-button": "More tour and tickets",
                "section-subtitle": "Find the cheapest tour and tickets in Singapore",
                "section-title": "Tour and Tickets"
            },
            "checkout": {
                "use-promo-code": ""
            },
            "checkout-failed": {
                "checkout-failed": ""
            },
            "checkout-success": {
                "checkout-success": "การชำระเงินสำเร็จ",
                "continue-shopping-button": "ช็อปต่อ",
                "done-button": "Done👌🏻",
                "download-now": "ดาวน์โหลดเดี๋ยวนี้",
                "order-number": "หมายเลขสั่งซื้อ",
                "register-email": "อีเมลของคุณ",
                "register-password": "ตั้งรหัสผ่านของคุณ",
                "sim-product": "ซื้อ <span class=\"bold\"> สำเร็จ: ซิม </span>อีเมลยืนยันถูกส่งไปที่: อีเมล",
                "slogan": "เปิดแอป HyperAir เพื่อเพลิดเพลินกับสิทธิพิเศษในการเดินทาง! นอกจากนี้คุณยังสามารถติดตามการสั่งซื้อตามเวลาจริงได้ในแอพ!",
                "slogan-password": "อีกหนึ่งขั้นตอน! คุณสามารถเพลิดเพลินกับคูปองซิมการ์ดต้อนรับ HK $ 10 และการติดตามคำสั่งซื้อแบบเรียลไทม์ในแอพ!",
                "trace-order": "",
                "trace-order-password": "",
                "welcome-offer": "อีกหนึ่งขั้นตอน! ��ุณสามารถเพลิดเพลินกับคูปองซิมการ์ดต้อนรับ HK $ 10 และการติดตามคำสั่งซื้อแบบเรียลไทม์ในแอพ!"
            },
            "country": {
                "all": "ทั้งหมด",
                "contact-us-description": "0 任何疑問， 歡迎發送電郵到<a href=\"mailto:corporate@hyperair.com\\>corporate@hyperair.com</a>查詢",
                "data": "ขีด จำกัด ข้อมูล:",
                "day": "วัน (s):",
                "day-day": "วัน",
                "esim": "ESIM",
                "esim-section-title": "สุดยอด eSIM สำหรับ: ประเทศ",
                "num-of-review": ": การจัดอันดับแบบไม่ระบุชื่อ",
                "per-day": "วัน",
                "phone-call": "สายเข้า",
                "plug-n-go": "",
                "plug-n-go-esim": "ซื้อและใช้งานได้ทันที",
                "plug-n-go-sim": "เสียบและใช้งาน",
                "section-title": "ซิมการ์ดที่ดีที่สุดสำหรับ: ประเทศ",
                "section-title copy": "ซิมการ์ดที่ดีที่สุดสำหรับ: ประเทศ",
                "sim": "ซิม",
                "supplier": "ผู้ให้บริการ:"
            },
            "download-app-banner": {
                "download-now": "ดาวน์โหลดแอปเลย",
                "hyperair": "HyperAir",
                "subtitle": "ดาวน์โหลดและลงทะเบียนแอพ HyperAir เพื่อรับข้อเสนอต้อนรับ HK $ 10!",
                "title": "ท่องเที่ยวอย่างชาญฉลาด ทุกแห่ง"
            },
            "email-subscription": {
                "cancel-button": "再諗一諗",
                "completed-subscribe": "Thank you for subscribing!",
                "confirm-button": "我要最抵優惠",
                "duplicate-email": "你的電郵已經訂閱了",
                "invalid-email": "Invalid email address",
                "title-1": "想Staycation價格跌至新低時通知你？",
                "title-2": "仲搜羅全城最抵既Staycation 及美食套餐優惠"
            },
            "fanfare": {
                "cover-title": "เสนอซิมการ์ด",
                "datetime-format": "เจเอ็ม",
                "end-next-fanfare": "ที่จะเกิดขึ้นเสนอซิมการ์ด:",
                "end-title": "ติดตามความคืบหน้าเพื่อ App และสื่อสังคมของเราสำหรับซิมโปรโมชั่นต่อไป",
                "end-title2": "ติดตามความคืบหน้าไปยังแอปและสื่อสังคมแพลตฟอร์มของเราสำหรับการเสนอซิมการ์ดต่อไป",
                "more-details-button": "รายละเอียดเพิ่มเติม",
                "out-of-stock": "ขายหมดแล้ว",
                "popular-countries-subtitle": "จดหมายพื้นผิวฟรีจัดส่งที่รวดเร็ว",
                "popular-countries-title": "ซิมการ์ดที่เป็นที่นิยม",
                "section-title": "ซิมการ์ดในราคาที่ถูกสุดในราคาสุดพิเศษ",
                "title": "เวลา จำกัด | การ์ด จำกัด",
                "x-inventory-left": "ล่าสุด{inventory}"
            },
            "fanfare-breadcrumb": "เสนอซิมการ์ด",
            "filter-button": {
                "filter": "กรอง"
            },
            "filter-container": {
                "apply": "",
                "category": "ประเภท",
                "category-aquarium": "พิพิธภัณฑ์สัตว์น้ำ",
                "category-class": "ชั้น",
                "category-day-tour": "ทัวร์วัน",
                "category-discount": "ส่วนลด",
                "category-diving": "การดำน้ำ",
                "category-food": "อาหาร",
                "category-massage-beauty": "นวดและความงาม",
                "category-museum": "พิพิธภัณฑ์",
                "category-musical": "ดนตรี",
                "category-outlet": "ทางออก",
                "category-photography": "การถ่ายภาพ",
                "category-playground": "สนามเด็กเล่น",
                "category-railway": "ทางรถไฟ",
                "category-show": "แสดง",
                "category-ski": "สกี",
                "category-spa": "สปา",
                "category-theme-park": "สวนสนุก",
                "category-ticket": "ตั๋ว",
                "category-transport": "ขนส่ง",
                "category-transport-ticket": "ตั๋วขนส่ง",
                "category-vr": "VR",
                "category-water-park": "สวนน้ำ",
                "category-yoga": "โยคะ",
                "category-zoo": "สวนสัตว์",
                "clear-all": "ตั้งค่าใหม่",
                "facilities": "Services & facilities",
                "filter": "กรอง",
                "food": "Food",
                "header": "กรอง",
                "popular-search": "Popular Search🔥",
                "price": "ราคา",
                "provider": "เว็บไซต์ท่องเที่ยว",
                "subcategory-buffet": "บุฟเฟ่ต์",
                "subcategory-car": "รถยนต์",
                "subcategory-facial": "ที่หน้า",
                "subcategory-food": "อาหาร",
                "subcategory-half-day-tour": "ทัวร์ครึ่งวัน",
                "subcategory-massage": "นวด",
                "subcategory-meal-voucher": "คูปองอาหาร",
                "subcategory-one-day-tour": "ทัวร์วันเดียว",
                "subcategory-restaurant": "ร้านอาหาร",
                "subcategory-transport": "การขนส่ง",
                "tag": "Tag"
            },
            "footer": {
                "about-hyperair-description": "HyperAir เป็นแพลตฟอร์มการเดินทางที่ชาญฉลาดตามที่คุณต้องการนำเสนอโซลูชั่นการเดินทางที่คุ้มค่าและเหมาะสมที่สุดเพื่อให้คุณสามารถเดินทางได้อย่างชาญฉลาดทุกที่",
                "download-now": "ดาวน์โหลดเดี๋ยวนี้",
                "email-subscription-button": "Subscribe",
                "email-subscription-placeholder": "Enter your email",
                "email-subscription-social-title": "or Follow our Facebook and Instagram",
                "email-subscription-title": "Subscribe to get the latest staycation discount",
                "travel-license": "Travel Agent Licence Number："
            },
            "fx-booking": {
                "back-button": "",
                "confirm-booking": "",
                "confirm-button": "",
                "contact-shop": "",
                "get-money-before": ""
            },
            "home": {
                "cover-button": "สัมผัสประสบการณ์ตอนนี้",
                "cover-subtitle": "เปิดตัวเองสู่โลกใหม่ของ HyperAir",
                "cover-title": "ท่องเที่ยวอย่างชาญฉลาด ทุกแห่ง",
                "grid": {
                    "1": {
                        "subtitle": "แรงบันดาลใจล่าสุด",
                        "title": "ชาว Cat ในโบสถ์ตุรกี"
                    },
                    "2": {
                        "subtitle": "แรงบันดาลใจล่าสุด",
                        "title": "กีฬาโอลิมปิกปี 2020 ที่โตเกียว 1 ปี To Go"
                    },
                    "3": {
                        "subtitle": "สุดฮอต",
                        "title": "รับประกันราคาที่ดีที่สุดออนไลน์"
                    },
                    "4": {
                        "subtitle": "Penawaran Waktu Terbatas",
                        "title": "Keriangan kartu SIM"
                    },
                    "5": {
                        "subtitle": "จุดหมายยอดนิยม",
                        "title": "Peek ดอดของ Galaxy Edge ของดิสนีย์แลนด์"
                    }
                },
                "home-example": {
                    "column-subtitle-1": "ใช้เวลา 2 ท่านเดินทาง 7 วันไปญี่ปุ่นเป็นตัวอย่าง:",
                    "column-subtitle-2": "การเปรียบเทียบราคา",
                    "column-title-1": "การเดินทางครั้งเดียวเพิ่มการประหยัดของคุณ",
                    "column-title-2": "เปรียบเทียบ บริษัท ตัวแทนท่องเที่ยวออนไลน์ 11 แห่ง",
                    "hotel": "รางวัลโรงแรม",
                    "hotel-package-1": "โรงแรมนิกโกะโอซาก้า x6 คืน",
                    "insurance": "ประกันการเดินทาง",
                    "insurance-package-1": "ประกันการเดินทาง 7 วัน x2",
                    "money": "ประกันการเดินทาง",
                    "money-package-1": "แลกเปลี่ยน JPD ¥ 410,000",
                    "save": "บันทึก",
                    "sim": "ท่องเที่ยวซิม",
                    "sim-package-1": "ญี่ปุ่น 7 วัน DoCoMo SIM x2",
                    "slogan": "เปรียบเทียบก่อนทำการจองประหยัดเงินสำหรับการเดินทางครั้งต่อไป!",
                    "total-saving": "เงินออมรวม 1,443 เหรียญ",
                    "travel-experience": "ประสบการณ์การเดินทาง",
                    "travel-experience-package-1": "JR Pass สำหรับทั้งญี่ปุ่น x2",
                    "travel-experience-package-2": "ยูนิเวอร์แซลสตูดิโอประเทศญี่ปุ่น™ 1 วัน eTicket x2"
                },
                "media-header-title": "Press",
                "more": "ท่องเที่ยวมากกว่าซิม",
                "partners-title": "Partnership",
                "photo-banner-button": "เรียนรู้เพิ่มเติม",
                "photo-banner-title": "แลกเปลี่ยนเงินการเดินทา���อย่างชาญฉลาด",
                "services-header-description": "",
                "services-header-title": "บริการการท่องเที่ยวแบบครบวงจร",
                "services-icon-subtitle-1": "ช่วยให้คุณได้รับเงินเดินทางอย่างชาญฉลาด!",
                "services-icon-subtitle-2": "มอบซิมการ์ดที่ดีที่สุดให้คุณพร้อมจัดส่งฟรี!",
                "services-icon-subtitle-3": "ให้คุณสำรวจโลกด้วยโซลูชันที่ปรับแต่งเอง!",
                "services-icon-title-1": "เงินเดินทาง",
                "services-icon-title-2": "ท่องเที่ยวซิม",
                "services-icon-title-3": "ประสบการณ์การเดินทาง",
                "statistic": {
                    "num-of-city": "",
                    "num-of-comparison": "",
                    "num-of-experience": "",
                    "num-of-saving": ""
                },
                "testimonial-1-content": "呢個แอป很好用, 方便比較滙率, 唔駛周圍去揾資料. 很欣賞程式員佢地既用心製作, 佢地都很積極用心為我解決使用時的困難. 推薦使用!",
                "testimonial-1-subtitle": "ผู้ใช้ Android",
                "testimonial-1-user": "คริสตินลำ",
                "testimonial-2-content": "好方便, 訂ซิม卡好快就送到, 唔洗特登出街買ซิม卡, 價錢都好平吓. 網絡收得幾好, 上次去日本喺市區同近郊玩都好流暢! 下次會再買!",
                "testimonial-2-subtitle": "ผู้ใช้ iOS",
                "testimonial-2-user": "นางฟ้า",
                "testimonial-header-description": "",
                "testimonial-header-title": "คำรับรองจากลูกค้า",
                "travel-activities": {
                    "home-slogan": "เปรียบเทียบและค้นหาประสบการณ์การเดินทางที่ดีที่สุดของคุณจากเว็บไซต์ต่างๆ"
                },
                "travel-country-header-description": "การจำแนกที่ชัดเจนง่ายต่อการเลือก",
                "travel-country-header-title": "Travel SIM ครอบคลุม 200 ประเทศ",
                "travel-info-header-description": "นำแรงบันดาลใจในการเดินทางที่ร้อนแรงมาให้คุณ",
                "travel-info-header-title": "แรงบันดาลใจในการเดินทาง",
                "travel-marketplace-header-description": "",
                "travel-marketplace-header-title": "",
                "travel-sim-header-description": "สุดยอดซิมการ์ดพร้อมจัดส่งฟรี",
                "travel-sim-header-title": "ซิมท่องเที่ยวยอดนิยม"
            },
            "hotel": {
                "cover-subtitle": "เพลิดเพลินไปกับ Trip.com พิเศษข้อเสนอพิเศษจองโรงแรม 5%",
                "cover-title": "รางวัลโรงแรม",
                "discount-detail": "ใช้รหัสโปรโมชั่น \"HYPERAIR5\" เพลิดเพลินไปกับ 5% ข้อเสนอพิเศษจองโรงแรม",
                "discount-title": "HYPERAIR5",
                "highlight-subtitle1": "โรงแรมค้นพบทั่วโลกสำหรับการเข้าพักที่ไม่ซ้ำกัน",
                "highlight-subtitle2": "ได้รับข้อเสนอที่ดีที่สุดและประหยัดเงินของคุณสำหรับการเดินทางต่อไป",
                "highlight-subtitle3": "ตรวจสอบราคาโรงแรมทุกที่ทุกเวลา",
                "highlight-title1": "ครอบคลุมทั่วโลก",
                "highlight-title2": "สิทธิพิเศษ",
                "highlight-title3": "คลิกเดียวจองห้องพัก"
            },
            "hypermiles": {
                "activity": "Activity",
                "balance": "Outstanding Balance",
                "benefit": "Your Privileges",
                "cumulative-purchase": "Accumulated Spending：HK$ {amount}",
                "diamond-black": "Diamond Black",
                "expire": "Expired HyperMiles ({date})",
                "expire-reminder-1": "HyperMiles is valid for one year from the shopping month",
                "expire-reminder-2": "Remember to use HyperMiles before expiry!",
                "hypermiles-total": "HyperMiles",
                "member": "Member",
                "member-tier": "You have become HyperAir {member_tier} member",
                "membership-details": "Membership Tier",
                "next-purchase": "save HK${amount} in your next purchase",
                "order-num": "Order No: {order_num}",
                "permanent-membership": "Permanent Membership",
                "popup-title": "HyperMiles Reward Scheme",
                "precious-platinum": "Precious Platinum",
                "product_purchase": "HyperMiles from gadgets purchase ({date})",
                "record": "HyperMiles Record",
                "royal-blue": "Royal Blue",
                "simcard_purchase": "HyperMiles from SIM purchase ({date})",
                "tier": "",
                "title": "HyperMiles. Explore the World, Enjoy the rebate!",
                "u-have": "Your have",
                "usage": "Redeemed HyperMiles",
                "what-is-hypermiles": "What is HyperMiles",
                "what-is-hypermiles-slogan1": "Spend more. Earn more!",
                "what-is-hypermiles-slogan2": "Every 100 HyperMiles can be used as HK$1 at checkout, no minimum spending limit",
                "what-is-hypermiles-slogan3": "Spend more at HyperAir to enjoy more privileges"
            },
            "hypermiles-disclaimer": "terms and conditions apply",
            "hypermiles-discount-diamond-black": "Spend every HK$1 to enjoy 1 HyperMiles",
            "hypermiles-discount-precious-platinum": "Spend every HK$1.5 to enjoy 1 HyperMiles",
            "hypermiles-discount-royal-blue": "Spend every HK$2 to enjoy 1 HyperMiles",
            "hypermiles-special-diamond-black": "Exclusive pre-sale offer",
            "hypermiles-spend-diamond-black": "Cumulative spending of HK$3,000",
            "hypermiles-spend-precious-platinum": "Cumulative spending of HK$1,500",
            "hypermiles-spend-royal-blue": "Basic Member",
            "login": {
                "email": "",
                "existing-user": "",
                "forgot-password": "",
                "forgot-password-please-fill-in-email": "",
                "login": "",
                "login-with-facebook": "",
                "login-with-google": "",
                "new-user": "",
                "or": "",
                "password": "",
                "phone-input-placeholder": "",
                "phone-input-title": "",
                "phone-verify": "",
                "resend-verification-code": "",
                "reset-password": "",
                "title": "",
                "verification-code-input-title": ""
            },
            "logo-loader": {
                "slogan": "We're almost there"
            },
            "my-order": {
                "amount": "",
                "esim-qrcode": "",
                "fx-status-cancelled": "",
                "fx-status-confirmed": "",
                "order-date": "",
                "order-details": "",
                "order-num": "",
                "status-confirmed": "",
                "status-pending-confirmation": "",
                "status-ready-to-ship": "",
                "status-shipped": ""
            },
            "my-order-details": {
                "delivery-info": "",
                "discount": "",
                "recipient-address": "",
                "recipient-email": "",
                "recipient-name": "",
                "recipient-tel": "",
                "shipping-method": "",
                "status": "",
                "total": "",
                "valid-date": ""
            },
            "nav": {
                "about-us": "เกี่ยวกับเรา",
                "car": "",
                "company": "บริษัท",
                "company-address": "Entrepreneurship Centre, Level 3, Cyberport 3, Hong Kong",
                "contact-us": "ติดต่อเรา",
                "contact-us-description": "โปรดส่งอีเมลไปที่ <a href=\"mailto:hello@hyperair.com\">hello@hyperair.com</a> เพื่อสอบถามข้อมูลใด ๆ",
                "disclaimer": "Disclaimer",
                "download-app": "ดาวน์โหลดแอพ",
                "flight": "",
                "foodie": "Foodie",
                "home": "Home",
                "hotel": "โรงแรม",
                "jobs": "รับสมัครงาน",
                "logout": "ออกจากระบบ",
                "media-coverage": "Press",
                "monthly-rental-hotel": "Monthly Rental Hotel",
                "privacy-policy": "นโยบายความเป็นส่วนตัว",
                "promo-banner-text": "HyperAir 客戶專享 5% Trip.com 獨家酒店折扣",
                "quarantine-hotel": "Long Stay Hotel",
                "refund-policy": "นโยบายการคืนเงิน",
                "spa-and-beauty": "Spa and Beauty",
                "staycation": "Staycation",
                "tag-line": "Compare Travel Sites & Save Money",
                "terms-of-service": "เงื่อนไขการให้บริการ",
                "travel-activity": "",
                "travel-affiliate-codes": "คูปอง",
                "travel-affiliate-codes-md": "คูปอง",
                "travel-blog": "Blog",
                "travel-experience-d": "ทัวร์ท่องเที่ยวและประสบการณ์",
                "travel-experience-md": "ทัวร์ท่องเที่ยวและประสบการณ์",
                "travel-insurance": "ประกันการเดินทาง",
                "travel-insurance-md": "ประกันการเดินทาง",
                "travel-marketplace": "ท่องเที่ยว Gadgets",
                "travel-marketplace-md": "ท่องเที่ยว Gadgets",
                "travel-money": "เงินเดินทาง",
                "travel-money-md": "เงินเดินทาง",
                "travel-sim": "ท่องเที่ยวซิม",
                "travel-sim-md": "ท่องเที่ยวซิม"
            },
            "photo-banner": {
                "banner-button": ""
            },
            "product-card": {
                "num-of-review": "{num}-of-review ratings"
            },
            "redirection-gate": {
                "columns-1-description": "เปรียบเทียบประสบการณ์การเดินทางที่ดีที่สุดจากเว็บไซต์ต่างๆ",
                "columns-1-title": "เปรียบเทียบกิจกรรมท่องเที่ยว",
                "columns-2-description": "ข้อเสนอที่ดีที่สุดซิมการ์ดพร้อมจัดส่งฟรี!",
                "columns-2-title": "ซิมการเดินทาง",
                "columns-3-description": "เปรียบเทียบและจองอัตราแลกเปลี่ยนที่ดีที่สุดในเมือง",
                "columns-3-title": "รายได้ท่องเที่ยว",
                "promo-code": "รหัส",
                "remember-to-fill-promo-code": "จำไว้ว่าให้ใช้รหัสโปรโมชั่นดังกล่าวข้างต้นก่อนที่จะเช็คเอาท์",
                "title": "We are taking you to {domain}",
                "trouble-link": "If the browser does not redirect you in 10 seconds, please click this <a href=\"{link}\">link</a>."
            },
            "register": {
                "guest-checkout": "",
                "title": ""
            },
            "seo": {
                "best-price-guarantee-title": "Best Price Guarantee",
                "country-description": "{country} Travel SIM - รับประกันราคาถูกที่สุดพร้อมจัดส่งฟรี",
                "country-keywords": "ซิม卡, 上網卡, 電話卡, 數據卡, DataSIM, 旅遊 DataSIM, 數據咭, 4G 上網卡, 上網卡, 4G 上網卡, 日本 4G 上網卡, 日本上網卡, 東京 4G 上網卡, 東京上網卡, 大阪 4G上網卡, 大阪上網卡, 泰國 4G 上網卡, 泰國上網卡, 曼谷 4G 上網卡, 布吉上網卡, 芭提雅 4G 上網卡, 台灣 4G 上網卡, 台灣上網卡, 台北 4G 上網卡, 高雄上網卡,台中 4G 上網卡, 台中上網卡, 韓國 4G 上網卡, 韓國上網卡, 首爾 4G 上網卡, 首爾上網卡, 中國 4G 上網卡, 中國上網卡, 深圳 4G 上網卡, 深圳上網卡, 澳門 4G 上網卡,澳門上網卡, Docomo, Softbank",
                "country-title": "{country} Travel SIM - รับประกันราคาถูกที่สุดพร้อมจัดส่งฟรี",
                "home-description": "HyperAir เป็นแพลตฟอร์มการเดินทางที่ชาญฉลาดตามที่คุณต้องการนำเสนอโซลูชั่นการเดินทางที่คุ้มค่าและเหมาะสมที่สุดเพื่อให้คุณสามารถเดินทางได้อย่างชาญฉลาดทุกที่",
                "home-keywords": "ซิม上, 上網卡, 電話卡, 數據卡, DataSIM, 旅遊 DataSIM, 咭咭, 4G 上網卡, 上網卡, 4G 4G 網卡, ซิม卡, ซิมการเดินทาง, 旅遊錢唱, 唱錢唱X 器, 唱錢, 唱錢แอป兌換, 找換, 兌換店, 找換店, 銀行, 金融, 外匯, 外滙, 匯率, 滙率, 匯款, 外幣, 貨幣, 旅行, 旅遊, 行程, 酒店, 機票,比較, 格價, 特價, 預訂, 交易, 日本, 泰國, 台灣, Hyper, Hyper, Hyper, Hyper, Hyper, Hyper, Hyper, Hyper, Hyper, Hyper, Hyper, A, A百年, 堅成, 發達鳥, 飛鳥, richbird, นกบ้า, การแลกเปลี่ยนเบอร์ลิน",
                "home-title": "‎HyperAir - Best Travel Comparison & Search Engine | Experience, Hotel, SIM, Exchange, Travel Insurance",
                "hotel-description": "รับข้อเสนอพิเศษจองโรงแรมผ่าน HyperAir.com",
                "hotel-keywords": "โรงแรม, โรงแรม, ส่วนลด, จอง, เอเชีย, ยุโรป, อเมริกา, กรุงเทพฯ, สิงคโปร์, ฮ่องกง, ภูเก็ต, ไทย, มาเลเซีย, บาหลี, ลอนดอน, ปารีส, โปรแกรมความภักดี, พนมรุ้งปุรี, ที่พัก, acomodation, ที่พัก, ที่พักตากอากาศ",
                "hotel-title": "โปรโมชั่นโรงแรม",
                "money-exchange-description": "Check {shop_name}'s latest FX rate and book your travel money online. You can lock in FX rate and reserve foreign currency.",
                "money-exchange-keywords": "{shop_name}, 唱錢神器, 唱X神器, 唱錢X器, 唱錢, 兌換, 找換, 兌換店, 找換店, 銀行, 金融, 外匯, 外滙, 匯率, 滙率, 匯款, 外幣, 貨幣, 旅行, 旅遊, 行程, 酒店, 機票, 比較, 格價, 特價, 預訂, 交易, 旅遊保險, 日本, 泰國, 韓國, 台灣, 日圓, 日元, 台幣, 泰銖, HyperAir, HyperAir FX, HyperAir Travel, Travel, Travel Money, Foreign Currency, Foreign Exchange, 百年, 堅成, 發達鳥, 飛鳥, richbird, crazy bird, berlin exchange",
                "money-exchange-title": "{shop_name}'s latest FX rate with instant booking | Lock in FX rate and reserve your travel money instantly",
                "privacy-policy-title": "Privacy Policy",
                "refund-policy-title": "Refund & Return Policy",
                "sim-fanfares-description": "HyperAir ได้เปิดตัวครั้งแรกที่ซิมการ์ด Fanfares ในฮ่องกง คุณสามารถซื้อซิมการ์ดสำหรับการเดินทางของคุณด้วยส่วนลดสูงสุดถึง 50% เวลา จำกัด จำนวน จำกัด !",
                "sim-fanfares-keywords": "fanfares, ซิมการ์ด, ซิมการ์ด, ซิม卡, 上網卡, 電話卡, 數據卡, DataSIM, 旅遊 DataSIM, 數據咭, 4G 上網卡, 上網卡, 4G 上網卡, 日本 4G 上網卡, 日本上網卡, 東京 4G 上網卡, 東京上網卡, 大阪 4G 上網卡, 大阪上網卡, 泰國 4G 上網卡, 泰國上網卡, 曼谷 4G 上網卡, 布吉上網卡, 芭提雅 4G 上網卡, 台灣 4G 上網卡, 台灣上網卡, 台北 4G上網卡, 高雄上網卡, 台中 4G 上網卡, 台中上網卡, 韓國 4G 上網卡, 韓國上網卡, 首爾 4G 上網卡, 首爾上網卡, 中國 4G 上網卡, 中國上網卡, 深圳 4G 上網卡, 深圳上網卡, 澳門 4G 上網卡, 澳門上網卡, Docomo, Softbank",
                "sim-fanfares-title": "ซิมการ์ด Fanfares - เวลา จำกัด จำกัด การ์ด",
                "term-of-service-title": "Terms of Service",
                "travel-activity-search-results-description": "",
                "travel-activity-search-results-keywords": "{activity}, travel, local experience, local activity, ticket, activities, day tours, tourist attractions",
                "travel-activity-search-results-title": "HyperAir - Search Result of {q} in {city}",
                "travel-affiliate-codes-description": "HyperAir ปรับปรุงอย่างต่อเนื่องรหัสรหัสส่วนลด / โปรโมชั่นล่าสุดได้รับส่วนลดในการจองโรงแรม, ส่วนลดตั๋วเครื่องบินส่วนลดกิจกรรมส่วนลดประกันการเดินทางส่วนลดซิมการ์ดและส่วนลดบัตรเครดิต",
                "travel-affiliate-codes-keywords": "รหัสส่วนลด, คูปองอิเล็กทรอนิกส์รหัสส่วนลด, รหัสโปรโมชั่นรหัสโปรโมชั่รหัสส่วนลด, โรงแรม, ตั๋วเครื่องบิน, เสนอเสนอบัตรเครดิตเสนอการเดินทาง",
                "travel-affiliate-codes-title": "2023 ล่าสุดการเดินทางส่วนลดรหัส (อัพเดททุกวัน) | ส่วนลดจองโรงแรม, ตั๋วเครื่องบิน, กิจกรรม, ประกันการเดินทาง, ซิมข้อมูล",
                "travel-insurance-description": "ค้นหาที่ดีที่สุดแผนประกันภัยการเดินทาง? ซึ่งมีแผนครอบคลุมโทรศัพท์มือถือ? เปรียบเทียบแผนประกันจาก บริษัท เช่นเอไอจี, MSIG และสตาร์และซื้อออนไลน์ที่มีส่วนลดพิเศษ!",
                "travel-insurance-keywords": "เอไอจี, MSIG, สตาร์, เอไอจี Promocode, MSIG Promocode สตาร์ Promocode, ประกันภัยการเดินทางประกันการเดินทางออนไลน์เปรียบเทียบประกันการเดินทางประกันราคาถูกเดินทางประกันการเดินทางฮ่องกงเที่ยวเดียว, แผนประจำปี",
                "travel-insurance-title": "ราคาที่ดีที่สุดประกันภัยการเดินทางและการเปรียบเทียบในฮ่องกง 2023",
                "travel-marketplace-checkout-payme-title": "Pay with PayMe",
                "travel-marketplace-checkout-success-keywords": "創意, 產品, 流行, 電器, 生活, 精品, 智能家居, 設計, 高品質, 設計概念, 創意科技, 生活用品, 戶外休閒, 廚房, 餐桌, 個人護理, 防疫抗疫, 健康, 遊戲, 兒童玩樂, 健身, 家居健身, gym, home gym, smart home, style home",
                "travel-marketplace-checkout-success-title": "{product_name}",
                "travel-marketplace-description": "A collection of coolest gadgets that you'll like",
                "travel-marketplace-keywords": "創意, 產品, 流行, 電器, 生活, 精品, 智能家居, 設計, 高品質, 設計概念, 創意科技, 生活用品, 戶外休閒, 廚房, 餐桌, 個人護理, 防疫抗疫, 健康, 遊戲, 兒童玩樂, 健身, 家居健身, gym, home gym, smart home, style home",
                "travel-marketplace-product-checkout-title": "{product}",
                "travel-marketplace-product-title": "{product}",
                "travel-marketplace-title": "ท่องเที่ยว Gadgets",
                "travel-money-description": "HyperAir มอบวิธีใหม่ในการรับเงินเดินทางให้คุณ ตอนนี้คุณสามารถจองการแลกเปลี่ยนออนไลน์ด้วยอัตราแลกเปลี่ยนที่ดีที่สุดในเมือง!",
                "travel-money-keywords": "ซิม卡, 上網卡, 電話卡, 數據卡, DataSIM, 旅遊 DataSIM, 數據咭, 4G 上網卡, 上網卡, 4G 上網卡, 唱錢神器, 唱 X 神器, 唱錢 X 器, 唱錢, 兌換, 找換, 兌換店, 找換店, 銀行, 金融, 外匯, 外滙, 匯率, 滙率, 匯款, 外幣, 貨幣, 旅行, 旅遊, 行程, 酒店, 機票, 比較, 格價, 特價, 預訂, 交易, 旅遊保險,日本, 泰國, 韓國, 台灣, 日圓, 台幣, Hyper, HyperAir, HyperAir FX, HyperAir ท่องเที่ยว, เดินทาง, เดินทาง, เดินทางเงิน, เงินตราต่างประเทศ, แลกเปล��่ยนเงินตราต่างประเทศ, 百年, 堅, rich, richbird, นกบ้า แลกเปลี่ยนเบอร์ลิน",
                "travel-money-title": "HyperAir - แลกเปลี่ยนเงินอย่างชาญฉลาด",
                "travel-product-checkout-keywords": "創意, 產品, 流行, 電器, 生活, 精品, 智能家居, 設計, 高品質, 設計概念, 創意科技, 生活用品, 戶外休閒, 廚房, 餐桌, 個人護理, 防疫抗疫, 健康, 遊戲, 兒童玩樂, 健身, 家居健身, gym, home gym, smart home, style home",
                "travel-product-keywords": "創意, 產品, 流行, 電器, 生活, 精品, 智能家居, 設計, 高品質, 設計概念, 創意科技, 生活用品, 戶外休閒, 廚房, 餐桌, 個人護理, 防疫抗疫, 健康, 遊戲, 兒童玩樂, 健身, 家居健身, gym, home gym, smart home, style home",
                "travel-sim-checkout-description": "{country} Travel SIM - ซิมการ์ดคุณภาพสูงพร้อมจัดส่งฟรีถึงบ้านคุณ!",
                "travel-sim-checkout-keywords": "上網卡, 電話卡, 數據卡, DataSIM, 旅遊 DataSIM, 數據咭, 4G 上網卡, 上網卡, 4G 上網卡, 日本 4G 上網卡, 日本上網卡, 東京 4G 上網卡, 東京上網卡, 大阪 4G 上網卡,大阪上網卡, 泰國 4G 上網卡, 泰國上網卡, 曼谷 4G 上網卡, 布吉上網卡, 芭提雅 4G 上網卡, 台灣 4G 上網卡, 台灣上網卡, 台北 4G 上網卡, 高雄上網卡, 台中 4G 上網卡, 台中上網卡, 韓國 4G 上網卡, 韓國上網卡, 首爾 4G 上網卡, 首爾上網卡, 中國 4G 上網卡, 中國上網卡, 深圳 4G 上網卡, 深圳上網卡, 澳門 4G 上網卡, 澳門上網卡, Docomo, Softbank",
                "travel-sim-checkout-success-description": "{country} Travel SIM - ซิมการ์ดคุณภาพสูงพร้อมจัดส่งฟรีถึงบ้านคุณ!",
                "travel-sim-checkout-success-keywords": "上網卡, 電話卡, 數據卡, DataSIM, 旅遊 DataSIM, 數據咭, 4G 上網卡, 上網卡, 4G 上網卡, 日本 4G 上網卡, 日本上網卡, 東京 4G 上網卡, 東京上網卡, 大阪 4G 上網卡,大阪上網卡, 泰國 4G 上網卡, 泰國上網卡, 曼谷 4G 上網卡, 布吉上網卡, 芭提雅 4G 上網卡, 台灣 4G 上網卡, 台灣上網卡, 台北 4G 上網卡, 高雄上網卡, 台中 4G 上網卡, 台中上網卡, 韓國 4G 上網卡, 韓國上網卡, 首爾 4G 上網卡, 首爾上網卡, 中國 4G 上網卡, 中國上網卡, 深圳 4G 上網卡, 深圳上網卡, 澳門 4G 上網卡, 澳門上網卡, Docomo, Softbank",
                "travel-sim-checkout-success-title": "ความสำเร็จของการชำระเงิน - Travel SIM",
                "travel-sim-checkout-title": "สั่งซื้อ - Travel SIM",
                "travel-sim-keywords": "ซิม卡, 上網卡, 電話卡, 數據卡, DataSIM, 旅遊 DataSIM, 數據咭, 4G 上網卡, 上網卡, 日本 4G 上網卡, 日本上網卡, 日本ซิม卡, 東京 4G 上網卡, 東京上網卡, 大阪 4G上網卡, 大阪上網卡, 泰國 4G 上網卡, 泰國上網卡, 泰國ซิม卡, 曼谷 4G 上網卡, 布吉上網卡, 芭提雅 4G 上網卡, 台灣 4G 上網卡, 台灣上網卡, 台灣ซิม卡, 台北4G 上網卡, 高雄上網卡, 台中 4G 上網卡, 台中上網卡, 韓國ซิม卡, 韓國 4G 上網卡, 韓國上網卡, 首爾 4G 上網卡, 首爾上網卡, 中國 4G 上網卡, 中國上網卡, 中國ซิม卡, 中國內地數據卡, 深圳 4G 上網卡, 深圳上網卡, 澳門 4G 上網卡, 澳門上網卡, 歐洲 4G 上網卡, 歐洲上網卡, 歐洲英國英國, 英國 4G , 法國 4G 網卡網卡, 法國上網卡, 法國 SIM 卡, 大利大利 4G 上網卡, 意大利上網卡, 意大利ซิม卡, 巴黎 4G 上網卡, 巴黎上網卡, 瑞士上網卡,瑞士ซิม卡, Docomo, Softbank, 和記, 聯通, 3hk, 3uk, เบอร์ดี้, 自由鳥, อากาศ sim, sim2fly, AIS, ais sim2fly, SK Telecom, TrueMove, dtac, t mobile 全球上網卡, เวียดนาม",
                "travel-sim-title": "【{country} SIM】{sim_name} - รับประกันราคาที่ดีที่สุดพร้อมจัดส่งฟรี",
                "travel-sims-description": "เครื่องมือค้นหาซิมท่องเที่ยวทั่วโลกพร้อมซิมการ์ดคุณภาพสูงและจัดส่งฟรีถึงบ้านคุณ!",
                "travel-sims-keywords": "ซิม卡, 上網卡, 電話卡, 數據卡, DataSIM, 旅遊 DataSIM, 數據咭, 4G 上網卡, 4Gsim 卡, 日本 4G 上網卡, 日本上網卡, 日本ซิม卡, 東京 4G 上網卡, 東京上網卡, 大阪 4G上網卡, 大阪上網卡, 泰國 4G 上網卡, 泰國上網卡, 泰國ซิม卡, 曼谷 4G 上網卡, 布吉上網卡, 芭提雅 4G 上網卡, 台灣 4G 上網卡, 台灣上網卡, 台灣ซิม卡, 台北4G 上網卡, 高雄上網卡, 台中 4G 上網卡, 台中上網卡, 韓國ซิม卡, 韓國 4G 上網卡, 韓國上網卡, 首爾 4G 上網卡, 首爾上網卡, 中國 4G 上網卡, 中國上網卡, 中國ซิม卡, 內地內地數據卡, 深圳 4G 上網卡, 深圳上網卡, 澳門 4G 上網卡, 澳門上網卡, 澳門 sim 歐洲, Doc ซิม Doc, Docomo, Softbank, sim2fly, เอไอเอส sim2fly, SK Telecom, TrueMove, dtac , t mobile 全球上網卡, vietnamobile",
                "travel-sims-title": "Travel SIM - รับประกันราคาถูกที่สุดพร้อมจัดส่งฟรี"
            },
            "shop-confirmation": {
                "app-download": "",
                "app-download-subtitle": "",
                "instruction": "",
                "my-order": "",
                "pending-confirm": ""
            },
            "staycation": {
                "activity-countdown-button": "Find the cheapest price",
                "all-hotels": {
                    "sorting": {
                        "recommended": "Recommended"
                    }
                },
                "all-hotels-all-button": "All",
                "all-hotels-hotel-name": "Hotel Name",
                "all-hotels-last-updated": "Last Updated",
                "all-hotels-less-button": "Less",
                "all-hotels-more-button": "More",
                "all-hotels-no-result": "Sorry, we couldn't find any results",
                "all-hotels-title": "",
                "compare-packages": "Compare other packages",
                "countdown-button": "More Details",
                "countdown-title": "",
                "countdown2-title": "HyperAir Recommended",
                "countdown3-title": "最新 Staycation 酒店限時優惠",
                "month-format": "MMM",
                "order-d-title": "浪漫精品酒店 💕💕",
                "order-g-subtitle": "暑假帶埋一家大細Relax下",
                "order-g-title": "親子Staycation必去之選👨‍👩‍👧‍👦😍",
                "order-h-title": "郵輪之旅🛳️",
                "order-i-title": "情侶煮飯仔酒店 🍽️",
                "order-j-title": "Glamping豪華露營推介",
                "seo-description": "點解咁多人用 HyperAir 搵 Staycation? 因為集合左 KKday, Trip.com, Klook 及各大香港酒店平台，一眼比較邊到有late checkout、免費泊車、自助早午晚餐及餐飲回贈等獨家 Staycation 優惠，每日更新。",
                "seo-keywords": "staycation, staycation 優惠, 香港 staycation, staycation 香港, staycation hk, staycation package, staycation hong kong, 酒店, 酒店 優惠, staycation 中文, 香港 酒店, klook 優惠, klook 優惠, kkday 優惠, trip 優惠, agoda 優惠, runhotel staycation, 酒店 套票, staycation 酒店, 香港 酒店 套票, 訂 酒店 優惠, 酒店 package, 特價 酒店, 香港 優惠 酒店, 酒店 優惠 套 票, 特價 酒店 香港, 香港 酒店 優惠, 酒店 住宿 優惠, staycation 2020, staycation 2021, staycation 2022, staycation 1月 優惠, staycation 2月 優惠, staycation 3月 優惠, staycation 4月 優惠, staycation 5月 優惠, staycation 6月 優惠, staycation 7月 優惠, staycation 8月 優惠, staycation 9月 優惠, staycation 10月 優惠, staycation 11月 優惠, staycation 12月 優惠, 四季酒店, W酒店, Murray, JW Marriott, St. Regis, Conrad Hotel, Grand Hyatt, Ritz Carlton, Rosewood, 露台 酒店, 廚房 酒店, 親子 酒店, 情侶 酒店",
                "seo-title": "【2021年9月最新】香港酒店 Staycation 優惠搜尋神器 全港最齊．每日更新 - 最齊香港staycation優惠、酒店優惠、Hong Kong Staycation Ideas、Klook優惠、KKday優惠、Trip優惠、Agoda優惠、專業旅運優惠 - HyperAir 玩樂必備搜尋比較平台！一次過，比較全球多個玩樂旅遊預訂網站！ - HyperAir",
                "share-button-alert": "Copied the Link",
                "subtitle": "每日更新酒店餐飲及住宿優惠（{start_month}月至{end_month}月）",
                "title": "",
                "top10-title": "",
                "top102-title": "",
                "top103-title": "值得一試的 Staycation 酒店🥂"
            },
            "travel-activities": {
                "best-deals": "Best Deal",
                "book-now": "View Deal",
                "disclaimer": "ราคาที่แสดงเป็นเพียงสำหรับการอ้างอิง ในกรณีที่มีความแตกต่างโปรดอ้างอิงเว็บไซต์ของพันธมิตรของเรา",
                "empty-destination": "",
                "more-deals": "More Deals",
                "not-available": "Not Available",
                "offers": "",
                "provider-getyourguide": "GetYourGuide",
                "provider-hk": {
                    "trip": {
                        "com": "Trip.com"
                    }
                },
                "provider-hyperair": "HyperAir",
                "provider-kkday": "KKday",
                "provider-klook": "KLOOK",
                "provider-seoultravelpass": "SeoulPass",
                "provider-sim": {
                    "hyperair": {
                        "com": "HyperAir"
                    }
                },
                "provider-travelexpert": "Travel Expert",
                "provider-trip": "Trip.com",
                "ratings": "อันดับ",
                "recommended-title": "กิจกรรมที่ได้รับความนิยมเพิ่มเติมใน {city}",
                "search-africa-oceania": "แอฟริกา / โอเชียเนีย",
                "search-all-cities": "เมืองทั้งหมด",
                "search-america": "สหรัฐอเมริกา",
                "search-asia": "เอเชีย",
                "search-button": "ค้นหา",
                "search-cancel-button": "ยกเลิก",
                "search-country-placeholder": "ป้อนประเทศหรือเมือง",
                "search-euro-middleeast": "ยุโรป / ตะวันออกกลาง",
                "search-hardcoded-cities": "ค้นหายอดนิยม:",
                "search-placeholder": "ค้นหา \"JR Pass\"",
                "search-popular-cities": "เมืองยอดนิยม",
                "search-searched-cities": "ค้นหาเมือง",
                "search-slogan-2": "",
                "show-similar-product": "เปรียบเทียบที่คล้ายกัน",
                "sorting": {
                    "price-asc": "ราคา (ต่ำไปสูง)",
                    "price-desc": "ราคา (มากไปน้อย)",
                    "rating": "อันดับ",
                    "relevance": "ความสัมพันธ์กัน",
                    "sort-by": "จัดเรียงตาม"
                },
                "title": "ผลการค้นหาที่ตรงกับ \"{q}\"",
                "title-everything": "กิจกรรมยอดนิยมใน{city}",
                "title-no-result": "ขออภัยเราไม่พบผลลัพธ์สำหรับ \"{q}\"",
                "title-no-result-without-keyword": "ขออภัยเราไม่พบผลลัพธ์ใด ๆ",
                "total-results": "ผลลัพธ์ <b>{number}</b> ทั้งหมด"
            },
            "travel-affiliate-codes": {
                "cover-slogan": "ให้รหัสส่วนลดสำหรับเว็บไซต์จองการเดินทางระหว่างประเทศ",
                "cover-title": "คูปองส่วนลดการเดินทาง",
                "disclaimer": "ข้อเสนอโปรโมชั่นที่แสดงเป็นเพียงสำหรับการอ้างอิง ในกรณีที่มีความแตกต่างโปรดดูที่เว็บไซต์พันธมิตรของเรา ซัพพลายเออร์ที่อาจมีการเปลี่ยนแปลงหรือลบข้อมูลได้ตลอดเวลาโดยไม่ต้องแจ้งให้ทราบล่วงหน้าและจะต้องมีดุลพินิจที่จะรับข้อเสนอพิเศษ",
                "exclusive": "พิเศษ",
                "type-activity": "กิจกรรม",
                "type-air": "ตั๋วเครื่องบิน",
                "type-all": "ทั้งหมด",
                "type-hotel": "โรงแรม",
                "type-insurance": "ประกันการเดินทาง",
                "type-shopping": "ช้อปปิ้ง",
                "type-sim": "ซิมการ์ด",
                "use-promo-code": "รับรหัส",
                "valid-until": "ใช้ได้ถึงวันที่:"
            },
            "travel-insurance": {
                "breadcrumb-travel-insurance": "ประกันการเดินทาง",
                "cover-subtitle": "ค้นหาและเปรียบเทียบประกันการเดินทางที่ดีที่สุดที่มีความคุ้มครองโทรศัพท์มือถือ!",
                "cover-title": "ประกันการเดินทาง",
                "departure-date-alert": "",
                "disclaimer": "ใบเสนอราคาสำหรับการอ้างอิงเท่านั้น โปรดดูที่เว็บไซต์ของ บริษัท ประกันภัยสำหรับรายละเอียดเพิ่มเติม",
                "highlight-subtitle1": "ออกรายการความคุ้มครองที่สำคัญของแผนประกันภัยการเดินทางสำหรับการเลือกของคุณง่าย",
                "highlight-subtitle2": "เปรียบเทียบข้อเสนอที่ดีที่สุดประกันการเดินทางเพื่อช่วยให้คุณประหยัดเงินทุก!",
                "highlight-subtitle3": "เพลิดเพลินกับสิทธิประโยชน์ประกันการเดินทางและข้อเสนอสุดพิเศษ!",
                "highlight-title1": "เปรียบเทียบความคุ้มครอง",
                "highlight-title2": "ราคาเปรียบเทียบ",
                "highlight-title3": "รางวัลพิเศษ",
                "num-of-travellers-alert": "",
                "partner-title": "การเดินทางจากพาร์ทเนอร์ของเราประกันภัย",
                "return-date-alert": "",
                "section-title": "ขณะนี้คุณกำลังค้นหา{num_of_day} สำหรับ{num_of_traveller} เดินทาง (s)",
                "slogan": "3 ขั้นตอนง่ายๆ",
                "sorting": {
                    "coverage": "คุ้มครองที่ดีที่สุด",
                    "price-asc": "ราคา (ต่ำไปสูง)",
                    "price-desc": "ราคา (สูงไปต่ำ)"
                },
                "step1": "กรอกข้อมูล",
                "step1-detail": "ใส่ปลายทางวันของคุณและไม่มี ของนักเดินทาง",
                "step2": "เปรียบเทียบแผน",
                "step2-detail": "เปรียบเทียบราคาและความคุ้มครองของแผนประกันภัยการเดินทางที่แตกต่างกัน",
                "step3": "เพลิดเพลินไปกับข้อเสนอ",
                "step3-detail": "คลิกเดียวเพลิดเพลินไปกับข้อเสนอพิเศษประกันการเดินทาง"
            },
            "travel-insurance-product-card": {
                "apply-now": "ได้รับข้อเสนอ",
                "cancellation": "ยกเลิก",
                "car-rental": "ส่วนเกินให้เช่ายานพาหนะ",
                "cruise-vacation": "วันหยุดล่องเรือ (ผลประโยชน์ตัวเลือก)",
                "dangerous-sports": "กีฬาอันตราย",
                "hyperair-exclusive": "HYPERAIR EXCLUSIVE",
                "medical": "แพทย์",
                "mobile": "การสูญเสีย / ความเสียหายโทรศัพท์มือถือ",
                "personal-belongings": "ส่วนบุคคลข้าวของ",
                "trip-delay": "เดินทางล่าช้า"
            },
            "travel-insurance-search-bar": {
                "children": "เด็กอายุต่ำกว่า 18",
                "date": "วันออกเดินทางและกลับวันที่",
                "destination": "คุณจะไปที่ไหน",
                "friend": "เพื่อน / ญาติ",
                "myself": "ตนเอง",
                "number-of-traveller": "จำนวนนักเดินทาง",
                "search-button": "ค้นหา",
                "spouse": "คู่สมรส"
            },
            "travel-marketplace": {
                "buy-now-can-earn-x-miles": "Earn Hy",
                "cover-slogan": "คอลเลกชันของแกดเจ็ตที่ยอดเยี่ยมที่คุณจะชอบ",
                "cover-title": "ท่องเที่ยว Gadgets"
            },
            "travel-marketplace-categories": "Categories",
            "travel-marketplace-checkout": {
                "delivery-message-body": "วันทำงานจะตั้งแต่วันจันทร์ถึงวันศุกร์ (ยกเว้นวันหยุดนักขัตฤกษ์) คำสั่งตัดเวลา 12{00} (GMT + 8) สั่งซื้อหลังจาก 12{00} (GMT + 8) จะจัดส่งออกไปในวันทำการถัดไป",
                "delivery-method-1": "เอสเอฟเอ็กซ์ (ฮ่องกงเท่านั้น)",
                "delivery-method-1-description": "โดยเอสเอฟเอ็กซ์ค่าจัดส่งเป็น HK $ 30 ต่อคำสั่งซื้อ ค่าธรรมเนียม Courier ถูกยกเลิกเมื่อการจัดซื้อดังกล่าวข้างต้นที่ HK $ 800 รายการสั่งซื้อจะถูกส่งโดยจัดส่งภายใน 1-3 วันทำการและหมู่เกาะจะใช้เวลา 5 วันทำการหมายถึงเว็บไซต์ของเอสเอฟเอ็กซ์",
                "delivery-method-2": "การจัดส่งสินค้าระหว่างประเทศ",
                "delivery-method-2-description": "จัดส่ง 4-15 วันทำการขึ้นอยู่กับปลายทาง ค่าขนส่งเป็น HK $ 100 ต่อรายการ ค่าธรรมเนียมการจัดส่งระหว่างประเทศดังกล่าวข้างต้นจะขึ้นอยู่กับการประมาณค่า คิดค่าใช้จ่ายนอกจากนี้อาจนำไปใช้"
            },
            "travel-money": {
                "breadcrumb-travel-money": "รายได้ท่องเที่ยว",
                "cover-button": "สัมผัสประสบการณ์ตอนนี้",
                "cover-slogan": "แลกเปลี่ยนเงินการเดินทางอย่างชาญฉลาด",
                "cover-title": "เงินเดินทาง",
                "disclaimer": "ราคาที่แสดงเป็นเพียงสำหรับการอ้างอิง ในกรณีที่มีความแตกต่างโปรดดูที่เว็บไซต์ของเงินที่แลก",
                "empty-amount": "",
                "fx": "",
                "fx-slogan": "สี่ขั้นตอนง่าย ๆ",
                "fx-step1": "ค้นหา",
                "fx-step1-detail": "เลือกสกุลเงินที่คุณต้องการแลกเปลี่ยน",
                "fx-step2": "เปรียบเทียบ",
                "fx-step2-detail": "ค้นหาอัตราที่ดีที่สุดและจุดรับที่สะดวกที่สุด",
                "fx-step3": "หนังสือ",
                "fx-step3-detail": "จองเงินเดินทางออนไลน์",
                "fx-step4": "ไปรับ",
                "fx-step4-detail": "แสดงรหัส QR เพื่อรับเงินเดินทาง",
                "hyperair-feature-1": "ฉลาด",
                "hyperair-feature-1-description": "วิธีที่ชาญฉลาดในการแลกเปลี่ยนเงินการเดินทาง ตอนนี้คุณสามารถเห็นอัตราที่ดีที่สุดด้วยการคลิกเพียงไม่กี่ครั้งและสำรองเงินเดินทางออนไลน์ ได้เวลาพูดลาก่อนต่อคิวยาว ๆ !",
                "hyperair-feature-2": "น่าเชื่อถือ",
                "hyperair-feature-2-description": "วิธีที่เชื่อถือได้ในการรับแลกเปลี่ยนเงิน พันธมิตรของเราทั้งหมดเป็นธนาคารที่ได้รับอนุญาตและผู้แลกเปลี่ยนเงินเพื่อให้การแลกเปลี่ยนเงินตราต่างประเทศของคุณปลอดภัย",
                "hyperair-feature-3": "ทุกแห่ง ทุกที่ทุกเวลา",
                "hyperair-feature-3-description": "วิธีใหม่ในการรับเงินเดินทาง เรากระตือรือร้นที่จะขยายขอบเขตการทำงานในต่างประเทศและมอบประสบการณ์การเดินทางที่ชาญฉลาดให้กับคุณทุกที่",
                "i-will-get": "ฉันจะได้รับ",
                "i-will-pay": "ฉันจะจ่าย",
                "join-us": "เพื่อโอกาสทางธุรกิจที่มากขึ้น",
                "join-us-button": "เข้าร่วมกับเราตอนนี้",
                "join-us-slogan": "เป็นผู้จำหน่ายของเรา",
                "search-bar-placeholder": "ใส่จำนวนเงิน",
                "search-button": "ค้นหา",
                "section-title": "",
                "section-title-from-hkd": "ค้นหา HKD สำหรับ {amount} {currency}",
                "section-title-to-hkd": "ค้นหา {amount} {currency} สกุลเงินเหรียญฮ่องกง",
                "why-hyperair": "",
                "why-hyperair-description": "HyperAir มอบวิธีใหม่ในการรับเงินเดินทางให้คุณ ตอนนี้คุณสามารถจองการแลกเปลี่ยนออนไลน์ด้วยอัตราแลกเปลี่ยนที่ดีที่สุดในเมือง!",
                "why-hyperair-title": "ทำไมถึงเลือกพวกเรา?"
            },
            "travel-product": {
                "buy-now": "ซื้อในตอนนี้",
                "product-option": "ตัวเลือก"
            },
            "travel-sim": {
                "as-low-as": "ต่ำเช่นเดียวกับ",
                "book-now": "สั่งซื้อทันที",
                "breadcrumb-homepage": "โฮมเพจ",
                "breadcrumb-mainpage": "หน้าหลัก",
                "breadcrumb-travel-sim": "ท่องเที่ยวซิม",
                "cancellation-policy": "นโยบายการยกเลิก",
                "cancellation-policy-content": "ไม่มีการยกเลิกการคืนเงินหรือการเปลี่ยนแปลงสามารถทำได้หลังการซื้อ",
                "download-hyperair-now-description": "สแกนรหัส QR หรือไปที่ร้านแอพเพื่อดาวน์โหลดแอป HyperAir",
                "download-hyperair-now-title": "ดาวน์โหลดแอพ HyperAir",
                "first-step": "ขั้นตอนที่ 1",
                "go-to-shopping-cart-description": "",
                "go-to-shopping-cart-title": "",
                "hardcoded-countries-title": "ประเทศยอดนิยมอื่น ๆ :",
                "highlights": "ไฮไลท์",
                "important-notice": "ประกาศสำคัญ",
                "instructions": "คำแนะนำ",
                "lowest-price-guarantee": "รับประกันราคาที่ดีที่สุด",
                "no-stock": "ขายหมดแล้ว",
                "num-of-review": ": ความคิดเห็นของจำนวนรีวิว",
                "popular-countries": "Travel SIM ครอบคลุม 200 ประเทศ",
                "popular-countries-search-button": "ค้นหาประเทศอื่น ๆ",
                "product-highlights": "Product Description",
                "product-specification": "คุณสมบัติของผลิตภัณฑ์",
                "related-sims": "ที่เกี่ยวข้อง: ประเทศ SIM",
                "related-sims-search-button": "เพิ่มเติม: ประเทศ SIM",
                "review": "ทบทวน",
                "review-date": ": วัน",
                "review-no-firstname-user": "นักท่องเที่ยว",
                "scan-product-qr-code": "一掃一掃รหัส QR 購買此產品",
                "second-step": "ขั้นตอนที่ 2",
                "sim": " Sim Cards",
                "web-traffic": "ซื้อแล้ว: จำนวนครั้งที่ซื้อตั้งแต่สัปดาห์ที่แล้วและผู้ใช้จำนวนคนดูปริมาณการใช้ซิมนี้ในขณะนี้",
                "web-traffic-title": "ซิมนี้มียอดขายร้อน!"
            },
            "travel-sim-checkout": {
                "-secure-payment-slogan": "",
                "address": "ที่อยู่สำหรับการจัดส่ง",
                "address-column1": "เช่น. ห้อง A, 18 / F, World Center",
                "address-column2": "เช่น. 88 ถนนท่องเที่ยว",
                "address-column3": "เช่น. ภาคกลางฮ่องกง",
                "back-button": "กลับ",
                "checkout-title-1": "ข้อมูลการจัดส่ง",
                "confirm-button": "ต่อ",
                "country-code": "รหัสประเทศ",
                "delivery-message-body": "Working days are from Monday to Friday (except public holidays). The order cut-off time is 12：00 PM (GMT+8). Orders placed after 12：00 PM (GMT+8) will ship out the next working day.\n<br><br>Within the same working day, orders with the same delivery address will be sent together.",
                "delivery-message-header": "ประกาศการจัดส่ง",
                "delivery-method": "วิธีการจัดส่ง",
                "delivery-method-1": "Hong Kong Post (Free)",
                "delivery-method-1-description": "By Hong Kong Post's Local Mail, the estimated delivery will be within 3-6 working days. Status tracking is not available to local mail and customers shall bare the full responsibility of losing items by using Hong Kong Post’s ordinary mail service.\n<br><br>Note: Due to the time required for delivery, customers who are about to travel are recommended to choose SF Express",
                "delivery-method-2": "SF Express (Hong Kong only. Courier fee payable on delivery)",
                "delivery-method-2-description": "By SF Express (courier fee payable on delivery), the ordered items will be delivered by courier within 1-3 working days, and islands will take longer delivery time. The courier fee is about HK$16-$25 by referring to the website of SF Express.\n<br><br>Note: The order over HK$399 will be upgraded to SF Express for FREE",
                "delivery-method-3": "International Shipping",
                "delivery-method-3-description": "Delivered by Hong Kong Post (tracking no. will be provided) within 4 to 15 working days depends on the destination. Shipping cost HK$30.",
                "error-alert-address": "กรุณากรอกที่อยู่ในการจัดส่ง",
                "error-alert-invalid-email": "รูปแบบอีเมลไม่ถูกต้อง",
                "error-alert-invalid-recipient-first-num": "หมายเลขติดต่อควรเริ่มต้นด้วย 2,3,5,6,7,8 หรือ 9",
                "error-alert-invalid-recipient-number": "กรุณากรอกหมายเลขติดต่อที่ถูกต้อง",
                "error-alert-invalid-user-first-num": "หมายเลขโทรศัพท์มือถือควรเริ่มต้นด้วย 5,6,7,8 หรือ 9",
                "error-alert-invalid-user-number": "กรุณากรอกเบอร์มือถือที่ถูกต้อง",
                "error-alert-personal-info": "กรุณากรอกข้อมูลส่วนบุคคล",
                "error-alert-recipient-info": "กรุณากรอกข้อมูลผู้รับ",
                "error-invalid-credit-card-info": "ข้อมูลบัตรเครดิตไม่ถูกต้อง",
                "facebook-login": "ดำเนินการต่อด้วย Facebook",
                "google-login": "ดำเนินการต่อด้วย Google",
                "logged-in": "เข้าสู่ระบบ",
                "login": "ลูกค้าที่มีอยู่เข้าสู่ระบบเพื่อเพลิดเพลินกับการเช็คเอาท์ด่วน",
                "login-button": "เข้าสู่ระบบ",
                "login-email": "อีเมล์",
                "login-no-user-exists": "อ๊ะ! ขออภัยเราไม่สามารถยืนยันข้อมูลเข้าสู่ระบบของคุณ โปรดลองอีกครั้งหรือทำตามคำสั่งโดยไม่ต้องเช็คเอาท์",
                "login-password": "รหัสผ่าน",
                "payme": {
                    "error-contacting-payme": "ข้อผิดพลาดการชำระเงินกรุณาสั่งซื้อใหม่อีกครั้งหรือติดต่อฝ่ายสนับสนุนลูกค้า"
                },
                "payment": {
                    "actual-payment": "The transaction will be settled at HK${actual_payment} and the exchange rate will be based on your credit card issuer.",
                    "choose-payment-method": "เลือกวิธีการชำระเงิน:",
                    "logistic-information": "ข้อมูลการจัดส่ง",
                    "modify-information": "แก้ไขข้อมูล",
                    "pay-now": "จ่ายตอนนี้",
                    "payme-instruction-do-not-close": "กรุณาอย่าปิดหน้านี้ก่อนที่จะชำระเงินเสร็จสมบูรณ์",
                    "payme-instruction-step-1": "1. เปิดแอปพลิเค PayMe",
                    "payme-instruction-step-2": "2. สแกน PayCode เพื่ออนุมัติการชำระเงิน",
                    "payme-instruction-step-3": "3. การชำระเงินเสร็จสมบูรณ์ในแอปและรอการยืนยัน",
                    "payme-instruction-title": "การชำระเงินด้วย PayMe",
                    "payme-title": "สแกน PayCode นี้กับ PayMe",
                    "payment": "การชำระเงิน",
                    "price": "จำนวน",
                    "shipping-fee": "ค่าจัดส่ง",
                    "subtotal": "ไม่ทั้งหมด"
                },
                "payment-method": "วิธีการชำระเงิน",
                "pending": {
                    "mobile-redirection-text": "คุณได้เลือก PayMe เป็นวิธีการชำระเงินของคุณและจะมีการเปลี่ยนเส้นทางไปยัง PayMe app เพื่อชำระเงินเสร็จสมบูรณ์",
                    "need-to-pay": "จำนวนที่เหลือจำนวนที่ยังค้างอยู่",
                    "order-number": "จำนวนการสั่งซื้อ",
                    "order-success-please-pay": "กรุณาชำระเงินกับ PayMe ที่จะเสร็จสิ้นการสั่งซื้อสินค้า",
                    "paycode-error": "ข้อผิดพลาดการชำระเงินกรุณาสั่งซื้อใหม่อีกครั้งหรือติดต่อฝ่ายสนับสนุนลูกค้า",
                    "paycode-expired": "paycode PayMe หมดอายุกรุณาสั่งซื้อใหม่อีกครั้ง",
                    "re-order": "เรื่องการสั่งซื้อ",
                    "title-payme": "ชำระเงินด้วย PayMe"
                },
                "recipient-address": "ที่อยู่สำหรับการจัดส่ง",
                "recipient-information": "ข้อมูลผู้รับ",
                "recipient-name": "ชื่อผู้รับ",
                "recipient-phone-number": "หมายเลขโทรศัพท์ผู้รับ",
                "secure-payment-slogan": "การชำระเงินที่ปลอดภัย การชำระเงินจะถูกเข้ารหัสและส่งอย่างปลอดภัยโดยใช้ SSL",
                "simproduct-detail": "ข้อมูลการสั่งซื้อ",
                "simproduct-quantity": "ปริมาณ",
                "simproduct-redeem": "",
                "simproduct-redeem-hypermiles": "",
                "simproduct-title": "ผลิตภัณฑ์",
                "simproduct-will-redeeming-x-miles": "",
                "simproduct-you-have-x-hypermiles": "",
                "user-email": "อีเมล (เพื่อรับใบแจ้งหนี้)",
                "user-firstname": "ชื่อจริง",
                "user-information": "ข้อมูลส่วนตัว",
                "user-lastname": "นามสกุล",
                "user-phone-number": "เบอร์มือถือ",
                "vertical-divider": "หรือ"
            },
            "travel-sims": {
                "column-title-1": "การจำแนกที่ชัดเจนง่ายต่อการเลือก",
                "column-title-2": "ชำระเงินออนไลน์สะดวกและรวดเร็ว",
                "column-title-3": "ฟรีพื้นผิวเมลจัดส่งที่รวดเร็ว",
                "country-search-no-place-found": "ไม่พบผลลัพธ์สำหรับปลายทางนี้",
                "cover-button": "สั่งซื้อด้วยแอป HyperAir ทันที",
                "cover-slogan": "สุดยอดซิมการ์ดพร้อมจัดส่งฟรี!",
                "cover-title": "ท่องเที่ยวซิม",
                "empty-destination": "",
                "num-of-days": "",
                "search-button": "",
                "search-input": "ค้นหาประเทศ",
                "search-placeholder": "ค้นหาประเทศ",
                "search-slogan": "ไปไหน?",
                "travel-sim-header-description": "",
                "travel-sim-header-title": ""
            }
        },
        "passwords": {
            "password": "รหัสผ่านต้องมีอย่างน้อยหกตัวและตรงกับการยืนยัน",
            "reset": "รหัสผ่านของคุณถูกรีเซ็ต!",
            "sent": "เราได้ส่งลิงค์รีเซ็ตรหัสผ่านของคุณทางอีเมลแล้ว!",
            "token": "โทเค็นรีเซ็ตรหัสผ่านนี้ไม่ถูกต้อง",
            "user": "เราไม่พบผู้ใช้ด้วยที่อยู่อีเมลนั้น"
        },
        "mail": {
            "product-simcard": {
                "delivery-update": {
                    "subject": "คำสั่งซื้อซิมการ์ดของคุณกำลังดำเนินการ"
                },
                "purchased": {
                    "subject": "การยืนยันการสั่งซื้อซิมการเดินทาง"
                },
                "tracking-number-update": {
                    "subject": "หมายเลขการติดตามคำสั่งซื้อของคุณได้รับการอัพเดต"
                }
            }
        },
        "member-center": {
            "login-to-receive-codes": "",
            "my-orders-empty": "ไม่มีประวัติ",
            "my-orders-title": "สั่งซื้อของฉัน",
            "profile-area-code": "รหัสพื้นที่",
            "profile-email": "อีเมล์",
            "profile-firstname": "ชื่อจริง",
            "profile-lastname": "นามสกุล",
            "profile-save": "บันทึก",
            "profile-tel": "โทร",
            "profile-title": "ข้อมูลส่วนตัว",
            "profile-update-successfully": "",
            "promo-code-enter-promotion-code": "ใส่รหัสโปรโมชั่น",
            "promo-code-my-promo-code": "HyperAir รหัสโปรโมชั่นของฉัน",
            "promo-code-no-code": "",
            "promo-code-please-fill-in-code": "",
            "promo-code-redeem": "ไถ่ถอน",
            "promo-code-redeem-code": "แลก HyperAir รหัสโปรโมชั่น",
            "promo-code-select": "เลือก",
            "promo-code-title": "HyperAir รหัสโปรโมชั่",
            "title": "ศูนย์สมาชิก"
        },
        "weekday": {
            "1": "วันจันทร์",
            "2": "วันอังคาร",
            "3": "วันพุธ",
            "4": "วันพฤหัสบดี",
            "5": "วันศุกร์",
            "6": "วันเสาร์",
            "7": "วันอาทิตย์"
        },
        "exchange-shop-details": {
            "address": "ที่อยู่",
            "book-button": "จองตอนนี้",
            "br": "BR",
            "closed-book-button": "ปิด",
            "download-pop-up": {
                "slogan-1": "ถูกขังอยู่ในอัตรา",
                "slogan-2": "ยืนยันการจองได้ทันที",
                "title": "ดาวน์โหลด App สำหรับจอง FX"
            },
            "latest-updated": "Updated ล่าสุด",
            "not-available-book-button": "ไม่มี",
            "opening-hrs": "เวลาทำการ",
            "phone-num": "หมายเลขโทรศัพท์",
            "rate": "ประเมินค่า",
            "reviews": "ความคิดเห็น",
            "table-buy-rate": "อัตราการซื้อ",
            "table-compare-button": "เปรียบเทียบ",
            "table-currency": "เงินตรา",
            "table-sell-rate": "อัตราการขาย",
            "table-short-form": "รหัส",
            "table-title": "สกุลเงินอื่น ๆ"
        },
        "credit-card": {
            "cannot-add-card": "เกิดข้อผิดพลาดขณะเพิ่มบัตรเครดิตของคุณ โปรดตรวจสอบข้อมูลของคุณแล้วลองอีกครั้งหรือคุณอาจเพิ่มบัตรเครดิตอีกใบ",
            "cannot-process": "เกิดข้อผิดพลาดขณะเรียกเก็บเงินจากบัตรเครดิตของคุณ โปรดตรวจสอบข้อมูลของคุณแล้วลองอีกครั้งหรือคุณอาจชำระเงินด้วยบัตรเครดิตอื่น"
        },
        "shoppingcart": {
            "add": {
                "no-stock": "อ๊ะ! ถึงปริมาณที่สามารถซื้อได้สูงสุดสำหรับผลิตภัณฑ์นี้ ..."
            },
            "pay": {
                "db-locked": "เซิร์ฟเวอร์ไม่ว่าง กรุณาลองใหม่อีกครั้งในภายหลัง. (รหัสอ้างอิง: E1003)",
                "invalid-promotion-code": "รหัสโปรโมชั่นไม่ถูกต้อง",
                "no-stock": "สินค้าหมดในขณะนี้! (รหัสอ้างอิง: E1002)"
            },
            "promotion-message": {
                "up-sell-1": "สนุกไปกับ HK $ 10 พร้อมคูปองต้อนรับ",
                "up-sell-2": "สนุกไปกับ HK $ 15 ด้วยรหัสโปรโมชั่น HYPER15 เมื่อใช้จ่ายสูงกว่า HK $ 299"
            }
        },
        "product": {
            "label-confirmation-duration-24_hours": "ยืนยัน 24 ชั่วโมง",
            "label-confirmation-duration-48_hours": "ยืนยัน 48 ชั่วโมง",
            "label-confirmation-duration-instant": "ยืนยันทันที",
            "label-duration-unit-day": "& nbsp; วัน",
            "label-duration-unit-hour": "ชั่วโมง (s)",
            "label-duration-unit-hr": "& nbsp; ชั่วโมง",
            "label-duration-unit-min": "& nbsp; นาที",
            "label-earliest-available-date": "j M Y",
            "label-earliest-available-date-today": "ในวันนี้",
            "label-earliest-available-date-tomorrow": "วันพรุ่งนี้",
            "label-lang-en": "อังกฤษ",
            "label-lang-jp": "ญี่ปุ่น",
            "label-lang-kr": "เกาหลี",
            "label-lang-zh": "ชาวจีน",
            "label-meet-up-method-hotel_pickup": "รถกระบะของโรงแรม",
            "label-meet-up-method-location_meet_up": "ตรงตามสถานที่ตั้ง",
            "label-refundable-conditional_cancel": "เงื่อนไขการยกเลิก",
            "label-refundable-no_cancel": "ไม่มีการยกเลิก",
            "label-ticket-logistic-mobile": "รับบัตรกำนัลมือถือ",
            "label-ticket-logistic-printed": "รับบัตรกำนัลพิมพ์แล้ว",
            "label-ticket-logistic-printed_or_mobile": "รับบัตรกำนัลพิมพ์หรือมือถือ",
            "label-ticket-validity-fixed_date": "ตั๋ววันที่คงที่",
            "label-ticket-validity-open_date": "เปิด Date Ticket",
            "label-ticket-validity-open_or_fixed_date": "ตั๋วเปิด / กำหนดวันที่คงที่"
        },
        "pagination": {
            "next": "ถัดไป & raquo;",
            "previous": "& laquo; ก่อน"
        },
        "city": {
            "abu-dhabi": "อาบูดาบี",
            "adelaide": "แอดิเลด",
            "agra": "อักกรา",
            "ahmedabad": "อาเมดาบัด",
            "alice-springs": "อลิซสปริงส์",
            "alsace": "Alsace",
            "amritsar": "อัมริตซาร์",
            "amsterdam": "อัมสเตอร์ดัม",
            "andalusia": "ดาลูเซีย",
            "antalya": "อันตัลยา",
            "anuradhapura": "อนุราธปุระ",
            "athens": "เอเธนส์",
            "auckland": "โอ๊คแลนด์",
            "bacolod": "โคล",
            "bagan": "พุกาม",
            "baku": "บากู",
            "bali": "บาหลี",
            "bandung": "บันดุง",
            "bangalore": "บังกาลอร์",
            "bangkok": "กรุงเทพมหานคร",
            "barcelona": "บาร์เซโลนา",
            "batam": "บาตัม",
            "bath": "การอาบน้ำ",
            "bay-of-islands": "เบย์ออฟไอซ์แลนด์",
            "beijing": "ปักกิ่ง",
            "belfast": "เบลฟาส",
            "bentota": "Bentota",
            "berlin": "กรุงเบอร์ลิน",
            "bohol": "โบโฮล",
            "boracay": "โบราเคย์",
            "bordeaux": "บอร์โดซ์",
            "boston": "เมืองบอสตัน",
            "bratislava": "บราติสลาวา",
            "brisbane": "บริสเบน",
            "bruges": "บรูจส์",
            "brussels": "บรัสเซลส์",
            "budapest": "บูดาเปสต์",
            "burgundy": "มณฑลเบอร์กันดี",
            "busan": "ปูซาน",
            "cairns": "แครนส์",
            "cambridge": "เคมบริดจ์",
            "cameron-highlands": "คาเมรอนไฮแลนด์",
            "canary-islands": "หมู่เกาะคะเนรี",
            "cape-town": "เคปทาวน์",
            "cappadocia": "Cappadocia",
            "cebu": "เซบู",
            "champagne": "แชมเปญ",
            "chengdu": "เฉิงตู",
            "chennai": "เจนไน",
            "chiang-mai": "เชียงใหม่",
            "chiang-rai": "เชียงราย",
            "chiayi": "เจียอี้",
            "chicago": "เมืองชิคาโก",
            "chongqing": "ฉงชิ่ง",
            "christchurch": "ไครสต์เชิ",
            "cochin": "ตะเภา",
            "cologne": "โคโลญ",
            "colombo": "โคลัมโบ",
            "copenhagen": "โคเปนเฮเกน",
            "costa-del-sol": "คอสตาเดลโซล",
            "crete": "ครีต",
            "da-lat": "ดาลัต",
            "da-nang": "ดานัง",
            "darwin": "ดาร์วิน",
            "davao": "ดาเวา",
            "delhi": "นิวเดลี",
            "dhaka": "ธากา",
            "dresden": "เดรสเดน",
            "dubai": "ดูไบ",
            "dublin": "ดับลิน",
            "dubrovnik": "Dubrovnik",
            "dumaguete": "Dumaguete",
            "dunedin": "เดอนี",
            "düsseldorf": "Düsseldorf",
            "edinburgh": "เอดินเบอระ",
            "finnish-lapland": "",
            "florence": "ฟลอเรนซ์",
            "frankfurt": "แฟรงค์เฟิร์ต",
            "fraser-island": "เกาะเฟรเซอร์",
            "french-riviera": "ริเวียร่าฝรั่งเศส",
            "fukuoka": "ฟุกุโอกะ",
            "galle": "กอลล์",
            "galway": "กัลเวย์",
            "gangtok": "กังต็อก",
            "gangwon-do": "กังวอนทำ",
            "gdansk": "Gdansk",
            "geneva": "เหล้ายิน",
            "genting-highlands": "เก็นติ้งไฮแลนด์",
            "geraldton": "เจอรัลด์",
            "glasgow": "กลาสโกว์",
            "goa": "กัว",
            "gold-coast": "โกลด์โคสต์",
            "gothenburg": "โกเธนเบิร์ก",
            "guam": "กวม",
            "guangdong": "กว่างตง",
            "guilin": "กุ้ยหลิน",
            "guizhou": "กุ้ยโจว",
            "gyeonggi-do": "Gyeonggi-do",
            "haikou": "ไหโข่ว",
            "hakone": "ฮาโกเนะ",
            "halong": "ฮาลอง",
            "hamburg": "แฮมเบิก",
            "hangzhou": "หางโจว",
            "hanoi": "ฮานอย",
            "harbin": "ฮาร์บิน",
            "hat-yai": "หาดใหญ่",
            "hawaii": "ฮาวาย",
            "heidelberg": "ไฮเดลเบิร์ก",
            "helsinki": "เฮลซิงกิ",
            "himachal-pradesh": "รัฐหิมาจัลประเทศ",
            "hiroshima": "ฮิโรชิมา",
            "ho-chi-minh-city": "โฮจิมินห์ซิตี้",
            "hobart": "โฮบาร์ต",
            "hoi-an": "ฮอยอัน",
            "hokkaido": "ฮอกไกโด",
            "hong-kong": "ฮ่องกง",
            "hua-hin": "หัวหิน",
            "hualien": "ฮัวเหลียน",
            "hue": "สี",
            "hyderabad": "ไฮเดอรา",
            "iloilo": "อิโลอิโล",
            "incheon": "อินชอน",
            "inle-lake": "ทะเลสาบอินเล",
            "inner-mongolia": "มองโกเลียใน",
            "innsbruck": "อินส์บรุ",
            "interlaken": "Interlaken",
            "inverness": "อินเวอร์เนส",
            "ipoh": "อีโปห์",
            "istanbul": "อิสตันบูล",
            "jaipur": "ชัยปุระ",
            "jaisalmer": "Jaisalmer",
            "jakarta": "จาการ์ตา",
            "jeju": "เกาะเชจู",
            "jerusalem": "เยรูซาเล็ม",
            "jodhpur": "โช ธ ปุระ",
            "johor-bahru": "ยะโฮร์บาห์รู",
            "kandy": "แคนดี้",
            "kaohsiung": "เกาสง",
            "kathmandu": "ฐมา ณ ฑุ",
            "kazan": "คาซาน",
            "kenting": "Kenting",
            "kiev": "เคียฟ",
            "kinmen": "Kinmen",
            "kobe": "โกเบ",
            "koh-chang": "เกาะช้าง",
            "koh-samui": "เกาะสมุย",
            "krabi": "กระบี่",
            "krakow": "คราคูฟ",
            "kuala-lumpur": "กัวลาลัมเปอร์",
            "kumamoto": "คุมาโมโตะ",
            "kyoto": "เกียวโต",
            "kyushu": "คิวชู",
            "lake-district": "เขตทะเลสาบ",
            "langkawi": "ลังกาวี",
            "lapland": "Lapland",
            "las-vegas": "ลาสเวกัส",
            "launceston": "ลอนเซสตัน",
            "lausanne": "เมืองโลซานน์",
            "leipzig": "เมืองไลพซิก",
            "lisbon": "นครลีสบัน",
            "liverpool": "ลิเวอร์พูล",
            "ljubljana": "ลูบลิยานา",
            "loire-valley": "หุบเขาลัวร์",
            "lombok": "ลอมบอก",
            "london": "กรุงลอนดอน",
            "los-angeles": "ลอสแองเจลิส",
            "luang-prabang": "หลวงพระบาง",
            "lucerne": "ลูเซิร์น",
            "lviv": "Lviv",
            "lyon": "ลียง",
            "macao": "มาเก๊า",
            "macau": "",
            "madrid": "กรุงมาดริด",
            "malaga": "มาลาก้า",
            "manchester": "แมนเชสเตอร์",
            "mandalay": "มั ณ ฑะเล",
            "manila": "มะนิลา",
            "marrakech": "มาราเกช",
            "mauritius": "มอริเชียส",
            "medan": "เมดาน",
            "melaka": "มะละกา",
            "melbourne": "เมลเบิร์น",
            "miami": "ไมอามี่",
            "milford-sound": "Milford Sound",
            "montreux": "Montreux",
            "moscow": "กรุงมอสโก",
            "mumbai": "มุมไบ",
            "munich": "มิวนิค",
            "muscat": "องุ่นหวานมัซคะท",
            "nagano": "นากาโนะ",
            "nagoya": "นาโกย่า",
            "naples": "เนเปิลส์",
            "nelson": "เนลสัน",
            "new-delhi": "นิวเดลี",
            "new-york": "นิวยอร์ก",
            "nha-trang": "ญาจาง",
            "niagara-falls": "Niagara Falls",
            "niigata": "นิอิกาตะ",
            "normandy": "นอร์มองดี",
            "odessa": "โอเดสซา",
            "okayama": "Okayama",
            "okinawa": "โอกินาว่า",
            "orlando": "ออร์แลนโด",
            "osaka": "โอซาก้า",
            "oslo": "ออสโล",
            "oxford": "ฟอร์ด",
            "palawan": "ปาลาวัน",
            "paris": "ปารีส",
            "pattaya": "พัทยา",
            "penang": "ปีนัง",
            "penghu": "Penghu",
            "perth": "เพิร์ ธ",
            "philadelphia": "นครฟิลาเดลเฟีย",
            "phnom-penh": "พนมเปญ",
            "phu-quoc": "ฟูก๊วก",
            "phuket": "ภูเก็ต",
            "pisa": "ปิซา",
            "pokhara": "โปขระ",
            "port-lincoln": "พอร์ตลินคอล์น",
            "porto": "",
            "porto-district": "อำเภอปอร์โต",
            "prague": "ปราก",
            "provence": "โปรวองซ์",
            "puglia": "Puglia",
            "pune": "Pune",
            "pushkar": "ปุชการ์",
            "queenstown": "ควีนส์ทาวน์",
            "ras-al-khaimah": "ราสอัลไคมาห์",
            "reykjavik": "เรคยาวิก",
            "rhodes": "โรดส์",
            "rhône-alpes": "โรนาลป์",
            "rome": "กรุงโรม",
            "rotorua": "โรโตรัว",
            "rotterdam": "ร็อตเตอร์",
            "sabah": "ซาบาห์",
            "saint-petersburg": "เซนต์ปีเตอร์สเบิร์ก",
            "saipan": "ไซปัน",
            "salzburg": "Salzburg",
            "san-diego": "ซานดิเอโก",
            "san-francisco": "ซานฟรานซิสโก",
            "santorini": "ซานโตรินี",
            "sanya": "ซานย่า",
            "sapa": "ซาปา",
            "sarawak": "รัฐซาราวัก",
            "seattle": "ซีแอตเติ",
            "seoul": "โซล",
            "seville": "เซวิลล์",
            "shanghai": "เซี่ยงไฮ้",
            "sibiu": "ซีบีอู",
            "sicily": "เกาะซีซิลิ",
            "siem-reap": "เสียมราฐ",
            "sihanoukville": "สีหนุวิล",
            "singapore": "สิงคโปร์",
            "split": "แยก",
            "surabaya": "สุราบายา",
            "suzhou": "ซูโจว",
            "swedish-lapland": "สวีเดนแลปแลนด์",
            "sydney": "ซิดนีย์",
            "taichung": "ไทจง",
            "tainan": "ไถหนาน",
            "taipei": "ไทเป",
            "taitung": "Taitung",
            "tarragona": "ตาราโกนา",
            "taupo": "เทาโป",
            "terengganu": "ตรังกานู",
            "thessaloniki": "เทสซาโล",
            "tokyo": "โตเกียว",
            "toledo": "Toledo",
            "trincomalee": "มะลี",
            "turin": "ตูริน",
            "udaipur": "อุทัยปุระ",
            "uluru": "Uluru",
            "uttarakhand": "ตราขั ณ ฑ์",
            "varanasi": "พารา ณ สี",
            "venice": "เวนิซ",
            "verona": "เวโรนา",
            "vienna": "เวียนนา",
            "vientiane": "เวียงจันทน์",
            "volendam": "โวเลนดัม",
            "washington-dc": "วอชิงตันดีซี",
            "wellington": "เวลลิงตัน",
            "whitsundays": "วิตซันเดย์",
            "xiamen": "เซียะเหมิ",
            "xian": "ซีอาน",
            "yangon": "ย่างกุ้ง",
            "yilan": "Yilan",
            "yogyakarta": "ยาการ์ตา",
            "york": "นิวยอร์ก",
            "yunnan": "มณฑลยูนนาน",
            "zagreb": "ซาเกร็บ",
            "zhangjiajie": "จางเจียเจี้ย",
            "zurich": "ซูริค"
        },
        "validation": {
            "accepted": "ต้องยอมรับแอตทริบิวต์:",
            "active_url": "คุณลักษณะ: ไม่ใช่ URL ที่ถูกต้อง",
            "after": "แอตทริบิวต์: ต้องเป็นวันที่หลังจาก: วันที่",
            "after_or_equal": "แอตทริบิวต์: ต้องเป็นวันที่หลังหรือเท่ากับ: วันที่",
            "alpha": "คุณลักษณะ: อาจมีเฉพาะตัวอักษร",
            "alpha_dash": "แอททริบิวต์: อาจประกอบด้วยตัวอักษรตัวเลขและขีดกลางเท่านั้น",
            "alpha_num": "แอตทริบิวต์: อาจมีเฉพาะตัวอักษรและตัวเลขเท่านั้น",
            "array": "กระบวนการ: แอตทริบิวต์ต้องเป็นอาร์เรย์",
            "before": "แอตทริบิวต์: ต้องเป็นวันที่ก่อน: วันที่",
            "before_or_equal": "แอตทริบิวต์: ต้องเป็นวันที่ก่อนหรือเท่ากับ: วันที่",
            "between": {
                "array": "แอ็ตทริบิวต์: ต้องมีไอเท็มระหว่าง: min และ: max",
                "file": "แอ็ตทริบิวต์: ต้องอยู่ระหว่าง: min และ: max kilobytes",
                "numeric": "แอตทริบิวต์: ต้องอยู่ระหว่าง: min และ: max",
                "string": "แอ็ตทริบิวต์: ต้องอยู่ระหว่าง: นาทีและ: สูงสุดตัวอักษร"
            },
            "boolean": "ฟิลด์: แอตทริบิวต์ต้องเป็นจริงหรือเท็จ",
            "confirmed": "กระบวนการ: การยืนยันคุณสมบัติไม่ตรงกัน",
            "custom": {
                "attribute-name": {
                    "rule-name": "ที่กำหนดเองข้อความ"
                }
            },
            "date": "แอตทริบิวต์: ไม่ใช่วันที่ที่ถูกต้อง",
            "date_format": "คุณลักษณะ: ไม่ตรงกับรูปแบบ: รูปแบบ",
            "different": "แอตทริบิวต์: และ: อื่น ๆ จะต้องแตกต่างกัน",
            "digits": "แอตทริบิวต์: ต้องเป็น: ดิจิตหลัก",
            "digits_between": "แอ็ตทริบิวต์: ต้องอยู่ระหว่าง: นาทีและ: หลักสูงสุด",
            "dimensions": "แอตทริบิวต์: มีขนาดภาพที่ไม่ถูกต้อง",
            "distinct": "ฟิลด์: แอตทริบิวต์มีค่าซ้ำกัน",
            "email": "แอตทริบิวต์: ต้องเป็นที่อยู่อีเมลที่ถูกต้อง",
            "exists": "แอตทริบิวต์ที่เลือก: ไม่ถูกต้อง",
            "file": "แอ็ตทริบิวต์: ต้องเป็นไฟล์",
            "filled": "",
            "image": "",
            "in": "แอตทริบิวต์ที่เลือก: ไม่ถูกต้อง",
            "in_array": "",
            "integer": "",
            "ip": "",
            "ipv4": "",
            "ipv6": "",
            "json": "",
            "max": {
                "array": "",
                "file": "",
                "numeric": "",
                "string": ""
            },
            "mimes": "",
            "mimetypes": "",
            "min": {
                "array": "",
                "file": "",
                "numeric": "",
                "string": ""
            },
            "not_in": "แอตทริบิวต์ที่เลือก: ไม่ถูกต้อง",
            "numeric": "",
            "present": "",
            "regex": "",
            "required": "",
            "required_if": "",
            "required_unless": "",
            "required_with": "",
            "required_with_all": "",
            "required_without": "",
            "required_without_all": "",
            "same": "",
            "size": {
                "array": "",
                "file": "",
                "numeric": "",
                "string": ""
            },
            "string": "",
            "timezone": "",
            "unique": "",
            "uploaded": "",
            "url": ""
        },
        "reset-password": {
            "confirm-new-password": "ยืนยันรหัสผ่านใหม่",
            "enter-new-password": "ใส่รหัสผ่านใหม่",
            "please-enter-a-new-password": "โปรดป้อนรหัสผ่านใหม่สำหรับบัญชีของคุณ: อีเมล",
            "submit": "เสนอ",
            "success-content": "ประสบความสำเร็จ! โปรดลงชื่อเข้าใช้แอปมือถือ HyperAir ด้วยรหัสผ่านใหม่",
            "title": "รีเซ็ตรหัสผ่าน",
            "validation-display": "รหัสผ่านจะต้องมีอย่างน้อย 6 ตัวอักษร"
        },
        "notification": {
            "activation-e-minus-content": "นับถอยหลัง 15 วัน! คูปองต้อนรับ Travel SIM ของคุณจะหมดอายุเร็ว ๆ นี้! อย่าพลาดโอกาสในการใช้คูปองสำหรับการเดินทางครั้งต่อไปของคุณ!",
            "activation-e-minus-title": "",
            "activation-t-plus-content": "อย่าลืมใช้คูปองซิมการ์ดต้อนรับสำหรับการเดินทางที่กำลังจะมาถึงของคุณ! ท่องเที่ยวอย่างชาญฉลาด ทุกแห่ง",
            "activation-t-plus-title": "",
            "ask-shop-to-quote-content": "ขอใบเสนอราคาสำหรับการซื้อ: จำนวน: สกุลเงิน",
            "ask-shop-to-quote-content2": "ขอใบเสนอราคาสำหรับการขาย: จำนวน: สกุลเงิน",
            "ask-shop-to-quote-title": "คำขอใหม่สำหรับใบเสนอราคา",
            "email-booking-details": "รายละเอียดการจอง",
            "email-booking-id": "รหัสการจอง",
            "email-exchange-approved-content": "คำสั่งซื้อแลกเปลี่ยนได้รับการอนุมัติสำหรับการซื้อ: จำนวน: สกุลเงินในอัตรา: อัตรา",
            "email-exchange-approved-footer": "ขอบคุณที่ใช้ HyperAir",
            "email-exchange-approved-title": "ร้านค้าตอบ \"เงินเดินทางของคุณพร้อมรับ!\"",
            "email-exchange-completed-content": "คำสั่งซื้อแลกเปลี่ยนเสร็จสมบูรณ์สำหรับการซื้อ: จำนวน: สกุลเงินในอัตรา: อัตรา",
            "email-exchange-completed-footer": "ขอบคุณที่ใช้ HyperAir",
            "email-exchange-completed-title": "การแลกเปลี่ยนเงินการเดินทางของคุณเสร็จสิ้นแล้ว!",
            "email-exchange-confirmed-content": "ยืนยันคำสั่งซื้อแลกเปลี่ยน: จำนวน: สกุลเงินในอัตรา: อัตรา",
            "email-exchange-confirmed-footer": "ขอบคุณที่ใช้ HyperAir",
            "email-exchange-confirmed-title": "เงินเดินทางของคุณพร้อมสำหรับการรับของคุณ!",
            "email-footer-copy-right": "สงวนลิขสิทธิ์.",
            "email-greetings": "สวัสดี!",
            "email-i-got": "ฉันได้",
            "email-i-paid": "ฉันจ่ายเงิน",
            "email-i-will-get": "ฉันจะได้รับ",
            "email-i-will-pay": "ฉันจะจ่าย",
            "email-pickup-before": "รถกระบะมาก่อน",
            "email-product-confirmed-greeting": "เรียนลูกค้าผู้มีเกียรติทุกท่าน<br><br>ขอบคุณที่ใช้ HyperAir บัตรกำนัลของคุณพร้อมแล้ว",
            "email-product-confirmed-subject": "ยืนยันการสั่งซื้อแล้ว",
            "email-product-confirmed-title": "คำสั่งซื้อของคุณได้รับการยืนยัน",
            "email-product-purchased": {
                "shipping": {
                    "international": "การจัดส่งสินค้าระหว่างประเทศ",
                    "sf": "เอสเอฟเอ็กซ์ (ฮ่องกงเท่านั้น)"
                }
            },
            "email-product-purchased-delievery-address": "ที่อยู่สำหรับการจัดส่ง",
            "email-product-purchased-delivery-info": "ข้อมูลการจัดส่งสินค้า",
            "email-product-purchased-delivery-method": "วิธีการจัดส่งสินค้า",
            "email-product-purchased-discount": "ส่วนลด",
            "email-product-purchased-email": "อีเมล์",
            "email-product-purchased-greeting": "เรียนลูกค้าผู้มีเกียรติทุกท่าน<br><br> ทางเลือกที่ดี จะใช้เวลาสักครู่เพื่อยืนยันการจอง แต่ไม่ต้องกังวลเวลาส่วนใหญ่เราสามารถยืนยันการสั่งซื้อภายใน 12 ชั่วโมง ขอบคุณที่ใช้ HyperAir!",
            "email-product-purchased-have-a-nice-trip": "เที่ยวให้สนุกนะ!",
            "email-product-purchased-important-notice": "เป็นไปตามข้อกำหนดและเงื่อนไข",
            "email-product-purchased-important-notice-content": "เป็นไปตามข้อกำหนดและเงื่อนไข",
            "email-product-purchased-name": "ชื่อ",
            "email-product-purchased-order-date": "วันสั่ง",
            "email-product-purchased-order-details": "รายละเอียดการสั่งซื้อ",
            "email-product-purchased-order-no": "หมายเลขสั่งซื้อ",
            "email-product-purchased-personal-info": "ข้อมูลส่วนตัว",
            "email-product-purchased-receipient-name": "ชื่อผู้รับ",
            "email-product-purchased-receipient-phone-no": "เบอร์โทรศัพท์",
            "email-product-purchased-shipping-fee": "ค่าบริการจัดส่งสินค้า",
            "email-product-purchased-sub-total": "ตำบลทั้งหมด",
            "email-product-purchased-subject": "คำสั่งซื้ออยู่ระหว่างรอการยืนยัน",
            "email-product-purchased-title": "คำสั่งซื้อของคุณอยู่ระหว่างดำเนินการ",
            "email-product-purchased-total": "ทั้งหมด",
            "email-product-simcapurchased-personal-info": "ข้อมูลส่วนตัว",
            "email-product-simcard-delivery-title": "ใบสั่งซื้อของคุณ SIM: order-num ได้รับการจัดเตรียมและจัดส่งในวันที่ หากคุณเลือก SF Express เราจะแจ้งหมายเลขติดตามในภายหลัง คุณสามารถตรวจสอบได้จากแอพมือถือของเรา",
            "email-product-simcard-delivery-title-carbon-format": "j M Y",
            "email-product-simcard-delivery-update-greeting": "เรียนลูกค้าผู้มีเกียรติทุกท่าน<br><br>ขอบคุณที่ใช้ HyperAir คำสั่งซื้อซิมการ์ดของคุณกำลังจะมาถึง",
            "email-product-simcard-delivery-update-title": "คำสั่งซื้อซิมการ์ดของคุณกำลังดำเนินการ",
            "email-product-simcard-delivery-update-tracking": "ติดตามรายละเอียด",
            "email-product-simcard-delivery-update-tracking-no": "หมายเลขติดตาม",
            "email-product-simcard-delivery-update-tracking-no-hkpost": "หมายเลขติดตาม: -",
            "email-product-simcard-delivery-update-tracking-no-sf": "หมายเลขติดตาม",
            "email-product-simcard-delivery-waiting-update-tracking-no-sf": "กำลังรอการอัปเดต SF Express",
            "email-product-simcard-delivery-with-tracking-num-title": "ใบสั่งซื้อของคุณ SIM: order-num จะถูกจัดส่งโดย SF Express พร้อมหมายเลขติดตาม:: tracking-num โปรดให้ความสนใจกับโทรศัพท์มือถือของคุณเพื่อรับการจัดส่ง คุณสามารถตรวจสอบสถานะการจัดส่งได้ที่เว็บไซต์ SF Express ขอบคุณที่ใช้บริการ HyperAir",
            "email-product-simcard-esim-code-greeting": "เรียนลูกค้าผู้มีเกียรติทุกท่าน<br><br>ขอบคุณที่ใช้ HyperAir นี่คือรหัส QR การเปิดใช้งาน eSIM ของคุณ",
            "email-product-simcard-esim-code-important-notice-content": "<span style=\"font-size: 10px; line-height: 12px;\">คำแนะนำ:<br />1. ไปที่การตั้งค่า<br />2. แตะที่ \"ข้อมูลมือถือ\"<br />3. ในแผนข้อมูลแตะ \"เพิ่มแผนข้อมูล\"<br />4. สแกนรหัส QR ในกล้อง frame<br />หากคุณถูกขอให้ป้อนรหัสยืนยันเพื่อเปิดใช้งาน eSIM ให้ป้อนหมายเลขที่ผู้ให้บริการระบุ มีคำถาม? โปรดส่งอีเมลไปที่ hello@hyperair.com แล้วเราจะติดต่อกลับไปหาคุณ</span>",
            "email-product-simcard-esim-code-title": "นี่คือรหัส QR การเปิด���ช้งาน eSIM ข��งคุณ",
            "email-product-simcard-esim-code-warning": "โปรดทราบว่า eSIM จะเปิดใช้งานเมื่อสแกนรหัส QR แล้ว โปรดสแกนเฉพาะเมื่อคุณต้องการเริ่มบริการ",
            "email-product-simcard-purchased-delievery-address": "ที่อยู่สำหรับการจัดส่ง",
            "email-product-simcard-purchased-delivery-info": "ข้อมูลการจัดส่ง",
            "email-product-simcard-purchased-delivery-method": "วิธีการจัดส่ง",
            "email-product-simcard-purchased-discount": "ส่วนลด",
            "email-product-simcard-purchased-greeting": "เรียนลูกค้าผู้มีเกียรติทุกท่าน<br><br>ขอบคุณที่ใช้ HyperAir เรากำลังเตรียมการจัดส่งของ Travel SIM ของคุณ",
            "email-product-simcard-purchased-greeting-esim-only": "เรียนลูกค้าผู้มีอุปการะคุณ<br><br>ขอบคุณที่ใช้ HyperAir eSIM ของคุณพร้อมแล้ว! กรุณาค้นหารหัส QR ที่แนบมาและเปิดใช้งานตามคำแนะนำ",
            "email-product-simcard-purchased-greeting-esim-with-sim": "เรียนลูกค้าผู้มีเกียรติทุกท่าน<br><br>ขอบคุณที่ใช้ HyperAir เรากำลังเตรียมการจัดส่งของ Travel SIM ของคุณ สำหรับ eSIM ของคุณโปรดค้นหารหัส QR ที่แนบมาและเปิดใช้งานตามคำแนะนำ",
            "email-product-simcard-purchased-greeting-sim-only": "เรียนลูกค้าผู้มีเกียรติทุกท่าน<br><br>ขอบคุณที่ใช้ HyperAir เรากำลังเตรียมการจัดส่งของ Travel SIM ของคุณ",
            "email-product-simcard-purchased-have-a-nice-trip": "เที่ยวให้สนุกนะ!",
            "email-product-simcard-purchased-important-notice": "ประกาศสำคัญ",
            "email-product-simcard-purchased-important-notice-content": "<span style=\"font-size: 10px; line-height: 12px;\">1. ทางไปรษณีย์ท้องถิ่นของฮ่องกงโพสต์การจัดส่งโดยประมาณจะอยู่ภายใน 5 วันทำการ การติดตามสถานะไม่สามารถใช้ได้กับเมลท้องถิ่นและลูกค้าจะต้องรับผิดชอบอย่างเต็มที่ต่อการสูญเสียไอเท็มโดยใช้ฮ่องกง </span><br> <span style=\"font-size: 10px; line-height: 12px;\">2. โปรดเปิดใช้งานซิมการ์ดการท่องเที่ยวก่อนหมดอายุ</span><br> <span style=\"font-size: 10px; line-height: 12px;\">3. ผลิตภัณฑ์ที่จัดส่งทั้งหมดอยู่ภายใต้ข้อกำหนดและเงื่อนไข</span><br><br> <span style=\"font-size: 10px; line-height: 12px;\">มีคำถามหรือไม่ โปรดส่งอีเมลไปที่ hello@hyperair.com แล้วเราจะติดต่อกลับไปหาคุณ</span>",
            "email-product-simcard-purchased-important-notice-content-esim-only": "<span style=\"font-size: 10px; line-height: 12px;\">1. ทางไปรษณีย์ท้องถิ่นของฮ่องกงโพสต์การจัดส่งโดยประมาณจะอยู่ภายใน 5 วันทำการ การติดตามสถานะไม่สามารถใช้ได้กับเมลท้องถิ่นและลูกค้าจะต้องรับผิดชอบอย่างเต็มที่ต่อการสูญเสียไอเท็มโดยใช้ฮ่องกง </span><br> <span style=\"font-size: 10px; line-height: 12px;\">2. โปรดเปิดใช้งานซิมการ์ดการท่องเที่ยวก่อนหมดอายุ</span><br> <span style=\"font-size: 10px; line-height: 12px;\">3. ผลิตภัณฑ์ที่จัดส่งทั้งหมดอยู่ภายใต้ข้อกำหนดและเงื่อนไข</span><br><br> <span style=\"font-size: 10px; line-height: 12px;\">มีคำถามหรือไม่ โปรดส่งอีเมลไปที่ hello@hyperair.com แล้วเราจะติดต่อกลับไปหาคุณ</span>",
            "email-product-simcard-purchased-important-notice-content-esim-with-sim": "<span style=\"font-size: 10px; line-height: 12px;\">1. ทางไปรษณีย์ท้องถิ่นของฮ่องกงโพสต์การจัดส่งโดยประมาณจะอยู่ภายใน 5 วันทำการ การติดตามสถานะไม่สามารถใช้ได้กับเมลท้องถิ่นและลูกค้าจะต้องรับผิดชอบอย่างเต็มที่ต่อการสูญเสียไอเท็มโดยใช้ฮ่องกง </span><br> <span style=\"font-size: 10px; line-height: 12px;\">2. โปรดเปิดใช้งานซิมการ์ดการท่องเที่ยวก่อนหมดอายุ</span><br> <span style=\"font-size: 10px; line-height: 12px;\">3. ผลิตภัณฑ์ที่จัดส่งทั้งหมดอยู่ภายใต้ข้อกำหนดและเงื่อนไข</span><br><br> <span style=\"font-size: 10px; line-height: 12px;\">มีคำถามหรือไม่ โปรดส่งอีเมลไปที่ hello@hyperair.com แล้วเราจะติดต่อกลับไปหาคุณ</span>",
            "email-product-simcard-purchased-important-notice-content-sim-only": "<span style=\"font-size: 10px; line-height: 12px;\">1. ทางไปรษณีย์ท้องถิ่นของฮ่องกงโพสต์การจัดส่งโดยประ���าณจะอยู่ภายใน 5 วันทำการ การติดตามสถานะไม่สามารถใช้ได้กับเมลท้องถิ่นและลูกค้าจะต้องรับผิดชอบอย่างเต็มที่ต่อการสูญเสียไอเท็มโดยใช้ฮ่องกง </span><br> <span style=\"font-size: 10px; line-height: 12px;\">2. โปรดเปิดใช้งานซิมการ์ดการท่องเที่ยวก่อนหมดอายุ</span><br> <span style=\"font-size: 10px; line-height: 12px;\">3. ผลิตภัณฑ์ที่จัดส่งทั้งหมดอยู่ภายใต้ข้อกำหนดและเงื่อนไข</span><br><br> <span style=\"font-size: 10px; line-height: 12px;\">มีคำถามหรือไม่ โปรดส่งอีเมลไปที่ hello@hyperair.com แล้วเราจะติดต่อกลับไปหาคุณ</span>",
            "email-product-simcard-purchased-order-date": "วันสั่ง",
            "email-product-simcard-purchased-order-details": "รายละเอียดการสั่งซื้อ",
            "email-product-simcard-purchased-order-no": "หมายเลขสั่งซื้อ",
            "email-product-simcard-purchased-personal-info": "ข้อมูลส่วนตัว",
            "email-product-simcard-purchased-receipient-name": "ชื่อผู้รับ",
            "email-product-simcard-purchased-receipient-phone-no": "หมายเลขโทรศัพท์ของผู้รับ",
            "email-product-simcard-purchased-shipping-fee": "ค่าจัดส่ง",
            "email-product-simcard-purchased-sub-total": "ตำบลทั้งหมด",
            "email-product-simcard-purchased-title": "คำสั่งซื้อ Travel SIM ของคุณได้รับการยืนยันแล้ว",
            "email-product-simcard-purchased-title-esim-only": "คำสั่ง Travel eSIM ของคุณได้รับการยืนยันแล้ว",
            "email-product-simcard-purchased-title-esim-with-sim": "คำสั่งซื้อ Travel SIM ของคุณได้รับการยืนยันแล้ว",
            "email-product-simcard-purchased-title-sim-only": "คำสั่งซื้อ Travel SIM ของคุณได้รับการยืนยันแล้ว",
            "email-product-simcard-purchased-total": "ทั้งหมด",
            "email-product-simcard-tracking-number-updated-greeting": "เรียนท่านลูกค้าที่มีค่า<br><br>ขอบคุณอีกครั้งสำหรับการใช้ HyperAir หมายเลขการติดตามของคุณได้รับการอัพเดต",
            "email-product-simcard-tracking-number-updated-title": "อัปเดตสถานะการติดตามคำสั่งซื้อของคุณแล้ว",
            "email-product-simcard-tracking-number-updated-tracking-no-sf": "หมายเลขติดตาม",
            "email-product-type-confirmed-greeting": "",
            "email-product-type-confirmed-title": "",
            "email-product-type-purchased-greeting": "",
            "email-product-type-purchased-title": "",
            "email-rate": "ประเมินค่า",
            "email-shop-name": "ชื่อร้านค้า",
            "email-verification-action": "ยืนยันอีเมลของคุณ",
            "email-verification-content": "ยินดีต้อนรับสู่ HyperAir! ในการสมัครให้เสร็จคุณต้องยืนยันว่าเราได้รับอีเมลของคุณถูกต้อง",
            "email-verification-title": "โปรดยืนยันอีเมลของคุณ",
            "email-verified-content": "อ��เมลของคุณได้รับการยืนยันแล้ว ขอบคุณที่เข้าร่วม HyperAir",
            "email-verified-title": "ยืนยันอีเมลแล้ว",
            "engagement-content": "ใช้งานยินดีต้อนรับ 10",
            "engagement-title": "ใช้งานยินดีต้อนรับ 10",
            "exchange-approved-content": "การยืนยันการซื้อ: จำนวน: สกุลเงินในอัตรา: อัตรา",
            "exchange-approved-content2": "การยืนยันการขาย: จำนวน: สกุลเงินในอัตรา: อัตรา",
            "exchange-approved-footer": "",
            "exchange-approved-title": "ร้านค้าตอบ \"เงินเดินทางของคุณพร้อมรับ!\"",
            "exchange-cancelled-content": "ลูกค้ายกเลิกคำสั่งซื้อ: จำนวน: สกุลเงินในอัตรา: อัตรา",
            "exchange-cancelled-content2": "ลูกค้ายกเลิกคำสั่งขาย: จำนวน: สกุลเงินในอัตรา: อัตรา",
            "exchange-cancelled-title": "ยกเลิกคำสั่งซื้อแลกเปลี่ยนแล้ว",
            "exchange-completed-content": "เสร็จสิ้นการซื้อ: จำนวน: สกุลเงินในอัตรา: อัตรา",
            "exchange-completed-content2": "เสร็จสิ้นการขาย: จำนวน: สกุลเงินในอัตรา: อัตรา",
            "exchange-completed-footer": "",
            "exchange-completed-title": "การแลกเปลี่ยนเงินการเดินทางของคุณเสร็จสิ้นแล้ว!",
            "exchange-confirmed-content": "คุณยืนยันลูกค้าที่ซื้อ: จำนวน: สกุลเงินในอัตรา: อัตรา",
            "exchange-confirmed-content2": "คุณยืนยันลูกค้าที่จะขาย: จำนวน: สกุลเงินในอัตรา: อัตรา",
            "exchange-confirmed-footer": "",
            "exchange-confirmed-title": "ได้รับคำสั่งซื้อแลกเปลี่ยนใหม่",
            "exchange-pending-content": "ตรวจสอบคำสั่งซื้อใหม่: จำนวน: สกุลเงินในอัตรา: อัตรา",
            "exchange-pending-content2": "คำสั่งซื้อที่รอการขาย: จำนวน: สกุลเงินในอัตรา: อัตรา",
            "exchange-pending-title": "รอการอนุมัติคำสั่งซื้อใหม่",
            "exchange-rejected-content": "ไม่สามารถทำการสั่งซื้อสำหรับการซื้อ: จำนวน: สกุลเงินในอัตรา: อัตรา กรุณาจองกับร้านค้าอีกครั้ง",
            "exchange-rejected-content2": "ไม่สามารถทำการสั่งซื้อเพื่อขาย: จำนวน: สกุลเงินในอัตรา: อัตรา กรุณาจองกับร้านค้าอีกครั้ง",
            "exchange-rejected-title": "อ๊ะ! ขออภัยทางร้านไม่สามารถรับสินค้าได้",
            "footer-trouble-link": "หากคุณมีปัญหาในการคลิกปุ่ม \": actionText\" ให้คัดลอกและวาง URL ด้านล่างลงในเว็บเบราว์เซอร์ของคุณ: <a href=\"{actionUrl}\">: actionUrl</a>",
            "password-reset-action": "รีเซ็ตรหัสผ่าน",
            "password-reset-content": "คุณได้รับอีเมลนี้เนื่องจากเราได้รับคำขอรีเซ็ตรหัสผ่านสำหรับบัญชีของคุณ",
            "password-reset-footer": "หากคุณไม่ได้ร้องขอการรีเซ็ตรหัสผ่านคุณไม่จำเป็นต้องดำเนินการใด ๆ อีก",
            "password-reset-title": "รีเซ็ตรหัสผ่าน",
            "simcard-purchased-title": "",
            "sms-verification-content": "รหัส HyperAir ของคุณคือ: authenticationCode"
        },
        "error": {
            "all-shops-are-closed": "อ๊ะร้านค้าทั้งหมดปิดตอนนี้ กรุณาลองใหม่อีกครั้งในภายหลัง.",
            "cancel-booking-failed": "คำสั่งนี้อาจจะเสร็จสมบูรณ์หมดอายุหรือยกเลิก โปรดตรวจสอบคำสั่งนี้ใน [การจองของฉัน> เสร็จสมบูรณ์] หรือ [การจองของฉัน> ไม่สมบูรณ์]",
            "cancel-booking-failed-title": "ไม่สามารถยกเลิกคำสั่งซื้อนี้",
            "invalid-api-app-version": "อัปเดตแอปทันทีเพื่อรับฟังก์ชั่นใหม่และเพลิดเพลินไปกับส่วนลด 5% สำหรับการสั่งซื้อ Travel SIM ด้วยรหัสโปรโมชั่น“ GIVEME5” !!",
            "invalid-old-password": "รหัสผ่านที่มีอยู่ไม่ถูกต้อง",
            "password-incorrect": "รหัสผ่านผิดพลาด.",
            "phone-number-is-already-registered": "หมายเลขโทรศัพท์นี้ได้รับการลงทะเบียนด้วยที่อยู่อีเมลอื่นแล้ว คุณสามารถเข้าสู่ระบบด้วยที่อยู่อีเมลที่ถูกต้อง กรุณาส่งอีเมลไปที่ hello@hyperair.com สำหรับการสนับสนุนใด ๆ",
            "this-email-is-registered": "ที่อยู่อีเมลนี้ถูกใช้โดยบัญชีอื่นแล้ว",
            "this-phone-number-is-registered": "หมายเลขโทรศัพท์นี้ได้รับการลงทะเบียนแล้ว กรุณาส่งอีเมลไปที่ hello@hyperair.com สำหรับการสนับสนุนใด ๆ"
        },
        "marketplace": {
            "homepage-product": "สินค้ายอดนิยม",
            "homepage-recently-viewed": "ดูล่าสุด",
            "product-carousels": {
                "group1": "ประสบการณ์ฤดูร้อน",
                "group2": "ระดับสูง"
            }
        }
    },
    "vi": {
        "currency": {
            "aed": "UAE Dirham",
            "afn": "Afghanistan Afghanistan",
            "all": "Albania Lek",
            "amd": "Armenia Dram",
            "ang": "Hà Lan Antillean Gulden",
            "aoa": "Angola Kwanza",
            "ars": "Argentina Peso",
            "aud": "Dollar Úc",
            "awg": "Aruban Florin",
            "azn": "Azerbaijan Manat",
            "bam": "Bosnia và Herzegovina Nhãn hiệu",
            "bbd": "Barbadian Dollar",
            "bdt": "Bangladesh Taka",
            "bgn": "Lép Bungari",
            "bhd": "Bahrain Dinar",
            "bif": "Burundi Franc",
            "bnd": "Brunei Dollar",
            "bob": "Bolivia Bôlivia",
            "brl": "Real Braxin",
            "bsd": "Đô la Bahamas",
            "btc": "Bitcoin",
            "btn": "Bhutan Ngultrum",
            "bwp": "Botswana Pula",
            "byn": "New Belarus Ruble",
            "bzd": "Belize Dollar",
            "cad": "Đô la Canada",
            "cdf": "Congo Franc",
            "chf": "Franc Thụy Sĩ",
            "clp": "Peso Chilê",
            "cop": "Peso Colombia",
            "crc": "Colon Costa Rica",
            "cup": "Cuba Peso",
            "cve": "Cape Verde Escudo",
            "czk": "Cuaron Séc",
            "djf": "Djibouti Franc",
            "dkk": "Krone Đan Mạch",
            "dop": "Dominican Peso",
            "dzd": "Algeria Dinar",
            "egp": "Bảng Ai Cập",
            "ern": "Eritrea Nakfa",
            "etb": "Birr Ethiopia",
            "eur": "Euro",
            "fjd": "Dollar Fiji",
            "fkp": "Quần đảo Falkland Pound",
            "gbp": "Pound Sterling",
            "gel": "Lari Georgia",
            "ghs": "Ghana Cedi",
            "gip": "Gibraltar Pound",
            "gmd": "Gambia Dalasi",
            "gnf": "Guinea Franc",
            "gtq": "Guatemala Quetzal",
            "gyd": "Guyana Dollar",
            "hkd": "Đôla Hong Kong",
            "hnl": "Honduras Lempira",
            "hrk": "Croatia Kuna",
            "htg": "Haiti Gourde",
            "huf": "Forint Hungary",
            "idr": "Rupiah Indonesia",
            "ils": "New Sheqel Isreal",
            "inr": "Rupee Ấn Độ",
            "iqd": "Dinar Iraq",
            "irr": "Rial Iran",
            "isk": "Iceland Đồng curon của",
            "jmd": "Dollar Jamaica",
            "jod": "Jordan Dinar",
            "jpy": "Yen Nhật",
            "kes": "Kenya Shilling",
            "kgs": "Kyrgyzstani Som",
            "khr": "Riel Campuchia",
            "kmf": "Comorian Franc",
            "kpw": "Bắc Triều Tiên Won",
            "krw": "Hàn Quốc Won",
            "kwd": "Kuwait Dinar",
            "kyd": "Quần đảo Cayman Dollar",
            "kzt": "Kazakhstan Tenge",
            "lak": "kíp Lào",
            "lbp": "Lebanon Lira",
            "lkr": "Rupee Sri Lanka",
            "lrd": "Dollar Liberia",
            "lsl": "Lesotho Loti",
            "lvl": "lats latvian",
            "lyd": "Dinar Libya",
            "mad": "Ma-rốc Dirham",
            "mdl": "Moldovan Leu",
            "mga": "Malagasy Ariary",
            "mkd": "Macedonia Denar",
            "mmk": "Myanma Kyat",
            "mnt": "Mông Cổ Tugrik",
            "mop": "Pataca Ma Cao",
            "mro": "Mauritania Ouguiya",
            "mur": "Rupee Mauritian",
            "mvr": "Maldives Rufiyaa",
            "mwk": "Đồng Ringgit Mã Lai",
            "mxn": "Đồng peso Mexican",
            "myr": "Đồng Ringgit Mã Lai",
            "mzn": "Mozambique Metical",
            "nad": "Namibia Dollar",
            "ngn": "Nigeria Naira",
            "nio": "Nicaragua Cordoba",
            "nok": "Na Uy Krone",
            "npr": "Rupee Nepal",
            "nzd": "New Zealand Dollar",
            "omr": "Oman Rial",
            "pab": "Panama Balboa",
            "pen": "Peru Nuevo Sol",
            "pgk": "Papua New Guinea Kina",
            "php": "Philippine Peso",
            "pkr": "Rupee Pakistan",
            "pln": "Zloty Ba Lan",
            "pyg": "Paraguay Guarani",
            "qar": "Rian Qatar",
            "rmb": "đồng nhân dân tệ",
            "ron": "Rumani Leu",
            "rsd": "Serbia Dinar",
            "rub": "Rúp Nga",
            "rwf": "Rwanda Franc",
            "sar": "Rian Ả Rập",
            "sbd": "Quần đảo Solomon Dollar",
            "scr": "Seychelles Rupee",
            "sdg": "Sudan Pound",
            "sek": "Đồng curon Thụy Điển",
            "sgd": "Đô la Singapore",
            "shp": "Saint Helena Pound",
            "sll": "Leone của Sierra Leone",
            "sos": "Somali Shilling",
            "srd": "Dollar Suriname",
            "std": "Sao Tome và Principe Dobra",
            "syp": "Bảng Syria",
            "szl": "Swazi Lilangeni",
            "thb": "Bạt Thái Lan",
            "tjs": "Tajikistan Somoni",
            "tmt": "Turkmenistan Manat",
            "tnd": "Dinar Tunisia",
            "top": "Paanga",
            "try": "Thổ Nhĩ Kỳ New Lia",
            "ttd": "Trinidad và Tobago Dollar",
            "twd": "Đài Loan mới Dollar",
            "tzs": "Tanzania Shilling",
            "uah": "Ukraine Hryvnia",
            "ugx": "Uganda Shilling",
            "usd": "Đô la Mỹ",
            "uyu": "Uruguay Peso",
            "uzs": "Uzbekistan Som",
            "vef": "Venezuela Bolivar",
            "vnd": "Đồng Việt",
            "vuv": "Vanuatu Vatu",
            "wst": "Samoa Tala",
            "xaf": "Central African CFA Franc",
            "xcd": "Đông Caribê Dollar",
            "xdr": "Quyền rút vốn đặc biệt",
            "xof": "Tây Phi CFA Franc",
            "xpf": "CFP Franc",
            "yer": "Yemen Rial",
            "zar": "Đơn vị tiền tệ tiêu chuẩn được sử dụng ở Nam Phi",
            "zmw": "Zambia Kwacha"
        },
        "shop-currency-rate": {
            "rate-last-updated-x-days-ago": "Tỷ lệ cập nhật {time} ngày trước",
            "rate-last-updated-x-hours-ago": "Tỷ lệ cập nhật {time} giờ trước"
        },
        "hyperair": {
            "copyright-footer": "Bản quyền © 2018 HyperAir Incorpination Limited. Đã đăng ký Bản quyền.",
            "today": "Hôm nay"
        },
        "product-simcard": {
            "shipping-methods": {
                "hkpost": "Bưu điện Hồng Kông (Miễn phí)",
                "international": "Vận chuyển quốc tế",
                "sf": "SF Express (Hong Kong only. Courier fee payable on delivery. Free Shipping for orders over HK$399)"
            }
        },
        "country": {
            "afghanistan": "Afghanistan",
            "aland-islands": "Quần đảo Aland",
            "albania": "Albania",
            "algeria": "Algeria",
            "andorra": "Andorra",
            "angola": "Ăng-gô",
            "anguilla": "Anguilla",
            "antigua-&-barbuda": "Antigua & Barbuda",
            "antigua-barbuda": "Antigua và Barbuda",
            "argentina": "Argentina",
            "armenia": "Armenia",
            "aruba": "Argentina",
            "australia": "Châu Úc",
            "austria": "Áo",
            "azerbaijan": "Ailen",
            "azores": "Azores",
            "bahamas": "Ba Tư",
            "bahrain": "BAHRAIN",
            "bangladesh": "BANGLADESH",
            "barbados": "BẾP",
            "belarus": "Bêlarut",
            "belgium": "NƯỚC BỈ",
            "belize": "Belize",
            "benin": "LỢI ÍCH",
            "bermuda": "BERMUDA",
            "bhutan": "BHUTAN",
            "bolivia": "BOLIVIA",
            "bonaire": "Bonaire",
            "bosnia-herzegovina": "Bosnia & Herzegovina",
            "botswana": "Botswana",
            "brazil": "Brazil",
            "british-virgin-islands": "Quần đảo British Virgin",
            "brunei": "BRUNEI",
            "bulgaria": "BULGARIA",
            "burkina-faso": "FURO BURKINA",
            "burundi": "BURUNDI",
            "cambodia": "Campuchia",
            "cameroon": "Ca-mơ-run",
            "canada": "Canada",
            "canary-islands": "đảo Canary",
            "cape-verde-islands": "Quần đảo Cape Verde",
            "cayman-islands": "Quần đảo Cayman",
            "central-african-republic": "Cộng hòa trung phi",
            "chad": "Chad",
            "chile": "Chile",
            "china": "Trung Quốc",
            "colombia": "Colombia",
            "comoros": "Comoros",
            "congo": "Công Phượng",
            "cook-islands": "Quần đảo Cook",
            "costa-rica": "Costa Rica",
            "cote-d-ivoire": "Côte D Ivoire",
            "croatia": "Croatia",
            "cruise-ship": "Tàu du lịch",
            "cuba": "Cuba",
            "curacao": "rượu cam bì",
            "cyprus": "Đảo Síp",
            "cyprus---north": "Đảo Síp",
            "cyprus---south": "Đảo Síp",
            "czech-republic": "Cộng hòa Séc",
            "denmark": "Đan mạch",
            "djibouti": "Djibouti",
            "dominica": "Đa Minh",
            "dominican-republic": "Cộng hòa Dominican",
            "dubai": "Dubai",
            "easter-island": "Đảo Phục Sinh",
            "ecuador": "Ecuador",
            "egypt": "Ai Cập",
            "el-salvador": "El Salvador",
            "equatorial-guinea": "Equatorial Guinea",
            "eritrea": "Eritrea",
            "estonia": "Estonia",
            "ethiopia": "Ê-díp-tô",
            "europe": "Europe",
            "falkland-islands": "Quần đảo Falkland",
            "faroe-islands": "Quần đảo Faroe",
            "fiji": "Phi-gi",
            "finland": "Phần Lan",
            "france": "Pháp",
            "french-guiana": "Guiana thuộc Pháp",
            "french-polynesia": "Polynesia thuộc Pháp",
            "french-west-indies": "Tây Ấn thuộc Pháp",
            "gabon": "Gabon",
            "gambia": "Gambia",
            "georgia": "Georgia",
            "germany": "nước Đức",
            "ghana": "Ghana",
            "gibraltar": "Gibraltar",
            "greece": "Hy Lạp",
            "greenland": "Đất xanh",
            "grenada": "Grenada",
            "guadeloupe": "Thành cổ",
            "guam": "Quê hương",
            "guatemala": "Guatemala",
            "guernsey": "Guernsey",
            "guinea": "Guinea",
            "guinea---bissau": "Guinea Bissau",
            "guinea-bissau": "Guinea-Bissau",
            "guyana": "Guyana",
            "haiti": "Haiti",
            "honduras": "Honduras",
            "hong-kong": "Hồng Kông",
            "hungary": "Hungary",
            "iceland": "Iceland",
            "india": "Ấn Độ",
            "indonesia": "Indonesia",
            "iran": "Iran",
            "iraq": "Irac",
            "ireland": "Ai-len",
            "isle-of-man": "Đảo Man",
            "israel": "Ixraen",
            "italy": "Ý",
            "jamaica": "JAMAICA",
            "japan": "Nhật Bản",
            "jersey": "Áo",
            "jordan": "Jordan",
            "kazakhstan": "Kazakhstan",
            "kenya": "Kenya",
            "kiribati": "Kiribati",
            "kosovo": "Kosovo",
            "kuwait": "Cô-oét",
            "kyrgyz-republic": "Cộng hoà Kyrgyz",
            "kyrgyzstan": "Kít-sinh-gơ",
            "laos": "Lào",
            "latvia": "Latvia",
            "lebanon": "Lebanon",
            "lesotho": "Lesicia",
            "liberia": "Liberia",
            "libya": "Libya",
            "liechtenstein": "Liechtenstein",
            "lithuania": "Litva",
            "luxembourg": "Tiếng Séc",
            "macau": "Ma Cao",
            "macedonia": "Ma-rốc",
            "madagascar": "Madagascar",
            "madeira": "Madeira",
            "malawi": "Ma-rốc",
            "malaysia": "Malaysia",
            "maldives": "Maldives",
            "mali": "Ma-rốc",
            "malta": "Malta",
            "marshall-islands": "đảo Marshall",
            "martinique": "Martinique",
            "mauritania": "Mauritania",
            "mauritius": "Mô-ri-xơ",
            "mayotte": "Mayotte",
            "mexico": "Mexico",
            "micronesia": "Micronesia",
            "moldova": "Moldova",
            "monaco": "Monaco",
            "mongolia": "Mông Cổ",
            "montenegro": "Montenegro",
            "montserrat": "Montserrat",
            "morocco": "Ma-rốc",
            "mozambique": "Mozambique",
            "myanmar": "Myanmar",
            "namibia": "Namibia",
            "nauru": "Nauru",
            "nepal": "Nepal",
            "netherlands": "nước Hà Lan",
            "netherlands-antilles": "Antilles Hà Lan",
            "new-caledonia": "Caledonia mới",
            "new-zealand": "New Zealand",
            "nicaragua": "Nicaragua",
            "niger": "Nigeria",
            "nigeria": "Nigeria",
            "niue": "Niue",
            "norfolk-islands": "Quần đảo Norfolk",
            "north-korea": "Bắc Triều Tiên",
            "northern-marianas": "Bắc Mariana",
            "norway": "Na Uy",
            "oman": "Ô-man",
            "pakistan": "Pakistan",
            "palau": "Palau",
            "palestine": "Palestine",
            "panama": "Panama",
            "papua-new-guinea": "Papua New Guinea",
            "paraguay": "Paraguay",
            "peru": "Peru",
            "philippines": "Philippines",
            "poland": "Ba Lan",
            "portugal": "Bồ Đào Nha",
            "puerto-rico": "Puerto Rico",
            "qatar": "Qatar",
            "reunion": "Sum họp",
            "romania": "Rumani",
            "russia": "Nga",
            "rwanda": "Rwanda",
            "saint-barthelemy": "SAINT BARTHELEMY",
            "saint-martin": "Saint martin",
            "saint-pierre-&-miquelon": "Saint Pierre & Miquelon",
            "samoa": "Samoa",
            "san-marino": "San Marino",
            "sao-tome-&-principe": "Sao Tome & Principe",
            "sao-tome-principe": "Sao Tome và Principe",
            "satellite": "Vệ tinh",
            "saudi-arabia": "Ả Rập Saudi",
            "senegal": "Sê-nê-gan",
            "serbia": "Serbia",
            "seychelles": "Seychelles",
            "sierra-leone": "Sierra Leone",
            "singapore": "Singapore",
            "slovak-republic": "Cộng hòa Slovakia",
            "slovakia": "Slovakia",
            "slovenia": "Slovenia",
            "solomon-islands": "Quần đảo Solomon",
            "somalia": "Somalia",
            "south-africa": "Nam Phi",
            "south-korea": "Nam Triều Tiên",
            "spain": "Tây Ban Nha",
            "sri-lanka": "Sri Lanka",
            "st-helena": "Thánh Helena",
            "st-kitts": "Thánh Kitts",
            "st-kitts-&-nevis": "St Kitts & Nevis",
            "st-lucia": "Thánh nữ",
            "st-vincent": "Thánh Vincent",
            "st.-helena": "Thánh Helena",
            "st.-kitts": "Kitts",
            "st.-lucia": "Thánh nữ",
            "sudan": "Sudan",
            "suriname": "Xuameame",
            "swaziland": "Swaziland",
            "sweden": "Thụy Điển",
            "switzerland": "Thụy sĩ",
            "syria": "Syria",
            "taiwan": "Đài Loan",
            "tajikistan": "Tajikistan",
            "tanzania": "Tanzania",
            "thailand": "nước Thái Lan",
            "timor-l'este": "Timore",
            "togo": "Đi",
            "tonga": "Tổng",
            "trinidad-&-tobago": "Trinidad & Tobago",
            "trinidad-tobago": "Trinidad và Tobago",
            "tunisia": "Tunisia",
            "turkey": "gà tây",
            "turkmenistan": "Turkmenistan",
            "turks-&-caicos": "Thổ Nhĩ Kỳ & Caicos",
            "turks-&-caicos-islands": "Quần đảo Turks & Caicos",
            "turks-caicos-islands": "Quần đảo Turks và Caicos",
            "uganda": "Nhật Bản",
            "ukraine": "Ukraine",
            "united-arab-emirates": "các Tiểu Vương Quốc Ả Rập Thống Nhất",
            "united-kingdom": "Vương quốc Anh",
            "united-states": "Hoa Kỳ",
            "united-states-minor-outlying-islands": "Quần đảo xa xôi nhỏ của Hoa Kỳ",
            "uruguay": "Uruguay",
            "uzbekistan": "Uzbekistan",
            "vanuatu": "Vanuatu",
            "vatican-city": "Thành phố Vatican",
            "venezuela": "Venezuela",
            "vietnam": "Việt Nam",
            "virgin-islands": "Quần đảo Virgin",
            "virgin-islands-(us)": "Quần đảo Virgin (Mỹ)",
            "wallis-&-futuna": "Wallis & Futuna",
            "wallis-futuna": "WALLIS VÀ FUTUNA",
            "yemen": "Yemen",
            "zambia": "Zambia",
            "zimbabwe": "Bêlarut"
        },
        "inspiration": {
            "published-date": "M Y",
            "published-duration": ": thời hạn ngày trước",
            "published-duration-singular": "Hôm qua",
            "published-duration-today": "Hôm nay"
        },
        "promotion-center": {
            "expires-at": "",
            "redeem": {
                "error": {
                    "already-redeemed": "Bạn đã đổi phiếu giảm giá.",
                    "new-customer-only": "Ưu đãi chỉ có giá trị cho khách hàng mới.",
                    "not-found": "Mã khuyến mãi không hợp lệ"
                }
            }
        },
        "auth": {
            "failed": "Những thông tin không phù hợp với hồ sơ của chúng tôi.",
            "throttle": "Quá nhiều lần thử đăng nhập. Vui lòng thử lại sau: giây giây."
        },
        "web": {
            "activity": {
                "countdown-title": "",
                "more-button": "More tour and tickets",
                "section-subtitle": "Find the cheapest tour and tickets in Singapore",
                "section-title": "Tour and Tickets"
            },
            "checkout": {
                "use-promo-code": ""
            },
            "checkout-failed": {
                "checkout-failed": ""
            },
            "checkout-success": {
                "checkout-success": "Thanh toán thành công",
                "continue-shopping-button": "Tiếp tục mua sắm",
                "done-button": "Xong👌🏻",
                "download-now": "Tải ngay",
                "order-number": "Số thứ tự",
                "register-email": "Email của bạn",
                "register-password": "Đặt mật khẩu của bạn",
                "sim-product": "Đã mua thành công <span class=\"bold\"> : sim </span>. Email xác nhận đã được gửi tới: email.",
                "slogan": "Mở ứng dụng HyperAir để tận hưởng các đặc quyền du lịch độc quyền! Bạn cũng có thể theo dõi đơn hàng theo thời gian thực trong Ứng dụng!",
                "slogan-password": "Thêm một bước! Bạn có thể tận hưởng phiếu giảm giá Thẻ SIM chào mừng 10 đô la Hồng Kông và theo dõi đơn hàng theo thời gian thực trong Ứng dụng!",
                "trace-order": "",
                "trace-order-password": "",
                "welcome-offer": "Thêm một bước! Bạn có thể tận hưởng phiếu giảm giá Thẻ SIM chào mừng 10 đô la Hồng Kông và theo dõi đơn hàng theo thời gian thực trong Ứng dụng!"
            },
            "country": {
                "all": "Tất cả các",
                "contact-us-description": "如有 任何 疑問<a href=\"mailto:corporate@hyperair.com\\>Corporate@hyperair.com</a>",
                "data": "Giới hạn dữ liệu:",
                "day": "Ngày",
                "day-day": "Ngày",
                "esim": "eSIM",
                "esim-section-title": "ESIM tốt nhất cho: quốc gia",
                "num-of-review": ": xếp hạng num-of-review",
                "per-day": "Ngày",
                "phone-call": "Gọi điện",
                "plug-n-go": "",
                "plug-n-go-esim": "Mua và sử dụng ngay",
                "plug-n-go-sim": "Cắm và sử dụng",
                "section-title": "Thẻ SIM tốt nhất cho: quốc gia",
                "section-title copy": "Thẻ SIM tốt nhất cho: quốc gia",
                "sim": "SIM",
                "supplier": "Các nhà cung cấp:"
            },
            "download-app-banner": {
                "download-now": "Tải xuống ứng dụng ngay",
                "hyperair": "HyperAir",
                "subtitle": "Tải xuống và đăng ký Ứng dụng HyperAir để tận hưởng ưu đãi chào mừng 10 đô la Hồng Kông!",
                "title": "Du lịch thông minh hơn. Bất cứ nơi nào."
            },
            "email-subscription": {
                "cancel-button": "再諗一諗",
                "completed-subscribe": "Thank you for subscribing!",
                "confirm-button": "我要最抵優惠",
                "duplicate-email": "你的電郵已經訂閱了",
                "invalid-email": "Invalid email address",
                "title-1": "想Staycation價格跌至新低時通知你？",
                "title-2": "仲搜羅全城最抵既Staycation 及美食套餐優惠"
            },
            "fanfare": {
                "cover-title": "Thẻ SIM Offer",
                "datetime-format": "j M",
                "end-next-fanfare": "Sắp tới thẻ SIM Offer:",
                "end-title": "Hãy theo dõi để App & xã hội phương tiện truyền thông của chúng tôi cho Chào SIM tiếp theo",
                "end-title2": "Tiếp tục theo dõi nền tảng APP & truyền thông xã hội của chúng tôi cho các thẻ SIM Offer tiếp theo",
                "more-details-button": "Xem chi tiết",
                "out-of-stock": "Bán hết",
                "popular-countries-subtitle": "Miễn phí Surface Mail, giao hàng nhanh chóng",
                "popular-countries-title": "Phổ biến Thẻ SIM",
                "section-title": "SIM Cards với giá siêu giảm giá",
                "title": "Limited Time | hạn chế Cards",
                "x-inventory-left": "Cuối cùng{inventory}"
            },
            "fanfare-breadcrumb": "Thẻ SIM Offer",
            "filter-button": {
                "filter": "Lọc"
            },
            "filter-container": {
                "apply": "",
                "category": "thể loại",
                "category-aquarium": "Bể nuôi cá",
                "category-class": "Lớp học",
                "category-day-tour": "Tour du lịch trong ngày",
                "category-discount": "Giảm giá",
                "category-diving": "lặn",
                "category-food": "Món ăn",
                "category-massage-beauty": "Massage và Beauty",
                "category-museum": "viện bảo tàng",
                "category-musical": "Âm nhạc",
                "category-outlet": "lối ra",
                "category-photography": "Nhiếp ảnh",
                "category-playground": "Sân chơi",
                "category-railway": "Đường sắt",
                "category-show": "Chỉ",
                "category-ski": "trượt tuyết",
                "category-spa": "spa",
                "category-theme-park": "Theme Park",
                "category-ticket": "vé",
                "category-transport": "Vận chuyển",
                "category-transport-ticket": "Giao thông vận tải Ticket",
                "category-vr": "VR",
                "category-water-park": "Công viên nước",
                "category-yoga": "Yoga",
                "category-zoo": "vườn bách thú",
                "clear-all": "Cài lại",
                "facilities": "Services & facilities",
                "filter": "Lọc",
                "food": "Food",
                "header": "Lọc",
                "popular-search": "Popular Search🔥",
                "price": "Giá bán",
                "provider": "Travel Site",
                "subcategory-buffet": "Tiệc đứng",
                "subcategory-car": "Xe hơi",
                "subcategory-facial": "ở mặt",
                "subcategory-food": "Món ăn",
                "subcategory-half-day-tour": "Nửa ngày Tour",
                "subcategory-massage": "Mát xa",
                "subcategory-meal-voucher": "Chứng từ bữa ăn",
                "subcategory-one-day-tour": "One Day Tour",
                "subcategory-restaurant": "Nhà hàng",
                "subcategory-transport": "Vận chuyển",
                "tag": "Tag"
            },
            "footer": {
                "about-hyperair-description": "HyperAir là một nền tảng du lịch thông minh theo ý thích của bạn, cung cấp giải pháp du lịch phù hợp và đáng giá nhất, để bạn có thể đi du lịch thông minh hơn, ở bất cứ đâu.",
                "download-now": "Tải ngay",
                "email-subscription-button": "Subscribe",
                "email-subscription-placeholder": "Enter your email",
                "email-subscription-social-title": "or Follow our Facebook and Instagram",
                "email-subscription-title": "Subscribe to get the latest staycation discount",
                "travel-license": "Travel Agent Licence Number："
            },
            "fx-booking": {
                "back-button": "",
                "confirm-booking": "",
                "confirm-button": "",
                "contact-shop": "",
                "get-money-before": ""
            },
            "home": {
                "cover-button": "Trải nghiệm ngay",
                "cover-subtitle": "Mở ra một thế giới mới của HyperAir",
                "cover-title": "Du lịch thông minh hơn. Bất cứ nơi nào.",
                "grid": {
                    "1": {
                        "subtitle": "Cảm hứng mới nhất",
                        "title": "Cư dân mèo trong nhà thờ Thổ Nhĩ Kỳ"
                    },
                    "2": {
                        "subtitle": "Cảm hứng mới nhất",
                        "title": "Thế vận hội Tokyo 2020 1 năm để đi"
                    },
                    "3": {
                        "subtitle": "Lựa chọn hấp dẫn",
                        "title": "Đảm bảo giá tốt nhất trực tuyến"
                    },
                    "4": {
                        "subtitle": "期間限定",
                        "title": "SIMカードファンファーレ"
                    },
                    "5": {
                        "subtitle": "Điểm đến phổ biến",
                        "title": "Sneak Peek của Disneyland Galaxy's Edge"
                    }
                },
                "home-example": {
                    "column-subtitle-1": "lấy 2 người chuyến đi 7 ngày tới Nhật Bản làm ví dụ:",
                    "column-subtitle-2": "So sánh giá",
                    "column-title-1": "một chuyến đi, tối đa hóa sự tiết kiệm của bạn",
                    "column-title-2": "So sánh 11 công ty du lịch trực tuyến",
                    "hotel": "Phần thưởng khách sạn",
                    "hotel-package-1": "Khách sạn Nikko Osaka x6 đêm",
                    "insurance": "Bảo hiểm du lịch",
                    "insurance-package-1": "Bảo hiểm du lịch 7 ngày x2",
                    "money": "Bảo hiểm du lịch",
                    "money-package-1": "Trao đổi JPD ¥ 410.000",
                    "save": "Tiết kiệm",
                    "sim": "SIM du lịch",
                    "sim-package-1": "SIM DoCoMo 7 ngày Nhật Bản x2",
                    "slogan": "So sánh trước khi đặt phòng, tiết kiệm tiền cho chuyến đi tiếp theo của bạn!",
                    "total-saving": "Tổng số tiền tiết kiệm $ 1,443",
                    "travel-experience": "Kinh nghiệm du lịch",
                    "travel-experience-package-1": "JR Pass cho toàn Nhật Bản x2",
                    "travel-experience-package-2": "Universal Studios Nhật Bản ™ 1-Day vé điện tử x2"
                },
                "media-header-title": "Press",
                "more": "Thêm SIM du lịch",
                "partners-title": "Partnership",
                "photo-banner-button": "Tìm hiểu thêm",
                "photo-banner-title": "Đổi tiền du lịch thông minh hơn",
                "services-header-description": "",
                "services-header-title": "Dịch vụ du lịch một cửa",
                "services-icon-subtitle-1": "Giúp bạn có được tiền du lịch thông minh hơn!",
                "services-icon-subtitle-2": "Cung cấp cho bạn các thẻ SIM tốt nhất với giao hàng miễn phí!",
                "services-icon-subtitle-3": "Cho phép bạn khám phá thế giới với giải pháp phù hợp!",
                "services-icon-title-1": "Tiền đi du lịch",
                "services-icon-title-2": "SIM du lịch",
                "services-icon-title-3": "Kinh nghiệm du lịch",
                "statistic": {
                    "num-of-city": "",
                    "num-of-comparison": "",
                    "num-of-experience": "",
                    "num-of-saving": ""
                },
                "testimonial-1-content": "Ứng dụng 很好 用 ，",
                "testimonial-1-subtitle": "Người dùng Android",
                "testimonial-1-user": "Christine Lam",
                "testimonial-2-content": "方便 ， 訂 卡 好 買 買 買 買 買 買再買！",
                "testimonial-2-subtitle": "Người dùng iOS",
                "testimonial-2-user": "Thiên thần",
                "testimonial-header-description": "",
                "testimonial-header-title": "Lời chứng thực của khách hàng",
                "travel-activities": {
                    "home-slogan": "So sánh và tìm kinh nghiệm du lịch tốt nhất của bạn từ các trang web khác nhau"
                },
                "travel-country-header-description": "Phân loại rõ ràng, dễ chọn",
                "travel-country-header-title": "SIM du lịch bao gồm 200 quốc gia",
                "travel-info-header-description": "Mang lại cho bạn cảm hứng du lịch nóng đỏ",
                "travel-info-header-title": "Cảm hứng du lịch",
                "travel-marketplace-header-description": "",
                "travel-marketplace-header-title": "",
                "travel-sim-header-description": "Giao dịch thẻ SIM tốt nhất với giao hàng miễn phí",
                "travel-sim-header-title": "SIM du lịch phổ biến"
            },
            "hotel": {
                "cover-subtitle": "Thưởng thức 5% Trip.com độc quyền phục vụ đặt phòng khách sạn",
                "cover-title": "thưởng khách sạn",
                "discount-detail": "Áp dụng mã promo \"HYPERAIR5\" để thưởng thức 5% phục vụ đặt phòng khách sạn",
                "discount-title": "HYPERAIR5",
                "highlight-subtitle1": "Khám phá khách sạn trên toàn thế giới cho một kỳ nghỉ độc đáo.",
                "highlight-subtitle2": "Lấy giao dịch tốt nhất và tiết kiệm tiền của bạn cho việc đi lại tới.",
                "highlight-subtitle3": "Kiểm tra giá khách sạn bất cứ lúc nào bất cứ nơi nào.",
                "highlight-title1": "Bảo hiểm toàn cầu",
                "highlight-title2": "Ưu đãi độc quyền",
                "highlight-title3": "One-click Đặt trước"
            },
            "hypermiles": {
                "activity": "Activity",
                "balance": "Outstanding Balance",
                "benefit": "Your Privileges",
                "cumulative-purchase": "Accumulated Spending：HK$ {amount}",
                "diamond-black": "Diamond Black",
                "expire": "Expired HyperMiles ({date})",
                "expire-reminder-1": "HyperMiles is valid for one year from the shopping month",
                "expire-reminder-2": "Remember to use HyperMiles before expiry!",
                "hypermiles-total": "HyperMiles",
                "member": "Member",
                "member-tier": "You have become HyperAir {member_tier} member",
                "membership-details": "Membership Tier",
                "next-purchase": "save HK${amount} in your next purchase",
                "order-num": "Order No: {order_num}",
                "permanent-membership": "Permanent Membership",
                "popup-title": "HyperMiles Reward Scheme",
                "precious-platinum": "Precious Platinum",
                "product_purchase": "HyperMiles from gadgets purchase ({date})",
                "record": "HyperMiles Record",
                "royal-blue": "Royal Blue",
                "simcard_purchase": "HyperMiles from SIM purchase ({date})",
                "tier": "",
                "title": "HyperMiles. Explore the World, Enjoy the rebate!",
                "u-have": "Your have",
                "usage": "Redeemed HyperMiles",
                "what-is-hypermiles": "What is HyperMiles",
                "what-is-hypermiles-slogan1": "Spend more. Earn more!",
                "what-is-hypermiles-slogan2": "Every 100 HyperMiles can be used as HK$1 at checkout, no minimum spending limit",
                "what-is-hypermiles-slogan3": "Spend more at HyperAir to enjoy more privileges"
            },
            "hypermiles-disclaimer": "terms and conditions apply",
            "hypermiles-discount-diamond-black": "Spend every HK$1 to enjoy 1 HyperMiles",
            "hypermiles-discount-precious-platinum": "Spend every HK$1.5 to enjoy 1 HyperMiles",
            "hypermiles-discount-royal-blue": "Spend every HK$2 to enjoy 1 HyperMiles",
            "hypermiles-special-diamond-black": "Exclusive pre-sale offer",
            "hypermiles-spend-diamond-black": "Cumulative spending of HK$3,000",
            "hypermiles-spend-precious-platinum": "Cumulative spending of HK$1,500",
            "hypermiles-spend-royal-blue": "Basic Member",
            "login": {
                "email": "",
                "existing-user": "",
                "forgot-password": "",
                "forgot-password-please-fill-in-email": "",
                "login": "",
                "login-with-facebook": "",
                "login-with-google": "",
                "new-user": "",
                "or": "",
                "password": "",
                "phone-input-placeholder": "",
                "phone-input-title": "",
                "phone-verify": "",
                "resend-verification-code": "",
                "reset-password": "",
                "title": "",
                "verification-code-input-title": ""
            },
            "logo-loader": {
                "slogan": "We're almost there"
            },
            "my-order": {
                "amount": "",
                "esim-qrcode": "",
                "fx-status-cancelled": "",
                "fx-status-confirmed": "",
                "order-date": "",
                "order-details": "",
                "order-num": "",
                "status-confirmed": "",
                "status-pending-confirmation": "",
                "status-ready-to-ship": "",
                "status-shipped": ""
            },
            "my-order-details": {
                "delivery-info": "",
                "discount": "",
                "recipient-address": "",
                "recipient-email": "",
                "recipient-name": "",
                "recipient-tel": "",
                "shipping-method": "",
                "status": "",
                "total": "",
                "valid-date": ""
            },
            "nav": {
                "about-us": "Về chúng tôi",
                "car": "",
                "company": "Công ty",
                "company-address": "Entrepreneurship Centre, Level 3, Cyberport 3, Hong Kong",
                "contact-us": "Liên hệ chúng tôi",
                "contact-us-description": "Vui lòng gửi email đến <a href=\"mailto:hello@hyperair.com\">hello@hyperair.com</a> để được giải đáp mọi thắc mắc.",
                "disclaimer": "Disclaimer",
                "download-app": "Tải ứng dụng",
                "flight": "",
                "foodie": "Foodie",
                "home": "Home",
                "hotel": "Khách sạn",
                "jobs": "Tuyển dụng",
                "logout": "Đăng xuất",
                "media-coverage": "Press",
                "monthly-rental-hotel": "Monthly Rental Hotel",
                "privacy-policy": "Chính sách bảo mật",
                "promo-banner-text": "HyperAir 客戶專享 5% Trip.com 獨家酒店折扣",
                "quarantine-hotel": "Long Stay Hotel",
                "refund-policy": "Chính sách hoàn tiền",
                "spa-and-beauty": "Spa and Beauty",
                "staycation": "Staycation",
                "tag-line": "Compare Travel Sites & Save Money",
                "terms-of-service": "Điều khoản dịch vụ",
                "travel-activity": "",
                "travel-affiliate-codes": "phiếu giảm giá",
                "travel-affiliate-codes-md": "phiếu giảm giá",
                "travel-blog": "Blog",
                "travel-experience-d": "du lịch và trải nghiệm",
                "travel-experience-md": "du lịch và trải nghiệm",
                "travel-insurance": "Bảo hiểm du lịch",
                "travel-insurance-md": "Bảo hiểm du lịch",
                "travel-marketplace": "Du lịch Tiện ích",
                "travel-marketplace-md": "Du lịch Tiện ích",
                "travel-money": "Tiền đi du lịch",
                "travel-money-md": "Tiền đi du lịch",
                "travel-sim": "SIM du lịch",
                "travel-sim-md": "SIM du lịch"
            },
            "photo-banner": {
                "banner-button": ""
            },
            "product-card": {
                "num-of-review": "{num}-of-review ratings"
            },
            "redirection-gate": {
                "columns-1-description": "Hãy so sánh các kinh nghiệm du lịch tốt nhất từ ​​các trang web khác nhau",
                "columns-1-title": "Hoạt động du lịch So sánh",
                "columns-2-description": "giao dịch thẻ SIM tốt nhất với miễn phí vận chuyển!",
                "columns-2-title": "Travel SIM",
                "columns-3-description": "Hãy so sánh và đặt tỷ lệ FX tốt nhất trong thị trấn",
                "columns-3-title": "Tiền đi du lịch",
                "promo-code": "Mã",
                "remember-to-fill-promo-code": "Hãy nhớ để áp dụng mã khuyến mãi ở trên trước khi thanh toán",
                "title": "We are taking you to {domain}",
                "trouble-link": "If the browser does not redirect you in 10 seconds, please click this <a href=\"{link}\">link</a>."
            },
            "register": {
                "guest-checkout": "",
                "title": ""
            },
            "seo": {
                "best-price-guarantee-title": "Best Price Guarantee",
                "country-description": "{country} du lịch quốc gia - Đảm bảo giá tốt nhất với giao hàng miễn phí",
                "country-keywords": "SIM 卡, 網卡, 電話, 數據 卡, DataSIM, DataSIM, 數據 咭, 4G 上 網卡, 網卡, 4G 上 網卡, 4G 上 網卡, 上 網卡, 4G 上, 4G網卡, 大阪 上, 泰國 4G 上 網卡, 泰國 上 網卡, 曼谷 4G 上 網卡, 布吉 上 網卡, 芭提雅 4G 上 網卡, 4G 上 網卡, 上 網卡, 4G 上,台 iển 4G, 台 iển, 4G 上, 韓國 上, 爾 4G 上, 爾 上 國, 4G 國 國Doc, Docomo, Softbank",
                "country-title": "{country} du lịch quốc gia - Đảm bảo giá tốt nhất với giao hàng miễn phí",
                "home-description": "HyperAir là một nền tảng du lịch thông minh theo ý thích của bạn, cung cấp giải pháp du lịch phù hợp và đáng giá nhất, để bạn có thể đi du lịch thông minh hơn, ở bất cứ đâu.",
                "home-keywords": "sim 卡, 網卡, 電話, 數據 卡, DataSIM, DataSIM, 數據 咭, 4G 上, 網卡, 4G 上 網卡, SIM 卡, SIM du lịch, 旅遊 SIM 卡,, X 器, 錢, 唱 錢 ứng dụng, 兌換, 找 換, 兌換 店, 找 換 店, 銀行, 金融,, 外滙, 匯率,, 匯款, 外幣, 貨幣, 旅行,, 行程, , 格 價, 特價,, 交易, 旅遊 保險, 日本,, 韓國,,,,,, HyperAir, HyperAir FX, HyperAir Travel, Travel, Travel Money, Foreign Foreign, Foreign Exchange, , 成, 發達 鳥,, richbird, crazy crazy, trao đổi berlin",
                "home-title": "HyperAir - Du lịch thông minh hơn. Bất cứ nơi nào. | SIM du lịch tốt nhất, FX, bảo hiểm du lịch, kinh nghiệm địa phương",
                "hotel-description": "Nhận thêm đặt phòng khách sạn cung cấp thông qua HyperAir.com",
                "hotel-keywords": "khách sạn, khách sạn, giảm giá, đặt phòng, Châu Á, Châu Âu, Châu Mỹ, Bangkok, Singapore, Hồng Kông, Phuket, Thái Lan, Malaysia, Bali, London, Paris, chương trình lòng trung thành, tiền khách sạn, chỗ ở, acomodation, chỗ ở, cho thuê nghỉ",
                "hotel-title": "Chào khách sạn",
                "money-exchange-description": "Check {shop_name}'s latest FX rate and book your travel money online. You can lock in FX rate and reserve foreign currency.",
                "money-exchange-keywords": "{shop_name}, 唱錢神器, 唱X神器, 唱錢X器, 唱錢, 兌換, 找換, 兌換店, 找換店, 銀行, 金融, 外匯, 外滙, 匯率, 滙率, 匯款, 外幣, 貨幣, 旅行, 旅遊, 行程, 酒店, 機票, 比較, 格價, 特價, 預訂, 交易, 旅遊保險, 日本, 泰國, 韓國, 台灣, 日圓, 日元, 台幣, 泰銖, HyperAir, HyperAir FX, HyperAir Travel, Travel, Travel Money, Foreign Currency, Foreign Exchange, 百年, 堅成, 發達鳥, 飛鳥, richbird, crazy bird, berlin exchange",
                "money-exchange-title": "{shop_name}'s latest FX rate with instant booking | Lock in FX rate and reserve your travel money instantly",
                "privacy-policy-title": "Privacy Policy",
                "refund-policy-title": "Refund & Return Policy",
                "sim-fanfares-description": "HyperAir đã đưa ra thẻ SIM Fanfares đầu tiên tại Hồng Kông. Bạn có thể mua thẻ SIM cho chuyến đi của bạn với chiết khấu lên tới 50%. Hạn chế thời gian, Ưu đãi có hạn!",
                "sim-fanfares-keywords": "fanfares, simcard, sim thẻ, SIM 卡, 上 網卡, 電話 卡, 數據 卡, DataSIM, 旅遊 DataSIM, 數據 咭, 4G 上 網卡, 上 網卡, 4G 上 網卡, 日本 4G 上 網卡, 日本 上 網卡, 東京 4G 上 網卡, 東京 上 網卡, 大阪 4G 上 網卡, 大阪 上 網卡, 泰國 4G 上 網卡, 泰國 上 網卡, 曼谷 4G 上 網卡, 布吉 上 網卡, 芭提雅 4G 上 網卡, 台灣 4G 上 網卡, 台灣 上 網卡, 台北 4G上 網卡, 高雄 上 網卡, 台中 4G 上 網卡, 台中 上 網卡, 韓國 4G 上 網卡, 韓國 上 網卡, 首 爾 4G 上 網卡, 首 爾 上 網卡, 中國 4G 上 網卡, 中國 上 網卡, 深圳 4G 上 網卡, 深圳 上網卡, 澳門 4G 上 網卡, 澳門 上 網卡, Docomo, Softbank",
                "sim-fanfares-title": "SIM Thẻ Fanfares - Limited Time, Limited Cards",
                "term-of-service-title": "Terms of Service",
                "travel-activity-search-results-description": "",
                "travel-activity-search-results-keywords": "{activity}, travel, local experience, local activity, ticket, activities, day tours, tourist attractions",
                "travel-activity-search-results-title": "HyperAir - Search Result of {q} in {city}",
                "travel-affiliate-codes-description": "HyperAir liên tục cập nhật các mã mã giảm giá / khuyến mãi mới nhất cho giảm giá đặt phòng khách sạn, giảm giá vé máy bay, giảm giá hoạt động, giảm giá bảo hiểm du lịch, giảm giá thẻ SIM và giảm giá với thẻ tín dụng.",
                "travel-affiliate-codes-keywords": "Giảm Mã, Phiếu giảm giá điện, giảm giá Mã, Promotion Code, mã khuyến mãi, giảm giá Mã, khách sạn, vé máy bay, Offer, Credit Card Offer, Du lịch Offer",
                "travel-affiliate-codes-title": "2023 Codes Travel Giảm mới nhất (Daily Updates) | đặt phòng giảm giá cho khách sạn, chuyến bay, hoạt động, bảo hiểm du lịch, dữ liệu SIM",
                "travel-insurance-description": "Tìm kiếm các kế hoạch Bảo hiểm du lịch tốt nhất? Những kế hoạch bao gồm điện thoại di động? Hãy so sánh các kế hoạch bảo hiểm từ các công ty như AIG, MSIG và Starr, và mua trực tuyến với chiết khấu thêm!",
                "travel-insurance-keywords": "AIG, MSIG, Starr, AIG PromoCode, MSIG PromoCode, Starr PromoCode, Bảo hiểm du lịch, bảo hiểm du lịch trực tuyến, so sánh Bảo hiểm du lịch, bảo hiểm giá rẻ du lịch, bảo hiểm du lịch hong kong, chuyến đi duy nhất, kế hoạch hàng năm",
                "travel-insurance-title": "Tốt nhất Travel Insurance giá & So sánh ở Hồng Kông 2023",
                "travel-marketplace-checkout-payme-title": "Pay with PayMe",
                "travel-marketplace-checkout-success-keywords": "創意, 產品, 流行, 電器, 生活, 精品, 智能家居, 設計, 高品質, 設計概念, 創意科技, 生活用品, 戶外休閒, 廚房, 餐桌, 個人護理, 防疫抗疫, 健康, 遊戲, 兒童玩樂, 健身, 家居健身, gym, home gym, smart home, style home",
                "travel-marketplace-checkout-success-title": "{product_name}",
                "travel-marketplace-description": "A collection of coolest gadgets that you'll like",
                "travel-marketplace-keywords": "創意, 產品, 流行, 電器, 生活, 精品, 智能家居, 設計, 高品質, 設計概念, 創意科技, 生活用品, 戶外休閒, 廚房, 餐桌, 個人護理, 防疫抗疫, 健康, 遊戲, 兒童玩樂, 健身, 家居健身, gym, home gym, smart home, style home",
                "travel-marketplace-product-checkout-title": "{product}",
                "travel-marketplace-product-title": "{product}",
                "travel-marketplace-title": "Du lịch Tiện ích",
                "travel-money-description": "HyperAir cung cấp cho bạn một cách hoàn toàn mới để nhận tiền du lịch. Bây giờ bạn có thể đặt trao đổi trực tuyến với tỷ giá hối đoái tốt nhất trong thị trấn!",
                "travel-money-keywords": "sim 卡, 網卡, 電話 卡, 數據 卡, DataSIM, DataSIM, 數據 咭, 4G 上 網卡, 網卡, 4G, , 兌換 店, 找 換 店,, 金融, 外匯, 外滙,,, 匯款,, 貨幣,, 旅遊, 行程, 酒店, 機票, 比較, 價, 特價,,, , 泰國,,,, 日元,,, HyperAir, HyperAir FX, HyperAir Travel, Travel, Travel Money, Foreign Foreign, Foreign Exchange,, 堅 成, 發達 鳥, 飛鳥, richbird, crazybird , trao đổi berlin",
                "travel-money-title": "HyperAir - Trao đổi tiền du lịch thông minh hơn.",
                "travel-product-checkout-keywords": "創意, 產品, 流行, 電器, 生活, 精品, 智能家居, 設計, 高品質, 設計概念, 創意科技, 生活用品, 戶外休閒, 廚房, 餐桌, 個人護理, 防疫抗疫, 健康, 遊戲, 兒童玩樂, 健身, 家居健身, gym, home gym, smart home, style home",
                "travel-product-keywords": "創意, 產品, 流行, 電器, 生活, 精品, 智能家居, 設計, 高品質, 設計概念, 創意科技, 生活用品, 戶外休閒, 廚房, 餐桌, 個人護理, 防疫抗疫, 健康, 遊戲, 兒童玩樂, 健身, 家居健身, gym, home gym, smart home, style home",
                "travel-sim-checkout-description": "{country} du lịch quốc gia - Thẻ SIM chất lượng cao miễn phí vận chuyển đến tận nhà!",
                "travel-sim-checkout-keywords": "上 網卡, 電話 卡, 數據, DataSIM, DataSIM, 數據 咭, 4G 上, 上 網卡, 4G 上 網卡, 4G 上 網卡, 日本 上 網卡, 4G 上,大阪 上, 4G 上 網卡, 泰國 上 網卡, 4G 上, 布吉 上 網卡, 4G 上, 4G 上 網卡, 台灣 上 網卡, 台北 4G 上 網卡, , 台 iển, 4G 上 網卡, 韓國 上 網卡, 爾 4G 上, 爾 上 國, 國 上 上 網卡 國 國, Tài liệu, Softbank",
                "travel-sim-checkout-success-description": "{country} du lịch quốc gia - Thẻ SIM chất lượng cao miễn phí vận chuyển đến tận nhà!",
                "travel-sim-checkout-success-keywords": "上 網卡, 電話 卡, 數據, DataSIM, DataSIM, 數據 咭, 4G 上, 上 網卡, 4G 上 網卡, 4G 上 網卡, 日本 上 網卡, 4G 上,大阪 上, 4G 上 網卡, 泰國 上 網卡, 4G 上, 布吉 上 網卡, 4G 上, 4G 上 網卡, 台灣 上 網卡, 台北 4G 上 網卡, , 台 iển, 4G 上 網卡, 韓國 上 網卡, 爾 4G 上, 爾 上 國, 國 上 上 網卡 國 國, Tài liệu, Softbank",
                "travel-sim-checkout-success-title": "Thanh toán thành công - SIM du lịch",
                "travel-sim-checkout-title": "Đặt hàng - SIM du lịch",
                "travel-sim-keywords": "sim 卡, 上 網卡, 電話 卡, 數據 卡, DataSIM, DataSIM, 數據 咭, 4G 上 網卡, 網卡, 4G 上 網卡, 日本 上 網卡, 日本 sim 卡, 4G 上網卡, 大阪 上 網卡, 泰國 4G 上 網卡, 泰國 上 網卡, 泰國 sim 卡, 4G 上 網卡, 上 網卡, 4G 上 網卡, 4G 上 網卡, 台灣, 4G 上 網卡, 高雄 上, 台 4G 4G, 台 Slovakia 上 網卡, sim 卡, 韓國 4G 上, 韓國 上 網卡, 4G 上 網卡, 首 爾 上 國 國,, 深圳 4G, 深圳 上, 澳門 4G 上, 澳門 上 網卡, 4G 上 網卡, 歐洲 上 網卡, sim 卡, 4G 上, , 法國 4G 上 網卡, 法國 上, sim 卡, 恴 4G 上, 意大利 上, sim 卡, 4G 上 網卡, 巴黎 上 網卡, 巴黎 sim 卡, 4G瑞士 sim 卡, Docomo, Softbank, 和 記,, 3hk, 3uk, birdie, 自由, không khí sim, sim2fly, AIS, ais sim2fly, SK Telecom, TrueMove, dtac, t mobile 上 網卡, vietnamobile",
                "travel-sim-title": "【{country} SIM】{sim_name} - Đảm bảo giá tốt nhất với miễn phí vận chuyển",
                "travel-sims-description": "Công cụ tìm kiếm SIM du lịch toàn cầu với thẻ SIM chất lượng cao và giao hàng miễn phí đến tận nhà!",
                "travel-sims-keywords": "sim 卡, 網卡, 電話 卡, 數據 卡, DataSIM, DataSIM, 數據 咭, 4G 上 網卡, 4Gsim, 4G 上 網卡, 日本 上 網卡, 日本 sim 卡, 4G 上網卡, 大阪 上 網卡, 泰國 4G 上 網卡, 泰國 上 網卡, 泰國 sim 卡, 4G 上 網卡, 上 網卡, 4G 上 網卡, 4G 上 網卡, 台灣, 4G 上 網卡, 高雄 上, 台 4G 4G, 台 Slovakia 上 網卡, sim 卡, 韓國 4G 上, 韓國 上 網卡, 4G 上 網卡, 首 爾 上 國 國,, 深圳 4G 上 上, 深圳 上 網卡, 澳門 4G 上 網卡, 上 網卡, sim 卡, sim 歐洲, Docomo, Softbank, sim2fly, AIS, ais sim2fly, SK , t di động 全球 上, vietnamobile",
                "travel-sims-title": "SIM du lịch - Đảm bảo giá tốt nhất với giao hàng miễn phí"
            },
            "shop-confirmation": {
                "app-download": "",
                "app-download-subtitle": "",
                "instruction": "",
                "my-order": "",
                "pending-confirm": ""
            },
            "staycation": {
                "activity-countdown-button": "Find the cheapest price",
                "all-hotels": {
                    "sorting": {
                        "recommended": "Recommended"
                    }
                },
                "all-hotels-all-button": "All",
                "all-hotels-hotel-name": "Hotel Name",
                "all-hotels-last-updated": "Last Updated",
                "all-hotels-less-button": "Less",
                "all-hotels-more-button": "More",
                "all-hotels-no-result": "Sorry, we couldn't find any results",
                "all-hotels-title": "",
                "compare-packages": "Compare other packages",
                "countdown-button": "More Details",
                "countdown-title": "",
                "countdown2-title": "HyperAir Recommended",
                "countdown3-title": "最新 Staycation 酒店限時優惠",
                "month-format": "MMM",
                "order-d-title": "浪漫精品酒店 💕💕",
                "order-g-subtitle": "暑假帶埋一家大細Relax下",
                "order-g-title": "親子Staycation必去之選👨‍👩‍👧‍👦😍",
                "order-h-title": "郵輪之旅🛳️",
                "order-i-title": "情侶煮飯仔酒店 🍽️",
                "order-j-title": "Glamping豪華露營推介",
                "seo-description": "點解咁多人用 HyperAir 搵 Staycation? 因為集合左 KKday, Trip.com, Klook 及各大香港酒店平台，一眼比較邊到有late checkout、免費泊車、自助早午晚餐及餐飲回贈等獨家 Staycation 優惠，每日更新。",
                "seo-keywords": "staycation, staycation 優惠, 香港 staycation, staycation 香港, staycation hk, staycation package, staycation hong kong, 酒店, 酒店 優惠, staycation 中文, 香港 酒店, klook 優惠, klook 優惠, kkday 優惠, trip 優惠, agoda 優惠, runhotel staycation, 酒店 套票, staycation 酒店, 香港 酒店 套票, 訂 酒店 優惠, 酒店 package, 特價 酒店, 香港 優惠 酒店, 酒店 優惠 套 票, 特價 酒店 香港, 香港 酒店 優惠, 酒店 住宿 優惠, staycation 2020, staycation 2021, staycation 2022, staycation 1月 優惠, staycation 2月 優惠, staycation 3月 優惠, staycation 4月 優惠, staycation 5月 優惠, staycation 6月 優惠, staycation 7月 優惠, staycation 8月 優惠, staycation 9月 優惠, staycation 10月 優惠, staycation 11月 優惠, staycation 12月 優惠, 四季酒店, W酒店, Murray, JW Marriott, St. Regis, Conrad Hotel, Grand Hyatt, Ritz Carlton, Rosewood, 露台 酒店, 廚房 酒店, 親子 酒店, 情侶 酒店",
                "seo-title": "【2021年9月最新】香港酒店 Staycation 優惠搜尋神器 全港最齊．每日更新 - 最齊香港staycation優惠、酒店優惠、Hong Kong Staycation Ideas、Klook優惠、KKday優惠、Trip優惠、Agoda優惠、專業旅運優惠 - HyperAir 玩樂必備搜尋比較平台！一次過，比較全球多個玩樂旅遊預訂網站！ - HyperAir",
                "share-button-alert": "Copied the Link",
                "subtitle": "每日更新酒店餐飲及住宿優惠（{start_month}月至{end_month}月）",
                "title": "",
                "top10-title": "",
                "top102-title": "",
                "top103-title": "值得一試的 Staycation 酒店🥂"
            },
            "travel-activities": {
                "best-deals": "Best Deal",
                "book-now": "View Deal",
                "disclaimer": "Giá hiển thị chỉ để tham khảo. Trong trường hợp có sự khác biệt, vui lòng tham khảo trang web của các đối tác của chúng tôi.",
                "empty-destination": "",
                "more-deals": "More Deals",
                "not-available": "Not Available",
                "offers": "",
                "provider-getyourguide": "GetYourGuide",
                "provider-hk": {
                    "trip": {
                        "com": "Trip.com"
                    }
                },
                "provider-hyperair": "HyperAir",
                "provider-kkday": "KKday",
                "provider-klook": "KLOOK",
                "provider-seoultravelpass": "SeoulPass",
                "provider-sim": {
                    "hyperair": {
                        "com": "HyperAir"
                    }
                },
                "provider-travelexpert": "Travel Expert",
                "provider-trip": "Trip.com",
                "ratings": "Xếp hạng",
                "recommended-title": "Các hoạt động phổ biến hơn tại {city}",
                "search-africa-oceania": "Châu Phi / Châu Đại Dương",
                "search-all-cities": "Tất cả các thành phố",
                "search-america": "Mỹ",
                "search-asia": "Châu Á",
                "search-button": "Tìm kiếm",
                "search-cancel-button": "hủy bỏ",
                "search-country-placeholder": "Nhập quốc gia hoặc thành phố",
                "search-euro-middleeast": "Châu Âu / Trung Âu",
                "search-hardcoded-cities": "Popular Tìm Kiếm:",
                "search-placeholder": "Tìm kiếm \"Đèo JR\"",
                "search-popular-cities": "Thành phố nổi tiếng",
                "search-searched-cities": "Thành phố tìm kiếm",
                "search-slogan-2": "",
                "show-similar-product": "Hãy so sánh tương tự",
                "sorting": {
                    "price-asc": "Giá (Thấp đến Cao)",
                    "price-desc": "Giá từ cao đến thấp)",
                    "rating": "Xếp hạng",
                    "relevance": "Relevance",
                    "sort-by": "Sort by"
                },
                "title": "Search results matching \"{q}\"",
                "title-everything": "Popular activities in {city}",
                "title-no-result": "Sorry, we couldn't find any results for \"{q}\"",
                "title-no-result-without-keyword": "Xin lỗi, chúng tôi không thể tìm thấy bất kỳ kết quả",
                "total-results": "Total <b>{number}</b> results"
            },
            "travel-affiliate-codes": {
                "cover-slogan": "Cung cấp mã giảm giá cho các trang web đặt phòng du lịch quốc tế",
                "cover-title": "Phiếu du lịch Giảm giá",
                "disclaimer": "Các Mời khuyến mãi hiển thị là chỉ để tham khảo. Trong trường hợp khác nhau, vui lòng tham khảo trang web của các đối tác của chúng tôi. Các nhà cung cấp có thể thay đổi hoặc xóa thông tin bất cứ lúc nào mà không cần thông báo trước và sẽ có tuỳ ý để cung cấp.",
                "exclusive": "Dành riêng",
                "type-activity": "Hoạt động",
                "type-air": "Vé máy bay",
                "type-all": "Tất cả",
                "type-hotel": "khách sạn",
                "type-insurance": "Bảo hiểm du lịch",
                "type-shopping": "Mua sắm",
                "type-sim": "Thẻ SIM",
                "use-promo-code": "Nhận được mã",
                "valid-until": "Ngày hết hạn:"
            },
            "travel-insurance": {
                "breadcrumb-travel-insurance": "Bảo hiểm du lịch",
                "cover-subtitle": "Tìm kiếm và so sánh bảo hiểm du lịch tốt nhất với vùng phủ sóng điện thoại di động!",
                "cover-title": "Bảo hiểm du lịch",
                "departure-date-alert": "",
                "disclaimer": "Trích dẫn chỉ dành cho tham khảo. Vui lòng tham khảo trang web của công ty bảo hiểm để biết thêm chi tiết.",
                "highlight-subtitle1": "Danh sách các bảo hiểm chủ yếu của kế hoạch bảo hiểm du lịch để lựa chọn dễ dàng của bạn",
                "highlight-subtitle2": "Hãy so sánh các giao dịch bảo hiểm du lịch tốt nhất để giúp bạn tiết kiệm mỗi đô la!",
                "highlight-subtitle3": "Thưởng thức đặc quyền độc quyền bảo hiểm du lịch và cung cấp!",
                "highlight-title1": "bảo hiểm So sánh",
                "highlight-title2": "giá So sánh",
                "highlight-title3": "thưởng Dành riêng",
                "num-of-travellers-alert": "",
                "partner-title": "Travel Insurance Partners của chúng tôi",
                "return-date-alert": "",
                "section-title": "Bạn đang tìm kiếm{num_of_day} cho{num_of_traveller} du lịch (s)",
                "slogan": "3 bước đơn giản",
                "sorting": {
                    "coverage": "Vùng phủ sóng tốt nhất",
                    "price-asc": "Giá (Thấp tới Cao)",
                    "price-desc": "Giá từ cao đến thấp)"
                },
                "step1": "Điền các thông tin",
                "step1-detail": "Nhập điểm đến, ngày của bạn và không. khách du lịch",
                "step2": "Hãy so sánh các kế hoạch",
                "step2-detail": "Hãy so sánh giá cả và độ bao phủ của các kế hoạch bảo hiểm du lịch khác nhau",
                "step3": "Thưởng thức cung cấp",
                "step3-detail": "One-click để thưởng thức cung cấp bảo hiểm du lịch độc quyền"
            },
            "travel-insurance-product-card": {
                "apply-now": "Nhận lời mời",
                "cancellation": "HỦY",
                "car-rental": "XE CHO THUÊ DƯ",
                "cruise-vacation": "CRUISE VACATION (lợi ích không bắt buộc)",
                "dangerous-sports": "THỂ THAO NGUY HIỂM",
                "hyperair-exclusive": "HYPERAIR ĐỘC QUYỀN",
                "medical": "Y KHOA",
                "mobile": "MẤT / THIỆT HẠI điện thoại di động",
                "personal-belongings": "ĐỒ DÙNG CÁ NHÂN",
                "trip-delay": "TRIP TRÌ HOÃN"
            },
            "travel-insurance-search-bar": {
                "children": "Trẻ em từ dưới 18",
                "date": "Ngày khởi hành và ngày trở về",
                "destination": "Bạn đi đâu vậy",
                "friend": "Bạn bè / Người thân",
                "myself": "Riêng tôi",
                "number-of-traveller": "Số Traveler",
                "search-button": "Tìm kiếm",
                "spouse": "vợ"
            },
            "travel-marketplace": {
                "buy-now-can-earn-x-miles": "",
                "cover-slogan": "Một bộ sưu tập các tiện ích tuyệt vời mà bạn sẽ thích",
                "cover-title": "Du lịch Tiện ích"
            },
            "travel-marketplace-categories": "Categories",
            "travel-marketplace-checkout": {
                "delivery-message-body": "ngày làm việc kể từ thứ Hai đến thứ Sáu (trừ ngày lễ). Trình tự cắt thời gian là 12{00} (GMT + 8). Đơn đặt hàng sau 12{00} AM (GMT + 8) sẽ xuất xưởng ra ngày làm việc tiếp theo.",
                "delivery-method-1": "SF Express (Hồng Kông Only)",
                "delivery-method-1-description": "Bởi SF Express, phí chuyển phát nhanh là HK $ 30 mỗi đơn hàng. Phí chuyển phát nhanh được miễn khi mua trên HK $ 800. Các mặt hàng đặt mua sẽ được gửi bằng chuyển phát nhanh trong vòng 1-3 ngày làm việc, và các đảo sẽ mất 5 ngày làm việc, đề cập đến trang web của SF Express.",
                "delivery-method-2": "Vận chuyển quốc tế",
                "delivery-method-2-description": "Giao hàng trong 4-15 ngày làm việc tùy thuộc vào đích. Vận chuyển phí là HK $ 100 cho mỗi mục. Lệ phí chuyển phát quốc tế trên được dựa trên dự toán. phụ phí hơn nữa có thể được áp dụng."
            },
            "travel-money": {
                "breadcrumb-travel-money": "Tiền đi du lịch",
                "cover-button": "Trải nghiệm ngay",
                "cover-slogan": "Đổi tiền du lịch thông minh hơn",
                "cover-title": "Tiền đi du lịch",
                "disclaimer": "Giá hiển thị là chỉ để tham khảo. Trong trường hợp khác nhau, vui lòng tham khảo trang web của những kẻ đổi tiền.",
                "empty-amount": "",
                "fx": "",
                "fx-slogan": "Bốn bước đơn giản",
                "fx-step1": "Tìm kiếm",
                "fx-step1-detail": "Chọn loại tiền bạn muốn đổi",
                "fx-step2": "So sánh",
                "fx-step2-detail": "Tìm tỷ lệ tốt nhất và điểm đón thuận tiện nhất",
                "fx-step3": "Sách",
                "fx-step3-detail": "Dự trữ tiền du lịch trực tuyến",
                "fx-step4": "Nhặt lên",
                "fx-step4-detail": "Hiển thị mã QR để nhận tiền đi lại",
                "hyperair-feature-1": "Thông minh",
                "hyperair-feature-1-description": "Một cách thông minh để trao đổi tiền du lịch. Bây giờ bạn có thể nhận ra mức giá tốt nhất chỉ với một vài cú nhấp chuột và đặt tiền du lịch trực tuyến. Đã đến lúc tạm biệt hàng dài!",
                "hyperair-feature-2": "Đáng tin cậy",
                "hyperair-feature-2-description": "Một cách đáng tin cậy để có được trao đổi tiền. Tất cả các đối tác của chúng tôi là ngân hàng được cấp phép và trao đổi tiền để giữ cho ngoại hối của bạn an toàn.",
                "hyperair-feature-3": "Bất cứ nơi nào. Bất cứ lúc nào.",
                "hyperair-feature-3-description": "Một cách hoàn toàn mới để có được tiền du lịch. Chúng tôi muốn mở rộng dấu chân ở nước ngoài và cung cấp cho bạn trải nghiệm du lịch thông minh nhất ở bất cứ đâu.",
                "i-will-get": "TÔI SẼ NHẬN",
                "i-will-pay": "TÔI SẼ TRẢ",
                "join-us": "Để có thêm cơ hội kinh doanh",
                "join-us-button": "Tham gia cùng chúng tôi ngay",
                "join-us-slogan": "Trở thành nhà cung cấp của chúng tôi",
                "search-bar-placeholder": "nhập Số tiền",
                "search-button": "Tìm kiếm",
                "section-title": "",
                "section-title-from-hkd": "Tìm kiếm HKD cho {amount} {currency}",
                "section-title-to-hkd": "Tìm kiếm {amount} {currency} cho HKD",
                "why-hyperair": "",
                "why-hyperair-description": "HyperAir cung cấp cho bạn một cách hoàn toàn mới để nhận tiền du lịch. Bây giờ bạn có thể đặt trao đổi trực tuyến với tỷ giá hối đoái tốt nhất trong thị trấn!",
                "why-hyperair-title": "Tại sao chọn chúng tôi?"
            },
            "travel-product": {
                "buy-now": "Mua ngay",
                "product-option": "tùy chọn"
            },
            "travel-sim": {
                "as-low-as": "Thấp như",
                "book-now": "ĐẶT HÀNG NGAY",
                "breadcrumb-homepage": "Trang chủ",
                "breadcrumb-mainpage": "Trang chính",
                "breadcrumb-travel-sim": "SIM du lịch",
                "cancellation-policy": "Chính sách hủy",
                "cancellation-policy-content": "Không hủy bỏ, hoàn lại tiền hoặc thay đổi có thể được thực hiện sau khi mua.",
                "download-hyperair-now-description": "Quét mã QR hoặc truy cập cửa hàng ứng dụng để tải xuống Ứng dụng HyperAir",
                "download-hyperair-now-title": "Tải xuống ứng dụng HyperAir",
                "first-step": "Bước 1",
                "go-to-shopping-cart-description": "",
                "go-to-shopping-cart-title": "",
                "hardcoded-countries-title": "Quốc gia nổi tiếng khác:",
                "highlights": "Điểm nổi bật",
                "important-notice": "Thông báo quan trọng",
                "instructions": "Hướng dẫn",
                "lowest-price-guarantee": "Đảm bảo giá tốt nhất",
                "no-stock": "Bán hết",
                "num-of-review": ": đánh giá số đánh giá",
                "popular-countries": "SIM du lịch bao gồm 200 quốc gia",
                "popular-countries-search-button": "Tìm kiếm các quốc gia khác",
                "product-highlights": "Product Description",
                "product-specification": "Đặc điểm kỹ thuật sản phẩm",
                "related-sims": "Liên quan: SIM quốc gia",
                "related-sims-search-button": "Thêm: SIM quốc gia",
                "review": "Ôn tập",
                "review-date": "{ng}ày",
                "review-no-firstname-user": "Khách du lịch",
                "scan-product-qr-code": "掃 Mã QR 此",
                "second-step": "Bước 2",
                "sim": " Sim Cards",
                "web-traffic": "Đã mua: số lần mua hàng kể từ tuần trước và: số người dùng lưu lượng truy cập đang xem SIM này ngay bây giờ",
                "web-traffic-title": "SIM này đang được bán rất chạy!"
            },
            "travel-sim-checkout": {
                "-secure-payment-slogan": "",
                "address": "Địa chỉ giao hàng",
                "address-column1": "ví dụ. Phòng A, 18 / F, Trung tâm Thế giới",
                "address-column2": "ví dụ. 88 đường du lịch",
                "address-column3": "ví dụ. Trung, Hồng Kông",
                "back-button": "Trở lại",
                "checkout-title-1": "Thông tin giao hàng",
                "confirm-button": "Tiếp tục",
                "country-code": "Mã quốc gia",
                "delivery-message-body": "Working days are from Monday to Friday (except public holidays). The order cut-off time is 12：00 PM (GMT+8). Orders placed after 12：00 PM (GMT+8) will ship out the next working day.\n<br><br>Within the same working day, orders with the same delivery address will be sent together.",
                "delivery-message-header": "Thông báo giao hàng",
                "delivery-method": "phương thức vận chuyển",
                "delivery-method-1": "Hong Kong Post (Free)",
                "delivery-method-1-description": "By Hong Kong Post's Local Mail, the estimated delivery will be within 3-6 working days. Status tracking is not available to local mail and customers shall bare the full responsibility of losing items by using Hong Kong Post’s ordinary mail service.\n<br><br>Note: Due to the time required for delivery, customers who are about to travel are recommended to choose SF Express",
                "delivery-method-2": "SF Express (Hong Kong only. Courier fee payable on delivery)",
                "delivery-method-2-description": "By SF Express (courier fee payable on delivery), the ordered items will be delivered by courier within 1-3 working days, and islands will take longer delivery time. The courier fee is about HK$16-$25 by referring to the website of SF Express.\n<br><br>Note: The order over HK$399 will be upgraded to SF Express for FREE",
                "delivery-method-3": "International Shipping",
                "delivery-method-3-description": "Delivered by Hong Kong Post (tracking no. will be provided) within 4 to 15 working days depends on the destination. Shipping cost HK$30.",
                "error-alert-address": "Vui lòng điền địa chỉ giao hàng.",
                "error-alert-invalid-email": "Định dạng email không hợp lệ.",
                "error-alert-invalid-recipient-first-num": "số liên lạc nên được bắt đầu với 2,3,5,6,7,8 hoặc 9.",
                "error-alert-invalid-recipient-number": "Vui lòng điền đúng số liên lạc.",
                "error-alert-invalid-user-first-num": "Số điện thoại di động nên được bắt đầu với 5,6,7,8 hoặc 9.",
                "error-alert-invalid-user-number": "Vui lòng điền đúng số điện thoại di động.",
                "error-alert-personal-info": "Vui lòng điền thông tin cá nhân.",
                "error-alert-recipient-info": "Vui lòng điền vào Thông tin người nhận.",
                "error-invalid-credit-card-info": "Thông tin thẻ tín dụng không hợp lệ",
                "facebook-login": "Tiếp tục với Facebook",
                "google-login": "Tiếp tục với Google",
                "logged-in": "Đăng nhập",
                "login": "Khách hàng hiện tại, đăng nhập để tận hưởng dịch vụ trả phòng nhanh",
                "login-button": "Đăng nhập",
                "login-email": "E-mail",
                "login-no-user-exists": "Úi! Xin lỗi, chúng tôi không thể xác nhận thông tin đăng nhập của bạn. Vui lòng thử lại hoặc đơn giản là hoàn thành đơn hàng mà không cần trả phòng cho khách.",
                "login-password": "mật khẩu",
                "payme": {
                    "error-contacting-payme": "Lỗi thanh toán, xin vui lòng sắp xếp lại một lần nữa hoặc hỗ trợ khách hàng tiếp xúc."
                },
                "payment": {
                    "actual-payment": "The transaction will be settled at HK${actual_payment} and the exchange rate will be based on your credit card issuer.",
                    "choose-payment-method": "Lựa chọn hình thức thanh toán:",
                    "logistic-information": "Thông tin giao hàng",
                    "modify-information": "Chỉnh sửa thông tin",
                    "pay-now": "Thanh toán ngay",
                    "payme-instruction-do-not-close": "Xin đừng đóng trang này trước khi thanh toán hoàn tất",
                    "payme-instruction-step-1": "1. Mở ứng dụng PayMe.",
                    "payme-instruction-step-2": "2. Quét các PayCode để ủy quyền thanh toán.",
                    "payme-instruction-step-3": "3. Hoàn tất thanh toán trong ứng dụng và chờ đợi để xác nhận.",
                    "payme-instruction-title": "Thanh toán bằng PayMe",
                    "payme-title": "Quét PayCode này với PayMe",
                    "payment": "Thanh toán",
                    "price": "Số tiền",
                    "shipping-fee": "Phí vận chuyển",
                    "subtotal": "Tổng phụ"
                },
                "payment-method": "Phương thức thanh toán",
                "pending": {
                    "mobile-redirection-text": "Bạn đã chọn PayMe như phương thức thanh toán và sẽ được chuyển đến các ứng dụng PayMe để thanh toán hoàn tất.",
                    "need-to-pay": "Số tiền do",
                    "order-number": "Số thứ tự",
                    "order-success-please-pay": "Hãy trả với PayMe để hoàn tất quá trình đặt hàng",
                    "paycode-error": "Lỗi thanh toán, xin vui lòng sắp xếp lại một lần nữa hoặc hỗ trợ khách hàng tiếp xúc.",
                    "paycode-expired": "paycode PayMe của hết hạn, hãy sắp xếp lại một lần nữa.",
                    "re-order": "Sắp xếp lại",
                    "title-payme": "Pay với PayMe"
                },
                "recipient-address": "Địa chỉ giao hàng",
                "recipient-information": "Thông tin người nhận",
                "recipient-name": "Tên người nhận",
                "recipient-phone-number": "Số điện thoại người nhận",
                "secure-payment-slogan": "Thanh toán an toàn | Thanh toán sẽ được mã hóa và truyền an toàn bằng SSL",
                "simproduct-detail": "Thông tin đặt hàng",
                "simproduct-quantity": "SỐ LƯỢNG",
                "simproduct-redeem": "",
                "simproduct-redeem-hypermiles": "",
                "simproduct-title": "Sản phẩm",
                "simproduct-will-redeeming-x-miles": "",
                "simproduct-you-have-x-hypermiles": "",
                "user-email": "Email (Để nhận hóa đơn)",
                "user-firstname": "Tên đầu tiên",
                "user-information": "Thông tin cá nhân",
                "user-lastname": "họ",
                "user-phone-number": "Số điện thoại",
                "vertical-divider": "hoặc là"
            },
            "travel-sims": {
                "column-title-1": "Phân loại rõ ràng, dễ chọn",
                "column-title-2": "Thanh toán trực tuyến, thuận tiện và nhanh chóng",
                "column-title-3": "Surface Mail miễn phí, giao hàng nhanh chóng",
                "country-search-no-place-found": "Không có kết quả được tìm thấy cho điểm đến này",
                "cover-button": "Đặt hàng với ứng dụng HyperAir ngay bây giờ",
                "cover-slogan": "Ưu đãi thẻ SIM tốt nhất với giao hàng miễn phí!",
                "cover-title": "SIM du lịch",
                "empty-destination": "",
                "num-of-days": "",
                "search-button": "",
                "search-input": "Tìm kiếm đất nước",
                "search-placeholder": "Tìm kiếm đất nước",
                "search-slogan": "Bạn đi đâu vậy?",
                "travel-sim-header-description": "",
                "travel-sim-header-title": ""
            }
        },
        "passwords": {
            "password": "Mật khẩu phải có ít nhất sáu ký tự và khớp với xác nhận.",
            "reset": "Mật khẩu của bạn đã được thiết lập lại!",
            "sent": "Chúng tôi đã gửi email liên kết đặt lại mật khẩu của bạn!",
            "token": "Mã thông báo đặt lại mật khẩu này không hợp lệ.",
            "user": "Chúng tôi không thể tìm thấy người dùng có địa chỉ email đó."
        },
        "mail": {
            "product-simcard": {
                "delivery-update": {
                    "subject": "Đơn hàng thẻ SIM của bạn đang trên đường"
                },
                "purchased": {
                    "subject": "Xác nhận đơn hàng SIM du lịch"
                },
                "tracking-number-update": {
                    "subject": "Số theo dõi đơn hàng của bạn được cập nhật"
                }
            }
        },
        "member-center": {
            "login-to-receive-codes": "",
            "my-orders-empty": "không ghi",
            "my-orders-title": "Đơn đặt hàng của tôi",
            "profile-area-code": "Mã vùng",
            "profile-email": "E-mail",
            "profile-firstname": "Tên đầu tiên",
            "profile-lastname": "tên họ",
            "profile-save": "Tiết kiệm",
            "profile-tel": "Tel",
            "profile-title": "Hồ sơ",
            "profile-update-successfully": "",
            "promo-code-enter-promotion-code": "Nhập Mã số khuyến mãi",
            "promo-code-my-promo-code": "My HyperAir Promotion Code",
            "promo-code-no-code": "",
            "promo-code-please-fill-in-code": "",
            "promo-code-redeem": "chuộc lại",
            "promo-code-redeem-code": "Đổi HyperAir Promotion Code",
            "promo-code-select": "Lựa chọn",
            "promo-code-title": "HyperAir Promo Mã",
            "title": "Trung tâm thành viên"
        },
        "weekday": {
            "1": "thứ hai",
            "2": "thứ ba",
            "3": "Thứ tư",
            "4": "Thứ năm",
            "5": "Thứ sáu",
            "6": "ngày thứ bảy",
            "7": "chủ nhật"
        },
        "exchange-shop-details": {
            "address": "Địa chỉ",
            "book-button": "Đặt bây giờ",
            "br": "BR",
            "closed-book-button": "khép kín",
            "download-pop-up": {
                "slogan-1": "Khóa trong Rate",
                "slogan-2": "tức thì comfirmation",
                "title": "Tải ứng dụng cho đăng ký trước FX"
            },
            "latest-updated": "Cập nhật gần nhất",
            "not-available-book-button": "Không có sẵn",
            "opening-hrs": "Giờ mở cửa",
            "phone-num": "Số điện thoại",
            "rate": "Tỷ lệ",
            "reviews": "Nhận xét",
            "table-buy-rate": "tỷ lệ Mua",
            "table-compare-button": "Đối chiếu",
            "table-currency": "Tiền tệ",
            "table-sell-rate": "bán Rate",
            "table-short-form": "Mã",
            "table-title": "Đơn vị tiền tệ khác"
        },
        "credit-card": {
            "cannot-add-card": "Đã xảy ra lỗi khi thêm thẻ tín dụng của bạn. Vui lòng kiểm tra thông tin của bạn và thử lại hoặc bạn có thể thêm một thẻ tín dụng khác.",
            "cannot-process": "Đã xảy ra lỗi khi sạc thẻ tín dụng của bạn. Vui lòng kiểm tra thông tin của bạn và thử lại hoặc bạn có thể kiểm tra bằng thẻ tín dụng khác."
        },
        "shoppingcart": {
            "add": {
                "no-stock": "Úi! Đạt số lượng mua tối đa cho sản phẩm này ..."
            },
            "pay": {
                "db-locked": "Máy chủ bận. Vui lòng thử lại sau. (Mã tham chiếu: E1003)",
                "invalid-promotion-code": "Mã khuyến mãi không hợp lệ",
                "no-stock": "Sản phẩm hết hàng ngay bây giờ! (Mã tham chiếu: E1002)"
            },
            "promotion-message": {
                "up-sell-1": "Tận hưởng 10 đô la Hồng Kông với phiếu giảm giá chào mừng",
                "up-sell-2": "Tận hưởng 15 đô la Hồng Kông với mã khuyến mãi HYPER15 khi chi tiêu trên 299 đô la Hồng Kông"
            }
        },
        "product": {
            "label-confirmation-duration-24_hours": "Xác nhận 24 giờ",
            "label-confirmation-duration-48_hours": "Xác nhận 48 giờ",
            "label-confirmation-duration-instant": "Chứng nhận tức thì",
            "label-duration-unit-day": "& nbsp; ngày",
            "label-duration-unit-hour": "Giờ",
            "label-duration-unit-hr": "& nbsp; giờ",
            "label-duration-unit-min": "& nbsp; phút",
            "label-earliest-available-date": "j M Y",
            "label-earliest-available-date-today": "Hôm nay",
            "label-earliest-available-date-tomorrow": "Ngày mai",
            "label-lang-en": "Anh",
            "label-lang-jp": "tiếng Nhật",
            "label-lang-kr": "Hàn Quốc",
            "label-lang-zh": "Trung Quốc",
            "label-meet-up-method-hotel_pickup": "Đón khách sạn",
            "label-meet-up-method-location_meet_up": "Địa điểm gặp gỡ",
            "label-refundable-conditional_cancel": "Hủy điều kiện",
            "label-refundable-no_cancel": "Không hủy",
            "label-ticket-logistic-mobile": "Chứng từ di động được chấp nhận",
            "label-ticket-logistic-printed": "Chứng từ in",
            "label-ticket-logistic-printed_or_mobile": "Chứng từ in hoặc di động được chấp nhận",
            "label-ticket-validity-fixed_date": "Vé ngày cố định",
            "label-ticket-validity-open_date": "Vé ngày mở",
            "label-ticket-validity-open_or_fixed_date": "Vé ngày mở / cố định"
        },
        "pagination": {
            "next": "Tiếp theo & raquo;",
            "previous": "& laquo; Trước"
        },
        "city": {
            "abu-dhabi": "Abu Dhabi",
            "adelaide": "Thành phố",
            "agra": "Agra",
            "ahmedabad": "Ahmedabad",
            "alice-springs": "Suối nước nóng",
            "alsace": "Alsace",
            "amritsar": "Amritsar",
            "amsterdam": "Amsterdam",
            "andalusia": "Andalusia",
            "antalya": "Antalya",
            "anuradhapura": "Anuradhapura",
            "athens": "Athens",
            "auckland": "Auckland",
            "bacolod": "Bacolod",
            "bagan": "Bagan",
            "baku": "Baku",
            "bali": "Bali",
            "bandung": "Ma-rốc",
            "bangalore": "Bangalore",
            "bangkok": "Bangkok",
            "barcelona": "Barcelona",
            "batam": "Batam",
            "bath": "Bồn tắm",
            "bay-of-islands": "Vịnh Đảo",
            "beijing": "Bắc Kinh",
            "belfast": "Belfast",
            "bentota": "Bentota",
            "berlin": "Berlin",
            "bohol": "Bô-na",
            "boracay": "Boracay",
            "bordeaux": "Bêlarut",
            "boston": "Boston",
            "bratislava": "Bratislava",
            "brisbane": "Brisbane",
            "bruges": "Quê hương",
            "brussels": "Brussels",
            "budapest": "Budapest",
            "burgundy": "Burgundy",
            "busan": "Busan",
            "cairns": "Thành phố Cairns",
            "cambridge": "Cambridge",
            "cameron-highlands": "Cao nguyên Cameron",
            "canary-islands": "đảo Canary",
            "cape-town": "Cape Town",
            "cappadocia": "Cappadocia",
            "cebu": "Cebu",
            "champagne": "Rượu sâm banh",
            "chengdu": "Thành Đô",
            "chennai": "Chennai",
            "chiang-mai": "Chiang Mai",
            "chiang-rai": "Tỉnh Chiang Rai",
            "chiayi": "Gia Nghĩa",
            "chicago": "Chicago",
            "chongqing": "Trùng Khánh",
            "christchurch": "Thành phố",
            "cochin": "Cochin",
            "cologne": "Köln",
            "colombo": "Colombo",
            "copenhagen": "Copenhagen",
            "costa-del-sol": "Costa del Sol",
            "crete": "Bêlarut",
            "da-lat": "Đà Lạt",
            "da-nang": "Đà Nẵng",
            "darwin": "Darwin",
            "davao": "Davao",
            "delhi": "Delhi",
            "dhaka": "Thủ đô",
            "dresden": "Dresden",
            "dubai": "Dubai",
            "dublin": "Dublin",
            "dubrovnik": "Cô dâu",
            "dumaguete": "Dumaguete",
            "dunedin": "Dunedin",
            "düsseldorf": "Düsseldorf",
            "edinburgh": "Edinburgh",
            "finnish-lapland": "",
            "florence": "Florence",
            "frankfurt": "Frankfurt",
            "fraser-island": "Đảo Fraser",
            "french-riviera": "Pháp",
            "fukuoka": "Fukuoka",
            "galle": "Galle",
            "galway": "Galway",
            "gangtok": "Gangtok",
            "gangwon-do": "Gangwon-do",
            "gdansk": "Gda Gdansksk",
            "geneva": "Genève",
            "genting-highlands": "Cao nguyên Genting",
            "geraldton": "Geraldton",
            "glasgow": "Glasgow",
            "goa": "Goa",
            "gold-coast": "Bờ biển Vàng",
            "gothenburg": "Gothenburg",
            "guam": "Quê hương",
            "guangdong": "Quảng Đông",
            "guilin": "Quế Lâm",
            "guizhou": "Quý Châu",
            "gyeonggi-do": "Gyeonggi-do",
            "haikou": "Hải Khẩu",
            "hakone": "Nhật Bản",
            "halong": "Hạ Long",
            "hamburg": "Hamburg",
            "hangzhou": "Hàng Châu",
            "hanoi": "Hà nội",
            "harbin": "Cáp Nhĩ Tân",
            "hat-yai": "Hat Yai",
            "hawaii": "Hawaii",
            "heidelberg": "Heidelberg",
            "helsinki": "Helsinki",
            "himachal-pradesh": "Himachal Pradesh",
            "hiroshima": "Hiroshima",
            "ho-chi-minh-city": "Thành phố Hồ Chí Minh",
            "hobart": "Hobart",
            "hoi-an": "Hội An",
            "hokkaido": "Hokkaido",
            "hong-kong": "Hồng Kông",
            "hua-hin": "Hua Hin",
            "hualien": "Hoa Liên",
            "hue": "Huế",
            "hyderabad": "Thành phố",
            "iloilo": "Iloilo",
            "incheon": "Incheon",
            "inle-lake": "Hồ Inle",
            "inner-mongolia": "Nội Mông",
            "innsbruck": "Innsbruck",
            "interlaken": "Xen kẽ",
            "inverness": "Đầm lầy",
            "ipoh": "Ipoh",
            "istanbul": "Istanbul",
            "jaipur": "Jaipur",
            "jaisalmer": "Jaisalmer",
            "jakarta": "Thủ đô Jakarta",
            "jeju": "Jeju",
            "jerusalem": "Jerusalem",
            "jodhpur": "Đức Giê-hô-va",
            "johor-bahru": "Johor Bahru",
            "kandy": "Kandy",
            "kaohsiung": "Cao Hùng",
            "kathmandu": "Thủ đô",
            "kazan": "Kazan",
            "kenting": "Kenting",
            "kiev": "Kiev",
            "kinmen": "Kinmen",
            "kobe": "Kobe",
            "koh-chang": "Koh Chang",
            "koh-samui": "Koh",
            "krabi": "Krabi",
            "krakow": "Krakow",
            "kuala-lumpur": "Quốc tế",
            "kumamoto": "Kumamoto",
            "kyoto": "Kyoto",
            "kyushu": "Kyushu",
            "lake-district": "Quận Hồ",
            "langkawi": "Langkawi",
            "lapland": "Nội địa",
            "las-vegas": "Las Vegas",
            "launceston": "Launceston",
            "lausanne": "Lausanne",
            "leipzig": "Trung tâm",
            "lisbon": "Lisbon",
            "liverpool": "Liverpool",
            "ljubljana": "Ljubljana",
            "loire-valley": "thung lũng Loire",
            "lombok": "Lombok",
            "london": "London",
            "los-angeles": "Los Angeles",
            "luang-prabang": "Luông Pha Băng",
            "lucerne": "Lucerne",
            "lviv": "Lviv",
            "lyon": "Lyon",
            "macao": "Ma Cao",
            "macau": "",
            "madrid": "Madrid",
            "malaga": "Malaga",
            "manchester": "Manchester",
            "mandalay": "Trừng phạt",
            "manila": "Manila",
            "marrakech": "Thành phố cổ",
            "mauritius": "Mô-ri-xơ",
            "medan": "Medan",
            "melaka": "Melaka",
            "melbourne": "Melbourne",
            "miami": "Miami",
            "milford-sound": "Âm thanh Milford",
            "montreux": "Montreux",
            "moscow": "Matxcơva",
            "mumbai": "Mumbai",
            "munich": "Munich",
            "muscat": "Quảng trường",
            "nagano": "Nagano",
            "nagoya": "Nagoya",
            "naples": "Thành phố Naples",
            "nelson": "Nelson",
            "new-delhi": "New Delhi",
            "new-york": "Newyork",
            "nha-trang": "Nha Trang",
            "niagara-falls": "thác Niagara",
            "niigata": "Niigata",
            "normandy": "Normandy",
            "odessa": "Thành phố",
            "okayama": "Okayama",
            "okinawa": "Okinawa",
            "orlando": "Orlando",
            "osaka": "Osaka",
            "oslo": "Oslo",
            "oxford": "Oxford",
            "palawan": "Palawan",
            "paris": "Paris",
            "pattaya": "Pattaya",
            "penang": "Penang",
            "penghu": "Bành Hồ",
            "perth": "Perth",
            "philadelphia": "Philadelphia",
            "phnom-penh": "Phnom Penh",
            "phu-quoc": "Phú Quốc",
            "phuket": "Phuket",
            "pisa": "Pisa",
            "pokhara": "Nhà thờ",
            "port-lincoln": "Cảng Lincoln",
            "porto": "",
            "porto-district": "Quận Porto",
            "prague": "Prague",
            "provence": "Provence",
            "puglia": "Puglia",
            "pune": "Pune",
            "pushkar": "Đẩy",
            "queenstown": "Queenstown",
            "ras-al-khaimah": "Ras Al Khaimah",
            "reykjavik": "Thành phố",
            "rhodes": "Rhodes",
            "rhône-alpes": "Rhône-Alpes",
            "rome": "la Mã",
            "rotorua": "Cánh quạt",
            "rotterdam": "Rotterdam",
            "sabah": "Sabah",
            "saint-petersburg": "Saint Petersburg",
            "saipan": "Saipan",
            "salzburg": "Salzburg",
            "san-diego": "thành phố San Diego",
            "san-francisco": "San Francisco",
            "santorini": "Đảo san hô",
            "sanya": "Tam Á",
            "sapa": "Sapa",
            "sarawak": "Sarawak",
            "seattle": "Seattle",
            "seoul": "Seoul",
            "seville": "Seville",
            "shanghai": "Thượng Hải",
            "sibiu": "Anh chị em",
            "sicily": "Sicily",
            "siem-reap": "Xiêm Riệp",
            "sihanoukville": "Sihanoukville",
            "singapore": "Singapore",
            "split": "Tách",
            "surabaya": "Surabaya",
            "suzhou": "Tô Châu",
            "swedish-lapland": "Lapland Thụy Điển",
            "sydney": "Sydney",
            "taichung": "Đài Trung",
            "tainan": "Đài Nam",
            "taipei": "Đài Bắc",
            "taitung": "Taitung",
            "tarragona": "Tarragona",
            "taupo": "Taupo",
            "terengganu": "Terengganu",
            "thessaloniki": "Thessaloniki",
            "tokyo": "Tokyo",
            "toledo": "Toledo",
            "trincomalee": "Trincomalee",
            "turin": "Torino",
            "udaipur": "Thành phố Udaipur",
            "uluru": "Uluru",
            "uttarakhand": "Uttarakhand",
            "varanasi": "Varanasi",
            "venice": "Venice",
            "verona": "Thành phố",
            "vienna": "Viên",
            "vientiane": "Viêng Chăn",
            "volendam": "Volendam",
            "washington-dc": "Washington DC",
            "wellington": "Wellington",
            "whitsundays": "Whitsundays",
            "xiamen": "Hạ Môn",
            "xian": "Tây An",
            "yangon": "Yangon",
            "yilan": "Yilan",
            "yogyakarta": "Yogyakarta",
            "york": "York",
            "yunnan": "Vân Nam",
            "zagreb": "Zagreb",
            "zhangjiajie": "Trương Gia Giới",
            "zurich": "Zurich"
        },
        "validation": {
            "accepted": "Thuộc tính: phải được chấp nhận.",
            "active_url": "Thuộc tính: không phải là một URL hợp lệ.",
            "after": "Thuộc tính: phải là một ngày sau: ngày.",
            "after_or_equal": "Thuộc tính: phải là một ngày sau hoặc bằng: ngày.",
            "alpha": "Thuộc tính: chỉ có thể chứa các chữ cái.",
            "alpha_dash": "Thuộc tính: chỉ có thể chứa các chữ cái, số và dấu gạch ngang.",
            "alpha_num": "Thuộc tính: chỉ có thể chứa các chữ cái và số.",
            "array": "Thuộc tính: phải là một mảng.",
            "before": "Thuộc tính: phải là một ngày trước: ngày.",
            "before_or_equal": "Thuộc tính: phải là một ngày trước hoặc bằng: ngày.",
            "between": {
                "array": "Thuộc tính: phải có giữa: min và: max item.",
                "file": "Thuộc tính: phải nằm trong khoảng: min và: kilobyte tối đa.",
                "numeric": "Thuộc tính: phải nằm giữa: min và: max.",
                "string": "Thuộc tính: phải nằm giữa: min và: max character."
            },
            "boolean": "Trường thuộc tính: phải đúng hoặc sai.",
            "confirmed": "Xác nhận: thuộc tính không khớp.",
            "custom": {
                "attribute-name": {
                    "rule-name": "thông báo tùy chỉnh"
                }
            },
            "date": "Thuộc tính: không phải là một ngày hợp lệ.",
            "date_format": "Thuộc tính: không khớp với định dạng: định dạng.",
            "different": "Thuộc tính: và khác phải khác.",
            "digits": "Thuộc tính: phải là: chữ số chữ số.",
            "digits_between": "Thuộc tính: phải nằm giữa: min và: chữ số tối đa.",
            "dimensions": "Thuộc tính: có kích thước hình ảnh không hợp lệ.",
            "distinct": "Trường thuộc tính: có một giá trị trùng lặp.",
            "email": "Thuộc tính: phải là một địa chỉ email hợp lệ.",
            "exists": "Thuộc tính được chọn: không hợp lệ.",
            "file": "Thuộc tính: phải là một tệp.",
            "filled": "",
            "image": "",
            "in": "Thuộc tính được chọn: không hợp lệ.",
            "in_array": "",
            "integer": "",
            "ip": "",
            "ipv4": "",
            "ipv6": "",
            "json": "",
            "max": {
                "array": "",
                "file": "",
                "numeric": "",
                "string": ""
            },
            "mimes": "",
            "mimetypes": "",
            "min": {
                "array": "",
                "file": "",
                "numeric": "",
                "string": ""
            },
            "not_in": "Thuộc tính được chọn: không hợp lệ.",
            "numeric": "",
            "present": "",
            "regex": "",
            "required": "",
            "required_if": "",
            "required_unless": "",
            "required_with": "",
            "required_with_all": "",
            "required_without": "",
            "required_without_all": "",
            "same": "",
            "size": {
                "array": "",
                "file": "",
                "numeric": "",
                "string": ""
            },
            "string": "",
            "timezone": "",
            "unique": "",
            "uploaded": "",
            "url": ""
        },
        "reset-password": {
            "confirm-new-password": "Xác nhận mật khẩu mới",
            "enter-new-password": "Nhập mật khẩu mới",
            "please-enter-a-new-password": "Vui lòng nhập mật khẩu mới cho tài khoản của bạn: email.",
            "submit": "Gửi đi",
            "success-content": "Thành công! Vui lòng đăng nhập vào ứng dụng di động HyperAir bằng mật khẩu mới.",
            "title": "Đặt lại mật khẩu",
            "validation-display": "Mật khẩu phải chứa ít nhất 6 ký tự."
        },
        "notification": {
            "activation-e-minus-content": "15 ngày đếm ngược! Phiếu giảm giá chào mừng SIM du lịch của bạn sẽ sớm hết hạn! Đừng bỏ lỡ cơ hội sử dụng phiếu giảm giá cho chuyến đi sắp tới của bạn!",
            "activation-e-minus-title": "",
            "activation-t-plus-content": "Hãy nhớ sử dụng phiếu giảm giá thẻ SIM chào mừng của chúng tôi cho chuyến đi sắp tới c��a bạn! Du lịch thông minh hơn. Bất cứ nơi nào.",
            "activation-t-plus-title": "",
            "ask-shop-to-quote-content": "Yêu cầu báo giá khi mua: số tiền: tiền tệ",
            "ask-shop-to-quote-content2": "Yêu cầu báo giá bán: số tiền: tiền tệ",
            "ask-shop-to-quote-title": "Yêu cầu báo giá mới",
            "email-booking-details": "Chi tiết đặt phòng",
            "email-booking-id": "ID đặt chỗ",
            "email-exchange-approved-content": "Đơn đặt hàng trao đổi được chấp thuận để mua: số tiền: tiền tệ theo tỷ lệ: tỷ lệ",
            "email-exchange-approved-footer": "Cảm ơn bạn đã sử dụng HyperAir.",
            "email-exchange-approved-title": "Cửa hàng trả lời: \"Tiền du lịch của bạn đã sẵn sàng để nhận!\"",
            "email-exchange-completed-content": "Đơn hàng đã trao đổi đã hoàn tất để mua: số tiền: tiền tệ theo tỷ lệ: tỷ giá",
            "email-exchange-completed-footer": "Cảm ơn bạn đã sử dụng HyperAir.",
            "email-exchange-completed-title": "Trao đổi tiền du lịch của bạn đã hoàn tất!",
            "email-exchange-confirmed-content": "Đơn hàng đã trao đổi được xác nhận để mua: số tiền: tiền tệ theo tỷ lệ: tỷ giá",
            "email-exchange-confirmed-footer": "Cảm ơn bạn đã sử dụng HyperAir.",
            "email-exchange-confirmed-title": "Tiền du lịch của bạn đã sẵn sàng để đón bạn!",
            "email-footer-copy-right": "Đã đăng ký Bản quyền.",
            "email-greetings": "Xin chào!",
            "email-i-got": "tôi đã nhận",
            "email-i-paid": "Tôi đã trả",
            "email-i-will-get": "tôi sẽ nhận",
            "email-i-will-pay": "tôi sẽ trả",
            "email-pickup-before": "Đón trước",
            "email-product-confirmed-greeting": "Kính gửi quý khách hàng,<br><br>Cảm ơn bạn đã sử dụng HyperAir. Chứng từ của bạn đã sẵn sàng",
            "email-product-confirmed-subject": "Đơn hàng đã được xác nhận",
            "email-product-confirmed-title": "Đơn hàng của bạn đã được xác nhận",
            "email-product-purchased": {
                "shipping": {
                    "international": "Vận chuyển quốc tế",
                    "sf": "SF Express (Hồng Kông Only)"
                }
            },
            "email-product-purchased-delievery-address": "Địa chỉ giao hàng",
            "email-product-purchased-delivery-info": "Cung cấp Thông tin",
            "email-product-purchased-delivery-method": "phương thức vận chuyển",
            "email-product-purchased-discount": "Giảm giá",
            "email-product-purchased-email": "E-mail",
            "email-product-purchased-greeting": "Kính gửi quý khách hàng,<br><br> Lựa chọn tốt. Sẽ mất một thời gian để xác nhận đặt phòng. Nhưng đừng lo lắng, hầu hết thời gian chúng tôi có thể xác nhận đơn hàng trong vòng 12 giờ. Cảm ơn bạn đã sử dụng HyperAir!",
            "email-product-purchased-have-a-nice-trip": "Chúc bạn có một chuyến đi vui vẻ",
            "email-product-purchased-important-notice": "Áp dụng Điều khoản và chính sách.",
            "email-product-purchased-important-notice-content": "Áp dụng Điều khoản và chính sách.",
            "email-product-purchased-name": "tên",
            "email-product-purchased-order-date": "NGÀY ĐẶT HÀNG",
            "email-product-purchased-order-details": "Chi tiết đặt hàng",
            "email-product-purchased-order-no": "Số thứ tự",
            "email-product-purchased-personal-info": "Thông tin cá nhân",
            "email-product-purchased-receipient-name": "Tên người nhận",
            "email-product-purchased-receipient-phone-no": "Không có điện thoại.",
            "email-product-purchased-shipping-fee": "Phí vận chuyển",
            "email-product-purchased-sub-total": "Tổng phụ",
            "email-product-purchased-subject": "Đơn hàng đang chờ xử lý để xác nhận",
            "email-product-purchased-title": "Đơn hàng của bạn đang chờ xử lý",
            "email-product-purchased-total": "toàn bộ",
            "email-product-simcapurchased-personal-info": "Thông tin cá nhân",
            "email-product-simcard-delivery-title": "SIM đặt hàng của bạn: order-num đã được chuẩn bị và giao hàng vào: ngày. Nếu bạn đã chọn SF Express, chúng tôi sẽ cung cấp số theo dõi sau. Bạn cũng có thể kiểm tra nó trên ứng dụng di động của chúng tôi.",
            "email-product-simcard-delivery-title-carbon-format": "j M Y",
            "email-product-simcard-delivery-update-greeting": "Kính gửi quý khách hàng,<br><br>Cảm ơn bạn đã sử dụng HyperAir. Đơn hàng thẻ SIM của bạn đang trên đường.",
            "email-product-simcard-delivery-update-title": "Đơn hàng thẻ SIM của bạn đang trên đường",
            "email-product-simcard-delivery-update-tracking": "Theo dõi chi tiết",
            "email-product-simcard-delivery-update-tracking-no": "Số theo dõi",
            "email-product-simcard-delivery-update-tracking-no-hkpost": "Số theo dõi: -",
            "email-product-simcard-delivery-update-tracking-no-sf": "Số theo dõi",
            "email-product-simcard-delivery-waiting-update-tracking-no-sf": "Đang chờ SF Express cập nhật",
            "email-product-simcard-delivery-with-tracking-num-title": "SIM đặt hàng của bạn: order-num sẽ được SF Express vận chuyển với số theo dõi :: theo dõi-num. Vui lòng chú ý đến điện thoại di động của bạn để nhận giao hàng. Bạn cũng có thể kiểm tra trạng thái giao hàng trên trang web SF Express. Cảm ơn bạn đã sử dụng dịch vụ HyperAir.",
            "email-product-simcard-esim-code-greeting": "Kính gửi quý khách hàng,<br><br>Cảm ơn bạn đã sử dụng HyperAir. Đây là Mã QR kích hoạt eSIM của bạn.",
            "email-product-simcard-esim-code-important-notice-content": "<span style=\"font-size: 10px; line-height: 12px;\">Hướng dẫn:<br />1. Chuyển đến Cài đặt<br />2. Nhấn \"Dữ liệu di động\"<br />3. Trong Gói dữ liệu, hãy nhấn \"Thêm gói dữ liệu\"<br />4. Quét mã QR trong máy ảnh frame<br />Nếu bạn được yêu cầu nhập mã xác nhận để kích hoạt eSIM, hãy nhập số mà nhà cung cấp dịch vụ cung cấp. Có một câu hỏi? Vui lòng gửi email đến hello@hyperair.com và chúng tôi sẽ liên lạc lại với bạn.</span>",
            "email-product-simcard-esim-code-title": "Đây là Mã QR kích hoạt eSIM của bạn",
            "email-product-simcard-esim-code-warning": "Vui lòng lưu ý rằng eSIM sẽ được kích hoạt sau khi quét mã QR. Vui lòng chỉ quét khi bạn muốn bắt đầu dịch vụ.",
            "email-product-simcard-purchased-delievery-address": "Địa chỉ giao hàng",
            "email-product-simcard-purchased-delivery-info": "Thông tin giao hàng",
            "email-product-simcard-purchased-delivery-method": "phương thức vận chuyển",
            "email-product-simcard-purchased-discount": "Giảm giá",
            "email-product-simcard-purchased-greeting": "Kính gửi quý khách hàng,<br><br>Cảm ơn bạn đã sử dụng HyperAir. Chúng tôi hiện đang chuẩn bị giao SIM du lịch của bạn.",
            "email-product-simcard-purchased-greeting-esim-only": "Kính gửi quý khách hàng,<br><br>Cảm ơn bạn đã sử dụng HyperAir, eSIM của bạn đã sẵn sàng! Vui lòng tìm mã QR đính kèm và kích hoạt theo hướng dẫn.",
            "email-product-simcard-purchased-greeting-esim-with-sim": "Kính gửi quý khách hàng,<br><br>Cảm ơn bạn đã sử dụng HyperAir. Chúng tôi hiện đang chuẩn bị giao SIM du lịch của bạn. Đối với eSIM của bạn, vui lòng tìm mã QR đính kèm và kích hoạt theo hướng dẫn.",
            "email-product-simcard-purchased-greeting-sim-only": "Kính gửi quý khách hàng,<br><br>Cảm ơn bạn đã sử dụng HyperAir. Chúng tôi hiện đang chuẩn bị giao SIM du lịch của bạn.",
            "email-product-simcard-purchased-have-a-nice-trip": "Chúc bạn có một chuyến đi vui vẻ",
            "email-product-simcard-purchased-important-notice": "Thông báo quan trọng",
            "email-product-simcard-purchased-important-notice-content": "<span style=\"font-size: 10px; line-height: 12px;\">1. Theo Thư địa phương của Bưu điện Hồng Kông, việc giao hàng ước tính sẽ trong vòng 5 ngày làm việc. Theo dõi trạng thái không có sẵn cho thư địa phương và khách hàng sẽ chịu toàn bộ trách nhiệm về việc mất các mặt hàng bằng cách sử dụng Hồng Kông </span><br> <span style=\"font-size: 10px; line-height: 12px;\">2. Vui lòng kích hoạt thẻ SIM du lịch trước khi hết hạn.</span><br> <span style=\"font-size: 10px; line-height: 12px;\">3. Tất cả các sản phẩm được giao phải tuân theo các điều khoản và điều kiện.</span><br><br> <span style=\"font-size: 10px; line-height: 12px;\">Bạn có câu hỏi không? Vui lòng gửi email đến hello@hyperair.com và chúng tôi sẽ liên lạc lại với bạn.</span>",
            "email-product-simcard-purchased-important-notice-content-esim-only": "<span style=\"font-size: 10px; line-height: 12px;\">1. Theo Thư địa phương của Bưu điện Hồng Kông, việc giao hàng ước tính sẽ trong vòng 5 ngày làm việc. Theo dõi trạng thái không có sẵn cho thư địa phương và khách hàng sẽ chịu toàn bộ trách nhiệm về việc mất các mặt hàng bằng cách sử dụng Hồng Kông </span><br> <span style=\"font-size: 10px; line-height: 12px;\">2. Vui lòng kích hoạt thẻ SIM du lịch trước khi hết hạn.</span><br> <span style=\"font-size: 10px; line-height: 12px;\">3. Tất cả các sản phẩm được giao phải tuân theo các điều khoản và điều kiện.</span><br><br> <span style=\"font-size: 10px; line-height: 12px;\">Bạn có câu hỏi không? Vui lòng gửi email đến hello@hyperair.com và chúng tôi sẽ liên lạc lại với bạn.</span>",
            "email-product-simcard-purchased-important-notice-content-esim-with-sim": "<span style=\"font-size: 10px; line-height: 12px;\">1. Theo Thư địa phương của Bưu điện Hồng Kông, việc giao hàng ước tính sẽ trong vòng 5 ngày làm việc. Theo dõi trạng thái không có sẵn cho thư địa phương và khách hàng sẽ chịu toàn bộ trách nhiệm về việc mất các mặt hàng bằng cách sử dụng Hồng Kông </span><br> <span style=\"font-size: 10px; line-height: 12px;\">2. Vui lòng kích hoạt thẻ SIM du lịch trước khi hết hạn.</span><br> <span style=\"font-size: 10px; line-height: 12px;\">3. Tất cả các sản phẩm được giao phải tuân theo các điều khoản và điều kiện.</span><br><br> <span style=\"font-size: 10px; line-height: 12px;\">Bạn có câu hỏi không? Vui lòng gửi email đến hello@hyperair.com và chúng tôi sẽ liên lạc lại với bạn.</span>",
            "email-product-simcard-purchased-important-notice-content-sim-only": "<span style=\"font-size: 10px; line-height: 12px;\">1. Theo Thư địa phương của Bưu điện Hồng Kông, việc giao hàng ước tính sẽ trong vòng 5 ngày làm việc. Theo dõi trạng thái không có sẵn cho thư địa phương và khách hàng sẽ chịu toàn bộ trách nhiệm về việc mất các mặt hàng bằng cách sử dụng Hồng Kông </span><br> <span style=\"font-size: 10px; line-height: 12px;\">2. Vui lòng kích hoạt thẻ SIM du lịch trước khi hết hạn.</span><br> <span style=\"font-size: 10px; line-height: 12px;\">3. Tất cả các sản phẩm được giao phải tuân theo các điều khoản và điều kiện.</span><br><br> <span style=\"font-size: 10px; line-height: 12px;\">Bạn có câu hỏi không? Vui lòng gửi email đến hello@hyperair.com và chúng tôi sẽ liên lạc lại với bạn.</span>",
            "email-product-simcard-purchased-order-date": "NGÀY ĐẶT HÀNG",
            "email-product-simcard-purchased-order-details": "Chi tiết đặt hàng",
            "email-product-simcard-purchased-order-no": "Số thứ tự",
            "email-product-simcard-purchased-personal-info": "Thông tin cá nhân",
            "email-product-simcard-purchased-receipient-name": "Tên người nhận",
            "email-product-simcard-purchased-receipient-phone-no": "Số điện thoại người nhận",
            "email-product-simcard-purchased-shipping-fee": "Phí vận chuyển",
            "email-product-simcard-purchased-sub-total": "Tổng phụ",
            "email-product-simcard-purchased-title": "Đơn hàng SIM du lịch của bạn đã được xác nhận.",
            "email-product-simcard-purchased-title-esim-only": "Đơn hàng eSIM du lịch của bạn đã được xác nhận.",
            "email-product-simcard-purchased-title-esim-with-sim": "Đơn hàng SIM du lịch của bạn đã được xác nhận.",
            "email-product-simcard-purchased-title-sim-only": "Đơn hàng SIM du lịch của bạn đã được xác nhận.",
            "email-product-simcard-purchased-total": "toàn bộ",
            "email-product-simcard-tracking-number-updated-greeting": "Kính gửi quý khách hàng,<br><br>Cảm ơn bạn lần nữa vì đã sử dụng HyperAir. Số theo dõi của bạn được cập nhật.",
            "email-product-simcard-tracking-number-updated-title": "Trạng thái theo dõi đơn hàng của bạn được cập nhật",
            "email-product-simcard-tracking-number-updated-tracking-no-sf": "Số theo dõi",
            "email-product-type-confirmed-greeting": "",
            "email-product-type-confirmed-title": "",
            "email-product-type-purchased-greeting": "",
            "email-product-type-purchased-title": "",
            "email-rate": "Tỷ lệ",
            "email-shop-name": "Tên cửa hàng",
            "email-verification-action": "Xác nhận email của bạn",
            "email-verification-content": "Chào mừng đến với HyperAir! Để hoàn tất đăng ký, bạn chỉ cần xác nhận rằng chúng tôi đã nhận được email của bạn ngay.",
            "email-verification-title": "Vui lòng xác nhận email của bạn",
            "email-verified-content": "Email của bạn đã được xác minh. Cảm ơn bạn đã tham gia HyperAir.",
            "email-verified-title": "email đã kích hoạt",
            "engagement-content": "Sử dụng welcome10",
            "engagement-title": "Sử dụng welcome10",
            "exchange-approved-content": "Xác nhận mua: số tiền: tiền tệ theo tỷ lệ: tỷ giá.",
            "exchange-approved-content2": "Xác nhận bán: số tiền: tiền tệ theo tỷ lệ: tỷ giá.",
            "exchange-approved-footer": "",
            "exchange-approved-title": "Cửa hàng trả lời: \"Tiền du lịch của bạn đã sẵn sàng để nhận!\"",
            "exchange-cancelled-content": "Một khách hàng đã hủy đơn đặt hàng để mua: số tiền: tiền tệ theo tỷ lệ: tỷ lệ.",
            "exchange-cancelled-content2": "Một khách hàng đã hủy đơn đặt hàng để bán: số tiền: tiền tệ theo tỷ lệ: tỷ lệ.",
            "exchange-cancelled-title": "Lệnh hủy đã bị hủy",
            "exchange-completed-content": "Hoàn thành để mua: số tiền: tiền tệ theo tỷ lệ: tỷ lệ.",
            "exchange-completed-content2": "Đã hoàn thành để bán: số tiền: tiền tệ theo tỷ lệ: tỷ lệ.",
            "exchange-completed-footer": "",
            "exchange-completed-title": "Trao đổi tiền du lịch của bạn đã hoàn tất!",
            "exchange-confirmed-content": "Bạn đã xác nhận một khách hàng để mua: số tiền: tiền tệ theo tỷ lệ: tỷ lệ.",
            "exchange-confirmed-content2": "Bạn đã xác nhận một khách hàng để bán: số tiền: tiền tệ theo tỷ lệ: tỷ lệ.",
            "exchange-confirmed-footer": "",
            "exchange-confirmed-title": "Nhận đặt hàng trao đổi mới",
            "exchange-pending-content": "Xem lại đơn đặt hàng mới để mua: số tiền: tiền tệ theo tỷ lệ: tỷ lệ.",
            "exchange-pending-content2": "Lệnh chờ bán: số tiền: tiền tệ theo tỷ lệ: tỷ lệ.",
            "exchange-pending-title": "Đang chờ phê duyệt đơn hàng mới",
            "exchange-rejected-content": "Không thể lấy đơn đặt hàng để mua: số tiền: tiền tệ theo tỷ lệ: tỷ lệ. Vui lòng đặt phòng với một cửa hàng khác một lần nữa.",
            "exchange-rejected-content2": "Không thể lấy đơn đặt hàng để bán: số tiền: tiền tệ theo tỷ lệ: tỷ lệ. Vui lòng đặt phòng với một cửa hàng khác một lần nữa.",
            "exchange-rejected-title": "Úi! Xin lỗi, cửa hàng không thể nhận đơn đặt hàng của bạn.",
            "footer-trouble-link": "Nếu bạn gặp sự cố khi nhấp vào nút \": actionText\", hãy sao chép và dán URL bên dưới vào trình duyệt web của bạn: <a href=\"{actionUrl}\">: actionUrl</a>",
            "password-reset-action": "Đặt lại mật khẩu",
            "password-reset-content": "Bạn đang nhận được email này vì chúng tôi đã nhận được yêu cầu đặt lại mật khẩu cho tài khoản của bạn.",
            "password-reset-footer": "Nếu bạn không yêu cầu đặt lại mật khẩu, không cần thực hiện thêm hành động nào.",
            "password-reset-title": "Đặt lại mật khẩu",
            "simcard-purchased-title": "",
            "sms-verification-content": "Mã HyperAir của bạn là: verifyCode"
        },
        "error": {
            "all-shops-are-closed": "Rất tiếc, tất cả c��c cửa hàng đã đóng cửa ngay bây giờ. Vui lòng thử lại sau.",
            "cancel-booking-failed": "Lệnh này có thể được hoàn thành, hết hạn hoặc hủy bỏ. Vui lòng kiểm tra đơn hàng này trong [Đặt chỗ của tôi> Đã hoàn thành] hoặc [Đặt chỗ của tôi> Chưa hoàn thành].",
            "cancel-booking-failed-title": "Không thể hủy đơn hàng này",
            "invalid-api-app-version": "Cập nhật APP ngay bây giờ để có được các chức năng mới và tận hưởng giảm giá 5% cho đơn hàng SIM du lịch với mã khuyến mãi CÂU GIVEME5!",
            "invalid-old-password": "Mật khẩu hiện tại không hợp lệ.",
            "password-incorrect": "Mật khẩu không đúng.",
            "phone-number-is-already-registered": "Số điện thoại này đã được đăng ký với một địa chỉ email khác. Bạn có thể đăng nhập với địa chỉ email chính xác. Vui lòng gửi email đến hello@hyperair.com để được hỗ trợ.",
            "this-email-is-registered": "Địa chỉ email này đã được sử dụng bởi một tài khoản khác.",
            "this-phone-number-is-registered": "Số điện thoại này đã được đăng ký. Vui lòng gửi email đến hello@hyperair.com để được hỗ trợ."
        },
        "marketplace": {
            "homepage-product": "Sản phẩm phổ biến",
            "homepage-recently-viewed": "Đã xem gần đây",
            "product-carousels": {
                "group1": "Trải nghiệm mùa hè",
                "group2": "Xếp hạng hàng đầu"
            }
        }
    },
    "zh-CN": {
        "currency": {
            "aed": "阿联酋迪拉姆",
            "afn": "阿富汗尼",
            "all": "阿尔巴尼亚列克",
            "amd": "亚美尼亚德拉姆",
            "ang": "荷属安的列斯盾",
            "aoa": "安哥拉宽扎",
            "ars": "阿根廷比索",
            "aud": "澳元",
            "awg": "阿鲁巴弗罗林",
            "azn": "亚塞拜然马纳特",
            "bam": "波士尼亚马克",
            "bbd": "巴贝多元",
            "bdt": "孟加拉塔卡",
            "bgn": "保加利亚列弗",
            "bhd": "巴林第纳尔",
            "bif": "蒲隆地法郎",
            "bnd": "汶莱元",
            "bob": "玻利维亚比索",
            "brl": "巴西雷亚尔",
            "bsd": "巴哈马元",
            "btc": "比特币",
            "btn": "不丹努尔特鲁姆",
            "bwp": "波札那普拉",
            "byn": "白俄罗斯卢布",
            "bzd": "贝里斯元",
            "cad": "加拿大元",
            "cdf": "刚果法郎",
            "chf": "瑞士法郎",
            "clp": "智利比索",
            "cop": "哥伦比亚比索",
            "crc": "哥斯达黎加科朗",
            "cup": "古巴比索",
            "cve": "维德角群岛埃斯库多",
            "czk": "捷克克朗",
            "djf": "吉布提法郎",
            "dkk": "丹麦克朗",
            "dop": "多米尼加比索",
            "dzd": "阿尔及利亚第纳尔",
            "egp": "埃及镑",
            "ern": "厄立特里亚纳克法",
            "etb": "埃塞俄比亚比尔",
            "eur": "欧元",
            "fjd": "斐济元",
            "fkp": "福克兰群岛镑",
            "gbp": "英镑",
            "gel": "格鲁吉亚拉里",
            "ghs": "加纳塞地",
            "gip": "直布罗陀镑",
            "gmd": "冈比亚达拉西",
            "gnf": "几内亚法郎",
            "gtq": "危地马拉格查尔",
            "gyd": "圭亚那元",
            "hkd": "港元",
            "hnl": "洪都拉斯伦皮拉",
            "hrk": "克罗埃西亚库纳",
            "htg": "海地古德",
            "huf": "匈牙利福林",
            "idr": "印尼盾",
            "ils": "以色列谢克尔",
            "inr": "印度卢比",
            "iqd": "伊拉克第纳尔",
            "irr": "伊朗里亚尔",
            "isk": "冰岛克朗",
            "jmd": "牙买加元",
            "jod": "约旦第纳尔",
            "jpy": "日元",
            "kes": "肯尼亚先令",
            "kgs": "吉尔吉斯索姆",
            "khr": "柬埔寨瑞尔",
            "kmf": "葛摩法郎",
            "kpw": "朝鲜圆",
            "krw": "韩圜",
            "kwd": "科威特第纳尔",
            "kyd": "开曼元",
            "kzt": "哈萨克坚戈",
            "lak": "老挝基普",
            "lbp": "黎巴嫩镑",
            "lkr": "斯里兰卡卢比",
            "lrd": "利比里亚元",
            "lsl": "莱索托洛蒂",
            "lvl": "拉脱维亚拉特",
            "lyd": "利比亚第纳尔",
            "mad": "摩洛哥迪拉姆",
            "mdl": "摩尔多瓦列伊",
            "mga": "马达加斯加阿里亚里",
            "mkd": "马其顿第纳尔",
            "mmk": "缅甸元",
            "mnt": "蒙古图格里克",
            "mop": "澳门元",
            "mro": "毛里塔尼亚乌吉亚",
            "mur": "毛里求斯卢比",
            "mvr": "马尔代夫卢比",
            "mwk": "马拉维克瓦查",
            "mxn": "墨西哥比索",
            "myr": "马来西亚币",
            "mzn": "莫三比克梅蒂卡尔",
            "nad": "纳米比亚元",
            "ngn": "尼日利亚奈拉",
            "nio": "尼加拉瓜金科多巴",
            "nok": "挪威克朗",
            "npr": "尼泊尔卢比",
            "nzd": "新西兰元",
            "omr": "阿曼里亚尔",
            "pab": "巴拿马巴波亚",
            "pen": "秘鲁新索尔",
            "pgk": "巴布亚基纳",
            "php": "菲律宾比索",
            "pkr": "巴基斯坦卢比",
            "pln": "波兰兹罗提",
            "pyg": "巴拉圭瓜拉尼",
            "qar": "卡塔尔里亚尔",
            "rmb": "人民币",
            "ron": "罗马尼亚列伊",
            "rsd": "塞尔维亚第纳尔",
            "rub": "俄罗斯卢布",
            "rwf": "卢旺达法郎",
            "sar": "沙特里亚尔",
            "sbd": "所罗门群岛元",
            "scr": "塞舌尔卢比",
            "sdg": "苏丹第纳尔",
            "sek": "瑞典克朗",
            "sgd": "新加坡元",
            "shp": "圣赫勒拿群岛镑",
            "sll": "塞拉利昂 利昂",
            "sos": "索马利亚先令",
            "srd": "苏利南元",
            "std": "圣多美和普林西比多布拉",
            "syp": "叙利亚镑",
            "szl": "斯威士兰 里兰吉尼",
            "thb": "泰国铢",
            "tjs": "塔吉克共和国 索莫尼",
            "tmt": "土库曼斯坦马纳特",
            "tnd": "突尼斯第纳尔",
            "top": "汤加潘加",
            "try": "土耳其里拉",
            "ttd": "特立尼达和多巴哥元",
            "twd": "新台币",
            "tzs": "坦桑尼亚先令",
            "uah": "乌克兰格里夫纳",
            "ugx": "乌干达先令",
            "usd": "美元",
            "uyu": "乌拉圭比索",
            "uzs": "乌兹别克斯坦索姆",
            "vef": "委内瑞拉玻利瓦尔",
            "vnd": "越南盾",
            "vuv": "瓦努阿图瓦图",
            "wst": "萨摩亚塔拉",
            "xaf": "中非共同体法郎",
            "xcd": "东加勒比元",
            "xdr": "国际货币基金组织特别提款权",
            "xof": "西非国家中央银行非洲法郎",
            "xpf": "太平洋法郎",
            "yer": "也门里亚尔",
            "zar": "南非兰特",
            "zmw": "尚比亚克瓦查"
        },
        "shop-currency-rate": {
            "rate-last-updated-x-days-ago": "汇率{time}日前更新",
            "rate-last-updated-x-hours-ago": "汇率{time}小时前更新"
        },
        "hyperair": {
            "copyright-footer": "© 2018 HyperAir Incorporation Limited. 版权所有",
            "today": "今日"
        },
        "product-simcard": {
            "shipping-methods": {
                "hkpost": "平邮（免费）",
                "international": "跨国运送",
                "sf": "顺丰速递 （只限香港，货到付运费。订单满HK$399，即可免运费）"
            }
        },
        "country": {
            "afghanistan": "阿富汗",
            "aland-islands": "奥兰群岛",
            "albania": "阿尔巴尼亚",
            "algeria": "阿尔及利亚",
            "andorra": "安道尔",
            "angola": "安哥拉",
            "anguilla": "安圭拉",
            "antigua-&-barbuda": "安提瓜和巴布达",
            "antigua-barbuda": "安地卡及巴布达",
            "argentina": "阿根廷",
            "armenia": "阿美尼亚",
            "aruba": "阿鲁巴",
            "australia": "澳洲",
            "austria": "奥地利",
            "azerbaijan": "阿塞拜疆",
            "azores": "亚速尔群岛",
            "bahamas": "巴哈马",
            "bahrain": "巴林",
            "bangladesh": "孟加拉国",
            "barbados": "巴巴多斯",
            "belarus": "白俄罗斯",
            "belgium": "比利时",
            "belize": "伯利兹",
            "benin": "贝宁",
            "bermuda": "百慕达",
            "bhutan": "不丹",
            "bolivia": "玻利维亚",
            "bonaire": "博奈尔",
            "bosnia-herzegovina": "波斯尼亚和黑塞哥维那",
            "botswana": "博茨瓦纳",
            "brazil": "巴西",
            "british-virgin-islands": "英属维尔京群岛",
            "brunei": "文莱",
            "bulgaria": "保加利亚",
            "burkina-faso": "布基纳法索",
            "burundi": "布隆迪",
            "cambodia": "柬埔寨",
            "cameroon": "喀麦隆",
            "canada": "加拿大",
            "canary-islands": "加那利群岛",
            "cape-verde-islands": "佛得角群岛",
            "cayman-islands": "开曼群岛",
            "central-african-republic": "中非共和国",
            "chad": "乍得",
            "chile": "智利",
            "china": "中国",
            "colombia": "哥伦比亚",
            "comoros": "科摩罗",
            "congo": "刚果",
            "cook-islands": "库克群岛",
            "costa-rica": "哥斯达黎加",
            "cote-d-ivoire": "科特迪瓦科特迪瓦",
            "croatia": "克罗地亚",
            "cruise-ship": "游轮",
            "cuba": "古巴",
            "curacao": "库拉索",
            "cyprus": "塞浦路斯",
            "cyprus---north": "塞浦路斯",
            "cyprus---south": "塞浦路斯",
            "czech-republic": "捷克共和国",
            "denmark": "丹麦",
            "djibouti": "吉布提",
            "dominica": "多米尼加",
            "dominican-republic": "多明尼加共和国",
            "dubai": "杜拜",
            "easter-island": "复活节岛",
            "ecuador": "厄瓜多尔",
            "egypt": "埃及",
            "el-salvador": "萨尔瓦多",
            "equatorial-guinea": "赤道几内亚",
            "eritrea": "厄立特里亚",
            "estonia": "爱沙尼亚",
            "ethiopia": "埃塞俄比亚",
            "europe": "欧洲",
            "falkland-islands": "福克兰群岛",
            "faroe-islands": "法罗群岛",
            "fiji": "斐济",
            "finland": "芬兰",
            "france": "法国",
            "french-guiana": "法属圭亚那",
            "french-polynesia": "法属波利尼西亚",
            "french-west-indies": "法属西印度群岛",
            "gabon": "加蓬",
            "gambia": "冈比亚",
            "georgia": "格鲁吉亚",
            "germany": "德国",
            "ghana": "加纳",
            "gibraltar": "直布罗陀",
            "greece": "希腊",
            "greenland": "格陵兰",
            "grenada": "格林纳达",
            "guadeloupe": "瓜德罗普岛",
            "guam": "关岛",
            "guatemala": "危地马拉",
            "guernsey": "根西岛",
            "guinea": "几内亚",
            "guinea---bissau": "几内亚比绍",
            "guinea-bissau": "几内亚比绍",
            "guyana": "圭亚那",
            "haiti": "海地",
            "honduras": "洪都拉斯",
            "hong-kong": "香港",
            "hungary": "匈牙利",
            "iceland": "冰岛",
            "india": "印度",
            "indonesia": "印尼",
            "iran": "伊朗",
            "iraq": "伊拉克",
            "ireland": "爱尔兰",
            "isle-of-man": "马恩岛",
            "israel": "以色列",
            "italy": "意大利",
            "jamaica": "牙买加",
            "japan": "日本",
            "jersey": "泽西",
            "jordan": "约旦",
            "kazakhstan": "哈萨克斯坦",
            "kenya": "肯尼亚",
            "kiribati": "基里巴斯",
            "kosovo": "科索沃",
            "kuwait": "科威特",
            "kyrgyz-republic": "吉尔吉斯共和国",
            "kyrgyzstan": "吉尔吉斯斯坦",
            "laos": "老挝",
            "latvia": "拉脱维亚",
            "lebanon": "黎巴嫩",
            "lesotho": "莱索托",
            "liberia": "利比里亚",
            "libya": "利比亚",
            "liechtenstein": "列支敦士登",
            "lithuania": "立陶宛",
            "luxembourg": "卢森堡",
            "macau": "澳门",
            "macedonia": "马其顿",
            "madagascar": "马达加斯加",
            "madeira": "马德拉",
            "malawi": "马拉维",
            "malaysia": "马来西亚",
            "maldives": "马尔代夫",
            "mali": "马里",
            "malta": "马耳他",
            "marshall-islands": "马绍尔群岛",
            "martinique": "马提尼克",
            "mauritania": "毛里塔尼亚",
            "mauritius": "毛里求斯",
            "mayotte": "马约特",
            "mexico": "墨西哥",
            "micronesia": "密克罗尼西亚",
            "moldova": "摩尔多瓦",
            "monaco": "摩纳哥",
            "mongolia": "蒙古",
            "montenegro": "黑山",
            "montserrat": "蒙特塞拉特",
            "morocco": "摩洛哥",
            "mozambique": "莫桑比克",
            "myanmar": "缅甸",
            "namibia": "纳米比亚",
            "nauru": "瑙鲁",
            "nepal": "尼泊尔",
            "netherlands": "荷兰",
            "netherlands-antilles": "荷属安的列斯",
            "new-caledonia": "新喀里多尼亚",
            "new-zealand": "纽西兰",
            "nicaragua": "尼加拉瓜",
            "niger": "尼日尔",
            "nigeria": "尼日利亚",
            "niue": "纽埃",
            "norfolk-islands": "诺福克群岛",
            "north-korea": "北朝鲜",
            "northern-marianas": "北马里亚纳",
            "norway": "挪威",
            "oman": "阿曼",
            "pakistan": "巴基斯坦",
            "palau": "帕劳",
            "palestine": "巴勒斯坦",
            "panama": "巴拿马",
            "papua-new-guinea": "巴布亚新几内亚",
            "paraguay": "巴拉圭",
            "peru": "秘鲁",
            "philippines": "菲律宾",
            "poland": "波兰",
            "portugal": "葡萄牙",
            "puerto-rico": "波多黎各",
            "qatar": "卡塔尔",
            "reunion": "留尼旺",
            "romania": "罗马尼亚",
            "russia": "俄罗斯",
            "rwanda": "卢旺达",
            "saint-barthelemy": "圣巴托洛缪岛",
            "saint-martin": "圣马丁",
            "saint-pierre-&-miquelon": "圣皮埃尔和密克隆",
            "samoa": "萨摩亚",
            "san-marino": "圣马力诺",
            "sao-tome-&-principe": "圣多美和普林西比",
            "sao-tome-principe": "圣多美普林西比",
            "satellite": "卫星",
            "saudi-arabia": "沙特阿拉伯",
            "senegal": "塞内加尔",
            "serbia": "塞尔维亚",
            "seychelles": "塞舌尔",
            "sierra-leone": "塞拉利昂",
            "singapore": "新加坡",
            "slovak-republic": "斯洛伐克共和国",
            "slovakia": "斯洛伐克",
            "slovenia": "斯洛文尼亚",
            "solomon-islands": "所罗门群岛",
            "somalia": "索马里",
            "south-africa": "南非",
            "south-korea": "韩国",
            "spain": "西班牙",
            "sri-lanka": "斯里兰卡",
            "st-helena": "圣赫伦那",
            "st-kitts": "圣克里斯多福岛",
            "st-kitts-&-nevis": "圣基茨和尼维斯",
            "st-lucia": "圣卢西亚",
            "st-vincent": "圣文森特",
            "st.-helena": "圣海伦娜",
            "st.-kitts": "圣基茨",
            "st.-lucia": "圣卢西亚",
            "sudan": "苏丹",
            "suriname": "苏里南",
            "swaziland": "斯威士兰",
            "sweden": "瑞典",
            "switzerland": "瑞士",
            "syria": "叙利亚",
            "taiwan": "台湾",
            "tajikistan": "塔吉克斯坦",
            "tanzania": "坦桑尼亚",
            "thailand": "泰国",
            "timor-l'este": "东帝汶埃斯特",
            "togo": "多哥",
            "tonga": "汤加",
            "trinidad-&-tobago": "特立尼达和多巴哥",
            "trinidad-tobago": "千里达及托巴哥",
            "tunisia": "突尼斯",
            "turkey": "土耳其",
            "turkmenistan": "土库曼斯坦",
            "turks-&-caicos": "特克斯和凯科斯群岛",
            "turks-&-caicos-islands": "特克斯和凯科斯群岛",
            "turks-caicos-islands": "土克凯可群岛",
            "uganda": "乌干达",
            "ukraine": "乌克兰",
            "united-arab-emirates": "阿拉伯联合酋长国",
            "united-kingdom": "英国",
            "united-states": "美国",
            "united-states-minor-outlying-islands": "美国本土外小岛屿",
            "uruguay": "乌拉圭",
            "uzbekistan": "乌兹别克斯坦",
            "vanuatu": "瓦努阿图",
            "vatican-city": "梵蒂冈城",
            "venezuela": "委内瑞拉",
            "vietnam": "越南",
            "virgin-islands": "维尔京群岛",
            "virgin-islands-(us)": "维尔京群岛（美国）",
            "wallis-&-futuna": "瓦利斯和富图纳",
            "wallis-futuna": "瓦利斯和富图纳",
            "yemen": "也门",
            "zambia": "赞比亚",
            "zimbabwe": "津巴布韦"
        },
        "inspiration": {
            "published-date": "Y年n月",
            "published-duration": "{duration}日前",
            "published-duration-singular": "昨天",
            "published-duration-today": "今天"
        },
        "promotion-center": {
            "expires-at": "有效期至",
            "redeem": {
                "error": {
                    "already-redeemed": "已兑换优惠劵",
                    "new-customer-only": "此优惠只适用于新客户",
                    "not-found": "优惠码无效"
                }
            }
        },
        "auth": {
            "failed": "",
            "throttle": ""
        },
        "web": {
            "activity": {
                "countdown-title": "",
                "more-button": "更多玩乐体验",
                "section-subtitle": "帮您比较各个网站，搵最正最抵慨玩乐体验",
                "section-title": "玩乐体验价格比较"
            },
            "checkout": {
                "use-promo-code": "使用优惠券"
            },
            "checkout-failed": {
                "checkout-failed": "Payment Failed, please try again later"
            },
            "checkout-success": {
                "checkout-success": "付款成功",
                "continue-shopping-button": "继续浏览",
                "done-button": "搞掂👌🏻",
                "download-now": "立即下载",
                "order-number": "订单编号",
                "register-email": "你慨电邮",
                "register-password": "设定密码",
                "sim-product": "你已成功购买<span class=\"bold\"> {sim} </span>，电邮确认订单将发送至 {email}。",
                "slogan": "立即打开 HyperAir app，尽享玩乐礼遇！仲可以即刻喺App到追踪订单。",
                "slogan-password": "还有一步，即享$10迎新SIM卡优惠！仲可以即刻喺App到追踪订单。",
                "trace-order": "",
                "trace-order-password": "",
                "welcome-offer": "仲差一步，注册即享$10迎新SIM卡奖赏！仲可以即喺App度追踪慨订单。"
            },
            "country": {
                "all": "所有",
                "contact-us-description": "如有任何疑问，欢迎发送电邮到<a href=\"mailto:corporate@hyperair.com\\>corporate@hyperair.com</a>查询",
                "data": "数据流量：",
                "day": "日数：",
                "day-day": "日",
                "esim": "eSIM",
                "esim-section-title": "为你搜罗{country}慨旅游 eSIM",
                "num-of-review": "{num}-of-review个旅客评分",
                "per-day": "每日",
                "phone-call": "当地通话",
                "plug-n-go": "即插即用",
                "plug-n-go-esim": "即买即用",
                "plug-n-go-sim": "即插即用",
                "section-title": "为你搜罗{country}慨旅游 SIM",
                "section-title copy": "为你搜罗{country}最正慨旅游 SIM",
                "sim": "SIM",
                "supplier": "网络商："
            },
            "download-app-banner": {
                "download-now": "立即下载 App",
                "hyperair": "HyperAir",
                "subtitle": "下载 HyperAir 应用程式并首次登记，即享 HK$10 优惠迎新礼遇！",
                "title": "随时随地 醒目旅游"
            },
            "email-subscription": {
                "cancel-button": "再谂一谂",
                "completed-subscribe": "多谢你慨订阅",
                "confirm-button": "我要最抵优惠",
                "duplicate-email": "你的电邮已经订阅了",
                "invalid-email": "无效或错误的电邮地址",
                "title-1": "想Staycation价格跌至新低时通知你？",
                "title-2": "仲搜罗全城最抵既Staycation 及美食套餐优惠"
            },
            "fanfare": {
                "cover-title": "SIM卡 Fanfares",
                "datetime-format": "n月d日",
                "end-next-fanfare": "下次开售时间:",
                "end-title": "想知SIM卡优惠慨开售时间及更多超笋玩乐优惠? 立即下载同follow我哋慨APP及社交平台啦！",
                "end-title2": "想知更多超笋玩乐优惠? 立即下载同follow我哋慨APP及社交平台啦！",
                "more-details-button": "优惠详情",
                "out-of-stock": "卖哂啦",
                "popular-countries-subtitle": "免费平邮，极速送到",
                "popular-countries-title": "热门 SIM 卡目的地",
                "section-title": "多款 SIM 卡以超优惠价发售",
                "title": "限时优惠 限量特价",
                "x-inventory-left": "最后{inventory}张"
            },
            "fanfare-breadcrumb": "SIM卡 Fanfares",
            "filter-button": {
                "filter": "筛选"
            },
            "filter-container": {
                "apply": "筛选",
                "category": "分类",
                "category-aquarium": "水族馆",
                "category-class": "课程",
                "category-day-tour": "半日+一日游",
                "category-discount": "优惠",
                "category-diving": "潜水",
                "category-food": "美食",
                "category-massage-beauty": "按摩及美容",
                "category-museum": "博物馆",
                "category-musical": "音乐剧",
                "category-outlet": "Outlet",
                "category-photography": "摄影",
                "category-playground": "游乐场",
                "category-railway": "铁路",
                "category-show": "表演",
                "category-ski": "滑雪",
                "category-spa": "温泉",
                "category-theme-park": "乐园",
                "category-ticket": "门票",
                "category-transport": "接送+包车",
                "category-transport-ticket": "车票",
                "category-vr": "VR",
                "category-water-park": "水上乐园",
                "category-yoga": "瑜伽",
                "category-zoo": "动物园",
                "clear-all": "重设",
                "facilities": "设施及套餐特点",
                "filter": "筛选",
                "food": "饮食",
                "header": "筛选",
                "popular-search": "人气搜寻🔥",
                "price": "价格",
                "provider": "旅游平台",
                "subcategory-buffet": "自助餐",
                "subcategory-car": "包车",
                "subcategory-facial": "美容",
                "subcategory-food": "美食",
                "subcategory-half-day-tour": "半日游",
                "subcategory-massage": "按摩",
                "subcategory-meal-voucher": "餐券",
                "subcategory-one-day-tour": "一日游",
                "subcategory-restaurant": "餐厅",
                "subcategory-transport": "接送",
                "tag": "主题"
            },
            "footer": {
                "about-hyperair-description": "HyperAir 系一间旅游科技初创，旨在为旅行爱好者提供最醒目慨方式去准备和享受旅行。",
                "download-now": "立即下载",
                "email-subscription-button": "立即订阅",
                "email-subscription-placeholder": "输入你的电邮",
                "email-subscription-social-title": "或立即追踪我地既社交平台",
                "email-subscription-title": "想知更多 Staycation 优惠慨<br />开售时间及更多超笋玩乐优惠?",
                "travel-license": "旅行代理商牌照号码："
            },
            "fx-booking": {
                "back-button": "更改订单",
                "confirm-booking": "核对资料",
                "confirm-button": "确认订单",
                "contact-shop": "如果您无法准时到达，请致电兑换店或取消订单。",
                "get-money-before": "请于以下时间前提取。"
            },
            "home": {
                "cover-button": "立即体验",
                "cover-subtitle": "从 HyperAir 开始",
                "cover-title": "一次过，比较全球多个玩乐旅游预订网站",
                "grid": {
                    "1": {
                        "subtitle": "最HIT旅游情报",
                        "title": "爱猫之城伊斯坦堡 历史大教堂有守护猫"
                    },
                    "2": {
                        "subtitle": "最HIT旅游情报",
                        "title": "东京奥运，最后倒数"
                    },
                    "3": {
                        "subtitle": "最抵之选",
                        "title": "网上SIM卡至低价保证"
                    },
                    "4": {
                        "subtitle": "限时优惠 限量特价",
                        "title": "SIM 卡 Fanfares"
                    },
                    "5": {
                        "subtitle": "必追景点",
                        "title": "愿原力与你同在！迪士尼星战园区现已开幕"
                    }
                },
                "home-example": {
                    "column-subtitle-1": "以2人日本7日游为例：",
                    "column-subtitle-2": "价格比较",
                    "column-title-1": "一次旅行，同你悭到尽",
                    "column-title-2": "比较多间国际旅游平台",
                    "hotel": "酒店优惠",
                    "hotel-package-1": "大阪日航酒店7日6夜",
                    "insurance": "旅游保险",
                    "insurance-package-1": "7天旅游保险 x2",
                    "money": "外币兑换",
                    "money-package-1": "唱JPD ¥ 410,000",
                    "save": "悭",
                    "sim": "上网SIM卡",
                    "sim-package-1": "日本7天DoCoMo SIM x2",
                    "slogan": "逐样格，逐样悭，先至系识玩！",
                    "total-saving": "一共悭 $ 1,443",
                    "travel-experience": "玩乐体验",
                    "travel-experience-package-1": "JR Pass 全日本铁路通票 x2",
                    "travel-experience-package-2": "日本环球影城™ 1日电子门票 x2"
                },
                "media-header-title": "媒体报导",
                "more": "更多旅游 SIM",
                "partners-title": "合作伙伴",
                "photo-banner-button": "了解更多",
                "photo-banner-title": "唱钱神器™助您轻松搜寻预订最抵汇率，唱钱快又醒!",
                "services-header-description": "",
                "services-header-title": "一站式旅游服务",
                "services-icon-subtitle-1": "助您轻松搜寻预订最抵汇率，唱钱快又醒!",
                "services-icon-subtitle-2": "为您提供多款劲抵价SIM卡，免运费送上门！",
                "services-icon-subtitle-3": "让您探索世界，从此自主旅游！",
                "services-icon-title-1": "唱钱神器",
                "services-icon-title-2": "旅游SIM卡",
                "services-icon-title-3": "旅游体验",
                "statistic": {
                    "num-of-city": "帮用户悭咗",
                    "num-of-comparison": "玩乐体验",
                    "num-of-experience": "国家城市",
                    "num-of-saving": "格价次数"
                },
                "testimonial-1-content": "呢个app很好用，方便比较汇率，唔驶周围去揾资料。很欣赏程式员渠地既用心制作，渠地都积极用心为我解决使用时的困难。推荐使用！",
                "testimonial-1-subtitle": "Android 用家",
                "testimonial-1-user": "Christine Lam",
                "testimonial-2-content": "好方便，订SIM卡好快就送到，唔洗特登出街买SIM卡，价钱都好平吓。网络收得几好，上次去日本喺市区同近郊玩都好流畅！下次会再买！",
                "testimonial-2-subtitle": "iOS 用家",
                "testimonial-2-user": "Angel",
                "testimonial-header-description": "",
                "testimonial-header-title": "用家分享",
                "travel-activities": {
                    "home-slogan": "帮您比较各个网站，搵最正最抵慨玩乐体验"
                },
                "travel-country-header-description": "清晰分类，容易挑选",
                "travel-country-header-title": "旅游 SIM 涵盖 200+ 国家",
                "travel-info-header-description": "为你带来最 Hit 旅游灵感",
                "travel-info-header-title": "旅游情报",
                "travel-marketplace-header-description": "",
                "travel-marketplace-header-title": "",
                "travel-sim-header-description": "劲抵价SIM卡 免费送上门",
                "travel-sim-header-title": "热门旅游 SIM"
            },
            "hotel": {
                "cover-subtitle": "HyperAir 客户专享 5% Trip.com 独家酒店折扣",
                "cover-title": "酒店优惠",
                "discount-detail": "使用 “HYPERAIR5” 优惠码可享5%折扣",
                "discount-title": "HYPERAIR5",
                "highlight-subtitle1": "探索遍布全球慨酒店，为您提供与众不同慨住宿体验。",
                "highlight-subtitle2": "独家超值订房优惠，为您省下更多旅费。",
                "highlight-subtitle3": "即时网上查看酒店价格详情 ，全天候一按预订。",
                "highlight-title1": "覆盖全球",
                "highlight-title2": "优惠价格",
                "highlight-title3": "一覧无遗"
            },
            "hypermiles": {
                "activity": "项目",
                "balance": "结余",
                "benefit": "你的会员礼遇包括:",
                "cumulative-purchase": "累积消费：HK$ {amount}",
                "diamond-black": "钻石黑",
                "expire": "已过期的HyperMiles ({date})",
                "expire-reminder-1": "HyperMiles 于购物月份起计一年内有效",
                "expire-reminder-2": "记得到期前用嚟买嘢啦！",
                "hypermiles-total": "HyperMiles",
                "member": "会籍",
                "member-tier": "你已经成为 HyperAir {member_tier}会员。",
                "membership-details": "详细级别",
                "next-purchase": "下次消费可即减 HK${amount}",
                "order-num": "订单编号: {order_num}",
                "permanent-membership": "永久免费会籍",
                "popup-title": "HyperMiles 奖赏计划",
                "precious-platinum": "尊铂白",
                "product_purchase": "购物赚取的HyperMiles ({date})",
                "record": "HyperMiles 纪录",
                "royal-blue": "贵族蓝",
                "simcard_purchase": "买SIM卡赚取的HyperMiles ({date})",
                "tier": "",
                "title": "HyperMiles。自主旅游，丰富回赠！",
                "u-have": "你拥有",
                "usage": "使用HyperMiles ({date})",
                "what-is-hypermiles": "什么是 HyperMiles",
                "what-is-hypermiles-slogan1": "消费越多，奖赏越多",
                "what-is-hypermiles-slogan2": "每100 HyperMiles 即可购物时抵销HK$1 ，无最低消费限制",
                "what-is-hypermiles-slogan3": "累积消费越多，更易赚取 HyperMiles"
            },
            "hypermiles-disclaimer": "优惠受条款及细则约束",
            "hypermiles-discount-diamond-black": "每消费满 HK$1 赚取 1 HyperMiles",
            "hypermiles-discount-precious-platinum": "每消费满 HK$1.5 赚取 1 HyperMiles",
            "hypermiles-discount-royal-blue": "每消费满 HK$2 赚取 1 HyperMiles",
            "hypermiles-special-diamond-black": "优先获得独家优惠",
            "hypermiles-spend-diamond-black": "累积消费满HK$3,000",
            "hypermiles-spend-precious-platinum": "累积消费满HK$1,500",
            "hypermiles-spend-royal-blue": "基本会员",
            "login": {
                "email": "电邮",
                "existing-user": "现有用户",
                "forgot-password": "忘记密码",
                "forgot-password-please-fill-in-email": "Enter your email and we'll send you a link to get back into your account.",
                "login": "登入",
                "login-with-facebook": "Facebook 继续",
                "login-with-google": "Google 继续",
                "new-user": "新用户",
                "or": "或",
                "password": "密码",
                "phone-input-placeholder": "输入你的电话",
                "phone-input-title": "我们需要你的电话号码，进行SMS认证。",
                "phone-verify": "电话认证",
                "resend-verification-code": "30秒后重新发送",
                "reset-password": "重设密码",
                "title": "登入",
                "verification-code-input-title": "请输入你的6位数字认证码"
            },
            "logo-loader": {
                "slogan": "帮紧你，帮紧你"
            },
            "my-order": {
                "amount": "金额",
                "esim-qrcode": "eSIM码",
                "fx-status-cancelled": "已取消",
                "fx-status-confirmed": "已确认",
                "order-date": "落单日期",
                "order-details": "订单详情",
                "order-num": "订单编号",
                "status-confirmed": "已寄出",
                "status-pending-confirmation": "准备寄出",
                "status-ready-to-ship": "准备寄出",
                "status-shipped": "已寄出"
            },
            "my-order-details": {
                "delivery-info": "物流资料",
                "discount": "折扣",
                "recipient-address": "地址",
                "recipient-email": "电邮",
                "recipient-name": "收件人名称",
                "recipient-tel": "收件人联络电话",
                "shipping-method": "物流方式",
                "status": "状态",
                "total": "总额",
                "valid-date": "完成日期"
            },
            "nav": {
                "about-us": "关于我们",
                "car": "租车",
                "company": "公司",
                "company-address": "地址：香港数码港3期3楼企业发展中心",
                "contact-us": "联络我们",
                "contact-us-description": "如有任何疑问，欢迎发送电邮到<a href=\"mailto:hello@hyperair.com\">hello@hyperair.com</a>查询",
                "disclaimer": "免責聲明",
                "download-app": "下载 App",
                "flight": "机票",
                "foodie": "美食优惠",
                "home": "首页",
                "hotel": "酒店",
                "jobs": "请人",
                "logout": "登出",
                "media-coverage": "媒体报导",
                "monthly-rental-hotel": "短租及月租酒店",
                "privacy-policy": "私隐政策",
                "promo-banner-text": "HyperAir 客户专享 5% Trip.com 独家酒店折扣",
                "quarantine-hotel": "回港长住酒店",
                "refund-policy": "退改政策",
                "spa-and-beauty": "Spa and Beauty",
                "staycation": "Staycation",
                "tag-line": "玩乐旅游 ‧ 搜寻格价",
                "terms-of-service": "服务条款",
                "travel-activity": "旅游体验",
                "travel-affiliate-codes": "折扣优惠券",
                "travel-affiliate-codes-md": "折扣优惠券",
                "travel-blog": "Blog",
                "travel-experience-d": "玩乐门票",
                "travel-experience-md": "玩乐门票",
                "travel-insurance": "旅游保险",
                "travel-insurance-md": "旅游保险",
                "travel-marketplace": "玩乐潮物",
                "travel-marketplace-md": "玩乐潮物",
                "travel-money": "唱钱神器",
                "travel-money-md": "唱钱神器",
                "travel-sim": "旅游 SIM",
                "travel-sim-md": "旅游 SIM"
            },
            "photo-banner": {
                "banner-button": ""
            },
            "product-card": {
                "num-of-review": "{num}-of-review则评价"
            },
            "redirection-gate": {
                "columns-1-description": "帮您比较各个网站，搵最正最抵慨玩乐体验",
                "columns-1-title": "玩乐格价",
                "columns-2-description": "多款劲抵价SIM卡，免运费送上门！",
                "columns-2-title": "旅游SIM卡",
                "columns-3-description": "助你轻松搜寻预订最抵汇率",
                "columns-3-title": "唱钱神器",
                "promo-code": "优惠码",
                "remember-to-fill-promo-code": "记得结帐慨时候输入以上优惠码",
                "title": "传送门正将你送到 {domain}",
                "trouble-link": "如果您的浏览器未能于10秒内重新导向，请您点击此<a href=\"{link}\">连结</a>"
            },
            "register": {
                "guest-checkout": "继续以访客结帐",
                "title": "注册"
            },
            "seo": {
                "best-price-guarantee-title": "最低价保证",
                "country-description": "{country}旅游SIM，多款劲抵价SIM卡，免运费送上门，准备旅程快又醒！",
                "country-keywords": "SIM卡,上网卡,电话卡,数据卡,DataSIM,旅游DataSIM,数据咭,4G上网卡,上网卡,4G上网卡,日本4G上网卡,日本上网卡,东京4G上网卡,东京上网卡,大阪4G上网卡,大阪上网卡,泰国4G上网卡,泰国上网卡,曼谷4G上网卡,布吉上网卡,芭提雅4G上网卡,台湾4G上网卡,台湾上网卡,台北4G上网卡,高雄上网卡,台中4G上网卡,台中上网卡,韩国4G上网卡,韩国上网卡,首尔4G上网卡,首尔上网卡,中国4G上网卡,中国上网卡,深圳4G上网卡,深圳上网卡,澳门4G上网卡,澳门上网卡, Docomo, Softbank",
                "country-title": "{country}旅游SIM卡 - 劲抵价，免运费送上门",
                "home-description": "HyperAir系一间旅游科技初创公司，打造一个能够了解用家喜好慨旅游平台，提供最合适同埋物超所值慨旅游方案，令旅行爱好者可以一站式咁浏览预订，随时随地醒目旅游！",
                "home-keywords": "sim卡,上网卡,电话卡,数据卡,DataSIM,旅游DataSIM,数据咭,4G上网卡,上网卡,4G上网卡,SIM卡,Travel SIM,旅游SIM卡,唱钱神器,唱X神器,唱钱X器,唱钱,唱钱app,兑换,找换,兑换店,找换店,银行,金融,外汇,外汇,汇率,汇率,汇款,外币,货币,旅行,旅游,行程,酒店,机票,比较,格价,特价,预订,交易,旅游保险,日本,泰国,韩国,台湾,日圆,日元,台币,泰铢,HyperAir,HyperAir FX,HyperAir Travel,Travel,Travel Money,Foreign Currency,Foreign Exchange,百年,坚成,发达鸟,飞鸟,richbird,crazy bird,berlin exchange",
                "home-title": "HyperAir - 玩乐旅游必备搜寻比较平台 | 玩乐体验、酒店优惠、上网SIM卡、唱钱神器、旅游保险",
                "hotel-description": "透过HyperAir网站，可享预订酒店额外折扣优惠",
                "hotel-keywords": "酒店预订, 酒店订房, 预订, 订房, 亚洲地区, 欧洲地区, 美洲地区, 泰国, 曼谷, 美国, 中国, 上海, 日本, 东京, 马来西亚, 新加坡, 韩国, 加拿大, 英国, 荷兰, 法国, 纽西兰, 澳洲, 优惠价格, 酒店评论,网路预订, 地图, 渡假村, 度假村",
                "hotel-title": "酒店优惠",
                "money-exchange-description": "查看{shop_name}的最新汇率，并且网上预订，可以即时锁定汇率及预留货币！",
                "money-exchange-keywords": "{shop_name}, 唱钱神器, 唱X神器, 唱钱X器, 唱钱, 兑换, 找换, 兑换店, 找换店, 银行, 金融, 外汇, 外汇, 汇率, 汇率, 汇款, 外币, 货币, 旅行, 旅游, 行程, 酒店, 机票, 比较, 格价, 特价, 预订, 交易, 旅游保险, 日本, 泰国, 韩国, 台湾, 日圆, 日元, 台币, 泰铢, HyperAir, HyperAir FX, HyperAir Travel, Travel, Travel Money, Foreign Currency, Foreign Exchange, 百年, 坚成, 发达鸟, 飞鸟, richbird, crazy bird, berlin exchange",
                "money-exchange-title": "{shop_name} 最新外币汇率 即时预订外币 | 唱钱神器 唱钱快又醒 | 每日更新兑换汇率",
                "privacy-policy-title": "私隐政策",
                "refund-policy-title": "退改政策",
                "sim-fanfares-description": "全港首个SIM卡Fanfares已经登陆 HyperAir 啦！热卖 SIM 卡低至5折发售，限时优惠，限量特价！",
                "sim-fanfares-keywords": "fanfares,SIM卡,上网卡,电话卡,数据卡,DataSIM,旅游DataSIM,数据咭,4G上网卡,上网卡,4G上网卡,日本4G上网卡,日本上网卡,东京4G上网卡,东京上网卡,大阪4G上网卡,大阪上网卡,泰国4G上网卡,泰国上网卡,曼谷4G上网卡,布吉上网卡,芭提雅4G上网卡,台湾4G上网卡,台湾上网卡,台北4G上网卡,高雄上网卡,台中4G上网卡,台中上网卡,韩国4G上网卡,韩国上网卡,首尔4G上网卡,首尔上网卡,中国4G上网卡,中国上网卡,深圳4G上网卡,深圳上网卡,澳门4G上网卡,澳门上网卡, Docomo, Softbank",
                "sim-fanfares-title": "SIM 卡 Fanfares - 限时优惠 限量特价",
                "term-of-service-title": "服务条款",
                "travel-activity-search-results-description": "立即格价，取得{activity}的最佳优惠，节省更多！在HyperAir.com可以找到最抵的活动，一次过比较热门玩乐体验的旅游网站。",
                "travel-activity-search-results-keywords": "{activity}, 旅游, 旅游体验, 旅游活动, 玩乐, 自由行, 一日游, 景点, 门票, 交通",
                "travel-activity-search-results-title": "HyperAir - {city}慨搜寻结果",
                "travel-affiliate-codes-description": "HyperAir 为你持续更新 2023 最新优惠码，轻松获得折扣码享受酒店优惠、机票优惠、门票车票优惠、旅游保险优惠、SIM卡优惠及信用卡优惠。",
                "travel-affiliate-codes-keywords": "优惠代码,电子优惠券,折扣码,Promotion,Promo Code,Discount Code,酒店,机票,优惠,信用卡优惠,旅游优惠",
                "travel-affiliate-codes-title": "2023 最新！玩乐旅游优惠码（每日更新） | 折扣预订酒店、机票、玩乐体验、旅游保险、SIM卡",
                "travel-insurance-description": "旅游保险边间好？边间保险包手提电话？立即比较旅游保险，一眼睇晒AIG、MSIG、STARR等公司的旅游保险保费。经HyperAir购买指定的旅行保险，可获赠额外旅游保险优惠。保障地点包括日本、韩国、台湾、泰国等最佳旅游胜地！",
                "travel-insurance-keywords": "旅游保险提供全面旅行保障，自驾游、手提电话、热气球、滑雪、潜水。即时免费网上报价投保！",
                "travel-insurance-title": "旅游保险 - 即时比较最佳旅游保险及额外折扣优惠 2023",
                "travel-marketplace-checkout-payme-title": "以 PayMe 付款",
                "travel-marketplace-checkout-success-keywords": "创意, 产品, 流行, 电器, 生活, 精品, 智能家居, 设计, 高品质, 设计概念, 创意科技, 生活用品, 户外休闲, 厨房, 餐桌, 个人护理, 防疫抗疫, 健康, 游戏, 儿童玩乐, 健身, 家居健身, gym, home gym, smart home, style home",
                "travel-marketplace-checkout-success-title": "付款成功",
                "travel-marketplace-description": "集合最潮最好玩慨创意科技产品，有设计概念慨生活用品",
                "travel-marketplace-keywords": "创意, 产品, 流行, 电器, 生活, 精品, 智能家居, 设计, 高品质, 设计概念, 创意科技, 生活用品, 户外休闲, 厨房, 餐桌, 个人护理, 防疫抗疫, 健康, 游戏, 儿童玩乐, 健身, 家居健身, gym, home gym, smart home, style home",
                "travel-marketplace-product-checkout-title": "{product}",
                "travel-marketplace-product-title": "{product} - 玩乐潮物",
                "travel-marketplace-title": "玩乐潮物",
                "travel-money-description": "透过「HyperAir唱钱神器」，您可以喺网上比较汇率同埋预订外币，之后再喺心水的商店提取。咁你就可以悭返好多格价同排队慨时间。",
                "travel-money-keywords": "sim卡,上网卡,电话卡,数据卡,DataSIM,旅游DataSIM,数据咭,4G上网卡,上网卡,4G上网卡,唱钱神器,唱X神器,唱钱X器,唱钱,兑换,找换,兑换店,找换店,银行,金融,外汇,外汇,汇率,汇率,汇款,外币,货币,旅行,旅游,行程,酒店,机票,比较,格价,特价,预订,交易,旅游保险,日本,泰国,韩国,台湾,日圆,日元,台币,泰铢,HyperAir,HyperAir FX,HyperAir Travel,Travel,Travel Money,Foreign Currency,Foreign Exchange,百年,坚成,发达鸟,飞鸟,richbird,crazy bird,berlin exchange",
                "travel-money-title": "唱钱神器™ - 轻松搜寻全球货币，比较价格及预订最抵汇率",
                "travel-product-checkout-keywords": "创意, 产品, 流行, 电器, 生活, 精品, 智能家居, 设计, 高品质, 设计概念, 创意科技, 生活用品, 户外休闲, 厨房, 餐桌, 个人护理, 防疫抗疫, 健康, 游戏, 儿童玩乐, 健身, 家居健身, gym, home gym, smart home, style home",
                "travel-product-keywords": "创意, 产品, 流行, 电器, 生活, 精品, 智能家居, 设计, 高品质, 设计概念, 创意科技, 生活用品, 户外休闲, 厨房, 餐桌, 个人护理, 防疫抗疫, 健康, 游戏, 儿童玩乐, 健身, 家居健身, gym, home gym, smart home, style home",
                "travel-sim-checkout-description": "{country}旅游SIM，多款劲抵价SIM卡，免运费送上门，准备旅程快又醒！",
                "travel-sim-checkout-keywords": "上网卡,电话卡,数据卡,DataSIM,旅游DataSIM,数据咭,4G上网卡,上网卡,4G上网卡,日本4G上网卡,日本上网卡,东京4G上网卡,东京上网卡,大阪4G上网卡,大阪上网卡,泰国4G上网卡,泰国上网卡,曼谷4G上网卡,布吉上网卡,芭提雅4G上网卡,台湾4G上网卡,台湾上网卡,台北4G上网卡,高雄上网卡,台中4G上网卡,台中上网卡,韩国4G上网卡,韩国上网卡,首尔4G上网卡,首尔上网卡,中国4G上网卡,中国上网卡,深圳4G上网卡,深圳上网卡,澳门4G上网卡,澳门上网卡, Docomo, Softbank",
                "travel-sim-checkout-success-description": "{country}旅游SIM，多款劲抵价SIM卡，免运费送上门，准备旅程快又醒！",
                "travel-sim-checkout-success-keywords": "上网卡,电话卡,数据卡,DataSIM,旅游DataSIM,数据咭,4G上网卡,上网卡,4G上网卡,日本4G上网卡,日本上网卡,东京4G上网卡,东京上网卡,大阪4G上网卡,大阪上网卡,泰国4G上网卡,泰国上网卡,曼谷4G上网卡,布吉上网卡,芭提雅4G上网卡,台湾4G上网卡,台湾上网卡,台北4G上网卡,高雄上网卡,台中4G上网卡,台中上网卡,韩国4G上网卡,韩国上网卡,首尔4G上网卡,首尔上网卡,中国4G上网卡,中国上网卡,深圳4G上网卡,深圳上网卡,澳门4G上网卡,澳门上网卡, Docomo, Softbank",
                "travel-sim-checkout-success-title": "付款成功 - 旅游SIM卡",
                "travel-sim-checkout-title": "订购 - 旅游SIM卡",
                "travel-sim-keywords": "sim卡,上网卡,电话卡,数据卡,DataSIM,旅游DataSIM,数据咭,4G上网卡,上网卡,日本4G上网卡,日本上网卡,日本sim卡,东京4G上网卡,东京上网卡,大阪4G上网卡,大阪上网卡,泰国4G上网卡,泰国上网卡,泰国sim卡,曼谷4G上网卡,布吉上网卡,芭提雅4G上网卡,台湾4G上网卡,台湾上网卡,台湾sim卡,台北4G上网卡,高雄上网卡,台中4G上网卡,台中上网卡,韩国sim卡,韩国4G上网卡,韩国上网卡,首尔4G上网卡,首尔上网卡,中国4G上网卡,中国上网卡,中国sim卡,中国内地数据卡,深圳4G上网卡,深圳上网卡,澳门4G上网卡,澳门上网卡, 欧洲4G上网卡,欧洲上网卡,欧洲sim卡,英国4G上网卡,英国上网卡,英国sim卡,法国4G上网卡,法国上网卡,法国sim卡, 恴大利4G上网卡,意大利上网卡,意大利sim卡,巴黎4G上网卡,巴黎上网卡,巴黎sim卡,瑞士4G上网卡,瑞士上网卡,瑞士sim卡,Docomo, Softbank, 和记, 联通, 3hk, 3uk, birdie, 自由鸟, airsim,sim2fly,AIS,ais sim2fly,SK Telecom,TrueMove,dtac,t mobile 全球上网卡,vietnamobile",
                "travel-sim-title": "【{country}上网SIM卡】{sim_name} - 劲抵价免运费",
                "travel-sims-description": "全球旅游SIM搜寻引擎，轻松订购优质劲抵价SIM卡，免运费送上门，准备旅程快又醒！",
                "travel-sims-keywords": "sim卡,上网卡,电话卡,数据卡,DataSIM,旅游DataSIM,数据咭,4G上网卡,4Gsim卡,日本4G上网卡,日本上网卡,日本sim卡,东京4G上网卡,东京上网卡,大阪4G上网卡,大阪上网卡,泰国4G上网卡,泰国上网卡,泰国sim卡,曼谷4G上网卡,布吉上网卡,芭提雅4G上网卡,台湾4G上网卡,台湾上网卡,台湾sim卡,台北4G上网卡,高雄上网卡,台中4G上网卡,台中上网卡,韩国sim卡,韩国4G上网卡,韩国上网卡,首尔4G上网卡,首尔上网卡,中国4G上网卡,中国上网卡,中国sim卡,中国内地数据卡,深圳4G上网卡,深圳上网卡,澳门4G上网卡,澳门上网卡,澳门sim卡,欧洲sim卡,Docomo,Softbank,sim2fly,AIS,ais sim2fly,SK Telecom,TrueMove,dtac,t mobile 全球上网卡,vietnamobile",
                "travel-sims-title": "旅游SIM - 优质，劲抵价，免运费送上门"
            },
            "shop-confirmation": {
                "app-download": "立即下载，推送通知",
                "app-download-subtitle": "下载 HyperAir 接收确认订单的通知。",
                "instruction": "你的预订已发送到找换店。一旦确认，我们会透过电邮或通知，将 QR CODE 将收到电邮通知，确认订单将发送至 {email} 。",
                "my-order": "我的订单",
                "pending-confirm": "等待兑换店确认"
            },
            "staycation": {
                "activity-countdown-button": "比较门票优惠",
                "all-hotels": {
                    "sorting": {
                        "recommended": "推介"
                    }
                },
                "all-hotels-all-button": "所有",
                "all-hotels-hotel-name": "酒店名称",
                "all-hotels-last-updated": "最后更新",
                "all-hotels-less-button": "收起",
                "all-hotels-more-button": "更多",
                "all-hotels-no-result": "Sorry！我哋搵唔到相关慨Staycation优惠",
                "all-hotels-title": "搜寻全港最齐 Staycation 酒店",
                "compare-packages": "比较此酒店其他套餐",
                "countdown-button": "立即抢购",
                "countdown-title": "最新 Staycation 酒店快闪优惠",
                "countdown2-title": "今期热爆推介",
                "countdown3-title": "最新 Staycation 酒店限时优惠",
                "month-format": "M",
                "order-d-title": "浪漫精品酒店 💕💕",
                "order-g-subtitle": "暑假带埋一家大细Relax下",
                "order-g-title": "亲子Staycation必去之选👨‍👩‍👧‍👦😍",
                "order-h-title": "邮轮之旅🛳️",
                "order-i-title": "情侣煮饭仔酒店 🍽️",
                "order-j-title": "Glamping豪华露营推介",
                "seo-description": "点解咁多人用 HyperAir 搵 Staycation? 因为集合左 KKday, Trip.com, Klook 及各大香港酒店平台，一眼比较边到有late checkout、免费泊车、自助早午晚餐及餐饮回赠等独家 Staycation 优惠，每日更新。",
                "seo-keywords": "staycation, staycation 优惠, 香港 staycation, staycation 香港, staycation hk, staycation package, staycation hong kong, 酒店, 酒店 优惠, staycation 中文, 香港 酒店, klook 优惠, klook 优惠, kkday 优惠, trip 优惠, agoda 优惠, runhotel staycation, 酒店 套票, staycation 酒店, 香港 酒店 套票, 订 酒店 优惠, 酒店 package, 特价 酒店, 香港 优惠 酒店, 酒店 优惠 套 票, 特价 酒店 香港, 香港 酒店 优惠, 酒店 住宿 优惠, staycation 2020, staycation 2021, staycation 2022, staycation 1月 优惠, staycation 2月 优惠, staycation 3月 优惠, staycation 4月 优惠, staycation 5月 优惠, staycation 6月 优惠, staycation 7月 优惠, staycation 8月 优惠, staycation 9月 优惠, staycation 10月 优惠, staycation 11月 优惠, staycation 12月 优惠, 四季酒店, W酒店, Murray, JW Marriott, St. Regis, Conrad Hotel, Grand Hyatt, Ritz Carlton, Rosewood, 露台 酒店, 厨房 酒店, 亲子 酒店, 情侣 酒店",
                "seo-title": "【2021年9月最新】香港酒店 Staycation 优惠搜寻神器 全港最齐．每日更新 - 最齐香港staycation优惠、酒店优惠、Hong Kong Staycation Ideas、Klook优惠、KKday优惠、Trip优惠、Agoda优惠、专业旅运优惠 - HyperAir 玩乐必备搜寻比较平台！一次过，比较全球多个玩乐旅游预订网站！ - HyperAir",
                "share-button-alert": "链结已复制",
                "subtitle": "每日更新酒店餐饮及住宿优惠（{start_month}月至{end_month}月）",
                "title": "香港最齐 Staycation 优惠搜寻神器",
                "top10-title": "Top 10 人气 Staycation 酒店",
                "top102-title": "Staycation 必去之选",
                "top103-title": "值得一试的 Staycation 酒店🥂"
            },
            "travel-activities": {
                "best-deals": "价格",
                "book-now": "查看详情",
                "disclaimer": "价格只供参考，一切内容将以合作平台为准。",
                "empty-destination": "请输入国家或城巿",
                "more-deals": "更多",
                "not-available": "未能预订",
                "offers": "",
                "provider-getyourguide": "GetYourGuide",
                "provider-hk": {
                    "trip": {
                        "com": "Trip.com"
                    }
                },
                "provider-hyperair": "HyperAir",
                "provider-kkday": "KKday",
                "provider-klook": "KLOOK",
                "provider-seoultravelpass": "SeoulPass",
                "provider-sim": {
                    "hyperair": {
                        "com": "HyperAir"
                    }
                },
                "provider-travelexpert": "Travel Expert",
                "provider-trip": "Trip.com",
                "ratings": "评分",
                "recommended-title": "更多{city}慨热门活动",
                "search-africa-oceania": "非洲/大洋洲",
                "search-all-cities": "所有城市",
                "search-america": "美洲",
                "search-asia": "亚洲",
                "search-button": "搜寻",
                "search-cancel-button": "取消",
                "search-country-placeholder": "输入国家或城市",
                "search-euro-middleeast": "欧洲/中东",
                "search-hardcoded-cities": "热门搜寻：",
                "search-placeholder": "搜寻 \"门票\" 或 \"一日游\"",
                "search-popular-cities": "🔥热门城市",
                "search-searched-cities": "搜寻城市",
                "search-slogan-2": "活动分类/景点",
                "show-similar-product": "比较相关产品",
                "sorting": {
                    "price-asc": "价格（从低到高）",
                    "price-desc": "价格（从高到低）",
                    "rating": "评分",
                    "relevance": "最相关",
                    "sort-by": "排序"
                },
                "title": "符合「{q}」的搜寻结果",
                "title-everything": "{city}慨热门活动",
                "title-no-result": "Sorry！我哋搵唔到同“{q}”相关慨活动",
                "title-no-result-without-keyword": "Sorry！我哋搵唔到相关慨活动",
                "total-results": "共 <b>{number}</b> 项搜寻结果"
            },
            "travel-affiliate-codes": {
                "cover-slogan": "提供各大预订网站旅游优惠码，帮您悭多啲、玩尽啲",
                "cover-title": "玩乐旅游优惠券",
                "disclaimer": "优惠资料只供参考，一切内容将以合作平台为准。供应商可随时对资料进行变更或删除，并保留最终之决定权。",
                "exclusive": "独家优惠",
                "type-activity": "玩乐体验",
                "type-air": "机票",
                "type-all": "所有",
                "type-hotel": "酒店",
                "type-insurance": "旅游保险",
                "type-shopping": "购物",
                "type-sim": "旅游SIM",
                "use-promo-code": "获取优惠码",
                "valid-until": "到期日："
            },
            "travel-insurance": {
                "breadcrumb-travel-insurance": "旅游保险",
                "cover-subtitle": "搜罗比较最正旅游保险，仲保埋手机添！",
                "cover-title": "旅游保险",
                "departure-date-alert": "出发日期必须于{latest_date_to_depart}或之前。",
                "disclaimer": "报价只供参考，详情请参阅保险公司网页。",
                "highlight-subtitle1": "保障范围清晰比较，最啱心水计划一目了然！",
                "highlight-subtitle2": "为你比较全港旅游保险报价 悭得一蚊得一蚊！",
                "highlight-subtitle3": "HyperAir 客户专享独家旅游保险折扣及优惠！",
                "highlight-title1": "保障比较",
                "highlight-title2": "旅保格价",
                "highlight-title3": "独家礼遇",
                "num-of-travellers-alert": "旅客人数不能多于10人",
                "partner-title": "旅游保险合作伙伴",
                "return-date-alert": "回程日期必须于{latest_date_to_return}或之前。",
                "section-title": "你正在搜寻{num_of_traveller}个旅客玩{num_of_day}日的旅游保险",
                "slogan": "简易3步 无忧投保",
                "sorting": {
                    "coverage": "最佳保障",
                    "price-asc": "价格（从低到高）",
                    "price-desc": "价格（从高到低）"
                },
                "step1": "填写旅程",
                "step1-detail": "输入你旅程慨目的地，日期和人数",
                "step2": "比较计划",
                "step2-detail": "比较不同保险计划的保障范围及价钱",
                "step3": "即享优惠",
                "step3-detail": "一按即享不同旅游保险优惠"
            },
            "travel-insurance-product-card": {
                "apply-now": "即享优惠",
                "cancellation": "取消旅游保障",
                "car-rental": "租车自负额保障",
                "cruise-vacation": "邮轮假期(附加保障)",
                "dangerous-sports": "业余危险运动",
                "hyperair-exclusive": "HYPERAIR 独家优惠",
                "medical": "医疗费用",
                "mobile": "手提电话损毁或遗失",
                "personal-belongings": "遗失钱财及证件",
                "trip-delay": "旅程延误"
            },
            "travel-insurance-search-bar": {
                "children": "子女(18岁以下)",
                "date": "出发日期及回程日期",
                "destination": "去边度玩",
                "friend": "朋友/亲属",
                "myself": "自己",
                "number-of-traveller": "旅客人数",
                "search-button": "搜寻",
                "spouse": "配偶"
            },
            "travel-marketplace": {
                "buy-now-can-earn-x-miles": "可赚取 HyperMiles 于下次消费使用",
                "cover-slogan": "集合最潮最好玩慨创意科技产品",
                "cover-title": "玩乐潮物"
            },
            "travel-marketplace-categories": "商品分类",
            "travel-marketplace-checkout": {
                "delivery-message-body": "工作天为星期一至星期五（公众假期除外），截数时间为当日正午12时，于正午12时后订购的货品将会顺延至下一个工作天寄出。",
                "delivery-method-1": "顺丰速递 （只限香港）",
                "delivery-method-1-description": "以顺丰速运寄送，每单运费HK$30，买满HK$800免运费。大概5-10个工作天内送达。",
                "delivery-method-2": "跨国运送",
                "delivery-method-2-description": "设运送编号作追查，大概4-25个工作天内送达，视乎选择的目的地。以上运费只是估算，或需额外运费。"
            },
            "travel-money": {
                "breadcrumb-travel-money": "唱钱神器",
                "cover-button": "立即体验",
                "cover-slogan": "助你轻松搜寻预订最抵汇率，咁就唱钱快又醒啦！",
                "cover-title": "唱钱神器™",
                "disclaimer": "价格只供参考，一切内容将以该找换店为准。",
                "empty-amount": "请输入金额",
                "fx": "",
                "fx-slogan": "简易四步 轻松唱钱",
                "fx-step1": "搜寻",
                "fx-step1-detail": "选择您所需要唱慨外币",
                "fx-step2": "比较",
                "fx-step2-detail": "搵最靓慨汇率同埋方便慨地点",
                "fx-step3": "预订",
                "fx-step3-detail": "随时随地网上轻松预订外币",
                "fx-step4": "提取",
                "fx-step4-detail": "出示您订单慨QR Code，提取您慨外币去旅行",
                "hyperair-feature-1": "醒目",
                "hyperair-feature-1-description": "一个醒目的方法唱外币去旅行。现在，您只需揿一个掣即可找到最好的商店，在几秒钟内预订外币，并在最近的地点拎外币。是时候告别排队和昂贵的汇率了。",
                "hyperair-feature-2": "可靠",
                "hyperair-feature-2-description": "这是一个安全的方式去兑换外币。我们精心挑选合作伙伴，仅与受监管的银行和持牌兑换店合作。使用我们的平台，您的资金将受最高的保障。",
                "hyperair-feature-3": "随时随地",
                "hyperair-feature-3-description": "这是革新的兑换外币方式。我们雄心勃勃地扩展在本地和全球的服务，为您提供最佳的旅行体验。我们努力确保您在任何地方，都以智能和可靠的方式获得旅行外币。",
                "i-will-get": "我要唱",
                "i-will-pay": "我要畀",
                "join-us": "获取更多商机",
                "join-us-button": "加入供应商",
                "join-us-slogan": "加入我们的找换店网络",
                "search-bar-placeholder": "输入金额",
                "search-button": "搜寻",
                "section-title": "你正在搜寻{amount} {currency} 兑换 HKD",
                "section-title-from-hkd": "你正在搜寻HKD 兑换 {amount} {currency}",
                "section-title-to-hkd": "你正在搜寻{amount} {currency} 兑换 HKD",
                "why-hyperair": "",
                "why-hyperair-description": "唱钱神器™为您带嚟醒目慨方法去准备您慨旅行。我哋提供快速、简易同埋中立慨外币搜索引擎。",
                "why-hyperair-title": "为什么选用唱钱神器 ?"
            },
            "travel-product": {
                "buy-now": "立即购买",
                "product-option": "产品选项"
            },
            "travel-sim": {
                "as-low-as": "每日低至",
                "book-now": "立即订购(有库存)",
                "breadcrumb-homepage": "首页",
                "breadcrumb-mainpage": "主页",
                "breadcrumb-travel-sim": "旅游SIM",
                "cancellation-policy": "取消政策",
                "cancellation-policy-content": "成功预订后，订单不可修改、取消或退款",
                "download-hyperair-now-description": "用相机扫一扫 QR Code 或按平台下载 HyperAir 应用程式",
                "download-hyperair-now-title": "立即下载 HyperAir",
                "first-step": "第一步",
                "go-to-shopping-cart-description": "下载后用相机扫描 QR 码可直达产品专业，选择数量或其他产品后可直接付款。",
                "go-to-shopping-cart-title": "直达购物车，立即付款",
                "hardcoded-countries-title": "其他热门地区：",
                "highlights": "特色",
                "important-notice": "注意事项",
                "instructions": "使用说明",
                "lowest-price-guarantee": "推廣價",
                "no-stock": "卖晒啦",
                "num-of-review": "{num}-of-review个评分",
                "popular-countries": "旅游 SIM 涵盖 200+ 国家",
                "popular-countries-search-button": "搜寻其他国家",
                "product-highlights": "产品详情",
                "product-specification": "产品规格",
                "related-sims": "相关{countrySIM}卡",
                "related-sims-search-button": "更多{country}旅游 SIM",
                "review": "评价",
                "review-date": "{date}",
                "review-no-firstname-user": "旅客",
                "scan-product-qr-code": "扫一扫 QR Code 购买此产品",
                "second-step": "第二步",
                "sim": "电话卡",
                "web-traffic": "最近7天已卖岀{num}-of-purchased张 , 而家有{num}-of-traffic个人同时睇紧呢张SIM卡",
                "web-traffic-title": "呢张 SIM 卡热卖中！"
            },
            "travel-sim-checkout": {
                "-secure-payment-slogan": "我们所有的线上付款都受加密保护",
                "address": "地址*",
                "address-column1": "例如：香港中环",
                "address-column2": "例如：旅游路88号",
                "address-column3": "例如：世界中心18楼A室",
                "back-button": "返回",
                "checkout-title-1": "物流资料",
                "confirm-button": "继续",
                "country-code": "国家编码",
                "delivery-message-body": "工作天为星期一至星期五（公众假期除外），截数时间为当日正午12时，于正午12时后订购的货品将会顺延至下一个工作天寄出。\n<br><br>如在同一日工作天内，相同收货地址的订单将会合并寄岀。",
                "delivery-message-header": "送货通告",
                "delivery-method": "物流方式",
                "delivery-method-1": "平邮（免费）",
                "delivery-method-1-description": "以香港邮政平邮寄送，免邮费，大概3-6个工作天内送达。如选择平邮寄送，将不设邮寄编号作追查，客户需要自行承担平邮延误及寄失的风险。\n<br>注意：因寄送需时，即将外游的顾客建议选用顺丰到付，确保货品能准时送达",
                "delivery-method-2": "顺丰速递 （只限香港，货到付运费）",
                "delivery-method-2-description": "以順豐速運寄送，貨到後付運費，大概1-3個工作天內送達，離島需時可與順豐查詢。速遞運費約HK$16-$25。詳情請參閱順豐速運網站。\n<br><br>注意：如即日總訂單付款滿HK$399，即可升級以順豐速運免費寄送。",
                "delivery-method-3": "跨国运送",
                "delivery-method-3-description": "以香港邮政空邮寄送，设邮寄编号作追查，固定$30邮费，大概4-15个工作天内送达，视乎选择的目的地",
                "error-alert-address": "请填写「收货地址」。",
                "error-alert-invalid-email": "电邮地址格式不正确。",
                "error-alert-invalid-recipient-first-num": "联系号码应该以2, 3, 5, 6, 7, 8或9开始。",
                "error-alert-invalid-recipient-number": "请填写正确的收货人联系号码。",
                "error-alert-invalid-user-first-num": "手机号码应该以5, 6, 7, 8或9开始。",
                "error-alert-invalid-user-number": "请填写正确的手机号码。",
                "error-alert-personal-info": "请填写「预订人资料」。",
                "error-alert-recipient-info": "请填写「收货人资料」。",
                "error-invalid-credit-card-info": "信用卡资料不正确",
                "facebook-login": "Facebook 继续",
                "google-login": "Google 继续",
                "logged-in": "已登入",
                "login": "现有客户，立即登入方便购买",
                "login-button": "登入",
                "login-email": "电邮",
                "login-no-user-exists": "哎哟！很抱歉，我哋未能确认您慨登入资料。请再试一次，或不登入直接完成订购也很容易。",
                "login-password": "密码",
                "payme": {
                    "error-contacting-payme": "付款失败，请重新落单 / 联络客户服务"
                },
                "payment": {
                    "actual-payment": "交易以港元 ${actual_payment} 结算，兑换率将跟据您的发卡机构为准",
                    "choose-payment-method": "选择付款方式：",
                    "logistic-information": "物流资料",
                    "modify-information": "修改资料",
                    "pay-now": "立即付款",
                    "payme-instruction-do-not-close": "在交易完成前请不要关闭此页面",
                    "payme-instruction-step-1": "1. 打开 PayMe 应用程式",
                    "payme-instruction-step-2": "2. 扫描 PayCode 以授权付款",
                    "payme-instruction-step-3": "3. 在 PayMe 完成交易后，请留在此页面等待确认",
                    "payme-instruction-title": "如何用 PayMe 付款？",
                    "payme-title": "请用 PayMe 扫描此 PayCode",
                    "payment": "付款",
                    "price": "金额",
                    "shipping-fee": "运费",
                    "subtotal": "小计"
                },
                "payment-method": "付款方式",
                "pending": {
                    "mobile-redirection-text": "您已选择以PayMe作为付款方式，并且将被重新定向至PayMe应用程式以完成付款。",
                    "need-to-pay": "需付金额",
                    "order-number": "订单号码",
                    "order-success-please-pay": "你已成功下单，请完成付款手续，以便完成订单程序",
                    "paycode-error": "付款失败，请重新落单 / 联络客户服务",
                    "paycode-expired": "PayMe 的 PayCode 已过期，请重新落单",
                    "re-order": "重新落单",
                    "title-payme": "PayMe 付款"
                },
                "recipient-address": "收货地址",
                "recipient-information": "收货人资料",
                "recipient-name": "收货人名称",
                "recipient-phone-number": "收货人联系电话",
                "secure-payment-slogan": "安全付款 | 付款资料受SSL安全加密传输",
                "simproduct-detail": "订单资料",
                "simproduct-quantity": "数量",
                "simproduct-redeem": "兑换",
                "simproduct-redeem-hypermiles": "兑换 HyperMiles",
                "simproduct-title": "产品",
                "simproduct-will-redeeming-x-miles": "将兑换 {miles} HyperMiles",
                "simproduct-you-have-x-hypermiles": "你已拥有 {miles} HyperMiles",
                "user-email": "电邮（接收发票）",
                "user-firstname": "名字",
                "user-information": "预订人资料",
                "user-lastname": "姓氏",
                "user-phone-number": "手机号码",
                "vertical-divider": "或"
            },
            "travel-sims": {
                "column-title-1": "清晰分类，容易挑选",
                "column-title-2": "网上付款，方便快捷",
                "column-title-3": "免费平邮，极速送到",
                "country-search-no-place-found": "请输入正确国家名称",
                "cover-button": "立即用App购买",
                "cover-slogan": "多款劲抵价SIM卡，免运费送上门!",
                "cover-title": "旅游SIM",
                "empty-destination": "请输入目的地",
                "num-of-days": "去几多日",
                "search-button": "",
                "search-input": "输入国家",
                "search-placeholder": "输入国家",
                "search-slogan": "去边到玩？",
                "travel-sim-header-description": "",
                "travel-sim-header-title": ""
            }
        },
        "passwords": {
            "password": "",
            "reset": "",
            "sent": "我们已经通过电子邮件发送了您的密码重置链接。",
            "token": "",
            "user": ""
        },
        "mail": {
            "product-simcard": {
                "delivery-update": {
                    "subject": "您慨SIM卡订单已经寄岀"
                },
                "purchased": {
                    "subject": "您慨旅游SIM卡订单已确认"
                },
                "tracking-number-update": {
                    "subject": "您慨快递单号已更新"
                }
            }
        },
        "member-center": {
            "login-to-receive-codes": "立即注册，即赏你优惠券",
            "my-orders-empty": "没有纪录",
            "my-orders-title": "我的订单",
            "profile-area-code": "国家编码",
            "profile-email": "电邮地址",
            "profile-firstname": "名字",
            "profile-lastname": "姓氏",
            "profile-save": "修改",
            "profile-tel": "手机号码",
            "profile-title": "帐户资料",
            "profile-update-successfully": "成功更新",
            "promo-code-enter-promotion-code": "输入优惠码",
            "promo-code-my-promo-code": "我慨 HyperAir 优惠券",
            "promo-code-no-code": "不好意思,你没有任何优惠券",
            "promo-code-please-fill-in-code": "请填写优惠码",
            "promo-code-redeem": "兑换",
            "promo-code-redeem-code": "兑换 HyperAir 优惠券",
            "promo-code-select": "选择",
            "promo-code-title": "HyperAir 优惠券",
            "title": "我的账户"
        },
        "weekday": {
            "1": "星期一",
            "2": "星期二",
            "3": "星期三",
            "4": "星期四",
            "5": "星期五",
            "6": "星期六",
            "7": "星期日"
        },
        "exchange-shop-details": {
            "address": "地址",
            "book-button": "立即预约",
            "br": "牌照号码",
            "closed-book-button": "休息中",
            "download-pop-up": {
                "slogan-1": "立即报价，锁住汇率",
                "slogan-2": "即时通知，确认订单",
                "title": "立即下载 HyperAir 预约唱钱"
            },
            "latest-updated": "最新",
            "not-available-book-button": "只供参考",
            "opening-hrs": "营业时间",
            "phone-num": "电话",
            "rate": "汇率",
            "reviews": "评论",
            "table-buy-rate": "买入价",
            "table-compare-button": "比较汇率",
            "table-currency": "外币",
            "table-sell-rate": "卖出价",
            "table-short-form": "代码",
            "table-title": "外币汇率"
        },
        "credit-card": {
            "cannot-add-card": "新增信用卡时发生错误，请确认所有资料正确并再次新增，您也可以选择新增另一张信用卡。",
            "cannot-process": "信用卡付款时发生错误，请确认所有资料正确并再次付款，您也可以选择以另一张信用卡付款。"
        },
        "shoppingcart": {
            "add": {
                "no-stock": "噢！已达最多可购买的数量~"
            },
            "pay": {
                "db-locked": "系统现在繁忙，请稍后再试。 （参考编号：E1003）",
                "invalid-promotion-code": "优惠码无效",
                "no-stock": "不好意思，您想买慨产品刚刚没有存货了！ （参考编号：E1002）"
            },
            "promotion-message": {
                "up-sell-1": "使用迎新优惠券可享 HK$10 折扣",
                "up-sell-2": "消费满 HK$299 并使用优惠码 HYPER15，可享 HK$15 折扣"
            }
        },
        "product": {
            "label-confirmation-duration-24_hours": "24小时确认",
            "label-confirmation-duration-48_hours": "48小时确认",
            "label-confirmation-duration-instant": "即时确认",
            "label-duration-unit-day": "日",
            "label-duration-unit-hour": "小时",
            "label-duration-unit-hr": "小时",
            "label-duration-unit-min": "分钟",
            "label-earliest-available-date": "Y年n月j日",
            "label-earliest-available-date-today": "今日",
            "label-earliest-available-date-tomorrow": "明日",
            "label-lang-en": "英文",
            "label-lang-jp": "日文",
            "label-lang-kr": "韩文",
            "label-lang-zh": "中文",
            "label-meet-up-method-hotel_pickup": "酒店接送",
            "label-meet-up-method-location_meet_up": "自行前往指定地点集合",
            "label-refundable-conditional_cancel": "有条件退改",
            "label-refundable-no_cancel": "不能退改",
            "label-ticket-logistic-mobile": "需要手机凭证",
            "label-ticket-logistic-printed": "需要列印凭证",
            "label-ticket-logistic-printed_or_mobile": "列印或手机凭证均可",
            "label-ticket-validity-fixed_date": "必须于指定日期使用",
            "label-ticket-validity-open_date": "有效期内任何一天使用",
            "label-ticket-validity-open_or_fixed_date": "有效期以具体方案所述为准"
        },
        "pagination": {
            "next": "下一页",
            "previous": "上一页"
        },
        "city": {
            "abu-dhabi": "阿布扎比",
            "adelaide": "阿德莱德",
            "agra": "阿格拉",
            "ahmedabad": "艾哈迈达巴德",
            "alice-springs": "爱丽斯泉",
            "alsace": "阿尔萨斯",
            "amritsar": "阿姆利则",
            "amsterdam": "阿姆斯特丹",
            "andalusia": "安大路西亚",
            "antalya": "安塔利亚",
            "anuradhapura": "阿努拉德普勒",
            "athens": "雅典",
            "auckland": "奥克兰市",
            "bacolod": "巴科洛德",
            "bagan": "蒲甘",
            "baku": "巴库",
            "bali": "里岛",
            "bandung": "万隆",
            "bangalore": "班加罗尔",
            "bangkok": "曼谷",
            "barcelona": "巴塞罗纳",
            "batam": "巴淡岛",
            "bath": "浴",
            "bay-of-islands": "岛屿湾",
            "beijing": "北京",
            "belfast": "贝尔法斯特",
            "bentota": "本托塔",
            "berlin": "柏林",
            "bohol": "保和",
            "boracay": "长滩岛",
            "bordeaux": "波尔多",
            "boston": "波斯顿",
            "bratislava": "布拉迪斯拉发",
            "brisbane": "布里斯班",
            "bruges": "布鲁日",
            "brussels": "布鲁塞尔",
            "budapest": "布达佩斯",
            "burgundy": "勃艮第酒",
            "busan": "釜山",
            "cairns": "凯恩斯",
            "cambridge": "剑桥",
            "cameron-highlands": "金马仑高原",
            "canary-islands": "加那利群岛",
            "cape-town": "开普敦",
            "cappadocia": "卡帕多细亚",
            "cebu": "宿务",
            "champagne": "香槟酒",
            "chengdu": "成都市",
            "chennai": "钦奈",
            "chiang-mai": "清迈",
            "chiang-rai": "清莱",
            "chiayi": "嘉义",
            "chicago": "芝加哥",
            "chongqing": "重庆市",
            "christchurch": "基督城",
            "cochin": "科钦",
            "cologne": "科隆",
            "colombo": "科伦坡",
            "copenhagen": "哥本哈根",
            "costa-del-sol": "太阳海岸",
            "crete": "克里特岛",
            "da-lat": "大叻",
            "da-nang": "岘港市",
            "darwin": "达尔文",
            "davao": "达沃",
            "delhi": "新德里",
            "dhaka": "达卡",
            "dresden": "德累斯顿",
            "dubai": "迪拜",
            "dublin": "都柏林",
            "dubrovnik": "杜布罗夫尼克",
            "dumaguete": "杜马格特",
            "dunedin": "但尼丁",
            "düsseldorf": "杜塞尔多夫",
            "edinburgh": "爱丁堡",
            "finnish-lapland": "",
            "florence": "佛罗伦斯",
            "frankfurt": "法兰克福",
            "fraser-island": "弗雷泽岛",
            "french-riviera": "法国里维埃拉",
            "fukuoka": "福冈",
            "galle": "加勒",
            "galway": "高威",
            "gangtok": "甘托克",
            "gangwon-do": "江原道",
            "gdansk": "格但斯克",
            "geneva": "日内瓦",
            "genting-highlands": "云顶高原",
            "geraldton": "杰拉尔顿",
            "glasgow": "格拉斯哥",
            "goa": "果阿",
            "gold-coast": "黄金海岸",
            "gothenburg": "哥德堡",
            "guam": "关岛",
            "guangdong": "粤",
            "guilin": "桂林",
            "guizhou": "贵州省",
            "gyeonggi-do": "京畿道",
            "haikou": "海口",
            "hakone": "箱根",
            "halong": "下龙",
            "hamburg": "汉堡",
            "hangzhou": "杭州",
            "hanoi": "河内",
            "harbin": "哈尔滨",
            "hat-yai": "合艾",
            "hawaii": "夏威夷",
            "heidelberg": "海德堡",
            "helsinki": "赫尔辛基",
            "himachal-pradesh": "喜马al尔邦",
            "hiroshima": "广岛",
            "ho-chi-minh-city": "胡志明市",
            "hobart": "霍巴特",
            "hoi-an": "会安",
            "hokkaido": "北海道",
            "hong-kong": "香港",
            "hua-hin": "华欣",
            "hualien": "花莲",
            "hue": "色调",
            "hyderabad": "海得拉巴",
            "iloilo": "伊洛伊洛",
            "incheon": "仁川",
            "inle-lake": "茵莱湖",
            "inner-mongolia": "内蒙古",
            "innsbruck": "因斯布鲁克",
            "interlaken": "因特拉肯",
            "inverness": "因弗内斯",
            "ipoh": "怡保",
            "istanbul": "伊斯坦堡",
            "jaipur": "斋浦尔",
            "jaisalmer": "斋沙默尔",
            "jakarta": "雅加达",
            "jeju": "济州",
            "jerusalem": "耶路撒冷",
            "jodhpur": "焦特布尔",
            "johor-bahru": "柔佛州新山",
            "kandy": "康提",
            "kaohsiung": "高雄",
            "kathmandu": "加德满都",
            "kazan": "喀山",
            "kenting": "垦丁",
            "kiev": "基辅",
            "kinmen": "金门",
            "kobe": "科比",
            "koh-chang": "象岛",
            "koh-samui": "苏梅岛",
            "krabi": "甲米",
            "krakow": "克拉科夫",
            "kuala-lumpur": "吉隆坡",
            "kumamoto": "熊本",
            "kyoto": "京都",
            "kyushu": "九州",
            "lake-district": "湖区",
            "langkawi": "兰卡威",
            "lapland": "拉普兰",
            "las-vegas": "拉斯维加斯",
            "launceston": "朗塞斯顿",
            "lausanne": "洛桑",
            "leipzig": "莱比锡",
            "lisbon": "里斯本",
            "liverpool": "利物浦",
            "ljubljana": "卢布尔雅那",
            "loire-valley": "卢瓦尔河谷",
            "lombok": "龙目岛",
            "london": "伦敦",
            "los-angeles": "洛杉矶",
            "luang-prabang": "琅勃拉邦",
            "lucerne": "琉森",
            "lviv": "利沃夫",
            "lyon": "里昂",
            "macao": "澳门",
            "macau": "",
            "madrid": "马德里",
            "malaga": "马拉加",
            "manchester": "曼彻斯特",
            "mandalay": "曼德勒",
            "manila": "马尼拉",
            "marrakech": "马拉喀什",
            "mauritius": "毛里求斯",
            "medan": "棉兰",
            "melaka": "马六甲",
            "melbourne": "墨尔本",
            "miami": "迈阿密",
            "milford-sound": "米尔福德峡湾",
            "montreux": "蒙特勒",
            "moscow": "莫斯科",
            "mumbai": "孟买",
            "munich": "慕尼黑",
            "muscat": "马斯喀特",
            "nagano": "长野",
            "nagoya": "名古屋",
            "naples": "那不勒斯",
            "nelson": "纳尔逊",
            "new-delhi": "新德里",
            "new-york": "纽约",
            "nha-trang": "芽庄",
            "niagara-falls": "尼亚加拉瀑布",
            "niigata": "新泻",
            "normandy": "诺曼底",
            "odessa": "敖德萨",
            "okayama": "冈山",
            "okinawa": "冲绳",
            "orlando": "奥兰多",
            "osaka": "大阪",
            "oslo": "奥斯陆",
            "oxford": "牛津",
            "palawan": "巴拉望岛",
            "paris": "巴黎",
            "pattaya": "芭堤雅",
            "penang": "槟城",
            "penghu": "澎湖",
            "perth": "珀斯",
            "philadelphia": "费城",
            "phnom-penh": "金边",
            "phu-quoc": "富国",
            "phuket": "普吉岛",
            "pisa": "比萨",
            "pokhara": "博卡拉",
            "port-lincoln": "林肯港",
            "porto": "",
            "porto-district": "波尔图",
            "prague": "布拉格",
            "provence": "普罗旺斯",
            "puglia": "普利亚大区",
            "pune": "浦那",
            "pushkar": "普什卡",
            "queenstown": "皇后镇",
            "ras-al-khaimah": "拉斯·海玛",
            "reykjavik": "雷克雅未克",
            "rhodes": "罗得岛",
            "rhône-alpes": "罗纳-阿尔卑斯",
            "rome": "罗马",
            "rotorua": "罗托鲁阿",
            "rotterdam": "鹿特丹",
            "sabah": "沙巴州",
            "saint-petersburg": "圣彼得堡",
            "saipan": "塞班岛",
            "salzburg": "萨尔茨堡",
            "san-diego": "圣地亚哥",
            "san-francisco": "旧金山",
            "santorini": "圣托里尼岛",
            "sanya": "三亚",
            "sapa": "沙巴",
            "sarawak": "砂拉越",
            "seattle": "西雅图",
            "seoul": "汉城",
            "seville": "塞维利亚",
            "shanghai": "上海",
            "sibiu": "锡比乌",
            "sicily": "西西里岛",
            "siem-reap": "暹粒市",
            "sihanoukville": "西哈努克城",
            "singapore": "新加坡",
            "split": "分裂",
            "surabaya": "泗水",
            "suzhou": "宿苏州",
            "swedish-lapland": "瑞典拉普兰",
            "sydney": "悉尼",
            "taichung": "台中",
            "tainan": "台南",
            "taipei": "台北",
            "taitung": "台东",
            "tarragona": "塔拉戈纳",
            "taupo": "陶波",
            "terengganu": "登嘉楼",
            "thessaloniki": "塞萨洛尼基",
            "tokyo": "东京",
            "toledo": "托莱多",
            "trincomalee": "亭可马里",
            "turin": "都灵",
            "udaipur": "乌代浦",
            "uluru": "乌鲁鲁",
            "uttarakhand": "北阿坎德邦",
            "varanasi": "瓦拉纳西",
            "venice": "威尼斯",
            "verona": "维罗纳",
            "vienna": "维也纳",
            "vientiane": "万象",
            "volendam": "福伦丹",
            "washington-dc": "华盛顿特区",
            "wellington": "惠灵顿",
            "whitsundays": "圣灵降临节",
            "xiamen": "厦门",
            "xian": "ian",
            "yangon": "仰光",
            "yilan": "宜兰",
            "yogyakarta": "日惹",
            "york": "约克",
            "yunnan": "云南",
            "zagreb": "萨格勒布",
            "zhangjiajie": "张家界",
            "zurich": "苏黎世"
        },
        "validation": {
            "accepted": "",
            "active_url": "",
            "after": "",
            "after_or_equal": "",
            "alpha": "",
            "alpha_dash": "",
            "alpha_num": "",
            "array": "",
            "before": "",
            "before_or_equal": "",
            "between": {
                "array": "",
                "file": "",
                "numeric": "",
                "string": ""
            },
            "boolean": "",
            "confirmed": "",
            "custom": {
                "attribute-name": {
                    "rule-name": ""
                }
            },
            "date": "",
            "date_format": "",
            "different": "",
            "digits": "",
            "digits_between": "",
            "dimensions": "",
            "distinct": "",
            "email": "",
            "exists": "",
            "file": "",
            "filled": "",
            "image": "",
            "in": "",
            "in_array": "",
            "integer": "",
            "ip": "",
            "ipv4": "",
            "ipv6": "",
            "json": "",
            "max": {
                "array": "",
                "file": "",
                "numeric": "",
                "string": ""
            },
            "mimes": "",
            "mimetypes": "",
            "min": {
                "array": "",
                "file": "",
                "numeric": "",
                "string": ""
            },
            "not_in": "",
            "numeric": "",
            "present": "",
            "regex": "",
            "required": "",
            "required_if": "",
            "required_unless": "",
            "required_with": "",
            "required_with_all": "",
            "required_without": "",
            "required_without_all": "",
            "same": "",
            "size": {
                "array": "",
                "file": "",
                "numeric": "",
                "string": ""
            },
            "string": "",
            "timezone": "",
            "unique": "",
            "uploaded": "",
            "url": ""
        },
        "reset-password": {
            "confirm-new-password": "重覆新密码",
            "enter-new-password": "输入新密码",
            "please-enter-a-new-password": "请为您慨帐户 {email} 输入新密码。",
            "submit": "提交",
            "success-content": "成功！请使用新密码登入HyperAir慨手机App。",
            "title": "重设密码",
            "validation-display": "密码长度必须为最少6个字元。"
        },
        "notification": {
            "activation-e-minus-content": "倒数中! 仲有15日你张迎新SIM卡coupon就会到期啦！快啲用嚟准备下次慨旅行啦！",
            "activation-e-minus-title": "",
            "activation-t-plus-content": "你咁醒目用HyperAir，记得用埋我哋张迎新SIM卡coupon! 咁就真系随时随地醒目旅游啦！",
            "activation-t-plus-title": "",
            "ask-shop-to-quote-content": "要求报价买入 {amount} {currency}",
            "ask-shop-to-quote-content2": "要求报价卖出 {amount} {currency}",
            "ask-shop-to-quote-title": "新柯打等您报价",
            "email-booking-details": "订单详情",
            "email-booking-id": "订单编号",
            "email-exchange-approved-content": "Exchanged order approved for buying {amount} {currency} at rate {rate}",
            "email-exchange-approved-footer": "感谢您使用HyperAir慨服务。",
            "email-exchange-approved-title": "兑换店已回覆：「已为您准备好您慨外币！」",
            "email-exchange-completed-content": "Exchanged order completed for buying {amount} {currency} at rate {rate}",
            "email-exchange-completed-footer": "感谢您使用HyperAir慨服务。",
            "email-exchange-completed-title": "您慨外币兑换已完成！",
            "email-exchange-confirmed-content": "Exchanged order confirmed for buying {amount} {currency} at rate {rate}",
            "email-exchange-confirmed-footer": "感谢您使用HyperAir慨服务。",
            "email-exchange-confirmed-title": "已为您准备好您慨外币！",
            "email-footer-copy-right": "版权所有",
            "email-greetings": "您好！",
            "email-i-got": "我唱咗",
            "email-i-paid": "我畀咗",
            "email-i-will-get": "我要唱",
            "email-i-will-pay": "我要畀",
            "email-pickup-before": "在此时间前拎钱",
            "email-product-confirmed-greeting": "亲爱的客户：<br><br>感谢您使用HyperAir，我们已为您准备好您慨凭证！",
            "email-product-confirmed-subject": "订单已经确认",
            "email-product-confirmed-title": "您慨订单已成功确认",
            "email-product-purchased": {
                "shipping": {
                    "international": "跨国运送",
                    "sf": "顺丰速递 （只限香港）"
                }
            },
            "email-product-purchased-delievery-address": "收货地址",
            "email-product-purchased-delivery-info": "送货详情",
            "email-product-purchased-delivery-method": "物流方式",
            "email-product-purchased-discount": "折扣",
            "email-product-purchased-email": "电邮",
            "email-product-purchased-greeting": "亲爱的客户：<br><br>很好慨选择！只系我哋仍然需要一点时间去确认您慨预订。不过别担心，大多数时候我哋将在12小时内确认订单，在这段时间请您稍候，我们将尽速回覆您订单确认事宜。感谢您使用HyperAir！",
            "email-product-purchased-have-a-nice-trip": "祝旅途愉快！",
            "email-product-purchased-important-notice": "须受条款及细则约束。",
            "email-product-purchased-important-notice-content": "须受条款及细则约束。",
            "email-product-purchased-name": "姓名",
            "email-product-purchased-order-date": "落单日期",
            "email-product-purchased-order-details": "订单详情",
            "email-product-purchased-order-no": "订单编号",
            "email-product-purchased-personal-info": "个人资料",
            "email-product-purchased-receipient-name": "收货人名称",
            "email-product-purchased-receipient-phone-no": "联络电话",
            "email-product-purchased-shipping-fee": "运费",
            "email-product-purchased-sub-total": "小计",
            "email-product-purchased-subject": "订单待确认",
            "email-product-purchased-title": "您慨订单正在等待确认",
            "email-product-purchased-total": "总金额",
            "email-product-simcapurchased-personal-info": "Personal Info",
            "email-product-simcard-delivery-title": "您慨订单 SIM{order}-num 已于{date} 准备完毕并已寄出。如选择顺丰速递，我们稍后将提供快递单号，您亦可以于我哋慨手机app查看。",
            "email-product-simcard-delivery-title-carbon-format": "Y-m-d",
            "email-product-simcard-delivery-update-greeting": "亲爱的客户,<br><br>感谢您使用HyperAir. 您所购买的SIM卡已在运送途中.",
            "email-product-simcard-delivery-update-title": "您所购买的SIM卡已经寄岀",
            "email-product-simcard-delivery-update-tracking": "物流详情",
            "email-product-simcard-delivery-update-tracking-no": "Tracking Number",
            "email-product-simcard-delivery-update-tracking-no-hkpost": "快递单号: -",
            "email-product-simcard-delivery-update-tracking-no-sf": "快递单号",
            "email-product-simcard-delivery-waiting-update-tracking-no-sf": "正等候顺丰速递提供",
            "email-product-simcard-delivery-with-tracking-num-title": "您慨订单 SIM{order}-num 将由顺丰速递为您派送，快递单号: {tracking}-num，请您保持手机畅通，注意收货通知。您亦可以于顺丰速运网站查看运送状况。非常感谢您对HyperAir的支持。",
            "email-product-simcard-esim-code-greeting": "亲爱的客户：<br><br>感谢您使用HyperAir，以下是你的eSIM启用QR码！",
            "email-product-simcard-esim-code-important-notice-content": "<span style=\"font-size: 10px; line-height: 12px;\">使用说明：<br />1. 前往「设定」<br />2. 点一下「流动网络」或「流动数据」<br />3. 点一下「加入流动网络计划」<br />4. 使用 iPhone 扫描 QR 码<br />如果在启用 eSIM 时，系统要求你输入确认码，请输入电讯商提供的号码。如有需要，请电邮至hello@hyperair.com查询。 </span>",
            "email-product-simcard-esim-code-title": "以下是你的eSIM启用QR码",
            "email-product-simcard-esim-code-warning": "请注意！以下QR码一经扫描后eSIM即可启动，请务必在使用时才扫描开通。",
            "email-product-simcard-purchased-delievery-address": "收货地址",
            "email-product-simcard-purchased-delivery-info": "送货详情",
            "email-product-simcard-purchased-delivery-method": "物流方式",
            "email-product-simcard-purchased-discount": "折扣",
            "email-product-simcard-purchased-greeting": "亲爱的客户：<br><br>感谢您使用HyperAir，我们正在为您的旅游SIM卡订单安排出货！",
            "email-product-simcard-purchased-greeting-esim-only": "亲爱的客户：<br><br>感谢您使⽤HyperAir，您的eSIM已经预备好！请打开附件跟住使用说明开通。",
            "email-product-simcard-purchased-greeting-esim-with-sim": "亲爱的客户：<br><br>感谢您使⽤HyperAir，我哋正在为您的旅游SIM卡订单安排出货！此外，您的eSIM已经预备好，请打开附件同埋跟住使用说明开通。",
            "email-product-simcard-purchased-greeting-sim-only": "亲爱的客户：<br><br>感谢您使用HyperAir，我们正在为您的旅游SIM卡订单安排出货！",
            "email-product-simcard-purchased-have-a-nice-trip": "祝旅途愉快！",
            "email-product-simcard-purchased-important-notice": "注意事项",
            "email-product-simcard-purchased-important-notice-content": "<span style=\"font-size: 10px; line-height: 12px;\">1. 如果以香港邮政平邮寄送，大概5个工作天内送达。如货品由香港邮政平邮寄出，将不设邮寄编号作追查，客户需承担平邮延误及寄失的风险。 </span><br> <span style=\"font-size: 10px; line-height: 12px;\">2. 请留意旅游SIM卡的有效日期，逾期使用将不会安排重新发货。 </span><br> <span style=\"font-size: 10px; line-height: 12px;\">3. 所有送递货品均受条款及细则约束。 </span><br><br> <span style=\"font-size: 10px; line-height: 12px;\">如有需要，请电邮至hello@hyperair.com查询。 </span>",
            "email-product-simcard-purchased-important-notice-content-esim-only": "<span style=\"font-size: 10px; line-height: 12px;\">1. 如果以香港邮政平邮寄送，大概5个工作天内送达。如货品由香港邮政平邮寄出，将不设邮寄编号作追查，客户需承担平邮延误及寄失的风险。 </span><br> <span style=\"font-size: 10px; line-height: 12px;\">2. 请留意旅游SIM卡的有效日期，逾期使用将不会安排重新发货。 </span><br> <span style=\"font-size: 10px; line-height: 12px;\">3. 所有送递货品均受条款及细则约束。 </span><br><br> <span style=\"font-size: 10px; line-height: 12px;\">如有需要，请电邮至hello@hyperair.com查询。 </span>",
            "email-product-simcard-purchased-important-notice-content-esim-with-sim": "<span style=\"font-size: 10px; line-height: 12px;\">1. 如果以香港邮政平邮寄送，大概5个工作天内送达。如货品由香港邮政平邮寄出，将不设邮寄编号作追查，客户需承担平邮延误及寄失的风险。 </span><br> <span style=\"font-size: 10px; line-height: 12px;\">2. 请留意旅游SIM卡的有效日期，逾期使用将不会安排重新发货。 </span><br> <span style=\"font-size: 10px; line-height: 12px;\">3. 所有送递货品均受条款及细则约束。 </span><br><br> <span style=\"font-size: 10px; line-height: 12px;\">如有需要，请电邮至hello@hyperair.com查询。 </span>",
            "email-product-simcard-purchased-important-notice-content-sim-only": "<span style=\"font-size: 10px; line-height: 12px;\">1. 如果以香港邮政平邮寄送，大概5个工作天内送达。如货品由香港邮政平邮寄出，将不设邮寄编号作追查，客户需承担平邮延误及寄失的风险。 </span><br> <span style=\"font-size: 10px; line-height: 12px;\">2. 请留意旅游SIM卡的有效日期，逾期使用将不会安排重新发货。 </span><br> <span style=\"font-size: 10px; line-height: 12px;\">3. 所有送递货品均受条款及细则约束。 </span><br><br> <span style=\"font-size: 10px; line-height: 12px;\">如有需要，请电邮至hello@hyperair.com查询。 </span>",
            "email-product-simcard-purchased-order-date": "落单日期",
            "email-product-simcard-purchased-order-details": "订单详情",
            "email-product-simcard-purchased-order-no": "订单编号",
            "email-product-simcard-purchased-personal-info": "Personal Info",
            "email-product-simcard-purchased-receipient-name": "收货人名称",
            "email-product-simcard-purchased-receipient-phone-no": "收货人联系电话",
            "email-product-simcard-purchased-shipping-fee": "运费",
            "email-product-simcard-purchased-sub-total": "小计",
            "email-product-simcard-purchased-title": "您慨旅游SIM卡订单已确认",
            "email-product-simcard-purchased-title-esim-only": "您慨旅游eSIM卡订单已确认",
            "email-product-simcard-purchased-title-esim-with-sim": "您慨旅游SIM卡订单已确认",
            "email-product-simcard-purchased-title-sim-only": "您慨旅游SIM卡订单已确认",
            "email-product-simcard-purchased-total": "总金额",
            "email-product-simcard-tracking-number-updated-greeting": "亲爱的客户,<br><br>再次感谢您使用HyperAir. 您的快递单号已经更新了.",
            "email-product-simcard-tracking-number-updated-title": "您的快递详情已经更新",
            "email-product-simcard-tracking-number-updated-tracking-no-sf": "快递单号",
            "email-product-type-confirmed-greeting": "亲爱的客户,<br><br>感谢您使用HyperAir. 您所购买的商品已在运送途中.",
            "email-product-type-confirmed-title": "您慨商品已经寄岀",
            "email-product-type-purchased-greeting": "亲爱的客户：<br><br>感谢您使用HyperAir，我们正在为您的商品安排岀货！",
            "email-product-type-purchased-title": "您慨商品订单",
            "email-rate": "汇率",
            "email-shop-name": "兑换店名称",
            "email-verification-action": "确认电邮地址",
            "email-verification-content": "非常感谢您加入HyperAir！我哋想确认您所输入慨电邮地址系正确。请㩒下面个制启用您慨帐户：",
            "email-verification-title": "请确认您注册慨电邮地址",
            "email-verified-content": "您慨电邮已验证。欢迎加入HyperAir！",
            "email-verified-title": "已成功验证电邮",
            "engagement-content": "Use welcome10",
            "engagement-title": "Use welcome10",
            "exchange-approved-content": "确认于汇率 {rate} 买入 {amount} {currency}。",
            "exchange-approved-content2": "确认于汇率 {rate} 卖出 {amount} {currency}。",
            "exchange-approved-footer": "感谢您使用HyperAir慨服务。",
            "exchange-approved-title": "兑换店已回覆：「已为您准好您慨外币！」",
            "exchange-cancelled-content": "客人已取消柯打于汇率 {rate} 买入 {amount} {currency}。",
            "exchange-cancelled-content2": "客人已取消柯打于汇率 {rate} 卖出 {amount} {currency}。",
            "exchange-cancelled-title": "外币柯打已取消",
            "exchange-completed-content": "已于汇率 {rate} 买入 {amount} {currency}。",
            "exchange-completed-content2": "已于汇率 {rate} 卖出 {amount} {currency}。",
            "exchange-completed-footer": "感谢您使用HyperAir慨服务。",
            "exchange-completed-title": "您慨外币兑换已完成！",
            "exchange-confirmed-content": "您已确认客人可于汇率 {rate} 买入 {amount} {currency}。",
            "exchange-confirmed-content2": "您已确认客人可于汇率 {rate} 卖出 {amount} {currency}。",
            "exchange-confirmed-footer": "感谢您使用HyperAir慨服务。",
            "exchange-confirmed-title": "已收到外币新柯打",
            "exchange-pending-content": "核实新柯打：于汇率 {rate} 买入 {amount} {currency}。",
            "exchange-pending-content2": "核实新柯打：于汇率 {rate} 卖出 {amount} {currency}。",
            "exchange-pending-title": "新柯打等您确认",
            "exchange-rejected-content": "这店未能处理于汇率 {rate} 买入 {amount} {currency}。请于另一家兑换店预订。",
            "exchange-rejected-content2": "这店未能处理于汇率 {rate} 卖出 {amount} {currency}。请于另一家兑换店预订。",
            "exchange-rejected-title": "哎哟！很抱歉，兑换店无法处理您慨订单。",
            "footer-trouble-link": "如果您在点击“{actionText}”按钮时遇到问题，请将以下网址复制并贴到您的浏览器： <a href=\"{actionUrl}\">{actionUrl}</a>",
            "password-reset-action": "重设密码",
            "password-reset-content": "您收到呢个电邮喺因为我哋收到了您慨密码重置请求。",
            "password-reset-footer": "如果您没有要求重置密码，您唔需要采取进一步慨操作。",
            "password-reset-title": "重设密码",
            "simcard-purchased-title": "您慨旅游SIM卡订单已确认",
            "sms-verification-content": "你的 HyperAir 验证码是 {verificationCode}"
        },
        "error": {
            "all-shops-are-closed": "喔噢，兑换店辛苦咗一日正在休息。请迟啲再搵佢哋报个靓价啦。",
            "cancel-booking-failed": "此订单已完成、逾期或被取消。请检查 [我的订单>已完成] 或 [我的订单>未能完成] 中慨订单。",
            "cancel-booking-failed-title": "无法取消此订单",
            "invalid-api-app-version": "立即更新APP以获取最新功能及以95折购买旅游SIM卡 (优惠码GIVEME5)",
            "invalid-old-password": "现有密码错误。",
            "password-incorrect": "密码错误。",
            "phone-number-is-already-registered": "此手机号码已被另一电邮地址注册，请使用该电邮地址登入。如需要提供协助，请电邮至hello@hyperair.com。",
            "this-email-is-registered": "",
            "this-phone-number-is-registered": "此手机号码已被注册。如需要提供协助，请电邮至hello@hyperair.com。"
        },
        "marketplace": {
            "homepage-product": "热门产品",
            "homepage-recently-viewed": "最近浏览",
            "product-carousels": {
                "group1": "热门推介",
                "group2": "口碑之选"
            }
        }
    },
    "zh-HK": {
        "currency": {
            "aed": "阿聯酋迪拉姆",
            "afn": "阿富汗尼",
            "all": "阿爾巴尼亞列克",
            "amd": "亞美尼亞德拉姆",
            "ang": "荷屬安的列斯盾",
            "aoa": "安哥拉寬紮",
            "ars": "阿根廷比索",
            "aud": "澳元",
            "awg": "阿魯巴弗羅林",
            "azn": "亞塞拜然馬納特",
            "bam": "波士尼亞馬克",
            "bbd": "巴貝多元",
            "bdt": "孟加拉塔卡",
            "bgn": "保加利亞列弗",
            "bhd": "巴林第納爾",
            "bif": "蒲隆地法郎",
            "bnd": "汶萊元",
            "bob": "玻利維亞比索",
            "brl": "巴西雷亞爾",
            "bsd": "巴哈馬元",
            "btc": "比特幣",
            "btn": "不丹努爾特魯姆",
            "bwp": "波札那普拉",
            "byn": "白俄羅斯盧布",
            "bzd": "貝里斯元",
            "cad": "加拿大元",
            "cdf": "剛果法郎",
            "chf": "瑞士法郎",
            "clp": "智利比索",
            "cop": "哥倫比亞比索",
            "crc": "哥斯達黎加科朗",
            "cup": "古巴比索",
            "cve": "維德角群島埃斯庫多",
            "czk": "捷克克朗",
            "djf": "吉布提法郎",
            "dkk": "丹麥克朗",
            "dop": "多米尼加比索",
            "dzd": "阿爾及利亞第納爾",
            "egp": "埃及鎊",
            "ern": "厄立特里亞納克法",
            "etb": "埃塞俄比亞比爾",
            "eur": "歐元",
            "fjd": "斐濟元",
            "fkp": "福克蘭群島鎊",
            "gbp": "英鎊",
            "gel": "格魯吉亞拉里",
            "ghs": "加納塞地",
            "gip": "直布羅陀鎊",
            "gmd": "岡比亞達拉西",
            "gnf": "幾內亞法郎",
            "gtq": "危地馬拉格查爾",
            "gyd": "圭亞那元",
            "hkd": "港元",
            "hnl": "洪都拉斯倫皮拉",
            "hrk": "克羅埃西亞庫納",
            "htg": "海地古德",
            "huf": "匈牙利福林",
            "idr": "印尼盾",
            "ils": "以色列謝克爾",
            "inr": "印度盧比",
            "iqd": "伊拉克第納爾",
            "irr": "伊朗里亞爾",
            "isk": "冰島克朗",
            "jmd": "牙買加元",
            "jod": "約旦第納爾",
            "jpy": "日元",
            "kes": "肯尼亞先令",
            "kgs": "吉爾吉斯索姆",
            "khr": "柬埔寨瑞爾",
            "kmf": "葛摩法郎",
            "kpw": "朝鮮圓",
            "krw": "韓圜",
            "kwd": "科威特第納爾",
            "kyd": "開曼元",
            "kzt": "哈薩克堅戈",
            "lak": "老撾基普",
            "lbp": "黎巴嫩鎊",
            "lkr": "斯里蘭卡盧比",
            "lrd": "利比里亞元",
            "lsl": "萊索托洛蒂",
            "lvl": "拉脫維亞拉特",
            "lyd": "利比亞第納爾",
            "mad": "摩洛哥迪拉姆",
            "mdl": "摩爾多瓦列伊",
            "mga": "馬達加斯加阿里亞里",
            "mkd": "馬其頓第納爾",
            "mmk": "緬甸元",
            "mnt": "蒙古圖格里克",
            "mop": "澳門元",
            "mro": "毛里塔尼亞烏吉亞",
            "mur": "毛里求斯盧比",
            "mvr": "馬爾代夫盧比",
            "mwk": "馬拉維克瓦查",
            "mxn": "墨西哥比索",
            "myr": "馬來西亞幣",
            "mzn": "莫三比克梅蒂卡爾",
            "nad": "納米比亞元",
            "ngn": "尼日利亞奈拉",
            "nio": "尼加拉瓜金科多巴",
            "nok": "挪威克朗",
            "npr": "尼泊爾盧比",
            "nzd": "新西蘭元",
            "omr": "阿曼里亞爾",
            "pab": "巴拿馬巴波亞",
            "pen": "秘魯新索爾",
            "pgk": "巴布亞基納",
            "php": "菲律賓比索",
            "pkr": "巴基斯坦盧比",
            "pln": "波蘭茲羅提",
            "pyg": "巴拉圭瓜拉尼",
            "qar": "卡塔爾里亞爾",
            "rmb": "人民幣",
            "ron": "羅馬尼亞列伊",
            "rsd": "塞爾維亞第納爾",
            "rub": "俄羅斯盧布",
            "rwf": "盧旺達法郎",
            "sar": "沙特里亞爾",
            "sbd": "所羅門群島元",
            "scr": "塞舌爾盧比",
            "sdg": "蘇丹第納爾",
            "sek": "瑞典克朗",
            "sgd": "星加坡元",
            "shp": "聖赫勒拿群島鎊",
            "sll": "塞拉利昂 利昂",
            "sos": "索馬利亞先令",
            "srd": "蘇利南元",
            "std": "圣多美和普林西比多布拉",
            "syp": "敘利亞鎊",
            "szl": "斯威士蘭 里蘭吉尼",
            "thb": "泰國銖",
            "tjs": "塔吉克共和國 索莫尼",
            "tmt": "土庫曼斯坦馬納特",
            "tnd": "突尼斯第納爾",
            "top": "湯加潘加",
            "try": "土耳其里拉",
            "ttd": "特立尼達和多巴哥元",
            "twd": "新臺幣",
            "tzs": "坦桑尼亞先令",
            "uah": "烏克蘭格里夫納",
            "ugx": "烏干達先令",
            "usd": "美元",
            "uyu": "烏拉圭比索",
            "uzs": "烏茲別克斯坦索姆",
            "vef": "委內瑞拉玻利瓦爾",
            "vnd": "越南盾",
            "vuv": "瓦努阿圖瓦圖",
            "wst": "薩摩亞塔拉",
            "xaf": "中非共同體法郎",
            "xcd": "東加勒比元",
            "xdr": "國際貨幣基金組織特別提款權",
            "xof": "西非國家中央銀行非洲法郎",
            "xpf": "太平洋法郎",
            "yer": "也門里亞爾",
            "zar": "南非蘭特",
            "zmw": "尚比亞克瓦查"
        },
        "shop-currency-rate": {
            "rate-last-updated-x-days-ago": "匯率{time}日前更新",
            "rate-last-updated-x-hours-ago": "匯率{time}小時前更新"
        },
        "hyperair": {
            "copyright-footer": "© 2018 HyperAir Incorporation Limited. 版權所有",
            "today": "今日"
        },
        "product-simcard": {
            "shipping-methods": {
                "hkpost": "平郵（免費）",
                "international": "跨國運送",
                "sf": "順豐速遞 （只限香港，貨到付運費。訂單滿HK$399，即可免運費）"
            }
        },
        "country": {
            "afghanistan": "阿富汗",
            "aland-islands": "奧蘭群島",
            "albania": "阿爾巴尼亞",
            "algeria": "阿爾及利亞",
            "andorra": "安道爾",
            "angola": "安哥拉",
            "anguilla": "安圭拉",
            "antigua-&-barbuda": "安提瓜和巴布達",
            "antigua-barbuda": "安地卡及巴布達",
            "argentina": "阿根廷",
            "armenia": "阿美尼亞",
            "aruba": "阿魯巴",
            "australia": "澳洲",
            "austria": "奧地利",
            "azerbaijan": "阿塞拜疆",
            "azores": "亞速爾群島",
            "bahamas": "巴哈馬",
            "bahrain": "巴林",
            "bangladesh": "孟加拉國",
            "barbados": "巴巴多斯",
            "belarus": "白俄羅斯",
            "belgium": "比利時",
            "belize": "伯利茲",
            "benin": "貝寧",
            "bermuda": "百慕達",
            "bhutan": "不丹",
            "bolivia": "玻利維亞",
            "bonaire": "博奈爾",
            "bosnia-herzegovina": "波斯尼亞和黑塞哥維那",
            "botswana": "博茨瓦納",
            "brazil": "巴西",
            "british-virgin-islands": "英屬維爾京群島",
            "brunei": "文萊",
            "bulgaria": "保加利亞",
            "burkina-faso": "布基納法索",
            "burundi": "布隆迪",
            "cambodia": "柬埔寨",
            "cameroon": "喀麥隆",
            "canada": "加拿大",
            "canary-islands": "加那利群島",
            "cape-verde-islands": "佛得角群島",
            "cayman-islands": "開曼群島",
            "central-african-republic": "中非共和國",
            "chad": "乍得",
            "chile": "智利",
            "china": "中國",
            "colombia": "哥倫比亞",
            "comoros": "科摩羅",
            "congo": "剛果",
            "cook-islands": "庫克群島",
            "costa-rica": "哥斯達黎加",
            "cote-d-ivoire": "科特迪瓦科特迪瓦",
            "croatia": "克羅地亞",
            "cruise-ship": "遊輪",
            "cuba": "古巴",
            "curacao": "庫拉索",
            "cyprus": "塞浦路斯",
            "cyprus---north": "塞浦路斯",
            "cyprus---south": "塞浦路斯",
            "czech-republic": "捷克共和國",
            "denmark": "丹麥",
            "djibouti": "吉布提",
            "dominica": "多米尼加",
            "dominican-republic": "多明尼加共和國",
            "dubai": "杜拜",
            "easter-island": "復活節島",
            "ecuador": "厄瓜多爾",
            "egypt": "埃及",
            "el-salvador": "薩爾瓦多",
            "equatorial-guinea": "赤道幾內亞",
            "eritrea": "厄立特里亞",
            "estonia": "愛沙尼亞",
            "ethiopia": "埃塞俄比亞",
            "europe": "歐洲",
            "falkland-islands": "福克蘭群島",
            "faroe-islands": "法羅群島",
            "fiji": "斐濟",
            "finland": "芬蘭",
            "france": "法國",
            "french-guiana": "法屬圭亞那",
            "french-polynesia": "法屬波利尼西亞",
            "french-west-indies": "法屬西印度群島",
            "gabon": "加蓬",
            "gambia": "岡比亞",
            "georgia": "格魯吉亞",
            "germany": "德國",
            "ghana": "加納",
            "gibraltar": "直布羅陀",
            "greece": "希臘",
            "greenland": "格陵蘭",
            "grenada": "格林納達",
            "guadeloupe": "瓜德羅普島",
            "guam": "關島",
            "guatemala": "危地馬拉",
            "guernsey": "根西島",
            "guinea": "幾內亞",
            "guinea---bissau": "幾內亞比紹",
            "guinea-bissau": "幾內亞比紹",
            "guyana": "圭亞那",
            "haiti": "海地",
            "honduras": "洪都拉斯",
            "hong-kong": "香港",
            "hungary": "匈牙利",
            "iceland": "冰島",
            "india": "印度",
            "indonesia": "印尼",
            "iran": "伊朗",
            "iraq": "伊拉克",
            "ireland": "愛爾蘭",
            "isle-of-man": "馬恩島",
            "israel": "以色列",
            "italy": "意大利",
            "jamaica": "牙買加",
            "japan": "日本",
            "jersey": "澤西",
            "jordan": "約旦",
            "kazakhstan": "哈薩克斯坦",
            "kenya": "肯尼亞",
            "kiribati": "基里巴斯",
            "kosovo": "科索沃",
            "kuwait": "科威特",
            "kyrgyz-republic": "吉爾吉斯共和國",
            "kyrgyzstan": "吉爾吉斯斯坦",
            "laos": "老撾",
            "latvia": "拉脫維亞",
            "lebanon": "黎巴嫩",
            "lesotho": "萊索托",
            "liberia": "利比里亞",
            "libya": "利比亞",
            "liechtenstein": "列支敦士登",
            "lithuania": "立陶宛",
            "luxembourg": "盧森堡",
            "macau": "澳門",
            "macedonia": "馬其頓",
            "madagascar": "馬達加斯加",
            "madeira": "馬德拉",
            "malawi": "馬拉維",
            "malaysia": "馬來西亞",
            "maldives": "馬爾代夫",
            "mali": "馬里",
            "malta": "馬耳他",
            "marshall-islands": "馬紹爾群島",
            "martinique": "馬提尼克",
            "mauritania": "毛里塔尼亞",
            "mauritius": "毛里求斯",
            "mayotte": "馬約特",
            "mexico": "墨西哥",
            "micronesia": "密克羅尼西亞",
            "moldova": "摩爾多瓦",
            "monaco": "摩納哥",
            "mongolia": "蒙古",
            "montenegro": "黑山",
            "montserrat": "蒙特塞拉特",
            "morocco": "摩洛哥",
            "mozambique": "莫桑比克",
            "myanmar": "緬甸",
            "namibia": "納米比亞",
            "nauru": "瑙魯",
            "nepal": "尼泊爾",
            "netherlands": "荷蘭",
            "netherlands-antilles": "荷屬安的列斯",
            "new-caledonia": "新喀裡多尼亞",
            "new-zealand": "紐西蘭",
            "nicaragua": "尼加拉瓜",
            "niger": "尼日爾",
            "nigeria": "尼日利亞",
            "niue": "紐埃",
            "norfolk-islands": "諾福克群島",
            "north-korea": "北朝鮮",
            "northern-marianas": "北馬里亞納",
            "norway": "挪威",
            "oman": "阿曼",
            "pakistan": "巴基斯坦",
            "palau": "帕勞",
            "palestine": "巴勒斯坦",
            "panama": "巴拿馬",
            "papua-new-guinea": "巴布亞新幾內亞",
            "paraguay": "巴拉圭",
            "peru": "秘魯",
            "philippines": "菲律賓",
            "poland": "波蘭",
            "portugal": "葡萄牙",
            "puerto-rico": "波多黎各",
            "qatar": "卡塔爾",
            "reunion": "留尼旺",
            "romania": "羅馬尼亞",
            "russia": "俄羅斯",
            "rwanda": "盧旺達",
            "saint-barthelemy": "聖巴托洛繆島",
            "saint-martin": "聖馬丁",
            "saint-pierre-&-miquelon": "聖皮埃爾和密克隆",
            "samoa": "薩摩亞",
            "san-marino": "聖馬力諾",
            "sao-tome-&-principe": "聖多美和普林西比",
            "sao-tome-principe": "聖多美普林西比",
            "satellite": "衛星",
            "saudi-arabia": "沙特阿拉伯",
            "senegal": "塞內加爾",
            "serbia": "塞爾維亞",
            "seychelles": "塞舌爾",
            "sierra-leone": "塞拉利昂",
            "singapore": "新加坡",
            "slovak-republic": "斯洛伐克共和國",
            "slovakia": "斯洛伐克",
            "slovenia": "斯洛文尼亞",
            "solomon-islands": "所羅門群島",
            "somalia": "索馬里",
            "south-africa": "南非",
            "south-korea": "韓國",
            "spain": "西班牙",
            "sri-lanka": "斯里蘭卡",
            "st-helena": "聖赫倫那",
            "st-kitts": "聖克里斯多福島",
            "st-kitts-&-nevis": "聖基茨和尼維斯",
            "st-lucia": "聖盧西亞",
            "st-vincent": "聖文森特",
            "st.-helena": "聖海倫娜",
            "st.-kitts": "聖基茨",
            "st.-lucia": "聖盧西亞",
            "sudan": "蘇丹",
            "suriname": "蘇里南",
            "swaziland": "斯威士蘭",
            "sweden": "瑞典",
            "switzerland": "瑞士",
            "syria": "敘利亞",
            "taiwan": "台灣",
            "tajikistan": "塔吉克斯坦",
            "tanzania": "坦桑尼亞",
            "thailand": "泰國",
            "timor-l'este": "東帝汶埃斯特",
            "togo": "多哥",
            "tonga": "湯加",
            "trinidad-&-tobago": "特立尼達和多巴哥",
            "trinidad-tobago": "千里達及托巴哥",
            "tunisia": "突尼斯",
            "turkey": "土耳其",
            "turkmenistan": "土庫曼斯坦",
            "turks-&-caicos": "特克斯和凱科斯群島",
            "turks-&-caicos-islands": "特克斯和凱科斯群島",
            "turks-caicos-islands": "土克凱可群島",
            "uganda": "烏干達",
            "ukraine": "烏克蘭",
            "united-arab-emirates": "阿拉伯聯合酋長國",
            "united-kingdom": "英國",
            "united-states": "美國",
            "united-states-minor-outlying-islands": "美國本土外小島嶼",
            "uruguay": "烏拉圭",
            "uzbekistan": "烏茲別克斯坦",
            "vanuatu": "瓦努阿圖",
            "vatican-city": "梵蒂岡城",
            "venezuela": "委內瑞拉",
            "vietnam": "越南",
            "virgin-islands": "維爾京群島",
            "virgin-islands-(us)": "維爾京群島（美國）",
            "wallis-&-futuna": "瓦利斯和富圖納",
            "wallis-futuna": "瓦利斯和富圖納",
            "yemen": "也門",
            "zambia": "贊比亞",
            "zimbabwe": "津巴布韋"
        },
        "inspiration": {
            "published-date": "Y年n月",
            "published-duration": "{duration}日前",
            "published-duration-singular": "昨天",
            "published-duration-today": "今天"
        },
        "promotion-center": {
            "expires-at": "有效期至",
            "redeem": {
                "error": {
                    "already-redeemed": "已兌換優惠劵",
                    "new-customer-only": "此優惠只適用於新客戶",
                    "not-found": "優惠碼無效"
                }
            }
        },
        "auth": {
            "failed": "",
            "throttle": ""
        },
        "web": {
            "activity": {
                "countdown-title": "",
                "more-button": "更多玩樂體驗",
                "section-subtitle": "幫您比較各個網站，搵最正最抵嘅玩樂體驗",
                "section-title": "玩樂體驗價格比較"
            },
            "checkout": {
                "use-promo-code": "使用優惠券"
            },
            "checkout-failed": {
                "checkout-failed": "Payment Failed, please try again later"
            },
            "checkout-success": {
                "checkout-success": "付款成功",
                "continue-shopping-button": "繼續瀏覽",
                "done-button": "搞掂👌🏻",
                "download-now": "立即下載",
                "order-number": "訂單編號",
                "register-email": "你嘅電郵",
                "register-password": "設定密碼",
                "sim-product": "你已成功購買<span class=\"bold\"> {sim} </span>，電郵確認訂單將發送至 {email}。",
                "slogan": "立即打開 HyperAir app，盡享玩樂禮遇！仲可以即刻喺App到追蹤訂單。",
                "slogan-password": "還有一步，即享$10迎新SIM卡優惠！仲可以即刻喺App到追蹤訂單。",
                "trace-order": "",
                "trace-order-password": "",
                "welcome-offer": "仲差一步，註冊即享$10迎新SIM卡獎賞！仲可以即喺App度追蹤嘅訂單。"
            },
            "country": {
                "all": "所有",
                "contact-us-description": "如有任何疑問，歡迎發送電郵到<a href=\"mailto:corporate@hyperair.com\\>corporate@hyperair.com</a>查詢",
                "data": "數據流量：",
                "day": "日數：",
                "day-day": "日",
                "esim": "eSIM",
                "esim-section-title": "為你搜羅{country}嘅旅遊 eSIM",
                "num-of-review": "{num}-of-review個旅客評分",
                "per-day": "每日",
                "phone-call": "當地通話",
                "plug-n-go": "即插即用",
                "plug-n-go-esim": "即買即用",
                "plug-n-go-sim": "即插即用",
                "section-title": "為你搜羅{country}嘅旅遊 SIM",
                "section-title copy": "為你搜羅{country}最正嘅旅遊 SIM",
                "sim": "SIM",
                "supplier": "網絡商："
            },
            "download-app-banner": {
                "download-now": "立即下載 App",
                "hyperair": "HyperAir",
                "subtitle": "下載 HyperAir 應用程式並首次登記，即享 HK$10 優惠迎新禮遇！",
                "title": "隨時隨地 醒目旅遊"
            },
            "email-subscription": {
                "cancel-button": "再諗一諗",
                "completed-subscribe": "多謝你嘅訂閱",
                "confirm-button": "我要最抵優惠",
                "duplicate-email": "你的電郵已經訂閱了",
                "invalid-email": "無效或錯誤的電郵地址",
                "title-1": "想Staycation價格跌至新低時通知你？",
                "title-2": "仲搜羅全城最抵既Staycation 及美食套餐優惠"
            },
            "fanfare": {
                "cover-title": "SIM卡 Fanfares",
                "datetime-format": "n月d日",
                "end-next-fanfare": "下次開售時間:",
                "end-title": "想知SIM卡優惠嘅開售時間及更多超筍玩樂優惠? 立即下載同follow我哋嘅APP及社交平台啦！",
                "end-title2": "想知更多超筍玩樂優惠? 立即下載同follow我哋嘅APP及社交平台啦！",
                "more-details-button": "優惠詳情",
                "out-of-stock": "返貨中",
                "popular-countries-subtitle": "免費平郵，極速送到",
                "popular-countries-title": "熱門 SIM 卡目的地",
                "section-title": "多款 SIM 卡以超優惠價發售",
                "title": "限時優惠 限量特價",
                "x-inventory-left": "最後{inventory}張"
            },
            "fanfare-breadcrumb": "SIM卡 Fanfares",
            "filter-button": {
                "filter": "篩選"
            },
            "filter-container": {
                "apply": "篩選",
                "category": "分類",
                "category-aquarium": "水族館",
                "category-class": "課程",
                "category-day-tour": "半日+一日遊",
                "category-discount": "優惠",
                "category-diving": "潛水",
                "category-food": "美食",
                "category-massage-beauty": "按摩及美容",
                "category-museum": "博物館",
                "category-musical": "音樂劇",
                "category-outlet": "Outlet",
                "category-photography": "攝影",
                "category-playground": "遊樂場",
                "category-railway": "鐵路",
                "category-show": "表演",
                "category-ski": "滑雪",
                "category-spa": "溫泉",
                "category-theme-park": "樂園",
                "category-ticket": "門票",
                "category-transport": "接送+包車",
                "category-transport-ticket": "車票",
                "category-vr": "VR",
                "category-water-park": "水上樂園",
                "category-yoga": "瑜伽",
                "category-zoo": "動物園",
                "clear-all": "重設",
                "facilities": "設施及套餐特點",
                "filter": "篩選",
                "food": "飲食",
                "header": "篩選",
                "popular-search": "人氣搜尋🔥",
                "price": "價格",
                "provider": "旅遊平台",
                "subcategory-buffet": "自助餐",
                "subcategory-car": "包車",
                "subcategory-facial": "美容",
                "subcategory-food": "美食",
                "subcategory-half-day-tour": "半日遊",
                "subcategory-massage": "按摩",
                "subcategory-meal-voucher": "餐券",
                "subcategory-one-day-tour": "一日遊",
                "subcategory-restaurant": "餐廳",
                "subcategory-transport": "接送",
                "tag": "主題"
            },
            "footer": {
                "about-hyperair-description": "HyperAir 係一間旅遊科技初創，旨在為旅行愛好者提供最醒目嘅方式去準備和享受旅行。",
                "download-now": "立即下載",
                "email-subscription-button": "立即訂閱",
                "email-subscription-placeholder": "輸入你的電郵",
                "email-subscription-social-title": "或立即追蹤我地既社交平台",
                "email-subscription-title": "想知更多 Staycation 優惠嘅<br />開售時間及更多超筍玩樂優惠?",
                "travel-license": "旅行代理商牌照號碼："
            },
            "fx-booking": {
                "back-button": "更改訂單",
                "confirm-booking": "核對資料",
                "confirm-button": "確認訂單",
                "contact-shop": "如果您無法準時到達，請致電兌換店或取消訂單。",
                "get-money-before": "請於以下時間前提取。"
            },
            "home": {
                "cover-button": "立即體驗",
                "cover-subtitle": "從 HyperAir 開始",
                "cover-title": "一次過，比較全球多個玩樂旅遊預訂網站",
                "grid": {
                    "1": {
                        "subtitle": "最HIT旅遊情報",
                        "title": "愛貓之城伊斯坦堡 歷史大教堂有守護貓"
                    },
                    "2": {
                        "subtitle": "最HIT旅遊情報",
                        "title": "東京奧運，最後倒數"
                    },
                    "3": {
                        "subtitle": "最抵之選",
                        "title": "網上SIM卡至低價保證"
                    },
                    "4": {
                        "subtitle": "限時優惠 限量特價",
                        "title": "SIM 卡 Fanfares"
                    },
                    "5": {
                        "subtitle": "必追景點",
                        "title": "願原力與你同在！迪士尼星戰園區現已開幕"
                    }
                },
                "home-example": {
                    "column-subtitle-1": "以2人日本7日遊為例：",
                    "column-subtitle-2": "價格比較",
                    "column-title-1": "一次旅行，同你慳到盡",
                    "column-title-2": "比較多間國際旅遊平台",
                    "hotel": "酒店優惠",
                    "hotel-package-1": "大阪日航酒店7日6夜",
                    "insurance": "旅遊保險",
                    "insurance-package-1": "7天旅遊保險 x2",
                    "money": "外幣兌換",
                    "money-package-1": "唱JPD ¥ 410,000",
                    "save": "慳",
                    "sim": "上網SIM卡",
                    "sim-package-1": "日本7天DoCoMo SIM x2",
                    "slogan": "逐樣格，逐樣慳，先至係識玩！",
                    "total-saving": "一共慳 $ 1,443",
                    "travel-experience": "玩樂體驗",
                    "travel-experience-package-1": "JR Pass 全日本鐵路通票 x2",
                    "travel-experience-package-2": "日本環球影城™ 1日電子門票 x2"
                },
                "media-header-title": "媒體報導",
                "more": "更多旅遊 SIM",
                "partners-title": "合作夥伴",
                "photo-banner-button": "了解更多",
                "photo-banner-title": "唱錢神器™助您輕鬆搜尋預訂最抵匯率，唱錢快又醒!",
                "services-header-description": "",
                "services-header-title": "一站式旅遊服務",
                "services-icon-subtitle-1": "助您輕鬆搜尋預訂最抵匯率，唱錢快又醒!",
                "services-icon-subtitle-2": "為您提供多款勁抵價SIM卡，免運費送上門！",
                "services-icon-subtitle-3": "讓您探索世界，從此自主旅遊！",
                "services-icon-title-1": "唱錢神器",
                "services-icon-title-2": "旅遊SIM卡",
                "services-icon-title-3": "旅遊體驗",
                "statistic": {
                    "num-of-city": "幫用戶慳咗",
                    "num-of-comparison": "玩樂體驗",
                    "num-of-experience": "國家城市",
                    "num-of-saving": "格價次數"
                },
                "testimonial-1-content": "呢個app很好用，方便比較滙率，唔駛周圍去揾資料。很欣賞程式員佢地既用心製作，佢地都積極用心為我解決使用時的困難。推薦使用！",
                "testimonial-1-subtitle": "Android 用家",
                "testimonial-1-user": "Christine Lam",
                "testimonial-2-content": "好方便，訂SIM卡好快就送到，唔洗特登出街買SIM卡，價錢都好平吓。網絡收得幾好，上次去日本喺市區同近郊玩都好流暢！下次會再買！",
                "testimonial-2-subtitle": "iOS 用家",
                "testimonial-2-user": "Angel",
                "testimonial-header-description": "",
                "testimonial-header-title": "用家分享",
                "travel-activities": {
                    "home-slogan": "幫您比較各個網站，搵最正最抵嘅玩樂體驗"
                },
                "travel-country-header-description": "清晰分類，容易挑選",
                "travel-country-header-title": "旅遊 SIM 涵蓋 200+ 國家",
                "travel-info-header-description": "為你帶來最 Hit 旅遊靈感",
                "travel-info-header-title": "旅遊情報",
                "travel-marketplace-header-description": "",
                "travel-marketplace-header-title": "",
                "travel-sim-header-description": "勁抵價SIM卡 免費送上門",
                "travel-sim-header-title": "熱門旅遊 SIM"
            },
            "hotel": {
                "cover-subtitle": "HyperAir 客戶專享 5% Trip.com 獨家酒店折扣",
                "cover-title": "酒店優惠",
                "discount-detail": "使用 “HYPERAIR5” 優惠碼可享5%折扣",
                "discount-title": "HYPERAIR5",
                "highlight-subtitle1": "探索遍佈全球嘅酒店，為您提供與眾不同嘅住宿體驗。",
                "highlight-subtitle2": "獨家超值訂房優惠，為您省下更多旅費。",
                "highlight-subtitle3": "即時網上查看酒店價格詳情 ，全天候一按預訂。",
                "highlight-title1": "覆蓋全球",
                "highlight-title2": "優惠價格",
                "highlight-title3": "一覧無遺"
            },
            "hypermiles": {
                "activity": "項目",
                "balance": "結餘",
                "benefit": "你的會員禮遇包括:",
                "cumulative-purchase": "累積消費：HK$ {amount}",
                "diamond-black": "鑽石黑",
                "expire": "已過期的HyperMiles ({date})",
                "expire-reminder-1": "HyperMiles 於購物月份起計一年內有效",
                "expire-reminder-2": "記得到期前用嚟買嘢啦！",
                "hypermiles-total": "HyperMiles",
                "member": "會籍",
                "member-tier": "你已經成為 HyperAir {member_tier}會員。",
                "membership-details": "詳細級別",
                "next-purchase": "下次消費可即減 HK${amount}",
                "order-num": "訂單編號: {order_num}",
                "permanent-membership": "永久免費會籍",
                "popup-title": "HyperMiles 獎賞計劃",
                "precious-platinum": "尊鉑白",
                "product_purchase": "購物賺取的HyperMiles ({date})",
                "record": "HyperMiles 紀錄",
                "royal-blue": "貴族藍",
                "simcard_purchase": "買SIM卡賺取的HyperMiles ({date})",
                "tier": "",
                "title": "HyperMiles。 自主旅遊，豐富回贈！",
                "u-have": "你擁有",
                "usage": "使用HyperMiles ({date})",
                "what-is-hypermiles": "甚麼是 HyperMiles",
                "what-is-hypermiles-slogan1": "消費越多，獎賞越多",
                "what-is-hypermiles-slogan2": "每100 HyperMiles 即可購物時抵銷HK$1 ，無最低消費限制",
                "what-is-hypermiles-slogan3": "累積消費越多，更易賺取 HyperMiles"
            },
            "hypermiles-disclaimer": "優惠受條款及細則約束",
            "hypermiles-discount-diamond-black": "每消費滿 HK$1 賺取 1 HyperMiles",
            "hypermiles-discount-precious-platinum": "每消費滿 HK$1.5 賺取 1 HyperMiles",
            "hypermiles-discount-royal-blue": "每消費滿 HK$2 賺取 1 HyperMiles",
            "hypermiles-special-diamond-black": "優先獲得獨家優惠",
            "hypermiles-spend-diamond-black": "累積消費滿HK$3,000",
            "hypermiles-spend-precious-platinum": "累積消費滿HK$1,500",
            "hypermiles-spend-royal-blue": "基本會員",
            "login": {
                "email": "電郵",
                "existing-user": "現有用戶",
                "forgot-password": "忘記密碼",
                "forgot-password-please-fill-in-email": "Enter your email and we'll send you a link to get back into your account.",
                "login": "登入",
                "login-with-facebook": "Facebook 繼續",
                "login-with-google": "Google 繼續",
                "new-user": "新用戶",
                "or": "或",
                "password": "密碼",
                "phone-input-placeholder": "輸入你的電話",
                "phone-input-title": "我們需要你的電話號碼，進行SMS認證。",
                "phone-verify": "電話認證",
                "resend-verification-code": "30秒後重新發送",
                "reset-password": "重設密碼",
                "title": "登入",
                "verification-code-input-title": "請輸入你的6位數字認證碼"
            },
            "logo-loader": {
                "slogan": "幫緊你，幫緊你"
            },
            "my-order": {
                "amount": "金額",
                "esim-qrcode": "eSIM碼",
                "fx-status-cancelled": "已取消",
                "fx-status-confirmed": "已確認",
                "order-date": "落單日期",
                "order-details": "訂單詳情",
                "order-num": "訂單編號",
                "status-confirmed": "已寄出",
                "status-pending-confirmation": "準備寄出",
                "status-ready-to-ship": "準備寄出",
                "status-shipped": "已寄出"
            },
            "my-order-details": {
                "delivery-info": "物流資料",
                "discount": "折扣",
                "recipient-address": "地址",
                "recipient-email": "電郵",
                "recipient-name": "收件人名稱",
                "recipient-tel": "收件人聯絡電話",
                "shipping-method": "物流方式",
                "status": "狀態",
                "total": "總額",
                "valid-date": "完成日期"
            },
            "nav": {
                "about-us": "關於我們",
                "car": "租車",
                "company": "公司",
                "company-address": "地址：香港數碼港3期3樓企業發展中心",
                "contact-us": "聯絡我們",
                "contact-us-description": "如有任何疑問，歡迎發送電郵到<a href=\"mailto:hello@hyperair.com\">hello@hyperair.com</a>查詢",
                "disclaimer": "免責聲明",
                "download-app": "下載 App",
                "flight": "機票",
                "foodie": "美食優惠",
                "home": "首頁",
                "hotel": "酒店",
                "jobs": "請人",
                "logout": "登出",
                "media-coverage": "媒體報導",
                "monthly-rental-hotel": "短租及月租酒店",
                "privacy-policy": "私隱政策",
                "promo-banner-text": "HyperAir 客戶專享 5% Trip.com 獨家酒店折扣",
                "quarantine-hotel": "回港長住酒店",
                "refund-policy": "退改政策",
                "spa-and-beauty": "Spa and Beauty",
                "staycation": "Staycation",
                "tag-line": "玩樂旅遊 ‧ 搜尋格價",
                "terms-of-service": "服務條款",
                "travel-activity": "旅遊體驗",
                "travel-affiliate-codes": "折扣優惠券",
                "travel-affiliate-codes-md": "折扣優惠券",
                "travel-blog": "Blog",
                "travel-experience-d": "玩樂門票",
                "travel-experience-md": "玩樂門票",
                "travel-insurance": "旅遊保險",
                "travel-insurance-md": "旅遊保險",
                "travel-marketplace": "玩樂潮物",
                "travel-marketplace-md": "玩樂潮物",
                "travel-money": "唱錢神器",
                "travel-money-md": "唱錢神器",
                "travel-sim": "旅遊 SIM",
                "travel-sim-md": "旅遊 SIM"
            },
            "photo-banner": {
                "banner-button": ""
            },
            "product-card": {
                "num-of-review": "{num}-of-review則評價"
            },
            "redirection-gate": {
                "columns-1-description": "幫您比較各個網站，搵最正最抵嘅玩樂體驗",
                "columns-1-title": "玩樂格價",
                "columns-2-description": "多款勁抵價SIM卡，免運費送上門！",
                "columns-2-title": "旅遊SIM卡",
                "columns-3-description": "助你輕鬆搜尋預訂最抵匯率",
                "columns-3-title": "唱錢神器",
                "promo-code": "優惠碼",
                "remember-to-fill-promo-code": "記得結帳嘅時候輸入以上優惠碼",
                "title": "傳送門正將你送到 {domain}",
                "trouble-link": "如果您的瀏覽器未能於10秒內重新導向，請您點擊此<a href=\"{link}\">連結</a>"
            },
            "register": {
                "guest-checkout": "繼續以訪客結帳",
                "title": "註冊"
            },
            "seo": {
                "best-price-guarantee-title": "最低價保證",
                "country-description": "{country}旅遊SIM，多款勁抵價SIM卡，免運費送上門，準備旅程快又醒！",
                "country-keywords": "SIM卡,上網卡,電話卡,數據卡,DataSIM,旅遊DataSIM,數據咭,4G上網卡,上網卡,4G上網卡,日本4G上網卡,日本上網卡,東京4G上網卡,東京上網卡,大阪4G上網卡,大阪上網卡,泰國4G上網卡,泰國上網卡,曼谷4G上網卡,布吉上網卡,芭提雅4G上網卡,台灣4G上網卡,台灣上網卡,台北4G上網卡,高雄上網卡,台中4G上網卡,台中上網卡,韓國4G上網卡,韓國上網卡,首爾4G上網卡,首爾上網卡,中國4G上網卡,中國上網卡,深圳4G上網卡,深圳上網卡,澳門4G上網卡,澳門上網卡, Docomo, Softbank",
                "country-title": "{country}旅遊SIM卡 - 勁抵價，免運費送上門",
                "home-description": "HyperAir係一間旅遊科技初創公司，打造一個能夠了解用家喜好嘅旅遊平台，提供最合適同埋物超所值嘅旅遊方案，令旅行愛好者可以一站式咁瀏覽預訂，隨時隨地醒目旅遊！",
                "home-keywords": "sim卡,上網卡,電話卡,數據卡,DataSIM,旅遊DataSIM,數據咭,4G上網卡,上網卡,4G上網卡,SIM卡,Travel SIM,旅遊SIM卡,唱錢神器,唱X神器,唱錢X器,唱錢,唱錢app,兌換,找換,兌換店,找換店,銀行,金融,外匯,外滙,匯率,滙率,匯款,外幣,貨幣,旅行,旅遊,行程,酒店,機票,比較,格價,特價,預訂,交易,旅遊保險,日本,泰國,韓國,台灣,日圓,日元,台幣,泰銖,HyperAir,HyperAir FX,HyperAir Travel,Travel,Travel Money,Foreign Currency,Foreign Exchange,百年,堅成,發達鳥,飛鳥,richbird,crazy bird,berlin exchange",
                "home-title": "HyperAir - 玩樂旅遊必備搜尋比較平台 | 玩樂體驗、酒店優惠、上網SIM卡、唱錢神器、旅遊保險",
                "hotel-description": "透過HyperAir網站，可享預訂酒店額外折扣優惠",
                "hotel-keywords": "酒店預訂, 酒店訂房, 預訂, 訂房, 亞洲地區, 歐洲地區, 美洲地區, 泰國, 曼谷, 美國, 中國, 上海, 日本, 東京, 馬來西亞, 新加坡, 韓國, 加拿大, 英國, 荷蘭, 法國, 紐西蘭, 澳洲, 優惠價格, 酒店評論,網路預訂, 地圖, 渡假村, 度假村",
                "hotel-title": "酒店優惠",
                "money-exchange-description": "查看{shop_name}的最新匯率，並且網上預訂，可以即時鎖定匯率及預留貨幣！",
                "money-exchange-keywords": "{shop_name}, 唱錢神器, 唱X神器, 唱錢X器, 唱錢, 兌換, 找換, 兌換店, 找換店, 銀行, 金融, 外匯, 外滙, 匯率, 滙率, 匯款, 外幣, 貨幣, 旅行, 旅遊, 行程, 酒店, 機票, 比較, 格價, 特價, 預訂, 交易, 旅遊保險, 日本, 泰國, 韓國, 台灣, 日圓, 日元, 台幣, 泰銖, HyperAir, HyperAir FX, HyperAir Travel, Travel, Travel Money, Foreign Currency, Foreign Exchange, 百年, 堅成, 發達鳥, 飛鳥, richbird, crazy bird, berlin exchange",
                "money-exchange-title": "{shop_name} 最新外幣匯率 即時預訂外幣 | 唱錢神器 唱錢快又醒 | 每日更新兌換匯率",
                "privacy-policy-title": "私隱政策",
                "refund-policy-title": "退改政策",
                "sim-fanfares-description": "全港首個SIM卡Fanfares已經登陸 HyperAir 啦！熱賣 SIM 卡低至5折發售，限時優惠，限量特價！",
                "sim-fanfares-keywords": "fanfares,SIM卡,上網卡,電話卡,數據卡,DataSIM,旅遊DataSIM,數據咭,4G上網卡,上網卡,4G上網卡,日本4G上網卡,日本上網卡,東京4G上網卡,東京上網卡,大阪4G上網卡,大阪上網卡,泰國4G上網卡,泰國上網卡,曼谷4G上網卡,布吉上網卡,芭提雅4G上網卡,台灣4G上網卡,台灣上網卡,台北4G上網卡,高雄上網卡,台中4G上網卡,台中上網卡,韓國4G上網卡,韓國上網卡,首爾4G上網卡,首爾上網卡,中國4G上網卡,中國上網卡,深圳4G上網卡,深圳上網卡,澳門4G上網卡,澳門上網卡, Docomo, Softbank",
                "sim-fanfares-title": "SIM 卡 Fanfares - 限時優惠 限量特價",
                "term-of-service-title": "服務條款",
                "travel-activity-search-results-description": "立即格價，取得{activity}的最佳優惠，節省更多！在HyperAir.com可以找到最抵的活動，一次過比較熱門玩樂體驗的旅遊網站。",
                "travel-activity-search-results-keywords": "{activity}, 旅遊, 旅遊體驗, 旅遊活動, 玩樂, 自由行, 一日遊, 景點, 門票, 交通",
                "travel-activity-search-results-title": "HyperAir - {city}嘅搜尋結果",
                "travel-affiliate-codes-description": "HyperAir 為你持續更新 2023 最新優惠碼，輕鬆獲得折扣碼享受酒店優惠、機票優惠、門票車票優惠、旅遊保險優惠、SIM卡優惠及信用卡優惠。",
                "travel-affiliate-codes-keywords": "優惠代碼,電子優惠券,折扣碼,Promotion,Promo Code,Discount Code,酒店,機票,優惠,信用卡優惠,旅遊優惠",
                "travel-affiliate-codes-title": "2023 最新！玩樂旅遊優惠碼（每日更新） | 折扣預訂酒店、機票、玩樂體驗、旅遊保險、SIM卡",
                "travel-insurance-description": "旅遊保險邊間好？邊間保險包手提電話？立即比較旅遊保險，一眼睇晒AIG、MSIG、STARR等公司的旅遊保險保費。經HyperAir購買指定的旅行保險，可獲贈額外旅遊保險優惠。保障地點包括日本、韓國、台灣、泰國等最佳旅遊勝地！",
                "travel-insurance-keywords": "旅遊保險提供全面旅行保障，自駕遊、手提電話、熱氣球、滑雪、潛水。即時免費網上報價投保！",
                "travel-insurance-title": "旅遊保險 - 即時比較最佳旅遊保險及額外折扣優惠 2023",
                "travel-marketplace-checkout-payme-title": "以 PayMe 付款",
                "travel-marketplace-checkout-success-keywords": "創意, 產品, 流行, 電器, 生活, 精品, 智能家居, 設計, 高品質, 設計概念, 創意科技, 生活用品, 戶外休閒, 廚房, 餐桌, 個人護理, 防疫抗疫, 健康, 遊戲, 兒童玩樂, 健身, 家居健身, gym, home gym, smart home, style home",
                "travel-marketplace-checkout-success-title": "付款成功",
                "travel-marketplace-description": "集合最潮最好玩嘅創意科技產品，有設計概念嘅生活用品",
                "travel-marketplace-keywords": "創意, 產品, 流行, 電器, 生活, 精品, 智能家居, 設計, 高品質, 設計概念, 創意科技, 生活用品, 戶外休閒, 廚房, 餐桌, 個人護理, 防疫抗疫, 健康, 遊戲, 兒童玩樂, 健身, 家居健身, gym, home gym, smart home, style home",
                "travel-marketplace-product-checkout-title": "{product}",
                "travel-marketplace-product-title": "{product} - 玩樂潮物",
                "travel-marketplace-title": "玩樂潮物",
                "travel-money-description": "透過「HyperAir唱錢神器」，您可以喺網上比較滙率同埋預訂外幣，之後再喺心水的商店提取。咁你就可以慳返好多格價同排隊嘅時間。",
                "travel-money-keywords": "sim卡,上網卡,電話卡,數據卡,DataSIM,旅遊DataSIM,數據咭,4G上網卡,上網卡,4G上網卡,唱錢神器,唱X神器,唱錢X器,唱錢,兌換,找換,兌換店,找換店,銀行,金融,外匯,外滙,匯率,滙率,匯款,外幣,貨幣,旅行,旅遊,行程,酒店,機票,比較,格價,特價,預訂,交易,旅遊保險,日本,泰國,韓國,台灣,日圓,日元,台幣,泰銖,HyperAir,HyperAir FX,HyperAir Travel,Travel,Travel Money,Foreign Currency,Foreign Exchange,百年,堅成,發達鳥,飛鳥,richbird,crazy bird,berlin exchange",
                "travel-money-title": "唱錢神器™ - 輕鬆搜尋全球貨幣，比較價格及預訂最抵匯率",
                "travel-product-checkout-keywords": "創意, 產品, 流行, 電器, 生活, 精品, 智能家居, 設計, 高品質, 設計概念, 創意科技, 生活用品, 戶外休閒, 廚房, 餐桌, 個人護理, 防疫抗疫, 健康, 遊戲, 兒童玩樂, 健身, 家居健身, gym, home gym, smart home, style home",
                "travel-product-keywords": "創意, 產品, 流行, 電器, 生活, 精品, 智能家居, 設計, 高品質, 設計概念, 創意科技, 生活用品, 戶外休閒, 廚房, 餐桌, 個人護理, 防疫抗疫, 健康, 遊戲, 兒童玩樂, 健身, 家居健身, gym, home gym, smart home, style home",
                "travel-sim-checkout-description": "{country}旅遊SIM，多款勁抵價SIM卡，免運費送上門，準備旅程快又醒！",
                "travel-sim-checkout-keywords": "上網卡,電話卡,數據卡,DataSIM,旅遊DataSIM,數據咭,4G上網卡,上網卡,4G上網卡,日本4G上網卡,日本上網卡,東京4G上網卡,東京上網卡,大阪4G上網卡,大阪上網卡,泰國4G上網卡,泰國上網卡,曼谷4G上網卡,布吉上網卡,芭提雅4G上網卡,台灣4G上網卡,台灣上網卡,台北4G上網卡,高雄上網卡,台中4G上網卡,台中上網卡,韓國4G上網卡,韓國上網卡,首爾4G上網卡,首爾上網卡,中國4G上網卡,中國上網卡,深圳4G上網卡,深圳上網卡,澳門4G上網卡,澳門上網卡, Docomo, Softbank",
                "travel-sim-checkout-success-description": "{country}旅遊SIM，多款勁抵價SIM卡，免運費送上門，準備旅程快又醒！",
                "travel-sim-checkout-success-keywords": "上網卡,電話卡,數據卡,DataSIM,旅遊DataSIM,數據咭,4G上網卡,上網卡,4G上網卡,日本4G上網卡,日本上網卡,東京4G上網卡,東京上網卡,大阪4G上網卡,大阪上網卡,泰國4G上網卡,泰國上網卡,曼谷4G上網卡,布吉上網卡,芭提雅4G上網卡,台灣4G上網卡,台灣上網卡,台北4G上網卡,高雄上網卡,台中4G上網卡,台中上網卡,韓國4G上網卡,韓國上網卡,首爾4G上網卡,首爾上網卡,中國4G上網卡,中國上網卡,深圳4G上網卡,深圳上網卡,澳門4G上網卡,澳門上網卡, Docomo, Softbank",
                "travel-sim-checkout-success-title": "付款成功 - 旅遊SIM卡",
                "travel-sim-checkout-title": "訂購 - 旅遊SIM卡",
                "travel-sim-keywords": "sim卡,上網卡,電話卡,數據卡,DataSIM,旅遊DataSIM,數據咭,4G上網卡,上網卡,日本4G上網卡,日本上網卡,日本sim卡,東京4G上網卡,東京上網卡,大阪4G上網卡,大阪上網卡,泰國4G上網卡,泰國上網卡,泰國sim卡,曼谷4G上網卡,布吉上網卡,芭提雅4G上網卡,台灣4G上網卡,台灣上網卡,台灣sim卡,台北4G上網卡,高雄上網卡,台中4G上網卡,台中上網卡,韓國sim卡,韓國4G上網卡,韓國上網卡,首爾4G上網卡,首爾上網卡,中國4G上網卡,中國上網卡,中國sim卡,中國內地數據卡,深圳4G上網卡,深圳上網卡,澳門4G上網卡,澳門上網卡, 歐洲4G上網卡,歐洲上網卡,歐洲sim卡,英國4G上網卡,英國上網卡,英國sim卡,法國4G上網卡,法國上網卡,法國sim卡, 恴大利4G上網卡,意大利上網卡,意大利sim卡,巴黎4G上網卡,巴黎上網卡,巴黎sim卡,瑞士4G上網卡,瑞士上網卡,瑞士sim卡,Docomo, Softbank, 和記, 聯通, 3hk, 3uk, birdie, 自由鳥, airsim,sim2fly,AIS,ais sim2fly,SK Telecom,TrueMove,dtac,t mobile 全球上網卡,vietnamobile",
                "travel-sim-title": "【{country}上網SIM卡】{sim_name} - 勁抵價免運費",
                "travel-sims-description": "全球旅遊SIM搜尋引擎，輕鬆訂購優質勁抵價SIM卡，免運費送上門，準備旅程快又醒！",
                "travel-sims-keywords": "sim卡,上網卡,電話卡,數據卡,DataSIM,旅遊DataSIM,數據咭,4G上網卡,4Gsim卡,日本4G上網卡,日本上網卡,日本sim卡,東京4G上網卡,東京上網卡,大阪4G上網卡,大阪上網卡,泰國4G上網卡,泰國上網卡,泰國sim卡,曼谷4G上網卡,布吉上網卡,芭提雅4G上網卡,台灣4G上網卡,台灣上網卡,台灣sim卡,台北4G上網卡,高雄上網卡,台中4G上網卡,台中上網卡,韓國sim卡,韓國4G上網卡,韓國上網卡,首爾4G上網卡,首爾上網卡,中國4G上網卡,中國上網卡,中國sim卡,中國內地數據卡,深圳4G上網卡,深圳上網卡,澳門4G上網卡,澳門上網卡,澳門sim卡,歐洲sim卡,Docomo,Softbank,sim2fly,AIS,ais sim2fly,SK Telecom,TrueMove,dtac,t mobile 全球上網卡,vietnamobile",
                "travel-sims-title": "旅遊SIM - 優質，勁抵價，免運費送上門"
            },
            "shop-confirmation": {
                "app-download": "立即下載，推送通知",
                "app-download-subtitle": "下載 HyperAir 接收確認訂單的通知。",
                "instruction": "你的預訂已發送到找換店。一旦確認，我們會透過電郵或通知，將 QR CODE 將收到電郵通知，確認訂單將發送至 {email} 。",
                "my-order": "我的訂單",
                "pending-confirm": "等待兌換店確認"
            },
            "staycation": {
                "activity-countdown-button": "比較門票優惠",
                "all-hotels": {
                    "sorting": {
                        "recommended": "推介"
                    }
                },
                "all-hotels-all-button": "所有",
                "all-hotels-hotel-name": "酒店名稱",
                "all-hotels-last-updated": "最後更新",
                "all-hotels-less-button": "收起",
                "all-hotels-more-button": "更多",
                "all-hotels-no-result": "Sorry！我哋搵唔到相關嘅Staycation優惠",
                "all-hotels-title": "搜尋全港最齊 Staycation 酒店",
                "compare-packages": "比較此酒店其他套餐",
                "countdown-button": "立即搶購",
                "countdown-title": "最新 Staycation 酒店快閃優惠",
                "countdown2-title": "今期熱爆推介",
                "countdown3-title": "最新 Staycation 酒店限時優惠",
                "month-format": "M",
                "order-d-title": "浪漫精品酒店 💕💕",
                "order-g-subtitle": "暑假帶埋一家大細Relax下",
                "order-g-title": "親子Staycation必去之選👨‍👩‍👧‍👦😍",
                "order-h-title": "郵輪之旅🛳️",
                "order-i-title": "情侶煮飯仔酒店 🍽️",
                "order-j-title": "Glamping豪華露營推介",
                "seo-description": "點解咁多人用 HyperAir 搵 Staycation? 因為集合左 KKday, Trip.com, Klook 及各大香港酒店平台，一眼比較邊到有late checkout、免費泊車、自助早午晚餐及餐飲回贈等獨家 Staycation 優惠，每日更新。",
                "seo-keywords": "staycation, staycation 優惠, 香港 staycation, staycation 香港, staycation hk, staycation package, staycation hong kong, 酒店, 酒店 優惠, staycation 中文, 香港 酒店, klook 優惠, klook 優惠, kkday 優惠, trip 優惠, agoda 優惠, runhotel staycation, 酒店 套票, staycation 酒店, 香港 酒店 套票, 訂 酒店 優惠, 酒店 package, 特價 酒店, 香港 優惠 酒店, 酒店 優惠 套 票, 特價 酒店 香港, 香港 酒店 優惠, 酒店 住宿 優惠, staycation 2020, staycation 2021, staycation 2022, staycation 1月 優惠, staycation 2月 優惠, staycation 3月 優惠, staycation 4月 優惠, staycation 5月 優惠, staycation 6月 優惠, staycation 7月 優惠, staycation 8月 優惠, staycation 9月 優惠, staycation 10月 優惠, staycation 11月 優惠, staycation 12月 優惠, 四季酒店, W酒店, Murray, JW Marriott, St. Regis, Conrad Hotel, Grand Hyatt, Ritz Carlton, Rosewood, 露台 酒店, 廚房 酒店, 親子 酒店, 情侶 酒店",
                "seo-title": "【2021年9月最新】香港酒店 Staycation 優惠搜尋神器 全港最齊．每日更新 - 最齊香港staycation優惠、酒店優惠、Hong Kong Staycation Ideas、Klook優惠、KKday優惠、Trip優惠、Agoda優惠、專業旅運優惠 - HyperAir 玩樂必備搜尋比較平台！一次過，比較全球多個玩樂旅遊預訂網站！ - HyperAir",
                "share-button-alert": "鏈結已複製",
                "subtitle": "每日更新酒店餐飲及住宿優惠（{start_month}月至{end_month}月）",
                "title": "香港最齊 Staycation 優惠搜尋神器",
                "top10-title": "Top 10 人氣 Staycation 酒店",
                "top102-title": "Staycation 必去之選",
                "top103-title": "值得一試的 Staycation 酒店🥂"
            },
            "travel-activities": {
                "best-deals": "價格",
                "book-now": "查看詳情",
                "disclaimer": "價格只供參考，一切內容將以合作平台為準。",
                "empty-destination": "請輸入國家或城巿",
                "more-deals": "更多",
                "not-available": "未能預訂",
                "offers": "",
                "provider-getyourguide": "GetYourGuide",
                "provider-hk": {
                    "trip": {
                        "com": "Trip.com"
                    }
                },
                "provider-hyperair": "HyperAir",
                "provider-kkday": "KKday",
                "provider-klook": "KLOOK",
                "provider-seoultravelpass": "SeoulPass",
                "provider-sim": {
                    "hyperair": {
                        "com": "HyperAir"
                    }
                },
                "provider-travelexpert": "Travel Expert",
                "provider-trip": "Trip.com",
                "ratings": "評分",
                "recommended-title": "更多{city}嘅熱門活動",
                "search-africa-oceania": "非洲/大洋洲",
                "search-all-cities": "所有城市",
                "search-america": "美洲",
                "search-asia": "亞洲",
                "search-button": "搜尋",
                "search-cancel-button": "取消",
                "search-country-placeholder": "輸入國家或城市",
                "search-euro-middleeast": "歐洲/中東",
                "search-hardcoded-cities": "熱門搜尋：",
                "search-placeholder": "搜尋 \"門票\" 或 \"一日遊\"",
                "search-popular-cities": "🔥熱門城市",
                "search-searched-cities": "搜尋城市",
                "search-slogan-2": "活動分類/景點",
                "show-similar-product": "比較相關產品",
                "sorting": {
                    "price-asc": "價格（從低到高）",
                    "price-desc": "價格（從高到低）",
                    "rating": "評分",
                    "relevance": "最相關",
                    "sort-by": "排序"
                },
                "title": "符合「{q}」的搜尋結果",
                "title-everything": "{city}嘅熱門活動",
                "title-no-result": "Sorry！我哋搵唔到同“{q}”相關嘅活動",
                "title-no-result-without-keyword": "Sorry！我哋搵唔到相關嘅活動",
                "total-results": "共 <b>{number}</b> 項搜尋結果"
            },
            "travel-affiliate-codes": {
                "cover-slogan": "提供各大預訂網站旅遊優惠碼，幫您慳多啲、玩盡啲",
                "cover-title": "玩樂旅遊優惠券",
                "disclaimer": "優惠資料只供參考，一切內容將以合作平台為準。供應商可隨時對資料進行變更或刪除，並保留最終之決定權。",
                "exclusive": "獨家優惠",
                "type-activity": "玩樂體驗",
                "type-air": "機票",
                "type-all": "所有",
                "type-hotel": "酒店",
                "type-insurance": "旅遊保險",
                "type-shopping": "購物",
                "type-sim": "旅遊SIM",
                "use-promo-code": "獲取優惠碼",
                "valid-until": "到期日："
            },
            "travel-insurance": {
                "breadcrumb-travel-insurance": "旅遊保險",
                "cover-subtitle": "搜羅比較最正旅遊保險，仲保埋手機添！",
                "cover-title": "旅遊保險",
                "departure-date-alert": "出發日期必須於{latest_date_to_depart}或之前。",
                "disclaimer": "報價只供參考，詳情請參閱保險公司網頁。",
                "highlight-subtitle1": "保障範圍清晰比較，最啱心水計劃一目了然！",
                "highlight-subtitle2": "為你比較全港旅遊保險報價 慳得一蚊得一蚊！",
                "highlight-subtitle3": "HyperAir 客户專享獨家旅遊保險折扣及優惠！",
                "highlight-title1": "保障比較",
                "highlight-title2": "旅保格價",
                "highlight-title3": "獨家禮遇",
                "num-of-travellers-alert": "旅客人數不能多於10人",
                "partner-title": "旅遊保險合作夥伴",
                "return-date-alert": "回程日期必須於{latest_date_to_return}或之前。",
                "section-title": "你正在搜尋{num_of_traveller}個旅客玩{num_of_day}日的旅遊保險",
                "slogan": "簡易3步 無憂投保",
                "sorting": {
                    "coverage": "最佳保障",
                    "price-asc": "價格（從低到高）",
                    "price-desc": "價格（從高到低）"
                },
                "step1": "填寫旅程",
                "step1-detail": "輸入你旅程嘅目的地，日期和人數",
                "step2": "比較計劃",
                "step2-detail": "比較不同保險計劃的保障範圍及價錢",
                "step3": "即享優惠",
                "step3-detail": "一按即享不同旅遊保險優惠"
            },
            "travel-insurance-product-card": {
                "apply-now": "即享優惠",
                "cancellation": "取消旅遊保障",
                "car-rental": "租車自負額保障",
                "cruise-vacation": "郵輪假期(附加保障)",
                "dangerous-sports": "業餘危險運動",
                "hyperair-exclusive": "HYPERAIR 獨家優惠",
                "medical": "醫療費用",
                "mobile": "手提電話損毀或遺失",
                "personal-belongings": "遺失錢財及證件",
                "trip-delay": "旅程延誤"
            },
            "travel-insurance-search-bar": {
                "children": "子女(18歲以下)",
                "date": "出發日期及回程日期",
                "destination": "去邊度玩",
                "friend": "朋友/親屬",
                "myself": "自己",
                "number-of-traveller": "旅客人數",
                "search-button": "搜尋",
                "spouse": "配偶"
            },
            "travel-marketplace": {
                "buy-now-can-earn-x-miles": "可賺取 HyperMiles 於下次消費使用",
                "cover-slogan": "集合最潮最好玩嘅創意科技產品",
                "cover-title": "玩樂潮物"
            },
            "travel-marketplace-categories": "商品分類",
            "travel-marketplace-checkout": {
                "delivery-message-body": "工作天為星期一至星期五（公眾假期除外），截數時間為當日正午12時，於正午12時後訂購的貨品將會順延至下一個工作天寄出。",
                "delivery-method-1": "順豐速遞 （只限香港）",
                "delivery-method-1-description": "以順豐速運寄送，每單運費HK$30，買滿HK$800免運費。大概5-10個工作天內送達。",
                "delivery-method-2": "跨國運送",
                "delivery-method-2-description": "設運送編號作追查，大概4-25個工作天內送達，視乎選擇的目的地。以上運費只是估算，或需額外運費。"
            },
            "travel-money": {
                "breadcrumb-travel-money": "唱錢神器",
                "cover-button": "立即體驗",
                "cover-slogan": "助你輕鬆搜尋預訂最抵匯率，咁就唱錢快又醒啦！",
                "cover-title": "唱錢神器™",
                "disclaimer": "價格只供參考，一切內容將以該找換店為準。",
                "empty-amount": "請輸入金額",
                "fx": "",
                "fx-slogan": "簡易四步 輕鬆唱錢",
                "fx-step1": "搜尋",
                "fx-step1-detail": "選擇您所需要唱嘅外幣",
                "fx-step2": "比較",
                "fx-step2-detail": "搵最靚嘅匯率同埋方便嘅地點",
                "fx-step3": "預訂",
                "fx-step3-detail": "隨時隨地網上輕鬆預訂外幣",
                "fx-step4": "提取",
                "fx-step4-detail": "出示您訂單嘅QR Code，提取您嘅外幣去旅行",
                "hyperair-feature-1": "醒目",
                "hyperair-feature-1-description": "一個醒目的方法唱外幣去旅行。現在，您只需撳一個掣即可找到最好的商店，在幾秒鐘內預訂外幣，並在最近的地點拎外幣。是時候告別排隊和昂貴的匯率了。",
                "hyperair-feature-2": "可靠",
                "hyperair-feature-2-description": "這是一個安全的方式去兌換外幣。我們精心挑選合作夥伴，僅與受監管的銀行和持牌兌換店合作。使用我們的平台，您的資金將受最高的保障。",
                "hyperair-feature-3": "隨時隨地",
                "hyperair-feature-3-description": "這是革新的兌換外幣方式。我們雄心勃勃地擴展在本地和全球的服務，為您提供最佳的旅行體驗。我們努力確保您在任何地方，都以智能和可靠的方式獲得旅行外幣。",
                "i-will-get": "我要唱",
                "i-will-pay": "我要畀",
                "join-us": "獲取更多商機",
                "join-us-button": "加入供應商",
                "join-us-slogan": "加入我們的找換店網絡",
                "search-bar-placeholder": "輸入金額",
                "search-button": "搜尋",
                "section-title": "你正在搜尋{amount} {currency} 兌換 HKD",
                "section-title-from-hkd": "你正在搜尋HKD 兌換 {amount} {currency}",
                "section-title-to-hkd": "你正在搜尋{amount} {currency} 兌換 HKD",
                "why-hyperair": "",
                "why-hyperair-description": "唱錢神器™為您帶嚟醒目嘅方法去準備您嘅旅行。我哋提供快速、簡易同埋中立嘅外幣搜索引擎。",
                "why-hyperair-title": "為甚麼選用唱錢神器 ?"
            },
            "travel-product": {
                "buy-now": "立即購買",
                "product-option": "產品選項"
            },
            "travel-sim": {
                "as-low-as": "每日低至",
                "book-now": "立即訂購(有庫存)",
                "breadcrumb-homepage": "首頁",
                "breadcrumb-mainpage": "主頁",
                "breadcrumb-travel-sim": "旅遊SIM",
                "cancellation-policy": "取消政策",
                "cancellation-policy-content": "成功預訂後，訂單不可修改、取消或退款",
                "download-hyperair-now-description": "用相機掃一掃 QR Code 或按平台下載 HyperAir 應用程式",
                "download-hyperair-now-title": "立即下載 HyperAir",
                "first-step": "第一步",
                "go-to-shopping-cart-description": "下載後用相機掃描 QR 碼可直達產品專業，選擇數量或其他產品後可直接付款。",
                "go-to-shopping-cart-title": "直達購物車，立即付款",
                "hardcoded-countries-title": "其他熱門地區：",
                "highlights": "特色",
                "important-notice": "注意事項",
                "instructions": "使用說明",
                "lowest-price-guarantee": "推廣價",
                "no-stock": "賣晒啦",
                "num-of-review": "{num}-of-review個評分",
                "popular-countries": "旅遊 SIM 涵蓋 200+ 國家",
                "popular-countries-search-button": "搜尋其他國家",
                "product-highlights": "產品詳情",
                "product-specification": "產品規格",
                "related-sims": "相關{countrySIM}卡",
                "related-sims-search-button": "更多{country}旅遊 SIM",
                "review": "評價",
                "review-date": "{date}",
                "review-no-firstname-user": "旅客",
                "scan-product-qr-code": "掃一掃 QR Code 購買此產品",
                "second-step": "第二步",
                "sim": "電話卡",
                "web-traffic": "最近7天已賣岀{num}-of-purchased張 , 而家有{num}-of-traffic個人同時睇緊呢張SIM卡",
                "web-traffic-title": "呢張 SIM 卡熱賣中！"
            },
            "travel-sim-checkout": {
                "-secure-payment-slogan": "我們所有的線上付款都受加密保護",
                "address": "地址*",
                "address-column1": "例如：香港中環",
                "address-column2": "例如：旅遊路88號",
                "address-column3": "例如：世界中心18樓A室",
                "back-button": "返回",
                "checkout-title-1": "物流資料",
                "confirm-button": "繼續",
                "country-code": "國家編碼",
                "delivery-message-body": "工作天為星期一至星期五（公眾假期除外），截數時間為當日正午12時，於正午12時後訂購的貨品將會順延至下一個工作天寄出。\n<br><br>如在同一日工作天內，相同收貨地址的訂單將會合併寄岀。",
                "delivery-message-header": "送貨通告",
                "delivery-method": "物流方式",
                "delivery-method-1": "平郵（免費）",
                "delivery-method-1-description": "以香港郵政平郵寄送，免郵費，大概3-6個工作天內送達。如選擇平郵寄送，將不設郵寄編號作追查，客戶需要自行承擔平郵延誤及寄失的風險。\n<br><br>注意：因寄送需時，即將外遊的顧客建議選用順豐到付，確保貨品能準時送達",
                "delivery-method-2": "順豐速遞 （只限香港，貨到付運費）",
                "delivery-method-2-description": "以順豐速運寄送，貨到後付運費，大概1-3個工作天內送達，離島需時可與順豐查詢。速遞運費約HK$16-$25。詳情請參閱順豐速運網站。\n<br><br>注意：如即日總訂單付款滿HK$399，即可升級以順豐速運免費寄送。",
                "delivery-method-3": "跨國運送",
                "delivery-method-3-description": "以香港郵政空郵寄送，設郵寄編號作追查，固定$30郵費，大概4-15個工作天內送達，視乎選擇的目的地",
                "error-alert-address": "請填寫「收貨地址」。",
                "error-alert-invalid-email": "電郵地址格式不正確。",
                "error-alert-invalid-recipient-first-num": "聯繫號碼應該以2, 3, 5, 6, 7, 8或9開始。",
                "error-alert-invalid-recipient-number": "請填寫正確的收貨人聯繫號碼。",
                "error-alert-invalid-user-first-num": "手機號碼應該以5, 6, 7, 8或9開始。",
                "error-alert-invalid-user-number": "請填寫正確的手機號碼。",
                "error-alert-personal-info": "請填寫「預訂人資料」。",
                "error-alert-recipient-info": "請填寫「收貨人資料」。",
                "error-invalid-credit-card-info": "信用卡資料不正確",
                "facebook-login": "Facebook 繼續",
                "google-login": "Google 繼續",
                "logged-in": "已登入",
                "login": "現有客戶，立即登入方便購買",
                "login-button": "登入",
                "login-email": "電郵",
                "login-no-user-exists": "哎喲！很抱歉，我哋未能確認您嘅登入資料。請再試一次，或不登入直接完成訂購也很容易。",
                "login-password": "密碼",
                "payme": {
                    "error-contacting-payme": "付款失敗，請重新落單 / 聯絡客戶服務"
                },
                "payment": {
                    "actual-payment": "交易以港元 ${actual_payment} 結算，兌換率將跟據您的發卡機構為準",
                    "choose-payment-method": "選擇付款方式：",
                    "logistic-information": "物流資料",
                    "modify-information": "修改資料",
                    "pay-now": "立即付款",
                    "payme-instruction-do-not-close": "在交易完成前請不要關閉此頁面",
                    "payme-instruction-step-1": "1. 打開 PayMe 應用程式",
                    "payme-instruction-step-2": "2. 掃描 PayCode 以授權付款",
                    "payme-instruction-step-3": "3. 在 PayMe 完成交易後，請留在此頁面等待確認",
                    "payme-instruction-title": "如何用 PayMe 付款？",
                    "payme-title": "請用 PayMe 掃描此 PayCode",
                    "payment": "付款",
                    "price": "金額",
                    "shipping-fee": "運費",
                    "subtotal": "小計"
                },
                "payment-method": "付款方式",
                "pending": {
                    "mobile-redirection-text": "您已選擇以PayMe作為付款方式，並且將被重新定向至PayMe應用程式以完成付款。",
                    "need-to-pay": "需付金額",
                    "order-number": "訂單號碼",
                    "order-success-please-pay": "你已成功下單，請完成付款手續，以便完成訂單程序",
                    "paycode-error": "付款失敗，請重新落單 / 聯絡客戶服務",
                    "paycode-expired": "PayMe 的 PayCode 已過期，請重新落單",
                    "re-order": "重新落單",
                    "title-payme": "PayMe 付款"
                },
                "recipient-address": "收貨地址",
                "recipient-information": "收貨人資料",
                "recipient-name": "收貨人名稱",
                "recipient-phone-number": "收貨人聯繫電話",
                "secure-payment-slogan": "安全付款 | 付款資料受SSL安全加密傳輸",
                "simproduct-detail": "訂單資料",
                "simproduct-quantity": "數量",
                "simproduct-redeem": "兌換",
                "simproduct-redeem-hypermiles": "兌換 HyperMiles",
                "simproduct-title": "產品",
                "simproduct-will-redeeming-x-miles": "將兌換 {miles} HyperMiles",
                "simproduct-you-have-x-hypermiles": "你已擁有 {miles} HyperMiles",
                "user-email": "電郵（接收發票）",
                "user-firstname": "名字",
                "user-information": "預訂人資料",
                "user-lastname": "姓氏",
                "user-phone-number": "手機號碼",
                "vertical-divider": "或"
            },
            "travel-sims": {
                "column-title-1": "清晰分類，容易挑選",
                "column-title-2": "網上付款，方便快捷",
                "column-title-3": "免費平郵，極速送到",
                "country-search-no-place-found": "請輸入正確國家名稱",
                "cover-button": "立即用App購買",
                "cover-slogan": "多款勁抵價SIM卡，免運費送上門!",
                "cover-title": "旅遊SIM",
                "empty-destination": "請輸入目的地",
                "num-of-days": "去幾多日",
                "search-button": "",
                "search-input": "輸入國家",
                "search-placeholder": "輸入國家",
                "search-slogan": "去邊到玩？",
                "travel-sim-header-description": "",
                "travel-sim-header-title": ""
            }
        },
        "passwords": {
            "password": "",
            "reset": "",
            "sent": "我們已經通過電子郵件發送了您的密碼重置鏈接。",
            "token": "",
            "user": ""
        },
        "mail": {
            "product-simcard": {
                "delivery-update": {
                    "subject": "您嘅SIM卡訂單已經寄岀"
                },
                "purchased": {
                    "subject": "您嘅旅遊SIM卡訂單已確認"
                },
                "tracking-number-update": {
                    "subject": "您嘅快遞單號已更新"
                }
            }
        },
        "member-center": {
            "login-to-receive-codes": "立即註冊，即賞你優惠券",
            "my-orders-empty": "沒有紀錄",
            "my-orders-title": "我的訂單",
            "profile-area-code": "國家編碼",
            "profile-email": "電郵地址",
            "profile-firstname": "名字",
            "profile-lastname": "姓氏",
            "profile-save": "修改",
            "profile-tel": "手機號碼",
            "profile-title": "帳戶資料",
            "profile-update-successfully": "成功更新",
            "promo-code-enter-promotion-code": "輸入優惠碼",
            "promo-code-my-promo-code": "我嘅 HyperAir 優惠券",
            "promo-code-no-code": "不好意思,你沒有任何優惠券",
            "promo-code-please-fill-in-code": "請填寫優惠碼",
            "promo-code-redeem": "兌換",
            "promo-code-redeem-code": "兌換 HyperAir 優惠券",
            "promo-code-select": "選擇",
            "promo-code-title": "HyperAir 優惠券",
            "title": "我的賬戶"
        },
        "weekday": {
            "1": "星期一",
            "2": "星期二",
            "3": "星期三",
            "4": "星期四",
            "5": "星期五",
            "6": "星期六",
            "7": "星期日"
        },
        "exchange-shop-details": {
            "address": "地址",
            "book-button": "立即預約",
            "br": "牌照號碼",
            "closed-book-button": "休息中",
            "download-pop-up": {
                "slogan-1": "立即報價，鎖住匯率",
                "slogan-2": "即時通知，確認訂單",
                "title": "立即下載 HyperAir 預約唱錢"
            },
            "latest-updated": "最新",
            "not-available-book-button": "只供參考",
            "opening-hrs": "營業時間",
            "phone-num": "電話",
            "rate": "匯率",
            "reviews": "評論",
            "table-buy-rate": "買入價",
            "table-compare-button": "比較匯率",
            "table-currency": "外幣",
            "table-sell-rate": "賣出價",
            "table-short-form": "代碼",
            "table-title": "外幣匯率"
        },
        "credit-card": {
            "cannot-add-card": "新增信用卡時發生錯誤，請確認所有資料正確並再次新增，您也可以選擇新增另一張信用卡。",
            "cannot-process": "信用卡付款時發生錯誤，請確認所有資料正確並再次付款，您也可以選擇以另一張信用卡付款。"
        },
        "shoppingcart": {
            "add": {
                "no-stock": "噢！已達最多可購買的數量~"
            },
            "pay": {
                "db-locked": "系統現在繁忙，請稍後再試。（參考編號：E1003）",
                "invalid-promotion-code": "優惠碼無效",
                "no-stock": "不好意思，您想買嘅產品剛剛沒有存貨了！（參考編號：E1002）"
            },
            "promotion-message": {
                "up-sell-1": "使用迎新優惠券可享 HK$10 折扣",
                "up-sell-2": "消費滿 HK$299 並使用優惠碼 HYPER15，可享 HK$15 折扣"
            }
        },
        "product": {
            "label-confirmation-duration-24_hours": "24小時確認",
            "label-confirmation-duration-48_hours": "48小時確認",
            "label-confirmation-duration-instant": "即時確認",
            "label-duration-unit-day": "日",
            "label-duration-unit-hour": "小時",
            "label-duration-unit-hr": "小時",
            "label-duration-unit-min": "分鐘",
            "label-earliest-available-date": "Y年n月j日",
            "label-earliest-available-date-today": "今日",
            "label-earliest-available-date-tomorrow": "明日",
            "label-lang-en": "英文",
            "label-lang-jp": "日文",
            "label-lang-kr": "韓文",
            "label-lang-zh": "中文",
            "label-meet-up-method-hotel_pickup": "酒店接送",
            "label-meet-up-method-location_meet_up": "自行前往指定地點集合",
            "label-refundable-conditional_cancel": "有條件退改",
            "label-refundable-no_cancel": "不能退改",
            "label-ticket-logistic-mobile": "需要手機憑證",
            "label-ticket-logistic-printed": "需要列印憑證",
            "label-ticket-logistic-printed_or_mobile": "列印或手機憑證均可",
            "label-ticket-validity-fixed_date": "必須於指定日期使用",
            "label-ticket-validity-open_date": "有效期内任何一天使用",
            "label-ticket-validity-open_or_fixed_date": "有效期以具體方案所述為准"
        },
        "pagination": {
            "next": "下一頁",
            "previous": "上一頁"
        },
        "city": {
            "abu-dhabi": "阿布達比",
            "adelaide": "阿德萊德",
            "agra": "阿格拉",
            "ahmedabad": "艾哈邁達巴德",
            "alice-springs": "愛麗斯泉",
            "alsace": "亞爾薩斯",
            "amritsar": "阿姆利則",
            "amsterdam": "阿姆斯特丹",
            "andalusia": "安達魯西亞",
            "antalya": "安塔利亞",
            "anuradhapura": "阿努拉德普勒",
            "athens": "雅典",
            "auckland": "奧克蘭",
            "bacolod": "巴科洛德",
            "bagan": "蒲甘",
            "baku": "巴庫",
            "bali": "峇里島",
            "bandung": "萬隆",
            "bangalore": "班加羅爾",
            "bangkok": "曼谷",
            "barcelona": "巴塞隆納",
            "batam": "巴淡島",
            "bath": "巴斯",
            "bay-of-islands": "島嶼灣",
            "beijing": "北京",
            "belfast": "貝爾法斯特",
            "bentota": "本托塔",
            "berlin": "柏林",
            "bohol": "Bohol",
            "boracay": "長灘島",
            "bordeaux": "波爾多",
            "boston": "波士頓",
            "bratislava": "布拉提斯拉瓦",
            "brisbane": "布里斯班",
            "bruges": "布魯日",
            "brussels": "布魯塞爾",
            "budapest": "布達佩斯",
            "burgundy": "勃艮第",
            "busan": "釜山",
            "cairns": "凱恩斯",
            "cambridge": "劍橋",
            "cameron-highlands": "金馬崙高原",
            "canary-islands": "加那利群島",
            "cape-town": "開普敦",
            "cappadocia": "卡帕多奇亞",
            "cebu": "宿務",
            "champagne": "香檳區",
            "chengdu": "成都",
            "chennai": "金娜",
            "chiang-mai": "清邁",
            "chiang-rai": "清萊",
            "chiayi": "Chiayi",
            "chicago": "芝加哥",
            "chongqing": "重慶",
            "christchurch": "克賴斯特徹奇",
            "cochin": "科欽",
            "cologne": "科隆",
            "colombo": "科倫坡",
            "copenhagen": "哥本哈根",
            "costa-del-sol": "太陽海岸",
            "crete": "克里特政區",
            "da-lat": "大叻市",
            "da-nang": "峴港",
            "darwin": "達爾文",
            "davao": "達沃",
            "delhi": "Delhi",
            "dhaka": "達卡",
            "dresden": "德累斯頓",
            "dubai": "杜拜",
            "dublin": "都柏林",
            "dubrovnik": "杜布羅夫尼克",
            "dumaguete": "杜馬蓋地",
            "dunedin": "達尼丁",
            "düsseldorf": "杜塞爾多夫",
            "edinburgh": "愛丁堡",
            "finnish-lapland": "拉普蘭",
            "florence": "佛羅倫斯",
            "frankfurt": "法蘭克福",
            "fraser-island": "費沙島",
            "french-riviera": "法國蔚藍海岸",
            "fukuoka": "福岡",
            "galle": "加勒",
            "galway": "戈爾韋",
            "gangtok": "甘托克",
            "gangwon-do": "江原道",
            "gdansk": "格但斯克",
            "geneva": "日內瓦",
            "genting-highlands": "雲頂高原",
            "geraldton": "杰拉爾頓",
            "glasgow": "格拉斯哥",
            "goa": "果阿邦",
            "gold-coast": "黃金海岸",
            "gothenburg": "哥德堡",
            "guam": "關島",
            "guangdong": "廣東",
            "guilin": "桂林",
            "guizhou": "貴州",
            "gyeonggi-do": "京畿道",
            "haikou": "海口",
            "hakone": "箱根",
            "halong": "下龍",
            "hamburg": "漢堡",
            "hangzhou": "杭州",
            "hanoi": "河內",
            "harbin": "哈爾濱",
            "hat-yai": "合艾",
            "hawaii": "夏威夷",
            "heidelberg": "海德堡",
            "helsinki": "赫爾辛基",
            "himachal-pradesh": "喜馬偕爾邦",
            "hiroshima": "廣島",
            "ho-chi-minh-city": "胡志明",
            "hobart": "霍巴特",
            "hoi-an": "會安",
            "hokkaido": "北海道",
            "hong-kong": "香港",
            "hua-hin": "華欣",
            "hualien": "花蓮",
            "hue": "Hue",
            "hyderabad": "海德拉巴",
            "iloilo": "伊洛伊洛",
            "incheon": "仁川",
            "inle-lake": "茵萊湖",
            "inner-mongolia": "內蒙古",
            "innsbruck": "因斯布魯克",
            "interlaken": "因特拉肯",
            "inverness": "因弗內斯",
            "ipoh": "怡保",
            "istanbul": "伊斯坦布爾",
            "jaipur": "齋浦爾",
            "jaisalmer": "賈沙梅爾",
            "jakarta": "Jakarta",
            "jeju": "濟州",
            "jerusalem": "耶路撒冷",
            "jodhpur": "焦特布爾",
            "johor-bahru": "新山",
            "kandy": "康提",
            "kaohsiung": "高雄",
            "kathmandu": "加德滿都",
            "kazan": "喀山",
            "kenting": "墾丁",
            "kiev": "Kiev",
            "kinmen": "Kinmen",
            "kobe": "神戶",
            "koh-chang": "象島",
            "koh-samui": "Koh Samui",
            "krabi": "甲米",
            "krakow": "克拉科夫",
            "kuala-lumpur": "吉隆坡",
            "kumamoto": "熊本",
            "kyoto": "京都",
            "kyushu": "九州",
            "lake-district": "湖區",
            "langkawi": "浮羅交怡",
            "lapland": "拉普蘭",
            "las-vegas": "拉斯維加斯",
            "launceston": "朗塞斯頓",
            "lausanne": "洛桑",
            "leipzig": "萊比錫",
            "lisbon": "里斯本",
            "liverpool": "利物浦",
            "ljubljana": "盧布爾雅那",
            "loire-valley": "盧瓦爾河谷",
            "lombok": "龍目島",
            "london": "倫敦",
            "los-angeles": "洛杉磯",
            "luang-prabang": "琅勃拉邦",
            "lucerne": "琉森",
            "lviv": "利維夫",
            "lyon": "里昂",
            "macao": "澳門",
            "macau": "Macau",
            "madrid": "馬德里",
            "malaga": "馬拉加",
            "manchester": "曼徹斯特",
            "mandalay": "曼德勒省",
            "manila": "馬尼拉",
            "marrakech": "馬拉喀什",
            "mauritius": "毛里裘斯",
            "medan": "棉蘭",
            "melaka": "馬六甲",
            "melbourne": "墨爾本",
            "miami": "邁阿密",
            "milford-sound": "米爾福德峽灣",
            "montreux": "蒙特勒",
            "moscow": "莫斯科",
            "mumbai": "孟買",
            "munich": "慕尼黑",
            "muscat": "馬斯喀特",
            "nagano": "長野",
            "nagoya": "名古屋",
            "naples": "那不勒斯",
            "nelson": "納爾遜",
            "new-delhi": "新德里",
            "new-york": "紐約",
            "nha-trang": "芽莊",
            "niagara-falls": "Niagara Falls",
            "niigata": "新潟",
            "normandy": "諾曼地",
            "odessa": "敖德薩",
            "okayama": "岡山",
            "okinawa": "沖繩",
            "orlando": "奧蘭多",
            "osaka": "大阪",
            "oslo": "奧斯陸",
            "oxford": "牛津",
            "palawan": "巴拉望",
            "paris": "巴黎",
            "pattaya": "芭堤雅",
            "penang": "Penang",
            "penghu": "Penghu",
            "perth": "珀斯",
            "philadelphia": "費城",
            "phnom-penh": "Phnom Penh",
            "phu-quoc": "Phu Quoc",
            "phuket": "布吉",
            "pisa": "比薩",
            "pokhara": "博卡拉",
            "port-lincoln": "林肯港",
            "porto": "波爾圖",
            "porto-district": "波爾圖",
            "prague": "布拉格",
            "provence": "普羅旺斯",
            "puglia": "普利亞",
            "pune": "浦那",
            "pushkar": "普希卡",
            "queenstown": "昆士敦",
            "ras-al-khaimah": "拉斯海瑪",
            "reykjavik": "雷克雅維克",
            "rhodes": "羅茲省",
            "rhône-alpes": "羅納-阿爾卑斯大區",
            "rome": "Rome",
            "rotorua": "Rotorua",
            "rotterdam": "鹿特丹",
            "sabah": "沙巴",
            "saint-petersburg": "圣彼得堡",
            "saipan": "塞班島",
            "salzburg": "薩爾斯堡",
            "san-diego": "聖地牙哥",
            "san-francisco": "舊金山",
            "santorini": "桑托里尼島",
            "sanya": "三亞",
            "sapa": "Sapa",
            "sarawak": "砂拉越",
            "seattle": "西雅圖",
            "seoul": "首爾",
            "seville": "塞維爾",
            "shanghai": "上海",
            "sibiu": "錫比烏",
            "sicily": "西西里島",
            "siem-reap": "暹粒",
            "sihanoukville": "Sihanoukville",
            "singapore": "新加坡",
            "split": "史普利特",
            "surabaya": "蘇拉巴雅",
            "suzhou": "蘇州",
            "swedish-lapland": "瑞典拉普蘭",
            "sydney": "悉尼",
            "taichung": "台中",
            "tainan": "台南",
            "taipei": "台北",
            "taitung": "台東",
            "tarragona": "塔拉戈納",
            "taupo": "陶波",
            "terengganu": "登嘉樓",
            "thessaloniki": "塞薩洛尼基",
            "tokyo": "東京",
            "toledo": "托萊多",
            "trincomalee": "亭可馬里",
            "turin": "都靈",
            "udaipur": "烏代布爾",
            "uluru": "烏魯魯",
            "uttarakhand": "北阿坎德邦",
            "varanasi": "瓦拉納西",
            "venice": "威尼斯",
            "verona": "維洛納",
            "vienna": "維也納",
            "vientiane": "萬象",
            "volendam": "沃倫丹",
            "washington-dc": "華盛頓特區",
            "wellington": "Wellington",
            "whitsundays": "Whitsundays",
            "xiamen": "廈門",
            "xian": "Xian",
            "yangon": "仰光",
            "yilan": "宜蘭",
            "yogyakarta": "Yogyakarta",
            "york": "約克",
            "yunnan": "雲南",
            "zagreb": "札格瑞布",
            "zhangjiajie": "張家界",
            "zurich": "蘇黎世"
        },
        "validation": {
            "accepted": "",
            "active_url": "",
            "after": "",
            "after_or_equal": "",
            "alpha": "",
            "alpha_dash": "",
            "alpha_num": "",
            "array": "",
            "before": "",
            "before_or_equal": "",
            "between": {
                "array": "",
                "file": "",
                "numeric": "",
                "string": ""
            },
            "boolean": "",
            "confirmed": "",
            "custom": {
                "attribute-name": {
                    "rule-name": ""
                }
            },
            "date": "",
            "date_format": "",
            "different": "",
            "digits": "",
            "digits_between": "",
            "dimensions": "",
            "distinct": "",
            "email": "",
            "exists": "",
            "file": "",
            "filled": "",
            "image": "",
            "in": "",
            "in_array": "",
            "integer": "",
            "ip": "",
            "ipv4": "",
            "ipv6": "",
            "json": "",
            "max": {
                "array": "",
                "file": "",
                "numeric": "",
                "string": ""
            },
            "mimes": "",
            "mimetypes": "",
            "min": {
                "array": "",
                "file": "",
                "numeric": "",
                "string": ""
            },
            "not_in": "",
            "numeric": "",
            "present": "",
            "regex": "",
            "required": "",
            "required_if": "",
            "required_unless": "",
            "required_with": "",
            "required_with_all": "",
            "required_without": "",
            "required_without_all": "",
            "same": "",
            "size": {
                "array": "",
                "file": "",
                "numeric": "",
                "string": ""
            },
            "string": "",
            "timezone": "",
            "unique": "",
            "uploaded": "",
            "url": ""
        },
        "reset-password": {
            "confirm-new-password": "重覆新密碼",
            "enter-new-password": "輸入新密碼",
            "please-enter-a-new-password": "請為您嘅帳戶 {email} 輸入新密碼。",
            "submit": "提交",
            "success-content": "成功！請使用新密碼登入HyperAir嘅手機App。",
            "title": "重設密碼",
            "validation-display": "密碼長度必須為最少6個字元。"
        },
        "notification": {
            "activation-e-minus-content": "倒數中! 仲有15日你張迎新SIM卡coupon就會到期啦！快啲用嚟準備下次嘅旅行啦！",
            "activation-e-minus-title": "",
            "activation-t-plus-content": "你咁醒目用HyperAir，記得用埋我哋張迎新SIM卡coupon! 咁就真係隨時隨地醒目旅遊啦！",
            "activation-t-plus-title": "",
            "ask-shop-to-quote-content": "要求報價買入 {amount} {currency}",
            "ask-shop-to-quote-content2": "要求報價賣出 {amount} {currency}",
            "ask-shop-to-quote-title": "新柯打等您報價",
            "email-booking-details": "訂單詳情",
            "email-booking-id": "訂單編號",
            "email-exchange-approved-content": "Exchanged order approved for buying {amount} {currency} at rate {rate}",
            "email-exchange-approved-footer": "感謝您使用HyperAir嘅服務。",
            "email-exchange-approved-title": "兌換店已回覆：「已為您準備好您嘅外幣！」",
            "email-exchange-completed-content": "Exchanged order completed for buying {amount} {currency} at rate {rate}",
            "email-exchange-completed-footer": "感謝您使用HyperAir嘅服務。",
            "email-exchange-completed-title": "您嘅外幣兌換已完成！",
            "email-exchange-confirmed-content": "Exchanged order confirmed for buying {amount} {currency} at rate {rate}",
            "email-exchange-confirmed-footer": "感謝您使用HyperAir嘅服務。",
            "email-exchange-confirmed-title": "已為您準備好您嘅外幣！",
            "email-footer-copy-right": "版權所有",
            "email-greetings": "您好！",
            "email-i-got": "我唱咗",
            "email-i-paid": "我畀咗",
            "email-i-will-get": "我要唱",
            "email-i-will-pay": "我要畀",
            "email-pickup-before": "在此時間前拎錢",
            "email-product-confirmed-greeting": "親愛的客戶：<br><br>感謝您使用HyperAir，我們已為您準備好您嘅憑證！",
            "email-product-confirmed-subject": "訂單已經確認",
            "email-product-confirmed-title": "您嘅訂單已成功確認",
            "email-product-purchased": {
                "shipping": {
                    "international": "跨國運送",
                    "sf": "順豐速遞 （只限香港）"
                }
            },
            "email-product-purchased-delievery-address": "收貨地址",
            "email-product-purchased-delivery-info": "送貨詳情",
            "email-product-purchased-delivery-method": "物流方式",
            "email-product-purchased-discount": "折扣",
            "email-product-purchased-email": "電郵",
            "email-product-purchased-greeting": "親愛的客戶：<br><br>很好嘅選擇！只係我哋仍然需要一點時間去確認您嘅預訂。不過別擔心，大多數時候我哋將在12小時內確認訂單，在這段時間請您稍候，我們將盡速回覆您訂單確認事宜。感謝您使用HyperAir！",
            "email-product-purchased-have-a-nice-trip": "祝旅途愉快！",
            "email-product-purchased-important-notice": "須受條款及細則約束。",
            "email-product-purchased-important-notice-content": "須受條款及細則約束。",
            "email-product-purchased-name": "姓名",
            "email-product-purchased-order-date": "落單日期",
            "email-product-purchased-order-details": "訂單詳情",
            "email-product-purchased-order-no": "訂單編號",
            "email-product-purchased-personal-info": "個人資料",
            "email-product-purchased-receipient-name": "收貨人名稱",
            "email-product-purchased-receipient-phone-no": "聯絡電話",
            "email-product-purchased-shipping-fee": "運費",
            "email-product-purchased-sub-total": "小計",
            "email-product-purchased-subject": "訂單待確認",
            "email-product-purchased-title": "您嘅訂單正在等待確認",
            "email-product-purchased-total": "總金額",
            "email-product-simcapurchased-personal-info": "Personal Info",
            "email-product-simcard-delivery-title": "您嘅訂單 SIM{order}-num 已於{date} 準備完畢並已寄出。如選擇順豐速遞，我們稍後將提供快遞單號，您亦可以於我哋嘅手機app查看。",
            "email-product-simcard-delivery-title-carbon-format": "Y-m-d",
            "email-product-simcard-delivery-update-greeting": "親愛的客戶,<br><br>感謝您使用HyperAir. 您所購買的SIM卡已在運送途中.",
            "email-product-simcard-delivery-update-title": "您所購買的SIM卡已經寄岀",
            "email-product-simcard-delivery-update-tracking": "物流詳情",
            "email-product-simcard-delivery-update-tracking-no": "Tracking Number",
            "email-product-simcard-delivery-update-tracking-no-hkpost": "快遞單號: -",
            "email-product-simcard-delivery-update-tracking-no-sf": "快遞單號",
            "email-product-simcard-delivery-waiting-update-tracking-no-sf": "正等候順豐速遞提供",
            "email-product-simcard-delivery-with-tracking-num-title": "您嘅訂單 SIM{order}-num 將由順豐速遞為您派送，快遞單號: {tracking}-num，請您保持手機暢通，注意收貨通知。您亦可以於順豐速運網站查看運送狀況。非常感謝您對HyperAir的支持。",
            "email-product-simcard-esim-code-greeting": "親愛的客戶：<br><br>感謝您使用HyperAir，以下是你的eSIM啟用QR碼！",
            "email-product-simcard-esim-code-important-notice-content": "<span style=\"font-size: 10px; line-height: 12px;\">使用說明：<br />1. 前往「設定」<br />2. 點一下「流動網絡」或「流動數據」<br />3. 點一下「加入流動網絡計劃」<br />4. 使用 iPhone 掃描 QR 碼<br />如果在啟用 eSIM 時，系統要求你輸入確認碼，請輸入電訊商提供的號碼。如有需要，請電郵至hello@hyperair.com查詢。</span>",
            "email-product-simcard-esim-code-title": "以下是你的eSIM啟用QR碼",
            "email-product-simcard-esim-code-warning": "請注意！以下QR碼一經掃描後eSIM即可啟動，請務必在使用時才掃描開通。",
            "email-product-simcard-purchased-delievery-address": "收貨地址",
            "email-product-simcard-purchased-delivery-info": "送貨詳情",
            "email-product-simcard-purchased-delivery-method": "物流方式",
            "email-product-simcard-purchased-discount": "折扣",
            "email-product-simcard-purchased-greeting": "親愛的客戶：<br><br>感謝您使用HyperAir，我們正在為您的旅遊SIM卡訂單安排出貨！",
            "email-product-simcard-purchased-greeting-esim-only": "親愛的客戶：<br><br>感謝您使⽤HyperAir，您的eSIM已經預備好！請打開附件跟住使用說明開通。",
            "email-product-simcard-purchased-greeting-esim-with-sim": "親愛的客戶：<br><br>感謝您使⽤HyperAir，我哋正在為您的旅遊SIM卡訂單安排出貨！此外，您的eSIM已經預備好，請打開附件同埋跟住使用說明開通。",
            "email-product-simcard-purchased-greeting-sim-only": "親愛的客戶：<br><br>感謝您使用HyperAir，我們正在為您的旅遊SIM卡訂單安排出貨！",
            "email-product-simcard-purchased-have-a-nice-trip": "祝旅途愉快！",
            "email-product-simcard-purchased-important-notice": "注意事項",
            "email-product-simcard-purchased-important-notice-content": "<span style=\"font-size: 10px; line-height: 12px;\">1. 如果以香港郵政平郵寄送，大概5個工作天內送達。如貨品由香港郵政平郵寄出，將不設郵寄編號作追查，客戶需承擔平郵延誤及寄失的風險。</span><br> <span style=\"font-size: 10px; line-height: 12px;\">2. 請留意旅遊SIM卡的有效日期，逾期使用將不會安排重新發貨。</span><br> <span style=\"font-size: 10px; line-height: 12px;\">3. 所有送遞貨品均受條款及細則約束。</span><br><br> <span style=\"font-size: 10px; line-height: 12px;\">如有需要，請電郵至hello@hyperair.com查詢。</span>",
            "email-product-simcard-purchased-important-notice-content-esim-only": "<span style=\"font-size: 10px; line-height: 12px;\">1. 如果以香港郵政平郵寄送，大概5個工作天內送達。如貨品由香港郵政平郵寄出，將不設郵寄編號作追查，客戶需承擔平郵延誤及寄失的風險。</span><br> <span style=\"font-size: 10px; line-height: 12px;\">2. 請留意旅遊SIM卡的有效日期，逾期使用將不會安排重新發貨。</span><br> <span style=\"font-size: 10px; line-height: 12px;\">3. 所有送遞貨品均受條款及細則約束。</span><br><br> <span style=\"font-size: 10px; line-height: 12px;\">如有需要，請電郵至hello@hyperair.com查詢。</span>",
            "email-product-simcard-purchased-important-notice-content-esim-with-sim": "<span style=\"font-size: 10px; line-height: 12px;\">1. 如果以香港郵政平郵寄送，大概5個工作天內送達。如貨品由香港郵政平郵寄出，將不設郵寄編號作追查，客戶需承擔平郵延誤及寄失的風險。</span><br> <span style=\"font-size: 10px; line-height: 12px;\">2. 請留意旅遊SIM卡的有效日期，逾期使用將不會安排重新發貨。</span><br> <span style=\"font-size: 10px; line-height: 12px;\">3. 所有送遞貨品均受條款及細則約束。</span><br><br> <span style=\"font-size: 10px; line-height: 12px;\">如有需要，請電郵至hello@hyperair.com查詢。</span>",
            "email-product-simcard-purchased-important-notice-content-sim-only": "<span style=\"font-size: 10px; line-height: 12px;\">1. 如果以香港郵政平郵寄送，大概5個工作天內送達。如貨品由香港郵政平郵寄出，將不設郵寄編號作追查，客戶需承擔平郵延誤及寄失的風險。</span><br> <span style=\"font-size: 10px; line-height: 12px;\">2. 請留意旅遊SIM卡的有效日期，逾期使用將不會安排重新發貨。</span><br> <span style=\"font-size: 10px; line-height: 12px;\">3. 所有送遞貨品均受條款及細則約束。</span><br><br> <span style=\"font-size: 10px; line-height: 12px;\">如有需要，請電郵至hello@hyperair.com查詢。</span>",
            "email-product-simcard-purchased-order-date": "落單日期",
            "email-product-simcard-purchased-order-details": "訂單詳情",
            "email-product-simcard-purchased-order-no": "訂單編號",
            "email-product-simcard-purchased-personal-info": "Personal Info",
            "email-product-simcard-purchased-receipient-name": "收貨人名稱",
            "email-product-simcard-purchased-receipient-phone-no": "收貨人聯繫電話",
            "email-product-simcard-purchased-shipping-fee": "運費",
            "email-product-simcard-purchased-sub-total": "小計",
            "email-product-simcard-purchased-title": "您嘅旅遊SIM卡訂單已確認",
            "email-product-simcard-purchased-title-esim-only": "您嘅旅遊eSIM卡訂單已確認",
            "email-product-simcard-purchased-title-esim-with-sim": "您嘅旅遊SIM卡訂單已確認",
            "email-product-simcard-purchased-title-sim-only": "您嘅旅遊SIM卡訂單已確認",
            "email-product-simcard-purchased-total": "總金額",
            "email-product-simcard-tracking-number-updated-greeting": "親愛的客戶,<br><br>再次感謝您使用HyperAir. 您的快遞單號已經更新了.",
            "email-product-simcard-tracking-number-updated-title": "您的快遞詳情已經更新",
            "email-product-simcard-tracking-number-updated-tracking-no-sf": "快遞單號",
            "email-product-type-confirmed-greeting": "親愛的客戶,<br><br>感謝您使用HyperAir. 您所購買的商品已在運送途中.",
            "email-product-type-confirmed-title": "您嘅商品已經寄岀",
            "email-product-type-purchased-greeting": "親愛的客戶：<br><br>感謝您使用HyperAir，我們正在為您的商品安排岀貨！",
            "email-product-type-purchased-title": "您嘅商品訂單",
            "email-rate": "匯率",
            "email-shop-name": "兌換店名稱",
            "email-verification-action": "確認電郵地址",
            "email-verification-content": "非常感謝您加入HyperAir！我哋想確認您所輸入嘅電郵地址係正確。請㩒下面個制啟用您嘅帳戶：",
            "email-verification-title": "請確認您註冊嘅電郵地址",
            "email-verified-content": "您嘅電郵已驗證。歡迎加入HyperAir！",
            "email-verified-title": "已成功驗證電郵",
            "engagement-content": "Use welcome10",
            "engagement-title": "Use welcome10",
            "exchange-approved-content": "確認於匯率 {rate} 買入 {amount} {currency}。",
            "exchange-approved-content2": "確認於匯率 {rate} 賣出 {amount} {currency}。",
            "exchange-approved-footer": "感謝您使用HyperAir嘅服務。",
            "exchange-approved-title": "兌換店已回覆：「已為您準好您嘅外幣！」",
            "exchange-cancelled-content": "客人已取消柯打於匯率 {rate} 買入 {amount} {currency}。",
            "exchange-cancelled-content2": "客人已取消柯打於匯率 {rate} 賣出 {amount} {currency}。",
            "exchange-cancelled-title": "外幣柯打已取消",
            "exchange-completed-content": "已於匯率 {rate} 買入 {amount} {currency}。",
            "exchange-completed-content2": "已於匯率 {rate} 賣出 {amount} {currency}。",
            "exchange-completed-footer": "感謝您使用HyperAir嘅服務。",
            "exchange-completed-title": "您嘅外幣兌換已完成！",
            "exchange-confirmed-content": "您已確認客人可於匯率 {rate} 買入 {amount} {currency}。",
            "exchange-confirmed-content2": "您已確認客人可於匯率 {rate} 賣出 {amount} {currency}。",
            "exchange-confirmed-footer": "感謝您使用HyperAir嘅服務。",
            "exchange-confirmed-title": "已收到外幣新柯打",
            "exchange-pending-content": "核實新柯打：於匯率 {rate} 買入 {amount} {currency}。",
            "exchange-pending-content2": "核實新柯打：於匯率 {rate} 賣出 {amount} {currency}。",
            "exchange-pending-title": "新柯打等您確認",
            "exchange-rejected-content": "這店未能處理於匯率 {rate} 買入 {amount} {currency}。 請於另一家兌換店預訂。",
            "exchange-rejected-content2": "這店未能處理於匯率 {rate} 賣出 {amount} {currency}。 請於另一家兌換店預訂。",
            "exchange-rejected-title": "哎喲！很抱歉，兌換店無法處理您嘅訂單。",
            "footer-trouble-link": "如果您在點擊“{actionText}”按鈕時遇到問題，請將以下網址複製並貼到您的瀏覽器： <a href=\"{actionUrl}\">{actionUrl}</a>",
            "password-reset-action": "重設密碼",
            "password-reset-content": "您收到呢個電郵喺因為我哋收到了您嘅密碼重置請求。",
            "password-reset-footer": "如果您沒有要求重置密碼，您唔需要採取進一步嘅操作。",
            "password-reset-title": "重設密碼",
            "simcard-purchased-title": "您嘅旅遊SIM卡訂單已確認",
            "sms-verification-content": "你的 HyperAir 驗證碼是 {verificationCode}"
        },
        "error": {
            "all-shops-are-closed": "喔噢，兌換店辛苦咗一日正在休息。請遲啲再搵佢哋報個靚價啦。",
            "cancel-booking-failed": "此訂單已完成、逾期或被取消。請檢查 [我的訂單>已完成] 或 [我的訂單>未能完成] 中嘅訂單。",
            "cancel-booking-failed-title": "無法取消此訂單",
            "invalid-api-app-version": "立即更新APP以獲取最新功能及以95折購買旅遊SIM卡 (優惠碼GIVEME5)",
            "invalid-old-password": "現有密碼錯誤。",
            "password-incorrect": "密碼錯誤。",
            "phone-number-is-already-registered": "此手機號碼已被另一電郵地址註冊，請使用該電郵地址登入。如需要提供協助，請電郵至hello@hyperair.com。",
            "this-email-is-registered": "",
            "this-phone-number-is-registered": "此手機號碼已被註冊。如需要提供協助，請電郵至hello@hyperair.com。"
        },
        "marketplace": {
            "homepage-product": "熱門產品",
            "homepage-recently-viewed": "最近瀏覽",
            "product-carousels": {
                "group1": "熱門推介",
                "group2": "口碑之選"
            }
        }
    },
    "zh-TW": {
        "currency": {
            "aed": "阿聯酋迪拉姆",
            "afn": "阿富汗尼",
            "all": "阿爾巴尼亞列克",
            "amd": "亞美尼亞德拉姆",
            "ang": "荷屬安的列斯盾",
            "aoa": "安哥拉寬紮",
            "ars": "阿根廷比索",
            "aud": "澳元",
            "awg": "阿魯巴弗羅林",
            "azn": "亞塞拜然馬納特",
            "bam": "波士尼亞馬克",
            "bbd": "巴貝多元",
            "bdt": "孟加拉塔卡",
            "bgn": "保加利亞列弗",
            "bhd": "巴林第納爾",
            "bif": "蒲隆地法郎",
            "bnd": "汶萊元",
            "bob": "玻利維亞比索",
            "brl": "巴西雷亞爾",
            "bsd": "巴哈馬元",
            "btc": "比特幣",
            "btn": "不丹努爾特魯姆",
            "bwp": "波札那普拉",
            "byn": "白俄羅斯盧布",
            "bzd": "貝里斯元",
            "cad": "加拿大元",
            "cdf": "剛果法郎",
            "chf": "瑞士法郎",
            "clp": "智利比索",
            "cop": "哥倫比亞比索",
            "crc": "哥斯達黎加科朗",
            "cup": "古巴比索",
            "cve": "維德角群島埃斯庫多",
            "czk": "捷克克朗",
            "djf": "吉布提法郎",
            "dkk": "丹麥克朗",
            "dop": "多米尼加比索",
            "dzd": "阿爾及利亞第納爾",
            "egp": "埃及鎊",
            "ern": "厄立特里亞納克法",
            "etb": "埃塞俄比亞比爾",
            "eur": "歐元",
            "fjd": "斐濟元",
            "fkp": "福克蘭群島鎊",
            "gbp": "英鎊",
            "gel": "格魯吉亞拉里",
            "ghs": "加納塞地",
            "gip": "直布羅陀鎊",
            "gmd": "岡比亞達拉西",
            "gnf": "幾內亞法郎",
            "gtq": "危地馬拉格查爾",
            "gyd": "圭亞那元",
            "hkd": "港元",
            "hnl": "洪都拉斯倫皮拉",
            "hrk": "克羅埃西亞庫納",
            "htg": "海地古德",
            "huf": "匈牙利福林",
            "idr": "印尼盾",
            "ils": "以色列謝克爾",
            "inr": "印度盧比",
            "iqd": "伊拉克第納爾",
            "irr": "伊朗里亞爾",
            "isk": "冰島克朗",
            "jmd": "牙買加元",
            "jod": "約旦第納爾",
            "jpy": "日元",
            "kes": "肯尼亞先令",
            "kgs": "吉爾吉斯索姆",
            "khr": "柬埔寨瑞爾",
            "kmf": "葛摩法郎",
            "kpw": "朝鮮圓",
            "krw": "韓圜",
            "kwd": "科威特第納爾",
            "kyd": "開曼元",
            "kzt": "哈薩克堅戈",
            "lak": "老撾基普",
            "lbp": "黎巴嫩鎊",
            "lkr": "斯里蘭卡盧比",
            "lrd": "利比里亞元",
            "lsl": "萊索托洛蒂",
            "lvl": "拉脫維亞拉特",
            "lyd": "利比亞第納爾",
            "mad": "摩洛哥迪拉姆",
            "mdl": "摩爾多瓦列伊",
            "mga": "馬達加斯加阿里亞里",
            "mkd": "馬其頓第納爾",
            "mmk": "緬甸元",
            "mnt": "蒙古圖格里克",
            "mop": "澳門元",
            "mro": "毛里塔尼亞烏吉亞",
            "mur": "毛里求斯盧比",
            "mvr": "馬爾代夫盧比",
            "mwk": "馬拉維克瓦查",
            "mxn": "墨西哥比索",
            "myr": "馬來西亞幣",
            "mzn": "莫三比克梅蒂卡爾",
            "nad": "納米比亞元",
            "ngn": "尼日利亞奈拉",
            "nio": "尼加拉瓜金科多巴",
            "nok": "挪威克朗",
            "npr": "尼泊爾盧比",
            "nzd": "新西蘭元",
            "omr": "阿曼里亞爾",
            "pab": "巴拿馬巴波亞",
            "pen": "秘魯新索爾",
            "pgk": "巴布亞基納",
            "php": "菲律賓比索",
            "pkr": "巴基斯坦盧比",
            "pln": "波蘭茲羅提",
            "pyg": "巴拉圭瓜拉尼",
            "qar": "卡塔爾里亞爾",
            "rmb": "人民幣",
            "ron": "羅馬尼亞列伊",
            "rsd": "塞爾維亞第納爾",
            "rub": "俄羅斯盧布",
            "rwf": "盧旺達法郎",
            "sar": "沙特里亞爾",
            "sbd": "所羅門群島元",
            "scr": "塞舌爾盧比",
            "sdg": "蘇丹第納爾",
            "sek": "瑞典克朗",
            "sgd": "星加坡元",
            "shp": "聖赫勒拿群島鎊",
            "sll": "塞拉利昂 利昂",
            "sos": "索馬利亞先令",
            "srd": "蘇利南元",
            "std": "圣多美和普林西比多布拉",
            "syp": "敘利亞鎊",
            "szl": "斯威士蘭 里蘭吉尼",
            "thb": "泰國銖",
            "tjs": "塔吉克共和國 索莫尼",
            "tmt": "土庫曼斯坦馬納特",
            "tnd": "突尼斯第納爾",
            "top": "湯加潘加",
            "try": "土耳其里拉",
            "ttd": "特立尼達和多巴哥元",
            "twd": "新臺幣",
            "tzs": "坦桑尼亞先令",
            "uah": "烏克蘭格里夫納",
            "ugx": "烏干達先令",
            "usd": "美元",
            "uyu": "烏拉圭比索",
            "uzs": "烏茲別克斯坦索姆",
            "vef": "委內瑞拉玻利瓦爾",
            "vnd": "越南盾",
            "vuv": "瓦努阿圖瓦圖",
            "wst": "薩摩亞塔拉",
            "xaf": "中非共同體法郎",
            "xcd": "東加勒比元",
            "xdr": "國際貨幣基金組織特別提款權",
            "xof": "西非國家中央銀行非洲法郎",
            "xpf": "太平洋法郎",
            "yer": "也門里亞爾",
            "zar": "南非蘭特",
            "zmw": "尚比亞克瓦查"
        },
        "shop-currency-rate": {
            "rate-last-updated-x-days-ago": "匯率{time}日前更新",
            "rate-last-updated-x-hours-ago": "匯率{time}小時前更新"
        },
        "hyperair": {
            "copyright-footer": "© 2018 HyperAir Incorporation Limited. 版權所有",
            "today": "今日"
        },
        "product-simcard": {
            "shipping-methods": {
                "hkpost": "平郵（免費）",
                "international": "跨國運送",
                "sf": "順豐速遞 （只限香港，貨到付運費。訂單滿HK$399，即可免運費）"
            }
        },
        "country": {
            "afghanistan": "阿富汗",
            "aland-islands": "奧蘭群島",
            "albania": "阿爾巴尼亞",
            "algeria": "阿爾及利亞",
            "andorra": "安道爾",
            "angola": "安哥拉",
            "anguilla": "安圭拉",
            "antigua-&-barbuda": "安提瓜和巴布達",
            "antigua-barbuda": "安地卡及巴布達",
            "argentina": "阿根廷",
            "armenia": "阿美尼亞",
            "aruba": "阿魯巴",
            "australia": "澳洲",
            "austria": "奧地利",
            "azerbaijan": "阿塞拜疆",
            "azores": "亞速爾群島",
            "bahamas": "巴哈馬",
            "bahrain": "巴林",
            "bangladesh": "孟加拉國",
            "barbados": "巴巴多斯",
            "belarus": "白俄羅斯",
            "belgium": "比利時",
            "belize": "伯利茲",
            "benin": "貝寧",
            "bermuda": "百慕達",
            "bhutan": "不丹",
            "bolivia": "玻利維亞",
            "bonaire": "博奈爾",
            "bosnia-herzegovina": "波斯尼亞和黑塞哥維那",
            "botswana": "博茨瓦納",
            "brazil": "巴西",
            "british-virgin-islands": "英屬維爾京群島",
            "brunei": "文萊",
            "bulgaria": "保加利亞",
            "burkina-faso": "布基納法索",
            "burundi": "布隆迪",
            "cambodia": "柬埔寨",
            "cameroon": "喀麥隆",
            "canada": "加拿大",
            "canary-islands": "加那利群島",
            "cape-verde-islands": "佛得角群島",
            "cayman-islands": "開曼群島",
            "central-african-republic": "中非共和國",
            "chad": "乍得",
            "chile": "智利",
            "china": "中國",
            "colombia": "哥倫比亞",
            "comoros": "科摩羅",
            "congo": "剛果",
            "cook-islands": "庫克群島",
            "costa-rica": "哥斯達黎加",
            "cote-d-ivoire": "科特迪瓦科特迪瓦",
            "croatia": "克羅地亞",
            "cruise-ship": "遊輪",
            "cuba": "古巴",
            "curacao": "庫拉索",
            "cyprus": "塞浦路斯",
            "cyprus---north": "塞浦路斯",
            "cyprus---south": "塞浦路斯",
            "czech-republic": "捷克共和國",
            "denmark": "丹麥",
            "djibouti": "吉布提",
            "dominica": "多米尼加",
            "dominican-republic": "多明尼加共和國",
            "dubai": "杜拜",
            "easter-island": "復活節島",
            "ecuador": "厄瓜多爾",
            "egypt": "埃及",
            "el-salvador": "薩爾瓦多",
            "equatorial-guinea": "赤道幾內亞",
            "eritrea": "厄立特里亞",
            "estonia": "愛沙尼亞",
            "ethiopia": "埃塞俄比亞",
            "europe": "歐洲",
            "falkland-islands": "福克蘭群島",
            "faroe-islands": "法羅群島",
            "fiji": "斐濟",
            "finland": "芬蘭",
            "france": "法國",
            "french-guiana": "法屬圭亞那",
            "french-polynesia": "法屬波利尼西亞",
            "french-west-indies": "法屬西印度群島",
            "gabon": "加蓬",
            "gambia": "岡比亞",
            "georgia": "格魯吉亞",
            "germany": "德國",
            "ghana": "加納",
            "gibraltar": "直布羅陀",
            "greece": "希臘",
            "greenland": "格陵蘭",
            "grenada": "格林納達",
            "guadeloupe": "瓜德羅普島",
            "guam": "關島",
            "guatemala": "危地馬拉",
            "guernsey": "根西島",
            "guinea": "幾內亞",
            "guinea---bissau": "幾內亞比紹",
            "guinea-bissau": "幾內亞比紹",
            "guyana": "圭亞那",
            "haiti": "海地",
            "honduras": "洪都拉斯",
            "hong-kong": "香港",
            "hungary": "匈牙利",
            "iceland": "冰島",
            "india": "印度",
            "indonesia": "印尼",
            "iran": "伊朗",
            "iraq": "伊拉克",
            "ireland": "愛爾蘭",
            "isle-of-man": "馬恩島",
            "israel": "以色列",
            "italy": "意大利",
            "jamaica": "牙買加",
            "japan": "日本",
            "jersey": "澤西",
            "jordan": "約旦",
            "kazakhstan": "哈薩克斯坦",
            "kenya": "肯尼亞",
            "kiribati": "基里巴斯",
            "kosovo": "科索沃",
            "kuwait": "科威特",
            "kyrgyz-republic": "吉爾吉斯共和國",
            "kyrgyzstan": "吉爾吉斯斯坦",
            "laos": "老撾",
            "latvia": "拉脫維亞",
            "lebanon": "黎巴嫩",
            "lesotho": "萊索托",
            "liberia": "利比里亞",
            "libya": "利比亞",
            "liechtenstein": "列支敦士登",
            "lithuania": "立陶宛",
            "luxembourg": "盧森堡",
            "macau": "澳門",
            "macedonia": "馬其頓",
            "madagascar": "馬達加斯加",
            "madeira": "馬德拉",
            "malawi": "馬拉維",
            "malaysia": "馬來西亞",
            "maldives": "馬爾代夫",
            "mali": "馬里",
            "malta": "馬耳他",
            "marshall-islands": "馬紹爾群島",
            "martinique": "馬提尼克",
            "mauritania": "毛里塔尼亞",
            "mauritius": "毛里求斯",
            "mayotte": "馬約特",
            "mexico": "墨西哥",
            "micronesia": "密克羅尼西亞",
            "moldova": "摩爾多瓦",
            "monaco": "摩納哥",
            "mongolia": "蒙古",
            "montenegro": "黑山",
            "montserrat": "蒙特塞拉特",
            "morocco": "摩洛哥",
            "mozambique": "莫桑比克",
            "myanmar": "緬甸",
            "namibia": "納米比亞",
            "nauru": "瑙魯",
            "nepal": "尼泊爾",
            "netherlands": "荷蘭",
            "netherlands-antilles": "荷屬安的列斯",
            "new-caledonia": "新喀裡多尼亞",
            "new-zealand": "紐西蘭",
            "nicaragua": "尼加拉瓜",
            "niger": "尼日爾",
            "nigeria": "尼日利亞",
            "niue": "紐埃",
            "norfolk-islands": "諾福克群島",
            "north-korea": "北朝鮮",
            "northern-marianas": "北馬里亞納",
            "norway": "挪威",
            "oman": "阿曼",
            "pakistan": "巴基斯坦",
            "palau": "帕勞",
            "palestine": "巴勒斯坦",
            "panama": "巴拿馬",
            "papua-new-guinea": "巴布亞新幾內亞",
            "paraguay": "巴拉圭",
            "peru": "秘魯",
            "philippines": "菲律賓",
            "poland": "波蘭",
            "portugal": "葡萄牙",
            "puerto-rico": "波多黎各",
            "qatar": "卡塔爾",
            "reunion": "留尼旺",
            "romania": "羅馬尼亞",
            "russia": "俄羅斯",
            "rwanda": "盧旺達",
            "saint-barthelemy": "聖巴托洛繆島",
            "saint-martin": "聖馬丁",
            "saint-pierre-&-miquelon": "聖皮埃爾和密克隆",
            "samoa": "薩摩亞",
            "san-marino": "聖馬力諾",
            "sao-tome-&-principe": "聖多美和普林西比",
            "sao-tome-principe": "聖多美普林西比",
            "satellite": "衛星",
            "saudi-arabia": "沙特阿拉伯",
            "senegal": "塞內加爾",
            "serbia": "塞爾維亞",
            "seychelles": "塞舌爾",
            "sierra-leone": "塞拉利昂",
            "singapore": "新加坡",
            "slovak-republic": "斯洛伐克共和國",
            "slovakia": "斯洛伐克",
            "slovenia": "斯洛文尼亞",
            "solomon-islands": "所羅門群島",
            "somalia": "索馬里",
            "south-africa": "南非",
            "south-korea": "韓國",
            "spain": "西班牙",
            "sri-lanka": "斯里蘭卡",
            "st-helena": "聖赫倫那",
            "st-kitts": "聖克里斯多福島",
            "st-kitts-&-nevis": "聖基茨和尼維斯",
            "st-lucia": "聖盧西亞",
            "st-vincent": "聖文森特",
            "st.-helena": "聖海倫娜",
            "st.-kitts": "聖基茨",
            "st.-lucia": "聖盧西亞",
            "sudan": "蘇丹",
            "suriname": "蘇里南",
            "swaziland": "斯威士蘭",
            "sweden": "瑞典",
            "switzerland": "瑞士",
            "syria": "敘利亞",
            "taiwan": "台灣",
            "tajikistan": "塔吉克斯坦",
            "tanzania": "坦桑尼亞",
            "thailand": "泰國",
            "timor-l'este": "東帝汶埃斯特",
            "togo": "多哥",
            "tonga": "湯加",
            "trinidad-&-tobago": "特立尼達和多巴哥",
            "trinidad-tobago": "千里達及托巴哥",
            "tunisia": "突尼斯",
            "turkey": "土耳其",
            "turkmenistan": "土庫曼斯坦",
            "turks-&-caicos": "特克斯和凱科斯群島",
            "turks-&-caicos-islands": "特克斯和凱科斯群島",
            "turks-caicos-islands": "土克凱可群島",
            "uganda": "烏干達",
            "ukraine": "烏克蘭",
            "united-arab-emirates": "阿拉伯聯合酋長國",
            "united-kingdom": "英國",
            "united-states": "美國",
            "united-states-minor-outlying-islands": "美國本土外小島嶼",
            "uruguay": "烏拉圭",
            "uzbekistan": "烏茲別克斯坦",
            "vanuatu": "瓦努阿圖",
            "vatican-city": "梵蒂岡城",
            "venezuela": "委內瑞拉",
            "vietnam": "越南",
            "virgin-islands": "維爾京群島",
            "virgin-islands-(us)": "維爾京群島（美國）",
            "wallis-&-futuna": "瓦利斯和富圖納",
            "wallis-futuna": "瓦利斯和富圖納",
            "yemen": "也門",
            "zambia": "贊比亞",
            "zimbabwe": "津巴布韋"
        },
        "inspiration": {
            "published-date": "Y年n月",
            "published-duration": "{duration}日前",
            "published-duration-singular": "昨天",
            "published-duration-today": "今天"
        },
        "promotion-center": {
            "expires-at": "有效期至",
            "redeem": {
                "error": {
                    "already-redeemed": "已兌換優惠劵",
                    "new-customer-only": "此優惠只適用於新客戶",
                    "not-found": "優惠碼無效"
                }
            }
        },
        "auth": {
            "failed": "",
            "throttle": ""
        },
        "web": {
            "activity": {
                "countdown-title": "",
                "more-button": "更多玩樂體驗",
                "section-subtitle": "幫您比較各個網站，搵最正最抵嘅玩樂體驗",
                "section-title": "玩樂體驗價格比較"
            },
            "checkout": {
                "use-promo-code": "使用優惠券"
            },
            "checkout-failed": {
                "checkout-failed": ""
            },
            "checkout-success": {
                "checkout-success": "付款成功",
                "continue-shopping-button": "繼續瀏覽",
                "done-button": "搞掂👌🏻",
                "download-now": "立即下載",
                "order-number": "訂單編號",
                "register-email": "你嘅電郵",
                "register-password": "設定密碼",
                "sim-product": "你已成功購買<span class=\"bold\"> {sim} </span>，電郵確認訂單將發送至 {email}。",
                "slogan": "立即打開 HyperAir app，盡享玩樂禮遇！仲可以即刻喺App到追蹤訂單。",
                "slogan-password": "還有一步，即享$10迎新SIM卡優惠！仲可以即刻喺App到追蹤訂單。",
                "trace-order": "",
                "trace-order-password": "",
                "welcome-offer": "仲差一步，註冊即享$10迎新SIM卡獎賞！仲可以即喺App度追蹤嘅訂單。"
            },
            "country": {
                "all": "所有",
                "contact-us-description": "如有任何疑問，歡迎發送電郵到<a href=\"mailto:corporate@hyperair.com\\>corporate@hyperair.com</a>查詢",
                "data": "數據流量：",
                "day": "日數：",
                "day-day": "日",
                "esim": "eSIM",
                "esim-section-title": "為你搜羅{country}嘅旅遊 eSIM",
                "num-of-review": "{num}-of-review個旅客評分",
                "per-day": "每日",
                "phone-call": "當地通話",
                "plug-n-go": "即插即用",
                "plug-n-go-esim": "即買即用",
                "plug-n-go-sim": "即插即用",
                "section-title": "為你搜羅{country}嘅旅遊 SIM",
                "section-title copy": "為你搜羅{country}最正嘅旅遊 SIM",
                "sim": "SIM",
                "supplier": "網絡商："
            },
            "download-app-banner": {
                "download-now": "立即下載 App",
                "hyperair": "HyperAir",
                "subtitle": "下載 HyperAir 應用程式並首次登記，即享 HK$10 優惠迎新禮遇！",
                "title": "隨時隨地 醒目旅遊"
            },
            "email-subscription": {
                "cancel-button": "再諗一諗",
                "completed-subscribe": "多謝你嘅訂閱",
                "confirm-button": "我要最抵優惠",
                "duplicate-email": "你的電郵已經訂閱了",
                "invalid-email": "無效或錯誤的電郵地址",
                "title-1": "想Staycation價格跌至新低時通知你？",
                "title-2": "仲搜羅全城最抵既Staycation 及美食套餐優惠"
            },
            "fanfare": {
                "cover-title": "SIM卡 Fanfares",
                "datetime-format": "n月d日",
                "end-next-fanfare": "下次開售時間:",
                "end-title": "想知SIM卡優惠嘅開售時間及更多超筍玩樂優惠? 立即下載同follow我哋嘅APP及社交平台啦！",
                "end-title2": "想知更多超筍玩樂優惠? 立即下載同follow我哋嘅APP及社交平台啦！",
                "more-details-button": "優惠詳情",
                "out-of-stock": "返貨中",
                "popular-countries-subtitle": "免費平郵，極速送到",
                "popular-countries-title": "熱門 SIM 卡目的地",
                "section-title": "多款 SIM 卡以超優惠價發售",
                "title": "限時優惠 限量特價",
                "x-inventory-left": "最後{inventory}張"
            },
            "fanfare-breadcrumb": "SIM卡 Fanfares",
            "filter-button": {
                "filter": "篩選"
            },
            "filter-container": {
                "apply": "篩選",
                "category": "分類",
                "category-aquarium": "水族館",
                "category-class": "課程",
                "category-day-tour": "半日+一日遊",
                "category-discount": "優惠",
                "category-diving": "潛水",
                "category-food": "美食",
                "category-massage-beauty": "按摩及美容",
                "category-museum": "博物館",
                "category-musical": "音樂劇",
                "category-outlet": "Outlet",
                "category-photography": "攝影",
                "category-playground": "遊樂場",
                "category-railway": "鐵路",
                "category-show": "表演",
                "category-ski": "滑雪",
                "category-spa": "溫泉",
                "category-theme-park": "樂園",
                "category-ticket": "門票",
                "category-transport": "接送+包車",
                "category-transport-ticket": "車票",
                "category-vr": "VR",
                "category-water-park": "水上樂園",
                "category-yoga": "瑜伽",
                "category-zoo": "動物園",
                "clear-all": "重設",
                "facilities": "設施及套餐特點",
                "filter": "篩選",
                "food": "飲食",
                "header": "篩選",
                "popular-search": "人氣搜尋🔥",
                "price": "價格",
                "provider": "旅遊平台",
                "subcategory-buffet": "自助餐",
                "subcategory-car": "包車",
                "subcategory-facial": "美容",
                "subcategory-food": "美食",
                "subcategory-half-day-tour": "半日遊",
                "subcategory-massage": "按摩",
                "subcategory-meal-voucher": "餐券",
                "subcategory-one-day-tour": "一日遊",
                "subcategory-restaurant": "餐廳",
                "subcategory-transport": "接送",
                "tag": "主題"
            },
            "footer": {
                "about-hyperair-description": "HyperAir 係一間旅遊科技初創，旨在為旅行愛好者提供最醒目嘅方式去準備和享受旅行。",
                "download-now": "立即下載",
                "email-subscription-button": "立即訂閱",
                "email-subscription-placeholder": "輸入你的電郵",
                "email-subscription-social-title": "或立即追蹤我地既社交平台",
                "email-subscription-title": "想知更多 Staycation 優惠嘅<br />開售時間及更多超筍玩樂優惠?",
                "travel-license": "旅行代理商牌照號碼："
            },
            "fx-booking": {
                "back-button": "更改訂單",
                "confirm-booking": "核對資料",
                "confirm-button": "確認訂單",
                "contact-shop": "如果您無法準時到達，請致電兌換店或取消訂單。",
                "get-money-before": "請於以下時間前提取。"
            },
            "home": {
                "cover-button": "立即體驗",
                "cover-subtitle": "從 HyperAir 開始",
                "cover-title": "一次過，比較全球多個玩樂旅遊預訂網站",
                "grid": {
                    "1": {
                        "subtitle": "最HIT旅遊情報",
                        "title": "愛貓之城伊斯坦堡 歷史大教堂有守護貓"
                    },
                    "2": {
                        "subtitle": "最HIT旅遊情報",
                        "title": "東京奧運，最後倒數"
                    },
                    "3": {
                        "subtitle": "最抵之選",
                        "title": "網上SIM卡至低價保證"
                    },
                    "4": {
                        "subtitle": "限時優惠 限量特價",
                        "title": "SIM 卡 Fanfares"
                    },
                    "5": {
                        "subtitle": "必追景點",
                        "title": "願原力與你同在！迪士尼星戰園區現已開幕"
                    }
                },
                "home-example": {
                    "column-subtitle-1": "以2人日本7日遊為例：",
                    "column-subtitle-2": "價格比較",
                    "column-title-1": "一次旅行，同你慳到盡",
                    "column-title-2": "比較多間國際旅遊平台",
                    "hotel": "酒店優惠",
                    "hotel-package-1": "大阪日航酒店7日6夜",
                    "insurance": "旅遊保險",
                    "insurance-package-1": "7天旅遊保險 x2",
                    "money": "外幣兌換",
                    "money-package-1": "唱JPD ¥ 410,000",
                    "save": "慳",
                    "sim": "上網SIM卡",
                    "sim-package-1": "日本7天DoCoMo SIM x2",
                    "slogan": "逐樣格，逐樣慳，先至係識玩！",
                    "total-saving": "一共慳 $ 1,443",
                    "travel-experience": "玩樂體驗",
                    "travel-experience-package-1": "JR Pass 全日本鐵路通票 x2",
                    "travel-experience-package-2": "日本環球影城™ 1日電子門票 x2"
                },
                "media-header-title": "媒體報導",
                "more": "更多旅遊 SIM",
                "partners-title": "合作夥伴",
                "photo-banner-button": "了解更多",
                "photo-banner-title": "唱錢神器™助您輕鬆搜尋預訂最抵匯率，唱錢快又醒!",
                "services-header-description": "",
                "services-header-title": "一站式旅遊服務",
                "services-icon-subtitle-1": "助您輕鬆搜尋預訂最抵匯率，唱錢快又醒!",
                "services-icon-subtitle-2": "為您提供多款勁抵價SIM卡，免運費送上門！",
                "services-icon-subtitle-3": "讓您探索世界，從此自主旅遊！",
                "services-icon-title-1": "唱錢神器",
                "services-icon-title-2": "旅遊SIM卡",
                "services-icon-title-3": "旅遊體驗",
                "statistic": {
                    "num-of-city": "幫用戶慳咗",
                    "num-of-comparison": "玩樂體驗",
                    "num-of-experience": "國家城市",
                    "num-of-saving": "格價次數"
                },
                "testimonial-1-content": "呢個app很好用，方便比較滙率，唔駛周圍去揾資料。很欣賞程式員佢地既用心製作，佢地都積極用心為我解決使用時的困難。推薦使用！",
                "testimonial-1-subtitle": "Android 用家",
                "testimonial-1-user": "Christine Lam",
                "testimonial-2-content": "好方便，訂SIM卡好快就送到，唔洗特登出街買SIM卡，價錢都好平吓。網絡收得幾好，上次去日本喺市區同近郊玩都好流暢！下次會再買！",
                "testimonial-2-subtitle": "iOS 用家",
                "testimonial-2-user": "Angel",
                "testimonial-header-description": "",
                "testimonial-header-title": "用家分享",
                "travel-activities": {
                    "home-slogan": "幫您比較各個網站，搵最正最抵嘅玩樂體驗"
                },
                "travel-country-header-description": "清晰分類，容易挑選",
                "travel-country-header-title": "旅遊 SIM 涵蓋 200+ 國家",
                "travel-info-header-description": "為你帶來最 Hit 旅遊靈感",
                "travel-info-header-title": "旅遊情報",
                "travel-marketplace-header-description": "",
                "travel-marketplace-header-title": "",
                "travel-sim-header-description": "勁抵價SIM卡 免費送上門",
                "travel-sim-header-title": "熱門旅遊 SIM"
            },
            "hotel": {
                "cover-subtitle": "HyperAir 客戶專享 5% Trip.com 獨家酒店折扣",
                "cover-title": "酒店優惠",
                "discount-detail": "使用 “HYPERAIR5” 優惠碼可享5%折扣",
                "discount-title": "HYPERAIR5",
                "highlight-subtitle1": "探索遍佈全球嘅酒店，為您提供與眾不同嘅住宿體驗。",
                "highlight-subtitle2": "獨家超值訂房優惠，為您省下更多旅費。",
                "highlight-subtitle3": "即時網上查看酒店價格詳情 ，全天候一按預訂。",
                "highlight-title1": "覆蓋全球",
                "highlight-title2": "優惠價格",
                "highlight-title3": "一覧無遺"
            },
            "hypermiles": {
                "activity": "項目",
                "balance": "結餘",
                "benefit": "你的會員禮遇包括:",
                "cumulative-purchase": "累積消費：HK$ {amount}",
                "diamond-black": "鑽石黑",
                "expire": "已過期的HyperMiles ({date})",
                "expire-reminder-1": "HyperMiles 於購物月份起計一年內有效",
                "expire-reminder-2": "記得到期前用嚟買嘢啦！",
                "hypermiles-total": "HyperMiles",
                "member": "會籍",
                "member-tier": "你已經成為 HyperAir {member_tier}會員。",
                "membership-details": "詳細級別",
                "next-purchase": "下次消費可即減 HK${amount}",
                "order-num": "訂單編號: {order_num}",
                "permanent-membership": "永久免費會籍",
                "popup-title": "HyperMiles 獎賞計劃",
                "precious-platinum": "尊鉑白",
                "product_purchase": "購物賺取的HyperMiles ({date})",
                "record": "HyperMiles 紀錄",
                "royal-blue": "貴族藍",
                "simcard_purchase": "買SIM卡賺取的HyperMiles ({date})",
                "tier": "",
                "title": "HyperMiles。 自主旅遊，豐富回贈！",
                "u-have": "你擁有",
                "usage": "使用HyperMiles ({date})",
                "what-is-hypermiles": "甚麼是 HyperMiles",
                "what-is-hypermiles-slogan1": "消費越多，獎賞越多",
                "what-is-hypermiles-slogan2": "每100 HyperMiles 即可購物時抵銷HK$1 ，無最低消費限制",
                "what-is-hypermiles-slogan3": "累積消費越多，更易賺取 HyperMiles"
            },
            "hypermiles-disclaimer": "優惠受條款及細則約束",
            "hypermiles-discount-diamond-black": "每消費滿 HK$1 賺取 1 HyperMiles",
            "hypermiles-discount-precious-platinum": "每消費滿 HK$1.5 賺取 1 HyperMiles",
            "hypermiles-discount-royal-blue": "每消費滿 HK$2 賺取 1 HyperMiles",
            "hypermiles-special-diamond-black": "優先獲得獨家優惠",
            "hypermiles-spend-diamond-black": "累積消費滿HK$3,000",
            "hypermiles-spend-precious-platinum": "累積消費滿HK$1,500",
            "hypermiles-spend-royal-blue": "基本會員",
            "login": {
                "email": "電郵",
                "existing-user": "現有用戶",
                "forgot-password": "忘記密碼",
                "forgot-password-please-fill-in-email": "Enter your email and we'll send you a link to get back into your account.",
                "login": "登入",
                "login-with-facebook": "Facebook 繼續",
                "login-with-google": "Google 繼續",
                "new-user": "新用戶",
                "or": "或",
                "password": "密碼",
                "phone-input-placeholder": "輸入你的電話",
                "phone-input-title": "我們需要你的電話號碼，進行SMS認證。",
                "phone-verify": "電話認證",
                "resend-verification-code": "30秒後重新發送",
                "reset-password": "重設密碼",
                "title": "登入",
                "verification-code-input-title": "請輸入你的6位數字認證碼"
            },
            "logo-loader": {
                "slogan": "幫緊你，幫緊你"
            },
            "my-order": {
                "amount": "金額",
                "esim-qrcode": "eSIM碼",
                "fx-status-cancelled": "已取消",
                "fx-status-confirmed": "已確認",
                "order-date": "落單日期",
                "order-details": "訂單詳情",
                "order-num": "訂單編號",
                "status-confirmed": "已寄出",
                "status-pending-confirmation": "準備寄出",
                "status-ready-to-ship": "準備寄出",
                "status-shipped": "已寄出"
            },
            "my-order-details": {
                "delivery-info": "物流資料",
                "discount": "折扣",
                "recipient-address": "地址",
                "recipient-email": "電郵",
                "recipient-name": "收件人名稱",
                "recipient-tel": "收件人聯絡電話",
                "shipping-method": "物流方式",
                "status": "狀態",
                "total": "總額",
                "valid-date": "完成日期"
            },
            "nav": {
                "about-us": "關於我們",
                "car": "租車",
                "company": "公司",
                "company-address": "地址：香港數碼港3期3樓企業發展中心",
                "contact-us": "聯絡我們",
                "contact-us-description": "如有任何疑問，歡迎發送電郵到<a href=\"mailto:hello@hyperair.com\">hello@hyperair.com</a>查詢",
                "disclaimer": "免責聲明",
                "download-app": "下載 App",
                "flight": "機票",
                "foodie": "美食優惠",
                "home": "首頁",
                "hotel": "酒店",
                "jobs": "請人",
                "logout": "登出",
                "media-coverage": "媒體報導",
                "monthly-rental-hotel": "短租及月租酒店",
                "privacy-policy": "私隱政策",
                "promo-banner-text": "HyperAir 客戶專享 5% Trip.com 獨家酒店折扣",
                "quarantine-hotel": "回港長住酒店",
                "refund-policy": "退改政策",
                "spa-and-beauty": "Spa and Beauty",
                "staycation": "宅度假",
                "tag-line": "玩樂旅遊 ‧ 搜尋格價",
                "terms-of-service": "服務條款",
                "travel-activity": "旅遊體驗",
                "travel-affiliate-codes": "折扣優惠券",
                "travel-affiliate-codes-md": "折扣優惠券",
                "travel-blog": "Blog",
                "travel-experience-d": "玩樂門票",
                "travel-experience-md": "玩樂門票",
                "travel-insurance": "旅遊保險",
                "travel-insurance-md": "旅遊保險",
                "travel-marketplace": "玩樂潮物",
                "travel-marketplace-md": "玩樂潮物",
                "travel-money": "唱錢神器",
                "travel-money-md": "唱錢神器",
                "travel-sim": "旅遊 SIM",
                "travel-sim-md": "旅遊 SIM"
            },
            "photo-banner": {
                "banner-button": ""
            },
            "product-card": {
                "num-of-review": "{num}-of-review則評價"
            },
            "redirection-gate": {
                "columns-1-description": "幫您比較各個網站，搵最正最抵嘅玩樂體驗",
                "columns-1-title": "玩樂格價",
                "columns-2-description": "多款勁抵價SIM卡，免運費送上門！",
                "columns-2-title": "旅遊SIM卡",
                "columns-3-description": "助你輕鬆搜尋預訂最抵匯率",
                "columns-3-title": "唱錢神器",
                "promo-code": "優惠碼",
                "remember-to-fill-promo-code": "記得結帳嘅時候輸入以上優惠碼",
                "title": "傳送門正將你送到 {domain}",
                "trouble-link": "如果您的瀏覽器未能於10秒內重新導向，請您點擊此<a href=\"{link}\">連結</a>"
            },
            "register": {
                "guest-checkout": "繼續以訪客結帳",
                "title": "註冊"
            },
            "seo": {
                "best-price-guarantee-title": "最低價保證",
                "country-description": "{country}旅遊SIM，多款勁抵價SIM卡，免運費送上門，準備旅程快又醒！",
                "country-keywords": "SIM卡,上網卡,電話卡,數據卡,DataSIM,旅遊DataSIM,數據咭,4G上網卡,上網卡,4G上網卡,日本4G上網卡,日本上網卡,東京4G上網卡,東京上網卡,大阪4G上網卡,大阪上網卡,泰國4G上網卡,泰國上網卡,曼谷4G上網卡,布吉上網卡,芭提雅4G上網卡,台灣4G上網卡,台灣上網卡,台北4G上網卡,高雄上網卡,台中4G上網卡,台中上網卡,韓國4G上網卡,韓國上網卡,首爾4G上網卡,首爾上網卡,中國4G上網卡,中國上網卡,深圳4G上網卡,深圳上網卡,澳門4G上網卡,澳門上網卡, Docomo, Softbank",
                "country-title": "{country}旅遊SIM卡 - 勁抵價，免運費送上門",
                "home-description": "HyperAir係一間旅遊科技初創公司，打造一個能夠了解用家喜好嘅旅遊平台，提供最合適同埋物超所值嘅旅遊方案，令旅行愛好者可以一站式咁瀏覽預訂，隨時隨地醒目旅遊！",
                "home-keywords": "sim卡,上網卡,電話卡,數據卡,DataSIM,旅遊DataSIM,數據咭,4G上網卡,上網卡,4G上網卡,SIM卡,Travel SIM,旅遊SIM卡,唱錢神器,唱X神器,唱錢X器,唱錢,唱錢app,兌換,找換,兌換店,找換店,銀行,金融,外匯,外滙,匯率,滙率,匯款,外幣,貨幣,旅行,旅遊,行程,酒店,機票,比較,格價,特價,預訂,交易,旅遊保險,日本,泰國,韓國,台灣,日圓,日元,台幣,泰銖,HyperAir,HyperAir FX,HyperAir Travel,Travel,Travel Money,Foreign Currency,Foreign Exchange,百年,堅成,發達鳥,飛鳥,richbird,crazy bird,berlin exchange",
                "home-title": "HyperAir - 玩樂旅遊必備搜尋比較平台 | 玩樂體驗、酒店優惠、上網SIM卡、唱錢神器、旅遊保險",
                "hotel-description": "透過HyperAir網站，可享預訂酒店額外折扣優惠",
                "hotel-keywords": "酒店預訂, 酒店訂房, 預訂, 訂房, 亞洲地區, 歐洲地區, 美洲地區, 泰國, 曼谷, 美國, 中國, 上海, 日本, 東京, 馬來西亞, 新加坡, 韓國, 加拿大, 英國, 荷蘭, 法國, 紐西蘭, 澳洲, 優惠價格, 酒店評論,網路預訂, 地圖, 渡假村, 度假村",
                "hotel-title": "酒店優惠",
                "money-exchange-description": "查看{shop_name}的最新匯率，並且網上預訂，可以即時鎖定匯率及預留貨幣！",
                "money-exchange-keywords": "{shop_name}, 唱錢神器, 唱X神器, 唱錢X器, 唱錢, 兌換, 找換, 兌換店, 找換店, 銀行, 金融, 外匯, 外滙, 匯率, 滙率, 匯款, 外幣, 貨幣, 旅行, 旅遊, 行程, 酒店, 機票, 比較, 格價, 特價, 預訂, 交易, 旅遊保險, 日本, 泰國, 韓國, 台灣, 日圓, 日元, 台幣, 泰銖, HyperAir, HyperAir FX, HyperAir Travel, Travel, Travel Money, Foreign Currency, Foreign Exchange, 百年, 堅成, 發達鳥, 飛鳥, richbird, crazy bird, berlin exchange",
                "money-exchange-title": "{shop_name} 最新外幣匯率 即時預訂外幣 | 唱錢神器 唱錢快又醒 | 每日更新兌換匯率",
                "privacy-policy-title": "私隱政策",
                "refund-policy-title": "退改政策",
                "sim-fanfares-description": "全港首個SIM卡Fanfares已經登陸 HyperAir 啦！熱賣 SIM 卡低至5折發售，限時優惠，限量特價！",
                "sim-fanfares-keywords": "fanfares,SIM卡,上網卡,電話卡,數據卡,DataSIM,旅遊DataSIM,數據咭,4G上網卡,上網卡,4G上網卡,日本4G上網卡,日本上網卡,東京4G上網卡,東京上網卡,大阪4G上網卡,大阪上網卡,泰國4G上網卡,泰國上網卡,曼谷4G上網卡,布吉上網卡,芭提雅4G上網卡,台灣4G上網卡,台灣上網卡,台北4G上網卡,高雄上網卡,台中4G上網卡,台中上網卡,韓國4G上網卡,韓國上網卡,首爾4G上網卡,首爾上網卡,中國4G上網卡,中國上網卡,深圳4G上網卡,深圳上網卡,澳門4G上網卡,澳門上網卡, Docomo, Softbank",
                "sim-fanfares-title": "SIM 卡 Fanfares - 限時優惠 限量特價",
                "term-of-service-title": "服務條款",
                "travel-activity-search-results-description": "立即格價，取得{activity}的最佳優惠，節省更多！在HyperAir.com可以找到最抵的活動，一次過比較熱門玩樂體驗的旅遊網站。",
                "travel-activity-search-results-keywords": "{activity}, 旅遊, 旅遊體驗, 旅遊活動, 玩樂, 自由行, 一日遊, 景點, 門票, 交通",
                "travel-activity-search-results-title": "HyperAir - {city}嘅搜尋結果",
                "travel-affiliate-codes-description": "HyperAir 為你持續更新 2023 最新優惠碼，輕鬆獲得折扣碼享受酒店優惠、機票優惠、門票車票優惠、旅遊保險優惠、SIM卡優惠及信用卡優惠。",
                "travel-affiliate-codes-keywords": "優惠代碼,電子優惠券,折扣碼,Promotion,Promo Code,Discount Code,酒店,機票,優惠,信用卡優惠,旅遊優惠",
                "travel-affiliate-codes-title": "2023 最新！玩樂旅遊優惠碼（每日更新） | 折扣預訂酒店、機票、玩樂體驗、旅遊保險、SIM卡",
                "travel-insurance-description": "旅遊保險邊間好？邊間保險包手提電話？立即比較旅遊保險，一眼睇晒AIG、MSIG、STARR等公司的旅遊保險保費。經HyperAir購買指定的旅行保險，可獲贈額外旅遊保險優惠。保障地點包括日本、韓國、台灣、泰國等最佳旅遊勝地！",
                "travel-insurance-keywords": "旅遊保險提供全面旅行保障，自駕遊、手提電話、熱氣球、滑雪、潛水。即時免費網上報價投保！",
                "travel-insurance-title": "旅遊保險 - 即時比較最佳旅遊保險及額外折扣優惠 2023",
                "travel-marketplace-checkout-payme-title": "以 PayMe 付款",
                "travel-marketplace-checkout-success-keywords": "創意, 產品, 流行, 電器, 生活, 精品, 智能家居, 設計, 高品質, 設計概念, 創意科技, 生活用品, 戶外休閒, 廚房, 餐桌, 個人護理, 防疫抗疫, 健康, 遊戲, 兒童玩樂, 健身, 家居健身, gym, home gym, smart home, style home",
                "travel-marketplace-checkout-success-title": "付款成功",
                "travel-marketplace-description": "集合最潮最好玩嘅創意科技產品，有設計概念嘅生活用品",
                "travel-marketplace-keywords": "創意, 產品, 流行, 電器, 生活, 精品, 智能家居, 設計, 高品質, 設計概念, 創意科技, 生活用品, 戶外休閒, 廚房, 餐桌, 個人護理, 防疫抗疫, 健康, 遊戲, 兒童玩樂, 健身, 家居健身, gym, home gym, smart home, style home",
                "travel-marketplace-product-checkout-title": "{product}",
                "travel-marketplace-product-title": "{product} - 玩樂潮物",
                "travel-marketplace-title": "玩樂潮物",
                "travel-money-description": "透過「HyperAir唱錢神器」，您可以喺網上比較滙率同埋預訂外幣，之後再喺心水的商店提取。咁你就可以慳返好多格價同排隊嘅時間。",
                "travel-money-keywords": "sim卡,上網卡,電話卡,數據卡,DataSIM,旅遊DataSIM,數據咭,4G上網卡,上網卡,4G上網卡,唱錢神器,唱X神器,唱錢X器,唱錢,兌換,找換,兌換店,找換店,銀行,金融,外匯,外滙,匯率,滙率,匯款,外幣,貨幣,旅行,旅遊,行程,酒店,機票,比較,格價,特價,預訂,交易,旅遊保險,日本,泰國,韓國,台灣,日圓,日元,台幣,泰銖,HyperAir,HyperAir FX,HyperAir Travel,Travel,Travel Money,Foreign Currency,Foreign Exchange,百年,堅成,發達鳥,飛鳥,richbird,crazy bird,berlin exchange",
                "travel-money-title": "唱錢神器™ - 輕鬆搜尋全球貨幣，比較價格及預訂最抵匯率",
                "travel-product-checkout-keywords": "創意, 產品, 流行, 電器, 生活, 精品, 智能家居, 設計, 高品質, 設計概念, 創意科技, 生活用品, 戶外休閒, 廚房, 餐桌, 個人護理, 防疫抗疫, 健康, 遊戲, 兒童玩樂, 健身, 家居健身, gym, home gym, smart home, style home",
                "travel-product-keywords": "創意, 產品, 流行, 電器, 生活, 精品, 智能家居, 設計, 高品質, 設計概念, 創意科技, 生活用品, 戶外休閒, 廚房, 餐桌, 個人護理, 防疫抗疫, 健康, 遊戲, 兒童玩樂, 健身, 家居健身, gym, home gym, smart home, style home",
                "travel-sim-checkout-description": "{country}旅遊SIM，多款勁抵價SIM卡，免運費送上門，準備旅程快又醒！",
                "travel-sim-checkout-keywords": "上網卡,電話卡,數據卡,DataSIM,旅遊DataSIM,數據咭,4G上網卡,上網卡,4G上網卡,日本4G上網卡,日本上網卡,東京4G上網卡,東京上網卡,大阪4G上網卡,大阪上網卡,泰國4G上網卡,泰國上網卡,曼谷4G上網卡,布吉上網卡,芭提雅4G上網卡,台灣4G上網卡,台灣上網卡,台北4G上網卡,高雄上網卡,台中4G上網卡,台中上網卡,韓國4G上網卡,韓國上網卡,首爾4G上網卡,首爾上網卡,中國4G上網卡,中國上網卡,深圳4G上網卡,深圳上網卡,澳門4G上網卡,澳門上網卡, Docomo, Softbank",
                "travel-sim-checkout-success-description": "{country}旅遊SIM，多款勁抵價SIM卡，免運費送上門，準備旅程快又醒！",
                "travel-sim-checkout-success-keywords": "上網卡,電話卡,數據卡,DataSIM,旅遊DataSIM,數據咭,4G上網卡,上網卡,4G上網卡,日本4G上網卡,日本上網卡,東京4G上網卡,東京上網卡,大阪4G上網卡,大阪上網卡,泰國4G上網卡,泰國上網卡,曼谷4G上網卡,布吉上網卡,芭提雅4G上網卡,台灣4G上網卡,台灣上網卡,台北4G上網卡,高雄上網卡,台中4G上網卡,台中上網卡,韓國4G上網卡,韓國上網卡,首爾4G上網卡,首爾上網卡,中國4G上網卡,中國上網卡,深圳4G上網卡,深圳上網卡,澳門4G上網卡,澳門上網卡, Docomo, Softbank",
                "travel-sim-checkout-success-title": "付款成功 - 旅遊SIM卡",
                "travel-sim-checkout-title": "訂購 - 旅遊SIM卡",
                "travel-sim-keywords": "sim卡,上網卡,電話卡,數據卡,DataSIM,旅遊DataSIM,數據咭,4G上網卡,上網卡,日本4G上網卡,日本上網卡,日本sim卡,東京4G上網卡,東京上網卡,大阪4G上網卡,大阪上網卡,泰國4G上網卡,泰國上網卡,泰國sim卡,曼谷4G上網卡,布吉上網卡,芭提雅4G上網卡,台灣4G上網卡,台灣上網卡,台灣sim卡,台北4G上網卡,高雄上網卡,台中4G上網卡,台中上網卡,韓國sim卡,韓國4G上網卡,韓國上網卡,首爾4G上網卡,首爾上網卡,中國4G上網卡,中國上網卡,中國sim卡,中國內地數據卡,深圳4G上網卡,深圳上網卡,澳門4G上網卡,澳門上網卡, 歐洲4G上網卡,歐洲上網卡,歐洲sim卡,英國4G上網卡,英國上網卡,英國sim卡,法國4G上網卡,法國上網卡,法國sim卡, 恴大利4G上網卡,意大利上網卡,意大利sim卡,巴黎4G上網卡,巴黎上網卡,巴黎sim卡,瑞士4G上網卡,瑞士上網卡,瑞士sim卡,Docomo, Softbank, 和記, 聯通, 3hk, 3uk, birdie, 自由鳥, airsim,sim2fly,AIS,ais sim2fly,SK Telecom,TrueMove,dtac,t mobile 全球上網卡,vietnamobile",
                "travel-sim-title": "【{country}上網SIM卡】{sim_name} - 勁抵價免運費",
                "travel-sims-description": "全球旅遊SIM搜尋引擎，輕鬆訂購優質勁抵價SIM卡，免運費送上門，準備旅程快又醒！",
                "travel-sims-keywords": "sim卡,上網卡,電話卡,數據卡,DataSIM,旅遊DataSIM,數據咭,4G上網卡,4Gsim卡,日本4G上網卡,日本上網卡,日本sim卡,東京4G上網卡,東京上網卡,大阪4G上網卡,大阪上網卡,泰國4G上網卡,泰國上網卡,泰國sim卡,曼谷4G上網卡,布吉上網卡,芭提雅4G上網卡,台灣4G上網卡,台灣上網卡,台灣sim卡,台北4G上網卡,高雄上網卡,台中4G上網卡,台中上網卡,韓國sim卡,韓國4G上網卡,韓國上網卡,首爾4G上網卡,首爾上網卡,中國4G上網卡,中國上網卡,中國sim卡,中國內地數據卡,深圳4G上網卡,深圳上網卡,澳門4G上網卡,澳門上網卡,澳門sim卡,歐洲sim卡,Docomo,Softbank,sim2fly,AIS,ais sim2fly,SK Telecom,TrueMove,dtac,t mobile 全球上網卡,vietnamobile",
                "travel-sims-title": "旅遊SIM - 優質，勁抵價，免運費送上門"
            },
            "shop-confirmation": {
                "app-download": "立即下載，推送通知",
                "app-download-subtitle": "下載 HyperAir 接收確認訂單的通知。",
                "instruction": "你的預訂已發送到找換店。一旦確認，我們會透過電郵或通知，將 QR CODE 將收到電郵通知，確認訂單將發送至 {email} 。",
                "my-order": "我的訂單",
                "pending-confirm": "等待兌換店確認"
            },
            "staycation": {
                "activity-countdown-button": "比較門票優惠",
                "all-hotels": {
                    "sorting": {
                        "recommended": "推介"
                    }
                },
                "all-hotels-all-button": "所有",
                "all-hotels-hotel-name": "酒店名稱",
                "all-hotels-last-updated": "最後更新",
                "all-hotels-less-button": "收起",
                "all-hotels-more-button": "更多",
                "all-hotels-no-result": "Sorry！我哋搵唔到相關嘅Staycation優惠",
                "all-hotels-title": "搜尋全台最齊「宅度假」飯店",
                "compare-packages": "比較此酒店其他套餐",
                "countdown-button": "立即搶購",
                "countdown-title": "",
                "countdown2-title": "今期熱爆推介",
                "countdown3-title": "最新 Staycation 酒店限時優惠",
                "month-format": "M",
                "order-d-title": "浪漫精品酒店 💕💕",
                "order-g-subtitle": "暑假帶埋一家大細Relax下",
                "order-g-title": "親子Staycation必去之選👨‍👩‍👧‍👦😍",
                "order-h-title": "郵輪之旅🛳️",
                "order-i-title": "情侶煮飯仔酒店 🍽️",
                "order-j-title": "Glamping豪華露營推介",
                "seo-description": "點解咁多人用 HyperAir 搵 Staycation? 因為集合左 KKday, Trip.com, Klook 及各大香港酒店平台，一眼比較邊到有late checkout、免費泊車、自助早午晚餐及餐飲回贈等獨家 Staycation 優惠，每日更新。",
                "seo-keywords": "staycation, staycation 優惠, 香港 staycation, staycation 香港, staycation hk, staycation package, staycation hong kong, 酒店, 酒店 優惠, staycation 中文, 香港 酒店, klook 優惠, klook 優惠, kkday 優惠, trip 優惠, agoda 優惠, runhotel staycation, 酒店 套票, staycation 酒店, 香港 酒店 套票, 訂 酒店 優惠, 酒店 package, 特價 酒店, 香港 優惠 酒店, 酒店 優惠 套 票, 特價 酒店 香港, 香港 酒店 優惠, 酒店 住宿 優惠, staycation 2020, staycation 2021, staycation 2022, staycation 1月 優惠, staycation 2月 優惠, staycation 3月 優惠, staycation 4月 優惠, staycation 5月 優惠, staycation 6月 優惠, staycation 7月 優惠, staycation 8月 優惠, staycation 9月 優惠, staycation 10月 優惠, staycation 11月 優惠, staycation 12月 優惠, 四季酒店, W酒店, Murray, JW Marriott, St. Regis, Conrad Hotel, Grand Hyatt, Ritz Carlton, Rosewood, 露台 酒店, 廚房 酒店, 親子 酒店, 情侶 酒店",
                "seo-title": "【2021年9月最新】香港酒店 Staycation 優惠搜尋神器 全港最齊．每日更新 - 最齊香港staycation優惠、酒店優惠、Hong Kong Staycation Ideas、Klook優惠、KKday優惠、Trip優惠、Agoda優惠、專業旅運優惠 - HyperAir 玩樂必備搜尋比較平台！一次過，比較全球多個玩樂旅遊預訂網站！ - HyperAir",
                "share-button-alert": "鏈結已複製",
                "subtitle": "每日更新酒店餐飲及住宿優惠（{start_month}月至{end_month}月）",
                "title": "台灣最強「宅度假」飯店搜尋神器",
                "top10-title": "Top 10 最棒的「宅度假」飯店",
                "top102-title": "",
                "top103-title": "值得一試的 Staycation 酒店🥂"
            },
            "travel-activities": {
                "best-deals": "價格",
                "book-now": "查看詳情",
                "disclaimer": "價格只供參考，一切內容將以合作平台為準。",
                "empty-destination": "請輸入國家或城巿",
                "more-deals": "更多",
                "not-available": "未能預訂",
                "offers": "",
                "provider-getyourguide": "GetYourGuide",
                "provider-hk": {
                    "trip": {
                        "com": "Trip.com"
                    }
                },
                "provider-hyperair": "HyperAir",
                "provider-kkday": "KKday",
                "provider-klook": "KLOOK",
                "provider-seoultravelpass": "SeoulPass",
                "provider-sim": {
                    "hyperair": {
                        "com": "HyperAir"
                    }
                },
                "provider-travelexpert": "Travel Expert",
                "provider-trip": "Trip.com",
                "ratings": "評分",
                "recommended-title": "更多{city}嘅熱門活動",
                "search-africa-oceania": "非洲/大洋洲",
                "search-all-cities": "所有城市",
                "search-america": "美洲",
                "search-asia": "亞洲",
                "search-button": "搜尋",
                "search-cancel-button": "取消",
                "search-country-placeholder": "輸入國家或城市",
                "search-euro-middleeast": "歐洲/中東",
                "search-hardcoded-cities": "熱門搜尋：",
                "search-placeholder": "搜尋 \"門票\" 或 \"一日遊\"",
                "search-popular-cities": "🔥熱門城市",
                "search-searched-cities": "搜尋城市",
                "search-slogan-2": "活動分類/景點",
                "show-similar-product": "比較相關產品",
                "sorting": {
                    "price-asc": "價格（從低到高）",
                    "price-desc": "價格（從高到低）",
                    "rating": "評分",
                    "relevance": "最相關",
                    "sort-by": "排序"
                },
                "title": "符合「{q}」的搜尋結果",
                "title-everything": "{city}嘅熱門活動",
                "title-no-result": "Sorry！我哋搵唔到同“{q}”相關嘅活動",
                "title-no-result-without-keyword": "Sorry！我哋搵唔到相關嘅活動",
                "total-results": "共 <b>{number}</b> 項搜尋結果"
            },
            "travel-affiliate-codes": {
                "cover-slogan": "提供各大預訂網站旅遊優惠碼，幫您慳多啲、玩盡啲",
                "cover-title": "玩樂旅遊優惠券",
                "disclaimer": "優惠資料只供參考，一切內容將以合作平台為準。供應商可隨時對資料進行變更或刪除，並保留最終之決定權。",
                "exclusive": "獨家優惠",
                "type-activity": "玩樂體驗",
                "type-air": "機票",
                "type-all": "所有",
                "type-hotel": "酒店",
                "type-insurance": "旅遊保險",
                "type-shopping": "購物",
                "type-sim": "旅遊SIM",
                "use-promo-code": "獲取優惠碼",
                "valid-until": "到期日："
            },
            "travel-insurance": {
                "breadcrumb-travel-insurance": "旅遊保險",
                "cover-subtitle": "搜羅比較最正旅遊保險，仲保埋手機添！",
                "cover-title": "旅遊保險",
                "departure-date-alert": "出發日期必須於{latest_date_to_depart}或之前。",
                "disclaimer": "報價只供參考，詳情請參閱保險公司網頁。",
                "highlight-subtitle1": "保障範圍清晰比較，最啱心水計劃一目了然！",
                "highlight-subtitle2": "為你比較全港旅遊保險報價 慳得一蚊得一蚊！",
                "highlight-subtitle3": "HyperAir 客户專享獨家旅遊保險折扣及優惠！",
                "highlight-title1": "保障比較",
                "highlight-title2": "旅保格價",
                "highlight-title3": "獨家禮遇",
                "num-of-travellers-alert": "旅客人數不能多於10人",
                "partner-title": "旅遊保險合作夥伴",
                "return-date-alert": "回程日期必須於{latest_date_to_return}或之前。",
                "section-title": "你正在搜尋{num_of_traveller}個旅客玩{num_of_day}日的旅遊保險",
                "slogan": "簡易3步 無憂投保",
                "sorting": {
                    "coverage": "最佳保障",
                    "price-asc": "價格（從低到高）",
                    "price-desc": "價格（從高到低）"
                },
                "step1": "填寫旅程",
                "step1-detail": "輸入你旅程嘅目的地，日期和人數",
                "step2": "比較計劃",
                "step2-detail": "比較不同保險計劃的保障範圍及價錢",
                "step3": "即享優惠",
                "step3-detail": "一按即享不同旅遊保險優惠"
            },
            "travel-insurance-product-card": {
                "apply-now": "即享優惠",
                "cancellation": "取消旅遊保障",
                "car-rental": "租車自負額保障",
                "cruise-vacation": "郵輪假期(附加保障)",
                "dangerous-sports": "業餘危險運動",
                "hyperair-exclusive": "HYPERAIR 獨家優惠",
                "medical": "醫療費用",
                "mobile": "手提電話損毀或遺失",
                "personal-belongings": "遺失錢財及證件",
                "trip-delay": "旅程延誤"
            },
            "travel-insurance-search-bar": {
                "children": "子女(18歲以下)",
                "date": "出發日期及回程日期",
                "destination": "去邊度玩",
                "friend": "朋友/親屬",
                "myself": "自己",
                "number-of-traveller": "旅客人數",
                "search-button": "搜尋",
                "spouse": "配偶"
            },
            "travel-marketplace": {
                "buy-now-can-earn-x-miles": "可賺取 HyperMiles 於下次消費使用",
                "cover-slogan": "集合最潮最好玩嘅創意科技產品",
                "cover-title": "玩樂潮物"
            },
            "travel-marketplace-categories": "商品分類",
            "travel-marketplace-checkout": {
                "delivery-message-body": "工作天為星期一至星期五（公眾假期除外），截數時間為當日正午12時，於正午12時後訂購的貨品將會順延至下一個工作天寄出。",
                "delivery-method-1": "順豐速遞 （只限香港）",
                "delivery-method-1-description": "以順豐速運寄送，每單運費HK$30，買滿HK$800免運費。大概5-10個工作天內送達。",
                "delivery-method-2": "跨國運送",
                "delivery-method-2-description": "設運送編號作追查，大概4-25個工作天內送達，視乎選擇的目的地。以上運費只是估算，或需額外運費。"
            },
            "travel-money": {
                "breadcrumb-travel-money": "唱錢神器",
                "cover-button": "立即體驗",
                "cover-slogan": "助你輕鬆搜尋預訂最抵匯率，咁就唱錢快又醒啦！",
                "cover-title": "唱錢神器™",
                "disclaimer": "價格只供參考，一切內容將以該找換店為準。",
                "empty-amount": "請輸入金額",
                "fx": "",
                "fx-slogan": "簡易四步 輕鬆唱錢",
                "fx-step1": "搜尋",
                "fx-step1-detail": "選擇您所需要唱嘅外幣",
                "fx-step2": "比較",
                "fx-step2-detail": "搵最靚嘅匯率同埋方便嘅地點",
                "fx-step3": "預訂",
                "fx-step3-detail": "隨時隨地網上輕鬆預訂外幣",
                "fx-step4": "提取",
                "fx-step4-detail": "出示您訂單嘅QR Code，提取您嘅外幣去旅行",
                "hyperair-feature-1": "醒目",
                "hyperair-feature-1-description": "一個醒目的方法唱外幣去旅行。現在，您只需撳一個掣即可找到最好的商店，在幾秒鐘內預訂外幣，並在最近的地點拎外幣。是時候告別排隊和昂貴的匯率了。",
                "hyperair-feature-2": "可靠",
                "hyperair-feature-2-description": "這是一個安全的方式去兌換外幣。我們精心挑選合作夥伴，僅與受監管的銀行和持牌兌換店合作。使用我們的平台，您的資金將受最高的保障。",
                "hyperair-feature-3": "隨時隨地",
                "hyperair-feature-3-description": "這是革新的兌換外幣方式。我們雄心勃勃地擴展在本地和全球的服務，為您提供最佳的旅行體驗。我們努力確保您在任何地方，都以智能和可靠的方式獲得旅行外幣。",
                "i-will-get": "我要唱",
                "i-will-pay": "我要畀",
                "join-us": "獲取更多商機",
                "join-us-button": "加入供應商",
                "join-us-slogan": "加入我們的找換店網絡",
                "search-bar-placeholder": "輸入金額",
                "search-button": "搜尋",
                "section-title": "",
                "section-title-from-hkd": "你正在搜尋HKD 兌換 {amount} {currency}",
                "section-title-to-hkd": "你正在搜尋{amount} {currency} 兌換 HKD",
                "why-hyperair": "",
                "why-hyperair-description": "唱錢神器™為您帶嚟醒目嘅方法去準備您嘅旅行。我哋提供快速、簡易同埋中立嘅外幣搜索引擎。",
                "why-hyperair-title": "為甚麼選用唱錢神器 ?"
            },
            "travel-product": {
                "buy-now": "立即購買",
                "product-option": "產品選項"
            },
            "travel-sim": {
                "as-low-as": "每日低至",
                "book-now": "立即訂購(有庫存)",
                "breadcrumb-homepage": "首頁",
                "breadcrumb-mainpage": "主頁",
                "breadcrumb-travel-sim": "旅遊SIM",
                "cancellation-policy": "取消政策",
                "cancellation-policy-content": "成功預訂後，訂單不可修改、取消或退款",
                "download-hyperair-now-description": "用相機掃一掃 QR Code 或按平台下載 HyperAir 應用程式",
                "download-hyperair-now-title": "立即下載 HyperAir",
                "first-step": "第一步",
                "go-to-shopping-cart-description": "下載後用相機掃描 QR 碼可直達產品專業，選擇數量或其他產品後可直接付款。",
                "go-to-shopping-cart-title": "直達購物車，立即付款",
                "hardcoded-countries-title": "其他熱門地區：",
                "highlights": "特色",
                "important-notice": "注意事項",
                "instructions": "使用說明",
                "lowest-price-guarantee": "推廣價",
                "no-stock": "賣晒啦",
                "num-of-review": "{num}-of-review個評分",
                "popular-countries": "旅遊 SIM 涵蓋 200+ 國家",
                "popular-countries-search-button": "搜尋其他國家",
                "product-highlights": "產品詳情",
                "product-specification": "產品規格",
                "related-sims": "相關{countrySIM}卡",
                "related-sims-search-button": "更多{country}旅遊 SIM",
                "review": "評價",
                "review-date": "{date}",
                "review-no-firstname-user": "旅客",
                "scan-product-qr-code": "掃一掃 QR Code 購買此產品",
                "second-step": "第二步",
                "sim": "電話卡",
                "web-traffic": "最近7天已賣岀{num}-of-purchased張 , 而家有{num}-of-traffic個人同時睇緊呢張SIM卡",
                "web-traffic-title": "呢張 SIM 卡熱賣中！"
            },
            "travel-sim-checkout": {
                "-secure-payment-slogan": "我們所有的線上付款都受加密保護",
                "address": "地址*",
                "address-column1": "例如：香港中環",
                "address-column2": "例如：旅遊路88號",
                "address-column3": "例如：世界中心18樓A室",
                "back-button": "返回",
                "checkout-title-1": "物流資料",
                "confirm-button": "繼續",
                "country-code": "國家編碼",
                "delivery-message-body": "工作天為星期一至星期五（公眾假期除外），截數時間為當日正午12時，於正午12時後訂購的貨品將會順延至下一個工作天寄出。\n<br><br>如在同一日工作天內，相同收貨地址的訂單將會合併寄岀。",
                "delivery-message-header": "送貨通告",
                "delivery-method": "物流方式",
                "delivery-method-1": "平郵（免費）",
                "delivery-method-1-description": "以香港郵政平郵寄送，免郵費，大概3-6個工作天內送達。如選擇平郵寄送，將不設郵寄編號作追查，客戶需要自行承擔平郵延誤及寄失的風險。\n<br><br>注意：因寄送需時，即將外遊的顧客建議選用順豐到付，確保貨品能準時送達",
                "delivery-method-2": "順豐速遞 （只限香港，貨到付運費）",
                "delivery-method-2-description": "以順豐速運寄送，貨到後付運費，大概1-3個工作天內送達，離島需時可與順豐查詢。速遞運費約HK$16-$25。詳情請參閱順豐速運網站。\n<br><br>注意：如即日總訂單付款滿HK$399，即可升級以順豐速運免費寄送。",
                "delivery-method-3": "跨國運送",
                "delivery-method-3-description": "以香港郵政空郵寄送，設郵寄編號作追查，固定$30郵費，大概4-15個工作天內送達，視乎選擇的目的地",
                "error-alert-address": "請填寫「收貨地址」。",
                "error-alert-invalid-email": "電郵地址格式不正確。",
                "error-alert-invalid-recipient-first-num": "聯繫號碼應該以2, 3, 5, 6, 7, 8或9開始。",
                "error-alert-invalid-recipient-number": "請填寫正確的收貨人聯繫號碼。",
                "error-alert-invalid-user-first-num": "手機號碼應該以5, 6, 7, 8或9開始。",
                "error-alert-invalid-user-number": "請填寫正確的手機號碼。",
                "error-alert-personal-info": "請填寫「預訂人資料」。",
                "error-alert-recipient-info": "請填寫「收貨人資料」。",
                "error-invalid-credit-card-info": "信用卡資料不正確",
                "facebook-login": "Facebook 繼續",
                "google-login": "Google 繼續",
                "logged-in": "已登入",
                "login": "現有客戶，立即登入方便購買",
                "login-button": "登入",
                "login-email": "電郵",
                "login-no-user-exists": "哎喲！很抱歉，我哋未能確認您嘅登入資料。請再試一次，或不登入直接完成訂購也很容易。",
                "login-password": "密碼",
                "payme": {
                    "error-contacting-payme": "付款失敗，請重新落單 / 聯絡客戶服務"
                },
                "payment": {
                    "actual-payment": "交易以港元 ${actual_payment} 結算，兌換率將跟據您的發卡機構為準",
                    "choose-payment-method": "選擇付款方式：",
                    "logistic-information": "物流資料",
                    "modify-information": "修改資料",
                    "pay-now": "立即付款",
                    "payme-instruction-do-not-close": "在交易完成前請不要關閉此頁面",
                    "payme-instruction-step-1": "1. 打開 PayMe 應用程式",
                    "payme-instruction-step-2": "2. 掃描 PayCode 以授權付款",
                    "payme-instruction-step-3": "3. 在 PayMe 完成交易後，請留在此頁面等待確認",
                    "payme-instruction-title": "如何用 PayMe 付款？",
                    "payme-title": "請用 PayMe 掃描此 PayCode",
                    "payment": "付款",
                    "price": "金額",
                    "shipping-fee": "運費",
                    "subtotal": "小計"
                },
                "payment-method": "付款方式",
                "pending": {
                    "mobile-redirection-text": "您已選擇以PayMe作為付款方式，並且將被重新定向至PayMe應用程式以完成付款。",
                    "need-to-pay": "需付金額",
                    "order-number": "訂單號碼",
                    "order-success-please-pay": "你已成功下單，請完成付款手續，以便完成訂單程序",
                    "paycode-error": "付款失敗，請重新落單 / 聯絡客戶服務",
                    "paycode-expired": "PayMe 的 PayCode 已過期，請重新落單",
                    "re-order": "重新落單",
                    "title-payme": "PayMe 付款"
                },
                "recipient-address": "收貨地址",
                "recipient-information": "收貨人資料",
                "recipient-name": "收貨人名稱",
                "recipient-phone-number": "收貨人聯繫電話",
                "secure-payment-slogan": "安全付款 | 付款資料受SSL安全加密傳輸",
                "simproduct-detail": "訂單資料",
                "simproduct-quantity": "數量",
                "simproduct-redeem": "兌換",
                "simproduct-redeem-hypermiles": "兌換 HyperMiles",
                "simproduct-title": "產品",
                "simproduct-will-redeeming-x-miles": "將兌換 {miles} HyperMiles",
                "simproduct-you-have-x-hypermiles": "你已擁有 {miles} HyperMiles",
                "user-email": "電郵（接收發票）",
                "user-firstname": "名字",
                "user-information": "預訂人資料",
                "user-lastname": "姓氏",
                "user-phone-number": "手機號碼",
                "vertical-divider": "或"
            },
            "travel-sims": {
                "column-title-1": "清晰分類，容易挑選",
                "column-title-2": "網上付款，方便快捷",
                "column-title-3": "免費平郵，極速送到",
                "country-search-no-place-found": "請輸入正確國家名稱",
                "cover-button": "立即用App購買",
                "cover-slogan": "多款勁抵價SIM卡，免運費送上門!",
                "cover-title": "旅遊SIM",
                "empty-destination": "請輸入目的地",
                "num-of-days": "去幾多日",
                "search-button": "",
                "search-input": "輸入國家",
                "search-placeholder": "輸入國家",
                "search-slogan": "去邊到玩？",
                "travel-sim-header-description": "",
                "travel-sim-header-title": ""
            }
        },
        "passwords": {
            "password": "",
            "reset": "",
            "sent": "我們已經通過電子郵件發送了您的密碼重置鏈接。",
            "token": "",
            "user": ""
        },
        "mail": {
            "product-simcard": {
                "delivery-update": {
                    "subject": "您嘅SIM卡訂單已經寄岀"
                },
                "purchased": {
                    "subject": "您嘅旅遊SIM卡訂單已確認"
                },
                "tracking-number-update": {
                    "subject": "您嘅快遞單號已更新"
                }
            }
        },
        "member-center": {
            "login-to-receive-codes": "立即註冊，即賞你優惠券",
            "my-orders-empty": "沒有紀錄",
            "my-orders-title": "我的訂單",
            "profile-area-code": "國家編碼",
            "profile-email": "電郵地址",
            "profile-firstname": "名字",
            "profile-lastname": "姓氏",
            "profile-save": "修改",
            "profile-tel": "手機號碼",
            "profile-title": "帳戶資料",
            "profile-update-successfully": "成功更新",
            "promo-code-enter-promotion-code": "輸入優惠碼",
            "promo-code-my-promo-code": "我嘅 HyperAir 優惠券",
            "promo-code-no-code": "不好意思,你沒有任何優惠券",
            "promo-code-please-fill-in-code": "請填寫優惠碼",
            "promo-code-redeem": "兌換",
            "promo-code-redeem-code": "兌換 HyperAir 優惠券",
            "promo-code-select": "選擇",
            "promo-code-title": "HyperAir 優惠券",
            "title": "我的賬戶"
        },
        "weekday": {
            "1": "星期一",
            "2": "星期二",
            "3": "星期三",
            "4": "星期四",
            "5": "星期五",
            "6": "星期六",
            "7": "星期日"
        },
        "exchange-shop-details": {
            "address": "地址",
            "book-button": "立即預約",
            "br": "牌照號碼",
            "closed-book-button": "休息中",
            "download-pop-up": {
                "slogan-1": "立即報價，鎖住匯率",
                "slogan-2": "即時通知，確認訂單",
                "title": "立即下載 HyperAir 預約唱錢"
            },
            "latest-updated": "最新",
            "not-available-book-button": "只供參考",
            "opening-hrs": "營業時間",
            "phone-num": "電話",
            "rate": "匯率",
            "reviews": "評論",
            "table-buy-rate": "買入價",
            "table-compare-button": "比較匯率",
            "table-currency": "外幣",
            "table-sell-rate": "賣出價",
            "table-short-form": "代碼",
            "table-title": "外幣匯率"
        },
        "credit-card": {
            "cannot-add-card": "新增信用卡時發生錯誤，請確認所有資料正確並再次新增，您也可以選擇新增另一張信用卡。",
            "cannot-process": "信用卡付款時發生錯誤，請確認所有資料正確並再次付款，您也可以選擇以另一張信用卡付款。"
        },
        "shoppingcart": {
            "add": {
                "no-stock": "噢！已達最多可購買的數量~"
            },
            "pay": {
                "db-locked": "系統現在繁忙，請稍後再試。（參考編號：E1003）",
                "invalid-promotion-code": "優惠碼無效",
                "no-stock": "不好意思，您想買嘅產品剛剛沒有存貨了！（參考編號：E1002）"
            },
            "promotion-message": {
                "up-sell-1": "使用迎新優惠券可享 HK$10 折扣",
                "up-sell-2": "消費滿 HK$299 並使用優惠碼 HYPER15，可享 HK$15 折扣"
            }
        },
        "product": {
            "label-confirmation-duration-24_hours": "24小時確認",
            "label-confirmation-duration-48_hours": "48小時確認",
            "label-confirmation-duration-instant": "即時確認",
            "label-duration-unit-day": "日",
            "label-duration-unit-hour": "小時",
            "label-duration-unit-hr": "小時",
            "label-duration-unit-min": "分鐘",
            "label-earliest-available-date": "Y年n月j日",
            "label-earliest-available-date-today": "今日",
            "label-earliest-available-date-tomorrow": "明日",
            "label-lang-en": "英文",
            "label-lang-jp": "日文",
            "label-lang-kr": "韓文",
            "label-lang-zh": "中文",
            "label-meet-up-method-hotel_pickup": "酒店接送",
            "label-meet-up-method-location_meet_up": "自行前往指定地點集合",
            "label-refundable-conditional_cancel": "有條件退改",
            "label-refundable-no_cancel": "不能退改",
            "label-ticket-logistic-mobile": "需要手機憑證",
            "label-ticket-logistic-printed": "需要列印憑證",
            "label-ticket-logistic-printed_or_mobile": "列印或手機憑證均可",
            "label-ticket-validity-fixed_date": "必須於指定日期使用",
            "label-ticket-validity-open_date": "有效期内任何一天使用",
            "label-ticket-validity-open_or_fixed_date": "有效期以具體方案所述為准"
        },
        "pagination": {
            "next": "下一頁",
            "previous": "上一頁"
        },
        "city": {
            "abu-dhabi": "阿布達比",
            "adelaide": "阿德萊德",
            "agra": "阿格拉",
            "ahmedabad": "艾哈邁達巴德",
            "alice-springs": "愛麗斯泉",
            "alsace": "亞爾薩斯",
            "amritsar": "阿姆利則",
            "amsterdam": "阿姆斯特丹",
            "andalusia": "安達魯西亞",
            "antalya": "安塔利亞",
            "anuradhapura": "阿努拉德普勒",
            "athens": "雅典",
            "auckland": "奧克蘭",
            "bacolod": "巴科洛德",
            "bagan": "蒲甘",
            "baku": "巴庫",
            "bali": "峇里島",
            "bandung": "萬隆",
            "bangalore": "班加羅爾",
            "bangkok": "曼谷",
            "barcelona": "巴塞隆納",
            "batam": "巴淡島",
            "bath": "巴斯",
            "bay-of-islands": "島嶼灣",
            "beijing": "北京",
            "belfast": "貝爾法斯特",
            "bentota": "本托塔",
            "berlin": "柏林",
            "bohol": "Bohol",
            "boracay": "長灘島",
            "bordeaux": "波爾多",
            "boston": "波士頓",
            "bratislava": "布拉提斯拉瓦",
            "brisbane": "布里斯班",
            "bruges": "布魯日",
            "brussels": "布魯塞爾",
            "budapest": "布達佩斯",
            "burgundy": "勃艮第",
            "busan": "釜山",
            "cairns": "凱恩斯",
            "cambridge": "劍橋",
            "cameron-highlands": "金馬崙高原",
            "canary-islands": "加那利群島",
            "cape-town": "開普敦",
            "cappadocia": "卡帕多奇亞",
            "cebu": "宿務",
            "champagne": "香檳區",
            "chengdu": "成都",
            "chennai": "金娜",
            "chiang-mai": "清邁",
            "chiang-rai": "清萊",
            "chiayi": "Chiayi",
            "chicago": "芝加哥",
            "chongqing": "重慶",
            "christchurch": "克賴斯特徹奇",
            "cochin": "科欽",
            "cologne": "科隆",
            "colombo": "科倫坡",
            "copenhagen": "哥本哈根",
            "costa-del-sol": "太陽海岸",
            "crete": "克里特政區",
            "da-lat": "大叻市",
            "da-nang": "峴港",
            "darwin": "達爾文",
            "davao": "達沃",
            "delhi": "Delhi",
            "dhaka": "達卡",
            "dresden": "德累斯頓",
            "dubai": "杜拜",
            "dublin": "都柏林",
            "dubrovnik": "杜布羅夫尼克",
            "dumaguete": "杜馬蓋地",
            "dunedin": "達尼丁",
            "düsseldorf": "杜塞爾多夫",
            "edinburgh": "愛丁堡",
            "finnish-lapland": "",
            "florence": "佛羅倫斯",
            "frankfurt": "法蘭克福",
            "fraser-island": "費沙島",
            "french-riviera": "法國蔚藍海岸",
            "fukuoka": "福岡",
            "galle": "加勒",
            "galway": "戈爾韋",
            "gangtok": "甘托克",
            "gangwon-do": "江原道",
            "gdansk": "格但斯克",
            "geneva": "日內瓦",
            "genting-highlands": "雲頂高原",
            "geraldton": "杰拉爾頓",
            "glasgow": "格拉斯哥",
            "goa": "果阿邦",
            "gold-coast": "黃金海岸",
            "gothenburg": "哥德堡",
            "guam": "關島",
            "guangdong": "廣東",
            "guilin": "桂林",
            "guizhou": "貴州",
            "gyeonggi-do": "京畿道",
            "haikou": "海口",
            "hakone": "箱根",
            "halong": "下龍",
            "hamburg": "漢堡",
            "hangzhou": "杭州",
            "hanoi": "河內",
            "harbin": "哈爾濱",
            "hat-yai": "合艾",
            "hawaii": "夏威夷",
            "heidelberg": "海德堡",
            "helsinki": "赫爾辛基",
            "himachal-pradesh": "喜馬偕爾邦",
            "hiroshima": "廣島",
            "ho-chi-minh-city": "胡志明",
            "hobart": "霍巴特",
            "hoi-an": "會安",
            "hokkaido": "北海道",
            "hong-kong": "香港",
            "hua-hin": "華欣",
            "hualien": "花蓮",
            "hue": "Hue",
            "hyderabad": "海德拉巴",
            "iloilo": "伊洛伊洛",
            "incheon": "仁川",
            "inle-lake": "茵萊湖",
            "inner-mongolia": "內蒙古",
            "innsbruck": "因斯布魯克",
            "interlaken": "因特拉肯",
            "inverness": "因弗內斯",
            "ipoh": "怡保",
            "istanbul": "伊斯坦布爾",
            "jaipur": "齋浦爾",
            "jaisalmer": "賈沙梅爾",
            "jakarta": "Jakarta",
            "jeju": "濟州",
            "jerusalem": "耶路撒冷",
            "jodhpur": "焦特布爾",
            "johor-bahru": "新山",
            "kandy": "康提",
            "kaohsiung": "高雄",
            "kathmandu": "加德滿都",
            "kazan": "喀山",
            "kenting": "墾丁",
            "kiev": "Kiev",
            "kinmen": "Kinmen",
            "kobe": "神戶",
            "koh-chang": "象島",
            "koh-samui": "Koh Samui",
            "krabi": "甲米",
            "krakow": "克拉科夫",
            "kuala-lumpur": "吉隆坡",
            "kumamoto": "熊本",
            "kyoto": "京都",
            "kyushu": "九州",
            "lake-district": "湖區",
            "langkawi": "浮羅交怡",
            "lapland": "拉普蘭",
            "las-vegas": "拉斯維加斯",
            "launceston": "朗塞斯頓",
            "lausanne": "洛桑",
            "leipzig": "萊比錫",
            "lisbon": "里斯本",
            "liverpool": "利物浦",
            "ljubljana": "盧布爾雅那",
            "loire-valley": "盧瓦爾河谷",
            "lombok": "龍目島",
            "london": "倫敦",
            "los-angeles": "洛杉磯",
            "luang-prabang": "琅勃拉邦",
            "lucerne": "琉森",
            "lviv": "利維夫",
            "lyon": "里昂",
            "macao": "澳門",
            "macau": "",
            "madrid": "馬德里",
            "malaga": "馬拉加",
            "manchester": "曼徹斯特",
            "mandalay": "曼德勒省",
            "manila": "馬尼拉",
            "marrakech": "馬拉喀什",
            "mauritius": "毛里裘斯",
            "medan": "棉蘭",
            "melaka": "馬六甲",
            "melbourne": "墨爾本",
            "miami": "邁阿密",
            "milford-sound": "米爾福德峽灣",
            "montreux": "蒙特勒",
            "moscow": "莫斯科",
            "mumbai": "孟買",
            "munich": "慕尼黑",
            "muscat": "馬斯喀特",
            "nagano": "長野",
            "nagoya": "名古屋",
            "naples": "那不勒斯",
            "nelson": "納爾遜",
            "new-delhi": "新德里",
            "new-york": "紐約",
            "nha-trang": "芽莊",
            "niagara-falls": "Niagara Falls",
            "niigata": "新潟",
            "normandy": "諾曼地",
            "odessa": "敖德薩",
            "okayama": "岡山",
            "okinawa": "沖繩",
            "orlando": "奧蘭多",
            "osaka": "大阪",
            "oslo": "奧斯陸",
            "oxford": "牛津",
            "palawan": "巴拉望",
            "paris": "巴黎",
            "pattaya": "芭堤雅",
            "penang": "Penang",
            "penghu": "Penghu",
            "perth": "珀斯",
            "philadelphia": "費城",
            "phnom-penh": "Phnom Penh",
            "phu-quoc": "Phu Quoc",
            "phuket": "布吉",
            "pisa": "比薩",
            "pokhara": "博卡拉",
            "port-lincoln": "林肯港",
            "porto": "",
            "porto-district": "波爾圖",
            "prague": "布拉格",
            "provence": "普羅旺斯",
            "puglia": "普利亞",
            "pune": "浦那",
            "pushkar": "普希卡",
            "queenstown": "昆士敦",
            "ras-al-khaimah": "拉斯海瑪",
            "reykjavik": "雷克雅維克",
            "rhodes": "羅茲省",
            "rhône-alpes": "羅納-阿爾卑斯大區",
            "rome": "Rome",
            "rotorua": "Rotorua",
            "rotterdam": "鹿特丹",
            "sabah": "沙巴",
            "saint-petersburg": "圣彼得堡",
            "saipan": "塞班島",
            "salzburg": "薩爾斯堡",
            "san-diego": "聖地牙哥",
            "san-francisco": "舊金山",
            "santorini": "桑托里尼島",
            "sanya": "三亞",
            "sapa": "Sapa",
            "sarawak": "砂拉越",
            "seattle": "西雅圖",
            "seoul": "首爾",
            "seville": "塞維爾",
            "shanghai": "上海",
            "sibiu": "錫比烏",
            "sicily": "西西里島",
            "siem-reap": "暹粒",
            "sihanoukville": "Sihanoukville",
            "singapore": "新加坡",
            "split": "史普利特",
            "surabaya": "蘇拉巴雅",
            "suzhou": "蘇州",
            "swedish-lapland": "瑞典拉普蘭",
            "sydney": "悉尼",
            "taichung": "台中",
            "tainan": "台南",
            "taipei": "台北",
            "taitung": "台東",
            "tarragona": "塔拉戈納",
            "taupo": "陶波",
            "terengganu": "登嘉樓",
            "thessaloniki": "塞薩洛尼基",
            "tokyo": "東京",
            "toledo": "托萊多",
            "trincomalee": "亭可馬里",
            "turin": "都靈",
            "udaipur": "烏代布爾",
            "uluru": "烏魯魯",
            "uttarakhand": "北阿坎德邦",
            "varanasi": "瓦拉納西",
            "venice": "威尼斯",
            "verona": "維洛納",
            "vienna": "維也納",
            "vientiane": "萬象",
            "volendam": "沃倫丹",
            "washington-dc": "華盛頓特區",
            "wellington": "Wellington",
            "whitsundays": "Whitsundays",
            "xiamen": "廈門",
            "xian": "Xian",
            "yangon": "仰光",
            "yilan": "宜蘭",
            "yogyakarta": "Yogyakarta",
            "york": "約克",
            "yunnan": "雲南",
            "zagreb": "札格瑞布",
            "zhangjiajie": "張家界",
            "zurich": "蘇黎世"
        },
        "validation": {
            "accepted": "",
            "active_url": "",
            "after": "",
            "after_or_equal": "",
            "alpha": "",
            "alpha_dash": "",
            "alpha_num": "",
            "array": "",
            "before": "",
            "before_or_equal": "",
            "between": {
                "array": "",
                "file": "",
                "numeric": "",
                "string": ""
            },
            "boolean": "",
            "confirmed": "",
            "custom": {
                "attribute-name": {
                    "rule-name": ""
                }
            },
            "date": "",
            "date_format": "",
            "different": "",
            "digits": "",
            "digits_between": "",
            "dimensions": "",
            "distinct": "",
            "email": "",
            "exists": "",
            "file": "",
            "filled": "",
            "image": "",
            "in": "",
            "in_array": "",
            "integer": "",
            "ip": "",
            "ipv4": "",
            "ipv6": "",
            "json": "",
            "max": {
                "array": "",
                "file": "",
                "numeric": "",
                "string": ""
            },
            "mimes": "",
            "mimetypes": "",
            "min": {
                "array": "",
                "file": "",
                "numeric": "",
                "string": ""
            },
            "not_in": "",
            "numeric": "",
            "present": "",
            "regex": "",
            "required": "",
            "required_if": "",
            "required_unless": "",
            "required_with": "",
            "required_with_all": "",
            "required_without": "",
            "required_without_all": "",
            "same": "",
            "size": {
                "array": "",
                "file": "",
                "numeric": "",
                "string": ""
            },
            "string": "",
            "timezone": "",
            "unique": "",
            "uploaded": "",
            "url": ""
        },
        "reset-password": {
            "confirm-new-password": "重覆新密碼",
            "enter-new-password": "輸入新密碼",
            "please-enter-a-new-password": "請為您嘅帳戶 {email} 輸入新密碼。",
            "submit": "提交",
            "success-content": "成功！請使用新密碼登入HyperAir嘅手機App。",
            "title": "重設密碼",
            "validation-display": "密碼長度必須為最少6個字元。"
        },
        "notification": {
            "activation-e-minus-content": "倒數中! 仲有15日你張迎新SIM卡coupon就會到期啦！快啲用嚟準備下次嘅旅行啦！",
            "activation-e-minus-title": "",
            "activation-t-plus-content": "你咁醒目用HyperAir，記得用埋我哋張迎新SIM卡coupon! 咁就真係隨時隨地醒目旅遊啦！",
            "activation-t-plus-title": "",
            "ask-shop-to-quote-content": "要求報價買入 {amount} {currency}",
            "ask-shop-to-quote-content2": "要求報價賣出 {amount} {currency}",
            "ask-shop-to-quote-title": "新柯打等您報價",
            "email-booking-details": "訂單詳情",
            "email-booking-id": "訂單編號",
            "email-exchange-approved-content": "Exchanged order approved for buying {amount} {currency} at rate {rate}",
            "email-exchange-approved-footer": "感謝您使用HyperAir嘅服務。",
            "email-exchange-approved-title": "兌換店已回覆：「已為您準備好您嘅外幣！」",
            "email-exchange-completed-content": "Exchanged order completed for buying {amount} {currency} at rate {rate}",
            "email-exchange-completed-footer": "感謝您使用HyperAir嘅服務。",
            "email-exchange-completed-title": "您嘅外幣兌換已完成！",
            "email-exchange-confirmed-content": "Exchanged order confirmed for buying {amount} {currency} at rate {rate}",
            "email-exchange-confirmed-footer": "感謝您使用HyperAir嘅服務。",
            "email-exchange-confirmed-title": "已為您準備好您嘅外幣！",
            "email-footer-copy-right": "版權所有",
            "email-greetings": "您好！",
            "email-i-got": "我唱咗",
            "email-i-paid": "我畀咗",
            "email-i-will-get": "我要唱",
            "email-i-will-pay": "我要畀",
            "email-pickup-before": "在此時間前拎錢",
            "email-product-confirmed-greeting": "親愛的客戶：<br><br>感謝您使用HyperAir，我們已為您準備好您嘅憑證！",
            "email-product-confirmed-subject": "訂單已經確認",
            "email-product-confirmed-title": "您嘅訂單已成功確認",
            "email-product-purchased": {
                "shipping": {
                    "international": "跨國運送",
                    "sf": "順豐速遞 （只限香港）"
                }
            },
            "email-product-purchased-delievery-address": "收貨地址",
            "email-product-purchased-delivery-info": "送貨詳情",
            "email-product-purchased-delivery-method": "物流方式",
            "email-product-purchased-discount": "折扣",
            "email-product-purchased-email": "電郵",
            "email-product-purchased-greeting": "親愛的客戶：<br><br>很好嘅選擇！只係我哋仍然需要一點時間去確認您嘅預訂。不過別擔心，大多數時候我哋將在12小時內確認訂單，在這段時間請您稍候，我們將盡速回覆您訂單確認事宜。感謝您使用HyperAir！",
            "email-product-purchased-have-a-nice-trip": "祝旅途愉快！",
            "email-product-purchased-important-notice": "須受條款及細則約束。",
            "email-product-purchased-important-notice-content": "須受條款及細則約束。",
            "email-product-purchased-name": "姓名",
            "email-product-purchased-order-date": "落單日期",
            "email-product-purchased-order-details": "訂單詳情",
            "email-product-purchased-order-no": "訂單編號",
            "email-product-purchased-personal-info": "個人資料",
            "email-product-purchased-receipient-name": "收貨人名稱",
            "email-product-purchased-receipient-phone-no": "聯絡電話",
            "email-product-purchased-shipping-fee": "運費",
            "email-product-purchased-sub-total": "小計",
            "email-product-purchased-subject": "訂單待確認",
            "email-product-purchased-title": "您嘅訂單正在等待確認",
            "email-product-purchased-total": "總金額",
            "email-product-simcapurchased-personal-info": "Personal Info",
            "email-product-simcard-delivery-title": "您嘅訂單 SIM{order}-num 已於{date} 準備完畢並已寄出。如選擇順豐速遞，我們稍後將提供快遞單號，您亦可以於我哋嘅手機app查看。",
            "email-product-simcard-delivery-title-carbon-format": "Y-m-d",
            "email-product-simcard-delivery-update-greeting": "親愛的客戶,<br><br>感謝您使用HyperAir. 您所購買的SIM卡已在運送途中.",
            "email-product-simcard-delivery-update-title": "您所購買的SIM卡已經寄岀",
            "email-product-simcard-delivery-update-tracking": "物流詳情",
            "email-product-simcard-delivery-update-tracking-no": "Tracking Number",
            "email-product-simcard-delivery-update-tracking-no-hkpost": "快遞單號: -",
            "email-product-simcard-delivery-update-tracking-no-sf": "快遞單號",
            "email-product-simcard-delivery-waiting-update-tracking-no-sf": "正等候順豐速遞提供",
            "email-product-simcard-delivery-with-tracking-num-title": "您嘅訂單 SIM{order}-num 將由順豐速遞為您派送，快遞單號: {tracking}-num，請您保持手機暢通，注意收貨通知。您亦可以於順豐速運網站查看運送狀況。非常感謝您對HyperAir的支持。",
            "email-product-simcard-esim-code-greeting": "親愛的客戶：<br><br>感謝您使用HyperAir，以下是你的eSIM啟用QR碼！",
            "email-product-simcard-esim-code-important-notice-content": "<span style=\"font-size: 10px; line-height: 12px;\">使用說明：<br />1. 前往「設定」<br />2. 點一下「流動網絡」或「流動數據」<br />3. 點一下「加入流動網絡計劃」<br />4. 使用 iPhone 掃描 QR 碼<br />如果在啟用 eSIM 時，系統要求你輸入確認碼，請輸入電訊商提供的號碼。如有需要，請電郵至hello@hyperair.com查詢。</span>",
            "email-product-simcard-esim-code-title": "以下是你的eSIM啟用QR碼",
            "email-product-simcard-esim-code-warning": "請注意！以下QR碼一經掃描後eSIM即可啟動，請務必在使用時才掃描開通。",
            "email-product-simcard-purchased-delievery-address": "收貨地址",
            "email-product-simcard-purchased-delivery-info": "送貨詳情",
            "email-product-simcard-purchased-delivery-method": "物流方式",
            "email-product-simcard-purchased-discount": "折扣",
            "email-product-simcard-purchased-greeting": "親愛的客戶：<br><br>感謝您使用HyperAir，我們正在為您的旅遊SIM卡訂單安排出貨！",
            "email-product-simcard-purchased-greeting-esim-only": "親愛的客戶：<br><br>感謝您使⽤HyperAir，您的eSIM已經預備好！請打開附件跟住使用說明開通。",
            "email-product-simcard-purchased-greeting-esim-with-sim": "親愛的客戶：<br><br>感謝您使⽤HyperAir，我哋正在為您的旅遊SIM卡訂單安排出貨！此外，您的eSIM已經預備好，請打開附件同埋跟住使用說明開通。",
            "email-product-simcard-purchased-greeting-sim-only": "親愛的客戶：<br><br>感謝您使用HyperAir，我們正在為您的旅遊SIM卡訂單安排出貨！",
            "email-product-simcard-purchased-have-a-nice-trip": "祝旅途愉快！",
            "email-product-simcard-purchased-important-notice": "注意事項",
            "email-product-simcard-purchased-important-notice-content": "<span style=\"font-size: 10px; line-height: 12px;\">1. 如果以香港郵政平郵寄送，大概5個工作天內送達。如貨品由香港郵政平郵寄出，將不設郵寄編號作追查，客戶需承擔平郵延誤及寄失的風險。</span><br> <span style=\"font-size: 10px; line-height: 12px;\">2. 請留意旅遊SIM卡的有效日期，逾期使用將不會安排重新發貨。</span><br> <span style=\"font-size: 10px; line-height: 12px;\">3. 所有送遞貨品均受條款及細則約束。</span><br><br> <span style=\"font-size: 10px; line-height: 12px;\">如有需要，請電郵至hello@hyperair.com查詢。</span>",
            "email-product-simcard-purchased-important-notice-content-esim-only": "<span style=\"font-size: 10px; line-height: 12px;\">1. 如果以香港郵政平郵寄送，大概5個工作天內送達。如貨品由香港郵政平郵寄出，將不設郵寄編號作追查，客戶需承擔平郵延誤及寄失的風險。</span><br> <span style=\"font-size: 10px; line-height: 12px;\">2. 請留意旅遊SIM卡的有效日期，逾期使用將不會安排重新發貨。</span><br> <span style=\"font-size: 10px; line-height: 12px;\">3. 所有送遞貨品均受條款及細則約束。</span><br><br> <span style=\"font-size: 10px; line-height: 12px;\">如有需要，請電郵至hello@hyperair.com查詢。</span>",
            "email-product-simcard-purchased-important-notice-content-esim-with-sim": "<span style=\"font-size: 10px; line-height: 12px;\">1. 如果以香港郵政平郵寄送，大概5個工作天內送達。如貨品由香港郵政平郵寄出，將不設郵寄編號作追查，客戶需承擔平郵延誤及寄失的風險。</span><br> <span style=\"font-size: 10px; line-height: 12px;\">2. 請留意旅遊SIM卡的有效日期，逾期使用將不會安排重新發貨。</span><br> <span style=\"font-size: 10px; line-height: 12px;\">3. 所有送遞貨品均受條款及細則約束。</span><br><br> <span style=\"font-size: 10px; line-height: 12px;\">如有需要，請電郵至hello@hyperair.com查詢。</span>",
            "email-product-simcard-purchased-important-notice-content-sim-only": "<span style=\"font-size: 10px; line-height: 12px;\">1. 如果以香港郵政平郵寄送，大概5個工作天內送達。如貨品由香港郵政平郵寄出，將不設郵寄編號作追查，客戶需承擔平郵延誤及寄失的風險。</span><br> <span style=\"font-size: 10px; line-height: 12px;\">2. 請留意旅遊SIM卡的有效日期，逾期使用將不會安排重新發貨。</span><br> <span style=\"font-size: 10px; line-height: 12px;\">3. 所有送遞貨品均受條款及細則約束。</span><br><br> <span style=\"font-size: 10px; line-height: 12px;\">如有需要，請電郵至hello@hyperair.com查詢。</span>",
            "email-product-simcard-purchased-order-date": "落單日期",
            "email-product-simcard-purchased-order-details": "訂單詳情",
            "email-product-simcard-purchased-order-no": "訂單編號",
            "email-product-simcard-purchased-personal-info": "Personal Info",
            "email-product-simcard-purchased-receipient-name": "收貨人名稱",
            "email-product-simcard-purchased-receipient-phone-no": "收貨人聯繫電話",
            "email-product-simcard-purchased-shipping-fee": "運費",
            "email-product-simcard-purchased-sub-total": "小計",
            "email-product-simcard-purchased-title": "您嘅旅遊SIM卡訂單已確認",
            "email-product-simcard-purchased-title-esim-only": "您嘅旅遊eSIM卡訂單已確認",
            "email-product-simcard-purchased-title-esim-with-sim": "您嘅旅遊SIM卡訂單已確認",
            "email-product-simcard-purchased-title-sim-only": "您嘅旅遊SIM卡訂單已確認",
            "email-product-simcard-purchased-total": "總金額",
            "email-product-simcard-tracking-number-updated-greeting": "親愛的客戶,<br><br>再次感謝您使用HyperAir. 您的快遞單號已經更新了.",
            "email-product-simcard-tracking-number-updated-title": "您的快遞詳情已經更新",
            "email-product-simcard-tracking-number-updated-tracking-no-sf": "快遞單號",
            "email-product-type-confirmed-greeting": "親愛的客戶,<br><br>感謝您使用HyperAir. 您所購買的商品已在運送途中.",
            "email-product-type-confirmed-title": "您嘅商品已經寄岀",
            "email-product-type-purchased-greeting": "親愛的客戶：<br><br>感謝您使用HyperAir，我們正在為您的商品安排岀貨！",
            "email-product-type-purchased-title": "您嘅商品訂單",
            "email-rate": "匯率",
            "email-shop-name": "兌換店名稱",
            "email-verification-action": "確認電郵地址",
            "email-verification-content": "非常感謝您加入HyperAir！我哋想確認您所輸入嘅電郵地址係正確。請㩒下面個制啟用您嘅帳戶：",
            "email-verification-title": "請確認您註冊嘅電郵地址",
            "email-verified-content": "您嘅電郵已驗證。歡迎加入HyperAir！",
            "email-verified-title": "已成功驗證電郵",
            "engagement-content": "Use welcome10",
            "engagement-title": "Use welcome10",
            "exchange-approved-content": "確認於匯率 {rate} 買入 {amount} {currency}。",
            "exchange-approved-content2": "確認於匯率 {rate} 賣出 {amount} {currency}。",
            "exchange-approved-footer": "感謝您使用HyperAir嘅服務。",
            "exchange-approved-title": "兌換店已回覆：「已為您準好您嘅外幣！」",
            "exchange-cancelled-content": "客人已取消柯打於匯率 {rate} 買入 {amount} {currency}。",
            "exchange-cancelled-content2": "客人已取消柯打於匯率 {rate} 賣出 {amount} {currency}。",
            "exchange-cancelled-title": "外幣柯打已取消",
            "exchange-completed-content": "已於匯率 {rate} 買入 {amount} {currency}。",
            "exchange-completed-content2": "已於匯率 {rate} 賣出 {amount} {currency}。",
            "exchange-completed-footer": "感謝您使用HyperAir嘅服務。",
            "exchange-completed-title": "您嘅外幣兌換已完成！",
            "exchange-confirmed-content": "您已確認客人可於匯率 {rate} 買入 {amount} {currency}。",
            "exchange-confirmed-content2": "您已確認客人可於匯率 {rate} 賣出 {amount} {currency}。",
            "exchange-confirmed-footer": "感謝您使用HyperAir嘅服務。",
            "exchange-confirmed-title": "已收到外幣新柯打",
            "exchange-pending-content": "核實新柯打：於匯率 {rate} 買入 {amount} {currency}。",
            "exchange-pending-content2": "核實新柯打：於匯率 {rate} 賣出 {amount} {currency}。",
            "exchange-pending-title": "新柯打等您確認",
            "exchange-rejected-content": "這店未能處理於匯率 {rate} 買入 {amount} {currency}。 請於另一家兌換店預訂。",
            "exchange-rejected-content2": "這店未能處理於匯率 {rate} 賣出 {amount} {currency}。 請於另一家兌換店預訂。",
            "exchange-rejected-title": "哎喲！很抱歉，兌換店無法處理您嘅訂單。",
            "footer-trouble-link": "如果您在點擊“{actionText}”按鈕時遇到問題，請將以下網址複製並貼到您的瀏覽器： <a href=\"{actionUrl}\">{actionUrl}</a>",
            "password-reset-action": "重設密碼",
            "password-reset-content": "您收到呢個電郵喺因為我哋收到了您嘅密碼重置請求。",
            "password-reset-footer": "如果您沒有要求重置密碼，您唔需要採取進一步嘅操作。",
            "password-reset-title": "重設密碼",
            "simcard-purchased-title": "您嘅旅遊SIM卡訂單已確認",
            "sms-verification-content": "你的 HyperAir 驗證碼是 {verificationCode}"
        },
        "error": {
            "all-shops-are-closed": "喔噢，兌換店辛苦咗一日正在休息。請遲啲再搵佢哋報個靚價啦。",
            "cancel-booking-failed": "此訂單已完成、逾期或被取消。請檢查 [我的訂單>已完成] 或 [我的訂單>未能完成] 中嘅訂單。",
            "cancel-booking-failed-title": "無法取消此訂單",
            "invalid-api-app-version": "立即更新APP以獲取最新功能及以95折購買旅遊SIM卡 (優惠碼GIVEME5)",
            "invalid-old-password": "現有密碼錯誤。",
            "password-incorrect": "密碼錯誤。",
            "phone-number-is-already-registered": "此手機號碼已被另一電郵地址註冊，請使用該電郵地址登入。如需要提供協助，請電郵至hello@hyperair.com。",
            "this-email-is-registered": "",
            "this-phone-number-is-registered": "此手機號碼已被註冊。如需要提供協助，請電郵至hello@hyperair.com。"
        },
        "marketplace": {
            "homepage-product": "熱門產品",
            "homepage-recently-viewed": "最近瀏覽",
            "product-carousels": {
                "group1": "熱門推介",
                "group2": "口碑之選"
            }
        }
    }
}
